import Res from './Res';

export enum ActionButtonCategory {
	TicketManagement_Operations = 100,
	TicketManagement_Edition = 200,
	TableManagement = 300,
	CashOperations_CashMovements = 400,
	CashOperations_PaymentsAndCharges = 500,
	CashOperations_Refunds = 600,
	WarehouseAndStock = 700,
	PromotionsAndLoyalty = 800,
	DeliveryAndWebOrders = 900,
	CustomersAndReservations = 1000,
	PrintingManagement = 1100,
	Queries_Products = 1200,
	Queries_Documents = 1300,
	Queries_Ticket_And_Kitchen_Command = 1400,
	KitchenActions = 1500,
	Admin_And_Utilities = 1600,
	Custom = 1700
}

export namespace ActionButtonCategory {
	export function toString(value: ActionButtonCategory) {
		switch (value) {
			case ActionButtonCategory.TicketManagement_Operations:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_TICKET_MANAGEMENT_OPERATIONS();
			case ActionButtonCategory.TicketManagement_Edition:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_TICKET_MANAGEMENT_EDITION();
			case ActionButtonCategory.TableManagement:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_TABLE_MANAGEMENT();
			case ActionButtonCategory.CashOperations_CashMovements:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_CASH_OPERATIONS_CASH_MOVEMENTS();
			case ActionButtonCategory.CashOperations_PaymentsAndCharges:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_CASH_OPERATIONS_PAYMENTS_AND_CHARGES();
			case ActionButtonCategory.CashOperations_Refunds:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_CASH_OPERATIONS_REFUNDS();
			case ActionButtonCategory.WarehouseAndStock:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_WAREHOUSE_AND_STOCK();
			case ActionButtonCategory.PromotionsAndLoyalty:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_PROMOTIONS_AND_LOYALTY();
			case ActionButtonCategory.DeliveryAndWebOrders:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_DELIVERY_AND_WEB_ORDERS();
			case ActionButtonCategory.CustomersAndReservations:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_CUSTOMERS_AND_RESERVATIONS();
			case ActionButtonCategory.PrintingManagement:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_PRINTING_MANAGEMENT();
			case ActionButtonCategory.Queries_Products:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_QUERIES_PRODUCT_SEARCHES();
			case ActionButtonCategory.Queries_Documents:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_QUERIES_DOCUMENT_SEARCHES();
			case ActionButtonCategory.Queries_Ticket_And_Kitchen_Command:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_QUERIES_TICKET_AND_KITCHEN_COMMAND();
			case ActionButtonCategory.KitchenActions:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_KITCHEN_ACTIONS();
			case ActionButtonCategory.Admin_And_Utilities:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_ADMIN_AND_UTILITIES();
			case ActionButtonCategory.Custom:
				return Res.Const.ENUM_ACTION_BUTTON_CATEGORY_CUSTOM();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ActionButtonVisibility {
	MainView = 1,
	SelectLocationView = 2
}

export enum AddinRoleAdditionMode {
	UseSameAddinForAll = 0,
	ChooseDifferentAddinPerUnit = 1
}

export namespace AddinRoleAdditionMode {
	export function toString(value: AddinRoleAdditionMode) {
		switch (value) {
			case AddinRoleAdditionMode.UseSameAddinForAll:
				return Res.Const.ENUM_ADDIN_ROLE_ADDITION_MODE_USE_SAME_ADDIN_FOR_ALL();
			case AddinRoleAdditionMode.ChooseDifferentAddinPerUnit:
				return Res.Const.ENUM_ADDIN_ROLE_ADDITION_MODE_CHOOSE_DIFFERENTE_ADDIN_PER_UNIT();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum AgoraPaymentsTransactionError {
	None = 0,
	NotFoundInAgora = 1,
	NotFoundInAdyen = 2
}

export enum AppointmentStatus {
	Pending = 0,
	Cancelled = 1,
	Closed = 2
}

export namespace AppointmentStatus {
	export function toString(value: AppointmentStatus) {
		switch (value) {
			case AppointmentStatus.Pending:
				return Res.Const.ENUM_APPOINTMENT_STATUS_PENDING();
			case AppointmentStatus.Cancelled:
				return Res.Const.ENUM_APPOINTMENT_STATUS_CANCELLED();
			case AppointmentStatus.Closed:
				return Res.Const.ENUM_APPOINTMENT_STATUS_CLOSED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum AuditEventType {
	Low = 100,
	Ticket_AddLine = 101,
	Ticket_AddNote = 102,
	Ticket_SetTableCompanions = 103,
	Ticket_SetLineQuantity = 104,
	Preparation_RequestCourses = 105,
	Preparation_Prepare = 106,
	Ticket_Move = 107,
	Ticket_SetCustomer = 108,
	Emailing_Save = 109,
	Company_Save = 110,
	CustomTemplate_Save = 111,
	Custom_Save = 112,
	DisplayProfile_Activate = 113,
	DisplayOrder_Category = 114,
	Family_Save = 115,
	PaymentMethod_Save = 116,
	PredefinedNote_Save = 117,
	POS_Save = 118,
	Product_Save = 119,
	User_Save = 120,
	SaleCenter_Save = 121,
	SpecialPriceList_Save = 122,
	Supplier_Save = 123,
	Vats_Save = 124,
	IncomingDeliveryNote_Save = 125,
	Inventory_Save = 126,
	Category_Save = 127,
	DisplayOrder_ProductGroups = 128,
	DisplayOrder_Family = 129,
	TimeFrame_Save = 130,
	Map_Save = 131,
	AuditQuery_Save = 132,
	KitchenPrintTemplate_Save = 133,
	ScaleCounter_Save = 134,
	StockChange_Save = 136,
	UserProfile_Save = 137,
	MajorGroup_Save = 138,
	SystemSettings_Save = 139,
	Size_Save = 140,
	Color_Save = 141,
	CostPrice_Update = 145,
	Serie_Save = 146,
	Menu_Save = 147,
	Menu_AddProductToCategory = 148,
	Menu_RemoveProductFromCategory = 149,
	PreparationType_Save = 150,
	PreparationOrder_Save = 151,
	Ticket_SetLinePreparationOrder = 152,
	ActionDisplayProfile_Save = 153,
	KitchenDisplay_Save = 154,
	Deliver_Preparations = 156,
	Appointment_Save = 158,
	Offer_Save = 159,
	Warehouse_Save = 160,
	PurchaseOrder_Save = 161,
	NamedDiscount_Save = 162,
	PosGroup_Save = 163,
	RegularSuppliers_Update = 164,
	LineCancellationReason_Save = 165,
	Inventory_CreateFromDraft = 166,
	PurchaseOrder_CreateFromDraft = 167,
	IncomingDeliveryNote_CreateFromDraft = 168,
	StockChange_CreateFromDraft = 169,
	Report_SendByMail = 170,
	DisplayPreparation_StartItem = 180,
	DisplayPreparation_Print = 181,
	WebAdmin_Save = 182,
	Workplace_Save = 183,
	Hub_GenerateWorkplaceData = 184,
	CouponPrintTemplate_Save = 185,
	Ticket_ChangeAddins = 186,
	SystemOfMeasurement_Save = 187,
	CustomActionButton_Save = 188,
	PurchaseInvoice_Save = 189,
	HubClient_ClearCache = 190,
	StockChange_Send = 191,
	StockChange_UndoSend = 192,
	StockChange_Receive = 193,
	PurchaseOrder_Confirm = 194,
	PurchaseOrder_UndoConfirm = 195,
	PurchaseOrder_DiscardPendingQuantities = 196,
	PurchaseInvoice_Account = 197,
	PurchaseInvoice_UndoAccount = 198,
	Ticket_AddUnusualProductLine = 199,
	TimeFrameGroup_Save = 200,
	TimeFrameGroup_Deleted = 201,
	WorkingPeriod_Save = 202,
	CouponSettings_Save = 203,
	CardProcessorSettings_Save = 204,
	CardProcessorTablePaymentSettings_Save = 205,
	CashControlSettings_Save = 206,
	Invoice_SetCustomer = 207,
	PurchaseOrder_AttachDocument = 208,
	IncomingDeliveryNote_AttachDocument = 210,
	PurchaseInvoice_AttachDocument = 211,
	Allergen_Save = 212,
	DigitalMenu_Save = 213,
	DigitalMenuResources_Update = 214,
	ProductTag_Save = 215,
	EmailAccount_Save = 216,
	Lot_Save = 217,
	Label_Save = 218,
	Preparation_RequestLine = 219,
	DisplayPreparation_UndoItem = 220,
	CustomerType_Deleted = 221,
	CustomerType_Save = 222,
	SmartMenuOrderSettings_Save = 223,
	WarehouseCloseOut_Save = 224,
	Inventory_Confirm = 225,
	Inventory_UnConfirm = 226,
	Ticket_AddOnlineReservation = 227,
	Ticket_RemoveOnlineReservation = 228,
	SmartMenuWorkplaceGroupSettings_Save = 229,
	CashControlTransaction_Registered = 230,
	CardTransaction_Completed = 231,
	Ticket_AdjustIngredients = 232,
	Ticket_SetMinAmount = 233,
	IncomingDeliveryNote_Confirm = 234,
	IncomingDeliveryNote_UndoConfirm = 235,
	Ticket_SetLineSeatNumber = 236,
	ReportView_Add = 237,
	ReportView_SetDefault = 238,
	ReportView_ClearDefault = 239,
	SifSettings_Save = 240,
	SifSettings_Delete = 241,
	InternalSupplier_Save = 242,
	InternalSupplier_Delete = 243,
	InternalCustomer_Save = 244,
	InternalCustomer_Delete = 245,
	Preparation_Prepare_Again = 246,
	MyAgoraAccount_Delete = 247,
	MyAgoraAccount_Save = 248,
	StockChange_AttachDocument = 249,
	Medium = 10000,
	Emailing_Send = 10001,
	POS_PrintPartialBalance = 10002,
	POS_PrintTotalBalance = 10003,
	POS_CloseDay = 10004,
	POS_OpenDay = 10005,
	Ticket_ChangePayment = 10006,
	Ticket_Close = 10007,
	DeliveryNote_Create = 10008,
	Ticket_SetLinePercentageDiscount = 10009,
	Ticket_SetLineCashDiscount = 10010,
	Ticket_SetLinePrice = 10011,
	Ticket_UnPark = 10012,
	Login_Success = 10013,
	POS_OpenCashdrawer = 10014,
	Ticket_Join = 10015,
	Ticket_Print = 10016,
	Category_Delete = 10017,
	Emailing_Cancel = 10018,
	Emailing_Delete = 10019,
	PriceList_SetPriceListConfiguration = 10020,
	Customer_Delete = 10021,
	CustomTemplate_Delete = 10022,
	Family_Delete = 10023,
	PaymentMethod_Delete = 10024,
	POS_Delete = 10025,
	PredefinedNote_Delete = 10026,
	Product_Delete = 10027,
	SaleCenter_Delete = 10028,
	SpecialPriceList_Delete = 10029,
	Supplier_Delete = 10030,
	User_Delete = 10031,
	IncomingDeliveryNote_Delete = 10032,
	Inventory_Delete = 10033,
	Map_Delete = 10034,
	AuditQuery_Delete = 10035,
	Pos_ChangePrintMode = 10036,
	PriceList_SetScheduleTable = 10037,
	System_PrintTotalBalance = 10039,
	System_OpenDay = 10040,
	System_CloseDay = 10041,
	ScaleCounter_Delete = 10042,
	ScaleCounter_Export = 10043,
	StockChange_Delete = 10045,
	UserProfile_Delete = 10046,
	MajorGroup_Delete = 10047,
	Logout = 10048,
	Serie_Delete = 10049,
	Invoice_Print = 10050,
	Menu_Delete = 10051,
	PreparationType_Delete = 10052,
	PreparationOrder_Delete = 10053,
	POS_PrintCashTransaction = 10054,
	ActionDisplayProfile_Delete = 10055,
	PreparationCounter_Reset = 10056,
	KitchenDisplay_Delete = 10057,
	Ticket_Gift = 10058,
	Appointment_Cancelled = 10063,
	Appointment_Closed = 10064,
	Appointment_Delete = 10065,
	Offer_Delete = 10066,
	POS_PrintCashControlReport = 10069,
	Warehouse_Delete = 10070,
	PurchaseOrder_Delete = 10071,
	Ticket_SendMail = 10072,
	Ticket_SetLineCreator = 10073,
	NamedDiscount_Delete = 10074,
	Ticket_SetTicketLineNamedDiscount = 10075,
	Ticket_SetTicketNamedDiscount = 10076,
	DeliveryNote_AddPayment = 10077,
	SalesOrder_Create = 10078,
	SalesOrder_Close = 10079,
	SalesOrder_Print = 10080,
	SalesOrder_AddPayment = 10081,
	Ticket_AddPayment = 10082,
	POS_PrintTrainingSession = 10083,
	PosGroup_Delete = 10084,
	LineCancellationReason_Delete = 10085,
	DeliveryNote_SendMail = 10087,
	SalesOrder_SendMail = 10088,
	DeliveryNote_Print = 10089,
	DisplayPreparation_CompleteItem = 10090,
	DisplayPreparation_Complete = 10091,
	CashControl_CloseDay = 10092,
	CashControl_AddChange = 10093,
	CashControl_GiveChange = 10094,
	CashControl_ShowAdvancedOptions = 10095,
	CashControl_ShowStatus = 10096,
	Ticket_PriceList = 10097,
	Ticket_SetTipSettings = 10098,
	Workplace_Delete = 10099,
	KitchenPrintTemplate_Delete = 10100,
	CouponSettings_Delete = 10101,
	CouponPrintTemplate_Delete = 10102,
	ProductAvailability_Update = 10103,
	SystemOfMeasurement_Delete = 10104,
	CustomActionButton_Delete = 10105,
	CashControl_Reset = 10106,
	PurchaseInvoice_Delete = 10107,
	Production_Delete = 10108,
	Production_Save = 10109,
	Ticket_FromDeliveryNote = 10110,
	Ticket_FromSalesOrder = 10111,
	Ticket_FromInvoice = 10112,
	StockChange_LossCreated = 10113,
	GStock_AddToUpload = 10114,
	Ticket_UpdateCustomerData = 10115,
	DeliveryNote_ChangeCustomer = 10116,
	SaleOrder_ChangeCustomer = 10117,
	Ticket_UpdateTips = 10118,
	CashControlSettings_Delete = 10119,
	CardProcessorSettings_Delete = 10121,
	CardProcessorTablePaymentSettings_Delete = 10123,
	Clocking_RegisterIn = 10125,
	Clocking_RegisterOut = 10126,
	Ticket_SetServiceCharge = 10127,
	WorkingPeriod_Delete = 10128,
	DeliveryAddress_Add = 10129,
	DeliveryAddress_Remove = 10130,
	Ticket_ChangeOpenerUser = 10131,
	Ticket_BeginPartialClosing = 10132,
	Ticket_EndPartialClosing = 10133,
	Ticket_AddLoyaltyInfo = 10134,
	Ticket_RemoveLoyaltyInfo = 10135,
	PurchaseOrder_DeleteAttachedDocument = 10136,
	IncomingDeliveryNote_DeleteAttachedDocument = 10137,
	PurchaseInvoice_DeleteAttachedDocument = 10138,
	Allergen_Delete = 10139,
	DigitalMenu_Delete = 10140,
	ProductTag_Delete = 10141,
	EmailAccount_Delete = 10142,
	Lot_Delete = 10143,
	Ticket_SetTicketLineLot = 10144,
	Label_Delete = 10145,
	Label_Print = 10146,
	CsvLabel_Print = 10147,
	PurchaseOrder_SupplierChange = 10148,
	IncomingDeliveryNote_SupplierChange = 10149,
	DisplayPreparation_Undo = 10150,
	TableOrder_Created = 10151,
	SmartMenuOrderSettings_Delete = 10152,
	SalesOrder_MarkAsDelivered = 10153,
	SalesOrder_Deliver = 10154,
	SalesOrder_Accept = 10155,
	SalesOrder_MarkAsPrepared = 10156,
	SalesOrder_Reject = 10157,
	SmartMenuOrderComms_Resume = 10158,
	WarehouseCloseOut_Delete = 10159,
	Ticket_CompleteMenu = 10160,
	SalesOrder_TakeOutStarted = 10161,
	SalesOrder_TakeOutFinished = 10162,
	SalesOrder_ChangeDeliveryUser = 10163,
	DeliveryPerson_AddBalanceDelta = 10164,
	DeliveryPerson_SubstractBalanceDelta = 10165,
	SmartMenuWorkplaceGroupSettings_Delete = 10166,
	CashControlTransaction_Undo = 10167,
	CardTransaction_Undo = 10168,
	Invoice_SendAutoInvoiceLink = 10169,
	SalesOrder_UpdateDeliveryAddress = 10170,
	Preparation_Undo = 10171,
	Preparation_Start = 10172,
	Preparation_Finish = 10173,
	Preparation_Serve = 10174,
	Preparation_Cancellation_Accept = 10175,
	ReportView_Remove = 10176,
	Preparation_Served_Accept = 10177,
	DeliveryNote_CreateFromSalesOrder = 10178,
	StockChange_DeleteAttachedDocument = 10179,
	High = 20000,
	Ticket_CancelPrintedLine = 20001,
	Ticket_Cancel = 20002,
	POS_NegativeAmount = 20003,
	POS_CloseDayWithIncident = 20004,
	POS_RegisterInputCashTransaction = 20005,
	POS_RegisterOutputCashTransaction = 20006,
	Ticket_CancelLine = 20007,
	Management_DeleteCashActivity = 20008,
	Ticket_Invoice = 20009,
	Login_Failed = 20010,
	Ticket_RemovePrintedLine = 20011,
	Ticket_RemoveLine = 20012,
	Ticket_Reopen = 20013,
	Ticket_AddFreeLine = 20016,
	Ticket_Reprint = 20017,
	Ticket_SetCashDiscount = 20018,
	Ticket_SetDiscountRate = 20019,
	Product_ChangePrices = 20020,
	POS_CloseDayForzed = 20022,
	Invoice_Reprint = 20023,
	Ticket_DeliveryNoteCancelled = 20024,
	Ticket_Refund = 20025,
	SalesOrder_Reprint = 20026,
	Product_ChangePricesByMargin = 20027,
	Ticket_Loss = 20028,
	Ticket_DeliveryNoteReopen = 20029,
	SalesOrder_RefundPayment = 20030,
	DeliveryNote_RefundPayment = 20031,
	DeliveryNote_Reopen = 20032,
	SalesOrder_Cancel = 20033,
	Training_Configure_Settings = 20034,
	Ticket_RefundPayment = 20035,
	Training_Delete_All = 20036,
	Coupon_Configure_Settings = 20037,
	Ticket_SetOffers = 20038,
	Ticket_SetFriendlyName = 20039,
	DeliveryNote_Reprint = 20040,
	Hub_DiscardOperation = 20041,
	Workplace_UnlinkFromMachine = 20042,
	Coupon_Print = 20043,
	Product_SystemOfMeasurementChanged = 20044,
	Pos_IgnorePayment = 20045,
	Management_ImportDistributorExcel = 20046,
	GStock_ClearUploads = 20047,
	Workplace_SendUpdate = 20048,
	Workplace_CancelUpdate = 20049,
	GStock_ClearUpload = 20050,
	Invoice_ReplaceContentOnPrint = 20051,
	DeliveryNote_ReplaceContentOnPrint = 20052,
	SalesOrder_ReplaceContentOnPrint = 20053,
	Pos_ErrorExtractTip = 20055,
	Pos_ExtractPendingTip = 20056,
	Ticket_AddLoyaltyInfoWithRewards = 20057,
	Ticket_AddReservationPrepayment = 20058,
	DigitalMenu_SetOwner = 20059,
	DigitalMenu_SetWorkplaceOwner = 20060,
	SmartMenuOrderComms_Suspend = 20061,
	Ticket_AddNegativeLine = 20062,
	CashControlTransaction_UndoFailed = 20063,
	CardTransaction_UndoFailed = 20064,
	Ticket_CancelPartialClosing = 20065,
	Pos_AddPendingTip = 20066,
	Ticket_UnlockedByPos = 20067,
	Ticket_CheckPendingCardTransactions = 20068
}

export namespace AuditEventType {
	export function toString(value: AuditEventType) {
		switch (value) {
			case AuditEventType.Low:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LOW();
			case AuditEventType.Ticket_AddLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_LINE();
			case AuditEventType.Ticket_AddNote:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_LINE_NOTE();
			case AuditEventType.Ticket_SetTableCompanions:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_TABLE_COMPANIONS();
			case AuditEventType.Ticket_SetLineQuantity:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_LINE_QUANTITY();
			case AuditEventType.Preparation_RequestCourses:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_REQUEST_ORDERED_COURSES();
			case AuditEventType.Preparation_Prepare:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_PREPARE();
			case AuditEventType.Ticket_Move:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_MOVE();
			case AuditEventType.Ticket_SetCustomer:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_CUSTOMER();
			case AuditEventType.Emailing_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_EMAILING_SAVE();
			case AuditEventType.Company_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COMPANY_SAVE();
			case AuditEventType.CustomTemplate_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOM_TEMPLATE_SAVE();
			case AuditEventType.Custom_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOMER_SAVE();
			case AuditEventType.DisplayProfile_Activate:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_PROFILE_ACTIVE_SAVE();
			case AuditEventType.DisplayOrder_Category:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_ORDER_CATEGORY_SAVE();
			case AuditEventType.Family_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_FAMILY_SAVE();
			case AuditEventType.PaymentMethod_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PAYMENT_METHOD_SAVE();
			case AuditEventType.PredefinedNote_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREDEFINED_NOTE_SAVE();
			case AuditEventType.POS_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_SAVE();
			case AuditEventType.Product_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_SAVE();
			case AuditEventType.User_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_USER_SAVE();
			case AuditEventType.SaleCenter_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALE_CENTER_SAVE();
			case AuditEventType.SpecialPriceList_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SPECIAL_PRICE_LIST();
			case AuditEventType.Supplier_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SUPPLIER_SAVE();
			case AuditEventType.Vats_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_VATS_SAVE();
			case AuditEventType.IncomingDeliveryNote_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_SAVE();
			case AuditEventType.Inventory_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVENTORY_SAVE();
			case AuditEventType.Category_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CATEGORY_SAVE();
			case AuditEventType.DisplayOrder_ProductGroups:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_ORDER_PRODUCT_GROUPS();
			case AuditEventType.DisplayOrder_Family:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_ORDER_FAMILY();
			case AuditEventType.TimeFrame_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TIME_FRAME_SAVE();
			case AuditEventType.Map_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MAP_SAVE();
			case AuditEventType.AuditQuery_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_AUDIT_QUERY_SAVE();
			case AuditEventType.KitchenPrintTemplate_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_KITCHEN_PRINT_TEMPLATE_SAVE();
			case AuditEventType.ScaleCounter_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SCALE_COUNTER_SAVE();
			case AuditEventType.StockChange_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_SAVE();
			case AuditEventType.UserProfile_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_USER_PROFILE_SAVE();
			case AuditEventType.MajorGroup_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MAJOR_GROUP_SAVE();
			case AuditEventType.SystemSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SYSTEM_SETTINGS_SAVE();
			case AuditEventType.Size_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SIZE_SAVE();
			case AuditEventType.Color_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COLOR_SAVE();
			case AuditEventType.CostPrice_Update:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COST_PRICE_UPDATE();
			case AuditEventType.Serie_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SERIE_SAVE();
			case AuditEventType.Menu_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MENU_SAVE();
			case AuditEventType.Menu_AddProductToCategory:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MENU_ADD_PRODUCT_TO_CATEGORY();
			case AuditEventType.Menu_RemoveProductFromCategory:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MENU_REMOVE_PRODUCT_FROM_CATEGORY();
			case AuditEventType.PreparationType_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_TYPE_SAVE();
			case AuditEventType.PreparationOrder_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_ORDER_SAVE();
			case AuditEventType.Ticket_SetLinePreparationOrder:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SET_LINE_PREPARATION_ORDER();
			case AuditEventType.ActionDisplayProfile_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_ACTION_DISPLAY_PROFILE_SAVE();
			case AuditEventType.KitchenDisplay_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_KITCHEN_DISPLAY_SAVE();
			case AuditEventType.Deliver_Preparations:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVER_PREPARATIONS();
			case AuditEventType.Appointment_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_APPOINTMENT_SAVE();
			case AuditEventType.Offer_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_OFFER_SAVE();
			case AuditEventType.Warehouse_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WAREHOUSE_SAVE();
			case AuditEventType.PurchaseOrder_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_SAVE();
			case AuditEventType.NamedDiscount_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_NAMED_DISCOUNT_SAVE();
			case AuditEventType.PosGroup_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_GROUP_SAVE();
			case AuditEventType.RegularSuppliers_Update:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_REGULAR_SUPPLIERS_UPDATE();
			case AuditEventType.LineCancellationReason_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LINE_CANCELLATION_REASON_SAVE();
			case AuditEventType.Inventory_CreateFromDraft:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVENTORY_CREATE_FROM_DRAFT();
			case AuditEventType.PurchaseOrder_CreateFromDraft:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_CREATE_FROM_DRAFT();
			case AuditEventType.IncomingDeliveryNote_CreateFromDraft:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_CREATE_FROM_DRAFT();
			case AuditEventType.StockChange_CreateFromDraft:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_CREATE_FROM_DRAFT();
			case AuditEventType.Report_SendByMail:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_REPORT_SEND_BY_EMAIL();
			case AuditEventType.DisplayPreparation_StartItem:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_PREPARATION_START_ITEM();
			case AuditEventType.DisplayPreparation_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_PREPARATION_PRINT();
			case AuditEventType.WebAdmin_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WEBADMIN_SAVE();
			case AuditEventType.Workplace_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WORKPLACE_SAVE();
			case AuditEventType.Hub_GenerateWorkplaceData:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_HUB_GENERATE_WORKPLACE_DATA();
			case AuditEventType.CouponPrintTemplate_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COUPON_PRINT_TEMPALTE_SAVE();
			case AuditEventType.Ticket_ChangeAddins:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CHANGE_ADDINS();
			case AuditEventType.SystemOfMeasurement_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SYSTEM_OF_MEASUREMENT_SAVE();
			case AuditEventType.CustomActionButton_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOM_ACTION_BUTTON_SAVE();
			case AuditEventType.PurchaseInvoice_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_INVOICE_SAVE();
			case AuditEventType.HubClient_ClearCache:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_HUB_CLIENT_CLEAR_CACHE();
			case AuditEventType.StockChange_Send:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_SEND();
			case AuditEventType.StockChange_UndoSend:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_UNDO_SEND();
			case AuditEventType.StockChange_Receive:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_RECEIVE();
			case AuditEventType.PurchaseOrder_Confirm:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_CONFIRM();
			case AuditEventType.PurchaseOrder_UndoConfirm:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_UNDO_CONFIRM();
			case AuditEventType.PurchaseOrder_DiscardPendingQuantities:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_DISCARD_PENDING_QUANTITIES();
			case AuditEventType.PurchaseInvoice_Account:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_INVOICE_ACCOUNT();
			case AuditEventType.PurchaseInvoice_UndoAccount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_INVOICE_UNDO_ACCOUNT();
			case AuditEventType.Ticket_AddUnusualProductLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_UNUSUAL_PRODUCT_LINE();
			case AuditEventType.TimeFrameGroup_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TIME_FRAME_GROUP_SAVE();
			case AuditEventType.TimeFrameGroup_Deleted:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TIME_FRAME_GROUP_DELETED();
			case AuditEventType.WorkingPeriod_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WORKING_PERIOD_SAVE();
			case AuditEventType.CouponSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COUPON_SETTINGS_SAVE();
			case AuditEventType.CardProcessorSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CARD_PROCESSOR_SETTINGS_SAVED();
			case AuditEventType.CardProcessorTablePaymentSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CARD_PROCESSOR_TABLE_PAYMENT_SETTINGS_SAVED();
			case AuditEventType.CashControlSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_SETTINGS_SAVED();
			case AuditEventType.Invoice_SetCustomer:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVOICE_SET_CUSTOMER();
			case AuditEventType.PurchaseOrder_AttachDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_ATTACH_DOCUMENT();
			case AuditEventType.IncomingDeliveryNote_AttachDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_ATTACH_DOCUMENT();
			case AuditEventType.PurchaseInvoice_AttachDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_INVOICE_ATTACH_DOCUMENT();
			case AuditEventType.Allergen_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_ALLERGEN_SAVE();
			case AuditEventType.DigitalMenu_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DIGITAL_MENU_SAVE();
			case AuditEventType.DigitalMenuResources_Update:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DIGITAL_MENU_RESOURCES_UPDATED();
			case AuditEventType.ProductTag_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_TAG_SAVE();
			case AuditEventType.EmailAccount_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_EMAIL_ACCOUNT_SAVE();
			case AuditEventType.Lot_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LOT_SAVE();
			case AuditEventType.Label_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LABEL_SAVE();
			case AuditEventType.Preparation_RequestLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_REQUEST_ORDERED_LINE();
			case AuditEventType.DisplayPreparation_UndoItem:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_PREPARATION_UNDO_ITEM();
			case AuditEventType.CustomerType_Deleted:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOMER_TYPE_DELETED();
			case AuditEventType.CustomerType_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOMER_TYPE_SAVE();
			case AuditEventType.SmartMenuOrderSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SMART_MENU_ORDER_SETTINGS_SAVE();
			case AuditEventType.WarehouseCloseOut_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WAREHOUSE_CLOSE_OUT_SAVE();
			case AuditEventType.Inventory_Confirm:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVENTORY_CONFIRM();
			case AuditEventType.Inventory_UnConfirm:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVENTORY_UNCONFIRM();
			case AuditEventType.Ticket_AddOnlineReservation:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_ONLINE_RESERVATION();
			case AuditEventType.Ticket_RemoveOnlineReservation:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REMOVE_ONLINE_RESERVATION();
			case AuditEventType.SmartMenuWorkplaceGroupSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SMART_MENU_WORKPLACE_GROUP_SETTINGS_SAVE();
			case AuditEventType.CashControlTransaction_Registered:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_TRANSACTION_REGISTERED();
			case AuditEventType.CardTransaction_Completed:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CARD_TRANSACTION_COMPLETED();
			case AuditEventType.Ticket_AdjustIngredients:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_ADJUST_INGREDIENTS();
			case AuditEventType.Ticket_SetMinAmount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_MIN_AMOUNT();
			case AuditEventType.IncomingDeliveryNote_Confirm:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_CONFIRM();
			case AuditEventType.IncomingDeliveryNote_UndoConfirm:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_UNDO_CONFIRM();
			case AuditEventType.Ticket_SetLineSeatNumber:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_SEAT_NUMBER();
			case AuditEventType.ReportView_Add:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_REPORT_VIEW_ADD();
			case AuditEventType.ReportView_SetDefault:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_REPORT_VIEW_SET_DEFAULT();
			case AuditEventType.ReportView_ClearDefault:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_REPORT_VIEW_CLEAR_DEFAULT();
			case AuditEventType.SifSettings_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SIF_SETTINGS_SAVE();
			case AuditEventType.SifSettings_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SIF_SETTINGS_DELETE();
			case AuditEventType.InternalSupplier_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INTERNAL_SUPPLIER_SAVE();
			case AuditEventType.InternalSupplier_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INTERNAL_SUPPLIER_DELETE();
			case AuditEventType.InternalCustomer_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INTERNAL_CUSTOMER_SAVE();
			case AuditEventType.InternalCustomer_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INTERNAL_CUSTOMER_DELETE();
			case AuditEventType.Preparation_Prepare_Again:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_PREPARE_AGAIN();
			case AuditEventType.MyAgoraAccount_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MY_AGORA_ACCOUNT_DELETE();
			case AuditEventType.MyAgoraAccount_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MY_AGORA_ACCOUNT_SAVE();
			case AuditEventType.StockChange_AttachDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_ATTACH_DOCUMENT();
			case AuditEventType.Medium:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MEDIUM();
			case AuditEventType.Emailing_Send:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_EMAILING_SEND();
			case AuditEventType.POS_PrintPartialBalance:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_PRINT_PARTIAL_BALANCE();
			case AuditEventType.POS_PrintTotalBalance:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_PRINT_TOTAL_BALANCE();
			case AuditEventType.POS_CloseDay:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_CLOSE_DAY();
			case AuditEventType.POS_OpenDay:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_OPEN_DAY();
			case AuditEventType.Ticket_ChangePayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CHANGE_PAYMENT();
			case AuditEventType.Ticket_Close:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CLOSE();
			case AuditEventType.DeliveryNote_Create:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE();
			case AuditEventType.Ticket_SetLinePercentageDiscount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_LINE_PERCENTAGE_DISCOUNT();
			case AuditEventType.Ticket_SetLineCashDiscount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_LINE_CASH_DISCOUNT();
			case AuditEventType.Ticket_SetLinePrice:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_LINE_PRICE();
			case AuditEventType.Ticket_UnPark:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_UNPARK();
			case AuditEventType.Login_Success:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LOGIN_SUCCESS();
			case AuditEventType.POS_OpenCashdrawer:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_OPEN_CASHDRAWER();
			case AuditEventType.Ticket_Join:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_JOIN();
			case AuditEventType.Ticket_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_PRINT();
			case AuditEventType.Category_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CATEGORY_DELETE();
			case AuditEventType.Emailing_Cancel:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_EMAILING_CANCEL();
			case AuditEventType.Emailing_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_EMAILING_DELETE();
			case AuditEventType.PriceList_SetPriceListConfiguration:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRICE_LIST_SET_PRICE_LIST_CONFIGURATION();
			case AuditEventType.Customer_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOMER_DELETE();
			case AuditEventType.CustomTemplate_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOM_TEMPLATE_DELETE();
			case AuditEventType.Family_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_FAMILY_DELETE();
			case AuditEventType.PaymentMethod_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PAYMENT_METHOD_DELETE();
			case AuditEventType.POS_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_DELETE();
			case AuditEventType.PredefinedNote_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREDEFINED_NOTE_DELETE();
			case AuditEventType.Product_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_DELETE();
			case AuditEventType.SaleCenter_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALE_CENTER_DELETE();
			case AuditEventType.SpecialPriceList_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SPECIAL_PRICE_LIST_DELETE();
			case AuditEventType.Supplier_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SUPPLIER_DELETE();
			case AuditEventType.User_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_USER_DELETE();
			case AuditEventType.IncomingDeliveryNote_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_DELETE();
			case AuditEventType.Inventory_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVENTORY_DELETE();
			case AuditEventType.Map_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MAP_DELETE();
			case AuditEventType.AuditQuery_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_AUDIT_QUERY_DELETE();
			case AuditEventType.Pos_ChangePrintMode:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CHANGE_PRINT_MODE();
			case AuditEventType.PriceList_SetScheduleTable:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRICELIST_SET_SCHEDULE_TABLE();
			case AuditEventType.System_PrintTotalBalance:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRINT_SYSTEM_TOTAL_BALANCE();
			case AuditEventType.System_OpenDay:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRINT_SYSTEM_OPEN_DAY();
			case AuditEventType.System_CloseDay:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRINT_SYSTEM_CLOSE_DAY();
			case AuditEventType.ScaleCounter_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SCALE_COUNTER_DELETE();
			case AuditEventType.ScaleCounter_Export:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SCALE_COUNTER_EXPORT();
			case AuditEventType.StockChange_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_DELETE();
			case AuditEventType.UserProfile_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_USER_PROFILE_DELETE();
			case AuditEventType.MajorGroup_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MAJOR_GROUP_DELETE();
			case AuditEventType.Logout:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LOGOUT();
			case AuditEventType.Serie_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SERIE_DELETE();
			case AuditEventType.Invoice_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVOICE_PRINT();
			case AuditEventType.Menu_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MENU_DELETE();
			case AuditEventType.PreparationType_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_TYPE_DELETE();
			case AuditEventType.PreparationOrder_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_ORDER_DELETE();
			case AuditEventType.POS_PrintCashTransaction:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_PRINT_CASH_TRANSACTION();
			case AuditEventType.ActionDisplayProfile_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_ACTION_DISPLAY_PROFILE_DELETE();
			case AuditEventType.PreparationCounter_Reset:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PREPARATION_COUNTER_RESET();
			case AuditEventType.KitchenDisplay_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_KITCHEN_DISPLAY_DELETE();
			case AuditEventType.Ticket_Gift:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_GIFT_TICKET();
			case AuditEventType.Appointment_Cancelled:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_APPOINTMENT_CANCELLED();
			case AuditEventType.Appointment_Closed:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_APPOINTMENT_CLOSED();
			case AuditEventType.Appointment_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_APPOINTMENT_DELETED();
			case AuditEventType.Offer_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_OFFER_DELETE();
			case AuditEventType.POS_PrintCashControlReport:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_PRINT_CASH_CONTROL_REPORT();
			case AuditEventType.Warehouse_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WAREHOUSE_DELETE();
			case AuditEventType.PurchaseOrder_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_DELETE();
			case AuditEventType.Ticket_SendMail:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SEND_EMAIL();
			case AuditEventType.Ticket_SetLineCreator:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_LINE_CREATOR();
			case AuditEventType.NamedDiscount_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_NAMED_DISCOUNT_DELETE();
			case AuditEventType.Ticket_SetTicketLineNamedDiscount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_TICKET_LINE_NAMED_DISCOUNT();
			case AuditEventType.Ticket_SetTicketNamedDiscount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_TICKET_NAMED_DISCOUNT();
			case AuditEventType.DeliveryNote_AddPayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_ADD_PAYMENT();
			case AuditEventType.SalesOrder_Create:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_CREATE();
			case AuditEventType.SalesOrder_Close:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_CLOSE();
			case AuditEventType.SalesOrder_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_PRINT();
			case AuditEventType.SalesOrder_AddPayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_ADD_PAYMENT();
			case AuditEventType.Ticket_AddPayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_PAYMENT();
			case AuditEventType.POS_PrintTrainingSession:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_PRINT_TRAINING_SESSION();
			case AuditEventType.PosGroup_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_GROUP_DELETE();
			case AuditEventType.LineCancellationReason_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LINE_CANCELLATION_REASON_DELETE();
			case AuditEventType.DeliveryNote_SendMail:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_SEND_EMAIL();
			case AuditEventType.SalesOrder_SendMail:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_SEND_EMAIL();
			case AuditEventType.DeliveryNote_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_PRINT();
			case AuditEventType.DisplayPreparation_CompleteItem:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_PREPARATION_COMPLETE_ITEM();
			case AuditEventType.DisplayPreparation_Complete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_PREPARATION_COMPLETE();
			case AuditEventType.CashControl_CloseDay:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_CLOSE_DAY();
			case AuditEventType.CashControl_AddChange:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_ADD_CHANGE();
			case AuditEventType.CashControl_GiveChange:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_GIVE_CHANGE();
			case AuditEventType.CashControl_ShowAdvancedOptions:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_SHOW_ADVANCED_OPTIONS();
			case AuditEventType.CashControl_ShowStatus:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_SHOW_STATUS();
			case AuditEventType.Ticket_PriceList:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_PRICE_LIST_CHANGED();
			case AuditEventType.Ticket_SetTipSettings:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_TIP_SETTINGS();
			case AuditEventType.Workplace_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WORKPLACE_DELETE();
			case AuditEventType.KitchenPrintTemplate_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_KITCHEN_PRINT_TEMPLATE_DELETE();
			case AuditEventType.CouponSettings_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COUPON_SETTINGS_DELETE();
			case AuditEventType.CouponPrintTemplate_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COUPON_PRINT_TEMPLATE_DELETE();
			case AuditEventType.ProductAvailability_Update:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_AVAILABILITY_UPDATED();
			case AuditEventType.SystemOfMeasurement_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SYSTEM_OF_MEASUREMENT_DELETE();
			case AuditEventType.CustomActionButton_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOM_ACTION_BUTTON_DELETE();
			case AuditEventType.CashControl_Reset:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_RESET();
			case AuditEventType.PurchaseInvoice_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_INVOICE_DELETE();
			case AuditEventType.Production_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCTION_DELETE();
			case AuditEventType.Production_Save:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCTION_SAVE();
			case AuditEventType.Ticket_FromDeliveryNote:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_FROM_DELIVERY_NOTE_REOPENED();
			case AuditEventType.Ticket_FromSalesOrder:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_FROM_SALES_ORDER_REOPENED();
			case AuditEventType.Ticket_FromInvoice:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_FROM_INVOICE_REOPENED();
			case AuditEventType.StockChange_LossCreated:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_LOSS_CREATED();
			case AuditEventType.GStock_AddToUpload:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_GSTOCK_ADD_TO_UPLOAD();
			case AuditEventType.Ticket_UpdateCustomerData:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_UPDATE_CUSTOMER_DATA();
			case AuditEventType.DeliveryNote_ChangeCustomer:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_CHANGE_CUSTOMER();
			case AuditEventType.SaleOrder_ChangeCustomer:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALE_ORDER_CHANGE_CUSTOMER();
			case AuditEventType.Ticket_UpdateTips:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_TIPS_UPDATED();
			case AuditEventType.CashControlSettings_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_SETTINGS_DELETED();
			case AuditEventType.CardProcessorSettings_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CARD_PROCESSOR_SETTINGS_DELETED();
			case AuditEventType.CardProcessorTablePaymentSettings_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CARD_PROCESSOR_TABLE_PAYMENT_SETTINGS_DELETED();
			case AuditEventType.Clocking_RegisterIn:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CLOCKING_REGISTER_IN();
			case AuditEventType.Clocking_RegisterOut:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CLOCKING_REGISTER_OUT();
			case AuditEventType.Ticket_SetServiceCharge:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_SERVICE_CHARGE_SETTINGS();
			case AuditEventType.WorkingPeriod_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WORKING_PERIOD_DELETE();
			case AuditEventType.DeliveryAddress_Add:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOMER_DELIVERY_ADDRESS_ADDED();
			case AuditEventType.DeliveryAddress_Remove:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CUSTOMER_DELIVERY_ADDRESS_REMOVED();
			case AuditEventType.Ticket_ChangeOpenerUser:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CHANGE_OPENER_USER();
			case AuditEventType.Ticket_BeginPartialClosing:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_BEGIN_PARTIAL_CLOSING();
			case AuditEventType.Ticket_EndPartialClosing:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_END_PARTIAL_CLOSING();
			case AuditEventType.Ticket_AddLoyaltyInfo:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_LOYALTY_INFO();
			case AuditEventType.Ticket_RemoveLoyaltyInfo:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REMOVE_LOYALTY_INFO();
			case AuditEventType.PurchaseOrder_DeleteAttachedDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_DELETE_ATTACHED_DOCUMENT();
			case AuditEventType.IncomingDeliveryNote_DeleteAttachedDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_DELETE_ATTACHED_DOCUMENT();
			case AuditEventType.PurchaseInvoice_DeleteAttachedDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_INVOICE_DELETE_ATTACHED_DOCUMENT();
			case AuditEventType.Allergen_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_ALLERGEN_DELETE();
			case AuditEventType.DigitalMenu_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DIGITAL_MENU_DELETE();
			case AuditEventType.ProductTag_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_TAG_DELETE();
			case AuditEventType.EmailAccount_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_EMAIL_ACCOUNT_DELETE();
			case AuditEventType.Lot_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LOT_DELETE();
			case AuditEventType.Ticket_SetTicketLineLot:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SET_TICKET_LINE_LOT();
			case AuditEventType.Label_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LABEL_DELETE();
			case AuditEventType.Label_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LABEL_PRINT();
			case AuditEventType.CsvLabel_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CSV_LABEL_PRINT();
			case AuditEventType.PurchaseOrder_SupplierChange:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PURCHASE_ORDER_SUPPLIER_CHANGE();
			case AuditEventType.IncomingDeliveryNote_SupplierChange:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INCOMING_DELIVERY_NOTE_SUPPLIER_CHANGE();
			case AuditEventType.DisplayPreparation_Undo:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DISPLAY_PREPARATION_UNDO();
			case AuditEventType.TableOrder_Created:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TABLE_ORDER_CREATED();
			case AuditEventType.SmartMenuOrderSettings_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SMART_MENU_ORDER_SETTINGS_DELETE();
			case AuditEventType.SalesOrder_MarkAsDelivered:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_MARK_AS_DELIVERED();
			case AuditEventType.SalesOrder_Deliver:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_DELIVER();
			case AuditEventType.SalesOrder_Accept:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_ACCEPTED();
			case AuditEventType.SalesOrder_MarkAsPrepared:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_MARK_AS_PREPARED();
			case AuditEventType.SalesOrder_Reject:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_REJECTED();
			case AuditEventType.SmartMenuOrderComms_Resume:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SMART_MENU_ORDER_COMMS_RESUME();
			case AuditEventType.WarehouseCloseOut_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WAREHOUSE_CLOSE_OUT_DELETE();
			case AuditEventType.Ticket_CompleteMenu:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_COMPLETE_MENU();
			case AuditEventType.SalesOrder_TakeOutStarted:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_TAKEOUT_STARTED();
			case AuditEventType.SalesOrder_TakeOutFinished:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_TAKEOUT_FINISHED();
			case AuditEventType.SalesOrder_ChangeDeliveryUser:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_CHANGE_DELIVERY_PERSON();
			case AuditEventType.DeliveryPerson_AddBalanceDelta:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_PERSON_ADD_BALANCE_DELTA();
			case AuditEventType.DeliveryPerson_SubstractBalanceDelta:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_PERSON_SUBSTRACT_BALANCE_DELTA();
			case AuditEventType.SmartMenuWorkplaceGroupSettings_Delete:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SMART_MENU_WORKPLACE_GROUP_SETTINGS_DELETE();
			case AuditEventType.CashControlTransaction_Undo:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CASH_CONTROL_TRANSACTION_UNDO();
			case AuditEventType.CardTransaction_Undo:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_CARD_TRANSACTION_UNDO();
			case AuditEventType.Invoice_SendAutoInvoiceLink:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SEND_AUTO_INVOICE_LINK();
			case AuditEventType.SalesOrder_UpdateDeliveryAddress:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_UPDATE_DELIVERY_ADDRESS();
			case AuditEventType.Preparation_Undo:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_UNDO_PREPARATION();
			case AuditEventType.Preparation_Start:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_START_PREPARATION();
			case AuditEventType.Preparation_Finish:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_FINISH_PREPARATION();
			case AuditEventType.Preparation_Serve:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SERVE_PREPARATION();
			case AuditEventType.Preparation_Cancellation_Accept:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_ACCEPT_PREPARATION_CANCELLATION();
			case AuditEventType.ReportView_Remove:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_REPORT_VIEW_REMOVE();
			case AuditEventType.Preparation_Served_Accept:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_ACCEPT_SERVED_PREPARATION();
			case AuditEventType.DeliveryNote_CreateFromSalesOrder:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_FROM_SALES_ORDER();
			case AuditEventType.StockChange_DeleteAttachedDocument:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_STOCK_CHANGE_DELETE_ATTACHED_DOCUMENT();
			case AuditEventType.High:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_HIGH();
			case AuditEventType.Ticket_CancelPrintedLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CANCEL_PRINTED_LINE();
			case AuditEventType.Ticket_Cancel:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CANCEL();
			case AuditEventType.POS_NegativeAmount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_NEGATIVE_AMOUNT();
			case AuditEventType.POS_CloseDayWithIncident:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_CLOSE_DAY_WITH_INCIDENT();
			case AuditEventType.POS_RegisterInputCashTransaction:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_REGISTER_INPUT_CASH_TRANSACTION();
			case AuditEventType.POS_RegisterOutputCashTransaction:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_REGISTER_OUTPUT_CASH_TRANSACTION();
			case AuditEventType.Ticket_CancelLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CANCEL_LINE();
			case AuditEventType.Management_DeleteCashActivity:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MANAGEMENT_DELETE_CASH_ACTIVITY();
			case AuditEventType.Ticket_Invoice:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_INVOICE();
			case AuditEventType.Login_Failed:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_LOGIN_FAILED();
			case AuditEventType.Ticket_RemovePrintedLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REMOVE_PRINTED_LINE();
			case AuditEventType.Ticket_RemoveLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REMOVE_LINE();
			case AuditEventType.Ticket_Reopen:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REOPEN();
			case AuditEventType.Ticket_AddFreeLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_FREE_LINE();
			case AuditEventType.Ticket_Reprint:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REPRINT();
			case AuditEventType.Ticket_SetCashDiscount:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_CASH_DISCOUNT();
			case AuditEventType.Ticket_SetDiscountRate:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_DISCOUNT_RATE();
			case AuditEventType.Product_ChangePrices:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_CHANGE_PRICES();
			case AuditEventType.POS_CloseDayForzed:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_CLOSE_DAY_FORZED();
			case AuditEventType.Invoice_Reprint:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVOICE_REPRINT();
			case AuditEventType.Ticket_DeliveryNoteCancelled:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_DELIVERY_NOTE_CANCELLED();
			case AuditEventType.Ticket_Refund:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REFUND();
			case AuditEventType.SalesOrder_Reprint:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_REPRINT();
			case AuditEventType.Product_ChangePricesByMargin:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_CHANGE_PRICES_BY_MARGIN();
			case AuditEventType.Ticket_Loss:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_LOSS();
			case AuditEventType.Ticket_DeliveryNoteReopen:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_REOPEN();
			case AuditEventType.SalesOrder_RefundPayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_REFUND_PAYMENT();
			case AuditEventType.DeliveryNote_RefundPayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_REFUND_PAYMENT();
			case AuditEventType.DeliveryNote_Reopen:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_REOPEN();
			case AuditEventType.SalesOrder_Cancel:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_CANCEL();
			case AuditEventType.Training_Configure_Settings:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TRAINING_CONFIGURE_SETTINGS();
			case AuditEventType.Ticket_RefundPayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_REFUND_PAYMENT();
			case AuditEventType.Training_Delete_All:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELETED_TRAINING_SESSIONS();
			case AuditEventType.Coupon_Configure_Settings:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COUPON_CONFIGURE_SETTINGS();
			case AuditEventType.Ticket_SetOffers:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_OFFERS();
			case AuditEventType.Ticket_SetFriendlyName:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_SET_FRIENDLY_NAME();
			case AuditEventType.DeliveryNote_Reprint:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_REPRINT();
			case AuditEventType.Hub_DiscardOperation:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_HUB_DISCARD_OPERATION();
			case AuditEventType.Workplace_UnlinkFromMachine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WORKPLACE_UNLINK_FROM_MACHINE();
			case AuditEventType.Coupon_Print:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_COUPON_PRINT();
			case AuditEventType.Product_SystemOfMeasurementChanged:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_PRODUCT_SYSTEM_OF_MEASUREMENT_CHANGED();
			case AuditEventType.Pos_IgnorePayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_IGNORE_PAYMENT();
			case AuditEventType.Management_ImportDistributorExcel:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_MANAGEMENT_IMPORT_DISTRIBUTOR_EXCEL();
			case AuditEventType.GStock_ClearUploads:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_GSTOCK_CLEAR_UPLOADS();
			case AuditEventType.Workplace_SendUpdate:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WORKPLACE_SEND_UPDATE();
			case AuditEventType.Workplace_CancelUpdate:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_WORKPLACE_CANCEL_UPDATE();
			case AuditEventType.GStock_ClearUpload:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_GSTOCK_CLEAR_ONE();
			case AuditEventType.Invoice_ReplaceContentOnPrint:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_INVOICE_REPLACE_CONTENT_ON_PRINT();
			case AuditEventType.DeliveryNote_ReplaceContentOnPrint:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DELIVERY_NOTE_REPLACE_CONTENT_ON_PRINT();
			case AuditEventType.SalesOrder_ReplaceContentOnPrint:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SALES_ORDER_REPLACE_CONTENT_ON_PRINT();
			case AuditEventType.Pos_ErrorExtractTip:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_ERROR_EXTRACT_TIP_FROM_CASHDRAWER();
			case AuditEventType.Pos_ExtractPendingTip:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_EXTRACT_PENDING_TIP();
			case AuditEventType.Ticket_AddLoyaltyInfoWithRewards:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_LOYALTY_INFO_WITH_REWARDS();
			case AuditEventType.Ticket_AddReservationPrepayment:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_RESERVATION_PREPAYMENT();
			case AuditEventType.DigitalMenu_SetOwner:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DIGITAL_MENU_SET_OWNER();
			case AuditEventType.DigitalMenu_SetWorkplaceOwner:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_DIGITAL_MENU_SET_WORKPLACE_OWNER();
			case AuditEventType.SmartMenuOrderComms_Suspend:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_SMART_MENU_ORDER_COMMS_SUSPEND();
			case AuditEventType.Ticket_AddNegativeLine:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_ADD_NEGATIVE_LINE();
			case AuditEventType.CashControlTransaction_UndoFailed:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_CASH_CONTROL_TRANSACTION_UNDO_FAILED();
			case AuditEventType.CardTransaction_UndoFailed:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_CARD_TRANSACTION_UNDO_FAILED();
			case AuditEventType.Ticket_CancelPartialClosing:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CANCEL_PARTIAL_CLOSING();
			case AuditEventType.Pos_AddPendingTip:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_POS_ADD_PENDING_TIP();
			case AuditEventType.Ticket_UnlockedByPos:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_UNLOCKED_BY_POS();
			case AuditEventType.Ticket_CheckPendingCardTransactions:
				return Res.Const.ENUM_AUDIT_EVENT_TYPE_TICKET_CHECK_PENDING_CARD_TRANSACTIONS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum CancellationType {
	UnPaid = 0,
	Error = 1,
	Other = 2
}

export namespace CancellationType {
	export function toString(value: CancellationType) {
		switch (value) {
			case CancellationType.UnPaid:
				return Res.Const.ENUM_CANCELLATION_TYPE_UNPAID();
			case CancellationType.Error:
				return Res.Const.ENUM_CANCELLATION_TYPE_ERROR();
			case CancellationType.Other:
				return Res.Const.ENUM_CANCELLATION_TYPE_OTHERS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum CardTransactionType {
	ClearOne = 0,
	Redsys = 1,
	UniversalPay = 2,
	AdyenEcommerce = 3,
	Adyen = 4,
	AdyenNYC1 = 5,
	AdyenTapToPay = 6
}

export namespace CardTransactionType {
	export function toString(value: CardTransactionType) {
		switch (value) {
			case CardTransactionType.ClearOne:
				return Res.Const.ENUM_CARD_TRANSACTION_TYPE_CLEARONE();
			case CardTransactionType.Redsys:
				return Res.Const.ENUM_CARD_TRANSACTION_TYPE_REDSYS();
			case CardTransactionType.UniversalPay:
				return Res.Const.ENUM_CARD_TRANSACTION_TYPE_UNIVERSAL_PAY();
			case CardTransactionType.AdyenEcommerce:
				return Res.Const.ENUM_CARD_TRANSACTION_TYPE_ADYEN_ECOMMERCE();
			case CardTransactionType.Adyen:
				return Res.Const.ENUM_CARD_TRANSACTION_TYPE_ADYEN();
			case CardTransactionType.AdyenNYC1:
				return Res.Const.ENUM_CARD_TRANSACTION_TYPE_ADYEN_NYC1();
			case CardTransactionType.AdyenTapToPay:
				return Res.Const.ENUM_CARD_TRANSACTION_TYPE_ADYEN_TAP_TO_PAY();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum CostPriceMode {
	ByWarehouse = 0,
	Global = 1
}

export namespace CostPriceMode {
	export function toString(value: CostPriceMode) {
		switch (value) {
			case CostPriceMode.ByWarehouse:
				return Res.Const.ENUM_COST_PRICE_MODE_BY_WAREHOUSE();
			case CostPriceMode.Global:
				return Res.Const.ENUM_COST_PRICE_MODE_GLOBAL();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum CustomActionType {
	External = 0,
	DirectPayment = 1,
	NamedDiscount = 2,
	PriceList = 3,
	Offer = 4
}

export namespace CustomActionType {
	export function toString(value: CustomActionType) {
		switch (value) {
			case CustomActionType.External:
				return Res.Const.ENUM_CUSTOM_ACTION_COMMAND_TYPE_EXTERNAL();
			case CustomActionType.DirectPayment:
				return Res.Const.ENUM_CUSTOM_ACTION_COMMAND_TYPE_DIRECT_PAYMENT();
			case CustomActionType.NamedDiscount:
				return Res.Const.ENUM_CUSTOM_ACTION_COMMAND_TYPE_NAMED_DISCOUNT();
			case CustomActionType.PriceList:
				return Res.Const.ENUM_CUSTOM_ACTION_COMMAND_TYPE_PRICE_LIST();
			case CustomActionType.Offer:
				return Res.Const.ENUM_CUSTOM_ACTION_COMMAND_TYPE_OFFER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum CustomerDisplayType {
	None = 0,
	Serie = 1,
	Screen = 2
}

export namespace CustomerDisplayType {
	export function toString(value: CustomerDisplayType) {
		switch (value) {
			case CustomerDisplayType.None:
				return Res.Const.ENUM_CUSTOMER_DISPLAY_NONE_TYPE();
			case CustomerDisplayType.Serie:
				return Res.Const.ENUM_CUSTOMER_DISPLAY_SERIE_TYPE();
			case CustomerDisplayType.Screen:
				return Res.Const.ENUM_CUSTOMER_DISPLAY_SCREEN_TYPE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum CustomerDocumentIdType {
	DNI = 0,
	CIF = 1,
	NIE = 2,
	Other = 3
}

export namespace CustomerDocumentIdType {
	export function toString(value: CustomerDocumentIdType) {
		switch (value) {
			case CustomerDocumentIdType.DNI:
				return Res.Const.ENUM_CUSTOMER_DOCUMENT_ID_DNI();
			case CustomerDocumentIdType.CIF:
				return Res.Const.ENUM_CUSTOMER_DOCUMENT_ID_CIF();
			case CustomerDocumentIdType.NIE:
				return Res.Const.ENUM_CUSTOMER_DOCUMENT_ID_NIE();
			case CustomerDocumentIdType.Other:
				return Res.Const.ENUM_CUSTOMER_DOCUMENT_ID_OTHER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum CustomQueryColumnAlignment {
	Left = 0,
	Center = 1,
	Right = 2
}

export enum CustomQueryColumnTotalizer {
	None = 0,
	Sum = 1,
	Count = 2,
	Avg = 3
}

export enum CustomQueryParamType {
	Date = 0,
	Int = 1,
	String = 2,
	Decimal = 3,
	Bool = 4,
	Family = 5,
	Category = 6,
	Supplier = 7,
	PosGroup = 8,
	Warehouse = 9,
	PriceList = 10,
	Product = 11,
	SaleFormat = 12,
	PreparationType = 13,
	PreparationOrder = 14,
	PaymentMethod = 15,
	SaleCenter = 16,
	Offer = 17,
	NamedDiscount = 18,
	User = 19,
	Custom = 20,
	TimeFrameGroup = 21,
	Workplace = 22
}

export enum DeliveryStatus {
	New = 0,
	Accepted = 1,
	Rejected = 2,
	Preparing = 3,
	Prepared = 4,
	Delivering = 5,
	Delivered = 6
}

export namespace DeliveryStatus {
	export function toString(value: DeliveryStatus) {
		switch (value) {
			case DeliveryStatus.New:
				return Res.Const.ENUM_DELIVERY_STATUS_NEW();
			case DeliveryStatus.Accepted:
				return Res.Const.ENUM_DELIVERY_STATUS_ACCEPTED();
			case DeliveryStatus.Rejected:
				return Res.Const.ENUM_DELIVERY_STATUS_REJECTED();
			case DeliveryStatus.Preparing:
				return Res.Const.ENUM_DELIVERY_STATUS_PREPARING();
			case DeliveryStatus.Prepared:
				return Res.Const.ENUM_DELIVERY_STATUS_PREPARED();
			case DeliveryStatus.Delivering:
				return Res.Const.ENUM_DELIVERY_STATUS_DELIVERING();
			case DeliveryStatus.Delivered:
				return Res.Const.ENUM_DELIVERY_STATUS_DELIVERED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum DigitalMenuMode {
	ScanAndPay = 0,
	TableOrder = 1,
	TakeOut = 2,
	ScanAndPayAndTableOrder = 3
}

export namespace DigitalMenuMode {
	export function toString(value: DigitalMenuMode) {
		switch (value) {
			case DigitalMenuMode.ScanAndPay:
				return Res.Const.ENUM_DIGITAL_MENU_MODE_SCANANDPAY();
			case DigitalMenuMode.TableOrder:
				return Res.Const.ENUM_DIGITAL_MENU_MODE_TABLEORDER();
			case DigitalMenuMode.TakeOut:
				return Res.Const.ENUM_DIGITAL_MENU_MODE_TAKEOUT();
			case DigitalMenuMode.ScanAndPayAndTableOrder:
				return Res.Const.ENUM_DIGITAL_MENU_MODE_SCAN_AND_PAY_AND_TABLE_ORDER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum DiscountMode {
	Rate = 0,
	Cash = 1
}

export namespace DiscountMode {
	export function toString(value: DiscountMode) {
		switch (value) {
			case DiscountMode.Rate:
				return Res.Const.ENUM_DISCOUNT_MODE_RATE();
			case DiscountMode.Cash:
				return Res.Const.ENUM_DISCOUNT_MODE_CASH();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum DiscountStrategyApplyBy {
	Groups = 0,
	Units = 1
}

export namespace DiscountStrategyApplyBy {
	export function toString(value: DiscountStrategyApplyBy) {
		switch (value) {
			case DiscountStrategyApplyBy.Groups:
				return Res.Const.ENUM_DISCOUNT_STRATEGY_APPLY_BY_GROUPS();
			case DiscountStrategyApplyBy.Units:
				return Res.Const.ENUM_DISCOUNT_STRATEGY_APPLY_BY_UNITS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum DisplayPreparationPrintMode {
	Manual = 0,
	OnComplete = 1,
	OnCompleteLine = 2,
	OnServe = 3,
	OnServeLine = 4,
	OnAcceptServed = 5,
	OnAcceptServedLine = 6
}

export namespace DisplayPreparationPrintMode {
	export function toString(value: DisplayPreparationPrintMode) {
		switch (value) {
			case DisplayPreparationPrintMode.Manual:
				return Res.Const.ENUM_DISPLAY_PREPARATION_PRINT_MODE_MANUAL();
			case DisplayPreparationPrintMode.OnComplete:
				return Res.Const.ENUM_DISPLAY_PREPARATION_PRINT_MODE_ON_COMPLETE();
			case DisplayPreparationPrintMode.OnCompleteLine:
				return Res.Const.ENUM_DISPLAY_PREPARATION_PRINT_MODE_ON_COMPLETE_LINE();
			case DisplayPreparationPrintMode.OnServe:
				return Res.Const.ENUM_DISPLAY_PREPARATION_PRINT_MODE_ON_SEVE();
			case DisplayPreparationPrintMode.OnServeLine:
				return Res.Const.ENUM_DISPLAY_PREPARATION_PRINT_MODE_ON_SERVE_LINE();
			case DisplayPreparationPrintMode.OnAcceptServed:
				return Res.Const.ENUM_DISPLAY_PREPARATION_PRINT_MODE_ON_ACCEPT_SERVED();
			case DisplayPreparationPrintMode.OnAcceptServedLine:
				return Res.Const.ENUM_DISPLAY_PREPARATION_PRINT_MODE_ON_ACCEPT_SERVED_LINE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum DocumentPrinterType {
	Ticket = 0,
	BasicInvoice = 1,
	StandardInvoice = 2,
	DeliveryNote = 3
}

export namespace DocumentPrinterType {
	export function toString(value: DocumentPrinterType) {
		switch (value) {
			case DocumentPrinterType.Ticket:
				return Res.Const.ENUM_DOCUMENT_PRINTER_TYPE_TICKET();
			case DocumentPrinterType.BasicInvoice:
				return Res.Const.ENUM_DOCUMENT_PRINTER_TYPE_BASIC_INVOICE();
			case DocumentPrinterType.StandardInvoice:
				return Res.Const.ENUM_DOCUMENT_PRINTER_TYPE_STANDARD_INVOICE();
			case DocumentPrinterType.DeliveryNote:
				return Res.Const.ENUM_DOCUMENT_PRINTER_TYPE_DELIVERY_NOTE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum DocumentType {
	BasicInvoice = 0,
	StandardInvoice = 1,
	DeliveryNote = 2,
	BasicRefund = 3,
	StandardRefund = 4,
	SalesOrder = 5,
	PurchaseOrder = 6,
	IncomingDeliveryNote = 7,
	PurchaseInvoice = 8
}

export namespace DocumentType {
	export function toString(value: DocumentType) {
		switch (value) {
			case DocumentType.BasicInvoice:
				return Res.Const.ENUM_DOCUMENT_TYPE_BASICINVOICE();
			case DocumentType.StandardInvoice:
				return Res.Const.ENUM_DOCUMENT_TYPE_STANDARDINVOICE();
			case DocumentType.DeliveryNote:
				return Res.Const.ENUM_DOCUMENT_TYPE_DELIVERYINVOICE();
			case DocumentType.BasicRefund:
				return Res.Const.ENUM_DOCUMENT_TYPE_BASICREFUND();
			case DocumentType.StandardRefund:
				return Res.Const.ENUM_DOCUMENT_TYPE_STANDARDREFUND();
			case DocumentType.SalesOrder:
				return Res.Const.ENUM_DOCUMENT_TYPE_SALESORDERINVOICE();
			case DocumentType.PurchaseOrder:
				return Res.Const.ENUM_DOCUMENT_TYPE_PURCHASEORDER();
			case DocumentType.IncomingDeliveryNote:
				return Res.Const.ENUM_DOCUMENT_TYPE_INCOMINGDELIVERYNOTE();
			case DocumentType.PurchaseInvoice:
				return Res.Const.ENUM_DOCUMENT_TYPE_PURCHASEINVOICE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum EmailDeliveryResult {
	Pending = 0,
	OK = 1,
	Error = 2
}

export namespace EmailDeliveryResult {
	export function toString(value: EmailDeliveryResult) {
		switch (value) {
			case EmailDeliveryResult.Pending:
				return Res.Const.ENUM_EMAIL_DELIVERY_RESULT_PENDING();
			case EmailDeliveryResult.OK:
				return Res.Const.ENUM_EMAIL_DELIVERY_RESULT_OK();
			case EmailDeliveryResult.Error:
				return Res.Const.ENUM_EMAIL_DELIVERY_RESULT_ERROR();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum EmailingState {
	Unscheduled = 0,
	Sending = 1,
	Completed = 2,
	Cancelling = 3
}

export namespace EmailingState {
	export function toString(value: EmailingState) {
		switch (value) {
			case EmailingState.Unscheduled:
				return Res.Const.ENUM_EMAILING_STATE_UNSCHEDULED();
			case EmailingState.Sending:
				return Res.Const.ENUM_EMAILING_STATE_SENDING();
			case EmailingState.Completed:
				return Res.Const.ENUM_EMAILING_STATE_COMPLETED();
			case EmailingState.Cancelling:
				return Res.Const.ENUM_EMAILING_STATE_CANCELLING();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum EntityType {
	Ticket = 10,
	DeliveryNote = 11,
	Invoice = 12,
	Cancellation = 13,
	SalesOrder = 14
}

export enum FiscalSystem {
	None = 0,
	TicketBAI = 1,
	Verifactu = 2
}

export namespace FiscalSystem {
	export function toString(value: FiscalSystem) {
		switch (value) {
			case FiscalSystem.None:
				return Res.Const.ENUM_FISCAL_SYSTEM_NONE();
			case FiscalSystem.TicketBAI:
				return Res.Const.ENUM_FISCAL_SYSTEM_TICKET_BAI();
			case FiscalSystem.Verifactu:
				return Res.Const.ENUM_FISCAL_SYSTEM_VERIFACTU();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum FlowAction {
	DoNothing = 0,
	ChangeUser = 1,
	ChangeLocation = 2
}

export namespace FlowAction {
	export function toString(value: FlowAction) {
		switch (value) {
			case FlowAction.DoNothing:
				return Res.Const.ENUM_FLOW_ACTION_DO_NOTHING();
			case FlowAction.ChangeUser:
				return Res.Const.ENUM_FLOW_ACTION_CHANGE_USER();
			case FlowAction.ChangeLocation:
				return Res.Const.ENUM_FLOW_ACTION_CHANGE_LOCATION();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum Handshake {
	None = 0,
	XOnXOff = 1,
	RequestToSend = 2,
	RequestToSendXOnXOff = 3
}

export enum HubClientCommStatus {
	Success = 0,
	Error = 1
}

export namespace HubClientCommStatus {
	export function toString(value: HubClientCommStatus) {
		switch (value) {
			case HubClientCommStatus.Success:
				return Res.Const.ENUM_HUB_CLIENT_COMM_STATUS_SUCCESS();
			case HubClientCommStatus.Error:
				return Res.Const.ENUM_HUB_CLIENT_COMM_STATUS_ERROR();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum HubCommStatus {
	Success = 0,
	Error = 1,
	Pending = 2,
	Downloading = 3
}

export namespace HubCommStatus {
	export function toString(value: HubCommStatus) {
		switch (value) {
			case HubCommStatus.Success:
				return Res.Const.ENUM_HUB_COMM_STATUS_SUCCESS();
			case HubCommStatus.Error:
				return Res.Const.ENUM_HUB_COMM_STATUS_ERROR();
			case HubCommStatus.Pending:
				return Res.Const.ENUM_HUB_COMM_STATUS_PENDING();
			case HubCommStatus.Downloading:
				return Res.Const.ENUM_HUB_COMM_STATUS_DOWNLOADING();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum IncomingDeliveryNoteStatus {
	Draft = 0,
	Confirmed = 1,
	Invoiced = 2
}

export namespace IncomingDeliveryNoteStatus {
	export function toString(value: IncomingDeliveryNoteStatus) {
		switch (value) {
			case IncomingDeliveryNoteStatus.Draft:
				return Res.Const.ENUM_INCOMING_DELIVERY_NOTE_STATUS_DRAFT();
			case IncomingDeliveryNoteStatus.Confirmed:
				return Res.Const.ENUM_INCOMING_DELIVERY_NOTE_STATUS_CONFIRMED();
			case IncomingDeliveryNoteStatus.Invoiced:
				return Res.Const.ENUM_INCOMING_DELIVERY_NOTE_STATUS_INVOICED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum InstallationType {
	Hub = 0,
	HubClient = 1,
	Standalone = 2
}

export namespace InstallationType {
	export function toString(value: InstallationType) {
		switch (value) {
			case InstallationType.Hub:
				return Res.Const.ENUM_INSTALLATION_TYPE_HUB();
			case InstallationType.HubClient:
				return Res.Const.ENUM_INSTALLATION_TYPE_HUB_CLIENT();
			case InstallationType.Standalone:
				return Res.Const.ENUM_INSTALLATION_TYPE_STANDALONE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum InternalOrderServeMode {
	CancelPending = 0,
	CreateNewOrder = 1
}

export namespace InternalOrderServeMode {
	export function toString(value: InternalOrderServeMode) {
		switch (value) {
			case InternalOrderServeMode.CancelPending:
				return Res.Const.ENUM_SALES_ORDER_SERVE_MODE_CANCEL_PENDING();
			case InternalOrderServeMode.CreateNewOrder:
				return Res.Const.ENUM_SALES_ORDER_SERVE_MODE_CREATE_NEW_ORDER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum InventoryState {
	Draft = 0,
	Confirmed = 1
}

export namespace InventoryState {
	export function toString(value: InventoryState) {
		switch (value) {
			case InventoryState.Draft:
				return Res.Const.ENUM_INVENTORY_STATE_DRAFT();
			case InventoryState.Confirmed:
				return Res.Const.ENUM_INVENTORY_STATE_CONFIRMED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum InvoiceContentType {
	SingleTicket = 0,
	DeliveryNotes = 1
}

export namespace InvoiceContentType {
	export function toString(value: InvoiceContentType) {
		switch (value) {
			case InvoiceContentType.SingleTicket:
				return Res.Const.ENUM_INVOICE_CONTENT_TYPE_SINGLE_TICKET();
			case InvoiceContentType.DeliveryNotes:
				return Res.Const.ENUM_INVOICE_CONTENT_TYPE_DELIVERY_NOTES();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum KitchenDisplayType {
	FastFood = 0,
	Restaurant = 1
}

export namespace KitchenDisplayType {
	export function toString(value: KitchenDisplayType) {
		switch (value) {
			case KitchenDisplayType.FastFood:
				return Res.Const.ENUM_KITCHEN_DISPLAY_TYPE_FAST_FOOD();
			case KitchenDisplayType.Restaurant:
				return Res.Const.ENUM_KITCHEN_DISPLAY_TYPE_RESTAURANT();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum KitchenDisplayVisualizationMode {
	Classic = 0,
	Rows = 1,
	Mixed = 2
}

export namespace KitchenDisplayVisualizationMode {
	export function toString(value: KitchenDisplayVisualizationMode) {
		switch (value) {
			case KitchenDisplayVisualizationMode.Classic:
				return Res.Const.ENUM_KITCHEN_DISPLAY_VISUALIZATION_MODE_CLASSIC();
			case KitchenDisplayVisualizationMode.Rows:
				return Res.Const.ENUM_KITCHEN_DISPLAY_VISUALIZATION_MODE_ROWS();
			case KitchenDisplayVisualizationMode.Mixed:
				return Res.Const.ENUM_KITCHEN_DISPLAY_VISUALIZATION_MODE_MIXED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum KitchenTemplateFontSize {
	Regular = 0,
	Large = 1
}

export namespace KitchenTemplateFontSize {
	export function toString(value: KitchenTemplateFontSize) {
		switch (value) {
			case KitchenTemplateFontSize.Regular:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_FONT_SIZE_REGULAR();
			case KitchenTemplateFontSize.Large:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_FONT_SIZE_LARGE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum KitchenTemplateLineMode {
	AsTicket = 0,
	Grouped = 1,
	OnePerUnit = 2,
	GroupedNotes = 3
}

export namespace KitchenTemplateLineMode {
	export function toString(value: KitchenTemplateLineMode) {
		switch (value) {
			case KitchenTemplateLineMode.AsTicket:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_LINE_MODE_AS_TICKET();
			case KitchenTemplateLineMode.Grouped:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_LINE_MODE_GROUPED();
			case KitchenTemplateLineMode.OnePerUnit:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_LINE_MODE_ONE_PER_UNIT();
			case KitchenTemplateLineMode.GroupedNotes:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_LINE_MODE_GROUPED_NOTES();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum KitchenTemplateSplitPreparationMode {
	ByDefault = 0,
	ByOrder = 1,
	ByLines = 2
}

export namespace KitchenTemplateSplitPreparationMode {
	export function toString(value: KitchenTemplateSplitPreparationMode) {
		switch (value) {
			case KitchenTemplateSplitPreparationMode.ByDefault:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_SPLIT_PREPARATION_MODE_BY_DEFAULT();
			case KitchenTemplateSplitPreparationMode.ByOrder:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_SPLIT_PREPARATION_MODE_BY_ORDER();
			case KitchenTemplateSplitPreparationMode.ByLines:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_SPLIT_PREPARATION_MODE_BY_LINES();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum KitchenTemplateWidth {
	Columns33 = 0,
	Columns42 = 1,
	Columns48 = 2
}

export namespace KitchenTemplateWidth {
	export function toString(value: KitchenTemplateWidth) {
		switch (value) {
			case KitchenTemplateWidth.Columns33:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_WIDTH_COLUMNS_33();
			case KitchenTemplateWidth.Columns42:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_WIDTH_COLUMNS_42();
			case KitchenTemplateWidth.Columns48:
				return Res.Const.ENUM_KITCHEN_TEMPLATE_WIDTH_COLUMNS_48();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum LabelFormat {
	Epl = 0,
	Zpl = 1
}

export namespace LabelFormat {
	export function toString(value: LabelFormat) {
		switch (value) {
			case LabelFormat.Epl:
				return Res.Const.ENUM_LABEL_FORMAT_EPL();
			case LabelFormat.Zpl:
				return Res.Const.ENUM_LABEL_FORMAT_ZPL();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum LabelMediaType {
	Gap = 0,
	Mark = 1
}

export namespace LabelMediaType {
	export function toString(value: LabelMediaType) {
		switch (value) {
			case LabelMediaType.Gap:
				return Res.Const.ENUM_LABEL_MEDIA_TYPE_GAP();
			case LabelMediaType.Mark:
				return Res.Const.ENUM_LABEL_MEDIA_TYPE_MARK();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum LicenseStatus {
	OK = 0,
	Warning = 1,
	Error = 2
}

export enum LicenseType {
	Invalid = 0,
	Demo = 1,
	Regular = 2,
	Lite = 3
}

export namespace LicenseType {
	export function toString(value: LicenseType) {
		switch (value) {
			case LicenseType.Invalid:
				return Res.Const.ENUM_LICENSE_TYPE_INVALID();
			case LicenseType.Demo:
				return Res.Const.ENUM_LICENSE_TYPE_DEMO();
			case LicenseType.Regular:
				return Res.Const.ENUM_LICENSE_TYPE_REGULAR();
			case LicenseType.Lite:
				return Res.Const.ENUM_LICENSE_TYPE_LITE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum LicensingMode {
	Perpetual = 0,
	Temporary = 1,
	Subscription = 2
}

export namespace LicensingMode {
	export function toString(value: LicensingMode) {
		switch (value) {
			case LicensingMode.Perpetual:
				return Res.Const.ENUM_LICENSING_MODE_PERPETUAL();
			case LicensingMode.Temporary:
				return Res.Const.ENUM_LICENSING_MODE_TEMPORARY();
			case LicensingMode.Subscription:
				return Res.Const.ENUM_LICENSING_MODE_SUBSCRIPTION();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum LinesOrderType {
	ByDefault = 0,
	ByFamilyOrder = 1,
	ByPreparationOrder = 2
}

export namespace LinesOrderType {
	export function toString(value: LinesOrderType) {
		switch (value) {
			case LinesOrderType.ByDefault:
				return Res.Const.ENUM_LINES_ORDER_TYPE_BY_DEFAULT();
			case LinesOrderType.ByFamilyOrder:
				return Res.Const.ENUM_LINES_ORDER_TYPE_BY_FAMILY_ORDER();
			case LinesOrderType.ByPreparationOrder:
				return Res.Const.ENUM_LINES_ORDER_TYPE_BY_PREPARATION_ORDER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum LocationButtonAmountMode {
	Consumption = 0,
	Balance = 1
}

export namespace LocationButtonAmountMode {
	export function toString(value: LocationButtonAmountMode) {
		switch (value) {
			case LocationButtonAmountMode.Consumption:
				return Res.Const.ENUM_LOCATION_BUTTON_AMOUNT_CONSUMPTION_MODE();
			case LocationButtonAmountMode.Balance:
				return Res.Const.ENUM_LOCATION_BUTTON_AMOUNT_BALANCE_MODE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum MachineType {
	Pos = 0,
	Server = 1,
	SmartphoneOrTablet = 2,
	KitchenDisplay = 3,
	WebAdmin = 4,
	WarehouseSmartphone = 5
}

export enum MovementType {
	Purchase = 0,
	Sale = 1,
	Inventory = 2,
	StockChange = 3,
	Production = 4
}

export namespace MovementType {
	export function toString(value: MovementType) {
		switch (value) {
			case MovementType.Purchase:
				return Res.Const.ENUM_MOVEMENT_TYPE_PURCHASE();
			case MovementType.Sale:
				return Res.Const.ENUM_MOVEMENT_TYPE_SALE();
			case MovementType.Inventory:
				return Res.Const.ENUM_MOVEMENT_TYPE_INVENTORY();
			case MovementType.StockChange:
				return Res.Const.ENUM_MOVEMENT_TYPE_STOCK_CHANGE();
			case MovementType.Production:
				return Res.Const.ENUM_MOVEMENT_TYPE_PRODUCTION();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum NamedDiscountType {
	Ticket = 0,
	Line = 1
}

export namespace NamedDiscountType {
	export function toString(value: NamedDiscountType) {
		switch (value) {
			case NamedDiscountType.Ticket:
				return Res.Const.ENUM_NAMED_DISCOUNT_TYPE_TICKET();
			case NamedDiscountType.Line:
				return Res.Const.ENUM_NAMED_DISCOUNT_TYPE_LINE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum OfferApplicationMode {
	AllTickets = 0,
	SelectedCustomerOrTickets = 1
}

export namespace OfferApplicationMode {
	export function toString(value: OfferApplicationMode) {
		switch (value) {
			case OfferApplicationMode.AllTickets:
				return Res.Const.ENUM_OFFER_APPLICATION_MODE_ALL_TICKETS();
			case OfferApplicationMode.SelectedCustomerOrTickets:
				return Res.Const.ENUM_OFFER_TYPE_DIRECT_DISCOUNT_SELECTED_CUSTOMERS_OR_TICKETS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum OfferCandidates {
	MostExpensive = 0,
	Cheapest = 1
}

export namespace OfferCandidates {
	export function toString(value: OfferCandidates) {
		switch (value) {
			case OfferCandidates.MostExpensive:
				return Res.Const.ENUM_OFFER_CANDIDATES_MOST_EXPENSIVE();
			case OfferCandidates.Cheapest:
				return Res.Const.ENUM_OFFER_CANDIDATES_CHEAPEST();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum OfferType {
	DirectDiscount = 0,
	BuyOneGetOneFree = 1,
	SecondUnitDiscount = 2,
	TakeNPayM = 3,
	Custom = 4,
	FixedPrice = 5
}

export namespace OfferType {
	export function toString(value: OfferType) {
		switch (value) {
			case OfferType.DirectDiscount:
				return Res.Const.ENUM_OFFER_TYPE_DIRECT_DISCOUNT();
			case OfferType.BuyOneGetOneFree:
				return Res.Const.ENUM_OFFER_TYPE_BUY_ONE_GET_ONE_FREE();
			case OfferType.SecondUnitDiscount:
				return Res.Const.ENUM_OFFER_TYPE_SECOND_UNIT_DISCOUNT();
			case OfferType.TakeNPayM:
				return Res.Const.ENUM_OFFER_TYPE_TAKE_N_PAY_M();
			case OfferType.Custom:
				return Res.Const.ENUM_OFFER_TYPE_CUSTOM();
			case OfferType.FixedPrice:
				return Res.Const.ENUM_OFFER_TYPE_FIXED_PRICE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum OnSelectLocationAction {
	LoadOpenedOrCreateNewTicket = 0,
	LoadByUserOrCreateNewTicket = 1,
	AlwaysCreateNewTicket = 2
}

export namespace OnSelectLocationAction {
	export function toString(value: OnSelectLocationAction) {
		switch (value) {
			case OnSelectLocationAction.LoadOpenedOrCreateNewTicket:
				return Res.Const.ENUM_ON_SELECT_LOCATION_ACTION_LOAD_OPENED_OR_CREATE_NEW_TICKET();
			case OnSelectLocationAction.LoadByUserOrCreateNewTicket:
				return Res.Const.ENUM_ON_SELECT_LOCATION_ACTION_LOAD_BY_USER_OR_CREATE_NEW_TICKET();
			case OnSelectLocationAction.AlwaysCreateNewTicket:
				return Res.Const.ENUM_ON_SELECT_LOCATION_ACTION_CREATE_NEW_TICKET();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum OutOfBandMessageSeverity {
	Info = 0,
	Warning = 1,
	Error = 2
}

export enum PagerMode {
	ExternalBar = 0,
	InlineButtons = 1
}

export namespace PagerMode {
	export function toString(value: PagerMode) {
		switch (value) {
			case PagerMode.ExternalBar:
				return Res.Const.ENUM_PAGER_MODE_EXTERNAL_BAR();
			case PagerMode.InlineButtons:
				return Res.Const.ENUM_PAGER_MODE_INLINE_BUTTONS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum Parity {
	None = 0,
	Odd = 1,
	Even = 2,
	Mark = 3,
	Space = 4
}

export enum PaymentPlatformType {
	UPay = 0,
	Adyen = 1
}

export namespace PaymentPlatformType {
	export function toString(value: PaymentPlatformType) {
		switch (value) {
			case PaymentPlatformType.UPay:
				return Res.Const.ENUM_PAYMENT_PLATFORM_TYPE_UPAY();
			case PaymentPlatformType.Adyen:
				return Res.Const.ENUM_PAYMENT_PLATFORM_TYPE_ADYEN();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PDFOrientation {
	Portrait = 0,
	Landscape = 1
}

export enum PendingCardTransactionStatus {
	NotFound = 0,
	NotAuthorizedOrCancelledOrRefunded = 1,
	Authorized = 2
}

export namespace PendingCardTransactionStatus {
	export function toString(value: PendingCardTransactionStatus) {
		switch (value) {
			case PendingCardTransactionStatus.NotFound:
				return Res.Const.ENUM_PENDING_CARD_TRANSACTION_STATUS_NOT_FOUND();
			case PendingCardTransactionStatus.NotAuthorizedOrCancelledOrRefunded:
				return Res.Const.ENUM_PENDING_CARD_TRANSACTION_STATUS_NOT_AUTHORIZED_OR_CANCELLED_OR_REFUNDED();
			case PendingCardTransactionStatus.Authorized:
				return Res.Const.ENUM_PENDING_CARD_TRANSACTION_STATUS_AUTHORIZED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum Permission {
	Application_Update = 1,
	Application_InstallAgoraCab = 2,
	SaleLocation_Change = 100,
	Ticket_AddLineNotes = 300,
	Ticket_ViewOpened = 301,
	Ticket_RemoveLine = 302,
	Ticket_Close = 303,
	Ticket_ComposeProduct = 304,
	Ticket_ViewClosed = 305,
	Ticket_SetTicketLinePercentageDiscount = 306,
	Ticket_SetQuantity = 307,
	Ticket_SetTicketLineCashDiscount = 308,
	Ticket_SetTicketLineNewPrice = 309,
	Ticket_SetTicketCashDiscount = 310,
	Ticket_SetTicketDiscountPercentage = 311,
	Ticket_PrintCopy = 312,
	Ticket_Cancel = 313,
	Ticket_ComposeUnusualProduct = 314,
	Ticket_ChangePayment = 315,
	Ticket_Invoice = 316,
	Ticket_PrintInvoiceCopy = 317,
	Ticket_SetUnusualProductPrice = 318,
	Ticket_CancelLine = 319,
	Ticket_PrepareTicket = 320,
	Ticket_RequestOrderedItems = 321,
	Ticket_MoveTicket = 322,
	Ticket_SetBuyerCustomer = 323,
	DeliveryNote_Create = 324,
	DeliveryNote_FindPending = 325,
	Ticket_UnPark = 326,
	Ticket_Reopen = 327,
	Ticket_RemovePrintedLine = 328,
	Ticket_CancelPrintedLine = 329,
	Ticket_InviteLine = 330,
	Ticket_Refund = 331,
	Ticket_SetTicketLinePreparationOrder = 332,
	Ticket_PrepareTicketAgain = 333,
	Ticket_DeliverPreparations = 334,
	Ticket_SetLineQuantityInOrderedLines = 335,
	Ticket_Loss = 336,
	Ticket_SendEmail = 337,
	Ticket_SetTicketLineCreator = 338,
	SalesOrder_Create = 339,
	SalesOrder_Complete = 340,
	SalesOrder_Print = 341,
	SalesOrder_Cancel = 342,
	SalesOrder_AddPayment = 344,
	SalesOrder_RefundPayment = 345,
	DeliveryNote_AddPayment = 346,
	DeliveryNote_RefundPayment = 347,
	SalesOrder_Reopen = 348,
	Ticket_AddPayment = 349,
	Ticket_RefundPayment = 350,
	Ticket_RefundAgain = 351,
	Ticket_ApplyOffer = 352,
	Ticket_OpenCreatedByOtherUser = 353,
	Ticket_SetFriendlyName = 354,
	Ticket_OpenInUseByOtherUser = 355,
	SalesOrder_SendEmail = 356,
	Ticket_ShowAuditory = 357,
	Ticket_UpdateCustomerData = 358,
	DeliveryNote_ChangeCustomer = 359,
	SalesOrder_ChangeCustomer = 360,
	Ticket_UpdateTips = 361,
	Ticket_UseProductFromOtherRoleInMenu = 362,
	Ticket_ChangeOpenerUser = 363,
	SalesOrder_ShowPreparation = 364,
	Ticket_PrepareTicketLine = 365,
	Ticket_PrepareTicketLineAgain = 366,
	Ticket_RequestOrderedLine = 367,
	SalesOrder_ShowTakeOutOrders = 368,
	SalesOrder_Deliver = 369,
	SalesOrder_MarkAsDelivered = 370,
	SalesOrder_Accept = 371,
	SalesOrder_MarkAsPrepared = 372,
	SalesOrder_Reject = 373,
	SalesOrder_StartTakeOut = 374,
	SalesOrder_EndTakeOut = 375,
	SalesOrder_ChangeDeliveryPerson = 376,
	Ticket_AdjustIngredients = 377,
	Pos_OpenDay = 400,
	Pos_CloseDay = 401,
	Pos_PrintTotalBalanceReport = 402,
	Pos_PrintPartialBalanceReport = 403,
	Pos_RegisterBalanceIncident = 404,
	Pos_ChangePrintMode = 405,
	Pos_OpenDayWithDifferentDate = 406,
	Pos_PrintTrainingSession = 407,
	Pos_LoginWithoutClockIn = 408,
	Pos_ExtractPendingTip = 409,
	ScaleTicket_ReadAgain = 410,
	Ticket_SetMinTicketAmount = 411,
	Ticket_PrintGift = 412,
	Ticket_PartialRefund = 413,
	Pos_CloseDay_With_Open_Tickets = 414,
	Ticket_Park = 415,
	Pos_SearchProductInOtherPos = 416,
	Cashdrawer_Open = 500,
	Cashdrawer_RegisterOutputCashTransaction = 501,
	Cashdrawer_RegisterInputCashTransaction = 502,
	Cashdrawer_ShowDiscrepancyAmount = 503,
	PriceList_Configure = 600,
	Ticket_ChangePriceList = 601,
	Screen_Minimize = 700,
	CashControl_CashControlOperations = 800,
	CashControl_GiveChange = 801,
	CashControl_Reset = 802,
	System_ShowStatus = 900,
	System_PrintStatusReport = 901,
	System_ShowPointsOfSaleStatus = 902,
	ScaleTicket_ShowList = 903,
	CardProcessor_ShowAdvancedOptions = 904,
	DeliveryNote_Cancel = 1000,
	DeliveryNote_Invoice = 1001,
	Product_ShowDetails = 1002,
	Customer_ShowDetails = 1100,
	Customer_ShowRecentSales = 1101,
	Menu_Configure = 1200,
	DeliveryNote_Reopen = 1202,
	DeliveryNote_SendEmail = 1203,
	DeliveryNote_Print = 1204,
	Ticket_EditTip = 1305,
	Ticket_EditServiceCharge = 1306,
	Ticket_AddLoyaltyInfo = 1307,
	Ticket_RemoveLoyaltyInfo = 1308,
	PreparationCounter_Reset = 1300,
	Appointment_ShowList = 1400,
	Appointment_CreateOrModify = 1401,
	Appointment_Cancel = 1402,
	Appointment_Close = 1403,
	Appointment_Delete = 1404,
	Coupon_Print = 1500,
	ProductAvailability_Set = 1501,
	OnlineReservation_Attend = 1502,
	Print_ReplaceDocumentContent = 1503,
	Attendance_ModifyClockInDateTime = 1504,
	Attendance_ModifyClockOutDateTime = 1505,
	Attendance_ClockingWithPassword = 1506,
	Attendance_ClockingWithCardNumber = 1509,
	ProductAvailability_Get = 1507,
	SmartMenuOrderComms_Configure = 1508,
	Ticket_CompleteMenu = 1510,
	Ticket_AllowNegativeLines = 1511,
	DeliveryPerson_ShowStatus = 1512,
	DeliveryPerson_AddBalance = 1513,
	DeliveryPerson_SubstractBalance = 1514,
	Ticket_NextSeatNumber = 1515,
	Ticket_EditSeatNumber = 1516,
	Ticket_EditLineSeatNumber = 1517,
	Ticket_OpenBlockedByOtherPos = 1518,
	Ticket_PrintProformUnderMinRequiredAmount = 1519,
	CardProcessor_AllowUnreferencedRefunds = 1520,
	Administration_Execute = 10000,
	Family_ShowList = 10010,
	Family_CreateOrModify = 10011,
	Family_Delete = 10012,
	Family_CreateOrModifyMultiple = 10013,
	Family_MultipleDelete = 10014,
	Pos_ShowList = 10020,
	Pos_CreateOrModify = 10021,
	Pos_Delete = 10022,
	KitchenDisplay_CreateOrModify = 10023,
	PredefinedNote_ShowList = 10030,
	PredefinedNote_CreateOrModify = 10031,
	PredefinedNote_Delete = 10032,
	PredefinedNote_CreateOrModifyMultiple = 10033,
	PredefinedNote_MultipleDelete = 10034,
	SaleCenter_ShowList = 10040,
	SaleCenter_CreateOrModify = 10041,
	SaleCenter_Delete = 10042,
	SaleCenter_MultipleDelete = 10043,
	SaleCenter_CreateOrModifyMultiple = 10044,
	User_ShowList = 10050,
	User_CreateOrModify = 10051,
	User_Delete = 10052,
	User_MultipleDelete = 10053,
	User_CreateOrModifyMultiple = 10054,
	Vat_ShowList = 10060,
	Vat_Edition = 10061,
	Product_ShowList = 10070,
	Product_CreateOrModify = 10071,
	Product_Delete = 10072,
	Product_CreateOrModifyMultiple = 10073,
	Product_MultipleDelete = 10074,
	Product_ChangePrices = 10075,
	Product_ShowHistory = 10076,
	Product_ShowStocks = 10077,
	Product_PurchaseWithoutSupplierConditions = 10078,
	Category_ShowList = 10080,
	Category_CreateOrModify = 10081,
	Category_Delete = 10082,
	Category_CreateOrModifyMultiple = 10083,
	Category_MultipleDelete = 10084,
	AuditMonitor_ShowList = 10090,
	Company_Edition = 10100,
	PaymentMethod_ShowList = 10110,
	PaymentMethod_CreateOrModify = 10111,
	PaymentMethod_Delete = 10112,
	PriceList_ShowList = 10120,
	PriceList_CreateOrModify = 10121,
	PriceList_Delete = 10122,
	PriceList_Schedule = 10123,
	PriceList_CreateOrModifyMultiple = 10124,
	PriceList_MultipleDelete = 10125,
	Supplier_ShowList = 10130,
	Supplier_CreateOrModify = 10131,
	Supplier_Delete = 10132,
	Supplier_MultipleDelete = 10133,
	Supplier_CreateOrModifyMultiple = 10134,
	Customer_ShowList = 10140,
	Customer_CreateOrModify = 10141,
	Customer_Delete = 10142,
	Customer_CreateOrModifyWithOtherDocumentIdType = 10143,
	Menu_ShowList = 10150,
	Menu_CreateOrModify = 10151,
	Menu_Delete = 10152,
	Menu_MultipleDelete = 16703,
	Menu_CreateOrModifyMultiple = 16704,
	PosVisualSettings_ChangeProductGroupOrder = 10200,
	PosVisualSettings_ChangeProductsOrderInProductGroup = 10201,
	PosVisualSettings_ChangeActionDisplaySettings = 10202,
	Report_DateRangeSales = 10301,
	Report_ProductSales = 10302,
	Report_UserSales = 10303,
	Report_DateRangeSalesSummary = 10304,
	Report_SaleCenterSales = 10305,
	Report_PriceList = 10306,
	Report_SupplierPurchases = 10307,
	Report_ProductStock = 10308,
	Report_ProductPurchasesAndSales = 10309,
	Report_CustomerPurchases = 10310,
	Report_PaymentMethods = 10311,
	Report_ProductSalesByTimeFrame = 10312,
	TimeFrames_Change = 10313,
	Report_UserSalesByTimeFrame = 10314,
	Report_ProductSalesBySaleCenter = 10315,
	Report_TableCompanionsByTimeFrame = 10316,
	Report_TableCompanionsBySaleCenter = 10317,
	Report_TicketsByTimeFrame = 10318,
	Report_TicketsBySaleCenter = 10319,
	Report_ProductsUnderMinStock = 10320,
	Report_CashTransactions = 10321,
	Report_SaleCenterSalesByTimeFrame = 10322,
	Report_FiscalSummary = 10323,
	Report_CustomerSalesByProduct = 10324,
	Report_UserLogins = 10325,
	Report_ProductSalesByCategory = 10326,
	Report_ProductSalesByCustomer = 10327,
	Report_ProductMarginsByFamily = 10328,
	Report_ProductMarginsByCategory = 10329,
	Report_ProductSalesByUser = 10330,
	Report_InvitationsByBusinessDay = 10331,
	Report_ProductSalesByOffer = 10332,
	Report_SalesLocationSales = 10333,
	Report_MajorGroupSales = 10334,
	Report_MenuSales = 10335,
	Report_DiscountsByAndProductUser = 10336,
	Report_ProductPreparationTime = 10337,
	Report_TipsByUser = 10338,
	Report_DiscountsByTypeAndUser = 10339,
	Report_CancellationsByAndProductUser = 10340,
	Report_CancellationsByAndTypeUser = 10341,
	Report_InvoicesByCustomer = 10342,
	Report_TaxesByCustomer = 10343,
	Report_InvoicesPerMonthThroughYears = 10344,
	Report_PurchaseDetailsBySupplier = 10345,
	Report_WorkplaceSales = 10346,
	Report_TableCompanionsByWorkplaceAndTimeFrame = 10347,
	Report_TicketsByWokrplaceAndTimeFrame = 10348,
	Report_AppointmentsByDay = 10349,
	TimeFrameGroups_ShowList = 10350,
	TimeFrameGroups_CreateOrModify = 10351,
	TimeFrameGroups_Delete = 10352,
	Report_WorkedHours = 10353,
	Report_PurchasePrices = 10354,
	Report_LotsInStock = 10355,
	Report_LotsByExpirationDate = 10356,
	Report_UnpaidScaleSales = 10357,
	Report_SaveViews = 10358,
	Excel_ImportAndExport = 10401,
	Backup_Create_And_Restore = 10501,
	Modules_Activate = 10502,
	RemoteSupport = 10601,
	Ticket_Deletion = 10701,
	Ticket_Migrate = 10702,
	Ticket_DeleteMigrated = 10703,
	Ticket_CheckTickets = 10704,
	Ticket_GenerateControlRoll = 10705,
	SalesOrders_Check = 10706,
	Ticket_SaveToPdf = 10707,
	DeliveryNote_CheckDeliveryNotes = 10708,
	SalesOrders_SaveToPdf = 10709,
	DeliveryNote_SaveToPdf = 10710,
	Wizard_Configuration = 10801,
	PrintTemplate_ShowList = 10901,
	PrintTemplate_Delete = 10902,
	PrintTemplate_CreateOrModify = 10903,
	IncomingDeliveryNote_ShowList = 11001,
	IncomingDeliveryNote_Delete = 11002,
	IncomingDeliveryNote_CreateOrModify = 11003,
	IncomingDeliveryNote_UpdateCostPrices = 11004,
	IncomingDeliveryNote_UpdateRegularSuppliers = 11005,
	IncomingDeliveryNote_SendEmail = 11006,
	IncomingDeliveryNote_UpdateCostPricePolicy = 11007,
	IncomingDeliveryNote_MultipleDelete = 11008,
	Inventory_ShowList = 11101,
	Inventory_Delete = 11102,
	Inventory_CreateOrModify = 11103,
	Inventory_ShowCostPrices = 11104,
	Inventory_ShowExpectedStock = 11105,
	Pos_CheckPosCloseOuts = 11201,
	Emailing_CreateOrModify = 11301,
	Emailing_ShowStats = 11302,
	Emailing_Start = 11303,
	Emailing_Test = 11304,
	Emailing_Cancel = 11305,
	Emailing_Delete = 11306,
	Emailing_ShowList = 11307,
	Map_ShowList = 11401,
	Map_CreateOrModify = 11402,
	Map_Delete = 11403,
	AuditQuery_CreateOrModify = 11501,
	AuditQuery_Delete = 11502,
	KitchenPrintTemplate_CreateOrModify = 11602,
	Cctv_Configure = 11700,
	Cctv_Show = 11701,
	Cctv_Navigate = 11702,
	System_CheckSystemCloseOuts = 11800,
	Language_Select = 11900,
	ScaleCounter_ShowList = 12000,
	ScaleCounter_CreateOrModify = 12001,
	ScaleCounter_Delete = 12002,
	ScaleCounter_SendConfiguration = 12003,
	StockChange_ShowList = 12200,
	StockChange_Delete = 12201,
	StockChange_CreateOrModify = 12202,
	StockChange_ShowCostPrices = 12203,
	StockChange_UpdateCostPrices = 12004,
	StockChange_UpdateCostPricePolicy = 12005,
	UserProfile_ShowList = 12300,
	UserProfile_CreateOrModify = 12301,
	UserProfile_Delete = 12302,
	MajorGroup_ShowList = 12400,
	MajorGroup_CreateOrModify = 12401,
	MajorGroup_Delete = 12402,
	Workplace_ShowList = 12500,
	Workplace_CreateOrModify = 12501,
	Workplace_Delete = 12502,
	Workplace_CreateOrModifyMultiple = 12503,
	Workplace_DeleteMultiple = 12504,
	Serie_ShowList = 12600,
	Serie_CreateOrModify = 12601,
	Serie_Delete = 12602,
	PreparationType_ShowList = 12700,
	PreparationType_CreateOrModify = 12701,
	PreparationType_Delete = 12702,
	PreparationOrder_ShowList = 12800,
	PreparationOrder_CreateOrModify = 12801,
	PreparationOrder_Delete = 12802,
	ActionDisplayProfile_ShowList = 12900,
	ActionDisplayProfile_CreateOrModify = 12901,
	ActionDisplayProfile_Delete = 12902,
	KitchenDisplay_Delete = 13000,
	KitchenDisplay_ShowList = 13001,
	Offer_ShowList = 13200,
	Offer_CreateOrModify = 13201,
	Offer_Delete = 13202,
	Offer_CreateOrModifyMultiple = 13203,
	Offer_MultipleDelete = 13204,
	Margins_Edit = 13300,
	Warehouse_ShowList = 13400,
	Warehouse_CreateOrModify = 13401,
	Warehouse_Delete = 13402,
	Warehouse_MultipleDelete = 13403,
	Warehouse_CreateOrModifyMultiple = 13404,
	PurchaseOrder_ShowList = 13500,
	PurchaseOrder_Delete = 13501,
	PurchaseOrder_CreateOrModify = 13502,
	PurchaseOrder_SendEmail = 13503,
	PurchaseOrder_MultipleDelete = 13504,
	NamedDiscount_ShowList = 13600,
	NamedDiscount_CreateOrModify = 13601,
	NamedDiscount_Delete = 13602,
	NamedDiscount_CreateOrModifyMultiple = 13603,
	NamedDiscount_DeleteMultiple = 13604,
	Training_ConfigureSettings = 13700,
	Training_CheckSessions = 13701,
	Training_DeleteSummaries = 13702,
	PosGroup_ShowList = 13800,
	PosGroup_CreateOrModify = 13801,
	PosGroup_Delete = 13802,
	Coupon_ShowList = 13900,
	Coupon_CreateOrModify = 13901,
	Coupon_Delete = 13902,
	LineCancellation_ShowList = 14000,
	LineCancellation_CreateOrModify = 14001,
	LineCancellation_Delete = 14002,
	WebAdmin_Edition = 14100,
	Hub_GenerateWorkplaceData = 14200,
	Dashboard_Show = 14300,
	CouponPrintTemplate_ShowList = 14400,
	CouponPrintTemplate_CreateOrModify = 14401,
	CouponPrintTemplate_Delete = 14402,
	SystemOfMeasurement_ShowList = 14500,
	SystemOfMeasurement_CreateOrModify = 14501,
	SystemOfMeasurement_Delete = 14502,
	CustomActionButton_ShowList = 14600,
	CustomActionButton_CreateOrModify = 14601,
	CustomActionButton_Delete = 14602,
	WebAdmin_DownloadServerLogs = 14603,
	PurchaseInvoice_ShowList = 14700,
	PurchaseInvoice_CreateOrModify = 14701,
	PurchaseInvoice_Delete = 14702,
	PurchaseInvoice_SendEmail = 14703,
	PurchaseInvocie_MultipleDelete = 14704,
	Production_ShowList = 14800,
	Production_CreateOrModify = 14801,
	Production_Delete = 14802,
	Production_ShowCostPrices = 14803,
	Production_UpdateCostPrices = 14804,
	Widget_Warehouses = 15800,
	Widget_Sales = 15801,
	Widget_Comms = 15802,
	Widget_Tickets = 15803,
	Widget_Occupancy = 15804,
	GStock_ViewStatus = 15900,
	CashControlSettings_ShowList = 16000,
	CashControlSettings_CreateOrModify = 16001,
	CashControlSettings_Delete = 16002,
	CardProcessorSettings_ShowList = 16100,
	CardProcessorSettings_CreateOrModify = 16101,
	CardProcessorSettings_Delete = 16102,
	TablePaymentSettings_ShowList = 16200,
	TablePaymentSettings_CreateOrModify = 16201,
	TablePaymentSettings_Delete = 16202,
	WorkingPeriod_ShowList = 16300,
	WorkingPeriod_CreateOrModify = 16301,
	WorkingPeriod_Delete = 16302,
	WorkingPeriod_MultipleDelete = 16303,
	WorkingPeriod_CreateorModifyMultiple = 16304,
	WorkingPeriod_GenerateExcel = 16305,
	Allergen_ShowList = 16400,
	Allergen_CreateOrModify = 16401,
	Allergen_Delete = 16402,
	DigitalMenu_ShowList = 16500,
	DigitalMenu_CreateOrModify = 16501,
	DigitalMenu_Delete = 16503,
	DigitalMenu_PublishAll = 16504,
	DigitalMenu_GenerateQR = 16505,
	DigitalMenuResources_Update = 16600,
	ProductTag_ShowList = 16700,
	ProductTag_CreateOrModify = 16701,
	ProductTag_Delete = 16702,
	EmailAccount_ShowList = 16800,
	EmailAccount_CreateOrModify = 16801,
	EmailAccount_Delete = 16802,
	Lot_CreateOrModify = 16900,
	Lot_ShowList = 16901,
	Lot_Delete = 16902,
	Label_ShowList = 17000,
	Label_CreateOrModify = 17001,
	Label_Delete = 17003,
	Label_Print = 176004,
	CustomerType_ShowList = 17100,
	CustomerType_CreateOrModify = 17101,
	CustomerType_Delete = 17102,
	SmartMenuOrderSettings_ShowList = 17200,
	SmartMenuOrderSettings_CreateOrModify = 17201,
	SmartMenuOrderSettings_Delete = 17202,
	WarehouseCloseOut_Create = 17300,
	WarehouseCloseOut_Delete = 17301,
	WarehouseCloseOut_ShowList = 17302,
	WarehouseCloseOut_Review = 17303,
	SmartMenuWorkplaceSettings_ShowList = 17400,
	SmartMenuWorkplaceSettings_CreateOrModify = 17401,
	SmartMenuWorkplaceSettings_Delete = 17402,
	Size_CreateOrModify = 17501,
	Color_CreateOrModify = 17502,
	Report_AgoraPayments = 17503,
	Report_SalesAnalytics = 17504,
	Report_PurchasesAnalytics = 17505,
	Report_StocksAnalytics = 17506,
	Report_AgoraPayouts = 17507,
	SifSettings_ShowList = 17600,
	SifSettings_CreateOrModify = 17601,
	SifSettings_Delete = 17602,
	Verifactu_ChainViewer = 17700,
	Internal_Supplier_ShowList = 17800,
	Internal_Supplier_CreateOrModify = 17801,
	Internal_Supplier_Delete = 17802,
	Internal_Customer_ShowList = 17900,
	Internal_Customer_CreateOrModify = 17901,
	Internal_Customer_Delete = 17902,
	Internal_Orders_ShowList = 18000,
	Internal_Orders_Send = 18001,
	My_Agora_Account_ShowList = 18100,
	My_Agora_Account_CreateOrModify = 18101,
	My_Agora_Account_Delete = 18102
}

export namespace Permission {
	export function toString(value: Permission) {
		switch (value) {
			case Permission.Application_Update:
				return Res.Const.ENUM_PERMISSION_APPLICATION_UPDATE();
			case Permission.Application_InstallAgoraCab:
				return Res.Const.ENUM_PERMISSION_APPLICATION_INSTALL_AGORA_CAB();
			case Permission.SaleLocation_Change:
				return Res.Const.ENUM_PERMISSION_SALE_LOCATION_CHANGE();
			case Permission.Ticket_AddLineNotes:
				return Res.Const.ENUM_PERMISSION_TICKET_ADD_LINE_NOTES();
			case Permission.Ticket_ViewOpened:
				return Res.Const.ENUM_PERMISSION_TICKET_VIEW_OPENED();
			case Permission.Ticket_RemoveLine:
				return Res.Const.ENUM_PERMISSION_TICKET_REMOVE_LINE();
			case Permission.Ticket_Close:
				return Res.Const.ENUM_PERMISSION_TICKET_CLOSE();
			case Permission.Ticket_ComposeProduct:
				return Res.Const.ENUM_PERMISSION_TICKET_COMPOSE_PRODUCT();
			case Permission.Ticket_ViewClosed:
				return Res.Const.ENUM_PERMISSION_TICKET_VIEW_CLOSED();
			case Permission.Ticket_SetTicketLinePercentageDiscount:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_TICKET_LINE_PERCENTAGE_DISCOUNT();
			case Permission.Ticket_SetQuantity:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_QUANTITY();
			case Permission.Ticket_SetTicketLineCashDiscount:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_LINE_CASH_DISCOUNT();
			case Permission.Ticket_SetTicketLineNewPrice:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_TICKET_LINE_NEW_PRICE();
			case Permission.Ticket_SetTicketCashDiscount:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_TICKET_CASH_DISCOUNT();
			case Permission.Ticket_SetTicketDiscountPercentage:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_TICKET_DISCOUNT_PERCENTAGE();
			case Permission.Ticket_PrintCopy:
				return Res.Const.ENUM_PERMISSION_TICKET_PRINT_COPY();
			case Permission.Ticket_Cancel:
				return Res.Const.ENUM_PERMISSION_TICKET_CANCEL();
			case Permission.Ticket_ComposeUnusualProduct:
				return Res.Const.ENUM_PERMISSION_TICKET_COMPOSE_UNUSUAL_PRODUCT();
			case Permission.Ticket_ChangePayment:
				return Res.Const.ENUM_PERMISSION_TICKET_CHANGE_PAYMENT();
			case Permission.Ticket_Invoice:
				return Res.Const.ENUM_PERMISSION_TICKET_INVOICE();
			case Permission.Ticket_PrintInvoiceCopy:
				return Res.Const.ENUM_PERMISSION_TICKET_PRINT_INVOICE_COPY();
			case Permission.Ticket_SetUnusualProductPrice:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_UNUSUAL_PRODUCT_PRICE();
			case Permission.Ticket_CancelLine:
				return Res.Const.ENUM_PERMISSION_TICKET_CANCEL_LINE();
			case Permission.Ticket_PrepareTicket:
				return Res.Const.ENUM_PERMISSION_TICKET_PREPARE_TICKET();
			case Permission.Ticket_RequestOrderedItems:
				return Res.Const.ENUM_PERMISSION_TICKET_REQUEST_ORDERED_ITEMS();
			case Permission.Ticket_MoveTicket:
				return Res.Const.ENUM_PERMISSION_TICKET_MOVE_TICKET();
			case Permission.Ticket_SetBuyerCustomer:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_BUYER_CUSTOMER();
			case Permission.DeliveryNote_Create:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_CREATE();
			case Permission.DeliveryNote_FindPending:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTES_FIND_PENDING();
			case Permission.Ticket_UnPark:
				return Res.Const.ENUM_PERMISSION_TICKET_UN_PARK();
			case Permission.Ticket_Reopen:
				return Res.Const.ENUM_PERMISSION_TICKET_REOPEN();
			case Permission.Ticket_RemovePrintedLine:
				return Res.Const.ENUM_PERMISSION_TICKET_REMOVE_PRINTED_LINE();
			case Permission.Ticket_CancelPrintedLine:
				return Res.Const.ENUM_PERMISSION_TICKET_CANCEL_PRINTED_LINE();
			case Permission.Ticket_InviteLine:
				return Res.Const.ENUM_PERMISSION_TICKET_INVITE_LINE();
			case Permission.Ticket_Refund:
				return Res.Const.ENUM_PERMISSION_TICKET_REFUND();
			case Permission.Ticket_SetTicketLinePreparationOrder:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_TICKET_LINE_PREPARATION_ORDER();
			case Permission.Ticket_PrepareTicketAgain:
				return Res.Const.ENUM_PERMISSION_TICKET_PREPARE_TICKET_AGAIN();
			case Permission.Ticket_DeliverPreparations:
				return Res.Const.ENUM_PERMISSION_TICKET_DELIVER_PREPARATIONS();
			case Permission.Ticket_SetLineQuantityInOrderedLines:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_LINE_QUANTITY_IN_ORDERED_LINES();
			case Permission.Ticket_Loss:
				return Res.Const.ENUM_PERMISSION_TICKET_LOSS();
			case Permission.Ticket_SendEmail:
				return Res.Const.ENUM_PERMISSION_TICKET_SEND_EMAIL();
			case Permission.Ticket_SetTicketLineCreator:
				return Res.Const.ENUM_PERMISSION_TICKET_SET_TICKET_LINE_CREATOR();
			case Permission.SalesOrder_Create:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_CREATE();
			case Permission.SalesOrder_Complete:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_COMPLETE();
			case Permission.SalesOrder_Print:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_PRINT();
			case Permission.SalesOrder_Cancel:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_CANCEL();
			case Permission.SalesOrder_AddPayment:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_ADD_PAYMENT();
			case Permission.SalesOrder_RefundPayment:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_REFUND_PAYMENT();
			case Permission.DeliveryNote_AddPayment:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_ADD_PAYMENT();
			case Permission.DeliveryNote_RefundPayment:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_REFUND_PAYMENT();
			case Permission.SalesOrder_Reopen:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_REOPEN();
			case Permission.Ticket_AddPayment:
				return Res.Const.ENUM_PERMISSION_TICKET_ADD_PAYMENT();
			case Permission.Ticket_RefundPayment:
				return Res.Const.ENUM_PERMISSION_TICKET_REFUND_PAYMENT();
			case Permission.Ticket_RefundAgain:
				return Res.Const.ENUM_PERMISSION_TICKET_REFUND_AGAIN();
			case Permission.Ticket_ApplyOffer:
				return Res.Const.ENUM_PERMISSION_TICKET_APPLY_OFFER();
			case Permission.Ticket_OpenCreatedByOtherUser:
				return Res.Const.ENUM_PERMISSION_TICKET_OPEN_CREATED_BY_OTHER_USER();
			case Permission.Ticket_SetFriendlyName:
				return Res.Const.ENUM_PERMISSION_SET_TICKET_FRIENDLY_NAME();
			case Permission.Ticket_OpenInUseByOtherUser:
				return Res.Const.ENUM_PERMISSION_TICKET_OPEN_IN_USE_BY_OTHER_USER();
			case Permission.SalesOrder_SendEmail:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_SEND_EMAIL();
			case Permission.Ticket_ShowAuditory:
				return Res.Const.ENUM_PERMISSION_TICKET_SHOW_AUDITORY();
			case Permission.Ticket_UpdateCustomerData:
				return Res.Const.ENUM_PERMISSION_TICKET_UPDATE_CUSTOMER_DATA();
			case Permission.DeliveryNote_ChangeCustomer:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_CHANGE_CUSTOMER();
			case Permission.SalesOrder_ChangeCustomer:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_CHANGE_CUSTOMER();
			case Permission.Ticket_UpdateTips:
				return Res.Const.ENUM_PERMISSION_TICKET_UPDATE_TIPS();
			case Permission.Ticket_UseProductFromOtherRoleInMenu:
				return Res.Const.ENUM_PERMISSION_TICKET_USE_PRODUCT_FROM_OTHER_ROLE_IN_MENU();
			case Permission.Ticket_ChangeOpenerUser:
				return Res.Const.ENUM_PERMISSION_TICKET_CHANGE_OPENER_USER();
			case Permission.SalesOrder_ShowPreparation:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_SHOW_PREPARATION();
			case Permission.Ticket_PrepareTicketLine:
				return Res.Const.ENUM_PERMISSION_TICKET_PREPARE_TICKET_LINE();
			case Permission.Ticket_PrepareTicketLineAgain:
				return Res.Const.ENUM_PERMISSION_TICKET_PREPARE_TICKET_LINE_AGAIN();
			case Permission.Ticket_RequestOrderedLine:
				return Res.Const.ENUM_PERMISSION_TICKET_REQUEST_ORDERED_LINE();
			case Permission.SalesOrder_ShowTakeOutOrders:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_SHOW_TAKE_OUT_ORDERS();
			case Permission.SalesOrder_Deliver:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_DELIVER();
			case Permission.SalesOrder_MarkAsDelivered:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_MARK_AS_DELIVERED();
			case Permission.SalesOrder_Accept:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_ACCEPT_DELIVERY_ORDER();
			case Permission.SalesOrder_MarkAsPrepared:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_MARK_AS_PREPARED();
			case Permission.SalesOrder_Reject:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_REJECT_DELIVERY();
			case Permission.SalesOrder_StartTakeOut:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_START_TAKE_OUT();
			case Permission.SalesOrder_EndTakeOut:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_END_TAKE_OUT();
			case Permission.SalesOrder_ChangeDeliveryPerson:
				return Res.Const.ENUM_PERMISSION_SALES_ORDER_CHANGE_DELIVERY_PERSON();
			case Permission.Ticket_AdjustIngredients:
				return Res.Const.ENUM_PERMISSION_TICKET_ADJUST_INGREDIENTS();
			case Permission.Pos_OpenDay:
				return Res.Const.ENUM_PERMISSION_POS_OPEN_DAY();
			case Permission.Pos_CloseDay:
				return Res.Const.ENUM_PERMISSION_POS_CLOSE_DAY();
			case Permission.Pos_PrintTotalBalanceReport:
				return Res.Const.ENUM_PERMISSION_POS_PRINT_TOTAL_BALANCE_REPORT();
			case Permission.Pos_PrintPartialBalanceReport:
				return Res.Const.ENUM_PERMISSION_POS_PRINT_PARTIAL_BALANCE_REPORT();
			case Permission.Pos_RegisterBalanceIncident:
				return Res.Const.ENUM_PERMISSION_POS_REGISTER_BALANCE_INCIDENT();
			case Permission.Pos_ChangePrintMode:
				return Res.Const.ENUM_PERMISSION_POS_CHANGE_PRINT_MODE();
			case Permission.Pos_OpenDayWithDifferentDate:
				return Res.Const.ENUM_PERMISSION_POS_OPEN_DAY_WITH_DIFFERENT_DATE();
			case Permission.Pos_PrintTrainingSession:
				return Res.Const.ENUM_PERMISSION_POS_PRINT_TRAINING_SESSION_REPORT();
			case Permission.Pos_LoginWithoutClockIn:
				return Res.Const.ENUM_PERMISSION_POS_LOGIN_WITHOUT_CLOCK_IN();
			case Permission.Pos_ExtractPendingTip:
				return Res.Const.ENUM_PERMISSION_POS_EXTRACT_PENDING_TIP();
			case Permission.ScaleTicket_ReadAgain:
				return Res.Const.ENUM_PERMISSION_SCALE_TICKET_READ_AGAIN();
			case Permission.Ticket_SetMinTicketAmount:
				return Res.Const.ENUM_PERMISSION_SET_MIN_TICKET_AMOUNT();
			case Permission.Ticket_PrintGift:
				return Res.Const.ENUM_PERMISSION_PRINT_TICKET_GIFT();
			case Permission.Ticket_PartialRefund:
				return Res.Const.ENUM_PERMISSION_TICKET_PARTIAL_REFUND();
			case Permission.Pos_CloseDay_With_Open_Tickets:
				return Res.Const.ENUM_PERMISSION_POS_CLOSE_DAY_WITH_OPEN_TICKETS();
			case Permission.Ticket_Park:
				return Res.Const.ENUM_PERMISSION_TICKET_PARK();
			case Permission.Pos_SearchProductInOtherPos:
				return Res.Const.ENUM_PERMISSION_SEARCH_PRODUCT_IN_OTHER_POS();
			case Permission.Cashdrawer_Open:
				return Res.Const.ENUM_PERMISSION_CASHDRAWER_OPEN();
			case Permission.Cashdrawer_RegisterOutputCashTransaction:
				return Res.Const.ENUM_PERMISSION_CASHDRAWER_REGISTER_OUTPUT_CASH_TRANSACTION();
			case Permission.Cashdrawer_RegisterInputCashTransaction:
				return Res.Const.ENUM_PERMISSION_CASHDRAWER_REGISTER_INPUT_CASH_TRANSACTION();
			case Permission.Cashdrawer_ShowDiscrepancyAmount:
				return Res.Const.ENUM_PERMISSION_CASHDRAWER_SHOW_DISCREPANCY_AMOUNT();
			case Permission.PriceList_Configure:
				return Res.Const.ENUM_PERMISSION_PRICE_LIST_CONFIGURE();
			case Permission.Ticket_ChangePriceList:
				return Res.Const.ENUM_PERMISSION_TICKET_CHANGE_PRICE_LIST();
			case Permission.Screen_Minimize:
				return Res.Const.ENUM_PERMISSION_SCREEN_MINIMIZE();
			case Permission.CashControl_CashControlOperations:
				return Res.Const.ENUM_PERMISSION_CASH_CONTROL_OPERATIONS();
			case Permission.CashControl_GiveChange:
				return Res.Const.ENUM_PERMISSION_CASH_CONTROL_GIVE_CHANGE();
			case Permission.CashControl_Reset:
				return Res.Const.ENUM_PERMISSION_CASH_CONTROL_RESET();
			case Permission.System_ShowStatus:
				return Res.Const.ENUM_PERMISSION_SHOW_SYSTEM_STATUS();
			case Permission.System_PrintStatusReport:
				return Res.Const.ENUM_PERMISSION_PRINT_SYSTEM_STATUS();
			case Permission.System_ShowPointsOfSaleStatus:
				return Res.Const.ENUM_PERMISSION_SHOW_POINT_OF_SALES_STATUS();
			case Permission.ScaleTicket_ShowList:
				return Res.Const.ENUM_PERMISSION_SCALETICKET_LIST();
			case Permission.CardProcessor_ShowAdvancedOptions:
				return Res.Const.ENUM_PERMISSION_CARD_PROCESSOR_SHOW_ADVANCED_OPTIONS();
			case Permission.DeliveryNote_Cancel:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_CANCEL();
			case Permission.DeliveryNote_Invoice:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_INVOICE();
			case Permission.Product_ShowDetails:
				return Res.Const.ENUM_PERMISSION_SHOW_PRODUCT_DETAILS();
			case Permission.Customer_ShowDetails:
				return Res.Const.ENUM_PERMISSION_SHOW_CUSTOMER_DETAILS();
			case Permission.Customer_ShowRecentSales:
				return Res.Const.ENUM_PERMISSION_SHOW_RECENT_SALES();
			case Permission.Menu_Configure:
				return Res.Const.ENUM_PERMISSION_MENU_CONFIGURE();
			case Permission.DeliveryNote_Reopen:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_REOPEN();
			case Permission.DeliveryNote_SendEmail:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_SEND_EMAIL();
			case Permission.DeliveryNote_Print:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_PRINT();
			case Permission.Ticket_EditTip:
				return Res.Const.ENUM_PERMISSION_TICKET_EDIT_TIP();
			case Permission.Ticket_EditServiceCharge:
				return Res.Const.ENUM_PERMISSION_TICKET_EDIT_SERVICE_CHARGE();
			case Permission.Ticket_AddLoyaltyInfo:
				return Res.Const.ENUM_PERMISSION_TICKET_ADD_LOYALTY_INFO();
			case Permission.Ticket_RemoveLoyaltyInfo:
				return Res.Const.ENUM_PERMISSION_TICKET_REMOVE_LOYALTY_INFO();
			case Permission.PreparationCounter_Reset:
				return Res.Const.ENUM_PERMISSION_PREPARATION_COUNTER_RESET();
			case Permission.Appointment_ShowList:
				return Res.Const.ENUM_PERMISSION_APPOINTMENT_SHOW_LIST();
			case Permission.Appointment_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_APPOINTMENT_CREATE();
			case Permission.Appointment_Cancel:
				return Res.Const.ENUM_PERMISSION_APPOINTMENT_CANCEL();
			case Permission.Appointment_Close:
				return Res.Const.ENUM_PERMISSION_APPOINTMENT_CLOSE();
			case Permission.Appointment_Delete:
				return Res.Const.ENUM_PERMISSION_APPOINTMENT_DELETE();
			case Permission.Coupon_Print:
				return Res.Const.ENUM_PERMISSION_COUPON_PRINT();
			case Permission.ProductAvailability_Set:
				return Res.Const.ENUM_PERMISSION_UPDATE_PRODUCT_AVAILABILITY();
			case Permission.OnlineReservation_Attend:
				return Res.Const.ENUM_PERMISSION_ONLINE_RESERVATION_ATTEND();
			case Permission.Print_ReplaceDocumentContent:
				return Res.Const.ENUM_PERMISSION_PRINT_REPLACE_DOCUMENT_CONTENT();
			case Permission.Attendance_ModifyClockInDateTime:
				return Res.Const.ENUM_PERMISSION_ATTENDANCE_CLOCKING_MODIFY_CLOCK_IN_DATE_TIME();
			case Permission.Attendance_ModifyClockOutDateTime:
				return Res.Const.ENUM_PERMISSION_ATTENDANCE_CLOCKING_MODIFY_CLOCK_OUT_DATE_TIME();
			case Permission.Attendance_ClockingWithPassword:
				return Res.Const.ENUM_PERMISSION_ATTENDANCE_CLOCKING_CLOCKING_WITH_PASSWORD();
			case Permission.Attendance_ClockingWithCardNumber:
				return Res.Const.ENUM_PERMISSION_ATTENDANCE_CLOCKING_CLOCKING_WITH_CARDNUMBER();
			case Permission.ProductAvailability_Get:
				return Res.Const.ENUM_PERMISSION_GET_PRODUCT_AVAILABILITY();
			case Permission.SmartMenuOrderComms_Configure:
				return Res.Const.ENUM_PERMISSION_SMART_MENU_ORDER_COMMS_CONFIGURE();
			case Permission.Ticket_CompleteMenu:
				return Res.Const.ENUM_PERMISSION_TICKET_COMPLETE_MENU();
			case Permission.Ticket_AllowNegativeLines:
				return Res.Const.ENUM_PERMISSION_TICKET_ALLOW_NEGATIVE_LINES();
			case Permission.DeliveryPerson_ShowStatus:
				return Res.Const.ENUM_PERMISSION_DELIVERY_PERSON_SHOW_STATUS();
			case Permission.DeliveryPerson_AddBalance:
				return Res.Const.ENUM_PERMISSION_DELIVERY_PERSON_ADD_BALANCE();
			case Permission.DeliveryPerson_SubstractBalance:
				return Res.Const.ENUM_PERMISSION_DELIVERY_PERSON_SUBSTRACT_BALANCE();
			case Permission.Ticket_NextSeatNumber:
				return Res.Const.ENUM_PERMISSION_TICKET_NEXT_SEAT_NUMBER();
			case Permission.Ticket_EditSeatNumber:
				return Res.Const.ENUM_PERMISSION_TICKET_EDIT_SEAT_NUMBER();
			case Permission.Ticket_EditLineSeatNumber:
				return Res.Const.ENUM_PERMISSION_TICKET_EDIT_LINE_SEAT_NUMBER();
			case Permission.Ticket_OpenBlockedByOtherPos:
				return Res.Const.ENUM_PERMISSION_TICKET_OPEN_BLOCKED_BY_OTHER_POS();
			case Permission.Ticket_PrintProformUnderMinRequiredAmount:
				return Res.Const.ENUM_PERMISSION_TICKET_PRINT_PROFORM_UNDER_MIN_REQUIRED_AMOUNT();
			case Permission.CardProcessor_AllowUnreferencedRefunds:
				return Res.Const.ENUM_PERMISSION_CARD_PROCESSOR_ALLOW_UNREFERENCED_REFUNDS();
			case Permission.Administration_Execute:
				return Res.Const.ENUM_PERMISSION_ADMINISTRATION_EXECUTE();
			case Permission.Family_ShowList:
				return Res.Const.ENUM_PERMISSION_FAMILY_SHOW_LIST();
			case Permission.Family_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_FAMILY_CREATE_OR_MODIFY();
			case Permission.Family_Delete:
				return Res.Const.ENUM_PERMISSION_FAMILY_DELETE();
			case Permission.Family_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_FAMILY_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.Family_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_FAMILY_MULTIPLE_DELETE();
			case Permission.Pos_ShowList:
				return Res.Const.ENUM_PERMISSION_POS_SHOW_LIST();
			case Permission.Pos_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_POS_CREATE_OR_MODIFY();
			case Permission.Pos_Delete:
				return Res.Const.ENUM_PERMISSION_POS_DELETE();
			case Permission.KitchenDisplay_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_KITCHEN_DISPLAY_CREATE_OR_MODIFY();
			case Permission.PredefinedNote_ShowList:
				return Res.Const.ENUM_PERMISSION_PREDEFINED_NOTE_SHOW_LIST();
			case Permission.PredefinedNote_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PREDEFINED_NOTE_CREATE_OR_MODIFY();
			case Permission.PredefinedNote_Delete:
				return Res.Const.ENUM_PERMISSION_PREDEFINED_NOTE_DELETE();
			case Permission.PredefinedNote_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_PREDEFINED_NOTE_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.PredefinedNote_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_PREDEFINED_NOTE_MULTIPLE_DELETE();
			case Permission.SaleCenter_ShowList:
				return Res.Const.ENUM_PERMISSION_SALE_CENTER_SHOW_LIST();
			case Permission.SaleCenter_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SALE_CENTER_CREATE_OR_MODIFY();
			case Permission.SaleCenter_Delete:
				return Res.Const.ENUM_PERMISSION_SALE_CENTER_DELETE();
			case Permission.SaleCenter_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_SALE_CENTER_MULTIPLE_DELETE();
			case Permission.SaleCenter_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_SALE_CENTER_MULTIPLE_CREATE_OR_MODIFY();
			case Permission.User_ShowList:
				return Res.Const.ENUM_PERMISSION_USER_SHOW_LIST();
			case Permission.User_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_USER_CREATE_OR_MODIFY();
			case Permission.User_Delete:
				return Res.Const.ENUM_PERMISSION_USER_DELETE();
			case Permission.User_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_USER_MULTIPLE_DELETE();
			case Permission.User_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_USER_MULTIPLE_CREATE_OR_MODIFY();
			case Permission.Vat_ShowList:
				return Res.Const.ENUM_PERMISSION_VAT_SHOW_LIST();
			case Permission.Vat_Edition:
				return Res.Const.ENUM_PERMISSION_VAT_EDITION();
			case Permission.Product_ShowList:
				return Res.Const.ENUM_PERMISSION_PRODUCT_SHOW_LIST();
			case Permission.Product_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PRODUCT_CREATE_OR_MODIFY();
			case Permission.Product_Delete:
				return Res.Const.ENUM_PERMISSION_PRODUCT_DELETE();
			case Permission.Product_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_PRODUCT_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.Product_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_PRODUCT_MULTIPLE_DELETE();
			case Permission.Product_ChangePrices:
				return Res.Const.ENUM_PERMISSION_PRODUCT_CHANGE_PRICES();
			case Permission.Product_ShowHistory:
				return Res.Const.ENUM_PERMISSION_SHOW_PRODUCT_HISTORY();
			case Permission.Product_ShowStocks:
				return Res.Const.ENUM_PERMISSION_SHOW_PRODUCT_STOCKS();
			case Permission.Product_PurchaseWithoutSupplierConditions:
				return Res.Const.ENUM_PERMISSION_PRODUCT_PURCHASE_WITHOUT_SUPPLIER_CONDITIONS();
			case Permission.Category_ShowList:
				return Res.Const.ENUM_PERMISSION_CATEGORY_SHOW_LIST();
			case Permission.Category_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_CATEGORY_CREATE_OR_MODIFY();
			case Permission.Category_Delete:
				return Res.Const.ENUM_PERMISSION_CATEGORY_DELETE();
			case Permission.Category_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_CATEGORY_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.Category_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_CATEGORY_MULTIPLE_DELETE();
			case Permission.AuditMonitor_ShowList:
				return Res.Const.ENUM_PERMISSION_AUDIT_MONITOR_SHOW_LIST();
			case Permission.Company_Edition:
				return Res.Const.ENUM_PERMISSION_COMPANY_EDITION();
			case Permission.PaymentMethod_ShowList:
				return Res.Const.ENUM_PERMISSION_PAYMENT_METHOD_SHOW_LIST();
			case Permission.PaymentMethod_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PAYMENT_METHOD_CREATE_OR_MODIFY();
			case Permission.PaymentMethod_Delete:
				return Res.Const.ENUM_PERMISSION_PAYMENT_METHOD_DELETE();
			case Permission.PriceList_ShowList:
				return Res.Const.ENUM_PERMISSION_PRICE_LIST_SHOW_LIST();
			case Permission.PriceList_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PRICE_LIST_CREATE_OR_MODIFY();
			case Permission.PriceList_Delete:
				return Res.Const.ENUM_PERMISSION_PRICE_LIST_DELETE();
			case Permission.PriceList_Schedule:
				return Res.Const.ENUM_PERMISSION_PRICE_LIST_SCHEDULE();
			case Permission.PriceList_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_PRICE_LIST_MULTIPLE_CREATE_OR_MODIFY();
			case Permission.PriceList_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_PRICE_LIST_MULTIPLE_DELETE();
			case Permission.Supplier_ShowList:
				return Res.Const.ENUM_PERMISSION_SUPPLIER_SHOW_LIST();
			case Permission.Supplier_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SUPPLIER_CREATE_OR_MODIFY();
			case Permission.Supplier_Delete:
				return Res.Const.ENUM_PERMISSION_SUPPLIER_DELETE();
			case Permission.Supplier_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_SUPPLIER_MULTIPLE_DELETE();
			case Permission.Supplier_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_SUPPLIER_MULTIPLE_CREATE_OR_MODIFY();
			case Permission.Customer_ShowList:
				return Res.Const.ENUM_PERMISSION_CUSTOMER_SHOW_LIST();
			case Permission.Customer_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_CUSTOMER_CREATE_OR_MODIFY();
			case Permission.Customer_Delete:
				return Res.Const.ENUM_PERMISSION_CUSTOMER_DELETE();
			case Permission.Customer_CreateOrModifyWithOtherDocumentIdType:
				return Res.Const.ENUM_PERMISSION_CUSTOMER_CREATE_OR_MODIFY_WITH_OTHER_DOCUMENT_ID_TYPE();
			case Permission.Menu_ShowList:
				return Res.Const.ENUM_PERMISSION_MENU_SHOW_LIST();
			case Permission.Menu_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_MENU_CREATE_OR_MODIFY();
			case Permission.Menu_Delete:
				return Res.Const.ENUM_PERMISSION_MENU_DELETE();
			case Permission.Menu_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_MENU_TAG_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.Menu_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_MENU_DELETE_MULTIPLE();
			case Permission.PosVisualSettings_ChangeProductGroupOrder:
				return Res.Const.ENUM_PERMISSION_POS_VISUAL_SETTINGS_CHANGE_PRODUCT_GROUP_ORDER();
			case Permission.PosVisualSettings_ChangeProductsOrderInProductGroup:
				return Res.Const.ENUM_PERMISSION_POS_VISUAL_SETTINGS_CHANGE_PRODUCTS_ORDER_IN_PRODUCT_GROUP();
			case Permission.PosVisualSettings_ChangeActionDisplaySettings:
				return Res.Const.ENUM_PERMISSION_POS_VISUAL_SETTINGS_CHANGE_ACTION_DISPLAY_SETTINGS();
			case Permission.Report_DateRangeSales:
				return Res.Const.ENUM_PERMISSION_REPORT_DATE_RANGE_SALES();
			case Permission.Report_ProductSales:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_SALES();
			case Permission.Report_UserSales:
				return Res.Const.ENUM_PERMISSION_REPORT_USER_SALES();
			case Permission.Report_DateRangeSalesSummary:
				return Res.Const.ENUM_PERMISSION_REPORT_DATE_RANGE_SALES_SUMMARY();
			case Permission.Report_SaleCenterSales:
				return Res.Const.ENUM_PERMISSION_REPORT_SALE_CENTER_SALES();
			case Permission.Report_PriceList:
				return Res.Const.ENUM_PERMISSION_REPORT_PRICE_LIST();
			case Permission.Report_SupplierPurchases:
				return Res.Const.ENUM_PERMISSION_REPORT_SUPPLIER_PURCHASES();
			case Permission.Report_ProductStock:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_STOCK();
			case Permission.Report_ProductPurchasesAndSales:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_PURCHASES_AND_SALES();
			case Permission.Report_CustomerPurchases:
				return Res.Const.ENUM_PERMISSION_REPORT_CUSTOMER_PURCHASES();
			case Permission.Report_PaymentMethods:
				return Res.Const.ENUM_PERMISSION_REPORT_PAYMENT_METHODS();
			case Permission.Report_ProductSalesByTimeFrame:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_SALES_BY_TIME_FRAME();
			case Permission.TimeFrames_Change:
				return Res.Const.ENUM_PERMISSION_TIME_FRAME_CHANGE();
			case Permission.Report_UserSalesByTimeFrame:
				return Res.Const.ENUM_PERMISSION_REPORT_USER_SALES_BY_TIME_FRAME();
			case Permission.Report_ProductSalesBySaleCenter:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_SALES_BY_SALE_CENTER();
			case Permission.Report_TableCompanionsByTimeFrame:
				return Res.Const.ENUM_PERMISSION_REPORT_TABLE_COMPANIONS_BY_TIME_FRAME();
			case Permission.Report_TableCompanionsBySaleCenter:
				return Res.Const.ENUM_PERMISSION_REPORT_TABLE_COMPANIONS_BY_SALE_CENTER();
			case Permission.Report_TicketsByTimeFrame:
				return Res.Const.ENUM_PERMISSION_REPORT_TICKETS_BY_TIME_FRAME();
			case Permission.Report_TicketsBySaleCenter:
				return Res.Const.ENUM_PERMISSION_REPORT_TICKETS_BY_SALE_CENTER();
			case Permission.Report_ProductsUnderMinStock:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCTS_UNDER_MIN_STOCK();
			case Permission.Report_CashTransactions:
				return Res.Const.ENUM_PERMISSION_REPORT_CASH_TRANSACTIONS();
			case Permission.Report_SaleCenterSalesByTimeFrame:
				return Res.Const.ENUM_PERMISSION_REPORT_SALE_CENTER_SALES_BY_TIME_FRAME();
			case Permission.Report_FiscalSummary:
				return Res.Const.ENUM_PERMISSION_REPORT_FISCAL_SUMMARY();
			case Permission.Report_CustomerSalesByProduct:
				return Res.Const.ENUM_PERMISSION_REPORT_CUSTOMER_SALES_BY_PRODUCT();
			case Permission.Report_UserLogins:
				return Res.Const.ENUM_PERMISSION_REPORT_USER_LOGINS();
			case Permission.Report_ProductSalesByCategory:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_SALES_BY_CATEGORY();
			case Permission.Report_ProductSalesByCustomer:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_SALES_BY_CUSTOMER();
			case Permission.Report_ProductMarginsByFamily:
				return Res.Const.ENUM_PERMISSION_REPORT_MARGINS_BY_FAMILY();
			case Permission.Report_ProductMarginsByCategory:
				return Res.Const.ENUM_PERMISSION_REPORT_MARGINS_BY_CATEGORY();
			case Permission.Report_ProductSalesByUser:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_SALES_BY_USER();
			case Permission.Report_InvitationsByBusinessDay:
				return Res.Const.ENUM_PERMISSION_REPORT_INVITATIONS_BY_BUSINESS_DAY();
			case Permission.Report_ProductSalesByOffer:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_SALES_BY_OFFER();
			case Permission.Report_SalesLocationSales:
				return Res.Const.ENUM_PERMISSION_REPORT_SALES_LOCATION_SALES();
			case Permission.Report_MajorGroupSales:
				return Res.Const.ENUM_PERMISSION_REPORT_MAJOR_GROUP_SALES();
			case Permission.Report_MenuSales:
				return Res.Const.ENUM_PERMISSION_REPORT_MENU_SALES();
			case Permission.Report_DiscountsByAndProductUser:
				return Res.Const.ENUM_PERMISSION_REPORT_DISCOUNTS_BY_USER_AND_PRODUCT();
			case Permission.Report_ProductPreparationTime:
				return Res.Const.ENUM_PERMISSION_REPORT_PRODUCT_PREPARATION_TIME();
			case Permission.Report_TipsByUser:
				return Res.Const.ENUM_PERMISSION_REPORT_TIPS_BY_USER();
			case Permission.Report_DiscountsByTypeAndUser:
				return Res.Const.ENUM_PERMISSION_REPORT_DISCOUNTS_BY_USER_AND_TYPE();
			case Permission.Report_CancellationsByAndProductUser:
				return Res.Const.ENUM_PERMISSION_REPORT_CANCELLATIONS_BY_USER_AND_PRODUCT();
			case Permission.Report_CancellationsByAndTypeUser:
				return Res.Const.ENUM_PERMISSION_REPORT_CANCELLATIONS_BY_USER_AND_TYPE();
			case Permission.Report_InvoicesByCustomer:
				return Res.Const.ENUM_PERMISSION_REPORT_INVOICES_BY_CUSTOMER();
			case Permission.Report_TaxesByCustomer:
				return Res.Const.ENUM_PERMISSION_REPORT_TAXES_BY_CUSTOMER();
			case Permission.Report_InvoicesPerMonthThroughYears:
				return Res.Const.ENUM_PERMISSION_REPORT_INVOICES_PER_MONTH_THROUGH_YEARS();
			case Permission.Report_PurchaseDetailsBySupplier:
				return Res.Const.ENUM_PERMISSION_REPORT_PURCHASE_DETAILS_BY_SUPPLIER();
			case Permission.Report_WorkplaceSales:
				return Res.Const.ENUM_PERMISSION_REPORT_WORKPLACE_SALES();
			case Permission.Report_TableCompanionsByWorkplaceAndTimeFrame:
				return Res.Const.ENUM_PERMISSION_TABLE_COMPANIONS_BY_WORKPLACE_AND_TIME_FRAME();
			case Permission.Report_TicketsByWokrplaceAndTimeFrame:
				return Res.Const.ENUM_PERMISSION_TICKETS_BY_WORKPLACE_AND_TIME_FRAME();
			case Permission.Report_AppointmentsByDay:
				return Res.Const.ENUM_PERMISSION_APPOINTMENTS_BY_DAY();
			case Permission.TimeFrameGroups_ShowList:
				return Res.Const.ENUM_PERMISSION_TIME_FRAME_GROUPS_SHOW_LIST();
			case Permission.TimeFrameGroups_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_TIME_FRAME_GROUPS_CREATE_OR_MODIFY();
			case Permission.TimeFrameGroups_Delete:
				return Res.Const.ENUM_PERMISSION_TIME_FRAME_GROUPS_DELETE();
			case Permission.Report_WorkedHours:
				return Res.Const.ENUM_PERMISSION_REPORT_WORKED_HOURS();
			case Permission.Report_PurchasePrices:
				return Res.Const.ENUM_PERMISSION_REPORT_PURCHASE_PRICES();
			case Permission.Report_LotsInStock:
				return Res.Const.ENUM_PERMISSION_REPORT_LOTS_IN_STOCK();
			case Permission.Report_LotsByExpirationDate:
				return Res.Const.ENUM_PERMISSION_REPORT_LOTS_BY_EXPIRATION_DATE();
			case Permission.Report_UnpaidScaleSales:
				return Res.Const.ENUM_PERMISSION_REPORT_UNPAID_SCALE_SALES();
			case Permission.Report_SaveViews:
				return Res.Const.ENUM_PERMISSION_REPORT_SAVE_VIEWS();
			case Permission.Excel_ImportAndExport:
				return Res.Const.ENUM_PERMISSION_EXCEL_IMPORT_AND_EXPORT();
			case Permission.Backup_Create_And_Restore:
				return Res.Const.ENUM_PERMISSION_BACKUP_CREATE_AND_RESTORE();
			case Permission.Modules_Activate:
				return Res.Const.ENUM_PERMISSION_MODULES_ACTIVATE();
			case Permission.RemoteSupport:
				return Res.Const.ENUM_PERMISSION_REMOTE_SUPPORT();
			case Permission.Ticket_Deletion:
				return Res.Const.ENUM_PERMISSION_TICKET_DELETION();
			case Permission.Ticket_Migrate:
				return Res.Const.ENUM_PERMISSION_TICKET_MIGRATE();
			case Permission.Ticket_DeleteMigrated:
				return Res.Const.ENUM_PERMISSION_TICKET_DELETE_MIGRATED();
			case Permission.Ticket_CheckTickets:
				return Res.Const.ENUM_PERMISSION_TICKET_CHECK_TICKETS();
			case Permission.Ticket_GenerateControlRoll:
				return Res.Const.ENUM_PERMISSION_GENERATE_CONTROL_ROLL();
			case Permission.SalesOrders_Check:
				return Res.Const.ENUM_PERMISSION_SALES_ORDERS_CHECK();
			case Permission.Ticket_SaveToPdf:
				return Res.Const.ENUM_PERMISSION_TICKET_SAVE_TO_PDF();
			case Permission.DeliveryNote_CheckDeliveryNotes:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_CHECK_DELIVERY_NOTES();
			case Permission.SalesOrders_SaveToPdf:
				return Res.Const.ENUM_PERMISSION_SALES_ORDERS_SAVE_TO_PDF();
			case Permission.DeliveryNote_SaveToPdf:
				return Res.Const.ENUM_PERMISSION_DELIVERY_NOTE_SAVE_TO_PDF();
			case Permission.Wizard_Configuration:
				return Res.Const.ENUM_PERMISSION_WIZARD_CONFIGURATION();
			case Permission.PrintTemplate_ShowList:
				return Res.Const.ENUM_PERMISSION_PRINT_TEMPLATE_SHOW_LIST();
			case Permission.PrintTemplate_Delete:
				return Res.Const.ENUM_PERMISSION_PRINT_TEMPLATE_DELETE();
			case Permission.PrintTemplate_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PRINT_TEMPLATE_CREATE_OR_MODIFY();
			case Permission.IncomingDeliveryNote_ShowList:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_SHOW_LIST();
			case Permission.IncomingDeliveryNote_Delete:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_DELETE();
			case Permission.IncomingDeliveryNote_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_CREATE_OR_MODIFY();
			case Permission.IncomingDeliveryNote_UpdateCostPrices:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_UPDATE_COST_PRICES();
			case Permission.IncomingDeliveryNote_UpdateRegularSuppliers:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_UPDATE_REGULAR_SUPPLIERS();
			case Permission.IncomingDeliveryNote_SendEmail:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_SEND_EMAIL();
			case Permission.IncomingDeliveryNote_UpdateCostPricePolicy:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_UPDATE_PRICE_POLICY();
			case Permission.IncomingDeliveryNote_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_INCOMING_DELIVERY_NOTE_DELETE_MULTIPLE();
			case Permission.Inventory_ShowList:
				return Res.Const.ENUM_PERMISSION_INVENTORY_SHOW_LIST();
			case Permission.Inventory_Delete:
				return Res.Const.ENUM_PERMISSION_INVENTORY_DELETE();
			case Permission.Inventory_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_INVENTORY_CREATE_OR_MODIFY();
			case Permission.Inventory_ShowCostPrices:
				return Res.Const.ENUM_PERMISSION_INVENTORY_SHOW_COST_PRICES();
			case Permission.Inventory_ShowExpectedStock:
				return Res.Const.ENUM_PERMISSION_INVENTORY_SHOW_EXPECTED_STOCK();
			case Permission.Pos_CheckPosCloseOuts:
				return Res.Const.ENUM_PERMISSION_POS_CHECK_POS_CLOSE_OUTS();
			case Permission.Emailing_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_EMAILING_CREATE_OR_MODIFY();
			case Permission.Emailing_ShowStats:
				return Res.Const.ENUM_PERMISSION_EMAILING_SHOW_STATS();
			case Permission.Emailing_Start:
				return Res.Const.ENUM_PERMISSION_EMAILING_START();
			case Permission.Emailing_Test:
				return Res.Const.ENUM_PERMISSION_EMAILING_TEST();
			case Permission.Emailing_Cancel:
				return Res.Const.ENUM_PERMISSION_EMAILING_CANCEL();
			case Permission.Emailing_Delete:
				return Res.Const.ENUM_PERMISSION_EMAILING_DELETE();
			case Permission.Emailing_ShowList:
				return Res.Const.ENUM_PERMISSION_EMAILING_SHOW_LIST();
			case Permission.Map_ShowList:
				return Res.Const.ENUM_PERMISSION_MAP_SHOW_LIST();
			case Permission.Map_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_MAP_CREATE_OR_MODIFY();
			case Permission.Map_Delete:
				return Res.Const.ENUM_PERMISSION_MAP_DELETE();
			case Permission.AuditQuery_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_AUDIT_QUERY_CREATE_OR_MODIFY();
			case Permission.AuditQuery_Delete:
				return Res.Const.ENUM_PERMISSION_AUDIT_QUERY_DELETE();
			case Permission.KitchenPrintTemplate_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_KITCHEN_PRINT_TEMPLATE_CREATE_OR_MODIFY();
			case Permission.Cctv_Configure:
				return Res.Const.ENUM_PERMISSION_CCTV_CONFIGURE();
			case Permission.Cctv_Show:
				return Res.Const.ENUM_PERMISSION_CCTV_SHOW();
			case Permission.Cctv_Navigate:
				return Res.Const.ENUM_PERMISSION_CCTV_NAVIGATE();
			case Permission.System_CheckSystemCloseOuts:
				return Res.Const.ENUM_PERMISSION_CHECK_SYSTEM_CLOSE_OUTS();
			case Permission.Language_Select:
				return Res.Const.ENUM_PERMISSION_SELECT_LANGUAGE();
			case Permission.ScaleCounter_ShowList:
				return Res.Const.ENUM_PERMISSION_SCALE_COUNTER_SHOW_LIST();
			case Permission.ScaleCounter_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SCALE_COUNTER_CREATE_OR_MODIFY();
			case Permission.ScaleCounter_Delete:
				return Res.Const.ENUM_PERMISSION_SCALE_COUNTER_DELETE();
			case Permission.ScaleCounter_SendConfiguration:
				return Res.Const.ENUM_PERMISSION_SCALE_COUNTER_SEND_CONFIGURATION();
			case Permission.StockChange_ShowList:
				return Res.Const.ENUM_PERMISSION_STOCK_CHANGE_SHOW_LIST();
			case Permission.StockChange_Delete:
				return Res.Const.ENUM_PERMISSION_STOCK_CHANGE_DELETE();
			case Permission.StockChange_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_STOCK_CHANGE_CREATE_OR_MODIFY();
			case Permission.StockChange_ShowCostPrices:
				return Res.Const.ENUM_PERMISSION_STOCK_CHANGE_SHOW_COST_PRICES();
			case Permission.StockChange_UpdateCostPrices:
				return Res.Const.ENUM_PERMISSION_STOCK_CHANGE_UPDATE_COST_PRICES();
			case Permission.StockChange_UpdateCostPricePolicy:
				return Res.Const.ENUM_PERMISSION_STOCK_CHANGE_UPDATE_PRICE_POLICY();
			case Permission.UserProfile_ShowList:
				return Res.Const.ENUM_PERMISSION_USER_PROFILE_SHOW_LIST();
			case Permission.UserProfile_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_USER_PROFILE_CREATE_OR_MODIFY();
			case Permission.UserProfile_Delete:
				return Res.Const.ENUM_PERMISSION_USER_PROFILE_DELETE();
			case Permission.MajorGroup_ShowList:
				return Res.Const.ENUM_PERMISSION_MAJOR_GROUP_SHOW_LIST();
			case Permission.MajorGroup_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_MAJOR_GROUP_CREATE_OR_MODIFY();
			case Permission.MajorGroup_Delete:
				return Res.Const.ENUM_PERMISSION_MAJOR_GROUP_DELETE();
			case Permission.Workplace_ShowList:
				return Res.Const.ENUM_PERMISSION_WORKPLACES_SHOW_LIST();
			case Permission.Workplace_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_WORKPLACE_CREATE_OR_MODIFY();
			case Permission.Workplace_Delete:
				return Res.Const.ENUM_PERMISSION_WORKPLACE_DELETE();
			case Permission.Workplace_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_WORKPLACE_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.Workplace_DeleteMultiple:
				return Res.Const.ENUM_PERMISSION_WORKPLACE_DELETE_MULTIPLE();
			case Permission.Serie_ShowList:
				return Res.Const.ENUM_PERMISSION_SERIE_SHOW_LIST();
			case Permission.Serie_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SERIE_CREATE_OR_MODIFY();
			case Permission.Serie_Delete:
				return Res.Const.ENUM_PERMISSION_SERIE_DELETE();
			case Permission.PreparationType_ShowList:
				return Res.Const.ENUM_PERMISSION_PREPARATION_TYPE_SHOW_LIST();
			case Permission.PreparationType_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PREPARATION_TYPE_CREATE_OR_MODIFY();
			case Permission.PreparationType_Delete:
				return Res.Const.ENUM_PERMISSION_PREPARATION_TYPE_DELETE();
			case Permission.PreparationOrder_ShowList:
				return Res.Const.ENUM_PERMISSION_PREPARATION_ORDER_SHOW_LIST();
			case Permission.PreparationOrder_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PREPARATION_ORDER_CREATE_OR_MODIFY();
			case Permission.PreparationOrder_Delete:
				return Res.Const.ENUM_PERMISSION_PREPARATION_ORDER_DELETE();
			case Permission.ActionDisplayProfile_ShowList:
				return Res.Const.ENUM_PERMISSION_ACTION_DISPLAY_PROFILE_SHOW_LIST();
			case Permission.ActionDisplayProfile_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_ACTION_DISPLAY_PROFILE_CREATE_OR_MODIFY();
			case Permission.ActionDisplayProfile_Delete:
				return Res.Const.ENUM_PERMISSION_ACTION_DISPLAY_PROFILE_DELETE();
			case Permission.KitchenDisplay_Delete:
				return Res.Const.ENUM_PERMISSION_KITCHEN_DISPLAY_DELETE();
			case Permission.KitchenDisplay_ShowList:
				return Res.Const.ENUM_PERMISSION_KITCHEN_DISPLAY_SHOW_LIST();
			case Permission.Offer_ShowList:
				return Res.Const.ENUM_PERMISSION_OFFER_SHOW_LIST();
			case Permission.Offer_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_OFFER_CREATE_OR_MODIFY();
			case Permission.Offer_Delete:
				return Res.Const.ENUM_PERMISSION_OFFER_DELETE();
			case Permission.Offer_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_OFFER_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.Offer_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_OFFER_DELETE_MULTIPLE();
			case Permission.Margins_Edit:
				return Res.Const.ENUM_PERMISSION_MARGIN_EDIT();
			case Permission.Warehouse_ShowList:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_SHOW_LIST();
			case Permission.Warehouse_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_CREATE_OR_MODIFY();
			case Permission.Warehouse_Delete:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_DELETE();
			case Permission.Warehouse_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_DELETE_MULTIPLE();
			case Permission.Warehouse_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.PurchaseOrder_ShowList:
				return Res.Const.ENUM_PERMISSION_PURCHASE_ORDER_SHOW_LIST();
			case Permission.PurchaseOrder_Delete:
				return Res.Const.ENUM_PERMISSION_PURCHASE_ORDER_DELETE();
			case Permission.PurchaseOrder_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PURCHASE_ORDER_CREATE_OR_MODIFY();
			case Permission.PurchaseOrder_SendEmail:
				return Res.Const.ENUM_PERMISSION_PURCHASE_ORDER_SEND_EMAIL();
			case Permission.PurchaseOrder_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_PURCHASE_ORDER_DELETE_MULTIPLE();
			case Permission.NamedDiscount_ShowList:
				return Res.Const.ENUM_PERMISSION_NAMED_DISCOUNT_SHOW_LIST();
			case Permission.NamedDiscount_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_NAMED_DISCOUNT_CREATE_OR_MODIFY();
			case Permission.NamedDiscount_Delete:
				return Res.Const.ENUM_PERMISSION_NAMED_DISCOUNT_DELETE();
			case Permission.NamedDiscount_CreateOrModifyMultiple:
				return Res.Const.ENUM_PERMISSION_NAMED_DISCOUNT_CREATE_OR_MODIFY_MULTIPLE();
			case Permission.NamedDiscount_DeleteMultiple:
				return Res.Const.ENUM_PERMISSION_NAMED_DISCOUNT_DELETE_MULTIPLE();
			case Permission.Training_ConfigureSettings:
				return Res.Const.ENUM_PERMISSION_TRAINING_CONFIGURE_SETTINGS();
			case Permission.Training_CheckSessions:
				return Res.Const.ENUM_PERMISSION_TRAINING_CHECK_SESSIONS();
			case Permission.Training_DeleteSummaries:
				return Res.Const.ENUM_PERMISSION_TRAINING_DELETE_SESSIONS();
			case Permission.PosGroup_ShowList:
				return Res.Const.ENUM_PERMISSION_POS_GROUP_SHOW_LIST();
			case Permission.PosGroup_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_POS_GROUP_CREATE_OR_MODIFY();
			case Permission.PosGroup_Delete:
				return Res.Const.ENUM_PERMISSION_POS_GROUP_DELETE();
			case Permission.Coupon_ShowList:
				return Res.Const.ENUM_PERMISSION_COUPON_SHOW_LIST();
			case Permission.Coupon_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_COUPON_CREATE_OR_MODIFY();
			case Permission.Coupon_Delete:
				return Res.Const.ENUM_PERMISSION_COUPON_DELETE();
			case Permission.LineCancellation_ShowList:
				return Res.Const.ENUM_PERMISSION_LINE_CANCELLATION_REASON_SHOW_LIST();
			case Permission.LineCancellation_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_LINE_CANCELLATION_REASON_CREATE_OR_MODIFY();
			case Permission.LineCancellation_Delete:
				return Res.Const.ENUM_PERMISSION_LINE_CANCELLATION_REASON_DELETE();
			case Permission.WebAdmin_Edition:
				return Res.Const.ENUM_PERMISSION_WEB_ADMIN_EDITION();
			case Permission.Hub_GenerateWorkplaceData:
				return Res.Const.ENUM_PERMISSION_HUB_GENERATE_WORKPLACE_DATA();
			case Permission.Dashboard_Show:
				return Res.Const.ENUM_PERMISSION_DASHBOARD_SHOW();
			case Permission.CouponPrintTemplate_ShowList:
				return Res.Const.ENUM_PERMISSION_COUPON_PRINT_TEMPLATE_SHOW_LIST();
			case Permission.CouponPrintTemplate_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_COUPON_PRINT_TEMPLATE_CREATE_OR_MODIFY();
			case Permission.CouponPrintTemplate_Delete:
				return Res.Const.ENUM_PERMISSION_COUPON_PRINT_TEMPLATE_DELETE();
			case Permission.SystemOfMeasurement_ShowList:
				return Res.Const.ENUM_PERMISSION_SYSTEM_OF_MEASUREMENT_SHOW_LIST();
			case Permission.SystemOfMeasurement_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SYSTEM_OF_MEASUREMENT_CREATE_OR_MODIFY();
			case Permission.SystemOfMeasurement_Delete:
				return Res.Const.ENUM_PERMISSION_SYSTEM_OF_MEASUREMENT_DELETE();
			case Permission.CustomActionButton_ShowList:
				return Res.Const.ENUM_PERMISSION_CUSTOM_ACTION_BUTTON_LIST();
			case Permission.CustomActionButton_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_CUSTOM_ACTION_BUTTON_CREATE_OR_MODIFY();
			case Permission.CustomActionButton_Delete:
				return Res.Const.ENUM_PERMISSION_CUSTOM_ACTION_BUTTON_DELETE();
			case Permission.WebAdmin_DownloadServerLogs:
				return Res.Const.ENUM_PERMISSION_WEB_ADMIN_DONWLOAD_SERVER_LOGS();
			case Permission.PurchaseInvoice_ShowList:
				return Res.Const.ENUM_PERMISSION_PURCHASE_INVOICE_SHOW_LIST();
			case Permission.PurchaseInvoice_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PURCHASE_INVOICE_CREATE_OR_MODIFY();
			case Permission.PurchaseInvoice_Delete:
				return Res.Const.ENUM_PERMISSION_PURCHASE_INVOICE_DELETE();
			case Permission.PurchaseInvoice_SendEmail:
				return Res.Const.ENUM_PERMISSION_PURCHASE_INVOICE_SEND_EMAIL();
			case Permission.PurchaseInvocie_MultipleDelete:
				return Res.Const.ENUM_PERMISSION_PURCHASE_INVOICE_DELETE_MULTIPLE();
			case Permission.Production_ShowList:
				return Res.Const.ENUM_PERMISSION_PRODUCTION_SHOW_LIST();
			case Permission.Production_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PRODUCTION_CREATE_OR_MODIFY();
			case Permission.Production_Delete:
				return Res.Const.ENUM_PERMISSION_PRODUCTION_DELETE();
			case Permission.Production_ShowCostPrices:
				return Res.Const.ENUM_PERMISSION_PRODUCTION_SHOW_COST_PRICES();
			case Permission.Production_UpdateCostPrices:
				return Res.Const.ENUM_PERMISSION_PRODUCTION_UPDATE_COST_PRICES();
			case Permission.Widget_Warehouses:
				return Res.Const.ENUM_PERMISSION_WIDGET_WEAREHOUSES();
			case Permission.Widget_Sales:
				return Res.Const.ENUM_PERMISSION_WIDGET_SALES();
			case Permission.Widget_Comms:
				return Res.Const.ENUM_PERMISSION_WIDGET_COMMS();
			case Permission.Widget_Tickets:
				return Res.Const.ENUM_PERMISSION_WIDGET_TICKETS();
			case Permission.Widget_Occupancy:
				return Res.Const.ENUM_PERMISSION_WIDGET_OCCUPANCY();
			case Permission.GStock_ViewStatus:
				return Res.Const.ENUM_PERMISSION_GSTOCK_VIEW_STATUS();
			case Permission.CashControlSettings_ShowList:
				return Res.Const.ENUM_PERMISSION_CASH_CONTROL_SETTINGS_SHOW_LIST();
			case Permission.CashControlSettings_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_CASH_CONTROL_SETTINGS_CREATE_OR_MODIFY();
			case Permission.CashControlSettings_Delete:
				return Res.Const.ENUM_PERMISSION_CASH_CONTROL_SETTINGS_DELETE();
			case Permission.CardProcessorSettings_ShowList:
				return Res.Const.ENUM_PERMISSION_CARD_PROCESSOR_SETTINGS_SHOW_LIST();
			case Permission.CardProcessorSettings_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_CARD_PROCESSOR_SETTINGS_CREATE_OR_MODIFY();
			case Permission.CardProcessorSettings_Delete:
				return Res.Const.ENUM_PERMISSION_CARD_PROCESSOR_SETTINGS_DELETE();
			case Permission.TablePaymentSettings_ShowList:
				return Res.Const.ENUM_PERMISSION_TABLE_PAYMENT_SETTINGS_SHOW_LIST();
			case Permission.TablePaymentSettings_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_TABLE_PAYMENT_SETTINGS_CREATE_OR_MODIFY();
			case Permission.TablePaymentSettings_Delete:
				return Res.Const.ENUM_PERMISSION_TABLE_PAYMENT_SETTINGS_DELETE();
			case Permission.WorkingPeriod_ShowList:
				return Res.Const.ENUM_WORKING_PERIOD_SHOW_LIST();
			case Permission.WorkingPeriod_CreateOrModify:
				return Res.Const.ENUM_WORKING_PERIOD_CREATE_OR_MODIFY();
			case Permission.WorkingPeriod_Delete:
				return Res.Const.ENUM_WORKING_PERIOD_DELETE();
			case Permission.WorkingPeriod_MultipleDelete:
				return Res.Const.ENUM_WORKING_PERIOD_MULTIPLE_DELETE();
			case Permission.WorkingPeriod_CreateorModifyMultiple:
				return Res.Const.ENUM_WORKING_PERIOD_MULTIPLE_CREATE_OR_MODIFY();
			case Permission.WorkingPeriod_GenerateExcel:
				return Res.Const.ENUM_WORKING_PERIOD_GENERATE_EXCEL();
			case Permission.Allergen_ShowList:
				return Res.Const.ENUM_PERMISSION_ALLERGEN_SHOW_LIST();
			case Permission.Allergen_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_ALLERGEN_CREATE_OR_MODIFY();
			case Permission.Allergen_Delete:
				return Res.Const.ENUM_PERMISSION_ALLERGEN_DELETE();
			case Permission.DigitalMenu_ShowList:
				return Res.Const.ENUM_PERMISSION_DIGITAL_MENU_SHOW_LIST();
			case Permission.DigitalMenu_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_DIGITAL_MENU_CREATE_OR_MODIFY();
			case Permission.DigitalMenu_Delete:
				return Res.Const.ENUM_PERMISSION_DIGITAL_MENU_DELETE();
			case Permission.DigitalMenu_PublishAll:
				return Res.Const.ENUM_PERMISSION_DIGITAL_MENU_PUBLISH();
			case Permission.DigitalMenu_GenerateQR:
				return Res.Const.ENUM_PERMISSION_DIGITAL_MENU_GENERATEQR();
			case Permission.DigitalMenuResources_Update:
				return Res.Const.ENUM_PERMISSION_DIGITAL_MENU_RESOURCES_UPDATE();
			case Permission.ProductTag_ShowList:
				return Res.Const.ENUM_PERMISSION_PRODUCT_TAG_SHOW_LIST();
			case Permission.ProductTag_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_PRODUCT_TAG_CREATE_OR_MODIFY();
			case Permission.ProductTag_Delete:
				return Res.Const.ENUM_PERMISSION_PRODUCT_TAG_DELETE();
			case Permission.EmailAccount_ShowList:
				return Res.Const.ENUM_PERMISSION_EMAIL_ACCOUNT_SHOW_LIST();
			case Permission.EmailAccount_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_EMAIL_ACCOUNT_CREATE_OR_MODIFY();
			case Permission.EmailAccount_Delete:
				return Res.Const.ENUM_PERMISSION_EMAIL_ACCOUNT_DELETE();
			case Permission.Lot_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_LOT_CREATE_OR_MODIFY();
			case Permission.Lot_ShowList:
				return Res.Const.ENUM_PERMISSION_LOT_SHOW_LIST();
			case Permission.Lot_Delete:
				return Res.Const.ENUM_PERMISSION_LOT_DELETE();
			case Permission.Label_ShowList:
				return Res.Const.ENUM_PERMISSION_LABEL_SHOW_LIST();
			case Permission.Label_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_LABEL_CREATE_OR_MODIFY();
			case Permission.Label_Delete:
				return Res.Const.ENUM_PERMISSION_LABEL_DELETE();
			case Permission.Label_Print:
				return Res.Const.ENUM_PERMISSION_LABEL_PRINT();
			case Permission.CustomerType_ShowList:
				return Res.Const.ENUM_PERMISSION_CUSTOMER_TYPES_SHOW_LIST();
			case Permission.CustomerType_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_CUSTOMER_TYPES_CREATE_OR_MODIFY();
			case Permission.CustomerType_Delete:
				return Res.Const.ENUM_PERMISSION_CUSTOMER_TYPES_DELETE();
			case Permission.SmartMenuOrderSettings_ShowList:
				return Res.Const.ENUM_PERMISSION_SMART_MENU_ORDER_SETTINGS_SHOW_LIST();
			case Permission.SmartMenuOrderSettings_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SMART_MENU_ORDER_SETTINGS_CREATE_OR_MODIFY();
			case Permission.SmartMenuOrderSettings_Delete:
				return Res.Const.ENUM_PERMISSION_SMART_MENU_ORDER_SETTINGS_DELETE();
			case Permission.WarehouseCloseOut_Create:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_CLOSE_OUT_CREATE();
			case Permission.WarehouseCloseOut_Delete:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_CLOSE_OUT_DELETE();
			case Permission.WarehouseCloseOut_ShowList:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_CLOSE_OUT_SHOW_LIST();
			case Permission.WarehouseCloseOut_Review:
				return Res.Const.ENUM_PERMISSION_WAREHOUSE_CLOSE_OUT_REVIEW();
			case Permission.SmartMenuWorkplaceSettings_ShowList:
				return Res.Const.ENUM_PERMISSION_SMART_MENU_WORKPLACE_GROUP_SETTINGS_SHOW_LIST();
			case Permission.SmartMenuWorkplaceSettings_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SMART_MENU_WORKPLACE_GROUP_SETTINGS_CREATE_OR_MODIFY();
			case Permission.SmartMenuWorkplaceSettings_Delete:
				return Res.Const.ENUM_PERMISSION_SMART_MENU_WORKPLACE_GROUP_SETTINGS_DELETE();
			case Permission.Size_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SIZE_CREATE_OR_MODIFY();
			case Permission.Color_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_COLOR_CREATE_OR_MODIFY();
			case Permission.Report_AgoraPayments:
				return Res.Const.ENUM_PERMISSION_REPORT_AGORA_PAYMENTS();
			case Permission.Report_SalesAnalytics:
				return Res.Const.ENUM_PERMISSION_REPORT_SALES_ANALYTICS();
			case Permission.Report_PurchasesAnalytics:
				return Res.Const.ENUM_PERMISSION_REPORT_PURCHASES_ANALYTICS();
			case Permission.Report_StocksAnalytics:
				return Res.Const.ENUM_PERMISSION_REPORT_STOCKS_ANALYTICS();
			case Permission.Report_AgoraPayouts:
				return Res.Const.ENUM_PERMISSION_REPORT_AGORA_PAYOUTS();
			case Permission.SifSettings_ShowList:
				return Res.Const.ENUM_PERMISSION_SIF_SETTINGS_SHOW_LIST();
			case Permission.SifSettings_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_SIF_SETTINGS_CREATE_OR_MODIFY();
			case Permission.SifSettings_Delete:
				return Res.Const.ENUM_PERMISSION_SIF_SETTINGS_DELETE();
			case Permission.Verifactu_ChainViewer:
				return Res.Const.ENUM_PERMISSION_VERIFACTU_CHAIN_VIEWER();
			case Permission.Internal_Supplier_ShowList:
				return Res.Const.ENUM_PERMISSION_VIEW_INTERNAL_SUPPLIER();
			case Permission.Internal_Supplier_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_EDIT_INTERNAL_SUPPLIER();
			case Permission.Internal_Supplier_Delete:
				return Res.Const.ENUM_PERMISSION_DELETE_INTERNAL_SUPPLIER();
			case Permission.Internal_Customer_ShowList:
				return Res.Const.ENUM_PERMISSION_VIEW_INTERNAL_CUSTOMER();
			case Permission.Internal_Customer_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_EDIT_INTERNAL_CUSTOMER();
			case Permission.Internal_Customer_Delete:
				return Res.Const.ENUM_PERMISSION_DELETE_INTERNAL_CUSTOMER();
			case Permission.Internal_Orders_ShowList:
				return Res.Const.ENUM_PERMISSION_VIEW_INTERNAL_ORDER();
			case Permission.Internal_Orders_Send:
				return Res.Const.ENUM_PERMISSION_SEND_INTERNAL_ORDER();
			case Permission.My_Agora_Account_ShowList:
				return Res.Const.ENUM_PERMISSION_VIEW_MY_AGORA_ACCOUNT();
			case Permission.My_Agora_Account_CreateOrModify:
				return Res.Const.ENUM_PERMISSION_EDIT_MY_AGORA_ACCOUNT();
			case Permission.My_Agora_Account_Delete:
				return Res.Const.ENUM_PERMISSION_DELETE_MY_AGORA_ACCOUNT();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PosType {
	POS = 0,
	SMARTPHONE = 1,
	TABLET = 2
}

export namespace PosType {
	export function toString(value: PosType) {
		switch (value) {
			case PosType.POS:
				return Res.Const.ENUM_POS_TYPE_POS();
			case PosType.SMARTPHONE:
				return Res.Const.ENUM_POS_TYPE_SMARTPHONE();
			case PosType.TABLET:
				return Res.Const.ENUM_POS_TYPE_TABLET();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PreparationEntryDirection {
	Right = 0,
	Left = 1
}

export namespace PreparationEntryDirection {
	export function toString(value: PreparationEntryDirection) {
		switch (value) {
			case PreparationEntryDirection.Right:
				return Res.Const.ENUM_PREPARATION_ENTRTY_DIRECTION_RIGHT();
			case PreparationEntryDirection.Left:
				return Res.Const.ENUM_PREPARATION_ENTRTY_DIRECTION_LEFT();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PriceListScheduleDateKind {
	Always = 0,
	SingleDay = 1,
	DateRange = 2
}

export namespace PriceListScheduleDateKind {
	export function toString(value: PriceListScheduleDateKind) {
		switch (value) {
			case PriceListScheduleDateKind.Always:
				return Res.Const.ENUM_PRICE_LIST_SCHEDULE_DATE_KIND_ALWAYS();
			case PriceListScheduleDateKind.SingleDay:
				return Res.Const.ENUM_PRICE_LIST_SCHEDULE_DATE_KIND_SINGLE_DAY();
			case PriceListScheduleDateKind.DateRange:
				return Res.Const.ENUM_PRICE_LIST_SCHEDULE_DATE_KIND_DATE_RANGE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PriceModificationType {
	Coin = 0,
	Percentage = 1
}

export namespace PriceModificationType {
	export function toString(value: PriceModificationType) {
		switch (value) {
			case PriceModificationType.Coin:
				return Res.Const.ENUM_PRICE_MODIFICATION_COIN_TYPE();
			case PriceModificationType.Percentage:
				return Res.Const.ENUM_PRICE_MODIFICATION_PERCENTAGE_TYPE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PrintTemplateType {
	EscPos = 0,
	Rdl = 1
}

export namespace PrintTemplateType {
	export function toString(value: PrintTemplateType) {
		switch (value) {
			case PrintTemplateType.EscPos:
				return Res.Const.ENUM_PRINT_TEMPLATE_TYPE_ESCPOS();
			case PrintTemplateType.Rdl:
				return Res.Const.ENUM_PRINT_TEMPLATE_TYPE_RDL();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ProductExportFormat {
	Excel = 0,
	Csv = 1
}

export namespace ProductExportFormat {
	export function toString(value: ProductExportFormat) {
		switch (value) {
			case ProductExportFormat.Excel:
				return Res.Const.ENUM_PRODUCT_EXPORT_FORMAT_EXCEL();
			case ProductExportFormat.Csv:
				return Res.Const.ENUM_PRODUCT_EXPORT_FORMAT_CSV();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ProductGroupType {
	Family = 0,
	Category = 1,
	ProductForDirectSale = 2
}

export namespace ProductGroupType {
	export function toString(value: ProductGroupType) {
		switch (value) {
			case ProductGroupType.Family:
				return Res.Const.ENUM_PRODUCT_GROUP_TYPE_FAMILY();
			case ProductGroupType.Category:
				return Res.Const.ENUM_PRODUCT_GROUP_TYPE_CATEGORY();
			case ProductGroupType.ProductForDirectSale:
				return Res.Const.ENUM_PRODUCT_GROUP_TYPE_PRODUCT_FOR_DIRECT_SALE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ProductionCostPricePolicy {
	ProductionCost = 0,
	WeightedAvgCost = 1
}

export namespace ProductionCostPricePolicy {
	export function toString(value: ProductionCostPricePolicy) {
		switch (value) {
			case ProductionCostPricePolicy.ProductionCost:
				return Res.Const.ENUM_PRODUCTION_COST_PRICE_PRODUCED_PRICE_POLICY();
			case ProductionCostPricePolicy.WeightedAvgCost:
				return Res.Const.ENUM_PRODUCTION_COST_PRICE_WIEGHTED_AVG_PRICE_POLICY();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ProductMarginModificationType {
	FixedMargin = 0,
	LastMargin = 1
}

export namespace ProductMarginModificationType {
	export function toString(value: ProductMarginModificationType) {
		switch (value) {
			case ProductMarginModificationType.FixedMargin:
				return Res.Const.ENUM_PRODUCT_MARGIN_MODIFICATION_FIXED_MARGIN_TYPE();
			case ProductMarginModificationType.LastMargin:
				return Res.Const.ENUM_PRODUCT_MARGIN_MODIFICATION_LAST_MARGIN_TYPE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ProductOrigin {
	Inventory = 0,
	Purchase = 1,
	RecipeAuto = 2,
	RecipeManual = 3
}

export namespace ProductOrigin {
	export function toString(value: ProductOrigin) {
		switch (value) {
			case ProductOrigin.Inventory:
				return Res.Const.ENUM_PRODUCT_ORIGIN_INVENTORY();
			case ProductOrigin.Purchase:
				return Res.Const.ENUM_PRODUCT_ORIGIN_PURCHASE();
			case ProductOrigin.RecipeAuto:
				return Res.Const.ENUM_PRODUCT_ORIGIN_RECIPE_AUTO();
			case ProductOrigin.RecipeManual:
				return Res.Const.ENUM_PRODUCT_ORIGIN_RECIPE_MANUAL();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ProductPrintMode {
	IfHasPrice = 0,
	Always = 1
}

export enum ProductRoleToModify {
	All = 0,
	MainPrice = 1,
	AddinPrice = 2,
	MenuItemPrice = 3
}

export namespace ProductRoleToModify {
	export function toString(value: ProductRoleToModify) {
		switch (value) {
			case ProductRoleToModify.All:
				return Res.Const.ENUM_PRODUCT_ROLE_TO_MODIFY_ALL();
			case ProductRoleToModify.MainPrice:
				return Res.Const.ENUM_PRODUCT_ROLE_TO_MODIFY_MAIN_PRICE();
			case ProductRoleToModify.AddinPrice:
				return Res.Const.ENUM_PRODUCT_ROLE_TO_MODIFY_ADDIN_PRICE();
			case ProductRoleToModify.MenuItemPrice:
				return Res.Const.ENUM_PRODUCT_ROLE_TO_MODIFY_MENUITEM_PRICE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PurchaseCostPricePolicy {
	PurchasePrice = 0,
	WeightedAvgPrice = 1,
	PurchasePrice30Days = 2,
	PurchasePrice90Days = 3
}

export namespace PurchaseCostPricePolicy {
	export function toString(value: PurchaseCostPricePolicy) {
		switch (value) {
			case PurchaseCostPricePolicy.PurchasePrice:
				return Res.Const.ENUM_PURCHASE_COST_PRICE_INCOMING_PRICE_POLICY();
			case PurchaseCostPricePolicy.WeightedAvgPrice:
				return Res.Const.ENUM_PURCHASE_COST_PRICE_WEIGHTED_AVG_PRICE_POLICY();
			case PurchaseCostPricePolicy.PurchasePrice30Days:
				return Res.Const.ENUM_PURCHASE_COST_PRICE_WEIGHTED_AVG_PRICE_30_DAYS_POLICY();
			case PurchaseCostPricePolicy.PurchasePrice90Days:
				return Res.Const.ENUM_PURCHASE_COST_PRICE_WEIGHTED_AVG_PRICE_90_DAYS_POLICY();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PurchaseInvoiceStatus {
	Unpaid = 0,
	Paid = 1,
	Accounted = 2
}

export namespace PurchaseInvoiceStatus {
	export function toString(value: PurchaseInvoiceStatus) {
		switch (value) {
			case PurchaseInvoiceStatus.Unpaid:
				return Res.Const.ENUM_PURCHASE_INVOICE_STATUS_UNPAID();
			case PurchaseInvoiceStatus.Paid:
				return Res.Const.ENUM_PURCHASE_INVOICE_STATUS_PAID();
			case PurchaseInvoiceStatus.Accounted:
				return Res.Const.ENUM_PURCHASE_INVOICE_STATUS_ACCOUNTED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum PurchaseOrderStatus {
	Draft = 0,
	Confirmed = 1,
	PartialDelivery = 2,
	Delivered = 3
}

export namespace PurchaseOrderStatus {
	export function toString(value: PurchaseOrderStatus) {
		switch (value) {
			case PurchaseOrderStatus.Draft:
				return Res.Const.ENUM_PURCHASE_ORDER_STATUS_DRAFT();
			case PurchaseOrderStatus.Confirmed:
				return Res.Const.ENUM_PURCHASE_ORDER_STATUS_CONFIRMED();
			case PurchaseOrderStatus.PartialDelivery:
				return Res.Const.ENUM_PURCHASE_ORDER_STATUS_PARTIAL_DELIVERY();
			case PurchaseOrderStatus.Delivered:
				return Res.Const.ENUM_PURCHASE_ORDER_STATUS_DELIVERED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum RefundSource {
	Ticket = 0,
	Reopen = 1,
	ConvertToStandard = 2,
	Invoice = 3,
	InvoiceLines = 4,
	DeliveryNotes = 5,
	SalesOrder = 6
}

export namespace RefundSource {
	export function toString(value: RefundSource) {
		switch (value) {
			case RefundSource.Ticket:
				return Res.Const.ENUM_REFUND_SOURCE_TICKET();
			case RefundSource.Reopen:
				return Res.Const.ENUM_REFUND_SOURCE_REOPEN();
			case RefundSource.ConvertToStandard:
				return Res.Const.ENUM_REFUND_SOURCE_CONVERSION();
			case RefundSource.Invoice:
				return Res.Const.ENUM_REFUND_SOURCE_INVOICE();
			case RefundSource.InvoiceLines:
				return Res.Const.ENUM_REFUND_SOURCE_INVOICE_LINES();
			case RefundSource.DeliveryNotes:
				return Res.Const.ENUM_REFUND_SOURCE_DELIVERY_NOTES();
			case RefundSource.SalesOrder:
				return Res.Const.ENUM_REFUND_SOURCE_SALES_ORDER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ReportFileType {
	PDF = 0,
	Excel = 1
}

export namespace ReportFileType {
	export function toString(value: ReportFileType) {
		switch (value) {
			case ReportFileType.PDF:
				return Res.Const.ENUM_REPORT_FILE_TYPE_PDF();
			case ReportFileType.Excel:
				return Res.Const.ENUM_REPORT_FILE_TYPE_EXCEL();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum RewardType {
	CashDiscount = 0,
	DiscountRate = 1,
	NamedDiscount = 2,
	Offer = 3
}

export namespace RewardType {
	export function toString(value: RewardType) {
		switch (value) {
			case RewardType.CashDiscount:
				return Res.Const.ENUM_REWARD_TYPE_CASH_DISCOUNT();
			case RewardType.DiscountRate:
				return Res.Const.ENUM_REWARD_TYPE_DISCOUNT_RATE();
			case RewardType.NamedDiscount:
				return Res.Const.ENUM_REWARD_TYPE_NAMED_DISCOUNT();
			case RewardType.Offer:
				return Res.Const.ENUM_REWARD_TYPE_OFFER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SaleFormatRole {
	Main = 0,
	Addin = 1,
	MenuItem = 2
}

export namespace SaleFormatRole {
	export function toString(value: SaleFormatRole) {
		switch (value) {
			case SaleFormatRole.Main:
				return Res.Const.ENUM_SALE_FORMAT_ROLE_MAIN();
			case SaleFormatRole.Addin:
				return Res.Const.ENUM_SALE_FORMAT_ROLE_ADDIN();
			case SaleFormatRole.MenuItem:
				return Res.Const.ENUM_SALE_FORMAT_ROLE_MENU_ITEM();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SalesOrderStatus {
	Completed = 0,
	Cancelled = 1,
	Pending = 2
}

export namespace SalesOrderStatus {
	export function toString(value: SalesOrderStatus) {
		switch (value) {
			case SalesOrderStatus.Completed:
				return Res.Const.ENUM_SALES_ORDER_STATUS_CLOSED();
			case SalesOrderStatus.Cancelled:
				return Res.Const.ENUM_SALES_ORDER_STATUS_CANCELLED();
			case SalesOrderStatus.Pending:
				return Res.Const.ENUM_SALES_ORDER_STATUS_PENDING();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SalesOrderType {
	Standard = 0,
	Delivery = 1,
	TakeAway = 2,
	Table = 3
}

export namespace SalesOrderType {
	export function toString(value: SalesOrderType) {
		switch (value) {
			case SalesOrderType.Standard:
				return Res.Const.ENUM_SALES_ORDER_TYPE_STANDARD();
			case SalesOrderType.Delivery:
				return Res.Const.ENUM_SALES_ORDER_TYPE_DELIVERY();
			case SalesOrderType.TakeAway:
				return Res.Const.ENUM_SALES_ORDER_TYPE_TAKE_AWAY();
			case SalesOrderType.Table:
				return Res.Const.ENUM_SALES_ORDER_TYPE_TABLE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ScaleType {
	Dibal = 0,
	Epelsa = 1
}

export namespace ScaleType {
	export function toString(value: ScaleType) {
		switch (value) {
			case ScaleType.Dibal:
				return Res.Const.ENUM_SCALE_SYSTEM_TYPE_DIBAL();
			case ScaleType.Epelsa:
				return Res.Const.ENUM_SCALE_SYSTEM_TYPE_EPELSA();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ScreenSaverType {
	DBImage = 0,
	VideoURL = 1,
	ImageURL = 2
}

export namespace ScreenSaverType {
	export function toString(value: ScreenSaverType) {
		switch (value) {
			case ScreenSaverType.DBImage:
				return Res.Const.ENUM_SCREENSAVER_TYPE_DB_IMAGE();
			case ScreenSaverType.VideoURL:
				return Res.Const.ENUM_SCREENSAVER_TYPE_VIDEO_URL();
			case ScreenSaverType.ImageURL:
				return Res.Const.ENUM_SCREENSAVER_TYPE_IMAGE_URL();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum ScreenScrollMode {
	Hidden = 0,
	Visible = 1,
	Auto = 2
}

export namespace ScreenScrollMode {
	export function toString(value: ScreenScrollMode) {
		switch (value) {
			case ScreenScrollMode.Hidden:
				return Res.Const.ENUM_SCREEN_SCROLLBAR_MODE_HIDDEN();
			case ScreenScrollMode.Visible:
				return Res.Const.ENUM_SCREEN_SCROLLBAR_MODE_VISIBLE();
			case ScreenScrollMode.Auto:
				return Res.Const.ENUM_SCREEN_SCROLLBAR_MODE_AUTO();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SearchMode {
	Text = 0,
	ProductGroup = 1
}

export namespace SearchMode {
	export function toString(value: SearchMode) {
		switch (value) {
			case SearchMode.Text:
				return Res.Const.ENUM_SEARCH_MODE_TEXT();
			case SearchMode.ProductGroup:
				return Res.Const.ENUM_SEARCH_MODE_PRODUCT_GROUP();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SerializationFormat {
	Xml = 0,
	Json = 1
}

export enum SettingsFileType {
	CashControl = 0,
	CardProcessor = 1,
	CardProcessorTablePayment = 2
}

export namespace SettingsFileType {
	export function toString(value: SettingsFileType) {
		switch (value) {
			case SettingsFileType.CashControl:
				return Res.Const.ENUM_SETTINGS_FILE_TYPE_CASH_CONTROL();
			case SettingsFileType.CardProcessor:
				return Res.Const.ENUM_SETTINGS_FILE_TYPE_CARD_PROCESSOR();
			case SettingsFileType.CardProcessorTablePayment:
				return Res.Const.ENUM_SETTINGS_FILE_TYPE_CARD_PROCESSOR_TABLE_PAYMENT();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SmartMenuOrderCommStatus {
	Disabled = 0,
	Enabled = 1,
	Suspended = 2
}

export namespace SmartMenuOrderCommStatus {
	export function toString(value: SmartMenuOrderCommStatus) {
		switch (value) {
			case SmartMenuOrderCommStatus.Disabled:
				return Res.Const.ENUM_SMART_MENU_ORDER_COMM_STATUS_DISABLED();
			case SmartMenuOrderCommStatus.Enabled:
				return Res.Const.ENUM_SMART_MENU_ORDER_COMM_STATUS_ENABLED();
			case SmartMenuOrderCommStatus.Suspended:
				return Res.Const.ENUM_SMART_MENU_ORDER_COMM_STATUS_SUSPENDED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SmartMenuOrderSettingsType {
	ScanAndPay = 0,
	Delivery = 1,
	TakeAway = 2,
	TableOrder = 3
}

export namespace SmartMenuOrderSettingsType {
	export function toString(value: SmartMenuOrderSettingsType) {
		switch (value) {
			case SmartMenuOrderSettingsType.ScanAndPay:
				return Res.Const.ENUM_SMART_MENU_ORDER_SETTINGS_TYPE_SCAN_AND_PAY();
			case SmartMenuOrderSettingsType.Delivery:
				return Res.Const.ENUM_SMART_MENU_ORDER_SETTINGS_TYPE_DELIVERY();
			case SmartMenuOrderSettingsType.TakeAway:
				return Res.Const.ENUM_SMART_MENU_ORDER_SETTINGS_TYPE_TAKE_AWAY();
			case SmartMenuOrderSettingsType.TableOrder:
				return Res.Const.ENUM_SMART_MENU_ORDER_SETTINGS_TYPE_TABLE_ORDER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SmartMenuPaymentEnvironment {
	Test = 0,
	Production = 1
}

export namespace SmartMenuPaymentEnvironment {
	export function toString(value: SmartMenuPaymentEnvironment) {
		switch (value) {
			case SmartMenuPaymentEnvironment.Test:
				return Res.Const.ENUM_SMARTMENUPAYMENT_TEST_ENVIRONMENT();
			case SmartMenuPaymentEnvironment.Production:
				return Res.Const.ENUM_SMARTMENUPAYMENT_PRODUCTION_ENVIRONMENT();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SoldProductTranslationPolicy {
	UpdatePrice = 0,
	KeepOriginalPrice = 1,
	AskUser = 2
}

export namespace SoldProductTranslationPolicy {
	export function toString(value: SoldProductTranslationPolicy) {
		switch (value) {
			case SoldProductTranslationPolicy.UpdatePrice:
				return Res.Const.ENUM_SOLD_PRODUCT_TRANSLATION_POLICY_UPDATE_PRICE();
			case SoldProductTranslationPolicy.KeepOriginalPrice:
				return Res.Const.ENUM_SOLD_PRODUCT_TRANSLATION_POLICY_KEEP_ORIGINAL_PRICE();
			case SoldProductTranslationPolicy.AskUser:
				return Res.Const.ENUM_SOLD_PRODUCT_TRANSLATION_POLICY_ASK_USER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum SoldProductType {
	Standard = 0,
	MenuHeader = 1,
	MenuItem = 2
}

export namespace SoldProductType {
	export function toString(value: SoldProductType) {
		switch (value) {
			case SoldProductType.Standard:
				return Res.Const.ENUM_SOLD_PRODUCT_TYPE_STANDARD();
			case SoldProductType.MenuHeader:
				return Res.Const.ENUM_SOLD_PRODUCT_TYPE_MENUHEADER();
			case SoldProductType.MenuItem:
				return Res.Const.ENUM_SOLD_PRODUCT_TYPE_MENUITEM();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum StockChangeFixMode {
	UpdateQuantities = 0,
	CreateLoss = 1
}

export namespace StockChangeFixMode {
	export function toString(value: StockChangeFixMode) {
		switch (value) {
			case StockChangeFixMode.UpdateQuantities:
				return Res.Const.ENUM_STOCK_CHANGE_FIX_MODE_UPDATE_QUANTITIES();
			case StockChangeFixMode.CreateLoss:
				return Res.Const.ENUM_STOCK_CHANGE_FIX_MODE_CREATE_LOSS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum StockChangeType {
	Variation = 0,
	Transfer = 1,
	Loss = 2
}

export namespace StockChangeType {
	export function toString(value: StockChangeType) {
		switch (value) {
			case StockChangeType.Variation:
				return Res.Const.ENUM_STOCK_CHANGE_TYPE_VARIATION();
			case StockChangeType.Transfer:
				return Res.Const.ENUM_STOCK_CHANGE_TYPE_TRANSFER();
			case StockChangeType.Loss:
				return Res.Const.ENUM_STOCK_CHANGE_TYPE_LOSS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum StockControlMode {
	No = 0,
	Yes = 1,
	Alternative = 2
}

export namespace StockControlMode {
	export function toString(value: StockControlMode) {
		switch (value) {
			case StockControlMode.No:
				return Res.Const.ENUM_STOCK_CONTROL_MODE_NO();
			case StockControlMode.Yes:
				return Res.Const.ENUM_STOCK_CONTROL_MODE_YES();
			case StockControlMode.Alternative:
				return Res.Const.ENUM_STOCK_CONTROL_MODE_ALTERNATIVE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum StopBits {
	None = 0,
	One = 1,
	Two = 2,
	OnePointFive = 3
}

export enum SupplierSearchMode {
	Default = 0,
	BestPurchaseCondition = 1,
	BestLastPurchasePrice = 2
}

export namespace SupplierSearchMode {
	export function toString(value: SupplierSearchMode) {
		switch (value) {
			case SupplierSearchMode.Default:
				return Res.Const.ENUM_SUPPLIER_SEARCH_DEFAULT_MODE();
			case SupplierSearchMode.BestPurchaseCondition:
				return Res.Const.ENUM_SUPPLIER_SEARCH_BEST_PURCHASE_CONDITION_MODE();
			case SupplierSearchMode.BestLastPurchasePrice:
				return Res.Const.ENUM_SUPPLIER_SEARCH_BEST_LAST_PURCHASE_PRICE_MODE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TemplateElementType {
	Image = 0,
	Text = 1
}

export enum TicketBAICertType {
	PhysicalPerson = 0,
	LegalPerson = 1
}

export namespace TicketBAICertType {
	export function toString(value: TicketBAICertType) {
		switch (value) {
			case TicketBAICertType.PhysicalPerson:
				return Res.Const.ENUM_TICKET_BAI_CERT_TYPE_PHYSICAL_PERSON();
			case TicketBAICertType.LegalPerson:
				return Res.Const.ENUM_TICKET_BAI_CERT_TYPE_LEGAL_PERSON();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TicketBAIEnvironment {
	Production = 0,
	Test = 1
}

export namespace TicketBAIEnvironment {
	export function toString(value: TicketBAIEnvironment) {
		switch (value) {
			case TicketBAIEnvironment.Production:
				return Res.Const.ENUM_TICKET_BAI_ENVIRONMENT_PRODUCTION();
			case TicketBAIEnvironment.Test:
				return Res.Const.ENUM_TICKET_BAI_ENVIRONMENT_TEST();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TicketBAIFiscalRegion {
	Alava = 0,
	Vizcaya = 1,
	Guipuzcoa = 2
}

export namespace TicketBAIFiscalRegion {
	export function toString(value: TicketBAIFiscalRegion) {
		switch (value) {
			case TicketBAIFiscalRegion.Alava:
				return Res.Const.ENUM_TICKET_BAI_FISCAL_REGION_ALAVA();
			case TicketBAIFiscalRegion.Vizcaya:
				return Res.Const.ENUM_TICKET_BAI_FISCAL_REGION_VIZCAYA();
			case TicketBAIFiscalRegion.Guipuzcoa:
				return Res.Const.ENUM_TICKET_BAI_FISCAL_REGION_GUIPUZCOA();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TicketBAITaxRegime {
	General = 1,
	Surcharge = 51,
	Simplified = 52
}

export namespace TicketBAITaxRegime {
	export function toString(value: TicketBAITaxRegime) {
		switch (value) {
			case TicketBAITaxRegime.General:
				return Res.Const.ENUM_TICKET_BAI_GENERAL_TAX_REGIMEN();
			case TicketBAITaxRegime.Surcharge:
				return Res.Const.ENUM_TICKET_BAI_SURCHARGE_TAX_REGIMEN();
			case TicketBAITaxRegime.Simplified:
				return Res.Const.ENUM_TICKET_BAI_SIMPLIFIED_TAX_REGIMEN();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TicketLineStatus {
	New = 0,
	PendingPreparation = 1,
	Cooking = 2,
	ReadyToServe = 3,
	Served = 4
}

export namespace TicketLineStatus {
	export function toString(value: TicketLineStatus) {
		switch (value) {
			case TicketLineStatus.New:
				return Res.Const.ENUM_TICKET_LINE_STATUS_NEW();
			case TicketLineStatus.PendingPreparation:
				return Res.Const.ENUM_TICKET_LINE_STATUS_PENDING_PREPARATION();
			case TicketLineStatus.Cooking:
				return Res.Const.ENUM_TICKET_LINE_STATUS_COOKING();
			case TicketLineStatus.ReadyToServe:
				return Res.Const.ENUM_TICKET_LINE_STATUS_READY_TO_SERVE();
			case TicketLineStatus.Served:
				return Res.Const.ENUM_TICKET_LINE_STATUS_SERVED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TicketType {
	VatNotIncluded = 0,
	VatIncluded = 1
}

export namespace TicketType {
	export function toString(value: TicketType) {
		switch (value) {
			case TicketType.VatNotIncluded:
				return Res.Const.ENUM_TICKET_TYPE_VAT_NOT_INCLUDED();
			case TicketType.VatIncluded:
				return Res.Const.ENUM_TICKET_TYPE_VAT_INCLUDED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TipSettingsMode {
	None = 0,
	Fixed = 1,
	Suggested = 2
}

export namespace TipSettingsMode {
	export function toString(value: TipSettingsMode) {
		switch (value) {
			case TipSettingsMode.None:
				return Res.Const.ENUM_TIP_SETTINGS_NONE_MODE();
			case TipSettingsMode.Fixed:
				return Res.Const.ENUM_TIP_SETTINGS_FIXED_MODE();
			case TipSettingsMode.Suggested:
				return Res.Const.ENUM_TIP_SETTINGS_SUGGESTED_MODE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TransferCostPricePolicy {
	OriginCostPrice = 0,
	WeightedAvgCostPrice = 2
}

export namespace TransferCostPricePolicy {
	export function toString(value: TransferCostPricePolicy) {
		switch (value) {
			case TransferCostPricePolicy.OriginCostPrice:
				return Res.Const.ENUM_TRANSFER_COST_PRICE_FROM_ORIGIN_POLICY();
			case TransferCostPricePolicy.WeightedAvgCostPrice:
				return Res.Const.ENUM_TRANSFER_COST_PRICE_AVG_COST_PRICE_POLICY();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum TransferState {
	Draft = 0,
	Sent = 1,
	Received = 2
}

export namespace TransferState {
	export function toString(value: TransferState) {
		switch (value) {
			case TransferState.Draft:
				return Res.Const.ENUM_TRANSFER_STATE_DRAFT();
			case TransferState.Sent:
				return Res.Const.ENUM_TRANSFER_STATE_SENT();
			case TransferState.Received:
				return Res.Const.ENUM_TRANSFER_STATE_RECEIVED();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum UsePreparationType {
	FromMain = 0,
	FromAddin = 1
}

export namespace UsePreparationType {
	export function toString(value: UsePreparationType) {
		switch (value) {
			case UsePreparationType.FromMain:
				return Res.Const.ENUM_USE_PREPARATION_TYPE_FROM_MAIN();
			case UsePreparationType.FromAddin:
				return Res.Const.ENUM_USE_PREPARATION_TYPE_FROM_ADDIN();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum UsePriceList {
	FromSaleCenter = 0,
	FromCustomer = 1,
	FromUser = 2
}

export enum ValueButtonSize {
	Small = 0,
	Medium = 1,
	Large = 2
}

export namespace ValueButtonSize {
	export function toString(value: ValueButtonSize) {
		switch (value) {
			case ValueButtonSize.Small:
				return Res.Const.ENUM_BUTTON_VALUE_SIZE_SMALL();
			case ValueButtonSize.Medium:
				return Res.Const.ENUM_BUTTON_VALUE_SIZE_MEDIUM();
			case ValueButtonSize.Large:
				return Res.Const.ENUM_BUTTON_VALUE_SIZE_LARGE();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum VatType {
	IVA = 0,
	IGIC = 1,
	IPSI = 2,
	Others = 3
}

export namespace VatType {
	export function toString(value: VatType) {
		switch (value) {
			case VatType.IVA:
				return Res.Const.ENUM_VAT_TYPE_IVA();
			case VatType.IGIC:
				return Res.Const.ENUM_VAT_TYPE_IGIC();
			case VatType.IPSI:
				return Res.Const.ENUM_VAT_TYPE_IPSI();
			case VatType.Others:
				return Res.Const.ENUM_VAT_TYPE_OTHERS();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum VerifactuDataInvoiceStatus {
	Pending = 0,
	Rejected = 1,
	Accepted = 2,
	AcceptedWithWarnings = 3,
	PendingRetry = 4
}

export namespace VerifactuDataInvoiceStatus {
	export function toString(value: VerifactuDataInvoiceStatus) {
		switch (value) {
			case VerifactuDataInvoiceStatus.Pending:
				return Res.Const.ENUM_VERIFACTU_DATA_INVOICE_STATUS_PENDING();
			case VerifactuDataInvoiceStatus.Rejected:
				return Res.Const.ENUM_VERIFACTU_DATA_INVOICE_STATUS_REJECTED();
			case VerifactuDataInvoiceStatus.Accepted:
				return Res.Const.ENUM_VERIFACTU_DATA_INVOICE_STATUS_ACCEPTED();
			case VerifactuDataInvoiceStatus.AcceptedWithWarnings:
				return Res.Const.ENUM_VERIFACTU_DATA_INVOICE_STATUS_ACCEPTED();
			case VerifactuDataInvoiceStatus.PendingRetry:
				return Res.Const.ENUM_VERIFACTU_DATA_INVOICE_STATUS_PENDING_RETRY();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum VerifactuEnvironment {
	Production = 0,
	Test = 1
}

export namespace VerifactuEnvironment {
	export function toString(value: VerifactuEnvironment) {
		switch (value) {
			case VerifactuEnvironment.Production:
				return Res.Const.ENUM_VERIFACTU_ENVIRONMENT_PRODUCTION();
			case VerifactuEnvironment.Test:
				return Res.Const.ENUM_VERIFACTU_ENVIRONMENT_TEST();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum WebPrintResultType {
	EscPos = 0,
	Rdl = 1,
	Label = 2
}

export enum WhenAskForFriendlyName {
	Never = 0,
	OnOpenTicket = 1,
	OnCloseTicket = 2
}

export namespace WhenAskForFriendlyName {
	export function toString(value: WhenAskForFriendlyName) {
		switch (value) {
			case WhenAskForFriendlyName.Never:
				return Res.Const.ENUM_WHEN_ASK_FOR_FRIENDLY_NAME_NEVER();
			case WhenAskForFriendlyName.OnOpenTicket:
				return Res.Const.ENUM_WHEN_ASK_FOR_FRIENDLY_NAME_ON_OPEN_TICKET();
			case WhenAskForFriendlyName.OnCloseTicket:
				return Res.Const.ENUM_WHEN_ASK_FOR_FRIENDLY_NAME_ON_CLOSE_TICKET();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum WhenAskForTableCompanions {
	Never = 0,
	OnOpenDocument = 1,
	OnCloseDocument = 2
}

export namespace WhenAskForTableCompanions {
	export function toString(value: WhenAskForTableCompanions) {
		switch (value) {
			case WhenAskForTableCompanions.Never:
				return Res.Const.ENUM_WHEN_ASK_FOR_TABLE_COMPANIONS_NEVER();
			case WhenAskForTableCompanions.OnOpenDocument:
				return Res.Const.ENUM_WHEN_ASK_FOR_TABLE_COMPANIONS_ON_OPEN_DOCUMENT();
			case WhenAskForTableCompanions.OnCloseDocument:
				return Res.Const.ENUM_WHEN_ASK_FOR_TABLE_COMPANIONS_ON_CLOSE_DOCUMENT();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum WhenPrint {
	Always = 0,
	Never = 1,
	AskUser = 2
}

export namespace WhenPrint {
	export function toString(value: WhenPrint) {
		switch (value) {
			case WhenPrint.Always:
				return Res.Const.ENUM_WHEN_PRINT_ALWAYS();
			case WhenPrint.Never:
				return Res.Const.ENUM_WHEN_PRINT_NEVER();
			case WhenPrint.AskUser:
				return Res.Const.ENUM_WHEN_PRINT_ASK_USER();
			default:
				return 'UNKNOWN';
		}
	}
}

export enum WorkplaceUpdateStatus {
	Ok = 0,
	Pending = 1,
	Updating = 2
}

export class AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.AbstractMessage';
	IsBlocking = false;
	OutOfBandMessages: OutOfBandMessageDTO[];
	Sender: SenderDTO;
	constructor(_params: {
		sender?: SenderDTO,
		outOfBandMessages?: OutOfBandMessageDTO[]
	}) {
		this.Sender = null as any;
		this.OutOfBandMessages = [];
	}
}

export interface ActionButtonDefinitionDTO {
	ActionId: string;
	Category: ActionButtonCategory;
	DarkImageAsBase64: string;
	LightImageAsBase64: string;
	PosTypes: PosType[];
	Text: string;
	Visibility: ActionButtonVisibility[];
}

export interface ActionButtonReferenceDTO {
	ActionId: string;
	Category: ActionButtonCategory;
}

export interface ActionDisplayProfileForEditionDTO {
	ExistingPagerModes: PagerMode[];
	ExistingScrollbarMode: ScreenScrollMode[];
	ExistingValueButtonSizes: ValueButtonSize[];
	Id: number;
	MainViewOtherButtonColumns: number;
	MainViewOtherButtonRows: number;
	MainViewQuickButtonColumns: number;
	MainViewQuickButtonRows: number;
	Name: string;
	NumberOfProductGroupRows: number;
	NumberOfTicketLines: Nullable<number>;
	OtherActions: string[];
	PagerMode: PagerMode;
	QuickActions: string[];
	ScrollbarMode: ScreenScrollMode;
	SelectLocationActions: string[];
	SelectSaleLocationViewButtonColumns: number;
	SelectSaleLocationViewButtonRows: number;
	Type: PosType;
	ValueButtonSize: ValueButtonSize;
}

export interface ActionDisplayProfileInListDTO {
	Id: number;
	Name: string;
	Type: PosType;
	ValueButtonSize: ValueButtonSize;
}

export interface AddinRoleDTO {
	AdditionMode: AddinRoleAdditionMode;
	AllowRepeat: boolean;
	Id: number;
	MaxAddins: number;
	MinAddins: number;
	Name: string;
	UsePreparationType: UsePreparationType;
}

export interface AddinRoleForEditionDTO {
	Addins: SaleFormatInListDTO[];
	AdditionMode: AddinRoleAdditionMode;
	AllowRepeat: boolean;
	Id: number;
	Max: number;
	Min: number;
	Name: TranslatableStringDTO;
	UsePreparationType: UsePreparationType;
}

export interface AdditionalEpigraphDTO {
	Category: CategoryInListDTO;
	Epigraph: string;
}

export interface AddPosGroupToMultipleSaleCentersParamsDTO {
	PosGroup: PosGroupInListDTO;
	SaleCenters: SaleCenterForEditionDTO[];
}

export interface AddPosGroupToMultipleWarehousesParamsDTO {
	PosGroup: PosGroupInListDTO;
	Warehouses: WarehouseForEditionDTO[];
}

export interface AddressDTO {
	City: string;
	Region: string;
	Street: string;
	ZipCode: string;
}

export interface AddressLocationDTO {
	Latitude: number;
	Longitude: number;
}

export interface AdyenSettingsDTO {
	ApiKey: string;
	ClientKey: string;
	ExternalApiBaseUrl: string;
	ExternalWebhookHmac: string;
	GoogleMerchantId: string;
	MerchantAccount: string;
	Store: string;
}

export interface AgoraPaymentsSalesByDayDTO {
	AdyenExternal: number;
	AdyenInternal: number;
	AdyenTotal: number;
	AgoraExternal: number;
	AgoraInternal: number;
	AgoraTotal: number;
	Day: Date;
	Tips: number;
}

export interface AgoraPaymentsTransactionDetailsDTO {
	Amount: number;
	AuditEvents: AuditEventDTO[];
	CardType: string;
	Date: Date;
	DocumentNumber: number;
	DocumentSerie: string;
	Error: AgoraPaymentsTransactionError;
	OriginalPSP: string;
	PSP: string;
	Status: string;
	TicketGlobalId: string;
}

export interface AgoraPaymentsTransactionSummaryDTO {
	Amount: number;
	Date: Date;
	Error: AgoraPaymentsTransactionError;
	PSP: string;
	Status: string;
}

export interface AgoraPayoutByDayDTO {
	Adjustment: number;
	BatchNumber: number;
	Cost: number;
	ExternalRefunds: number;
	ExternalSales: number;
	PayoutDate: Date;
	Reference: string;
	Refunds: number;
	SaleDate: Nullable<Date>;
	Sales: number;
}

export interface AgoraPayoutsReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	ErrorMessage: string;
	From: Date;
	Payouts: AgoraPayoutByDayDTO[];
	To: Date;
}

export interface AllergenDTO {
	Id: number;
	ImageContent: string;
	ImageId: string;
	Name: string;
}

export interface AllergenForEditionDTO {
	Id: number;
	ImageContent: string;
	ImageId: string;
	Name: TranslatableStringDTO;
}

export interface AllergenInListDTO {
	Id: number;
	ImageContent: string;
	Name: string;
}

export interface AlternativeStockProductDTO {
	CategorySummary: string;
	FamilyName: string;
	Id: number;
	Name: string;
}

export interface AppliedServiceChargeDTO {
	ApplyTo: TicketType;
	ChargePercentage: number;
	ChargeTax: VatDTO;
	IgnoreTicketDiscounts: boolean;
}

export interface AppointmentForEditionDTO {
	Customer: CustomerDetailsDTO;
	Date: Date;
	ExistingLocations: TicketLocationDTO[];
	ExistingStatuses: AppointmentStatus[];
	Guests: Nullable<number>;
	Id: number;
	Location: TicketLocationDTO;
	Notes: string;
	Status: AppointmentStatus;
}

export interface AppointmentInListDTO {
	Customer: string;
	Date: Date;
	Guests: Nullable<number>;
	Id: number;
	Notes: string;
	SaleLocation: string;
	Status: AppointmentStatus;
}

export interface AppointmentsByDayDTO {
	Companions: number;
	Customer: string;
	Date: Date;
	Id: number;
	Location: string;
	Status: AppointmentStatus;
	StatusName: string;
	Workplace: string;
}

export interface AppointmentsByDayReportDTO {
	Appointments: AppointmentsByDayDTO[];
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	To: Date;
}

export interface AttachmentDTO {
	BinaryData: string;
	FileName: string;
}

export interface AuditEventDTO {
	Action: string;
	ApplicationName: string;
	Details: string;
	Id: number;
	MachineName: string;
	ParentTicketGlobalId: Nullable<string>;
	PosId: Nullable<number>;
	PosName: string;
	TicketGlobalId: Nullable<string>;
	Time: Date;
	Type: AuditEventType;
	TypeDescription: string;
	UserId: Nullable<number>;
	UserName: string;
}

export interface AuditEventTypeDTO {
	Description: string;
	Id: number;
}

export interface AuditMonitorOptionsDTO {
	From: Date;
	PointOfSaleIds: number[];
	To: Date;
	Types: AuditEventType[];
	UserIds: number[];
}

export interface AuditQueryDTO {
	Events: AuditEventTypeDTO[];
	IsReadOnly: boolean;
	Name: string;
	OriginalName: string;
}

export interface AutoInvoiceEmailOptionsDTO {
	Body: string;
	Email: string;
	HasAutoInvoice: boolean;
	HasEmailAccount: boolean;
	InvoiceId: number;
	Subject: string;
}

export interface AvailableUserDTO {
	Id: number;
	Name: string;
	RequiresPassword: boolean;
	Style: StyleDTO;
}

export interface BackupInfoDTO {
	Date: Date;
	Name: string;
	Size: number;
}

export interface BackupSettingsDTO {
	AutoCreateBackup: boolean;
	FixedHoursAsString: string;
	MaxRollBackupsNumber: number;
}

export interface BalanceReportOptionsDTO {
	IncludeCancellationsByUser: boolean;
	IncludeDeliveryPersonsStatus: boolean;
	IncludeDiscrepancyAmount: boolean;
	IncludeFamilySales: boolean;
	IncludeInvitationsByUser: boolean;
	IncludePaymentTips: boolean;
	IncludePendingOperations: boolean;
	IncludeProductReturns: boolean;
	IncludeProductSales: boolean;
	IncludeSaleCenterSales: boolean;
	IncludeTableCompanionsSummary: boolean;
	IncludeUserPayments: boolean;
	IncludeUserSales: boolean;
	IncludeVerificationCode: boolean;
	UseDeliveryNoteData: boolean;
}

export interface BuyerCustomerDTO {
	Address: AddressDTO;
	ApplySurcharge: boolean;
	BusinessName: string;
	Cif: string;
	CountryCode: string;
	DiscountRate: number;
	FiscalName: string;
	Id: number;
}

export interface CalculatedCostPriceDTO {
	IsStockProduct: boolean;
	NewCostPrice: number;
	OldCostPrice: number;
	ProductId: number;
	ProductName: string;
}

export interface CancellationsByUserAndProductReportDTO {
	Cancellations: CancellationsByUserReportDTO[];
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	To: Date;
}

export interface CancellationsByUserAndTypeReportDTO {
	Cancellations: CancellationsByUserReportDTO[];
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	To: Date;
}

export interface CancellationsByUserReportDTO {
	CancellationAmount: number;
	Date: Date;
	Document: string;
	IsPrepared: boolean;
	IsPrinted: boolean;
	ProductId: number;
	ProductName: string;
	Quantity: number;
	Reason: string;
	UserId: number;
	UserName: string;
}

export interface CanChangeInvoicePaymentResultDTO {
	CanChange: boolean;
	Reason: string;
}

export interface CanReopenDeliveryNoteResultDTO {
	CanReopen: boolean;
	Message: string;
}

export interface CardTransactionDTO {
	TransactionId: string;
	TransactionType: CardTransactionType;
	XmlDetails: string;
}

export interface CashControlStatusDTO {
	CoinsValues: number;
	NotesValues: number;
	RemainingChange: number;
	TotalValues: number;
}

export interface CashTransactionDTO {
	Amount: number;
	BusinessDay: Date;
	Description: string;
	Id: number;
	Pos: string;
	Provider: string;
	User: string;
}

export interface CashTransactionsReportDTO {
	CashTransactions: CashTransactionDTO[];
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	To: Date;
}

export interface CategoryByUserDTO {
	Id: number;
	Name: string;
	ParentCategoryId: number;
	Tags: string[];
}

export interface CategoryDataSheetForEditionDTO {
	ImageContent: string;
	ImageId: string;
}

export interface CategoryForEditionDTO {
	CategoryDataSheet: CategoryDataSheetForEditionDTO;
	ExistingParentCategories: CategoryInListDTO[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingSaleCenters: SaleCenterInListDTO[];
	ExistingTags: string[];
	ExtraInfo: DigitalMenuItemExtraInfoForEditionDTO;
	Id: number;
	Name: TranslatableStringDTO;
	ParentCategory: CategoryInListDTO;
	Products: ProductInGroupDTO[];
	Schedules: CategoryScheduleDTO[];
	ShowInMenuConfiguration: boolean;
	ShowInPos: boolean;
	Style: StyleForEditionDTO;
	Tags: string[];
	ValidForAllPosGroups: boolean;
	ValidForAllSaleCenters: boolean;
	ValidPosGroups: PosGroupInListDTO[];
	ValidSaleCenters: SaleCenterInListDTO[];
}

export interface CategoryInListDTO {
	GroupsSummary: string;
	Id: number;
	Name: string;
	ParentCategory: string;
	ParentCategoryId: number;
	ShowInMenuConfiguration: boolean;
	ShowInPos: boolean;
	Tags: string[];
	TagsSummary: string;
	WorkplacesSummary: string;
}

export interface CategoryInProductDTO {
	Id: number;
	Name: string;
	Tags: string[];
}

export interface CategoryScheduleDTO {
	EndTime: Date;
	Friday: boolean;
	Monday: boolean;
	Saturday: boolean;
	StartTime: Date;
	Sunday: boolean;
	Thursday: boolean;
	Tuesday: boolean;
	Wednesday: boolean;
}

export interface CertificateInfoDTO {
	Issuer: string;
	MachineId: string;
	NotAfter: Date;
	NotBefore: Date;
	SerialNumber: string;
	SignatureAlgorithm: string;
	Subject: string;
	Thumbprint: string;
	Version: string;
	Workplace: string;
}

export interface ChangePricesByMarginsParamsDTO {
	Percentage: number;
	Role: SaleFormatRole;
	RoundFactor: Nullable<number>;
	Type: ProductMarginModificationType;
}

export interface ChangePricesParamsDTO {
	Amount: number;
	Mode: ProductRoleToModify;
	PriceList: string;
	RoundFactor: Nullable<number>;
	Type: PriceModificationType;
}

export interface CheckRequiredCustomerResultDTO {
	ErrorMessage: string;
	IsValid: boolean;
}

export interface ClipartDTO {
	Image: string;
	Name: string;
}

export interface ClockingDTO {
	Date: Nullable<Date>;
	Pos: PosInListDTO;
	Time: Nullable<Date>;
}

export interface ClockingUserDTO {
	CanClockingWithCardNumber: boolean;
	CanClockingWithPassword: boolean;
	CanModifyClockInDateTime: boolean;
	CanModifyClockOutDateTime: boolean;
	Id: number;
	Name: string;
	RequiresPassword: boolean;
	ShowInClockings: boolean;
	Style: StyleDTO;
}

export interface ClosingQuantityDTO {
	Quantity: number;
	TicketLineId: number;
}

export interface ColorDTO {
	Id: number;
	Name: string;
	Priority: number;
	Value: string;
}

export interface ColorForEditionDTO {
	Id: number;
	Name: TranslatableStringDTO;
	Value: string;
}

export interface ColorsForEditionDTO {
	AvailableLanguageCodes: string[];
	Colors: ColorForEditionDTO[];
}

export interface CompanyDTO {
	Address: AddressDTO;
	BusinessName: string;
	Cif: string;
	Contact: string;
	Email: string;
	FiscalName: string;
	Id: number;
	IsEditable: boolean;
	Telephone: string;
	Web: string;
}

export interface ContactPersonDTO {
	Address: AddressDTO;
	Email: string;
	Id: number;
	Name: string;
	Telephone: string;
	Warehouses: WarehouseInListDTO[];
}

export interface ConvertToStandardInvoiceParamsFromAdminDTO {
	BusinessDay: Date;
	Customer: BuyerCustomerDTO;
	PosId: number;
}

export interface ConvertToStandardInvoiceParamsFromPosDTO {
	Customer: BuyerCustomerDTO;
}

export interface CoordinateDTO {
	Latitude: number;
	Longitude: number;
}

export interface CopyPricesParamsDTO {
	FromPriceList: string;
	Mode: ProductRoleToModify;
	ToPriceList: string;
}

export interface CostPriceByWarehouseDTO {
	CostPrice: number;
	WarehouseId: number;
	WarehouseName: string;
}

export interface CouponPrintTemplateForEditionDTO {
	Elements: TemplateElementDTO[];
	Id: number;
	InstalledPrinters: string[];
	Name: string;
	NumberOfColumns: number;
}

export interface CouponPrintTemplateInListDTO {
	Id: number;
	Name: string;
	NumberOfColumns: number;
}

export interface CouponSettingsForEditionDTO {
	ConsumedBy: SaleFormatInListDTO;
	CreatedBy: SaleFormatInListDTO;
	DurationInDays: Nullable<number>;
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingPrintTemplates: CouponPrintTemplateInListDTO[];
	Id: number;
	Name: string;
	PrintTemplate: CouponPrintTemplateInListDTO;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface CouponSettingsInListDTO {
	ConsumedBy: string;
	CreatedBy: string;
	DurationInDays: number;
	GroupsSummary: string;
	Id: number;
	Name: string;
	WorkplacesSummary: string;
}

export interface CourseDTO {
	Addins: string[];
	Family: string;
	Notes: string[];
	PreparationOrder: PreparationOrderDTO;
	Product: string;
	Quantity: number;
}

export interface CreateDeliveryNoteFromSalesOrderFromAdminParamsDTO {
	BusinessDay: Date;
	InternalOrderServeMode: InternalOrderServeMode;
	PosId: number;
	QuantityByProductLine: QuantityLineDTO[];
	SalesOrderIds: number[];
}

export interface CreateDeliveryNoteFromSalesOrderParamsFromPosDTO {
	InternalOrderServeMode: InternalOrderServeMode;
	QuantityByProductLine: QuantityLineDTO[];
	SalesOrderIds: number[];
}

export interface CsvLabelsFormatDTO {
	Header: string;
	Lines: string[];
}

export interface CurrentActionDisplayProfileDTO {
	ButtonSize: ValueButtonSize;
	MainViewOtherButtonColumns: number;
	MainViewOtherButtonRows: number;
	MainViewQuickButtonColumns: number;
	MainViewQuickButtonRows: number;
	NumberOfProductGroupRows: number;
	NumberOfTicketLines: Nullable<number>;
	OtherActions: ActionButtonReferenceDTO[];
	PagerMode: PagerMode;
	QuickActions: ActionButtonReferenceDTO[];
	ScreenScrollMode: ScreenScrollMode;
	SelectSaleLocationActions: ActionButtonReferenceDTO[];
	SelectSaleLocationViewButtonColumns: number;
	SelectSaleLocationViewButtonRows: number;
	Type: PosType;
}

export interface CurrentStockDTO {
	Color: ColorDTO;
	Location: string;
	ProductId: number;
	ProductName: string;
	Size: SizeDTO;
	Stock: number;
	WarehouseId: number;
	WarehouseName: string;
}

export interface CustomActionButtonCommandDTO {
	ActionType: CustomActionType;
	ArgumentId: Nullable<number>;
	CommandValue: string;
	HasPermission: boolean;
	IsAdvancedDirectPayment: boolean;
	ShowUrlInEmbeddedViewer: boolean;
}

export interface CustomActionButtonForEditionDTO {
	ActionType: CustomActionType;
	AllowAdvancedDirectPayment: boolean;
	Category: ActionButtonCategory;
	Command: string;
	DarkImage: string;
	DirectPayment: PaymentMethodInListDTO;
	ExistingActionCategories: ActionButtonCategory[];
	ExistingActionTypes: CustomActionType[];
	ExistingNamedDiscounts: NamedDiscountInListDTO[];
	ExistingOffers: OfferInListDTO[];
	ExistingPaymentMethods: PaymentMethodInListDTO[];
	ExistingPriceLists: PriceListInListDTO[];
	Id: number;
	LightImage: string;
	NamedDiscount: NamedDiscountInListDTO;
	Offer: OfferInListDTO;
	PriceList: PriceListInListDTO;
	ShowUrlInEmbeddedViewer: boolean;
	Text: TranslatableStringDTO;
}

export interface CustomActionButtonInListDTO {
	ActionType: CustomActionType;
	Command: string;
	Id: number;
	Text: string;
}

export interface CustomerDetailsDTO {
	AccountCode: string;
	Address: AddressDTO;
	ApplySurcharge: boolean;
	BusinessName: string;
	CardNumber: string;
	Cif: string;
	ContactPerson: string;
	CountryCode: string;
	DiscountRate: number;
	Email: string;
	FiscalName: string;
	Id: number;
	Notes: string;
	Offers: CustomerOfferDTO[];
	ParentCustomerId: number;
	PriceList: string;
	SendMailing: boolean;
	ShowNotes: boolean;
	Telephone: string;
	Type: CustomerTypeInListDTO;
}

export interface CustomerDisplayConfigurationDTO {
	DisplayType: CustomerDisplayType;
	PortConfig: SerialPortConfigurationDTO;
	ScreenImageContent: string;
	ScreenImageId: string;
	ScreenSaverImageContent: string;
	ScreenSaverImageId: string;
	ScreenSaverType: ScreenSaverType;
	ScreenSaverUrl: string;
	ScreenSaverWaitTimeInSeconds: number;
	ScreenShowLineNotes: boolean;
	ShowScreenSaver: boolean;
}

export interface CustomerForEditionDTO {
	AccountCode: string;
	Address: AddressDTO;
	ApplySurcharge: boolean;
	BusinessName: string;
	CardNumber: string;
	Cif: string;
	ContactPerson: string;
	CountryCode: string;
	DeliveryAddresses: AddressDTO[];
	DiscountPercentage: number;
	DocumentIdType: CustomerDocumentIdType;
	Email: string;
	ExistingCountryCodes: string[];
	ExistingDocumentIdTypes: CustomerDocumentIdType[];
	ExistingOffers: OfferInListDTO[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingPriceLists: PriceListInListDTO[];
	ExistingTypes: CustomerTypeInListDTO[];
	FiscalName: string;
	Id: number;
	Notes: string;
	Offers: CustomerOfferDTO[];
	ParentCustomer: CustomerInListDTO;
	PriceList: PriceListInListDTO;
	RequireIdentificationCard: boolean;
	SendMailing: boolean;
	ShowNotes: boolean;
	SpecialPrices: CustomerSpecialPriceForCustomerEditionDTO[];
	Telephone: string;
	Type: CustomerTypeInListDTO;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface CustomerForEmailingDTO {
	CustomerEmail: string;
	CustomerFiscalName: string;
	CustomerId: number;
}

export interface CustomerInListDTO {
	AccountCode: string;
	Address: AddressDTO;
	BusinessName: string;
	CardNumber: string;
	Cif: string;
	ContactPerson: string;
	CountryCode: string;
	Email: string;
	FiscalName: string;
	GroupsSummary: string;
	Id: number;
	ParentCustomer: string;
	ParentCustomerId: number;
	SendMailing: boolean;
	Telephone: string;
	Type: string;
	WorkplacesSummary: string;
}

export interface CustomerOfferDTO {
	MaxApplicationsPerBusinessDay: Nullable<number>;
	Offer: OfferInListDTO;
}

export interface CustomerPreparationDTO {
	Date: Nullable<Date>;
	Location: string;
	OrderNumber: Nullable<number>;
	OrderSerie: string;
	OrderType: Nullable<SalesOrderType>;
	PreparationNumber: Nullable<number>;
	SaleCenterId: number;
	TicketId: number;
}

export interface CustomerPurchasesDTO {
	CustomerFiscalName: string;
	CustomerId: number;
	GrossPurchases: number;
	NetPurchases: number;
	TicketCount: number;
}

export interface CustomerPurchasesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Purchases: CustomerPurchasesDTO[];
	To: Date;
}

export interface CustomerSpecialPriceForCustomerEditionDTO {
	Addin: Nullable<number>;
	FamilyName: string;
	Main: Nullable<number>;
	MenuItem: Nullable<number>;
	ProductName: string;
	SaleFormatId: number;
}

export interface CustomerSpecialPriceForSaleFormatEditionDTO {
	Addin: Nullable<number>;
	CustomerId: number;
	CustomerName: string;
	Main: Nullable<number>;
	MenuItem: Nullable<number>;
}

export interface CustomerTypeForEditionDTO {
	Id: number;
	Name: string;
}

export interface CustomerTypeInListDTO {
	Id: number;
	Name: string;
}

export interface CustomQueryColumnDTO {
	Alignment: CustomQueryColumnAlignment;
	Fixed: boolean;
	Format: string;
	Href: string;
	Label: string;
	Name: string;
	RequiredModule: string;
	Totalizer: CustomQueryColumnTotalizer;
	Width: number;
}

export interface CustomQueryInMenuDTO {
	Group: string;
	Guid: string;
	InstallationTypes: InstallationType[];
	Name: string;
	ShowInAdmin: boolean;
}

export interface CustomQueryParamControlDTO {
	ExistingValues: any[];
	Param: CustomQueryParamDTO;
}

export interface CustomQueryParamDTO {
	CustomValue: string;
	Label: string;
	MultipleValue: boolean;
	Name: string;
	Required: boolean;
	Type: CustomQueryParamType;
}

export interface CustomQueryResultDTO {
	Columns: CustomQueryColumnDTO[];
	Data: any[];
	RowStyles: CustomQueryRowStyleDTO[];
}

export interface CustomQueryRowStyleDTO {
	ColumnName: string;
	CssClass: string;
	EqualsTo: string;
}

export interface DailyFiscalSummaryDTO {
	BusinessDay: Date;
	GrossAmount: number;
	NetAmount: number;
	Number: number;
	Serie: string;
	SurchargeAmount: number;
	SurchargeRate: number;
	TaxAmount: number;
	VatRate: number;
}

export interface DailyFiscalSummaryReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Summaries: DailyFiscalSummaryDTO[];
	To: Date;
}

export interface DataToPrintTestDTO {
	CouponTemplates: CouponPrintTemplateForEditionDTO[];
	EscPosTemplates: EscPosTemplateForEditionDTO[];
	InstalledPrinters: string[];
	RdlTemplates: RdlTemplateForEditionDTO[];
}

export interface DefaultLocationDTO {
	SaleCenterFullName: string;
	SaleCenterId: number;
	SaleCenterName: string;
	SaleLocationName: string;
}

export interface DefaultLocationInSessionDTO {
	GoToDefaultLocation: boolean;
	Location: TicketLocationDTO;
	OnSelectLocationAction: OnSelectLocationAction;
}

export interface DeliveryAreaDTO {
	Coordinates: CoordinateDTO[];
	DeliveryTimeInMinutes: number;
	Id: number;
	MinOrderAmount: number;
	Name: string;
	ShippingCost: number;
	ShippingSaleFormat: SaleFormatInListDTO;
}

export interface DeliveryNoteDetailsDTO {
	AuditEvents: AuditEventDTO[];
	DeliveryNote: DeliveryNoteInListDTO;
	Previews: PrintPreviewDTO[];
}

export interface DeliveryNoteDraftDTO {
	DeliveryAddress: AddressDTO;
	Notes: string;
	SerialNumber: SerialNumberDTO;
}

export interface DeliveryNoteDTO {
	AppliedServiceChargeSurchargeRate: number;
	AppliedServiceChargeVatRate: number;
	CreationDate: Date;
	Customer: BuyerCustomerDTO;
	CustomerDocumentNumber: string;
	CustomerPhone: string;
	Id: number;
	Location: string;
	NetAmount: number;
	Notes: string;
	Number: number;
	PendingAmount: number;
	PosId: number;
	PosName: string;
	PrepaidAmount: number;
	Serie: string;
	ServiceChargeGross: number;
	TableCompanions: Nullable<number>;
	TicketGlobalId: Nullable<string>;
	TicketId: number;
	TicketType: TicketType;
	User: string;
}

export interface DeliveryNoteFromInternalOrdersDTO {
	ExistingServeModes: InternalOrderServeMode[];
	InternalOrderServeMode: InternalOrderServeMode;
	PosId: number;
	QuantityByProductLine: QuantityByProductLineDTO[];
	SalesOrders: RelatedOrderDTO[];
}

export interface DeliveryNoteInListDTO {
	ApplySurcharge: boolean;
	BusinessDay: Date;
	CreationDate: Date;
	CustomerAccountCode: string;
	CustomerBusinessName: string;
	CustomerCif: string;
	CustomerCity: string;
	CustomerCountryCode: string;
	CustomerDiscountRate: number;
	CustomerDocumentNumber: string;
	CustomerEmail: string;
	CustomerFiscalName: string;
	CustomerId: number;
	CustomerPhone: string;
	CustomerRegion: string;
	CustomerStreet: string;
	CustomerZipCode: string;
	FrozenDate: Nullable<Date>;
	GrossAmount: number;
	Id: number;
	InvoiceDate: Nullable<Date>;
	InvoiceId: number;
	InvoiceNumber: number;
	InvoiceSerie: string;
	IsForTraining: boolean;
	NetAmount: number;
	Number: number;
	PendingAmount: number;
	Pos: string;
	PosId: number;
	PrepaidAmount: number;
	SaleCenter: string;
	SaleLocation: string;
	Serie: string;
	SurchageAmount: number;
	TableCompanions: Nullable<number>;
	TaxAmount: number;
	TicketId: number;
	TicketType: TicketType;
	User: string;
	Workplace: string;
}

export interface DeliveryNoteLineDetailsDTO {
	BusinessDay: Date;
	CashDiscount: number;
	CostPrice: number;
	CustomerAccountCode: string;
	CustomerCif: string;
	CustomerCity: string;
	CustomerCountryCode: string;
	CustomerFiscalName: string;
	CustomerRegion: string;
	CustomerStreet: string;
	CustomerZipCode: string;
	DeliveryNoteCreationDate: Date;
	DeliveryNoteId: number;
	DiscountCode: string;
	DiscountPercentage: number;
	Family: string;
	Frozen: boolean;
	GrossAmount: number;
	InvoiceBusinessDay: Nullable<Date>;
	InvoiceCreationDate: Nullable<Date>;
	InvoiceId: Nullable<number>;
	InvoiceNumber: Nullable<number>;
	InvoiceSerie: string;
	IsLine: boolean;
	LineType: SoldProductType;
	MajorGroup: string;
	NetAmount: number;
	Number: number;
	OfferCode: string;
	Pos: string;
	ProductPrice: number;
	Quantity: number;
	SaleCenter: string;
	SaleFormat: string;
	SaleLocation: string;
	Serie: string;
	SurchargePercentage: number;
	TicketCashDiscount: number;
	TicketDiscountPercentage: number;
	UserName: string;
	VatPercentage: number;
	Workplace: string;
}

export interface DeliveryNoteParamsFromPosDTO {
	CustomerDocumentNumber: string;
	DeliveryAddress: AddressDTO;
	DraftSerialNumber: SerialNumberDTO;
	InvoiceCanBeEmitted: boolean;
	IsRefund: boolean;
	Payments: PaymentDTO[];
	PrepayAmount: number;
	Reason: string;
	RelatedSalesOrders: SalesOrderDTO[];
	ShouldPrint: boolean;
}

export interface DeliveryNotesSummaryDTO {
	DeliveryNotesCount: number;
	Descriptions: string[];
	FromBusinessDay: Date;
	IncludeSummaryDeliveryNotes: boolean;
	ToBusinessDay: Date;
	TotalGrossAmount: number;
	TotalNetAmount: number;
	TotalPendingAmount: number;
	TotalPrepaidAmount: number;
	TotalSurchargeAmount: number;
	TotalTaxAmount: number;
}

export interface DeliveryPersonDTO {
	Balance: number;
	DeliveredOrders: number;
	DeliveringOrders: number;
	UseDeliveryPlatform: boolean;
	UserBackColor: string;
	UserId: number;
	UserImageId: string;
	UserName: string;
}

export interface DigitalMenuByWorkplaceSettingsForEditionDTO {
	AdditionalInfo: string;
	DigitalMenu: DigitalMenuInListDTO;
	Workplace: WorkplaceInListDTO;
}

export interface DigitalMenuForEditionDTO {
	AdditionalPriceList1: PriceListInListDTO;
	AdditionalPriceList2: PriceListInListDTO;
	BackColor: string;
	Categories: CategoryInListDTO[];
	Color: string;
	CSSContent: string;
	Description: string;
	ExistingCategories: CategoryInListDTO[];
	ExistingPriceLists: PriceListInListDTO[];
	ExpectedOwnerMachineId: string;
	FooterText: string;
	HeaderImage: string;
	Id: number;
	ISOCode: string;
	Name: string;
	OwnerMachineId: string;
	PaymentConfirmationText: string;
	PriceList: PriceListInListDTO;
	ShowAddins: boolean;
	ShowAllergens: boolean;
	SmartMenuPaymentEnabled: boolean;
	SmartMenuUrl: string;
	SuggestedCategory: CategoryInListDTO;
	SuggestedCategoryInfoText: string;
	TermsAndConditions: string;
}

export interface DigitalMenuInListDTO {
	AdditionalPriceList1: PriceListInListDTO;
	AdditionalPriceList2: PriceListInListDTO;
	GlobalId: string;
	HasLicense: boolean;
	HasValidLink: boolean;
	Id: number;
	Name: string;
	PriceList: PriceListInListDTO;
	SmartMenuUrl: string;
}

export interface DigitalMenuItemExtraInfoForEditionDTO {
	Name: string;
	Text: string;
}

export interface DigitalMenuResourceItemForEditionDTO {
	Text: string;
	Translations: string[];
}

export interface DigitalMenuResourcesForEditionDTO {
	ExistingLanguages: LanguageDTO[];
	Items: DigitalMenuResourceItemForEditionDTO[];
	Languages: LanguageDTO[];
	ReferenceLanguageCode: string;
}

export interface DisabledLocationsDTO {
	Message: string;
	SaleLocations: string[];
}

export interface DiscountsByUserAndProductDTO {
	BusinessDay: Date;
	DiscountGrossAmount: number;
	DiscountNetAmount: number;
	DiscountType: string;
	DiscountValue: number;
	InvoiceNumber: number;
	InvoiceSerie: string;
	Price: number;
	Quantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	UserId: number;
	UserName: string;
}

export interface DiscountsByUserAndProductReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	Discounts: DiscountsByUserAndProductDTO[];
	From: Date;
	To: Date;
}

export interface DiscountsByUserAndTypeDTO {
	DiscountAmount: number;
	DiscountCount: number;
	DiscountName: string;
	DiscountType: string;
	UserId: number;
	UserName: string;
}

export interface DiscountsByUserAndTypeReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	Discounts: DiscountsByUserAndTypeDTO[];
	From: Date;
	To: Date;
}

export interface DocumentEmailOptionsDTO {
	Body: string;
	DocumentId: number;
	Email: string;
	ExistingTemplates: PrintTemplateInListDTO[];
	HasEmailAccount: boolean;
	Subject: string;
	Template: PrintTemplateInListDTO;
}

export interface DocumentLineDTO {
	CashDiscount: number;
	DiscountPercentage: number;
	Price: number;
	Quantity: number;
	SurchargeRate: number;
	VatId: number;
	VatRate: number;
}

export interface DocumentPaymentDTO {
	Amount: number;
	ChangeAmount: number;
	Date: Date;
	ExtraInformation: string;
	HasCardTransaction: boolean;
	Id: number;
	IsCash: boolean;
	Method: string;
	TipAmount: number;
}

export interface DocumentTotalDTO {
	GrossAmount: number;
	NetAmount: number;
	SurchargeAmount: number;
	TaxAmount: number;
	Taxes: TaxDTO[];
}

export interface EmailAccountByUserDTO {
	Id: number;
	Name: string;
}

export interface EmailAccountForEditionDTO {
	Address: string;
	AssignedWorkplaces: WorkplaceInListDTO[];
	EnableSsl: boolean;
	ExistingWorkplaces: WorkplaceInListDTO[];
	Id: number;
	Name: string;
	Password: string;
	Port: number;
	Smtp: string;
	User: string;
}

export interface EmailAccountInListDTO {
	Address: string;
	Id: number;
	Name: string;
	Smtp: string;
}

export interface EmailDeliveryDTO {
	CustomerEmail: string;
	CustomerFiscalName: string;
	ErrorMessage: string;
	Result: EmailDeliveryResult;
	SendDate: Nullable<Date>;
}

export interface EmailingForEditionDTO {
	Content: string;
	EmailAccount: EmailAccountByUserDTO;
	ExistingEmailAccounts: EmailAccountByUserDTO[];
	FooterImage: string;
	HeaderImage: string;
	Id: number;
	Subject: string;
}

export interface EmailingInListDTO {
	EndDate: Nullable<Date>;
	Id: number;
	StartDate: Nullable<Date>;
	State: EmailingState;
	Subject: string;
}

export interface EmailingStatsDTO {
	Deliveries: EmailDeliveryDTO[];
	EndDate: Nullable<Date>;
	ErrorCount: number;
	PendingCount: number;
	SentCount: number;
	StartDate: Nullable<Date>;
	State: EmailingState;
	Subject: string;
}

export interface EntitySummaryDTO {
	Items: string[];
	Name: string;
}

export interface EscPosTemplateForEditionDTO {
	AvailableLanguages: string[];
	Configuration: TemplateConfigurationInListDTO;
	ConsolidateLines: boolean;
	CreateStandardInvoiceDigitalMenu: DigitalMenuInListDTO;
	ExistingConfigurations: TemplateConfigurationInListDTO[];
	ExistingDigitalMenus: DigitalMenuInListDTO[];
	ExistingLinesOrderTypes: LinesOrderType[];
	Footer: TemplateElementDTO[];
	Header: TemplateElementDTO[];
	HidePrices: boolean;
	Id: number;
	InstalledPrinters: string[];
	Language: string;
	LinesOrder: LinesOrderType;
	Name: string;
	ScanAndPayDigitalMenu: DigitalMenuInListDTO;
	ShowAllPrepayments: boolean;
	ShowBarcode: boolean;
	ShowConsumedCouponInLine: boolean;
	ShowCreateStandardInvoiceQR: boolean;
	ShowDeliveryNoteDetailsInInvoice: boolean;
	ShowDocumentLocation: boolean;
	ShowFreeLines: boolean;
	ShowFreeLinesText: string;
	ShowGlobalIdQR: boolean;
	ShowMajorGroups: boolean;
	ShowMenuLines: boolean;
	ShowPreparationOrderId: boolean;
	ShowReference: boolean;
	ShowRegisteredTip: boolean;
	ShowScanAndPayQR: boolean;
	ShowSuggestedTip: boolean;
	ShowTableCompanions: boolean;
	ShowTicketId: boolean;
	ShowTicketLineNotes: boolean;
	ShowTicketNotPaid: boolean;
	ShowTime: boolean;
	ShowUserName: boolean;
	ShowVatCode: boolean;
	ShowVatDetail: boolean;
}

export interface FamilyByUserDTO {
	Id: number;
	Name: string;
	ParentFamilyId: number;
}

export interface FamilyForEditionDTO {
	ExistingMajorGroups: MajorGroupInListDTO[];
	ExistingParentFamilies: FamilyInListDTO[];
	ExistingPosGroups: PosGroupInListDTO[];
	FamilyProducts: ProductInGroupDTO[];
	Id: number;
	InvoicePrintOrder: number;
	MajorGroup: MajorGroupInListDTO;
	Name: TranslatableStringDTO;
	ParentFamily: FamilyInListDTO;
	ShowInMenuConfiguration: boolean;
	ShowInPos: boolean;
	Style: StyleForEditionDTO;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface FamilyForSectionDTO {
	Id: number;
	Name: string;
}

export interface FamilyInListDTO {
	GroupsSummary: string;
	Id: number;
	InvoicePrintOrder: number;
	MajorGroup: string;
	MajorGroupId: number;
	Name: string;
	ParentFamily: string;
	ParentFamilyId: number;
	ShowInMenuConfiguration: boolean;
	ShowInPos: boolean;
	WorkplacesSummary: string;
}

export interface FileContentDTO {
	Data: string;
	FileName: string;
}

export interface FingerprintDTO {
	Data: string;
	Name: string;
}

export interface FixedTipSettingsDTO {
	TipIgnoreTicketDiscounts: boolean;
	TipPercentage: number;
	TipTax: VatDTO;
	TipType: TicketType;
}

export interface GlobalSalesDTO {
	BusinessDay: Date;
	GrossAmount: number;
	NetAmount: number;
	Number: number;
	PosName: string;
	SaleCenterName: string;
	SaleLocationName: string;
	Serie: string;
}

export interface GlobalSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: GlobalSalesDTO[];
	To: Date;
}

export interface GrantedLicenseDTO {
	Granted: boolean;
	ModuleName: string;
}

export interface GStockPendingUploadDTO {
	BusinessDay: Date;
	Id: number;
	LastError: string;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface GuestFeeDTO {
	FormatId: number;
	FormatName: string;
	ProductName: string;
}

export interface HeatMapDTO {
	DayOfWeekAndHours: KpiPerDayOfWeekAndHourDTO[];
	Days: KpiPerDayDTO[];
}

export interface HubClientCommsDTO {
	CheckDate: Nullable<Date>;
	CheckVersion: string;
	DownloadConfirmationDate: Nullable<Date>;
	DownloadErrorMessage: string;
	DownloadIntervalInSeconds: number;
	DownloadStatus: HubClientCommStatus;
	HubVersion: string;
	UploadDate: Nullable<Date>;
	UploadErrorMessage: string;
	UploadQueueLength: number;
	UploadStatus: HubClientCommStatus;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface HubCommsDTO {
	CheckDate: Nullable<Date>;
	CheckVersion: string;
	DownloadConfirmationDate: Nullable<Date>;
	DownloadErrorMessage: string;
	DownloadStatus: HubCommStatus;
	HubVersion: string;
	PendingDataGenerationDate: Nullable<Date>;
	UpdatePendingDate: Nullable<Date>;
	UpdateSendDate: Nullable<Date>;
	UpdateStatus: WorkplaceUpdateStatus;
	UploadDate: Nullable<Date>;
	UploadErrorMessage: string;
	UploadStatus: HubCommStatus;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface ImageDTO {
	Content: string;
	Id: string;
}

export interface IncomingDeliveryNoteDetailsDTO {
	CashDiscount: number;
	Date: Date;
	DiscountPercentage: number;
	Gross: number;
	Id: number;
	InvoiceDate: Nullable<Date>;
	InvoiceNumber: Nullable<number>;
	InvoiceSerie: string;
	InvoiceStatus: PurchaseInvoiceStatus;
	InvoiceSupplierDocumentNumber: string;
	Net: number;
	Number: number;
	Serie: string;
	SupplierAccountCode: string;
	SupplierCif: string;
	SupplierDocumentNumber: string;
	SupplierFiscalName: string;
	Surcharge: number;
	Tax: number;
	Tax10Gross: number;
	Tax10Net: number;
	Tax10Surcharge: number;
	Tax10SurchargePercentage: number;
	Tax10Tax: number;
	Tax10VatPercentage: number;
	Tax1Gross: number;
	Tax1Net: number;
	Tax1Surcharge: number;
	Tax1SurchargePercentage: number;
	Tax1Tax: number;
	Tax1VatPercentage: number;
	Tax2Gross: number;
	Tax2Net: number;
	Tax2Surcharge: number;
	Tax2SurchargePercentage: number;
	Tax2Tax: number;
	Tax2VatPercentage: number;
	Tax3Gross: number;
	Tax3Net: number;
	Tax3Surcharge: number;
	Tax3SurchargePercentage: number;
	Tax3Tax: number;
	Tax3VatPercentage: number;
	Tax4Gross: number;
	Tax4Net: number;
	Tax4Surcharge: number;
	Tax4SurchargePercentage: number;
	Tax4Tax: number;
	Tax4VatPercentage: number;
	Tax5Gross: number;
	Tax5Net: number;
	Tax5Surcharge: number;
	Tax5SurchargePercentage: number;
	Tax5Tax: number;
	Tax5VatPercentage: number;
	Tax6Gross: number;
	Tax6Net: number;
	Tax6Surcharge: number;
	Tax6SurchargePercentage: number;
	Tax6Tax: number;
	Tax6VatPercentage: number;
	Tax7Gross: number;
	Tax7Net: number;
	Tax7Surcharge: number;
	Tax7SurchargePercentage: number;
	Tax7Tax: number;
	Tax7VatPercentage: number;
	Tax8Gross: number;
	Tax8Net: number;
	Tax8Surcharge: number;
	Tax8SurchargePercentage: number;
	Tax8Tax: number;
	Tax8VatPercentage: number;
	Tax9Gross: number;
	Tax9Net: number;
	Tax9Surcharge: number;
	Tax9SurchargePercentage: number;
	Tax9Tax: number;
	Tax9VatPercentage: number;
	WarehouseCif: string;
	WarehouseFiscalName: string;
	WarehouseName: string;
}

export interface IncomingDeliveryNoteForEditionDTO {
	CashDiscount: number;
	Company: CompanyDTO;
	Date: Date;
	DisableAudit: boolean;
	DiscountPercentage: number;
	ExistingSuppliers: SupplierDetailsDTO[];
	ExistingWarehouseCloseDates: WarehouseCloseDateDTO[];
	ExistingWarehouses: WarehouseByUserDTO[];
	HasBeenSentByEmail: boolean;
	Id: number;
	InvoiceDocumentNumber: string;
	InvoiceId: number;
	Lines: IncomingDeliveryNoteLineForEditionDTO[];
	Notes: string;
	SerialNumber: SerialNumberDTO;
	Status: IncomingDeliveryNoteStatus;
	Supplier: SupplierDetailsDTO;
	SupplierDocumentNumber: string;
	TaxDeltas: TaxDeltaDTO[];
	Warehouse: WarehouseByUserDTO;
}

export interface IncomingDeliveryNoteInListDTO {
	Date: Date;
	GrossAmount: number;
	HasBeenSentByEmail: boolean;
	Id: number;
	Invoiced: boolean;
	InvoiceDocumentNumber: string;
	InvoiceId: number;
	InvoiceNumber: number;
	InvoiceSerie: string;
	NetAmount: number;
	Number: number;
	Serie: string;
	Status: IncomingDeliveryNoteStatus;
	SupplierDocumentNumber: string;
	SupplierId: number;
	SupplierName: string;
	WarehouseId: number;
	WarehouseName: string;
}

export interface IncomingDeliveryNoteLineForEditionDTO {
	CashDiscount: number;
	DiscountPercentage: number;
	HasPurchaseConditionApplied: boolean;
	Id: number;
	Lot: LotInDocumentDTO;
	Notes: string;
	PricePerPurchaseUnit: number;
	Product: PurchasedProductDTO;
	PurchaseOrderLineId: Nullable<number>;
	PurchaseOrderReference: string;
	QuantityInPurchaseUnit: number;
}

export interface IngredientDTO {
	Id: number;
	Name: string;
}

export interface IngredientForRecipeDTO {
	AvgCostPrice: number;
	Barcodes: string[];
	BarcodeSummary: string;
	BaseUnit: string;
	CategorySummary: string;
	CostPrices: CostPriceByWarehouseDTO[];
	Family: string;
	Id: number;
	Name: string;
	PLU: string;
	WeightedAvgCostPrice: number;
}

export interface IngredientSearchResultDTO {
	Barcodes: string[];
	BarcodeSummary: string;
	BaseUnit: string;
	CategorySummary: string;
	Family: string;
	Id: number;
	Name: string;
	PLU: string;
}

export interface InternalCustomerForEditionDTO {
	Customer: CustomerInListDTO;
	CustomerWarehouse: WarehouseInListDTO;
	ExistingCustomers: CustomerInListDTO[];
	ExistingWarehouses: WarehouseInListDTO[];
	Id: number;
}

export interface InternalCustomerInListDTO {
	CustomerFiscalName: string;
	Id: number;
	WarehouseName: string;
}

export interface InternalOrderDTO {
	CustomerDocumentNumber: string;
	CustomerFiscalName: string;
	CustomerId: number;
	Id: number;
	Number: number;
	Serie: string;
	SupplierId: number;
	SupplierName: string;
	Total: number;
	WarehouseName: string;
	WorkplaceName: string;
}

export interface InternalSupplierForEditionDTO {
	ExistingLocations: DefaultLocationDTO[];
	ExistingPos: PosInListDTO[];
	ExistingPriceLists: PriceListInListDTO[];
	ExistingSuppliers: SupplierInListDTO[];
	ExistingUsers: UserInListDTO[];
	ExistingWorkplaces: WorkplaceInListDTO[];
	Id: number;
	Location: DefaultLocationDTO;
	Pos: PosInListDTO;
	PriceList: PriceListInListDTO;
	Supplier: SupplierInListDTO;
	User: UserInListDTO;
	Workplace: WorkplaceInListDTO;
}

export interface InternalSupplierInListDTO {
	Id: number;
	PosName: string;
	SaleLocation: DefaultLocationDTO;
	SupplierFiscalName: string;
	UserName: string;
	WorkplaceName: string;
}

export interface InventoryCountDTO {
	Id: number;
	Lines: InventoryCountLineDTO[];
	Name: string;
}

export interface InventoryCountLineDTO {
	Id: number;
	Product: StockedProductDTO;
	Quantity: number;
}

export interface InventoryForEditionDTO {
	Counts: InventoryCountDTO[];
	Date: Date;
	ExistingSystemsOfMeasurement: SystemOfMeasurementForProductDTO[];
	ExistingWarehouseCloseDates: WarehouseCloseDateDTO[];
	ExistingWarehouses: WarehouseByUserDTO[];
	Id: number;
	Lines: InventoryLineForEditionDTO[];
	Reason: string;
	State: InventoryState;
	Warehouse: WarehouseByUserDTO;
}

export interface InventoryInListDTO {
	ActualCostPrice: number;
	Date: Date;
	ExpectedCostPrice: number;
	Id: number;
	Reason: string;
	State: InventoryState;
	TotalCostPrice: number;
	Warehouse: string;
}

export interface InventoryLineForEditionDTO {
	ActualCostPrice: number;
	ActualStockInSaleUnit: number;
	ExpectedCostPrice: number;
	ExpectedStockInSaleUnit: number;
	Id: number;
	Product: StockedProductDTO;
	TotalCostPrice: number;
}

export interface InvitationsByBusinessDayDTO {
	BusinessDay: Date;
	ColorId: number;
	ColorName: string;
	GrossAmount: number;
	NetAmount: number;
	ProductName: string;
	Quantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SizeId: number;
	SizeName: string;
}

export interface InvitationsByBusinessDayReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Invitations: InvitationsByBusinessDayDTO[];
	To: Date;
}

export interface InvoiceByCustomerDTO {
	BusinessDay: Date;
	CustomerCif: string;
	CustomerName: string;
	CustomerType: string;
	GrossAmount: number;
	NetAmount: number;
	Number: number;
	Serie: string;
	SurchargeAmount: number;
	TaxAmount: number;
	Type: DocumentType;
}

export interface InvoiceDetailsDTO {
	AuditEvents: AuditEventDTO[];
	Invoice: InvoiceInListDTO;
	Previews: PrintPreviewDTO[];
}

export interface InvoiceDTO {
	BusinessDay: Date;
	ClosingAmountToPay: number;
	ContentType: InvoiceContentType;
	Customer: BuyerCustomerDTO;
	HasTicketBAIData: boolean;
	HasVerifactuData: boolean;
	Id: number;
	IsRefund: boolean;
	ItemsCount: number;
	NetAmount: number;
	PosId: number;
	PosName: string;
	SerialNumber: SerialNumberDTO;
	TableCompanions: Nullable<number>;
	Type: DocumentType;
}

export interface InvoiceInListDTO {
	BusinessDay: Date;
	ContentType: InvoiceContentType;
	CreationDate: Date;
	CustomerAccountCode: string;
	CustomerBusinessName: string;
	CustomerCif: string;
	CustomerCity: string;
	CustomerCountryCode: string;
	CustomerFiscalName: string;
	CustomerId: number;
	CustomerRegion: string;
	CustomerStreet: string;
	CustomerZipCode: string;
	GrossAmount: number;
	HasTicketBAIData: boolean;
	HasVerifactuData: boolean;
	Id: number;
	IsForTraining: boolean;
	NetAmount: number;
	Number: number;
	PaymentMethods: string;
	Pos: string;
	PosId: number;
	RefundSource: Nullable<RefundSource>;
	RelatedInvoiceId: Nullable<number>;
	RelatedNumber: Nullable<number>;
	RelatedSerie: string;
	SaleCenter: string;
	SaleLocation: string;
	Serie: string;
	ServiceChargeGrossAmount: number;
	ServiceChargeNetAmount: number;
	ServiceChargeSurchargeAmount: number;
	ServiceChargeTaxAmount: number;
	SurchageAmount: number;
	TableCompanions: Nullable<number>;
	TaxAmount: number;
	TicketId: Nullable<number>;
	TipAmount: number;
	Type: DocumentType;
	User: string;
	Workplace: string;
}

export interface InvoiceLineDetailsDTO {
	BusinessDay: Date;
	CashDiscount: number;
	CostPrice: number;
	CustomerAccountCode: string;
	CustomerCif: string;
	CustomerCity: string;
	CustomerCountryCode: string;
	CustomerFiscalName: string;
	CustomerRegion: string;
	CustomerStreet: string;
	CustomerZipCode: string;
	DiscountCode: string;
	DiscountPercentage: number;
	Family: string;
	GrossAmount: number;
	InvoiceCreationDate: Date;
	InvoiceId: number;
	InvoiceType: DocumentType;
	IsLine: boolean;
	LineType: SoldProductType;
	MajorGroup: string;
	NetAmount: number;
	Number: number;
	OfferCode: string;
	Pos: string;
	PosId: number;
	ProductPrice: number;
	Quantity: number;
	RefundSource: Nullable<RefundSource>;
	RelatedNumber: Nullable<number>;
	RelatedSerie: string;
	SaleCenter: string;
	SaleFormatId: number;
	SaleFormatName: string;
	SaleLocation: string;
	Serie: string;
	SurchargePercentage: number;
	TicketCashDiscount: number;
	TicketDiscountPercentage: number;
	User: string;
	VatPercentage: number;
	Workplace: string;
}

export interface InvoiceParamsFromAdminDTO {
	BusinessDay: Date;
	BuyerCustomer: BuyerCustomerDTO;
	CreationDate: Date;
	InvoiceType: DocumentType;
	Payments: PaymentDTO[];
	PosId: number;
	RelatedInvoiceId: Nullable<number>;
}

export interface InvoiceParamsFromPosDTO {
	BuyerCustomer: BuyerCustomerDTO;
	InvoiceType: DocumentType;
	Payments: PaymentDTO[];
	PrintGiftTicket: boolean;
	PrintTicket: boolean;
	RelatedInvoiceId: Nullable<number>;
}

export interface InvoicesByCustomerReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Invoices: InvoiceByCustomerDTO[];
	To: Date;
}

export interface InvoicesPerMonthThroughYearsDTO {
	CurrentGrossAmount: number;
	CurrentInvoiceCount: number;
	CurrentNetAmount: number;
	Month: number;
	PreviousGrossAmount: number;
	PreviousInvoiceCount: number;
	PreviousNetAmount: number;
	Year: number;
}

export interface InvoicesPerMonthThroughYearsReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	InvoicesPerMonth: InvoicesPerMonthThroughYearsDTO[];
	To: Date;
}

export interface InvoicesSummaryDTO {
	BasicInvoicesCount: number;
	BasicRefundCount: number;
	Descriptions: string[];
	FromBusinessDay: Date;
	IncludeSummaryTickets: boolean;
	StandardInvoicesCount: number;
	StandardRefundCount: number;
	ToBusinessDay: Date;
	TotalGrossAmount: number;
	TotalNetAmount: number;
	TotalSurchargeAmount: number;
	TotalTaxAmount: number;
}

export interface KitchenDisplayConfigurationDTO {
	ConsolidateLinesOnScreen: boolean;
	CounterFilterStatuses: TicketLineStatus[];
	EnableFinishCookingButton: boolean;
	EnablePrintOrderButton: boolean;
	EnableServePreparationButton: boolean;
	EnableStartCookingButton: boolean;
	HubUrl: string;
	JsonStyleRules: string;
	MainStatuses: TicketLineStatus[];
	PreparationEntryDirection: PreparationEntryDirection;
	PreparationTypes: PreparationTypeDTO[];
	Rows: number;
	SecondaryStatuses: TicketLineStatus[];
	Type: KitchenDisplayType;
	VisualizationMode: KitchenDisplayVisualizationMode;
}

export interface KitchenDisplayForEditionDTO {
	AcceptServedPreparationTimeInMinutes: number;
	ConsolidateLinesOnPrint: boolean;
	ConsolidateLinesOnScreen: boolean;
	CounterFilterStatuses: TicketLineStatus[];
	EnableFinishCookingButton: boolean;
	EnablePrintOrderButton: boolean;
	EnableServePreparationButton: boolean;
	EnableStartCookingButton: boolean;
	ExistingLineStatuses: TicketLineStatus[];
	ExistingPreparationEntryDirections: PreparationEntryDirection[];
	ExistingPreparationOrders: PreparationOrderInListDTO[];
	ExistingPreparationTypes: PreparationTypeInListDTO[];
	ExistingPrinters: string[];
	ExistingPrintModes: DisplayPreparationPrintMode[];
	ExistingSaleCenters: SaleCenterInListDTO[];
	ExistingTypes: KitchenDisplayType[];
	ExistingVisualizationModes: KitchenDisplayVisualizationMode[];
	Id: number;
	JsonStyleRules: string;
	MainLineStatuses: TicketLineStatus[];
	MarkAsServedOnReadyToServe: boolean;
	Name: string;
	PreparationEntryDirection: PreparationEntryDirection;
	PreparationOrders: PreparationOrderInListDTO[];
	PreparationTypes: PreparationTypeInListDTO[];
	PrinterName: string;
	PrintMode: DisplayPreparationPrintMode;
	Rows: number;
	SaleCenters: SaleCenterInListDTO[];
	SecondaryLineStatuses: TicketLineStatus[];
	Type: KitchenDisplayType;
	VisualizationMode: KitchenDisplayVisualizationMode;
}

export interface KitchenDisplayInListDTO {
	Id: number;
	Name: string;
	Type: KitchenDisplayType;
}

export interface KitchenPrinterForEditionDTO {
	AdditionalPreparationTypes: PreparationTypeInListDTO[];
	KitchenPrintTemplate: KitchenPrintTemplateInListDTO;
	KitchenValidPrintTemplates: KitchenPrintTemplateInListDTO[];
	Name: string;
	PreparationTypes: PreparationTypeInListDTO[];
	PrintCancellationReason: boolean;
	PrintCancellations: boolean;
	PrintMovements: boolean;
	PrintOrders: boolean;
	PrintRequestedCourses: boolean;
	PrintRequests: boolean;
	PrintSalesOrderInfo: boolean;
	SystemPrinter: string;
	ValidForAllSaleCenters: boolean;
	ValidSaleCenters: SaleCenterInListDTO[];
}

export interface KitchenPrintTemplateForEditionDTO {
	AvailableFontSizes: KitchenTemplateFontSize[];
	AvailableLanguages: string[];
	AvailableLineModes: KitchenTemplateLineMode[];
	AvailableSplitModes: KitchenTemplateSplitPreparationMode[];
	AvailableWidths: KitchenTemplateWidth[];
	BottomMargin: number;
	FontSize: KitchenTemplateFontSize;
	Id: number;
	Language: string;
	LineMode: KitchenTemplateLineMode;
	Name: string;
	ShowOrderId: boolean;
	ShowPLUCodes: boolean;
	SortProductsByFamily: boolean;
	SplitMode: KitchenTemplateSplitPreparationMode;
	TopMargin: number;
	Width: KitchenTemplateWidth;
}

export interface KitchenPrintTemplateInListDTO {
	Id: number;
	Name: string;
}

export interface KpiPerDayDTO {
	Day: Date;
	Value: number;
}

export interface KpiPerDayOfWeekAndHourDTO {
	DayOfWeek: number;
	Hour: number;
	HourPart: number;
	Value: number;
}

export interface LabelForEditionDTO {
	ExistingLabelFormats: LabelFormat[];
	ExistingMediaTypes: LabelMediaType[];
	Id: number;
	InstalledPrinters: string[];
	LabelContent: string;
	Name: string;
}

export interface LabelInListDTO {
	Format: LabelFormat;
	Id: number;
	Name: string;
}

export interface LanguageDTO {
	Code: string;
	Name: string;
}

export interface LicenseContainerDTO {
	ExpiredLicenses: LicenseDTO[];
	Licenses: LicenseDTO[];
	MachineId: string;
	OwnerCif: string;
	OwnerEmail: string;
	OwnerFiscalName: string;
	TemporaryBundleExpirationDate: Nullable<Date>;
	Type: LicenseType;
}

export interface LicenseDTO {
	ExpirationDate: Nullable<Date>;
	IsBundle: boolean;
	LicensingMode: LicensingMode;
	Modules: LicenseModuleDTO[];
	Product: string;
	Serial: string;
	Status: LicenseStatus;
	StatusInfo: string;
}

export interface LicenseModuleDTO {
	Name: string;
	Quantity: number;
}

export interface LineCancellationReasonForEditionDTO {
	GenerateLoss: boolean;
	Id: number;
	PrintInKitckenPrinter: boolean;
	Priority: number;
	Text: TranslatableStringDTO;
}

export interface LineCancellationReasonInListDTO {
	GenerateLoss: boolean;
	Id: number;
	Priority: number;
	Text: string;
}

export interface LotForEditionDTO {
	ExistingWarehouses: WarehouseInListDTO[];
	ExpirationDate: Nullable<Date>;
	Id: number;
	Movements: LotMovementForEditionDTO[];
	Notes: string;
	Number: string;
	PackingDate: Nullable<Date>;
	Product: ProductDetailsForTraceabilityDTO;
}

export interface LotInDocumentDTO {
	Id: number;
	Number: string;
}

export interface LotInListDTO {
	ExpirationDate: Nullable<Date>;
	Id: number;
	LastPurchaseDate: Nullable<Date>;
	Number: string;
	PackingDate: Nullable<Date>;
	ProductId: number;
	ProductName: string;
	Stock: number;
}

export interface LotInReportDTO {
	ExpirationDate: Nullable<Date>;
	FinalStock: number;
	InitialStock: number;
	LastPurchaseDate: Nullable<Date>;
	Number: string;
	PackingDate: Nullable<Date>;
	Product: string;
	WarehouseId: number;
}

export interface LotMovementForEditionDTO {
	Date: Date;
	Id: number;
	MovementType: MovementType;
	QuantityInSaleUnit: number;
	Reference: string;
	WarehouseId: number;
	WarehouseName: string;
}

export interface LotsReportDTO {
	BusinessName: string;
	Cif: string;
	FiscalName: string;
	From: Date;
	Lots: LotInReportDTO[];
	To: Date;
}

export interface LowStockWarningDTO {
	CurrentStock: number;
	MinStock: number;
	ProductId: number;
	ProductName: string;
	RequestedQuantity: number;
}

export interface LoyaltyProgramMemberDTO {
	DisplayText: string;
	MemberId: string;
	Rewards: RewardDTO[];
}

export interface MajorGroupForEditionDTO {
	ExistingFamilies: FamilyInListDTO[];
	Families: FamilyInListDTO[];
	Id: number;
	Name: TranslatableStringDTO;
}

export interface MajorGroupInListDTO {
	Id: number;
	Name: string;
}

export interface MajorGroupSalesDTO {
	BusinessDay: Date;
	Cuota: number;
	Gross: number;
	MajorGroupId: number;
	MajorGroupName: string;
	Net: number;
	Quantity: number;
}

export interface MajorGroupSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: MajorGroupSalesDTO[];
	To: Date;
}

export interface MajorGroupSalesWidgetDTO {
	Gross: number;
	Name: string;
	TotalCost: number;
}

export interface MajorGroupStockValueDTO {
	MajorGroup: string;
	StockValue: number;
}

export interface ManufacturerDTO {
	Cif: string;
	FiscalName: string;
}

export interface MapClipartsDTO {
	Floors: ClipartDTO[];
	Furnitures: ClipartDTO[];
	Tables: ClipartDTO[];
}

export interface MapDTO {
	Id: number;
	Name: string;
	XmlContent: string;
}

export interface MapForEditionDTO {
	ExistingLocations: TableSaleLocationDTO[];
	ExistingPosGroups: PosGroupInListDTO[];
	Height: number;
	Id: number;
	Name: string;
	Priority: number;
	ResizeMode: string;
	SaleCenters: SaleCenterInListDTO[];
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
	Width: number;
	XmlSerialization: string;
}

export interface MapInListDTO {
	Id: number;
	Name: string;
	Prioritiy: number;
}

export interface MenuConfigurationDTO {
	MenuGroups: MenuGroupConfigurationDTO[];
	MenuId: number;
	MenuName: string;
	MenuSaleFormatId: number;
}

export interface MenuForEditionDTO {
	Barcodes: string[];
	BarcodeSummary: string;
	Categories: CategoryInListDTO[];
	DataSheet: ProductDataSheetForEditionDTO;
	DocumentText: TranslatableStringDTO;
	ExistingCategories: CategoryInListDTO[];
	ExistingFamilies: FamilyInListDTO[];
	ExistingPreparationOrders: PreparationOrderDTO[];
	ExistingTags: ProductTagInListDTO[];
	ExistingVats: VatDTO[];
	ExtraInfo: DigitalMenuItemExtraInfoForEditionDTO;
	Family: FamilyInListDTO;
	Groups: MenuGroupForEditionDTO[];
	HasRestrictedAvailability: boolean;
	Id: number;
	Name: TranslatableStringDTO;
	PreparationText: TranslatableStringDTO;
	PriceLookUpCode: string;
	Prices: ProductPriceDTO[];
	SaleableAsMain: boolean;
	Style: StyleForEditionDTO;
	Tag: string;
	Tags: ProductTagInListDTO[];
	UseAsDirectSale: boolean;
	Vat: VatDTO;
}

export interface MenuForSaleDTO {
	MenuId: number;
	MenuName: string;
	Roles: MenuRoleDTO[];
}

export interface MenuGroupConfigurationDTO {
	GroupName: string;
	ItemsCategoryId: number;
	ItemsCategoryName: string;
	MaxItems: number;
	Priority: number;
}

export interface MenuGroupForEditionDTO {
	ItemsCategory: CategoryInListDTO;
	MaxItems: number;
	Name: TranslatableStringDTO;
	PreparationOrder: PreparationOrderDTO;
}

export interface MenuInListDTO {
	Barcodes: string[];
	BarcodeSummary: string;
	CategorySummary: string;
	Family: string;
	FamilyId: number;
	Id: number;
	Name: string;
	Prices: ProductPriceDTO[];
	SaleableAsMain: boolean;
	Vat: string;
}

export interface MenuRoleDTO {
	Category: ProductGroupForSaleDTO;
	MaxItems: number;
	Name: string;
	PreparationOrderId: number;
	Style: StyleDTO;
}

export interface MenuSalesDTO {
	ItemQuantity: number;
	ItemSaleFormatId: number;
	ItemSaleFormatName: string;
	MenuGrossAmount: number;
	MenuNetAmount: number;
	MenuQuantity: number;
	MenuSaleFormatId: number;
	MenuSaleFormatName: string;
}

export interface MenuSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: MenuSalesDTO[];
	To: Date;
}

export interface MonthlyAppointmentsDTO {
	BusyDays: Date[];
	CurrentAppointments: AppointmentInListDTO[];
}

export interface MultipleUserProfileEditionDTO {
	Profile: UserProfileInListDTO;
	Users: UserForEditionDTO[];
}

export interface MyAgoraAccountForEditionDTO {
	AssignedWorkplaces: WorkplaceInListDTO[];
	Email: string;
	ExistingWorkplaces: WorkplaceInListDTO[];
	Id: number;
	Password: string;
}

export interface MyAgoraAccountInListDTO {
	Email: string;
	Id: number;
}

export interface NamedDiscountDTO {
	Code: string;
	Id: number;
	IsAllowed: boolean;
	Mode: DiscountMode;
	Name: string;
	RateOrCash: number;
	RequiresAuthorization: boolean;
	RequiresAuthorizerAuthentication: boolean;
	Style: StyleDTO;
}

export interface NamedDiscountForEditionDTO {
	Code: string;
	ExistingModes: DiscountMode[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingTypes: NamedDiscountType[];
	Id: number;
	Mode: DiscountMode;
	Name: TranslatableStringDTO;
	PercentageOrCash: number;
	PrintAuthorizationDocument: boolean;
	RequiresAuthorization: boolean;
	RequiresAuthorizerAuthentication: boolean;
	Style: StyleForEditionDTO;
	Type: NamedDiscountType;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface NamedDiscountInListDTO {
	GroupsSummary: string;
	Id: number;
	Mode: DiscountMode;
	Name: string;
	PercentageOrCash: number;
	Type: NamedDiscountType;
	WorkplacesSummary: string;
}

export interface NamedDiscountProposalDTO {
	CashDiscount: number;
	DiscountDescription: string;
	DiscountName: string;
}

export interface NotificationDTO {
	Messages: NotificationMessageDTO[];
}

export interface NotificationMessageDTO {
	MessageText: string;
	PropertyName: string;
}

export interface OccupancyWidgetDTO {
	Guests: number;
	PendingAmount: number;
	Percentage: number;
	Tickets: number;
}

export interface OfferForEditionDTO {
	ApplicationMode: OfferApplicationMode;
	ApplyBy: DiscountStrategyApplyBy;
	Code: string;
	DiscountMode: DiscountMode;
	DiscountPercentageOrCash: number;
	ExistingApplicationModes: OfferApplicationMode[];
	ExistingApplyBy: DiscountStrategyApplyBy[];
	ExistingOfferCandidates: OfferCandidates[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingTypes: OfferType[];
	FixedPrices: PriceListFixedPriceDTO[];
	From: Date;
	Id: number;
	MaxApplicationsPerTicket: Nullable<number>;
	MaxTargetQuantity: number;
	Name: TranslatableStringDTO;
	RequiredSourceQuantity: number;
	Schedule: OfferScheduleDTO;
	SourceSaleFormats: SaleFormatInListDTO[];
	TargetSaleFormats: SaleFormatInListDTO[];
	TargetSelection: OfferCandidates;
	To: Date;
	Type: OfferType;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface OfferInListDTO {
	ApplicationMode: OfferApplicationMode;
	Code: string;
	From: Date;
	GroupsSummary: string;
	Id: number;
	Name: string;
	ScheduleDescription: string;
	To: Date;
	Type: OfferType;
	WorkplacesSummary: string;
}

export interface OfferScheduleDTO {
	EndTime: Date;
	Friday: boolean;
	Monday: boolean;
	Saturday: boolean;
	StartTime: Date;
	Sunday: boolean;
	Thursday: boolean;
	Tuesday: boolean;
	Wednesday: boolean;
}

export interface OnlineReservationInListDTO {
	Companions: number;
	Customer: string;
	EndTime: Date;
	Location: string;
	Notes: string;
	OfferCode: string;
	PrepaymentAmount: number;
	ReservationCode: string;
	StartTime: Date;
}

export interface OpenDayParamsDTO {
	DefaultInitialAmount: number;
	SystemBusinessDay: Nullable<Date>;
}

export interface OrderedItemsStateDTO {
	CanBeRequested: boolean;
	HasBeenRequested: boolean;
	Name: string;
	PreparationOrderId: number;
}

export interface OrderLineProposalDTO {
	CashDiscount: number;
	DiscountRate: number;
	IsFromPurchaseCondition: boolean;
	Notes: string;
	Price: number;
	Product: PurchasedProductDTO;
	Qty: number;
	RegularSupplierId: number;
}

export interface OutOfBandMessageDTO {
	IsBlocking: boolean;
	Message: string;
	Severity: OutOfBandMessageSeverity;
}

export interface ParseBarcodeResultDTO {
	IsScaleTicketBarcode: boolean;
	Products: ParsedBarcodeProductDTO[];
	ScaleTicketWasAlreadyRead: boolean;
}

export interface ParsedBarcodeProductDTO {
	Color: ColorDTO;
	Product: ProductForSaleDTO;
	Quantity: Nullable<number>;
	Size: SizeDTO;
}

export interface PaymentDTO {
	AllowExtraInformation: boolean;
	AllowOverPaid: boolean;
	Amount: number;
	CardTransaction: CardTransactionDTO;
	ExtraInformation: string;
	GiveChange: boolean;
	IsCash: boolean;
	IsRefundVoucher: boolean;
	MethodId: number;
	MethodName: string;
	RegisterTip: boolean;
	TipAmount: number;
	UseCardProcessor: boolean;
}

export interface PaymentMethodBalanceDTO {
	ActualEndAmount: number;
	ExpectedEndAmount: number;
	InitialAmount: number;
	Method: PaymentMethodDTO;
}

export interface PaymentMethodDTO {
	AllowExtraInformation: boolean;
	AllowOverPaid: boolean;
	ExtractTipFromCashdrawer: boolean;
	GiveChange: boolean;
	Id: number;
	IncludeInBalance: boolean;
	IsCash: boolean;
	IsRefundVoucher: boolean;
	IsValidForRefund: boolean;
	MaxAllowedPayment: Nullable<number>;
	Name: string;
	RegisterTip: boolean;
	RequireCustomer: boolean;
	RequiredCustomerType: CustomerTypeInListDTO;
	Style: StyleDTO;
	UseAsDeliveryPersonBalance: boolean;
	UseAsOnlineReservationPayment: boolean;
	UseCardProcessor: boolean;
}

export interface PaymentMethodForEditionDTO {
	AllowExtraInformation: boolean;
	AllowOverPaid: boolean;
	ExistingCustomerTypes: CustomerTypeInListDTO[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExtractTipFromCashdrawer: boolean;
	GiveChange: boolean;
	Id: number;
	IncludeInBalance: boolean;
	IncludeTipInBalance: boolean;
	IsCash: boolean;
	IsRefundVoucher: boolean;
	IsValidForPhoneOrder: boolean;
	IsValidForPurchase: boolean;
	IsValidForRefund: boolean;
	IsValidForSale: boolean;
	MaxAllowedPayment: Nullable<number>;
	Name: TranslatableStringDTO;
	OpenCashDrawer: boolean;
	Priority: number;
	RegisterTip: boolean;
	RequireCustomer: boolean;
	RequiredCustomerType: CustomerTypeInListDTO;
	Style: StyleForEditionDTO;
	UseAsDeliveryPersonBalance: boolean;
	UseAsOnlineReservationPayment: boolean;
	UseCardProcessor: boolean;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface PaymentMethodInListDTO {
	GroupsSummary: string;
	Id: number;
	Name: string;
	Priority: number;
	WorkplacesSummary: string;
}

export interface PaymentMethodSalesDTO {
	BusinessDay: Date;
	InvoiceCount: number;
	PaidAmount: number;
	PaymentMethod: string;
	TotalGrossAmount: number;
	TotalNetAmount: number;
}

export interface PaymentMethodSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: PaymentMethodSalesDTO[];
	To: Date;
}

export interface PaymentOperationDTO {
	MaxAvailableChange: number;
	Methods: PaymentMethodDTO[];
}

export interface PaymentSalesWidgetDTO {
	Amount: number;
	Name: string;
}

export interface PaymentsStatusDTO {
	AmountToPay: number;
	ChangeAmount: number;
	ErrorMessage: string;
	PaidAmount: number;
	PendingAmount: number;
	ThereIsEnoughChange: boolean;
	TipAmount: number;
}

export interface PaymentTotalDTO {
	Amount: number;
	MethodName: string;
}

export interface PendingCardTransactionsStatusDTO {
	Amount: number;
	Status: PendingCardTransactionStatus;
}

export interface PendingPurchaseOrderDTO {
	Date: Date;
	DeliveryDate: Nullable<Date>;
	Id: number;
	Number: number;
	Serie: string;
	Supplier: string;
	SupplierDocumentNumber: string;
	TotalAmount: number;
}

export interface PeriodSalesWidgetDTO {
	Current: number[];
	Previous: number[];
}

export interface PermissionDTO {
	Application: string;
	Description: string;
	Id: number;
}

export interface PointOfSaleStatusDTO {
	AllowCashTransactions: boolean;
	CurrentAmount: number;
	Id: number;
	IsClosed: boolean;
	Name: string;
	OpenDate: Nullable<Date>;
}

export interface PosCloseOutDTO {
	BusinessDay: Date;
	CashActualEndAmount: number;
	CashDiscrepancyAmount: number;
	CashExpectedEndAmount: number;
	CashInitialAmount: number;
	CloseDate: Date;
	CloserUser: string;
	HasIncident: boolean;
	Id: number;
	Incident: string;
	OpenDate: Date;
	OpenerUser: string;
	Payments: PaymentTotalDTO[];
	Pos: string;
	TotalCashTransactions: number;
	TotalSales: number;
	VerificationCode: string;
}

export interface PosForEditionDTO {
	ActionDisplayProfile: ActionDisplayProfileInListDTO;
	AfterCloseTicketAction: FlowAction;
	AfterOpenCashdrawerAction: FlowAction;
	AfterPrepareTicketAction: FlowAction;
	AfterPrintTicketAction: FlowAction;
	AllowCashTransactions: boolean;
	AllowPrintTicketGift: boolean;
	BasicInvoiceDefaultWhenPrint: string;
	BasicInvoiceNumberOfCopies: number;
	BasicInvoicePrinterName: string;
	BasicInvoiceTemplate: PrintTemplateInListDTO;
	CardProcessorSettingsFile: SettingsFileInListDTO;
	CashControlSettingsFile: SettingsFileInListDTO;
	CashdrawerPrinterName: string;
	CouponPrinterName: string;
	CustomerDisplayConfiguration: CustomerDisplayConfigurationDTO;
	DefaultInitialAmount: Nullable<number>;
	DefaultLocation: DefaultLocationDTO;
	DeliveryNoteDefaultWhenPrint: string;
	DeliveryNoteNumberOfCopies: number;
	DeliveryNotePrinterName: string;
	DeliveryNoteTemplate: PrintTemplateInListDTO;
	EnableAutoCloseSession: boolean;
	EnableFingerprintReader: boolean;
	ExistingActionDisplayProfiles: ActionDisplayProfileInListDTO[];
	ExistingCardProcessorSettingsFiles: SettingsFileInListDTO[];
	ExistingCashControlSettingsFiles: SettingsFileInListDTO[];
	ExistingCustomerDisplayTypes: CustomerDisplayType[];
	ExistingDefaultLocations: DefaultLocationDTO[];
	ExistingFlowActions: FlowAction[];
	ExistingGroups: PosGroupInListDTO[];
	ExistingMasters: PosInListDTO[];
	ExistingOnSelectLocationActions: OnSelectLocationAction[];
	ExistingPosTypes: PosType[];
	ExistingPreparationTypes: PreparationTypeInListDTO[];
	ExistingPrinters: string[];
	ExistingPrintTemplates: PrintTemplateInListDTO[];
	ExistingSearchModes: string[];
	ExistingSoldProductTranslationPolicies: SoldProductTranslationPolicy[];
	ExistingWarehouses: WarehouseInListDTO[];
	ExistingWhenPrint: string[];
	Group: PosGroupInListDTO;
	Id: number;
	KitchenPrinters: KitchenPrinterForEditionDTO[];
	MakeBalanceOnCloseDay: boolean;
	Master: PosInListDTO;
	Name: string;
	OnSelectLocationAction: OnSelectLocationAction;
	PrintTotalBalanceOnCloseDay: boolean;
	ReportOptions: BalanceReportOptionsDTO;
	ScaleConfiguration: ScaleConfigurationDTO;
	SearchMode: string;
	SecondsToAutoCloseSession: number;
	ShowLastSaleInLoginView: boolean;
	ShowLastSaleInSelectLocationView: boolean;
	ShowTicketPreviewBeforePrint: boolean;
	SoldProductTranslationPolicy: SoldProductTranslationPolicy;
	StandardInvoiceDefaultWhenPrint: string;
	StandardInvoiceNumberOfCopies: number;
	StandardInvoicePrinterName: string;
	StandardInvoiceTemplate: PrintTemplateInListDTO;
	TicketDefaultWhenPrint: string;
	TicketNumberOfCopies: number;
	TicketPrinterName: string;
	TicketTemplate: PrintTemplateInListDTO;
	Type: PosType;
	UseAutomaticPreparation: boolean;
	UseCardProcessor: boolean;
	UseCashControl: boolean;
	UseCashControlBlindOpening: boolean;
	Warehouse: WarehouseInListDTO;
	WarnOnTicketCreatedByOtherUser: boolean;
	WarnOnTicketInUseByOtherUser: boolean;
}

export interface PosGroupByUserDTO {
	Id: number;
	Name: string;
	Workplace: string;
}

export interface PosGroupForEditionDTO {
	ExistingWorkplaces: WorkplaceInListDTO[];
	Id: number;
	Name: string;
	Workplace: WorkplaceInListDTO;
}

export interface PosGroupInListDTO {
	Id: number;
	Name: string;
	Workplace: string;
	WorkplaceId: number;
}

export interface PosInListDTO {
	Group: string;
	GroupId: number;
	Id: number;
	Name: string;
	Type: PosType;
	Workplace: string;
	WorkplaceId: number;
}

export interface PredefinedNoteDTO {
	Style: StyleDTO;
	Text: string;
}

export interface PredefinedNoteForEditionDTO {
	ExistingProductGroups: ProductGroupDTO[];
	Id: number;
	Priority: number;
	ShowInDigitalMenu: boolean;
	ShowInPos: boolean;
	Style: StyleForEditionDTO;
	Text: TranslatableStringDTO;
	ValidForAllGroups: boolean;
	ValidProductGroups: ProductGroupDTO[];
}

export interface PredefinedNoteInListDTO {
	Id: number;
	Priority: number;
	ProductGroupsSummary: string;
	Text: string;
	ValidForAllGroups: boolean;
}

export interface PreparationItemDTO {
	Addins: PreparedProductDTO[];
	CategorySummary: string;
	CreationDate: Date;
	FriendlyName: string;
	Guests: Nullable<number>;
	HasRecipe: boolean;
	IsCancelled: boolean;
	IsMenuItem: boolean;
	MenuTag: string;
	Notes: string;
	OrderedAt: Date;
	PreparationNumber: Nullable<number>;
	PreparationOrder: PreparationOrderDTO;
	PreparationTimeInMinutes: Nullable<number>;
	PreparationTimeWarningMinutes: Nullable<number>;
	Product: PreparedProductDTO;
	Quantity: number;
	RemovedIngredients: string[];
	RequestedAt: Nullable<Date>;
	SaleCenterName: string;
	SaleLocationName: string;
	SaleOrder: PreparedSaleOrderDTO;
	SeatNumber: Nullable<number>;
	ServedAcceptedAt: Nullable<Date>;
	ServedAt: Nullable<Date>;
	Status: TicketLineStatus;
	TicketId: number;
	TicketLineId: number;
	UpdatedAt: Date;
	UserName: string;
}

export interface PreparationOrderDTO {
	Id: number;
	Name: string;
	Priority: number;
}

export interface PreparationOrderForEditionDTO {
	CanBeRequested: boolean;
	Id: number;
	Name: TranslatableStringDTO;
	OnPendingPreparationStartCooking: boolean;
	OnRequestedStartPreparation: boolean;
	Priority: number;
}

export interface PreparationOrderInListDTO {
	CanBeRequested: boolean;
	Id: number;
	Name: string;
	OnRequestedStartPreparation: boolean;
	Priority: number;
}

export interface PreparationTypeDTO {
	Id: number;
	Name: string;
}

export interface PreparationTypeForEditionDTO {
	Id: number;
	Name: TranslatableStringDTO;
}

export interface PreparationTypeInListDTO {
	Id: number;
	Name: string;
}

export interface PreparedProductDTO {
	ColorName: string;
	PreparationType: PreparationTypeDTO;
	SaleFormatId: number;
	SaleFormatName: string;
	SizeName: string;
}

export interface PreparedSaleOrderDTO {
	Number: number;
	Serie: string;
	Type: SalesOrderType;
}

export interface PreviousPurchaseDTO {
	CashDiscount: number;
	Date: Date;
	DiscountPercentage: number;
	IncomingDeliveryNoteId: number;
	IncomingDeliveryNoteNumber: number;
	IncomingDeliveryNoteSerie: string;
	IncomingDeliveryNoteSupplierDocumentNumber: string;
	PricePerPurchaseUnit: number;
	ProductId: number;
	QuantityInPurchaseUnit: number;
	UnitId: number;
}

export interface PriceListConfigurationDTO {
	Items: PriceListConfigurationItemDTO[];
}

export interface PriceListConfigurationItemDTO {
	AvailablePriceLists: PriceListDTO[];
	CurrentPriceList: PriceListDTO;
	SaleCenterId: number;
	SaleCenterName: string;
}

export interface PriceListDTO {
	Id: number;
	IsDefault: boolean;
	Name: string;
}

export interface PriceListFixedPriceDTO {
	Price: Nullable<number>;
	PriceListId: number;
	PriceListName: string;
}

export interface PriceListForEditionDTO {
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingTicketTypes: TicketType[];
	Id: number;
	Name: TranslatableStringDTO;
	TicketType: TicketType;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface PriceListInListDTO {
	GroupsSummary: string;
	Id: number;
	Name: string;
	TicketType: TicketType;
	WorkplacesSummary: string;
}

export interface PriceListSalesDTO {
	ColorId: number;
	ColorName: string;
	GrossSales: number;
	InvoiceCount: number;
	NetSales: number;
	PriceListId: number;
	PriceListName: string;
	ProductGrossAmount: number;
	ProductId: number;
	ProductName: string;
	ProductNetAmount: number;
	ProductQuantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SizeId: number;
	SizeName: string;
}

export interface PriceListSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: PriceListSalesDTO[];
	To: Date;
}

export interface PriceListScheduleForEditionDTO {
	AvailablePriceLists: PriceListInListDTO[];
	DateKind: PriceListScheduleDateKind;
	EndTime: Date;
	Friday: boolean;
	FromDate: Date;
	Monday: boolean;
	PriceList: PriceListInListDTO;
	SaleCenter: SaleCenterInListDTO;
	Saturday: boolean;
	StartTime: Date;
	Sunday: boolean;
	Thursday: boolean;
	ToDate: Date;
	Tuesday: boolean;
	Wednesday: boolean;
}

export interface PriceListScheduleTableDTO {
	ExistingDateKinds: PriceListScheduleDateKind[];
	ExistingPriceLists: PriceListInListDTO[];
	ExistingSaleCenters: SaleCenterInListDTO[];
	Schedules: PriceListScheduleForEditionDTO[];
}

export interface PriceProposalDTO {
	CashDiscount: number;
	DiscountPercentage: number;
	IsFromPurchaseCondition: boolean;
	Price: number;
	ProductId: number;
	SupplierReference: string;
	UnitId: number;
}

export interface PrintDocumentOptionsDTO {
	ExistingTemplates: PrintTemplateInListDTO[];
	InstalledPrinters: string[];
	Printer: string;
	Template: PrintTemplateInListDTO;
}

export interface PrintLabelOptionsDTO {
	ExistingLabels: LabelInListDTO[];
	InstalledPrinters: string[];
}

export interface PrintPreviewDTO {
	EscPosNumberOfColumns: number;
	EscPosPreview: string;
	RdlBase64Images: string[];
	TemplateType: PrintTemplateType;
}

export interface PrintTemplateInListDTO {
	BodyTemplate: string;
	Id: number;
	Name: string;
	Type: PrintTemplateType;
}

export interface ProducedOrConsumedProductDTO {
	CostPrice: number;
	GenerateAutomaticLot: boolean;
	HasLotControl: boolean;
	Id: number;
	Name: string;
}

export interface ProductAvailabilityDTO {
	CurrentQuantity: Nullable<number>;
	Id: number;
	Name: string;
	NewQuantity: Nullable<number>;
}

export interface ProductBarcodeDTO {
	Color: ColorDTO;
	Size: SizeDTO;
	Value: string;
}

export interface ProductDataSheetDTO {
	ImageContent: string;
	ImageId: string;
	ProductId: number;
	Text: string;
}

export interface ProductDataSheetForEditionDTO {
	ImageContent: string;
	ImageId: string;
	Text: string;
}

export interface ProductDetailsDTO {
	Allergens: AllergenDTO[];
	CurrentStock: CurrentStockDTO[];
	DataSheet: ProductDataSheetDTO;
	Prices: SaleFormatPriceDTO[];
	ProductId: number;
	ProductName: string;
	StockControlMode: StockControlMode;
	StockInOtherWarehouses: CurrentStockDTO[];
	Tags: ProductTagDTO[];
}

export interface ProductDetailsForProductionDTO {
	Barcodes: string[];
	BarcodeSummary: string;
	CostPrice: number;
	FamilyName: string;
	GenerateAutomaticLot: boolean;
	HasLotControl: boolean;
	Id: number;
	Name: string;
	PLU: string;
	ProductionUnit: UnitOfMeasurementDTO;
	RecipeUnit: UnitOfMeasurementDTO;
	StockUnit: UnitOfMeasurementDTO;
}

export interface ProductDetailsForPurchaseDTO {
	Barcodes: string[];
	BarcodeSummary: string;
	CategoryIds: number[];
	CategoryIdsSummary: string;
	CategorySummary: string;
	FamilyName: string;
	HasLotControl: boolean;
	Id: number;
	IsSoldBySizeAndColor: boolean;
	Name: string;
	PLU: string;
	ProviderReferenceSummary: string;
	PurchaseUnit: UnitOfMeasurementDTO;
	RegularSupplierIds: number[];
	RegularSupplierIdsSummary: string;
	SurchargeRate: number;
	VatId: number;
	VatRate: number;
}

export interface ProductDetailsForPurchaseSearchDTO {
	BarcodeSummary: string;
	CategorySummary: string;
	Family: string;
	Id: number;
	Name: string;
	PLU: string;
	ProviderReferenceSummary: string;
}

export interface ProductDetailsForStockControlDTO {
	Barcodes: string[];
	BarcodeSummary: string;
	CategoryIds: number[];
	CategorySummary: string;
	CostPrice: number;
	FamilyName: string;
	HasLotControl: boolean;
	Id: number;
	IsSoldBySizeAndColor: boolean;
	Name: string;
	PLU: string;
	Unit: UnitOfMeasurementDTO;
}

export interface ProductDetailsForStockControlSearchDTO {
	BarcodeSummary: string;
	CategorySummary: string;
	Family: string;
	Id: number;
	Name: string;
	PLU: string;
}

export interface ProductDetailsForTraceabilityDTO {
	BarcodeSummary: string;
	FamilyName: string;
	HasLotControlOnSale: boolean;
	Id: number;
	Name: string;
}

export interface ProductForDataSheetDTO {
	AllergenSummary: string;
	BarcodeSummary: string;
	CategorySummary: string;
	CurrentPrices: ProductPriceDTO[];
	CurrentStock: CurrentStockDTO[];
	Family: string;
	Id: number;
	Name: string;
	PLU: string;
}

export interface ProductForEditionDTO {
	AdjustIngredientsOnSale: boolean;
	Allergens: AllergenInListDTO[];
	AllowCustomNoteInDigitalMenu: boolean;
	AskBeforeNotifyQuantityChanged: boolean;
	AskForPreparationNotes: boolean;
	AutomaticLotExpirationInDays: number;
	AutomaticLotNeverExpire: boolean;
	Categories: CategoryInProductDTO[];
	Colors: ColorDTO[];
	CostPriceMode: CostPriceMode;
	CostPrices: CostPriceByWarehouseDTO[];
	DataSheet: ProductDataSheetForEditionDTO;
	DisablePrintIfPriceIsZero: boolean;
	ExistingAllergens: AllergenInListDTO[];
	ExistingCategories: CategoryInProductDTO[];
	ExistingColors: ColorDTO[];
	ExistingCostPriceModes: CostPriceMode[];
	ExistingFamilies: FamilyInListDTO[];
	ExistingOrigins: ProductOrigin[];
	ExistingPreparationOrders: PreparationOrderDTO[];
	ExistingPreparationTypes: PreparationTypeDTO[];
	ExistingSizes: SizeDTO[];
	ExistingSuppliers: SupplierInProductDTO[];
	ExistingSystemsOfMeasurement: SystemOfMeasurementForProductDTO[];
	ExistingTags: ProductTagInListDTO[];
	ExistingUsePreparationTypes: UsePreparationType[];
	ExistingVats: VatDTO[];
	ExtraInfo: DigitalMenuItemExtraInfoForEditionDTO;
	Family: FamilyInListDTO;
	GenerateAutomaticLot: boolean;
	GlobalCostPrice: number;
	GlobalStock: number;
	HasLotControl: boolean;
	HasLotControlOnSale: boolean;
	HasRestrictedAvailability: boolean;
	Id: number;
	IsEnabledForInternalOrders: boolean;
	IsSoldBySizeAndColor: boolean;
	IsSoldByWeight: boolean;
	LabelLine1: string;
	LabelLine2: string;
	LabelLine3: string;
	LabelLine4: string;
	LabelLine5: string;
	LastInputDate: Nullable<Date>;
	LastInputPrice: Nullable<number>;
	MainBarCode: string;
	Name: TranslatableStringDTO;
	Origin: ProductOrigin;
	PreparationOrder: PreparationOrderDTO;
	PreparationType: PreparationTypeDTO;
	PriceLookUpCode: string;
	ProductionUnit: UnitOfMeasurementDTO;
	PurchaseUnit: UnitOfMeasurementDTO;
	PurchaseVat: VatDTO;
	Recipe: RecipeForEditionDTO;
	RegularBarcodes: string[];
	RegularStorageOptions: StorageOptionsDTO[];
	ResetAvailabilityQuantity: boolean;
	SaleFormats: SaleFormatForEditionDTO[];
	ShelfInfoActualQuantity: Nullable<number>;
	ShelfInfoReferenceQuantity: Nullable<number>;
	ShelfInfoReferenceUnits: string;
	SizeAndColorStorageOptions: StorageOptionsDTO[];
	Sizes: SizeDTO[];
	SizingAndColorBarcodes: ProductBarcodeDTO[];
	StockControlMode: StockControlMode;
	StockProduct: ProductInListDTO;
	Suppliers: RegularSupplierDTO[];
	SystemOfMeasurement: SystemOfMeasurementForProductDTO;
	Tags: ProductTagInListDTO[];
	UpcomingDeliveries: UpcomingDeliveryDTO[];
	UseAsDirectSale: boolean;
	Vat: VatDTO;
}

export interface ProductForInventoryCountDTO {
	Color: ColorDTO;
	CostPrice: number;
	HasLotControl: boolean;
	Id: number;
	Name: string;
	Size: SizeDTO;
	Unit: UnitOfMeasurementDTO;
}

export interface ProductForMenuConfigurationDTO {
	Id: number;
	Name: string;
	Style: StyleDTO;
}

export interface ProductForPurchaseDTO {
	Color: ColorDTO;
	Id: number;
	Name: string;
	PurchaseUnit: UnitOfMeasurementDTO;
	Size: SizeDTO;
	SurchargeRate: number;
	VatId: number;
	VatRate: number;
}

export interface ProductForPurchaseSearchDTO {
	BarcodeSummary: string;
	CategorySummary: string;
	Color: ColorDTO;
	Family: string;
	Id: number;
	Name: string;
	PLU: string;
	ProviderReferenceSummary: string;
	Size: SizeDTO;
}

export interface ProductForSaleDTO {
	AdjustIngredientsOnSale: boolean;
	AskForAddins: boolean;
	AskForPreparationNotes: boolean;
	Barcode: string;
	CannotBeSold: boolean;
	CannotBeSoldReason: string;
	CouponCode: string;
	FamilyName: string;
	HasAddins: boolean;
	HasFixedPrice: boolean;
	HasLotControlOnSale: boolean;
	HasMoreFormats: boolean;
	Id: number;
	IsAvailable: boolean;
	IsMenu: boolean;
	IsSoldBySizeAndColor: boolean;
	IsSoldByWeight: boolean;
	IsSubCategory: boolean;
	IsSubFamily: boolean;
	Name: string;
	Origin: ProductOrigin;
	PreparationOrderId: number;
	PreparationTypeId: number;
	Price: Nullable<number>;
	PriceListId: number;
	PriceLookUpCode: string;
	PrintMode: ProductPrintMode;
	Priority: number;
	RequiresCouponCode: boolean;
	SaleFormatId: number;
	SaleFormatName: string;
	SaleFormatRatio: number;
	Style: StyleDTO;
	SurchargeRate: number;
	VatId: number;
	VatRate: number;
}

export interface ProductForStockControlSearchDTO {
	BarcodeSummary: string;
	CategorySummary: string;
	Color: ColorDTO;
	Family: string;
	Id: number;
	Name: string;
	PLU: string;
	Size: SizeDTO;
}

export interface ProductGroupDTO {
	Id: number;
	Name: string;
	Tags: string[];
	Type: ProductGroupType;
}

export interface ProductGroupForSaleDTO {
	Id: number;
	Style: StyleDTO;
	Type: ProductGroupType;
}

export interface ProductHistoryDTO {
	ColorId: number;
	ColorName: string;
	Date: Date;
	Document: string;
	MovementId: number;
	ProductId: number;
	QuantityInSaleUnit: number;
	SizeId: number;
	SizeName: string;
	SourceId: number;
	Stock: number;
	Type: string;
	Warehouse: string;
}

export interface ProductInGroupDTO {
	CategorySummary: string;
	FamilyName: string;
	Id: number;
	Name: string;
}

export interface ProductInListDTO {
	Barcodes: string[];
	BarcodeSummary: string;
	BaseSaleFormatId: number;
	CategorySummary: string;
	CostPriceMode: CostPriceMode;
	Family: string;
	FamilyId: number;
	Id: number;
	ImageId: string;
	LabelLines: string[];
	Name: string;
	Origin: ProductOrigin;
	PLU: string;
	PreparationOrderId: number;
	PreparationOrderName: string;
	PreparationTimeInMinutes: Nullable<number>;
	PreparationTypeId: number;
	PreparationTypeName: string;
	Prices: ProductPriceDTO[];
	PurchaseVat: string;
	SaleableAsAddin: boolean;
	SaleableAsMain: boolean;
	StockControlMode: StockControlMode;
	Vat: string;
}

export interface ProductInListStockDTO {
	ColorId: number;
	ColorName: string;
	ColorPriority: number;
	ProductId: number;
	ProductName: string;
	SizeId: number;
	SizeName: string;
	SizePriority: number;
	Stocks: ProductInListStockInWarehouseDTO[];
	TotalStock: number;
}

export interface ProductInListStockInWarehouseDTO {
	Stock: number;
	WarehouseId: number;
	WarehouseName: string;
}

export interface ProductionForEditionDTO {
	Date: Date;
	DocumentNumber: string;
	ExistingSystemOfMeasurement: SystemOfMeasurementForProductDTO[];
	ExistingWarehouseCloseDates: WarehouseCloseDateDTO[];
	ExistingWarehouses: WarehouseByUserDTO[];
	Id: number;
	Lines: ProductionLineForEditionDTO[];
	Notes: string;
	Warehouse: WarehouseByUserDTO;
}

export interface ProductionInListDTO {
	Date: Date;
	DocumentNumber: string;
	Id: number;
	Notes: string;
	TotalCostPrice: number;
	Warehouse: string;
}

export interface ProductionLineForEditionDTO {
	Id: number;
	ParentIndex: Nullable<number>;
	Product: ProducedOrConsumedProductDTO;
	ProductionUnit: UnitOfMeasurementDTO;
	QuantityByLots: QuantityByLotDTO[];
	QuantityInProductionUnit: Nullable<number>;
	QuantityInStockUnit: number;
	ShrinkPercentage: number;
	StockUnit: UnitOfMeasurementDTO;
	TotalCostPrice: number;
}

export interface ProductLabelDTO {
	AddinPrice: Nullable<number>;
	Allergens: AllergenInListDTO[];
	AlternativeAddinPrice: Nullable<number>;
	AlternativeMainPrice: Nullable<number>;
	AlternativeMenuItemPrice: Nullable<number>;
	Barcode: string;
	Color: string;
	ExpirationDate: Nullable<Date>;
	LabelLines: string[];
	LotNotes: string;
	LotNumber: string;
	MainPrice: Nullable<number>;
	MenuItemPrice: Nullable<number>;
	PackingDate: Nullable<Date>;
	ProductId: number;
	ProductName: string;
	Quantity: number;
	Size: string;
}

export interface ProductMarginForEditionDTO {
	CategorySummary: string;
	Family: string;
	NewAddinPrice: Nullable<number>;
	NewCostPrice: number;
	NewMainPrice: Nullable<number>;
	NewMenuItemPrice: Nullable<number>;
	ReferenceAddinPrice: Nullable<number>;
	ReferenceCostPrice: number;
	ReferenceMainPrice: Nullable<number>;
	ReferenceMenuItemPrice: Nullable<number>;
	SaleFormatId: number;
	SaleFormatName: string;
}

export interface ProductPreparationTimeDTO {
	AvgTimeInMinutes: number;
	FamilyId: number;
	FamilyName: string;
	MaxTimeInMinutes: number;
	MinTimeInMinutes: number;
	PreparationCount: number;
	Quantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
}

export interface ProductPreparationTimeReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	PreparationTimes: ProductPreparationTimeDTO[];
	To: Date;
}

export interface ProductPriceDTO {
	AddinPrice: Nullable<number>;
	MainPrice: Nullable<number>;
	MenuItemPrice: Nullable<number>;
	PriceListId: number;
	PriceListName: string;
	PriceListTicketType: TicketType;
	SpecificVat: VatDTO;
}

export interface ProductPriceForEditionDTO {
	CategorySummary: string;
	Family: string;
	Prices: ProductPriceDTO[];
	SaleFormatId: number;
	SaleFormatName: string;
}

export interface ProductPurchaseDetailsDTO {
	CashDiscount: number;
	DeliveryNoteCashDiscount: number;
	DeliveryNoteDate: Date;
	DeliveryNoteDiscountPercentage: number;
	DeliveryNoteId: number;
	DeliveryNoteNumber: number;
	DeliveryNoteSerie: string;
	DeliveryNoteSupplierDocumentNumber: string;
	DiscountPercentage: number;
	GrossAmount: number;
	InvoiceDate: Nullable<Date>;
	InvoiceId: Nullable<number>;
	InvoiceNumber: Nullable<number>;
	InvoiceSerie: string;
	InvoiceStatus: PurchaseInvoiceStatus;
	InvoiceSupplierDocumentNumber: string;
	NetAmount: number;
	PaidAmount: Nullable<number>;
	PendingAmount: Nullable<number>;
	PricePerPurchaseUnit: number;
	ProductFamily: string;
	ProductId: number;
	ProductMajorGroup: string;
	ProductName: string;
	ProductSupplierReference: string;
	QuantityInPurchaseUnit: number;
	SupplierAccountCode: string;
	SupplierCif: string;
	SupplierFiscalName: string;
	SurchargePercentage: number;
	UnitName: string;
	UnitSystemName: string;
	UnitToBaseFactor: number;
	VatPercentage: number;
	WarehouseCif: string;
	WarehouseFiscalName: string;
	WarehouseName: string;
}

export interface ProductPurchaseInfoProposalDTO {
	ExistingPurchaseUnits: UnitOfMeasurementDTO[];
	PriceProposal: PriceProposalDTO;
	PurchaseUnit: UnitOfMeasurementDTO;
}

export interface ProductPurchasesAndSalesDTO {
	CategoryIds: number[];
	CategoryIdsRawValue: string;
	ColorId: number;
	ColorName: string;
	FamilyId: number;
	FamilyName: string;
	ProductId: number;
	ProductName: string;
	PurchasedGrossAmount: Nullable<number>;
	PurchasedNetAmount: Nullable<number>;
	PurchasedUnits: Nullable<number>;
	SaleFormatId: number;
	SaleFormatName: string;
	SizeId: number;
	SizeName: string;
	SoldGrossAmount: Nullable<number>;
	SoldNetAmount: Nullable<number>;
	SoldUnits: Nullable<number>;
	StockFrom: number;
	StockTo: number;
}

export interface ProductPurchasesAndSalesReportDTO {
	BusinessName: string;
	Cif: string;
	FiscalName: string;
	From: Date;
	GrossAmountBalance: number;
	NetAmountBalance: number;
	PurchasesAndSales: ProductPurchasesAndSalesDTO[];
	To: Date;
	TotalGrossPurchases: number;
	TotalGrossSales: number;
	TotalNetPurchases: number;
	TotalNetSales: number;
}

export interface ProductSalesByCategoryDTO {
	CategoryId: number;
	CategoryName: string;
	ColorId: number;
	ColorName: string;
	ProductCostAmount: number;
	ProductGrossAmount: number;
	ProductId: number;
	ProductName: string;
	ProductNetAmount: number;
	ProductQuantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SizeId: number;
	SizeName: string;
}

export interface ProductSalesByCategoryReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ProductSalesByCategoryDTO[];
	To: Date;
}

export interface ProductSalesByCustomerDTO {
	ColorId: number;
	ColorName: string;
	CostAmount: number;
	CustomerCif: string;
	CustomerFiscalName: string;
	FamilyName: string;
	GrossAmount: number;
	NetAmount: number;
	ProductId: number;
	ProductName: string;
	Quantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SaleFormatRatio: number;
	SizeId: number;
	SizeName: string;
}

export interface ProductSalesByCustomerReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ProductSalesByCustomerDTO[];
	To: Date;
}

export interface ProductSalesByOfferDTO {
	ColorId: number;
	ColorName: string;
	GrossAmount: number;
	NetAmount: number;
	OfferId: number;
	OfferName: string;
	ProductId: number;
	ProductName: string;
	Quantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SaleFormatRatio: number;
	SizeId: number;
	SizeName: string;
}

export interface ProductSalesByOfferReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ProductSalesByOfferDTO[];
	To: Date;
}

export interface ProductSalesBySaleCenterDTO {
	NetAmount: number;
	ProductId: number;
	ProductName: string;
	SaleCenterId: number;
	SaleCenterName: string;
	SaleFormatId: number;
	SaleFormatName: string;
	TotalQuantity: number;
}

export interface ProductSalesBySaleCenterReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ProductSalesBySaleCenterDTO[];
	To: Date;
}

export interface ProductSalesByTimeFrameDTO {
	NetAmount: number;
	ProductId: number;
	ProductName: string;
	SaleFormatId: number;
	SaleFormatName: string;
	TimeFrameGroupId: number;
	TimeFrameIndex: number;
	TimeFrameName: string;
	TotalQuantity: number;
}

export interface ProductSalesByTimeFrameReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ProductSalesByTimeFrameDTO[];
	To: Date;
}

export interface ProductSalesByUserDTO {
	ColorId: number;
	ColorName: string;
	FamilyName: string;
	GrossAmount: number;
	MajorGroupName: string;
	NetAmount: number;
	ProductId: number;
	ProductName: string;
	Quantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SaleFormatRatio: number;
	SizeId: number;
	SizeName: string;
	UserId: number;
	UserName: string;
}

export interface ProductSalesByUserReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ProductSalesByUserDTO[];
	To: Date;
}

export interface ProductSalesDTO {
	ColorId: number;
	ColorName: string;
	FamilyId: number;
	FamilyName: string;
	ProductBarcode: string;
	ProductCostAmount: number;
	ProductGrossAmount: number;
	ProductId: number;
	ProductName: string;
	ProductNetAmount: number;
	ProductQuantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SizeId: number;
	SizeName: string;
}

export interface ProductSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ProductSalesDTO[];
	To: Date;
}

export interface ProductStockDTO {
	Color: string;
	CurrentStock: number;
	Id: number;
	Location: string;
	MaxStock: number;
	MinStock: number;
	Name: string;
	RestockQuantity: number;
	Size: string;
	WarehouseId: number;
	WarehouseName: string;
}

export interface ProductStocksDTO {
	CategoryIdSummary: string;
	CategorySummary: string;
	ColorId: number;
	ColorName: string;
	CostPrice: number;
	FamilyId: number;
	FamilyName: string;
	FinalStock: number;
	FinalValue: number;
	Id: number;
	InitialStock: number;
	InitialValue: number;
	LastPurchase: Nullable<Date>;
	LastPurchasePrice: number;
	MajorGroupName: string;
	MaxStock: number;
	MinStock: number;
	Name: string;
	SizeId: number;
	SizeName: string;
	StockDifference: number;
	StockUnit: string;
	SupplierIds: number[];
	SupplierIdsRawValue: string;
	ValueDifference: number;
	WarehouseFiscalName: string;
	WarehouseId: number;
	WarehouseName: string;
}

export interface ProductStocksReportDTO {
	BusinessName: string;
	Cif: string;
	FiscalName: string;
	From: Date;
	Stocks: ProductStocksDTO[];
	To: Date;
}

export interface ProductTagDTO {
	Id: number;
	ImageContent: string;
	ImageId: string;
	Name: string;
}

export interface ProductTagForEditionDTO {
	Id: number;
	ImageContent: string;
	ImageId: string;
	Name: string;
}

export interface ProductTagInListDTO {
	Id: number;
	ImageContent: string;
	Name: string;
}

export interface ProductUnitDTO {
	ProductId: number;
	UnitId: number;
}

export interface ProductWithRecipeDTO {
	Id: number;
	ImageId: string;
	Name: string;
	PreparationOrder: string;
	PreparationTimeInMinutes: Nullable<number>;
	PreparationType: string;
	SaleFormatId: number;
}

export interface PurchaseDetailsBySupplierDTO {
	ApplySurcharge: boolean;
	CashDiscount: number;
	Date: Date;
	DiscountPercentage: number;
	DocumentNumber: string;
	GlobalCashDiscount: number;
	GlobalDiscountPercentage: number;
	ProductName: string;
	PurchaseUnit: string;
	Quantity: number;
	SupplierDocumentNumber: string;
	SupplierId: number;
	SurchargePercentage: number;
	Tax10Gross: number;
	Tax10Net: number;
	Tax10Surcharge: number;
	Tax10SurchargePercentage: number;
	Tax10Tax: number;
	Tax10TaxPercentage: number;
	Tax1Gross: number;
	Tax1Net: number;
	Tax1Surcharge: number;
	Tax1SurchargePercentage: number;
	Tax1Tax: number;
	Tax1TaxPercentage: number;
	Tax2Gross: number;
	Tax2Net: number;
	Tax2Surcharge: number;
	Tax2SurchargePercentage: number;
	Tax2Tax: number;
	Tax2TaxPercentage: number;
	Tax3Gross: number;
	Tax3Net: number;
	Tax3Surcharge: number;
	Tax3SurchargePercentage: number;
	Tax3Tax: number;
	Tax3TaxPercentage: number;
	Tax4Gross: number;
	Tax4Net: number;
	Tax4Surcharge: number;
	Tax4SurchargePercentage: number;
	Tax4Tax: number;
	Tax4TaxPercentage: number;
	Tax5Gross: number;
	Tax5Net: number;
	Tax5Surcharge: number;
	Tax5SurchargePercentage: number;
	Tax5Tax: number;
	Tax5TaxPercentage: number;
	Tax6Gross: number;
	Tax6Net: number;
	Tax6Surcharge: number;
	Tax6SurchargePercentage: number;
	Tax6Tax: number;
	Tax6TaxPercentage: number;
	Tax7Gross: number;
	Tax7Net: number;
	Tax7Surcharge: number;
	Tax7SurchargePercentage: number;
	Tax7Tax: number;
	Tax7TaxPercentage: number;
	Tax8Gross: number;
	Tax8Net: number;
	Tax8Surcharge: number;
	Tax8SurchargePercentage: number;
	Tax8Tax: number;
	Tax8TaxPercentage: number;
	Tax9Gross: number;
	Tax9Net: number;
	Tax9Surcharge: number;
	Tax9SurchargePercentage: number;
	Tax9Tax: number;
	Tax9TaxPercentage: number;
	TotalAmount: number;
	UnitPrice: number;
	VatPercentage: number;
	WarehouseId: number;
	WarehouseName: string;
}

export interface PurchaseDetailsBySupplierReportDTO {
	BusinessName: string;
	Cif: string;
	FiscalName: string;
	From: Date;
	Purchases: PurchaseDetailsBySupplierDTO[];
	To: Date;
}

export interface PurchaseDocumentErrorDTO {
	Error: string;
	SerialNumber: string;
}

export interface PurchasedOrProducedProductLabelDTO {
	Color: ColorDTO;
	Lot: LotInDocumentDTO;
	ProductId: number;
	ProductName: string;
	Quantity: number;
	Size: SizeDTO;
}

export interface PurchasedProductDTO {
	Color: ColorDTO;
	Id: number;
	Name: string;
	Size: SizeDTO;
	SupplierReference: string;
	SurchargeRate: number;
	Unit: UnitOfMeasurementDTO;
	VatId: number;
	VatRate: number;
}

export interface PurchaseInvoiceDetailsDTO {
	Date: Date;
	Gross: number;
	Id: number;
	Net: number;
	Number: number;
	PaidAmount: number;
	PaymentMethods: string;
	PendingAmount: number;
	Serie: string;
	Status: PurchaseInvoiceStatus;
	SupplierAccountCode: string;
	SupplierCif: string;
	SupplierDocumentNumber: string;
	SupplierFiscalName: string;
	Surcharge: number;
	Tax: number;
	Tax10Gross: number;
	Tax10Net: number;
	Tax10Surcharge: number;
	Tax10SurchargePercentage: number;
	Tax10Tax: number;
	Tax10VatPercentage: number;
	Tax1Gross: number;
	Tax1Net: number;
	Tax1Surcharge: number;
	Tax1SurchargePercentage: number;
	Tax1Tax: number;
	Tax1VatPercentage: number;
	Tax2Gross: number;
	Tax2Net: number;
	Tax2Surcharge: number;
	Tax2SurchargePercentage: number;
	Tax2Tax: number;
	Tax2VatPercentage: number;
	Tax3Gross: number;
	Tax3Net: number;
	Tax3Surcharge: number;
	Tax3SurchargePercentage: number;
	Tax3Tax: number;
	Tax3VatPercentage: number;
	Tax4Gross: number;
	Tax4Net: number;
	Tax4Surcharge: number;
	Tax4SurchargePercentage: number;
	Tax4Tax: number;
	Tax4VatPercentage: number;
	Tax5Gross: number;
	Tax5Net: number;
	Tax5Surcharge: number;
	Tax5SurchargePercentage: number;
	Tax5Tax: number;
	Tax5VatPercentage: number;
	Tax6Gross: number;
	Tax6Net: number;
	Tax6Surcharge: number;
	Tax6SurchargePercentage: number;
	Tax6Tax: number;
	Tax6VatPercentage: number;
	Tax7Gross: number;
	Tax7Net: number;
	Tax7Surcharge: number;
	Tax7SurchargePercentage: number;
	Tax7Tax: number;
	Tax7VatPercentage: number;
	Tax8Gross: number;
	Tax8Net: number;
	Tax8Surcharge: number;
	Tax8SurchargePercentage: number;
	Tax8Tax: number;
	Tax8VatPercentage: number;
	Tax9Gross: number;
	Tax9Net: number;
	Tax9Surcharge: number;
	Tax9SurchargePercentage: number;
	Tax9Tax: number;
	Tax9VatPercentage: number;
	Warehouses: string;
}

export interface PurchaseInvoiceForEditionDTO {
	Date: Date;
	DeliveryNotes: IncomingDeliveryNoteInListDTO[];
	ExistingPaymentMethods: PaymentMethodInListDTO[];
	ExistingSuppliers: SupplierDetailsDTO[];
	HasBeenSentByEmail: boolean;
	Id: number;
	Payments: PurchaseInvoicePaymentDTO[];
	ReceptionDate: Date;
	SerialNumber: SerialNumberDTO;
	Status: PurchaseInvoiceStatus;
	Supplier: SupplierDetailsDTO;
	SupplierDocumentNumber: string;
	TaxDeltas: TaxDeltaDTO[];
}

export interface PurchaseInvoiceInListDTO {
	Date: Date;
	GrossAmount: number;
	HasBeenSentByEmail: boolean;
	Id: number;
	NetAmount: number;
	Number: number;
	PendingAmount: number;
	ReceptionDate: Date;
	Serie: string;
	Status: PurchaseInvoiceStatus;
	SupplierDocumentNumber: string;
	SupplierName: string;
	Warehouses: string;
}

export interface PurchaseInvoicePaymentDTO {
	Amount: number;
	Date: Date;
	Id: number;
	Method: PaymentMethodInListDTO;
}

export interface PurchaseOrderForDeliveryDTO {
	CashDiscount: number;
	DeliveryDate: Nullable<Date>;
	DiscountPercentage: number;
	GrossAmount: number;
	Id: number;
	Lines: PurchaseOrderLineForDeliveryDTO[];
	NetAmount: number;
	Number: number;
	OrderedDate: Date;
	Serie: string;
	SupplierDocumentNumber: string;
}

export interface PurchaseOrderForEditionDTO {
	CashDiscount: number;
	Company: CompanyDTO;
	DeliveryDate: Nullable<Date>;
	DisableAudit: boolean;
	DiscountPercentage: number;
	ExistingSuppliers: SupplierDetailsDTO[];
	ExistingWarehouses: WarehouseByUserDTO[];
	HasBeenSentByEmail: boolean;
	Id: number;
	Lines: PurchaseOrderLineForEditionDTO[];
	Notes: string;
	OrderDate: Date;
	SerialNumber: SerialNumberDTO;
	Status: PurchaseOrderStatus;
	Supplier: SupplierDetailsDTO;
	SupplierDocumentNumber: string;
	TaxDeltas: TaxDeltaDTO[];
	Warehouse: WarehouseByUserDTO;
}

export interface PurchaseOrderInListDTO {
	DeliveryDate: Nullable<Date>;
	GrossAmount: number;
	HasBeenSentByEmail: boolean;
	Id: number;
	NetAmount: number;
	Number: number;
	OrderDate: Date;
	Serie: string;
	Status: PurchaseOrderStatus;
	SupplierDocumentNumber: string;
	SupplierId: number;
	SupplierName: string;
	Warehouse: string;
	WarehouseId: number;
}

export interface PurchaseOrderLineForDeliveryDTO {
	CashDiscount: number;
	DeliveringQuantityInPurchaseUnit: number;
	DiscountPercentage: number;
	HasPurchaseConditionApplied: boolean;
	Id: number;
	Notes: string;
	PendingQuantityInPurchaseUnit: number;
	PricePerPurchaseUnit: number;
	Product: PurchasedProductDTO;
	PurchaseUnit: UnitOfMeasurementDTO;
	TotalAmount: number;
}

export interface PurchaseOrderLineForEditionDTO {
	CashDiscount: number;
	DeliveredQuantityInPurchaseUnits: number;
	DiscountPercentage: number;
	HasPurchaseConditionApplied: boolean;
	Id: number;
	Notes: string;
	OrderedQuantityInPurchaseUnit: number;
	PricePerPurchaseUnit: number;
	Product: PurchasedProductDTO;
}

export interface PurchasePricesDTO {
	ActualStock: number;
	FamilyName: string;
	LastPurchaseDate: Nullable<Date>;
	LastPurchaseQuantity: Nullable<number>;
	LastPurchaseTotalAmount: Nullable<number>;
	MaxStock: Nullable<number>;
	MinStock: Nullable<number>;
	ProductId: number;
	ProductName: string;
	PurchaseConditionCashDiscount: Nullable<number>;
	PurchaseConditionDiscountPercentage: Nullable<number>;
	PurchaseConditionPrice: Nullable<number>;
	PurchaseConditionSupplierReference: string;
	TotalAmount: number;
	TotalQuantity: number;
	UnitId: number;
	UnitName: string;
	UnitToBaseFactor: number;
}

export interface PurchasePricesReportDTO {
	BusinessName: string;
	FiscalName: string;
	From: Date;
	SupplierBusinessName: string;
	SupplierCIF: string;
	SupplierFiscalName: string;
	SupplierPurchases: PurchasePricesDTO[];
	To: Date;
}

export interface PurchasesAnalyticsDTO {
	CashDiscount: number;
	Categories: string;
	Color: string;
	DeliveryNote: string;
	DeliveryNoteDate: Date;
	DeliveryNoteDayOfWeek: number;
	DeliveryNoteId: number;
	DeliveryNoteMonth: number;
	DeliveryNoteStatus: IncomingDeliveryNoteStatus;
	DeliveryNoteSupplierDocument: string;
	DeliveryNoteWeekOfYear: number;
	DeliveryNoteYear: number;
	DiscountPercentage: number;
	Family: string;
	Gross: number;
	Invoice: string;
	InvoiceDate: Nullable<Date>;
	InvoiceDayOfWeek: number;
	InvoiceId: Nullable<number>;
	InvoiceMonth: number;
	InvoiceStatus: Nullable<PurchaseInvoiceStatus>;
	InvoiceStatusAsInt: Nullable<number>;
	InvoiceSupplierDocument: string;
	InvoiceWeekOfYear: number;
	InvoiceYear: number;
	MajorGroup: string;
	Net: number;
	PricePerPurchaseUnit: number;
	PricePerSaleUnit: number;
	Product: string;
	ProductSupplierReference: string;
	QuantityInPurchaseUnit: number;
	QuantityInSaleUnit: number;
	Size: string;
	SupplierFiscalName: string;
	Unit: string;
	UnitSystem: string;
	WarehouseFiscalName: string;
	WarehouseName: string;
}

export interface PurchasesAnalyticsReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Purchases: PurchasesAnalyticsDTO[];
	To: Date;
}

export interface PurchaseSupplierConditionDTO {
	CashDiscount: number;
	DiscountPercentage: number;
	From: Date;
	Price: number;
	To: Date;
	Unit: UnitOfMeasurementDTO;
	Warehouse: WarehouseInListDTO;
}

export interface QuantityByLotDTO {
	Lot: LotInDocumentDTO;
	Quantity: number;
}

export interface QuantityByProductLineDTO {
	AvailableUnits: UnitOfMeasurementDTO[];
	HasLotControl: boolean;
	Notes: string;
	OrderId: number;
	Product: SoldProductDTO;
	ProductId: number;
	Quantity: number;
	TicketLineId: number;
}

export interface QuantityLineDTO {
	OrderId: number;
	Quantity: number;
	SoldLotByProduct: SoldLotBySoldProductDTO;
	TicketLineId: number;
}

export interface RdlBodyDTO {
	Description: string;
	FileName: string;
}

export interface RdlTemplateForEditionDTO {
	AvailableLanguages: string[];
	Body: RdlBodyDTO;
	ConsolidateLines: boolean;
	CreateStandardInvoiceDigitalMenu: DigitalMenuInListDTO;
	ExistingBodies: RdlBodyDTO[];
	ExistingDigitalMenus: DigitalMenuInListDTO[];
	ExistingLinesOrderTypes: LinesOrderType[];
	ExistingPosGroups: PosGroupInListDTO[];
	HidePrices: boolean;
	Id: number;
	InstalledPrinters: string[];
	Language: string;
	LinesOrder: LinesOrderType;
	Name: string;
	RdlFooterXmlContent: string;
	RdlHeaderXmlContent: string;
	ShowAllPrepayments: boolean;
	ShowConsumedCouponInLine: boolean;
	ShowCreateStandardInvoiceQR: boolean;
	ShowDeliveryNoteDetailsInInvoice: boolean;
	ShowDocumentLocation: boolean;
	ShowFreeLines: boolean;
	ShowFreeLinesText: string;
	ShowMenuLines: boolean;
	ShowReference: boolean;
	ShowRegisteredTip: boolean;
	ShowTableCompanions: boolean;
	ShowTicketId: boolean;
	ShowTicketLineNotes: boolean;
	ShowTime: boolean;
	ShowUserName: boolean;
	ShowVatCode: boolean;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface RecentSaleDTO {
	Addins: string[];
	BusinessDay: Date;
	CashDiscount: number;
	ColorId: number;
	ColorName: string;
	DiscountRate: number;
	FamilyName: string;
	MenuTag: string;
	Price: number;
	Quantity: number;
	SaleFormatId: number;
	SaleFormatName: string;
	SizeId: number;
	SizeName: string;
	TotalAmount: number;
	UserName: string;
}

export interface RecipeDetailsDTO {
	ImageId: string;
	Items: RecipeItemDetailsDTO[];
	Notes: string;
	PreparationOrder: string;
	PreparationTimeInMinutes: Nullable<number>;
	PreparationType: string;
	ProductId: number;
	ProductName: string;
}

export interface RecipeForEditionDTO {
	Notes: string;
	ParentId: number;
	RecipeItems: RecipeItemDTO[];
	Unit: UnitOfMeasurementDTO;
}

export interface RecipeIngredientDTO {
	ProductId: number;
	SaleFormatId: number;
	SaleFormatName: string;
	Style: StyleDTO;
}

export interface RecipeItemCostPricesDTO {
	AvgCostPrice: number;
	CostPrices: CostPriceByWarehouseDTO[];
	IngredientId: number;
	WeightedAvgCostPrice: number;
}

export interface RecipeItemDetailsDTO {
	ProductId: number;
	ProductName: string;
	Quantity: number;
	ShrinkPercentage: number;
	UnitName: string;
}

export interface RecipeItemDTO {
	BaseUnit: string;
	Ingredient: IngredientDTO;
	QuantityInSaleUnit: number;
	ShrinkPercentage: number;
}

export interface RegisterCashTransactionResultDTO {
	Printed: boolean;
	Registered: boolean;
}

export interface RegularSupplierDTO {
	Conditions: PurchaseSupplierConditionDTO[];
	References: SupplierReferenceDTO[];
	SupplierFiscalName: string;
	SupplierId: number;
}

export interface RelatedAddinDTO {
	AddinName: string;
	AddinRoleName: string;
	Id: number;
}

export interface RelatedMenuDTO {
	Id: number;
	MenuGroupName: string;
	MenuName: string;
}

export interface RelatedOrderDTO {
	BusinessDay: Date;
	Id: number;
}

export interface RelatedRecipeItemDTO {
	Id: number;
	ProductName: string;
	Quantity: number;
	ShrinkPercentage: number;
}

export interface RemovedIngredientDTO {
	ProductId: number;
	SaleFormatId: number;
	SaleFormatName: string;
	Style: StyleDTO;
}

export interface RemovePosGroupFromMultipleSaleCentersParamsDTO {
	PosGroup: PosGroupInListDTO;
	SaleCenters: SaleCenterForEditionDTO[];
}

export interface RemovePosGroupFromMultipleWarehousesParamsDTO {
	PosGroup: PosGroupInListDTO;
	Warehouses: WarehouseForEditionDTO[];
}

export interface ReopenDeliveryNoteParamsFromPosDTO {
	Location: TicketLocationDTO;
	TargetTicketId: Nullable<number>;
}

export interface ReopenInvoiceParamsFromPosDTO {
	Location: TicketLocationDTO;
	TargetTicketId: Nullable<number>;
}

export interface ReopenSalesOrderParamsFromPosDTO {
	Location: TicketLocationDTO;
	TargetTicketId: Nullable<number>;
}

export interface ReportViewDTO {
	IsDefault: boolean;
	JsonConfiguration: string;
	Name: string;
	ReportId: string;
}

export interface ResellerBannerDTO {
	Action: string;
	Base64Image: string;
}

export interface RestaurantStatusDTO {
	Maps: MapDTO[];
	SaleCenters: SaleCenterStatusDTO[];
}

export interface RestockProposalDTO {
	CurrentStockInSaleUnits: number;
	IsFromPurchaseCondition: boolean;
	LastCashDiscount: Nullable<number>;
	LastDiscountPercentage: Nullable<number>;
	MaxStockInSaleUnits: number;
	MinStockInSaleUnits: number;
	PendingQtyInSaleUnits: number;
	PricePerPurchaseUnit: number;
	Product: PurchasedProductDTO;
	RegularSupplierId: number;
	RestockQtyInPurchaseUnits: number;
}

export interface RewardDTO {
	Code: string;
	Description: string;
	Name: string;
	RewardId: string;
	Type: RewardType;
	Value: Nullable<number>;
}

export interface SaleCenterByUserDTO {
	Id: number;
	Name: string;
}

export interface SaleCenterForEditionDTO {
	AskForFriendlyName: WhenAskForFriendlyName;
	AskForTableCompanions: WhenAskForTableCompanions;
	BasicInvoicePrinterType: DocumentPrinterType;
	DefaultPriceList: PriceListInListDTO;
	DefaultProductGroup: ProductGroupDTO;
	DeliveryNotePrinterType: DocumentPrinterType;
	EnableInactivityConfiguration: boolean;
	ExistingDocumentPrinterTypes: DocumentPrinterType[];
	ExistingLocationButtonAmountMode: LocationButtonAmountMode[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingPriceLists: PriceListInListDTO[];
	ExistingProductGroups: ProductGroupDTO[];
	ExistingWarehouses: WarehouseInListDTO[];
	ExistingWhenAskForFriendlyNames: WhenAskForFriendlyName[];
	ExistingWhenAskForTableCompanions: WhenAskForTableCompanions[];
	GuestFee: GuestFeeDTO;
	Id: number;
	LocationButtonAmountMode: LocationButtonAmountMode;
	Locations: string[];
	MinTableCompanionAmount: number;
	MinutesInactivityConfiguration: number;
	Name: string;
	Priority: number;
	StandardInvoicePrinterType: DocumentPrinterType;
	StartTakeOutOrderOnOpenTicket: boolean;
	Style: StyleForEditionDTO;
	TicketPrinterType: DocumentPrinterType;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
	Warehouse: WarehouseInListDTO;
}

export interface SaleCenterInListDTO {
	FullName: string;
	GroupsSummary: string;
	Id: number;
	Name: string;
	PriceList: string;
	PriceListType: TicketType;
	Priority: number;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface SaleCenterOccupancyWidgetDTO {
	Occupancy: OccupancyWidgetDTO;
	SaleCenterId: number;
	SaleCenterName: string;
}

export interface SaleCenterSalesByTimeFrameDTO {
	InvoiceCount: number;
	NetAmount: number;
	SaleCenterId: number;
	SaleCenterName: string;
	TimeFrameGroupId: number;
	TimeFrameIndex: number;
	TimeFrameName: string;
}

export interface SaleCenterSalesByTimeFrameReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: SaleCenterSalesByTimeFrameDTO[];
	To: Date;
}

export interface SaleCenterSalesDTO {
	AvgTableCompanions: number;
	BasicInvoicesCount: number;
	BasicRefundCount: number;
	CancellationCount: number;
	DeliveryNoteCount: number;
	GrossBasicInvoices: number;
	GrossBasicRefund: number;
	GrossCancellations: number;
	GrossDeliveryNotes: number;
	GrossStandardInvoices: number;
	GrossStandardRefund: number;
	NetBasicInvoices: number;
	NetBasicRefund: number;
	NetCancellations: number;
	NetDeliveryNotes: number;
	NetStandardInvoices: number;
	NetStandardRefund: number;
	SaleCenterId: number;
	SaleCenterName: string;
	StandardInvoicesCount: number;
	StandardRefundCount: number;
	TableCompanions: number;
}

export interface SaleCenterSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: SaleCenterSalesDTO[];
	To: Date;
}

export interface SaleCenterStatusDTO {
	AskForFriendlyName: WhenAskForFriendlyName;
	AskForTableCompanions: WhenAskForTableCompanions;
	Id: number;
	PriceList: PriceListDTO;
	SaleLocations: SaleLocationStatusDTO[];
	Style: StyleDTO;
}

export interface SaleDTO {
	ChangeAmount: number;
	DocumentId: number;
	NetAmount: number;
	PaidAmount: number;
	SerialNumber: SerialNumberDTO;
}

export interface SaleFormatForEditionDTO {
	AddinRoles: AddinRoleForEditionDTO[];
	AskForAddins: boolean;
	DocumentText: TranslatableStringDTO;
	Id: number;
	Name: TranslatableStringDTO;
	PreparationText: TranslatableStringDTO;
	PreparationTimeInMinutes: Nullable<number>;
	PreparationTimeWarningMinutes: Nullable<number>;
	Prices: ProductPriceDTO[];
	Ratio: number;
	SaleableAsAddin: boolean;
	SaleableAsMain: boolean;
	SpecialPrices: CustomerSpecialPriceForSaleFormatEditionDTO[];
	Style: StyleForEditionDTO;
}

export interface SaleFormatForKeyDTO {
	Barcode: string;
	FamilyName: string;
	Id: number;
	Name: string;
	PLU: string;
}

export interface SaleFormatInGroupDTO {
	CategorySummary: string;
	FamilyName: string;
	Id: number;
	Name: string;
}

export interface SaleFormatInListDTO {
	CategorySummary: string;
	FamilyName: string;
	Id: number;
	Name: string;
	ProductId: number;
	ProductName: string;
}

export interface SaleFormatPriceDTO {
	AddinPrice: Nullable<number>;
	MainPrice: Nullable<number>;
	MenuItemPrice: Nullable<number>;
	PriceListId: number;
	PriceListName: string;
	PriceListTicketType: TicketType;
	SaleFormatId: number;
	SaleFormatName: string;
}

export interface SaleLocationSalesDTO {
	GuestAmount: Nullable<number>;
	GuestCount: Nullable<number>;
	InvoiceCount: number;
	NetAmount: number;
	SaleCenterId: number;
	SaleCenterName: string;
	SaleLocationName: string;
}

export interface SaleLocationSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: SaleLocationSalesDTO[];
	To: Date;
}

export interface SaleLocationStatusDTO {
	Amount: number;
	AmountMode: LocationButtonAmountMode;
	DisplayName: string;
	HasOpenedTickets: boolean;
	IsInactive: boolean;
	OpenerUserName: string;
	TableCompanions: Nullable<number>;
	TicketHasBeenPrepared: boolean;
	TicketHasBeenPresented: boolean;
	TicketLocation: TicketLocationDTO;
}

export interface SalesAnalyticsDTO {
	BusinessDay: Date;
	Categories: string;
	Cost: number;
	Customer: string;
	CustomerType: string;
	DayOfWeek: number;
	Discount: string;
	DocumentId: number;
	DocumentIsDeliveryNote: boolean;
	DocumentNumber: string;
	Family: string;
	Gross: number;
	LineType: string;
	MajorGroup: string;
	Margin: number;
	Month: number;
	Net: number;
	Offer: string;
	Pos: string;
	PosGroup: string;
	PriceList: string;
	Product: string;
	Quantity: number;
	SaleCenter: string;
	SaleFormat: string;
	TimeFrame: string;
	User: string;
	UserProfile: string;
	WeekOfYear: number;
	Workplace: string;
	Year: number;
}

export interface SalesAnalyticsReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: SalesAnalyticsDTO[];
	To: Date;
}

export interface SalesOrderDetailsDTO {
	AuditEvents: AuditEventDTO[];
	Previews: PrintPreviewDTO[];
	SalesOrder: SalesOrderInListDTO;
}

export interface SalesOrderDraftDTO {
	DeliveryAddress: AddressDTO;
	DeliveryDate: Nullable<Date>;
	Notes: string;
	PreferredPaymentMethod: PaymentMethodDTO;
	SchedulePreparation: boolean;
	SerialNumber: SerialNumberDTO;
	Type: SalesOrderType;
}

export interface SalesOrderDTO {
	AddressSummary: string;
	CreationDate: Date;
	Customer: BuyerCustomerDTO;
	CustomerDocumentNumber: string;
	CustomerEmail: string;
	CustomerPhone: string;
	DeliveryDate: Nullable<Date>;
	DeliveryPerson: string;
	DeliveryStatus: DeliveryStatus;
	HasOrderedOrRequestedLines: boolean;
	Id: number;
	IsFrozen: boolean;
	IsInvoiced: boolean;
	Location: string;
	NetAmount: number;
	Notes: string;
	Number: number;
	PendingAmount: number;
	PosId: number;
	PosName: string;
	PreferredPaymentMethodId: Nullable<number>;
	PreferredPaymentMethodName: string;
	PrepaidAmount: number;
	SerialNumber: string;
	Serie: string;
	TableCompanions: Nullable<number>;
	TicketGlobalId: string;
	TicketId: number;
	Type: SalesOrderType;
	UserName: string;
}

export interface SalesOrderInListDTO {
	BusinessDay: Date;
	CompletionDate: Nullable<Date>;
	CompletionPos: string;
	CompletionPosId: number;
	CompletionUser: string;
	CreationDate: Date;
	CreationPos: string;
	CreationPosId: number;
	CreationUser: string;
	CustomerAccountCode: string;
	CustomerBusinessName: string;
	CustomerCif: string;
	CustomerCity: string;
	CustomerContact: string;
	CustomerCountryCode: string;
	CustomerDocumentNumber: string;
	CustomerEmail: string;
	CustomerFiscalName: string;
	CustomerId: number;
	CustomerPhone: string;
	CustomerRegion: string;
	CustomerStreet: string;
	CustomerZipCode: string;
	DeliveryDate: Nullable<Date>;
	DeliveryPerson: string;
	DeliveryStatus: DeliveryStatus;
	Id: number;
	InvoiceId: number;
	InvoiceNumber: number;
	InvoiceSerialNumber: string;
	InvoiceSerie: string;
	IsForTraining: boolean;
	Notes: string;
	PaidAmount: number;
	PaymentMethod: string;
	PendingAmount: number;
	SaleCenter: string;
	SaleLocation: string;
	SalesOrderNumber: number;
	SalesOrderSerialNumber: string;
	SalesOrderSerie: string;
	Status: SalesOrderStatus;
	TableCompanions: Nullable<number>;
	TicketId: number;
	TotalAmount: number;
	Type: SalesOrderType;
	Workplace: string;
}

export interface SalesOrderLineDetailsDTO {
	BusinessDay: Date;
	CashDiscount: number;
	CostPrice: number;
	CustomerAccountCode: string;
	CustomerCif: string;
	CustomerCity: string;
	CustomerCountryCode: string;
	CustomerFiscalName: string;
	CustomerRegion: string;
	CustomerStreet: string;
	CustomerZipCode: string;
	DeliveryPerson: string;
	DeliveryStatus: DeliveryStatus;
	DiscountCode: string;
	DiscountPercentage: number;
	Family: string;
	GrossAmount: number;
	Id: number;
	InvoiceNumber: number;
	InvoiceSerie: string;
	IsLine: boolean;
	LineType: SoldProductType;
	MajorGroup: string;
	NetAmount: number;
	Number: number;
	OfferCode: string;
	Pos: string;
	PosId: number;
	ProductPrice: number;
	Quantity: number;
	SaleCenter: string;
	SaleFormat: string;
	SaleFormatId: number;
	SaleLocation: string;
	SalesOrderCreationDate: Date;
	Serie: string;
	Status: SalesOrderStatus;
	SurchargePercentage: number;
	TicketCashDiscount: number;
	TicketDiscountPercentage: number;
	Type: SalesOrderType;
	User: string;
	VatPercentage: number;
	Workplace: string;
}

export interface SalesOrderParamsFromPosDTO {
	CustomerDocumentNumber: string;
	DeliveryAddress: AddressDTO;
	DeliveryDate: Nullable<Date>;
	DraftSerialNumber: SerialNumberDTO;
	IsRefund: boolean;
	Notes: string;
	Payments: PaymentDTO[];
	PrepayAmount: number;
	SchedulePreparation: boolean;
	ShouldPrint: boolean;
}

export interface SalesOrderParamsFromTakeOutDTO {
	DeliveryAddress: AddressDTO;
	DeliveryDate: Date;
	DraftSerialNumber: SerialNumberDTO;
	Notes: string;
	PreferredPaymentMethod: PaymentMethodDTO;
	Type: SalesOrderType;
}

export interface SalesWidgetDTO {
	ThisMonth: number;
	ThisWeek: number;
	ThisYear: number;
	Today: number;
}

export interface SampleLabelDTO {
	Allergens: AllergenInListDTO[];
	Barcode: string;
	Color: string;
	ExpirationDate: Date;
	LabelContent: string;
	LabelLines: string[];
	LotNotes: string;
	LotNumber: string;
	PackingDate: Date;
	Size: string;
}

export interface ScaleConfigurationDTO {
	PortConfig: SerialPortConfigurationDTO;
	ScaleEnabled: boolean;
}

export interface ScaleCounterForEditionDTO {
	Category: CategoryInListDTO;
	CounterNumber: number;
	ExistingCategories: CategoryInListDTO[];
	ExistingPriceLists: PriceListInListDTO[];
	ExistingWorkplaces: WorkplaceInListDTO[];
	Id: number;
	Keys: ScaleKeyDTO[];
	KeyTableColumns: number;
	KeyTableRows: number;
	KeyTables: number;
	Name: string;
	PriceList: PriceListInListDTO;
	ScaleCount: number;
	Sections: ScaleSectionDTO[];
	Workplace: WorkplaceInListDTO;
}

export interface ScaleCounterInListDTO {
	AssignedWorkplace: string;
	CounterNumber: number;
	Id: number;
	Name: string;
	ScaleCount: number;
}

export interface ScaleKeyDTO {
	Column: number;
	Row: number;
	SaleFormat: SaleFormatForKeyDTO;
	Table: number;
}

export interface ScaleSaleItemDTO {
	CreationDate: Date;
	HasBeenRead: boolean;
	Id: number;
	PLU: string;
	Quantity: number;
	SaleFormatName: string;
	Scale: string;
	Ticket: string;
	UnitPrice: number;
	User: string;
	WorkplaceId: number;
}

export interface ScaleSectionDTO {
	Family: FamilyForSectionDTO;
	Section: string;
}

export interface ScaleTicketDTO {
	Date: Date;
	Items: ScaleTicketItemDTO[];
	ItemsCount: number;
	Scale: string;
	Ticket: string;
	Total: number;
	User: string;
}

export interface ScaleTicketItemDTO {
	PLU: string;
	Price: number;
	Product: string;
	Quantity: number;
	Total: number;
}

export interface SearchTakeOutOrderResultDTO {
	Previews: PrintPreviewDTO[];
	SalesOrder: SalesOrderDTO;
}

export interface SendDocumentEmailResultDTO {
	Error: string;
}

export interface SenderDTO {
	ApplicationName: string;
	ApplicationVersion: string;
	LanguageCode: string;
	MachineId: string;
	MachineName: string;
	MachineType: MachineType;
	PosId: Nullable<number>;
	PosName: string;
	UserId: Nullable<number>;
	UserName: string;
}

export interface SerialNumberDTO {
	Number: number;
	SerieName: string;
}

export interface SerialPortConfigurationDTO {
	BaudRate: number;
	DataBits: number;
	Handshake: Handshake;
	Parity: Parity;
	PortName: string;
	StopBits: StopBits;
}

export interface SerieForEditionDTO {
	ExistingTypes: DocumentType[];
	Id: number;
	IsInUse: boolean;
	Name: string;
	NewNextNumber: number;
	Type: DocumentType;
}

export interface SerieInListDTO {
	AssignedWorkplaceOrWarehouse: string;
	Id: number;
	IsInUse: boolean;
	Name: string;
	NextNumber: number;
	Type: DocumentType;
}

export interface ServiceChargeDTO {
	ApplyTo: TicketType;
	ExistingTaxes: VatDTO[];
	ExistingTicketType: TicketType[];
	IgnoreTicketDiscounts: boolean;
	Percentage: number;
	Vat: VatDTO;
}

export interface SessionDTO {
	AdminHttpPort: number;
	AdminHttpUseSsl: boolean;
	AfterCloseTicketAction: FlowAction;
	AfterOpenCashdrawerAction: FlowAction;
	AfterPrepareTicketAction: FlowAction;
	AfterPrintTicketAction: FlowAction;
	AllowCashTransactions: boolean;
	AllowPrintTicketGift: boolean;
	CardProcessorType: Nullable<CardTransactionType>;
	DefaultLocation: DefaultLocationInSessionDTO;
	DeliveryNoteWhenPrint: WhenPrint;
	DeviceAskGratuity: boolean;
	EnableAttendanceModule: boolean;
	EnableAutoCloseSession: boolean;
	EnableCardProcessorModule: boolean;
	EnableCashControlModule: boolean;
	EnableCctvModule: boolean;
	EnableDelivery: boolean;
	EnableEmailingModule: boolean;
	EnableGStockModule: boolean;
	EnableKitchenDisplayModule: boolean;
	EnableOnlineReservationModule: boolean;
	EnablePayoutReport: boolean;
	EnablePriceListSchedulerModule: boolean;
	EnableSaleFormatsModule: boolean;
	EnableScaleSystemModule: boolean;
	EnableSchedulePreparation: boolean;
	EnableSizeAndColorModule: boolean;
	EnableSmartMenu: boolean;
	EnableStockModule: boolean;
	EnableTablePaymentModule: boolean;
	EnableTicketBAIModule: boolean;
	EnableTraceabilityModule: boolean;
	HasCashdrawer: boolean;
	HubUrl: string;
	IncludeLineCancellationReason: boolean;
	InstallationType: InstallationType;
	InternalConsumptionCustomerType: CustomerTypeInListDTO;
	InvoiceWhenPrint: WhenPrint;
	IsLite: boolean;
	IsTrainingMode: boolean;
	LanguageCode: string;
	MakeBalanceOnCloseDay: boolean;
	MasterHasCashControl: boolean;
	MasterPosId: number;
	MaxAllowedBasicInvoicePaymentAmount: Nullable<number>;
	Permissions: Permission[];
	PosId: number;
	PosName: string;
	ScaleSystemType: ScaleType;
	SearchMode: SearchMode;
	SecondsToAutoCloseSession: number;
	ShowLastSaleInLoginView: boolean;
	ShowLastSaleInSelectLocationView: boolean;
	ShowTicketPreviewBeforePrint: boolean;
	SoldProductTranslationPolicy: SoldProductTranslationPolicy;
	SuggestedTipRates: number[];
	TicketWhenPrint: WhenPrint;
	TipSettingsMode: TipSettingsMode;
	UseAutomaticPreparation: boolean;
	UseCardProcessor: boolean;
	UseCashControl: boolean;
	UseCashControlBlindOpening: boolean;
	UsePreparationNumber: boolean;
	UserBackColor: string;
	UserId: number;
	UserImageId: string;
	UserName: string;
	UseScale: boolean;
	UseTablePayment: boolean;
	WarnOnTicketCreatedByOtherUser: boolean;
	WarnOnTicketInUseByOtherUser: boolean;
}

export interface SetPosGroupsToMultipleSaleCentersParamsDTO {
	SaleCenters: SaleCenterForEditionDTO[];
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface SetPosGroupsToMultipleWarehousesParamsDTO {
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
	Warehouses: WarehouseForEditionDTO[];
}

export interface SettingsFileForEditionDTO {
	Content: string;
	ExistingWorkplaces: WorkplaceInListDTO[];
	Id: number;
	Name: string;
	SelectedWorkplaces: WorkplaceInListDTO[];
	Type: SettingsFileType;
}

export interface SettingsFileInListDTO {
	Id: number;
	Name: string;
}

export interface SetWarehouseToMultipleSaleCentersParamsDTO {
	SaleCenters: SaleCenterForEditionDTO[];
	Warehouse: WarehouseInListDTO;
}

export interface SifSettingsForEditionDTO {
	AssignedWorkplaces: WorkplaceInListDTO[];
	CertFile: FileContentDTO;
	CertInfo: CertificateInfoDTO;
	CertPassword: string;
	Cif: string;
	ExistingWorkplaces: WorkplaceInListDTO[];
	FiscalName: string;
	Id: number;
	IsInUse: boolean;
	VerifactuScheduleActivation: Date;
}

export interface SifSettingsInListDTO {
	Cif: string;
	FiscalName: string;
	Id: number;
}

export interface SizeDTO {
	Id: number;
	Name: string;
	Priority: number;
}

export interface SizeForEditionDTO {
	Id: number;
	Name: TranslatableStringDTO;
}

export interface SizesAndColorsDTO {
	Colors: ColorDTO[];
	Sizes: SizeDTO[];
}

export interface SizesForEditionDTO {
	AvailableLanguageCodes: string[];
	Sizes: SizeForEditionDTO[];
}

export interface SmartMenuOrderSettingsForEditionDTO {
	AllowOrdersForAnotherDay: boolean;
	AllowSelectDeliveryTime: boolean;
	AllowSplitPayments: boolean;
	AskForPaymentMethodOnDelivery: boolean;
	AskForTableCompanions: boolean;
	DeliveryAreas: DeliveryAreaDTO[];
	DownloadTemplate: PrintTemplateInListDTO;
	EmailAccentColor: string;
	EmailAccount: EmailAccountInListDTO;
	EmailFooter: string;
	EmailHeader: string;
	EmitInvoiceOnNewPaidOrder: boolean;
	ExistingCustomerTypes: CustomerTypeInListDTO[];
	ExistingDeliveryStatuses: DeliveryStatus[];
	ExistingEmailAccounts: EmailAccountInListDTO[];
	ExistingLocations: DefaultLocationDTO[];
	ExistingPaymentMethods: PaymentMethodInListDTO[];
	ExistingPos: PosInListDTO[];
	ExistingPriceLists: PriceListInListDTO[];
	ExistingPrintTemplates: PrintTemplateInListDTO[];
	ExistingTypes: SmartMenuOrderSettingsType[];
	ExistingUsers: UserInListDTO[];
	Id: number;
	InvoicedOrderStatus: Nullable<DeliveryStatus>;
	IsConfiguredInWorkplace: boolean;
	MaxOrdersDays: Nullable<number>;
	Name: string;
	NewCustomerType: CustomerTypeInListDTO;
	NewOrderLocation: DefaultLocationDTO;
	NewPaidOrderStatus: DeliveryStatus;
	NewUnpaidOrderStatus: DeliveryStatus;
	NotifyOnAccepted: boolean;
	NotifyOnDelivered: boolean;
	NotifyOnDelivering: boolean;
	NotifyOnPrepared: boolean;
	NotifyOnPreparing: boolean;
	NotifyOnReceived: boolean;
	NotifyOnRejected: boolean;
	PaymentMethod: PaymentMethodInListDTO;
	PayOnDelivery: boolean;
	PayOnOrder: boolean;
	Pos: PosInListDTO;
	PriceList: PriceListInListDTO;
	Services: TakeOutServiceDTO[];
	TableOrderCustomer: CustomerInListDTO;
	TableOrderPreparePaidOrder: boolean;
	TableOrderPrepareUnpaidOrder: boolean;
	TakeAwayDeliveryTimeInMinutes: number;
	TakeAwayMinOrderAmount: number;
	Type: SmartMenuOrderSettingsType;
	User: UserInListDTO;
}

export interface SmartMenuOrderSettingsInListDTO {
	Id: number;
	Name: string;
	Type: SmartMenuOrderSettingsType;
	Workplace: string;
}

export interface SmartMenuPaymentSettingsDTO {
	AdyenSettings: AdyenSettingsDTO;
	DeliverySettings: SmartMenuOrderSettingsInListDTO;
	DownloadTemplate: PrintTemplateInListDTO;
	PlatformType: Nullable<PaymentPlatformType>;
	ScanAndPaySettings: SmartMenuOrderSettingsInListDTO;
	TableOrderSettings: SmartMenuOrderSettingsInListDTO;
	TakeAwaySettings: SmartMenuOrderSettingsInListDTO;
	UPaySettings: UPaySettingsDTO;
}

export interface SmartMenuPaymentStatusDTO {
	AdyenSettings: AdyenSettingsDTO;
	Connected: boolean;
	DeliveryStatus: SmartMenuOrderCommStatus;
	Enabled: boolean;
	Environment: SmartMenuPaymentEnvironment;
	LastActivity: Date;
	PlatformType: PaymentPlatformType;
	RejectReason: number;
	ScanAndPayStatus: SmartMenuOrderCommStatus;
	TableOrderSaleCenterStatus: TableOrderSaleCenterStatusDTO[];
	TableOrderStatus: SmartMenuOrderCommStatus;
	TakeAwayStatus: SmartMenuOrderCommStatus;
	UPaySettings: UPaySettingsDTO;
}

export interface SmartMenuPublishStatusDTO {
	Error: string;
	IsPublishing: boolean;
}

export interface SmartMenuWorkplaceGroupSettingsForEditionDTO {
	BaseDigitalMenu: DigitalMenuInListDTO;
	ExistingDigitalMenus: DigitalMenuInListDTO[];
	ExistingWorkplaces: WorkplaceInListDTO[];
	GroupId: string;
	Id: number;
	Name: string;
	Settings: DigitalMenuByWorkplaceSettingsForEditionDTO[];
	SmartMenuCenter: string;
}

export interface SmartMenuWorkplaceGroupSettingsInListDTO {
	Id: number;
	Name: string;
}

export interface SoftwareDTO {
	DeviceId: string;
	Name: string;
	Version: string;
}

export interface SoldLotBySoldProductDTO {
	LotId: number;
	LotNumber: string;
	SaleFormatId: number;
}

export interface SoldLotDTO {
	Id: number;
	Number: string;
}

export interface SoldProductDTO {
	Color: ColorDTO;
	GroupName: string;
	Lot: SoldLotDTO;
	PreparationOrderId: number;
	PreparationTypeId: number;
	Price: number;
	PriceListId: number;
	PrintMode: ProductPrintMode;
	ProductName: string;
	SaleFormatId: number;
	SaleFormatName: string;
	SaleFormatRatio: number;
	Size: SizeDTO;
	SurchargeRate: number;
	Type: SoldProductType;
	VatId: number;
	VatRate: number;
}

export interface SortableProductDTO {
	Id: number;
	Name: string;
	TypeName: string;
}

export interface SortableProductGroupDTO {
	Id: number;
	Name: string;
	TypeName: string;
}

export interface StartTakeOutOrderParamsDTO {
	Customer: BuyerCustomerDTO;
	DeliveryAddress: AddressDTO;
	DeliveryDate: Date;
	Type: SalesOrderType;
}

export interface StockChangeForEditionDTO {
	AllExistingWarehouses: WarehouseByUserDTO[];
	Date: Date;
	DisableAudit: boolean;
	ExistingSystemsOfMeasurement: SystemOfMeasurementForProductDTO[];
	ExistingTypes: StockChangeType[];
	ExistingWarehouseCloseDates: WarehouseCloseDateDTO[];
	ExistingWarehousesByUser: WarehouseByUserDTO[];
	FromWarehouse: WarehouseByUserDTO;
	Id: number;
	Lines: StockChangeLineForEditionDTO[];
	Reason: string;
	ReceptionDate: Nullable<Date>;
	ToWarehouse: WarehouseByUserDTO;
	TransferState: TransferState;
	Type: StockChangeType;
}

export interface StockChangeInListDTO {
	Date: Date;
	FromWarehouseId: number;
	FromWarehouseName: string;
	Id: number;
	Reason: string;
	ReceptionDate: Nullable<Date>;
	TotalCostPrice: number;
	ToWarehouseId: number;
	ToWarehouseName: string;
	TransferState: TransferState;
	Type: StockChangeType;
}

export interface StockChangeLineForEditionDTO {
	Id: number;
	Lot: LotInDocumentDTO;
	Product: StockedProductDTO;
	Quantity: number;
	TotalCostPrice: number;
}

export interface StockedProductDTO {
	Color: ColorDTO;
	CostPrice: number;
	HasLotControl: boolean;
	Id: number;
	Name: string;
	Size: SizeDTO;
	Unit: UnitOfMeasurementDTO;
}

export interface StockValueSummaryWidgetDTO {
	ThisMonth: number;
	ThisYear: number;
	Today: number;
}

export interface StorageOptionsDTO {
	Color: ColorDTO;
	CurrentStock: number;
	Location: string;
	MaxStock: number;
	MinStock: number;
	Size: SizeDTO;
	Warehouse: WarehouseInListDTO;
}

export interface StyleDTO {
	BackColor: string;
	ImageId: string;
	Text: string;
}

export interface StyleForEditionDTO {
	BackColor: string;
	ImageContent: string;
	Text: TranslatableStringDTO;
}

export interface SuggestedTipSettingsDTO {
	Tip1Percentage: number;
	Tip2Percentage: number;
	Tip3Percentage: number;
	Tip4Percentage: number;
	Tip5Percentage: number;
}

export interface SupplierByUserDTO {
	FiscalName: string;
	Id: number;
}

export interface SupplierDetailsDTO {
	Address: AddressDTO;
	ApplySurcharge: boolean;
	BusinessName: string;
	Cif: string;
	FiscalName: string;
	HidePrices: boolean;
	Id: number;
	Notes: string;
	ShowSupplierProductsInPurchaseDocumentOnly: boolean;
}

export interface SupplierForEditionDTO {
	AccountCode: string;
	Address: AddressDTO;
	ApplySurcharge: boolean;
	BusinessName: string;
	Cif: string;
	ContactPersons: ContactPersonDTO[];
	Email: string;
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingWarehouses: WarehouseInListDTO[];
	FiscalName: string;
	HidePrices: boolean;
	Id: number;
	Notes: string;
	ShowSupplierProductsInPurchaseDocumentOnly: boolean;
	Telephone: string;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
	WarnIfPurchaseDocumentAlreadyExists: boolean;
	Web: string;
}

export interface SupplierInListDTO {
	AccountCode: string;
	Address: AddressDTO;
	BusinessName: string;
	Cif: string;
	Email: string;
	FiscalName: string;
	GroupsSummary: string;
	Id: number;
	Telephone: string;
	WorkplaceSummary: string;
}

export interface SupplierInProductDTO {
	FiscalName: string;
	Id: number;
	IsInternalSupplier: boolean;
}

export interface SupplierNotesDTO {
	Note: string;
	Supplier: SupplierInListDTO;
}

export interface SupplierPurchasesDTO {
	GrossPurchases: number;
	InvoiceCount: number;
	NetPurchases: number;
	ProductGrossAmount: number;
	ProductId: number;
	ProductName: string;
	ProductPurchaseUnit: string;
	ProductQuantity: number;
	SupplierCif: string;
	SupplierId: number;
	SupplierName: string;
}

export interface SupplierPurchasesReportDTO {
	BusinessName: string;
	Cif: string;
	FiscalName: string;
	From: Date;
	Purchases: SupplierPurchasesDTO[];
	To: Date;
}

export interface SupplierReferenceDTO {
	SupplierReference: string;
	UnitId: number;
	UnitName: string;
}

export interface SystemCloseOutDTO {
	BusinessDay: Date;
	GrossAmount: number;
	Id: number;
	NetAmount: number;
	Number: number;
	ReportPreview: PrintPreviewDTO;
	TaxAmount: number;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface SystemOfMeasurementForEditionDTO {
	AdditionalUnits: UnitOfMeasurementDTO[];
	BaseUnit: string;
	Id: number;
	Name: string;
}

export interface SystemOfMeasurementForProductDTO {
	Id: number;
	Name: string;
	Units: UnitOfMeasurementDTO[];
}

export interface SystemOfMeasurementInListDTO {
	BaseUnit: string;
	Id: number;
	Name: string;
}

export interface TableCompanionsAvgBySaleCenterDTO {
	AvgTableCompanionCount: Nullable<number>;
	AvgTableCompanionNetAmount: Nullable<number>;
	AvgTicketDurationInMinutes: number;
	SaleCenterId: number;
	SaleCenterName: string;
}

export interface TableCompanionsAvgByTimeFrameDTO {
	AvgTableCompanionCount: Nullable<number>;
	AvgTableCompanionNetAmount: Nullable<number>;
	AvgTicketDurationInMinutes: number;
	TimeFrameGroupId: number;
	TimeFrameIndex: number;
	TimeFrameName: string;
}

export interface TableCompanionsBySaleCenterDTO {
	BusinessDay: Date;
	NetAmount: number;
	SaleCenterId: number;
	SaleCenterName: string;
	TableCompanionsCount: number;
	TicketCount: number;
}

export interface TableCompanionsBySaleCenterReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: TableCompanionsBySaleCenterDTO[];
	TableCompanionsAvg: TableCompanionsAvgBySaleCenterDTO[];
	To: Date;
}

export interface TableCompanionsByTimeFrameDTO {
	BusinessDay: Date;
	NetAmount: number;
	TableCompanionsCount: number;
	TicketCount: number;
	TimeFrameGroupId: number;
	TimeFrameIndex: number;
	TimeFrameName: string;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface TableCompanionsByTimeFrameReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: TableCompanionsByTimeFrameDTO[];
	TableCompanionsAvg: TableCompanionsAvgByTimeFrameDTO[];
	To: Date;
}

export interface TableCompanionsByWorkplaceAndTimeFrameReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: TableCompanionsByTimeFrameDTO[];
	To: Date;
}

export interface TableOrderSaleCenterStatusDTO {
	IsEnabled: boolean;
	Message: string;
	SaleCenterId: number;
	SaleCenterName: string;
}

export interface TableSaleLocationDTO {
	SaleCenterFullName: string;
	SaleCenterId: number;
	SaleCenterName: string;
	SaleLocationName: string;
}

export interface TakeOutServiceDTO {
	EndTime: Date;
	Friday: boolean;
	MaxOrdersPerInterval: number;
	Monday: boolean;
	Name: string;
	Saturday: boolean;
	StartTime: Date;
	Sunday: boolean;
	Thursday: boolean;
	Tuesday: boolean;
	Wednesday: boolean;
}

export interface TaxByCustomerDTO {
	CustomerCif: string;
	CustomerFiscalName: string;
	CustomerId: number;
	DocumentType: DocumentType;
	Gross: number;
	Net: number;
	Surcharge: number;
	SurchargeRate: number;
	Tax: number;
	TaxRate: number;
}

export interface TaxDeltaDTO {
	Gross: number;
	Surcharge: number;
	SurchargeRate: number;
	Tax: number;
	VatId: number;
	VatRate: number;
}

export interface TaxDTO {
	Gross: number;
	Surcharge: number;
	SurchargeRate: number;
	Tax: number;
	VatId: number;
	VatRate: number;
}

export interface TaxesByCustomerReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Taxes: TaxByCustomerDTO[];
	To: Date;
}

export interface TelemetryDefaultPropertyDTO {
	Key: string;
	Value: string;
}

export interface TelemetrySamplingRateDTO {
	Key: string;
	Value: number;
}

export interface TemplateConfigurationInListDTO {
	Description: string;
	Id: string;
	NumberOfColumns: number;
}

export interface TemplateElementDTO {
	Bold: boolean;
	DoubleHeight: boolean;
	DoubleWidth: boolean;
	ImageData: string;
	Text: string;
	Type: TemplateElementType;
	Underlined: boolean;
}

export interface TicketBAISettingsDTO {
	AcceptPaymentCriteria: boolean;
	AdditionalEpigraphs: AdditionalEpigraphDTO[];
	CertFile: FileContentDTO;
	CertInfo: CertificateInfoDTO;
	CertPassword: string;
	CertType: TicketBAICertType;
	Cif: string;
	Epigraph: string;
	FiscalName: string;
	FiscalRegion: TicketBAIFiscalRegion;
	SkipCertValidation: boolean;
	SurchargeCategory: CategoryInListDTO;
	TaxRegime: TicketBAITaxRegime;
}

export interface TicketBAIStatusDTO {
	Certificates: CertificateInfoDTO[];
	Environment: TicketBAIEnvironment;
	Manufacturer: ManufacturerDTO;
	Software: SoftwareDTO;
}

export interface TicketDivisionDTO {
	ClosingQuantities: ClosingQuantityDTO[];
	Error: string;
	Left: TicketDTO;
	OriginalTicketId: number;
	Right: TicketDTO;
}

export interface TicketDTO {
	AppliedDiscountCode: string;
	AppliedDiscountId: number;
	AppliedDiscountMode: Nullable<DiscountMode>;
	AppliedServiceCharge: AppliedServiceChargeDTO;
	BlockerPos: string;
	BusinessDay: Nullable<Date>;
	CashDiscount: number;
	CurrentUser: string;
	Customer: BuyerCustomerDTO;
	DiscountPercentage: number;
	DiscountPercentageInCash: number;
	DiscountRate: number;
	DocumentPayments: DocumentPaymentDTO[];
	DraftSerialNumber: SerialNumberDTO;
	FriendlyName: string;
	GlobalId: string;
	GrossAmount: number;
	HasLoyaltyInfo: boolean;
	HasOnlineReservation: boolean;
	HasPendingTransactions: boolean;
	HasPhoneOrder: boolean;
	Id: number;
	IsEmpty: boolean;
	IsFrozen: boolean;
	IsInUse: boolean;
	Lines: TicketLineDTO[];
	Location: TicketLocationDTO;
	MinRequiredAmount: number;
	NetAmount: number;
	Offers: OfferInListDTO[];
	OpenerUser: string;
	PendingAmount: number;
	PrepaidAmount: number;
	PreparationsReady: boolean;
	PriceList: PriceListDTO;
	ServiceChargeAmount: number;
	SurchargeAmount: number;
	TableCompanions: Nullable<number>;
	TablePaymentReference: string;
	TipAmount: number;
	UsePriceList: UsePriceList;
	VatIncluded: boolean;
}

export interface TicketLineDTO {
	Addins: SoldProductDTO[];
	AppliedDiscountCode: string;
	AppliedDiscountId: number;
	AppliedDiscountMode: Nullable<DiscountMode>;
	AppliedOfferCode: string;
	CashDiscount: number;
	CashDiscountRate: number;
	ConsumedCouponCode: string;
	DiscountPercentage: number;
	DiscountPercentageInCash: number;
	DiscountRate: number;
	HasBeenPrinted: boolean;
	HasBeenRequested: boolean;
	HasCashDiscount: boolean;
	HasDiscountPercentage: boolean;
	HasNotes: boolean;
	Id: number;
	Notes: string[];
	OwnerId: Nullable<number>;
	PreparationOrderCanBeRequested: boolean;
	PreparationOrderId: number;
	PreparationOrderName: string;
	Product: SoldProductDTO;
	Quantity: number;
	RemovedIngredients: RemovedIngredientDTO[];
	SeatNumber: Nullable<number>;
	Status: TicketLineStatus;
	TotalAmount: number;
	Type: SoldProductType;
	UnitPrice: number;
	UserId: number;
	UserName: string;
}

export interface TicketLocationDTO {
	AskForFriendlyName: WhenAskForFriendlyName;
	AskForTableCompanions: WhenAskForTableCompanions;
	SaleCenterId: number;
	SaleCenterName: string;
	SaleLocationName: string;
	StartTakeOutOrderOnOpenTicket: boolean;
}

export interface TicketPreparationLineDTO {
	LineIds: number[];
	TicketId: number;
}

export interface TicketsByTimeFrameDTO {
	BusinessDay: Date;
	NetAmount: number;
	TicketCount: number;
	TimeFrameGroupId: number;
	TimeFrameIndex: number;
	TimeFrameName: string;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface TicketsByTimeFrameReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: TicketsByTimeFrameDTO[];
	To: Date;
}

export interface TicketSummaryDTO {
	AskForFriendlyName: WhenAskForFriendlyName;
	AskForTableCompanions: WhenAskForTableCompanions;
	BlockerPos: string;
	CreationDate: Nullable<Date>;
	CurrentUser: string;
	CustomerFiscalName: string;
	FriendlyName: string;
	GlobalId: string;
	HasPrepayments: boolean;
	Id: number;
	IsInactive: boolean;
	IsInUse: boolean;
	NetAmount: number;
	OpenerUser: string;
	PendingAmount: number;
	PreparationNumber: Nullable<number>;
	SaleCenterId: number;
	SaleCenterName: string;
	SaleLocationName: string;
	TableCompanions: Nullable<number>;
	TablePaymentReference: string;
}

export interface TicketsWidgetDTO {
	AvgTableCompanionsTicketAmount: number;
	AvgTicketAmount: number;
	AvgTicketDuration: number;
	TableCompanionsCount: number;
	TicketCount: number;
}

export interface TimeFrameDTO {
	End: Date;
	Name: string;
	Start: Date;
}

export interface TimeFrameGroupForEditionDTO {
	Id: number;
	Name: string;
	TimeFrames: TimeFrameDTO[];
}

export interface TimeFrameGroupInListDTO {
	Id: number;
	Name: string;
}

export interface TipDTO {
	ApplyTo: TicketType;
	ExistingTaxes: VatDTO[];
	ExistingTicketType: TicketType[];
	IgnoreTicketDiscounts: boolean;
	TipPercentage: number;
	TipTax: VatDTO;
}

export interface TipOperationDTO {
	AvailableMethods: PaymentMethodDTO[];
	Tips: TipPaymentDTO[];
}

export interface TipPaymentDTO {
	Amount: number;
	CardTransaction: CardTransactionDTO;
	MethodId: number;
	MethodName: string;
}

export interface TipsByUserDTO {
	BusinessDay: Date;
	TipAmount: number;
	UserId: number;
	UserName: string;
}

export interface TipsByUserReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Tips: TipsByUserDTO[];
	To: Date;
}

export interface TrainingSessionDTO {
	BusinessDay: Date;
	CloseDate: Date;
	Id: number;
	OpenDate: Date;
	PosName: string;
	Preview: PrintPreviewDTO;
	TotalDocuments: number;
	TotalPayments: number;
}

export interface TrainingSettingsDTO {
	ExistingUsers: UserInListDTO[];
	TrainingUsers: UserInListDTO[];
}

export interface TranslatableStringDTO {
	DefaultValue: string;
	Translations: TranslationDTO[];
}

export interface TranslationDTO {
	LanguageCode: string;
	Translation: string;
}

export interface UnitOfMeasurementDTO {
	Id: number;
	IsBase: boolean;
	Name: string;
	UnitToBaseFactor: number;
}

export interface UnpaidScaleSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: ScaleSaleItemDTO[];
	To: Date;
}

export interface UPaySettingsDTO {
	Key: string;
	Merchant: string;
}

export interface UpcomingDeliveryDTO {
	ColorId: number;
	ColorName: string;
	DeliveryDate: Nullable<Date>;
	Number: number;
	OrderDate: Date;
	Quantity: number;
	Serie: string;
	SizeId: number;
	SizeName: string;
	Supplier: string;
	SupplierDocumentNumber: string;
	Warehouse: string;
}

export interface UpdatedProductPriceDTO {
	AddinPrice: Nullable<number>;
	BarcodeSummary: string;
	Family: string;
	Id: number;
	MainPrice: Nullable<number>;
	MenuItemPrice: Nullable<number>;
	Name: string;
	UpdatedAt: Date;
}

export interface UserByUserDTO {
	Id: number;
	Name: string;
}

export interface UserCompanyInfoDTO {
	CCC: string;
	Cif: string;
	Name: string;
	UseInClockingReports: boolean;
}

export interface UserFingerprintDTO {
	Fingerprints: string[];
	UserId: number;
	UserName: string;
}

export interface UserForEditionDTO {
	Address: AddressDTO;
	AssignOrderUrl: string;
	AutoClockOutMaxWorkedHours: Date;
	AvailableLanguages: string[];
	CardNumber: string;
	CardNumber2: string;
	CompanyInfo: UserCompanyInfoDTO;
	Email: string;
	EnableAutoClockOutMaxHours: boolean;
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingProfiles: UserProfileInListDTO[];
	Fingerprints: FingerprintDTO[];
	FullName: string;
	Id: number;
	IsDeliveryPerson: boolean;
	Language: string;
	Name: string;
	Nif: string;
	Password: string;
	Priority: number;
	Profile: UserProfileInListDTO;
	ShowInClockings: boolean;
	ShowInPos: boolean;
	SmartphonePassword: string;
	SocialSecurityNumber: string;
	Style: StyleForEditionDTO;
	Telephone: string;
	UnassignOrderUrl: string;
	UseDeliveryPlatform: boolean;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
	WebAdminPassword: string;
}

export interface UserInListDTO {
	GroupsSummary: string;
	Id: number;
	Name: string;
	Priority: number;
	ProfileId: number;
	ProfileName: string;
	WorkplacesSummary: string;
}

export interface UserLoginDTO {
	BusinessDay: Date;
	EndTime: Nullable<Date>;
	StartTime: Nullable<Date>;
	SystemCloseOut: number;
	TotalHours: Nullable<number>;
	UserId: number;
	UserName: string;
}

export interface UserLoginsReportDTO {
	BusinessName: string;
	Cif: string;
	FiscalName: string;
	From: Date;
	Logins: UserLoginDTO[];
	To: Date;
}

export interface UserProfileForEditionDTO {
	ExistingPermissions: PermissionDTO[];
	Id: number;
	IsAdmin: boolean;
	Name: string;
	Permissions: PermissionDTO[];
}

export interface UserProfileInListDTO {
	Id: number;
	IsAdmin: boolean;
	Name: string;
}

export interface UserSalesByTimeFrameDTO {
	InvoiceCount: number;
	NetAmount: number;
	TimeFrameGroupId: number;
	TimeFrameIndex: number;
	TimeFrameName: string;
	UserId: number;
	UserName: string;
}

export interface UserSalesByTimeFrameReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: UserSalesByTimeFrameDTO[];
	To: Date;
}

export interface UserSalesDTO {
	BasicInvoiceCount: number;
	BasicInvoiceGrossAmount: number;
	BasicInvoiceNetAmount: number;
	BasicRefundCount: number;
	BasicRefundGrossAmount: number;
	BasicRefundNetAmount: number;
	CancellationCount: number;
	CancellationGrossAmount: number;
	CancellationNetAmount: number;
	DeliveryNoteCount: number;
	DeliveryNoteGrossAmount: number;
	DeliveryNoteNetAmount: number;
	ExpensesAmount: number;
	ExpensesCount: number;
	IncomesAmount: number;
	IncomesCount: number;
	MethodId: number;
	MethodName: string;
	MethodTotalAmount: number;
	StandardInvoiceCount: number;
	StandardInvoiceGrossAmount: number;
	StandardInvoiceNetAmount: number;
	StandardRefundCount: number;
	StandardRefundGrossAmount: number;
	StandardRefundNetAmount: number;
	UserId: number;
	UserName: string;
}

export interface UserSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: UserSalesDTO[];
	To: Date;
}

export interface UserWidgetDTO {
	Color: string;
	ImageId: string;
	InvoicesByUser: number;
	LastActivity: Date;
	LinesByUser: number;
	ProfileName: string;
	UserName: string;
}

export interface VatCollectionDTO {
	Id: number;
	Vat1: VatDTO;
	Vat10: VatDTO;
	Vat2: VatDTO;
	Vat3: VatDTO;
	Vat4: VatDTO;
	Vat5: VatDTO;
	Vat6: VatDTO;
	Vat7: VatDTO;
	Vat8: VatDTO;
	Vat9: VatDTO;
}

export interface VatDTO {
	Enabled: boolean;
	Id: number;
	Name: string;
	SurchargePercentage: number;
	VatPercentage: number;
	VatType: VatType;
}

export interface VerifactuChainDTO {
	SifSettingsFiscalName: string;
	SifSettingsId: number;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface VerifactuInvoiceInListDTO {
	BusinessDay: Date;
	ChainError: string;
	CreationDate: Date;
	GrossAmount: number;
	Hash: string;
	InvoiceId: number;
	NetAmount: number;
	Number: number;
	PreviousHash: string;
	PreviousInvoiceId: number;
	PreviousNumber: number;
	PreviousSerie: string;
	Serie: string;
	SubmitCsv: string;
	SubmitStatus: VerifactuDataInvoiceStatus;
	SubmitStatusDetails: string;
	SurchargeAmount: number;
	TaxAmount: number;
	Type: DocumentType;
	VerifactuDataId: number;
	XmlCif: string;
	XmlNetAmount: string;
	XmlTaxAndSurchargeAmount: string;
}

export interface WarehouseByUserDTO {
	Cif: string;
	City: string;
	FiscalName: string;
	Id: number;
	Name: string;
	ProductionCostPricePolicy: ProductionCostPricePolicy;
	PurchaseCostPricePolicy: PurchaseCostPricePolicy;
	Street: string;
	TransferCostPricePolicy: TransferCostPricePolicy;
	UseFiscalInfoInDocuments: boolean;
	ZipCode: string;
}

export interface WarehouseCloseDateDTO {
	Date: Date;
	WarehouseId: number;
}

export interface WarehouseCloseOutForEditionDTO {
	Date: Date;
	ExistingWarehouses: WarehouseByUserDTO[];
	Id: number;
	Warehouse: WarehouseByUserDTO;
}

export interface WarehouseCloseOutForReviewDTO {
	Date: Date;
	Id: number;
	Lines: WarehouseCloseOutLineDetailsDTO[];
	Warehouse: string;
}

export interface WarehouseCloseOutInListDTO {
	Date: Date;
	Id: number;
	Total: number;
	WarehouseId: number;
	WarehouseName: string;
}

export interface WarehouseCloseOutLineDetailsDTO {
	ColorName: string;
	CostPrice: number;
	FamilyName: string;
	MajorGroupName: string;
	ProductId: number;
	ProductName: string;
	QuantityInSaleUnit: number;
	SizeName: string;
	TotalCostPrice: number;
}

export interface WarehouseForEditionDTO {
	Address: AddressDTO;
	Cif: string;
	EmailAccount: EmailAccountInListDTO;
	ExistingEmailAccounts: EmailAccountInListDTO[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingSeries: SerieInListDTO[];
	ExistingSuppliers: SupplierInListDTO[];
	FiscalName: string;
	Id: number;
	IncomingDeliveryNoteSerie: SerieInListDTO;
	Name: string;
	Notes: string;
	ProductionCostPricePolicy: ProductionCostPricePolicy;
	PurchaseCostPricePolicy: PurchaseCostPricePolicy;
	PurchaseInvoiceSerie: SerieInListDTO;
	PurchaseOrderSerie: SerieInListDTO;
	RestockSupplierSearchMode: SupplierSearchMode;
	SupplierNotes: SupplierNotesDTO[];
	TransferCostPricePolicy: TransferCostPricePolicy;
	UseFiscalInfoInDocuments: boolean;
	ValidForAllPosGroups: boolean;
	ValidPosGroups: PosGroupInListDTO[];
}

export interface WarehouseInListDTO {
	Cif: string;
	City: string;
	FiscalName: string;
	GroupsSummary: string;
	Id: number;
	Name: string;
	ProductionCostPricePolicy: ProductionCostPricePolicy;
	PurchaseCostPricePolicy: PurchaseCostPricePolicy;
	Region: string;
	RestockSupplierSearchMode: SupplierSearchMode;
	Street: string;
	TransferCostPricePolicy: TransferCostPricePolicy;
	UseFiscalInfoInDocuments: boolean;
	WorkplaceSummary: string;
	ZipCode: string;
}

export interface WarehouseStockValueDetailsWidgetDTO {
	MajorGroups: MajorGroupStockValueDTO[];
	PendingOrders: PendingPurchaseOrderDTO[];
	ProductsUnderMinStock: ProductStockDTO[];
	Summary: WarehouseStockValueWidgetDTO;
}

export interface WarehouseStockValueWidgetDTO {
	ThisMonth: number;
	ThisYear: number;
	Today: number;
	WarehouseId: number;
	WarehouseName: string;
}

export interface WebAdminForEditionDTO {
	ExistingCategoryTags: string[];
	ExistingLanguages: LanguageDTO[];
	Id: number;
	IncludePricesInProductList: boolean;
	InventoryCountsCategoryTags: string[];
	Language: LanguageDTO;
	LogoImageData: string;
	MaxProductsInProductList: number;
	MenusCategoryTags: string[];
	PredefinedNotesCategoryTags: string[];
	PurchaseOrdersCategoryTags: string[];
	ReportsCategoryTags: string[];
	RestockCategoryTags: string[];
	StockTransfersCategoryTags: string[];
}

export interface WebPrintResultDTO {
	Data: string;
	DocumentType: WebPrintResultType;
	Filename: string;
}

export interface WorkingPeriodForEditionDTO {
	BusinessDay: Date;
	ExistingPos: PosInListDTO[];
	ExistingUsers: UserInListDTO[];
	Id: number;
	In: ClockingDTO;
	Out: ClockingDTO;
	User: UserInListDTO;
}

export interface WorkingPeriodInListDTO {
	BusinessDay: Date;
	Id: number;
	In: Date;
	Out: Nullable<Date>;
	User: string;
	UserProfile: string;
	WorkedHours: Nullable<number>;
	Workplace: string;
}

export interface WorkingPeriodStatusDTO {
	BusinessDay: Date;
	CanChangeBusinessDay: boolean;
	ClockIn: Nullable<Date>;
	ClockOut: Nullable<Date>;
	User: ClockingUserDTO;
}

export interface WorkplaceByUserDTO {
	Id: number;
	Name: string;
}

export interface WorkplaceEmailSettingsDTO {
	Footer: string;
}

export interface WorkplaceForEditionDTO {
	AdditionalPrintTemplates: PrintTemplateInListDTO[];
	AdditionalSeries: SerieInListDTO[];
	Address: AddressDTO;
	AllowDownloadFromOtherVersion: boolean;
	AskForLineCancellationReason: boolean;
	AutoClockOutMaxHours: Date;
	AutoCloseTime: Date;
	AvailableDBLanguages: string[];
	CanCreateDocumentsInWebAdmin: boolean;
	CompactLinesOnSale: boolean;
	CompletePendingPreparationsInSystemCloseOut: boolean;
	ConnectionToken: string;
	CreateNewPosSeries: boolean;
	CreateNewWebAdminSeries: boolean;
	DBLanguage: string;
	Email: string;
	EmailAccount: EmailAccountInListDTO;
	EmailSettings: WorkplaceEmailSettingsDTO;
	EnableAutoClockOutMaxHours: boolean;
	EnableAutoClose: boolean;
	EnableCommunications: boolean;
	EnableGStock: boolean;
	EnableScedulePreparation: boolean;
	EnableTablePayment: boolean;
	EnableTicketBAI: boolean;
	EnableTicketBAICommunications: boolean;
	EnableVerifactu: boolean;
	ExistingCategories: CategoryInListDTO[];
	ExistingCustomerTypes: CustomerTypeInListDTO[];
	ExistingEmailAccounts: EmailAccountInListDTO[];
	ExistingKitchenPrintTemplates: KitchenPrintTemplateInListDTO[];
	ExistingMyAgoraAccounts: MyAgoraAccountInListDTO[];
	ExistingPaymentPlatformTypes: PaymentPlatformType[];
	ExistingPosGroups: PosGroupInListDTO[];
	ExistingPrintTemplates: PrintTemplateInListDTO[];
	ExistingSeries: SerieInListDTO[];
	ExistingServiceChargeTypes: TicketType[];
	ExistingServiceChargeVats: VatDTO[];
	ExistingSifSettings: SifSettingsInListDTO[];
	ExistingSmartMenuOrderSettings: SmartMenuOrderSettingsInListDTO[];
	ExistingTablePaymentSettingsFiles: SettingsFileInListDTO[];
	ExistingTaxRegimes: TicketBAITaxRegime[];
	ExistingTicketBAICertTypes: TicketBAICertType[];
	ExistingTicketBAIFiscalRegions: TicketBAIFiscalRegion[];
	ExistingTipTaxes: VatDTO[];
	ExistingTipTypes: TicketType[];
	FixedTipSettings: FixedTipSettingsDTO;
	GStockReference: string;
	Id: number;
	IncludeCancellationsByUserInSystemCloseOut: boolean;
	IncludeDeliveryPersonsStatusInSystemCloseOut: boolean;
	IncludeDiscrepancyAmountInSystemCloseOut: boolean;
	IncludeFamilySalesInSystemCloseOut: boolean;
	IncludeInvitationsByUserInSystemCloseOut: boolean;
	IncludePendingOperationsInSystemCloseOut: boolean;
	IncludeProductReturnsInSystemCloseOut: boolean;
	IncludeProductSalesInSystemCloseOut: boolean;
	IncludeSalesBySaleCenterInSystemCloseOut: boolean;
	IncludeTableCompanionsSummary: boolean;
	IncludeTipsByPaymentMethodInSystemCloseOut: boolean;
	IncludeUserPaymentsInSystemCloseOut: boolean;
	IncludeUserSalesInSystemCloseOut: boolean;
	InternalConsumptionsCustomerType: CustomerTypeInListDTO;
	KitchenPrintTemplate: KitchenPrintTemplateInListDTO;
	LinkedMachineId: string;
	Manager: string;
	MaxAllowedBasicInvoicePaymentAmount: Nullable<number>;
	MyAgoraEnabled: boolean;
	MyAgoraSendPosCloseOut: boolean;
	MyAgoraSendSystemCloseOut: boolean;
	MyAgoraSendTicketPreview: boolean;
	Name: string;
	NewPosCustomerValidForAllPosGroups: boolean;
	NewPosCustomerValidPosGroups: PosGroupInListDTO[];
	PrintSystemCloseOut: boolean;
	SchedulePreparationTime: Date;
	SelectedBasicInvoiceSerie: SerieInListDTO;
	SelectedBasicRefundSerie: SerieInListDTO;
	SelectedDeliveryNoteSerie: SerieInListDTO;
	SelectedMyAgoraAccounts: MyAgoraAccountInListDTO[];
	SelectedSalesOrderSerie: SerieInListDTO;
	SelectedStandardInvoiceSerie: SerieInListDTO;
	SelectedStandardRefundSerie: SerieInListDTO;
	ServiceChargeIngoreTicketDiscounts: boolean;
	ServiceChargePercentage: number;
	ServiceChargeType: TicketType;
	ServiceChargeVat: VatDTO;
	SifSettings: SifSettingsInListDTO;
	SmartMenuPaymentSettings: SmartMenuPaymentSettingsDTO;
	SuggestedTipSettings: SuggestedTipSettingsDTO;
	TablePaymentSettingsFile: SettingsFileInListDTO;
	Telephone: string;
	TicketBAISettings: TicketBAISettingsDTO;
	TipSettingsMode: TipSettingsMode;
	UseDeliveryNoteData: boolean;
	UseScalePrice: boolean;
	WarnOnLowStock: boolean;
	Web: string;
	WebBasicInvoiceSerie: SerieInListDTO;
	WebBasicRefundSerie: SerieInListDTO;
	WebDeliveryNoteSerie: SerieInListDTO;
	WebSalesOrderSerie: SerieInListDTO;
	WebStandardInvoiceSerie: SerieInListDTO;
	WebStandardRefundSerie: SerieInListDTO;
}

export interface WorkplaceForQRDTO {
	DeliveryPriceList: PriceListInListDTO;
	GlobalId: string;
	Id: number;
	Name: string;
	TakeAwayPriceList: PriceListInListDTO;
}

export interface WorkplaceInListDTO {
	EnableCommunications: boolean;
	GlobalId: string;
	Id: number;
	Manager: string;
	Name: string;
	Telephone: string;
}

export interface WorkplaceOccupancyWidgetDTO {
	Occupancy: OccupancyWidgetDTO;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface WorkplaceSalesDTO {
	BusinessDay: Date;
	NetAmount: number;
	NetAmountWithTableCompanions: number;
	TableCompanionsCount: number;
	TicketCount: number;
	TicketCountWithTableCompanions: number;
	TicketDurationInMinutes: number;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface WorkplaceSalesReportDTO {
	CompanyDescription: string;
	CompanyDetails: string;
	From: Date;
	Sales: WorkplaceSalesDTO[];
	To: Date;
}

export interface WorkplaceSalesWidgetDTO {
	Sales: SalesWidgetDTO;
	WorkplaceId: number;
	WorkplaceName: string;
}

export interface WorkplaceTicketsWidgetDTO {
	Tickets: TicketsWidgetDTO;
	WorkplaceId: number;
	WorkplaceName: string;
}

export class AcceptPreparationCancellationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.AcceptPreparationCancellationRequest';
	IsBlocking = false;
	DisplayId: number;
	Lines: TicketPreparationLineDTO[];
	constructor(_params: {
		displayId: number,
		lines: TicketPreparationLineDTO[]
	}) {
		super({});
		this.DisplayId = _params.displayId;
		this.Lines = _params.lines;
	}
}

export class AcceptPreparationCancellationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.AcceptPreparationCancellationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AcceptSalesOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AcceptSalesOrderRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class AcceptSalesOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AcceptSalesOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AcceptServedPreparationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.AcceptServedPreparationRequest';
	IsBlocking = false;
	CancelledLines: TicketPreparationLineDTO[];
	DisplayId: number;
	Lines: TicketPreparationLineDTO[];
	constructor(_params: {
		displayId: number,
		lines: TicketPreparationLineDTO[],
		cancelledLines: TicketPreparationLineDTO[]
	}) {
		super({});
		this.DisplayId = _params.displayId;
		this.Lines = _params.lines;
		this.CancelledLines = _params.cancelledLines;
	}
}

export class AcceptServedPreparationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.AcceptServedPreparationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AccountPurchaseInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.AccountPurchaseInvoiceRequest';
	IsBlocking = true;
	PurchaseInvoiceId: number;
	constructor(_params: {
		purchaseInvoiceId: number
	}) {
		super({});
		this.PurchaseInvoiceId = _params.purchaseInvoiceId;
	}
}

export class AccountPurchaseInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.AccountPurchaseInvoiceResponse';
	IsBlocking = false;
	Data: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		data: PurchaseInvoiceForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class AddAdminBookmarkRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.WebAdmin.Messages.AddAdminBookmarkRequest';
	IsBlocking = false;
	Bookmark: string;
	constructor(_params: {
		bookmark: string
	}) {
		super({});
		this.Bookmark = _params.bookmark;
	}
}

export class AddAdminBookmarkResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.WebAdmin.Messages.AddAdminBookmarkResponse';
	IsBlocking = false;
	Bookmarks: string[];
	constructor(_params: {
		bookmarks: string[]
	}) {
		super({});
		this.Bookmarks = _params.bookmarks;
	}
}

export class AddCountToInventoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.AddCountToInventoryRequest';
	IsBlocking = false;
	CategoryId: number;
	CountName: string;
	InventoryId: number;
	constructor(_params: {
		inventoryId: number,
		categoryId: number,
		countName: string
	}) {
		super({});
		this.InventoryId = _params.inventoryId;
		this.CategoryId = _params.categoryId;
		this.CountName = _params.countName;
	}
}

export class AddCountToInventoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.AddCountToInventoryResponse';
	IsBlocking = false;
	Count: InventoryCountDTO;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO,
		count: InventoryCountDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
		this.Count = _params.count;
	}
}

export class AddDeliveryAddressRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.AddDeliveryAddressRequest';
	IsBlocking = false;
	Address: AddressDTO;
	CustomerId: number;
	constructor(_params: {
		customerId: number,
		address: AddressDTO
	}) {
		super({});
		this.CustomerId = _params.customerId;
		this.Address = _params.address;
	}
}

export class AddDeliveryAddressResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.AddDeliveryAddressResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddDeliveryNotePaymentsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddDeliveryNotePaymentsRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	Payments: PaymentDTO[];
	PrepayAmount: number;
	constructor(_params: {
		deliveryNoteId: number,
		payments: PaymentDTO[],
		prepayAmount: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
		this.Payments = _params.payments;
		this.PrepayAmount = _params.prepayAmount;
	}
}

export class AddDeliveryNotePaymentsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddDeliveryNotePaymentsResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class AddDeliveryPersonBalanceDeltaRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddDeliveryPersonBalanceDeltaRequest';
	IsBlocking = false;
	DeliveryPersonId: number;
	Delta: number;
	Reason: string;
	constructor(_params: {
		deliveryPersonId: number,
		delta: number,
		reason: string
	}) {
		super({});
		this.DeliveryPersonId = _params.deliveryPersonId;
		this.Delta = _params.delta;
		this.Reason = _params.reason;
	}
}

export class AddDeliveryPersonBalanceDeltaResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddDeliveryPersonBalanceDeltaResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddGStockUploadsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.AddGStockUploadsRequest';
	IsBlocking = true;
	From: Date;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
	}
}

export class AddGStockUploadsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.AddGStockUploadsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddPendingTipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.AddPendingTipRequest';
	IsBlocking = false;
	TipToAdd: number;
	constructor(_params: {
		tipToAdd: number
	}) {
		super({});
		this.TipToAdd = _params.tipToAdd;
	}
}

export class AddPendingTipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.AddPendingTipResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddProductToCategoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.AddProductToCategoryRequest';
	IsBlocking = false;
	CategoryId: number;
	ProductId: number;
	constructor(_params: {
		categoryId: number,
		productId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
		this.ProductId = _params.productId;
	}
}

export class AddProductToCategoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.AddProductToCategoryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddReportViewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.AddReportViewRequest';
	IsBlocking = false;
	View: ReportViewDTO;
	constructor(_params: {
		view: ReportViewDTO
	}) {
		super({});
		this.View = _params.view;
	}
}

export class AddReportViewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.AddReportViewResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddSalesOrderPaymentsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddSalesOrderPaymentsRequest';
	IsBlocking = false;
	OrderId: number;
	Payments: PaymentDTO[];
	PrepayAmount: number;
	constructor(_params: {
		orderId: number,
		payments: PaymentDTO[],
		prepayAmount: number
	}) {
		super({});
		this.OrderId = _params.orderId;
		this.Payments = _params.payments;
		this.PrepayAmount = _params.prepayAmount;
	}
}

export class AddSalesOrderPaymentsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddSalesOrderPaymentsResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class AddTicketLineNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketLineNoteRequest';
	IsBlocking = false;
	Note: string;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		note: string
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Note = _params.note;
	}
}

export class AddTicketLineNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketLineNoteResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddTicketLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketLineRequest';
	IsBlocking = false;
	Addins: SoldProductDTO[];
	CouponCode: string;
	OwnerId: Nullable<number>;
	PreparationNotes: string;
	Product: SoldProductDTO;
	Quantity: number;
	RemovedIngredients: RemovedIngredientDTO[];
	SeatNumber: Nullable<number>;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		product: SoldProductDTO,
		addins: SoldProductDTO[],
		quantity: number,
		preparationNotes: string,
		ownerId: Nullable<number>,
		couponCode: string,
		removedIngredients: RemovedIngredientDTO[],
		seatNumber: Nullable<number>
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Product = _params.product;
		this.Addins = _params.addins;
		this.Quantity = _params.quantity;
		this.PreparationNotes = _params.preparationNotes;
		this.OwnerId = _params.ownerId;
		this.CouponCode = _params.couponCode;
		this.RemovedIngredients = _params.removedIngredients;
		this.SeatNumber = _params.seatNumber;
	}
}

export class AddTicketLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketLineResponse';
	IsBlocking = false;
	LowStockWarnings: LowStockWarningDTO[];
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO,
		lowStockWarnings: LowStockWarningDTO[]
	}) {
		super({});
		this.Ticket = _params.ticket;
		this.LowStockWarnings = _params.lowStockWarnings;
	}
}

export class AddTicketLoyaltyInfoRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketLoyaltyInfoRequest';
	IsBlocking = false;
	MemberId: string;
	Rewards: RewardDTO[];
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		memberId: string,
		rewards: RewardDTO[]
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.MemberId = _params.memberId;
		this.Rewards = _params.rewards;
	}
}

export class AddTicketLoyaltyInfoResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketLoyaltyInfoResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddTicketPaymentsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketPaymentsRequest';
	IsBlocking = false;
	Payments: PaymentDTO[];
	PrepayAmount: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		payments: PaymentDTO[],
		prepayAmount: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Payments = _params.payments;
		this.PrepayAmount = _params.prepayAmount;
	}
}

export class AddTicketPaymentsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketPaymentsResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class AddTicketTablePaymentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketTablePaymentRequest';
	IsBlocking = false;
	Payment: PaymentDTO;
	PrepayAmount: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		payment: PaymentDTO,
		prepayAmount: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Payment = _params.payment;
		this.PrepayAmount = _params.prepayAmount;
	}
}

export class AddTicketTablePaymentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTicketTablePaymentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AddTipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTipRequest';
	IsBlocking = false;
	InvoiceId: number;
	Tip: TipPaymentDTO;
	constructor(_params: {
		invoiceId: number,
		tip: TipPaymentDTO
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Tip = _params.tip;
	}
}

export class AddTipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AddTipResponse';
	IsBlocking = false;
	Tips: TipPaymentDTO[];
	constructor(_params: {
		tips: TipPaymentDTO[]
	}) {
		super({});
		this.Tips = _params.tips;
	}
}

export class AdjustTicketLineIngredientsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AdjustTicketLineIngredientsRequest';
	IsBlocking = false;
	RemovedIngredients: RemovedIngredientDTO[];
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		removedIngredients: RemovedIngredientDTO[]
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.RemovedIngredients = _params.removedIngredients;
	}
}

export class AdjustTicketLineIngredientsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.AdjustTicketLineIngredientsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AreSupplierAndWarehouseCompatibleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.AreSupplierAndWarehouseCompatibleRequest';
	IsBlocking = false;
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		supplierId: number,
		warehouseId: number
	}) {
		super({});
		this.SupplierId = _params.supplierId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class AreSupplierAndWarehouseCompatibleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.AreSupplierAndWarehouseCompatibleResponse';
	IsBlocking = false;
	AreCompatible: boolean;
	constructor(_params: {
		areCompatible: boolean
	}) {
		super({});
		this.AreCompatible = _params.areCompatible;
	}
}

export class AttendOnlineReservationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.AttendOnlineReservationRequest';
	IsBlocking = false;
	Customer: string;
	EndTime: Date;
	Notes: string;
	OfferCode: string;
	OriginalLocation: string;
	PrepaymentAmount: number;
	ReservationCode: string;
	StartTime: Date;
	TableCompanions: number;
	TicketId: number;
	constructor(_params: {
		reservationCode: string,
		ticketId: number,
		tableCompanions: number,
		customer: string,
		notes: string,
		startTime: Date,
		endTime: Date,
		prepaymentAmount: number,
		originalLocation: string,
		offerCode: string
	}) {
		super({});
		this.ReservationCode = _params.reservationCode;
		this.TicketId = _params.ticketId;
		this.TableCompanions = _params.tableCompanions;
		this.Customer = _params.customer;
		this.Notes = _params.notes;
		this.StartTime = _params.startTime;
		this.EndTime = _params.endTime;
		this.PrepaymentAmount = _params.prepaymentAmount;
		this.OriginalLocation = _params.originalLocation;
		this.OfferCode = _params.offerCode;
	}
}

export class AttendOnlineReservationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.AttendOnlineReservationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AuditEventRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.AuditEventRequest';
	IsBlocking = false;
	Event: AuditEventDTO;
	constructor(_params: {
		event: AuditEventDTO
	}) {
		super({});
		this.Event = _params.event;
	}
}

export class AuditEventResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.AuditEventResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AwakeDownloadWorkplaceDataRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.AwakeDownloadWorkplaceDataRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AwakeDownloadWorkplaceDataResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.AwakeDownloadWorkplaceDataResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AwakeUploadWorkplaceDataRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.AwakeUploadWorkplaceDataRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class AwakeUploadWorkplaceDataResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.AwakeUploadWorkplaceDataResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class BeginFingerprintRegistrationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.BeginFingerprintRegistrationRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class BeginFingerprintRegistrationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.BeginFingerprintRegistrationResponse';
	IsBlocking = false;
	RegistrationId: string;
	constructor(_params: {
		registrationId: string
	}) {
		super({});
		this.RegistrationId = _params.registrationId;
	}
}

export class BeginPartialTicketClosingRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.BeginPartialTicketClosingRequest';
	IsBlocking = false;
	ClosingQuantities: ClosingQuantityDTO[];
	ClosingTableCompanions: Nullable<number>;
	OriginalTicketId: number;
	constructor(_params: {
		originalTicketId: number,
		closingQuantities: ClosingQuantityDTO[],
		closingTableCompanions: Nullable<number>
	}) {
		super({});
		this.OriginalTicketId = _params.originalTicketId;
		this.ClosingQuantities = _params.closingQuantities;
		this.ClosingTableCompanions = _params.closingTableCompanions;
	}
}

export class BeginPartialTicketClosingResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.BeginPartialTicketClosingResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class BlockTicketByPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.BlockTicketByPosRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class BlockTicketByPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.BlockTicketByPosResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CalculateCostPricesFromIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CalculateCostPricesFromIncomingDeliveryNoteRequest';
	IsBlocking = false;
	Note: IncomingDeliveryNoteForEditionDTO;
	Policy: PurchaseCostPricePolicy;
	constructor(_params: {
		note: IncomingDeliveryNoteForEditionDTO,
		policy: PurchaseCostPricePolicy
	}) {
		super({});
		this.Note = _params.note;
		this.Policy = _params.policy;
	}
}

export class CalculateCostPricesFromIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CalculateCostPricesFromIncomingDeliveryNoteResponse';
	IsBlocking = false;
	CostPrices: CalculatedCostPriceDTO[];
	constructor(_params: {
		costPrices: CalculatedCostPriceDTO[]
	}) {
		super({});
		this.CostPrices = _params.costPrices;
	}
}

export class CalculateCostPricesFromProductionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CalculateCostPricesFromProductionRequest';
	IsBlocking = false;
	Policy: ProductionCostPricePolicy;
	Production: ProductionForEditionDTO;
	constructor(_params: {
		production: ProductionForEditionDTO,
		policy: ProductionCostPricePolicy
	}) {
		super({});
		this.Production = _params.production;
		this.Policy = _params.policy;
	}
}

export class CalculateCostPricesFromProductionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CalculateCostPricesFromProductionResponse';
	IsBlocking = false;
	CostPrices: CalculatedCostPriceDTO[];
	constructor(_params: {
		costPrices: CalculatedCostPriceDTO[]
	}) {
		super({});
		this.CostPrices = _params.costPrices;
	}
}

export class CalculateCostPricesFromStockChangeTransferRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CalculateCostPricesFromStockChangeTransferRequest';
	IsBlocking = false;
	Policy: TransferCostPricePolicy;
	StockChange: StockChangeForEditionDTO;
	constructor(_params: {
		stockChange: StockChangeForEditionDTO,
		policy: TransferCostPricePolicy
	}) {
		super({});
		this.StockChange = _params.stockChange;
		this.Policy = _params.policy;
	}
}

export class CalculateCostPricesFromStockChangeTransferResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CalculateCostPricesFromStockChangeTransferResponse';
	IsBlocking = false;
	CostPrices: CalculatedCostPriceDTO[];
	constructor(_params: {
		costPrices: CalculatedCostPriceDTO[]
	}) {
		super({});
		this.CostPrices = _params.costPrices;
	}
}

export class CanCancelDocumentFromWebAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanCancelDocumentFromWebAdminRequest';
	IsBlocking = false;
	DocumentType: DocumentType;
	PosIds: number[];
	constructor(_params: {
		documentType: DocumentType,
		posIds: number[]
	}) {
		super({});
		this.DocumentType = _params.documentType;
		this.PosIds = _params.posIds;
	}
}

export class CanCancelDocumentFromWebAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanCancelDocumentFromWebAdminResponse';
	IsBlocking = false;
	CanCancel: boolean;
	Message: string;
	constructor(_params: {
		canCancel: boolean,
		message: string
	}) {
		super({});
		this.CanCancel = _params.canCancel;
		this.Message = _params.message;
	}
}

export class CancelAppointmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CancelAppointmentRequest';
	IsBlocking = false;
	AppointmentId: number;
	constructor(_params: {
		appointmentId: number
	}) {
		super({});
		this.AppointmentId = _params.appointmentId;
	}
}

export class CancelAppointmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CancelAppointmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelClosingTicketRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelClosingTicketRequest';
	IsBlocking = false;
	ClosingTicketId: number;
	OriginalTicketId: number;
	constructor(_params: {
		closingTicketId: number,
		originalTicketId: number
	}) {
		super({});
		this.ClosingTicketId = _params.closingTicketId;
		this.OriginalTicketId = _params.originalTicketId;
	}
}

export class CancelClosingTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelClosingTicketResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelDeliveryNotesFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelDeliveryNotesFromAdminRequest';
	IsBlocking = false;
	BusinessDay: Date;
	ClosingPosId: number;
	DeliveryNoteIds: number[];
	constructor(_params: {
		deliveryNoteIds: number[],
		businessDay: Date,
		closingPosId: number
	}) {
		super({});
		this.DeliveryNoteIds = _params.deliveryNoteIds;
		this.BusinessDay = _params.businessDay;
		this.ClosingPosId = _params.closingPosId;
	}
}

export class CancelDeliveryNotesFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelDeliveryNotesFromAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelDeliveryNotesFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelDeliveryNotesFromPosRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	ShouldPrint: boolean;
	constructor(_params: {
		deliveryNoteIds: number[],
		shouldPrint: boolean
	}) {
		super({});
		this.DeliveryNoteIds = _params.deliveryNoteIds;
		this.ShouldPrint = _params.shouldPrint;
	}
}

export class CancelDeliveryNotesFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelDeliveryNotesFromPosResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelEmailingRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CancelEmailingRequest';
	IsBlocking = true;
	EmailingId: number;
	constructor(_params: {
		emailingId: number
	}) {
		super({});
		this.EmailingId = _params.emailingId;
	}
}

export class CancelEmailingResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CancelEmailingResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelPrintedTicketLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelPrintedTicketLineRequest';
	IsBlocking = false;
	Reason: string;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		reason: string
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Reason = _params.reason;
	}
}

export class CancelPrintedTicketLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelPrintedTicketLineResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelSalesOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelSalesOrderRequest';
	IsBlocking = false;
	Audit: boolean;
	OrderId: number;
	OverrideBusinessDay: Nullable<Date>;
	OverrideCreationDate: Nullable<Date>;
	OverridePosId: Nullable<number>;
	constructor(_params: {
		orderId: number,
		overridePosId: Nullable<number>,
		overrideBusinessDay: Nullable<Date>,
		overrideCreationDate: Nullable<Date>,
		audit: boolean
	}) {
		super({});
		this.OrderId = _params.orderId;
		this.OverridePosId = _params.overridePosId;
		this.OverrideBusinessDay = _params.overrideBusinessDay;
		this.OverrideCreationDate = _params.overrideCreationDate;
		this.Audit = _params.audit;
	}
}

export class CancelSalesOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelSalesOrderResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Success: boolean;
	constructor(_params: {
		success: boolean,
		errorMessage: string
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class CancelTicketLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelTicketLineRequest';
	IsBlocking = false;
	Reason: string;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		reason: string
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Reason = _params.reason;
	}
}

export class CancelTicketLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelTicketLineResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelTicketRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelTicketRequest';
	IsBlocking = false;
	Reason: string;
	TicketId: number;
	Type: CancellationType;
	constructor(_params: {
		ticketId: number,
		reason: string,
		type: CancellationType
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Reason = _params.reason;
		this.Type = _params.type;
	}
}

export class CancelTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CancelTicketResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CancelWorkPlaceUpdateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.CancelWorkPlaceUpdateRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class CancelWorkPlaceUpdateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.CancelWorkPlaceUpdateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CanChangeInvoicePaymentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanChangeInvoicePaymentRequest';
	IsBlocking = true;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class CanChangeInvoicePaymentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanChangeInvoicePaymentResponse';
	IsBlocking = true;
	Result: CanChangeInvoicePaymentResultDTO;
	constructor(_params: {
		result: CanChangeInvoicePaymentResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class CanChangeInvoicePaymentsFromWebAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanChangeInvoicePaymentsFromWebAdminRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class CanChangeInvoicePaymentsFromWebAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanChangeInvoicePaymentsFromWebAdminResponse';
	IsBlocking = false;
	AmountToChange: number;
	CanBeChanged: boolean;
	Reason: string;
	constructor(_params: {
		canBeChanged: boolean,
		reason: string,
		amountToChange: number
	}) {
		super({});
		this.CanBeChanged = _params.canBeChanged;
		this.Reason = _params.reason;
		this.AmountToChange = _params.amountToChange;
	}
}

export class CanChangeUnitToBaseFactorRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanChangeUnitToBaseFactorRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanChangeUnitToBaseFactorResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanChangeUnitToBaseFactorResponse';
	IsBlocking = false;
	CanBeChanged: boolean;
	constructor(_params: {
		canBeChanged: boolean
	}) {
		super({});
		this.CanBeChanged = _params.canBeChanged;
	}
}

export class CanCreateDigitalMenuRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanCreateDigitalMenuRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CanCreateDigitalMenuResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanCreateDigitalMenuResponse';
	IsBlocking = false;
	CanCreate: boolean;
	Reason: string;
	constructor(_params: {
		canCreate: boolean,
		reason: string
	}) {
		super({});
		this.CanCreate = _params.canCreate;
		this.Reason = _params.reason;
	}
}

export class CanDeleteCardProcessorSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCardProcessorSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteCardProcessorSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCardProcessorSettingsResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteCashControlSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCashControlSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteCashControlSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCashControlSettingsResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteCategoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCategoryRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteCategoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCategoryResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteColorRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteColorRequest';
	IsBlocking = false;
	Data: ColorForEditionDTO;
	constructor(_params: {
		data: ColorForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class CanDeleteColorResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteColorResponse';
	IsBlocking = false;
	CanDelete: boolean;
	constructor(_params: {
		canDelete: boolean
	}) {
		super({});
		this.CanDelete = _params.canDelete;
	}
}

export class CanDeleteColorsFromProductRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteColorsFromProductRequest';
	IsBlocking = false;
	Colors: ColorDTO[];
	ProductId: number;
	constructor(_params: {
		productId: number,
		colors: ColorDTO[]
	}) {
		super({});
		this.ProductId = _params.productId;
		this.Colors = _params.colors;
	}
}

export class CanDeleteColorsFromProductResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteColorsFromProductResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteCouponPrintTemplateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCouponPrintTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteCouponPrintTemplateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCouponPrintTemplateResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCustomerRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteCustomerResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteDisplayProfileRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteDisplayProfileRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteDisplayProfileResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteDisplayProfileResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteEmailAccountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CanDeleteEmailAccountRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteEmailAccountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CanDeleteEmailAccountResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteIncomingDeliveryNoteRequest';
	IsBlocking = false;
	Ids: number[];
	constructor(_params: {
		ids: number[]
	}) {
		super({});
		this.Ids = _params.ids;
	}
}

export class CanDeleteIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteIncomingDeliveryNoteResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteInternalCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteInternalCustomerRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteInternalCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteInternalCustomerResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteInternalSupplierRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteInternalSupplierRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteInternalSupplierResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteInternalSupplierResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteInventoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDeleteInventoryRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteInventoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDeleteInventoryResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteKitchenPrintTemplateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteKitchenPrintTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteKitchenPrintTemplateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteKitchenPrintTemplateResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeletePointOfSaleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePointOfSaleRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeletePointOfSaleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePointOfSaleResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeletePointOfSalesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePointOfSalesRequest';
	IsBlocking = false;
	Ids: number[];
	constructor(_params: {
		ids: number[]
	}) {
		super({});
		this.Ids = _params.ids;
	}
}

export class CanDeletePointOfSalesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePointOfSalesResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeletePosGroupRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePosGroupRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeletePosGroupResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePosGroupResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeletePreparationOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePreparationOrderRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeletePreparationOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePreparationOrderResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeletePreparationTypeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePreparationTypeRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeletePreparationTypeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePreparationTypeResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeletePriceListRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePriceListRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeletePriceListResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePriceListResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeletePriceListsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePriceListsRequest';
	IsBlocking = false;
	Ids: number[];
	constructor(_params: {
		ids: number[]
	}) {
		super({});
		this.Ids = _params.ids;
	}
}

export class CanDeletePriceListsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePriceListsResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteProductionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDeleteProductionRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteProductionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDeleteProductionResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteProductRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteProductRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteProductResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteProductResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeletePurchaseOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePurchaseOrderRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeletePurchaseOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeletePurchaseOrderResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteSaleCenterRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSaleCenterRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteSaleCenterResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSaleCenterResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteSerieRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSerieRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteSerieResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSerieResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteSifSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSifSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteSifSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSifSettingsResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteSizeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSizeRequest';
	IsBlocking = false;
	Data: SizeForEditionDTO;
	constructor(_params: {
		data: SizeForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class CanDeleteSizeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSizeResponse';
	IsBlocking = false;
	CanDelete: boolean;
	constructor(_params: {
		canDelete: boolean
	}) {
		super({});
		this.CanDelete = _params.canDelete;
	}
}

export class CanDeleteSizesFromProductRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSizesFromProductRequest';
	IsBlocking = false;
	ProductId: number;
	Sizes: SizeDTO[];
	constructor(_params: {
		productId: number,
		sizes: SizeDTO[]
	}) {
		super({});
		this.ProductId = _params.productId;
		this.Sizes = _params.sizes;
	}
}

export class CanDeleteSizesFromProductResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSizesFromProductResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteSmartMenuOrderSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSmartMenuOrderSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteSmartMenuOrderSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteStockChangeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDeleteStockChangeRequest';
	IsBlocking = false;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
	}
}

export class CanDeleteStockChangeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDeleteStockChangeResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteSystemOfMeasurementRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSystemOfMeasurementRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteSystemOfMeasurementResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteSystemOfMeasurementResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteTablePaymentSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteTablePaymentSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteTablePaymentSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteTablePaymentSettingsResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteUnitOfMeasurementRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUnitOfMeasurementRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteUnitOfMeasurementResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUnitOfMeasurementResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteUserProfileRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUserProfileRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteUserProfileResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUserProfileResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUserRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteUserResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUserResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteUsersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUsersRequest';
	IsBlocking = false;
	Ids: number[];
	constructor(_params: {
		ids: number[]
	}) {
		super({});
		this.Ids = _params.ids;
	}
}

export class CanDeleteUsersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteUsersResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Reason: string;
	constructor(_params: {
		canBeDeleted: boolean,
		reason: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Reason = _params.reason;
	}
}

export class CanDeleteWarehouseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteWarehouseRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteWarehouseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteWarehouseResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDeleteWarehousesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteWarehousesRequest';
	IsBlocking = false;
	Ids: number[];
	constructor(_params: {
		ids: number[]
	}) {
		super({});
		this.Ids = _params.ids;
	}
}

export class CanDeleteWarehousesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteWarehousesResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	Message: string;
	constructor(_params: {
		canBeDeleted: boolean,
		message: string
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
		this.Message = _params.message;
	}
}

export class CanDeleteWorkplaceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteWorkplaceRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanDeleteWorkplaceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanDeleteWorkplaceResponse';
	IsBlocking = false;
	CanBeDeleted: boolean;
	constructor(_params: {
		canBeDeleted: boolean
	}) {
		super({});
		this.CanBeDeleted = _params.canBeDeleted;
	}
}

export class CanDuplicateStockChangeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDuplicateStockChangeRequest';
	IsBlocking = false;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
	}
}

export class CanDuplicateStockChangeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanDuplicateStockChangeResponse';
	IsBlocking = false;
	CanBeDuplicated: boolean;
	constructor(_params: {
		canBeDuplicated: boolean
	}) {
		super({});
		this.CanBeDuplicated = _params.canBeDuplicated;
	}
}

export class CanEditInternalCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanEditInternalCustomerRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanEditInternalCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanEditInternalCustomerResponse';
	IsBlocking = false;
	CanBeEdited: boolean;
	Reason: string;
	constructor(_params: {
		canBeEdited: boolean,
		reason: string
	}) {
		super({});
		this.CanBeEdited = _params.canBeEdited;
		this.Reason = _params.reason;
	}
}

export class CanEditInternalSupplierRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanEditInternalSupplierRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanEditInternalSupplierResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanEditInternalSupplierResponse';
	IsBlocking = false;
	CanBeEdited: boolean;
	Reason: string;
	constructor(_params: {
		canBeEdited: boolean,
		reason: string
	}) {
		super({});
		this.CanBeEdited = _params.canBeEdited;
		this.Reason = _params.reason;
	}
}

export class CanEditUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanEditUserRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class CanEditUserResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CanEditUserResponse';
	IsBlocking = false;
	CanBeEdited: boolean;
	Reason: string;
	constructor(_params: {
		canBeEdited: boolean,
		reason: string
	}) {
		super({});
		this.CanBeEdited = _params.canBeEdited;
		this.Reason = _params.reason;
	}
}

export class CanEmitDocumentFromWebAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanEmitDocumentFromWebAdminRequest';
	IsBlocking = false;
	DocumentType: DocumentType;
	PosIds: number[];
	constructor(_params: {
		documentType: DocumentType,
		posIds: number[]
	}) {
		super({});
		this.DocumentType = _params.documentType;
		this.PosIds = _params.posIds;
	}
}

export class CanEmitDocumentFromWebAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CanEmitDocumentFromWebAdminResponse';
	IsBlocking = false;
	CanEmit: boolean;
	Message: string;
	constructor(_params: {
		canEmit: boolean,
		message: string
	}) {
		super({});
		this.CanEmit = _params.canEmit;
		this.Message = _params.message;
	}
}

export class CanIncomingDeliveryNotesBeInvoicedTogetherRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanIncomingDeliveryNotesBeInvoicedTogetherRequest';
	IsBlocking = true;
	InvoiceId: Nullable<number>;
	NoteIds: number[];
	constructor(_params: {
		invoiceId: Nullable<number>,
		noteIds: number[]
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.NoteIds = _params.noteIds;
	}
}

export class CanIncomingDeliveryNotesBeInvoicedTogetherResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CanIncomingDeliveryNotesBeInvoicedTogetherResponse';
	IsBlocking = false;
	CanBeInvoiced: boolean;
	constructor(_params: {
		canBeInvoiced: boolean
	}) {
		super({});
		this.CanBeInvoiced = _params.canBeInvoiced;
	}
}

export class CanOpenDayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.CanOpenDayRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CanOpenDayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.CanOpenDayResponse';
	IsBlocking = false;
	CanOpen: boolean;
	Reason: string;
	constructor(_params: {
		canOpen: boolean,
		reason: string
	}) {
		super({});
		this.CanOpen = _params.canOpen;
		this.Reason = _params.reason;
	}
}

export class CanReopenDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CanReopenDeliveryNoteRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class CanReopenDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CanReopenDeliveryNoteResponse';
	IsBlocking = false;
	Result: CanReopenDeliveryNoteResultDTO;
	constructor(_params: {
		result: CanReopenDeliveryNoteResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class CardLoginRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.CardLoginRequest';
	IsBlocking = false;
	CardNumber: string;
	DefaultLanguageCode: string;
	constructor(_params: {
		cardNumber: string,
		defaultLanguageCode: string
	}) {
		super({});
		this.CardNumber = _params.cardNumber;
		this.DefaultLanguageCode = _params.defaultLanguageCode;
	}
}

export class CardLoginResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.CardLoginResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Session: SessionDTO;
	Success: boolean;
	constructor(_params: {
		session: SessionDTO,
		success: boolean,
		errorMessage: string
	}) {
		super({});
		this.Session = _params.session;
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class ChangeDeliveryNoteCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeDeliveryNoteCustomerRequest';
	IsBlocking = false;
	Customer: BuyerCustomerDTO;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number,
		customer: BuyerCustomerDTO
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
		this.Customer = _params.customer;
	}
}

export class ChangeDeliveryNoteCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeDeliveryNoteCustomerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ChangeInvoicePaymentFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeInvoicePaymentFromAdminRequest';
	IsBlocking = true;
	InvoiceId: number;
	Params: InvoiceParamsFromAdminDTO;
	constructor(_params: {
		invoiceId: number,
		params: InvoiceParamsFromAdminDTO
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Params = _params.params;
	}
}

export class ChangeInvoicePaymentFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeInvoicePaymentFromAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ChangeInvoicePaymentFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeInvoicePaymentFromPosRequest';
	IsBlocking = true;
	InvoiceId: number;
	Params: InvoiceParamsFromPosDTO;
	constructor(_params: {
		invoiceId: number,
		params: InvoiceParamsFromPosDTO
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Params = _params.params;
	}
}

export class ChangeInvoicePaymentFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeInvoicePaymentFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class ChangePricesByMarginsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ChangePricesByMarginsRequest';
	IsBlocking = false;
	Margins: ProductMarginForEditionDTO[];
	Params: ChangePricesByMarginsParamsDTO;
	constructor(_params: {
		margins: ProductMarginForEditionDTO[],
		params: ChangePricesByMarginsParamsDTO
	}) {
		super({});
		this.Margins = _params.margins;
		this.Params = _params.params;
	}
}

export class ChangePricesByMarginsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ChangePricesByMarginsResponse';
	IsBlocking = false;
	Margins: ProductMarginForEditionDTO[];
	constructor(_params: {
		margins: ProductMarginForEditionDTO[]
	}) {
		super({});
		this.Margins = _params.margins;
	}
}

export class ChangePricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ChangePricesRequest';
	IsBlocking = true;
	Params: ChangePricesParamsDTO;
	Prices: ProductPriceForEditionDTO[];
	constructor(_params: {
		prices: ProductPriceForEditionDTO[],
		params: ChangePricesParamsDTO
	}) {
		super({});
		this.Prices = _params.prices;
		this.Params = _params.params;
	}
}

export class ChangePricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ChangePricesResponse';
	IsBlocking = false;
	Result: ProductPriceForEditionDTO[];
	constructor(_params: {
		result: ProductPriceForEditionDTO[]
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class ChangePrintModeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.ChangePrintModeRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ChangePrintModeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.ChangePrintModeResponse';
	IsBlocking = false;
	WhenPrint: WhenPrint;
	constructor(_params: {
		whenPrint: WhenPrint
	}) {
		super({});
		this.WhenPrint = _params.whenPrint;
	}
}

export class ChangeSalesOrderCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeSalesOrderCustomerRequest';
	IsBlocking = false;
	Customer: BuyerCustomerDTO;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number,
		customer: BuyerCustomerDTO
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
		this.Customer = _params.customer;
	}
}

export class ChangeSalesOrderCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeSalesOrderCustomerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ChangeSalesOrderDeliveryPersonRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeSalesOrderDeliveryPersonRequest';
	IsBlocking = false;
	DeliveryPersonId: number;
	OrderId: number;
	constructor(_params: {
		orderId: number,
		deliveryPersonId: number
	}) {
		super({});
		this.OrderId = _params.orderId;
		this.DeliveryPersonId = _params.deliveryPersonId;
	}
}

export class ChangeSalesOrderDeliveryPersonResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeSalesOrderDeliveryPersonResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ChangeTicketLineAddinsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeTicketLineAddinsRequest';
	IsBlocking = false;
	Addins: SoldProductDTO[];
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		addins: SoldProductDTO[]
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Addins = _params.addins;
	}
}

export class ChangeTicketLineAddinsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeTicketLineAddinsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ChangeTicketOpenerUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeTicketOpenerUserRequest';
	IsBlocking = false;
	TicketId: number;
	UserId: number;
	constructor(_params: {
		ticketId: number,
		userId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.UserId = _params.userId;
	}
}

export class ChangeTicketOpenerUserResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ChangeTicketOpenerUserResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CheckPaymentsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.CheckPaymentsRequest';
	IsBlocking = false;
	AmountToPay: number;
	IsRefund: boolean;
	Payments: PaymentDTO[];
	constructor(_params: {
		amountToPay: number,
		payments: PaymentDTO[],
		isRefund: boolean
	}) {
		super({});
		this.AmountToPay = _params.amountToPay;
		this.Payments = _params.payments;
		this.IsRefund = _params.isRefund;
	}
}

export class CheckPaymentsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.CheckPaymentsResponse';
	IsBlocking = false;
	Result: PaymentsStatusDTO;
	constructor(_params: {
		result: PaymentsStatusDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class CheckRequiredCustomerForInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CheckRequiredCustomerForInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	NewPayments: PaymentDTO[];
	constructor(_params: {
		invoiceId: number,
		newPayments: PaymentDTO[]
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.NewPayments = _params.newPayments;
	}
}

export class CheckRequiredCustomerForInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CheckRequiredCustomerForInvoiceResponse';
	IsBlocking = false;
	Result: CheckRequiredCustomerResultDTO;
	constructor(_params: {
		result: CheckRequiredCustomerResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class CheckRequiredCustomerForTicketsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CheckRequiredCustomerForTicketsRequest';
	IsBlocking = false;
	NewPayments: PaymentDTO[];
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[],
		newPayments: PaymentDTO[]
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
		this.NewPayments = _params.newPayments;
	}
}

export class CheckRequiredCustomerForTicketsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CheckRequiredCustomerForTicketsResponse';
	IsBlocking = false;
	Result: CheckRequiredCustomerResultDTO;
	constructor(_params: {
		result: CheckRequiredCustomerResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class CheckSifSettingsHasEmittedInvoicesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CheckSifSettingsHasEmittedInvoicesRequest';
	IsBlocking = false;
	Data: SifSettingsForEditionDTO;
	constructor(_params: {
		data: SifSettingsForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class CheckSifSettingsHasEmittedInvoicesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CheckSifSettingsHasEmittedInvoicesResponse';
	IsBlocking = false;
	HasEmittedInvoices: boolean;
	constructor(_params: {
		hasEmittedInvoices: boolean
	}) {
		super({});
		this.HasEmittedInvoices = _params.hasEmittedInvoices;
	}
}

export class ClearDefaultReportViewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.ClearDefaultReportViewRequest';
	IsBlocking = false;
	ReportId: string;
	constructor(_params: {
		reportId: string
	}) {
		super({});
		this.ReportId = _params.reportId;
	}
}

export class ClearDefaultReportViewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.ClearDefaultReportViewResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ClearGStockPendingUploadRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.ClearGStockPendingUploadRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class ClearGStockPendingUploadResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.ClearGStockPendingUploadResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ClearGStockPendingUploadsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.ClearGStockPendingUploadsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ClearGStockPendingUploadsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.ClearGStockPendingUploadsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ClearWorkplaceDataCacheRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.ClearWorkplaceDataCacheRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CloseAppointmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CloseAppointmentRequest';
	IsBlocking = false;
	AppointmentId: number;
	Location: TicketLocationDTO;
	constructor(_params: {
		appointmentId: number,
		location: TicketLocationDTO
	}) {
		super({});
		this.AppointmentId = _params.appointmentId;
		this.Location = _params.location;
	}
}

export class CloseAppointmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CloseAppointmentResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class CloseBusinessDayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.CloseBusinessDayRequest';
	IsBlocking = false;
	Balances: PaymentMethodBalanceDTO[];
	Incident: string;
	constructor(_params: {
		balances: PaymentMethodBalanceDTO[],
		incident: string
	}) {
		super({});
		this.Balances = _params.balances;
		this.Incident = _params.incident;
	}
}

export class CloseBusinessDayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.CloseBusinessDayResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CloseSalesOrderFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseSalesOrderFromAdminRequest';
	IsBlocking = false;
	OrderId: number;
	Params: InvoiceParamsFromAdminDTO;
	constructor(_params: {
		orderId: number,
		params: InvoiceParamsFromAdminDTO
	}) {
		super({});
		this.OrderId = _params.orderId;
		this.Params = _params.params;
	}
}

export class CloseSalesOrderFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseSalesOrderFromAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CloseSalesOrderFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseSalesOrderFromPosRequest';
	IsBlocking = false;
	OrderId: number;
	Params: InvoiceParamsFromPosDTO;
	constructor(_params: {
		orderId: number,
		params: InvoiceParamsFromPosDTO
	}) {
		super({});
		this.OrderId = _params.orderId;
		this.Params = _params.params;
	}
}

export class CloseSalesOrderFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseSalesOrderFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CloseTicketFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseTicketFromPosRequest';
	IsBlocking = false;
	Params: InvoiceParamsFromPosDTO;
	TicketId: number;
	constructor(_params: {
		params: InvoiceParamsFromPosDTO,
		ticketId: number
	}) {
		super({});
		this.Params = _params.params;
		this.TicketId = _params.ticketId;
	}
}

export class CloseTicketFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseTicketFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CloseTicketFromTablePaymentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseTicketFromTablePaymentRequest';
	IsBlocking = false;
	Payment: PaymentDTO;
	TicketId: number;
	constructor(_params: {
		payment: PaymentDTO,
		ticketId: number
	}) {
		super({});
		this.Payment = _params.payment;
		this.TicketId = _params.ticketId;
	}
}

export class CloseTicketFromTablePaymentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CloseTicketFromTablePaymentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CompleteMenuRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CompleteMenuRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class CompleteMenuResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CompleteMenuResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class ConfirmAllIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmAllIncomingDeliveryNoteRequest';
	IsBlocking = true;
	IncomingDeliveryNoteIds: number[];
	constructor(_params: {
		incomingDeliveryNoteIds: number[]
	}) {
		super({});
		this.IncomingDeliveryNoteIds = _params.incomingDeliveryNoteIds;
	}
}

export class ConfirmAllIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmAllIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Errors: PurchaseDocumentErrorDTO[];
	constructor(_params: {
		errors: PurchaseDocumentErrorDTO[]
	}) {
		super({});
		this.Errors = _params.errors;
	}
}

export class ConfirmAllPurchaseOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmAllPurchaseOrderRequest';
	IsBlocking = true;
	PurchaseOrderIds: number[];
	SendEmail: boolean;
	constructor(_params: {
		purchaseOrderIds: number[],
		sendEmail: boolean
	}) {
		super({});
		this.PurchaseOrderIds = _params.purchaseOrderIds;
		this.SendEmail = _params.sendEmail;
	}
}

export class ConfirmAllPurchaseOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmAllPurchaseOrderResponse';
	IsBlocking = false;
	Errors: PurchaseDocumentErrorDTO[];
	constructor(_params: {
		errors: PurchaseDocumentErrorDTO[]
	}) {
		super({});
		this.Errors = _params.errors;
	}
}

export class ConfirmIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmIncomingDeliveryNoteRequest';
	IsBlocking = true;
	ForceCostPricesUpdate: boolean;
	IncomingDeliveryNoteId: number;
	constructor(_params: {
		incomingDeliveryNoteId: number,
		forceCostPricesUpdate: boolean
	}) {
		super({});
		this.IncomingDeliveryNoteId = _params.incomingDeliveryNoteId;
		this.ForceCostPricesUpdate = _params.forceCostPricesUpdate;
	}
}

export class ConfirmIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Data: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		data: IncomingDeliveryNoteForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ConfirmInventoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmInventoryRequest';
	IsBlocking = true;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class ConfirmInventoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmInventoryResponse';
	IsBlocking = false;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class ConfirmPurchaseOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmPurchaseOrderRequest';
	IsBlocking = true;
	PurchaseOrderId: number;
	constructor(_params: {
		purchaseOrderId: number
	}) {
		super({});
		this.PurchaseOrderId = _params.purchaseOrderId;
	}
}

export class ConfirmPurchaseOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConfirmPurchaseOrderResponse';
	IsBlocking = false;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ConfirmUserPasswordRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ConfirmUserPasswordRequest';
	IsBlocking = false;
	UserPassword: string;
	constructor(_params: {
		userPassword: string
	}) {
		super({});
		this.UserPassword = _params.userPassword;
	}
}

export class ConfirmUserPasswordResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ConfirmUserPasswordResponse';
	IsBlocking = false;
	IsValid: boolean;
	constructor(_params: {
		isValid: boolean
	}) {
		super({});
		this.IsValid = _params.isValid;
	}
}

export class ConvertPurchaseOrderToIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConvertPurchaseOrderToIncomingDeliveryNoteRequest';
	IsBlocking = false;
	PurchaseOrder: PurchaseOrderForEditionDTO;
	constructor(_params: {
		purchaseOrder: PurchaseOrderForEditionDTO
	}) {
		super({});
		this.PurchaseOrder = _params.purchaseOrder;
	}
}

export class ConvertPurchaseOrderToIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ConvertPurchaseOrderToIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Note: IncomingDeliveryNoteForEditionDTO;
	PurchaseOrderId: number;
	constructor(_params: {
		note: IncomingDeliveryNoteForEditionDTO,
		purchaseOrderId: number
	}) {
		super({});
		this.Note = _params.note;
		this.PurchaseOrderId = _params.purchaseOrderId;
	}
}

export class ConvertToStandardInvoiceFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ConvertToStandardInvoiceFromAdminRequest';
	IsBlocking = false;
	BasicInvoiceId: number;
	Params: ConvertToStandardInvoiceParamsFromAdminDTO;
	constructor(_params: {
		basicInvoiceId: number,
		params: ConvertToStandardInvoiceParamsFromAdminDTO
	}) {
		super({});
		this.BasicInvoiceId = _params.basicInvoiceId;
		this.Params = _params.params;
	}
}

export class ConvertToStandardInvoiceFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ConvertToStandardInvoiceFromAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ConvertToStandardInvoiceFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ConvertToStandardInvoiceFromPosRequest';
	IsBlocking = false;
	BasicInvoiceId: number;
	Params: ConvertToStandardInvoiceParamsFromPosDTO;
	constructor(_params: {
		basicInvoiceId: number,
		params: ConvertToStandardInvoiceParamsFromPosDTO
	}) {
		super({});
		this.BasicInvoiceId = _params.basicInvoiceId;
		this.Params = _params.params;
	}
}

export class ConvertToStandardInvoiceFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ConvertToStandardInvoiceFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CopyPricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CopyPricesRequest';
	IsBlocking = true;
	Params: CopyPricesParamsDTO;
	Prices: ProductPriceForEditionDTO[];
	constructor(_params: {
		prices: ProductPriceForEditionDTO[],
		params: CopyPricesParamsDTO
	}) {
		super({});
		this.Prices = _params.prices;
		this.Params = _params.params;
	}
}

export class CopyPricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CopyPricesResponse';
	IsBlocking = false;
	Result: ProductPriceForEditionDTO[];
	constructor(_params: {
		result: ProductPriceForEditionDTO[]
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class CopyReferencePricesFromMarginsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CopyReferencePricesFromMarginsRequest';
	IsBlocking = false;
	Margins: ProductMarginForEditionDTO[];
	Role: Nullable<SaleFormatRole>;
	constructor(_params: {
		margins: ProductMarginForEditionDTO[],
		role: Nullable<SaleFormatRole>
	}) {
		super({});
		this.Margins = _params.margins;
		this.Role = _params.role;
	}
}

export class CopyReferencePricesFromMarginsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CopyReferencePricesFromMarginsResponse';
	IsBlocking = false;
	Margins: ProductMarginForEditionDTO[];
	constructor(_params: {
		margins: ProductMarginForEditionDTO[]
	}) {
		super({});
		this.Margins = _params.margins;
	}
}

export class CreateAppointmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CreateAppointmentRequest';
	IsBlocking = false;
	Date: Date;
	constructor(_params: {
		date: Date
	}) {
		super({});
		this.Date = _params.date;
	}
}

export class CreateAppointmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.CreateAppointmentResponse';
	IsBlocking = false;
	Appointment: AppointmentForEditionDTO;
	constructor(_params: {
		appointment: AppointmentForEditionDTO
	}) {
		super({});
		this.Appointment = _params.appointment;
	}
}

export class CreateDeliveryNoteFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNoteFromPosRequest';
	IsBlocking = false;
	Params: DeliveryNoteParamsFromPosDTO;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		params: DeliveryNoteParamsFromPosDTO
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Params = _params.params;
	}
}

export class CreateDeliveryNoteFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNoteFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CreateDeliveryNoteFromSalesOrderFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNoteFromSalesOrderFromAdminRequest';
	IsBlocking = false;
	Params: CreateDeliveryNoteFromSalesOrderFromAdminParamsDTO;
	constructor(_params: {
		params: CreateDeliveryNoteFromSalesOrderFromAdminParamsDTO
	}) {
		super({});
		this.Params = _params.params;
	}
}

export class CreateDeliveryNoteFromSalesOrderFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNoteFromSalesOrderFromAdminResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CreateDeliveryNoteFromSalesOrderFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNoteFromSalesOrderFromPosRequest';
	IsBlocking = false;
	Params: CreateDeliveryNoteFromSalesOrderParamsFromPosDTO;
	constructor(_params: {
		params: CreateDeliveryNoteFromSalesOrderParamsFromPosDTO
	}) {
		super({});
		this.Params = _params.params;
	}
}

export class CreateDeliveryNoteFromSalesOrderFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNoteFromSalesOrderFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CreateDeliveryNotesInvoiceFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesInvoiceFromAdminRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	Params: InvoiceParamsFromAdminDTO;
	constructor(_params: {
		params: InvoiceParamsFromAdminDTO,
		deliveryNoteIds: number[]
	}) {
		super({});
		this.Params = _params.params;
		this.DeliveryNoteIds = _params.deliveryNoteIds;
	}
}

export class CreateDeliveryNotesInvoiceFromAdminRespone extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesInvoiceFromAdminRespone';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateDeliveryNotesInvoiceFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesInvoiceFromPosRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	Params: InvoiceParamsFromPosDTO;
	constructor(_params: {
		params: InvoiceParamsFromPosDTO,
		deliveryNoteIds: number[]
	}) {
		super({});
		this.Params = _params.params;
		this.DeliveryNoteIds = _params.deliveryNoteIds;
	}
}

export class CreateDeliveryNotesInvoiceFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesInvoiceFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CreateDeliveryNotesLinesFromInternalOrdersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateDeliveryNotesLinesFromInternalOrdersRequest';
	IsBlocking = true;
	SalesOrderIds: number[];
	constructor(_params: {
		salesOrderIds: number[]
	}) {
		super({});
		this.SalesOrderIds = _params.salesOrderIds;
	}
}

export class CreateDeliveryNotesLinesFromInternalOrdersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateDeliveryNotesLinesFromInternalOrdersResponse';
	IsBlocking = false;
	DeliveryNoteFromInternalOrders: DeliveryNoteFromInternalOrdersDTO;
	constructor(_params: {
		deliveryNoteFromInternalOrders: DeliveryNoteFromInternalOrdersDTO
	}) {
		super({});
		this.DeliveryNoteFromInternalOrders = _params.deliveryNoteFromInternalOrders;
	}
}

export class CreateDeliveryNotesRefundFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesRefundFromAdminRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	Params: InvoiceParamsFromAdminDTO;
	constructor(_params: {
		params: InvoiceParamsFromAdminDTO,
		deliveryNoteIds: number[]
	}) {
		super({});
		this.Params = _params.params;
		this.DeliveryNoteIds = _params.deliveryNoteIds;
	}
}

export class CreateDeliveryNotesRefundFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesRefundFromAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateDeliveryNotesRefundFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesRefundFromPosRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	Params: InvoiceParamsFromPosDTO;
	constructor(_params: {
		params: InvoiceParamsFromPosDTO,
		deliveryNoteIds: number[]
	}) {
		super({});
		this.Params = _params.params;
		this.DeliveryNoteIds = _params.deliveryNoteIds;
	}
}

export class CreateDeliveryNotesRefundFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateDeliveryNotesRefundFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CreateLossRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateLossRequest';
	IsBlocking = false;
	Reason: string;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		reason: string
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Reason = _params.reason;
	}
}

export class CreateLossResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateLossResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateNewOrGetUnusedTicketInLocationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateNewOrGetUnusedTicketInLocationRequest';
	IsBlocking = false;
	Location: TicketLocationDTO;
	constructor(_params: {
		location: TicketLocationDTO
	}) {
		super({});
		this.Location = _params.location;
	}
}

export class CreateNewOrGetUnusedTicketInLocationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateNewOrGetUnusedTicketInLocationResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class CreateNewTicketForLocationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateNewTicketForLocationRequest';
	IsBlocking = false;
	Location: TicketLocationDTO;
	constructor(_params: {
		location: TicketLocationDTO
	}) {
		super({});
		this.Location = _params.location;
	}
}

export class CreateNewTicketForLocationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateNewTicketForLocationResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class CreatePaymentOperationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.CreatePaymentOperationRequest';
	IsBlocking = false;
	IsForRefund: boolean;
	constructor(_params: {
		isForRefund: boolean
	}) {
		super({});
		this.IsForRefund = _params.isForRefund;
	}
}

export class CreatePaymentOperationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.CreatePaymentOperationResponse';
	IsBlocking = false;
	PaymentOperation: PaymentOperationDTO;
	constructor(_params: {
		paymentOperation: PaymentOperationDTO
	}) {
		super({});
		this.PaymentOperation = _params.paymentOperation;
	}
}

export class CreatePurchaseOrdersFromProposalsByWarehouseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreatePurchaseOrdersFromProposalsByWarehouseRequest';
	IsBlocking = false;
	Date: Date;
	Proposal: OrderLineProposalDTO[];
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		date: Date,
		proposal: OrderLineProposalDTO[]
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.Date = _params.date;
		this.Proposal = _params.proposal;
	}
}

export class CreatePurchaseOrdersFromProposalsByWarehouseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreatePurchaseOrdersFromProposalsByWarehouseResponse';
	IsBlocking = false;
	CreatedOrders: PurchaseOrderInListDTO[];
	constructor(_params: {
		createdOrders: PurchaseOrderInListDTO[]
	}) {
		super({});
		this.CreatedOrders = _params.createdOrders;
	}
}

export class CreateRequest<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateRequest<TForEdition>';
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateResponse<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateResponse<TForEdition>';
	Data: _TForEdition;
	constructor(_params: {
		data: _TForEdition
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class CreateRestockProposalByProductsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateRestockProposalByProductsRequest';
	IsBlocking = false;
	ProductIds: number[];
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		productIds: number[],
		supplierId: number,
		warehouseId: number
	}) {
		super({});
		this.ProductIds = _params.productIds;
		this.SupplierId = _params.supplierId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class CreateRestockProposalByProductsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateRestockProposalByProductsResponse';
	IsBlocking = false;
	Proposals: RestockProposalDTO[];
	constructor(_params: {
		proposals: RestockProposalDTO[]
	}) {
		super({});
		this.Proposals = _params.proposals;
	}
}

export class CreateRestockProposalRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateRestockProposalRequest';
	IsBlocking = false;
	IncludeAllProducts: boolean;
	Order: PurchaseOrderForEditionDTO;
	constructor(_params: {
		order: PurchaseOrderForEditionDTO,
		includeAllProducts: boolean
	}) {
		super({});
		this.Order = _params.order;
		this.IncludeAllProducts = _params.includeAllProducts;
	}
}

export class CreateRestockProposalResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateRestockProposalResponse';
	IsBlocking = false;
	Proposal: RestockProposalDTO[];
	constructor(_params: {
		proposal: RestockProposalDTO[]
	}) {
		super({});
		this.Proposal = _params.proposal;
	}
}

export class CreateRestockProposalsByWarehouseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateRestockProposalsByWarehouseRequest';
	IsBlocking = false;
	CategoryIds: number[];
	FamilyIds: number[];
	FromDate: Date;
	IncludeAllProducts: boolean;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		familyIds: number[],
		categoryIds: number[],
		includeAllProducts: boolean,
		fromDate: Date
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.FamilyIds = _params.familyIds;
		this.CategoryIds = _params.categoryIds;
		this.IncludeAllProducts = _params.includeAllProducts;
		this.FromDate = _params.fromDate;
	}
}

export class CreateRestockProposalsByWarehouseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateRestockProposalsByWarehouseResponse';
	IsBlocking = false;
	Proposals: RestockProposalDTO[];
	constructor(_params: {
		proposals: RestockProposalDTO[]
	}) {
		super({});
		this.Proposals = _params.proposals;
	}
}

export class CreateSalesOrderFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateSalesOrderFromPosRequest';
	IsBlocking = false;
	Params: SalesOrderParamsFromPosDTO;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		params: SalesOrderParamsFromPosDTO
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Params = _params.params;
	}
}

export class CreateSalesOrderFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateSalesOrderFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CreateSalesOrderRefundFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateSalesOrderRefundFromAdminRequest';
	IsBlocking = false;
	Params: InvoiceParamsFromAdminDTO;
	SalesOrderId: number;
	constructor(_params: {
		params: InvoiceParamsFromAdminDTO,
		salesOrderId: number
	}) {
		super({});
		this.Params = _params.params;
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class CreateSalesOrderRefundFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateSalesOrderRefundFromAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSalesOrderRefundFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateSalesOrderRefundFromPosRequest';
	IsBlocking = false;
	Params: InvoiceParamsFromPosDTO;
	SalesOrderId: number;
	constructor(_params: {
		params: InvoiceParamsFromPosDTO,
		salesOrderId: number
	}) {
		super({});
		this.Params = _params.params;
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class CreateSalesOrderRefundFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateSalesOrderRefundFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class CreateTicketDivisionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateTicketDivisionRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class CreateTicketDivisionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateTicketDivisionResponse';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class CreateTicketFromRefundRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateTicketFromRefundRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class CreateTicketFromRefundResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateTicketFromRefundResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class CreateTipOperationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateTipOperationRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class CreateTipOperationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.CreateTipOperationResponse';
	IsBlocking = false;
	Operation: TipOperationDTO;
	constructor(_params: {
		operation: TipOperationDTO
	}) {
		super({});
		this.Operation = _params.operation;
	}
}

export class DeleteAppointmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.DeleteAppointmentRequest';
	IsBlocking = false;
	AppointmentId: number;
	constructor(_params: {
		appointmentId: number
	}) {
		super({});
		this.AppointmentId = _params.appointmentId;
	}
}

export class DeleteAppointmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.DeleteAppointmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteAuditQueryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.DeleteAuditQueryRequest';
	IsBlocking = false;
	Name: string;
	constructor(_params: {
		name: string
	}) {
		super({});
		this.Name = _params.name;
	}
}

export class DeleteAuditQueryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.DeleteAuditQueryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteBackupRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.DeleteBackupRequest';
	IsBlocking = false;
	Name: string;
	constructor(_params: {
		name: string
	}) {
		super({});
		this.Name = _params.name;
	}
}

export class DeleteBackupResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.DeleteBackupResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCashActivityRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DeleteCashActivityRequest';
	IsBlocking = true;
	BeforeBusinessDay: Date;
	constructor(_params: {
		beforeBusinessDay: Date
	}) {
		super({});
		this.BeforeBusinessDay = _params.beforeBusinessDay;
	}
}

export class DeleteCashActivityResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DeleteCashActivityResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCountFromInventoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteCountFromInventoryRequest';
	IsBlocking = false;
	CountId: number;
	InventoryId: number;
	constructor(_params: {
		inventoryId: number,
		countId: number
	}) {
		super({});
		this.InventoryId = _params.inventoryId;
		this.CountId = _params.countId;
	}
}

export class DeleteCountFromInventoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteCountFromInventoryResponse';
	IsBlocking = false;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class DeleteIncomingDeliveryNoteAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteIncomingDeliveryNoteAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	IncomingDeliveryNoteId: number;
	constructor(_params: {
		incomingDeliveryNoteId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.IncomingDeliveryNoteId = _params.incomingDeliveryNoteId;
		this.Attachment = _params.attachment;
	}
}

export class DeleteIncomingDeliveryNoteAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteIncomingDeliveryNoteAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePurchaseInvoiceAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseInvoiceAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	PurchaseInvoiceId: number;
	constructor(_params: {
		purchaseInvoiceId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.PurchaseInvoiceId = _params.purchaseInvoiceId;
		this.Attachment = _params.attachment;
	}
}

export class DeletePurchaseInvoiceAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseInvoiceAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePurchaseOrderAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseOrderAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	PurchaseOrderId: number;
	constructor(_params: {
		purchaseOrderId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.PurchaseOrderId = _params.purchaseOrderId;
		this.Attachment = _params.attachment;
	}
}

export class DeletePurchaseOrderAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseOrderAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteRequest<_TInList> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteRequest<TInList>';
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class DeleteResponse<_TInList> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteResponse<TInList>';
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteStockChangeAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteStockChangeAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
		this.Attachment = _params.attachment;
	}
}

export class DeleteStockChangeAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteStockChangeAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteTicketFromRefundRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DeleteTicketFromRefundRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class DeleteTicketFromRefundResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DeleteTicketFromRefundResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteTrainingActivityRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.DeleteTrainingActivityRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteTrainingActivityResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.DeleteTrainingActivityResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteTrainingSessionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteTrainingSessionsRequest';
	IsBlocking = false;
	Ids: number[];
	constructor(_params: {
		ids: number[]
	}) {
		super({});
		this.Ids = _params.ids;
	}
}

export class DeleteTrainingSessionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteTrainingSessionsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeliverTakeOutOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DeliverTakeOutOrderRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class DeliverTakeOutOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DeliverTakeOutOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DiscardPurchaseOrderPendingQuantitiesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DiscardPurchaseOrderPendingQuantitiesRequest';
	IsBlocking = true;
	PurchaseOrderId: number;
	constructor(_params: {
		purchaseOrderId: number
	}) {
		super({});
		this.PurchaseOrderId = _params.purchaseOrderId;
	}
}

export class DiscardPurchaseOrderPendingQuantitiesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DiscardPurchaseOrderPendingQuantitiesResponse';
	IsBlocking = false;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class DivideEvenlyTicketDivisionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DivideEvenlyTicketDivisionRequest';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	NumberOfParts: number;
	constructor(_params: {
		division: TicketDivisionDTO,
		numberOfParts: number
	}) {
		super({});
		this.Division = _params.division;
		this.NumberOfParts = _params.numberOfParts;
	}
}

export class DivideEvenlyTicketDivisionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.DivideEvenlyTicketDivisionResponse';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class DuplicateRequest<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateRequest<TForEdition>';
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class DuplicateResponse<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateResponse<TForEdition>';
	Data: _TForEdition;
	constructor(_params: {
		data: _TForEdition
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class EditAppointmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.EditAppointmentRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class EditAppointmentsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.EditAppointmentsResponse';
	IsBlocking = false;
	Appointment: AppointmentForEditionDTO;
	constructor(_params: {
		appointment: AppointmentForEditionDTO
	}) {
		super({});
		this.Appointment = _params.appointment;
	}
}

export class EditColorsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditColorsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class EditColorsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditColorsResponse';
	IsBlocking = false;
	Data: ColorsForEditionDTO;
	constructor(_params: {
		data: ColorsForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class EditRequest<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditRequest<TForEdition>';
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class EditResponse<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditResponse<TForEdition>';
	Data: _TForEdition;
	constructor(_params: {
		data: _TForEdition
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class EditSizesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSizesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class EditSizesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSizesResponse';
	IsBlocking = false;
	Data: SizesForEditionDTO;
	constructor(_params: {
		data: SizesForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class EditWorkplaceSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWorkplaceSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class EditWorkplaceSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWorkplaceSettingsResponse';
	IsBlocking = false;
	Data: WorkplaceForEditionDTO;
	constructor(_params: {
		data: WorkplaceForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class EmitPurchaseInvoicesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EmitPurchaseInvoicesRequest';
	IsBlocking = true;
	Date: Nullable<Date>;
	Method: PaymentMethodInListDTO;
	NoteIds: number[];
	Pay: boolean;
	ReceptionDate: Nullable<Date>;
	constructor(_params: {
		noteIds: number[],
		date: Nullable<Date>,
		pay: boolean,
		method: PaymentMethodInListDTO,
		receptionDate: Nullable<Date>
	}) {
		super({});
		this.NoteIds = _params.noteIds;
		this.Date = _params.date;
		this.Pay = _params.pay;
		this.Method = _params.method;
		this.ReceptionDate = _params.receptionDate;
	}
}

export class EmitPurchaseInvoicesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EmitPurchaseInvoicesResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class EmitSinglePurchaseInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EmitSinglePurchaseInvoiceRequest';
	IsBlocking = true;
	Date: Date;
	Method: PaymentMethodInListDTO;
	NoteIds: number[];
	Pay: boolean;
	ReceptionDate: Date;
	SupplierDocumentNumber: string;
	constructor(_params: {
		noteIds: number[],
		supplierDocumentNumber: string,
		date: Date,
		pay: boolean,
		method: PaymentMethodInListDTO,
		receptionDate: Date
	}) {
		super({});
		this.NoteIds = _params.noteIds;
		this.SupplierDocumentNumber = _params.supplierDocumentNumber;
		this.Date = _params.date;
		this.Pay = _params.pay;
		this.Method = _params.method;
		this.ReceptionDate = _params.receptionDate;
	}
}

export class EmitSinglePurchaseInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EmitSinglePurchaseInvoiceResponse';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class EndPartialTicketClosingRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.EndPartialTicketClosingRequest';
	IsBlocking = false;
	ClosingQuantities: ClosingQuantityDTO[];
	ClosingTicketId: number;
	OriginalTableCompanions: Nullable<number>;
	OriginalTicketId: number;
	constructor(_params: {
		originalTicketId: number,
		closingTicketId: number,
		closingQuantities: ClosingQuantityDTO[],
		originalTableCompanions: Nullable<number>
	}) {
		super({});
		this.OriginalTicketId = _params.originalTicketId;
		this.ClosingTicketId = _params.closingTicketId;
		this.ClosingQuantities = _params.closingQuantities;
		this.OriginalTableCompanions = _params.originalTableCompanions;
	}
}

export class EndPartialTicketClosingResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.EndPartialTicketClosingResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class EndTakeOutOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.EndTakeOutOrderRequest';
	IsBlocking = false;
	Params: SalesOrderParamsFromTakeOutDTO;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		params: SalesOrderParamsFromTakeOutDTO
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Params = _params.params;
	}
}

export class EndTakeOutOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.EndTakeOutOrderResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class ExecuteCustomQueryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.ExecuteCustomQueryRequest';
	IsBlocking = false;
	Params: { [name: string]: any };
	QueryGuid: string;
	constructor(_params: {
		queryGuid: string,
		params: { [name: string]: any }
	}) {
		super({});
		this.QueryGuid = _params.queryGuid;
		this.Params = _params.params;
	}
}

export class ExecuteCustomQueryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.ExecuteCustomQueryResponse';
	IsBlocking = false;
	Result: CustomQueryResultDTO;
	constructor(_params: {
		result: CustomQueryResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class ExportDataToExcelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Distributor.ExportDataToExcelRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ExportDataToExcelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Distributor.ExportDataToExcelResponse';
	IsBlocking = false;
	ExcelBytes: string;
	constructor(_params: {
		excelBytes: string
	}) {
		super({});
		this.ExcelBytes = _params.excelBytes;
	}
}

export class ExportDigitalMenuResourcesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ExportDigitalMenuResourcesRequest';
	IsBlocking = false;
	Items: DigitalMenuResourceItemForEditionDTO[];
	Languages: LanguageDTO[];
	ReferenceLanguageCode: string;
	constructor(_params: {
		referenceLanguageCode: string,
		languages: LanguageDTO[],
		items: DigitalMenuResourceItemForEditionDTO[]
	}) {
		super({});
		this.ReferenceLanguageCode = _params.referenceLanguageCode;
		this.Languages = _params.languages;
		this.Items = _params.items;
	}
}

export class ExportDigitalMenuResourcesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ExportDigitalMenuResourcesResponse';
	IsBlocking = false;
	Data: string;
	constructor(_params: {
		data: string
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ExportPricesToExcelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ExportPricesToExcelRequest';
	IsBlocking = false;
	CategoryIds: number[];
	FamilyIds: number[];
	constructor(_params: {
		familyIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.FamilyIds = _params.familyIds;
		this.CategoryIds = _params.categoryIds;
	}
}

export class ExportPricesToExcelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ExportPricesToExcelResponse';
	IsBlocking = false;
	Data: string;
	constructor(_params: {
		data: string
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ExportProductsForInventoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ExportProductsForInventoryRequest';
	IsBlocking = false;
	CategoryIds: number[];
	FamilyIds: number[];
	Format: ProductExportFormat;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		format: ProductExportFormat,
		familyIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.Format = _params.format;
		this.FamilyIds = _params.familyIds;
		this.CategoryIds = _params.categoryIds;
	}
}

export class ExportProductsForInventoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ExportProductsForInventoryResponse';
	IsBlocking = false;
	FileContent: string;
	constructor(_params: {
		fileContent: string
	}) {
		super({});
		this.FileContent = _params.fileContent;
	}
}

export class ExportProductsForPurchaseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ExportProductsForPurchaseRequest';
	IsBlocking = false;
	CategoryIds: number[];
	FamilyIds: number[];
	Format: ProductExportFormat;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		format: ProductExportFormat,
		familyIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.Format = _params.format;
		this.FamilyIds = _params.familyIds;
		this.CategoryIds = _params.categoryIds;
	}
}

export class ExportProductsForPurchaseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ExportProductsForPurchaseResponse';
	IsBlocking = false;
	FileContent: string;
	constructor(_params: {
		fileContent: string
	}) {
		super({});
		this.FileContent = _params.fileContent;
	}
}

export class ExportProductsForStockChangeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ExportProductsForStockChangeRequest';
	IsBlocking = true;
	CategoryIds: number[];
	FamilyIds: number[];
	Format: ProductExportFormat;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		format: ProductExportFormat,
		familyIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.Format = _params.format;
		this.FamilyIds = _params.familyIds;
		this.CategoryIds = _params.categoryIds;
	}
}

export class ExportProductsForStockChangeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ExportProductsForStockChangeResponse';
	IsBlocking = false;
	FileContent: string;
	constructor(_params: {
		fileContent: string
	}) {
		super({});
		this.FileContent = _params.fileContent;
	}
}

export class ExportRelatedProductsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ExportRelatedProductsRequest';
	IsBlocking = false;
	ProductId: number;
	constructor(_params: {
		productId: number
	}) {
		super({});
		this.ProductId = _params.productId;
	}
}

export class ExportRelatedProductsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ExportRelatedProductsResponse';
	IsBlocking = false;
	File: string;
	constructor(_params: {
		file: string
	}) {
		super({});
		this.File = _params.file;
	}
}

export class ExtractPendingTipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.ExtractPendingTipRequest';
	IsBlocking = false;
	TipToExtract: number;
	constructor(_params: {
		tipToExtract: number
	}) {
		super({});
		this.TipToExtract = _params.tipToExtract;
	}
}

export class ExtractPendingTipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.ExtractPendingTipResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class FindAlternativeStockProductsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindAlternativeStockProductsRequest';
	IsBlocking = false;
	Text: string;
	constructor(_params: {
		text: string
	}) {
		super({});
		this.Text = _params.text;
	}
}

export class FindAlternativeStockProductsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindAlternativeStockProductsResponse';
	IsBlocking = false;
	Products: AlternativeStockProductDTO[];
	constructor(_params: {
		products: AlternativeStockProductDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindExistingAddinsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindExistingAddinsRequest';
	IsBlocking = false;
	Text: string;
	constructor(_params: {
		text: string
	}) {
		super({});
		this.Text = _params.text;
	}
}

export class FindExistingAddinsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindExistingAddinsResponse';
	IsBlocking = false;
	Addins: SaleFormatInListDTO[];
	constructor(_params: {
		addins: SaleFormatInListDTO[]
	}) {
		super({});
		this.Addins = _params.addins;
	}
}

export class FindInternalOrderByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindInternalOrderByTextRequest';
	IsBlocking = true;
	Text: string;
	constructor(_params: {
		text: string
	}) {
		super({});
		this.Text = _params.text;
	}
}

export class FindInternalOrderByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindInternalOrderByTextResponse';
	IsBlocking = false;
	InternalPurchases: InternalOrderDTO[];
	constructor(_params: {
		internalPurchases: InternalOrderDTO[]
	}) {
		super({});
		this.InternalPurchases = _params.internalPurchases;
	}
}

export class FindLoyaltyMemberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.FindLoyaltyMemberRequest';
	IsBlocking = false;
	MemberId: string;
	constructor(_params: {
		memberId: string
	}) {
		super({});
		this.MemberId = _params.memberId;
	}
}

export class FindLoyaltyMemberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.FindLoyaltyMemberResponse';
	IsBlocking = false;
	LoyaltyMember: LoyaltyProgramMemberDTO;
	constructor(_params: {
		loyaltyMember: LoyaltyProgramMemberDTO
	}) {
		super({});
		this.LoyaltyMember = _params.loyaltyMember;
	}
}

export class FindMenusByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindMenusByTextRequest';
	IsBlocking = true;
	IncludePrices: boolean;
	MaxMenus: number;
	Text: string;
	constructor(_params: {
		text: string,
		includePrices: boolean,
		maxMenus: number
	}) {
		super({});
		this.Text = _params.text;
		this.IncludePrices = _params.includePrices;
		this.MaxMenus = _params.maxMenus;
	}
}

export class FindMenusByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindMenusByTextResponse';
	IsBlocking = false;
	Menus: MenuInListDTO[];
	constructor(_params: {
		menus: MenuInListDTO[]
	}) {
		super({});
		this.Menus = _params.menus;
	}
}

export class FindOnlineReservationDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.FindOnlineReservationDetailsRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class FindOnlineReservationDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.FindOnlineReservationDetailsResponse';
	IsBlocking = false;
	Reservation: OnlineReservationInListDTO;
	constructor(_params: {
		reservation: OnlineReservationInListDTO
	}) {
		super({});
		this.Reservation = _params.reservation;
	}
}

export class FindProductDetailsForProductionByBarcodeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForProductionByBarcodeRequest';
	IsBlocking = true;
	Barcode: string;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		barcode: string
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.Barcode = _params.barcode;
	}
}

export class FindProductDetailsForProductionByBarcodeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForProductionByBarcodeResponse';
	IsBlocking = false;
	Product: ProductDetailsForProductionDTO;
	constructor(_params: {
		product: ProductDetailsForProductionDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class FindProductDetailsForProductionByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForProductionByIdRequest';
	IsBlocking = true;
	ProductId: number;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		productId: number
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.ProductId = _params.productId;
	}
}

export class FindProductDetailsForProductionByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForProductionByIdResponse';
	IsBlocking = false;
	Product: ProductDetailsForProductionDTO;
	constructor(_params: {
		product: ProductDetailsForProductionDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class FindProductDetailsForPurchaseByBarcodeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForPurchaseByBarcodeRequest';
	IsBlocking = true;
	Barcode: string;
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		barcode: string,
		supplierId: number,
		warehouseId: number
	}) {
		super({});
		this.Barcode = _params.barcode;
		this.SupplierId = _params.supplierId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class FindProductDetailsForPurchaseByBarcodeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForPurchaseByBarcodeResponse';
	IsBlocking = false;
	Product: ProductDetailsForPurchaseDTO;
	constructor(_params: {
		product: ProductDetailsForPurchaseDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class FindProductDetailsForStockControlByBarcodeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForStockControlByBarcodeRequest';
	IsBlocking = false;
	Barcode: string;
	ExcludeRecipeAuto: boolean;
	WarehouseId: number;
	constructor(_params: {
		barcode: string,
		warehouseId: number,
		excludeRecipeAuto: boolean
	}) {
		super({});
		this.Barcode = _params.barcode;
		this.WarehouseId = _params.warehouseId;
		this.ExcludeRecipeAuto = _params.excludeRecipeAuto;
	}
}

export class FindProductDetailsForStockControlByBarcodeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForStockControlByBarcodeResponse';
	IsBlocking = false;
	Product: ProductDetailsForStockControlDTO;
	constructor(_params: {
		product: ProductDetailsForStockControlDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class FindProductDetailsForStockControlByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForStockControlByIdRequest';
	IsBlocking = false;
	ExcludeRecipeAuto: boolean;
	ProductId: number;
	WarehouseId: number;
	constructor(_params: {
		productId: number,
		warehouseId: number,
		excludeRecipeAuto: boolean
	}) {
		super({});
		this.ProductId = _params.productId;
		this.WarehouseId = _params.warehouseId;
		this.ExcludeRecipeAuto = _params.excludeRecipeAuto;
	}
}

export class FindProductDetailsForStockControlByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductDetailsForStockControlByIdResponse';
	IsBlocking = false;
	Product: ProductDetailsForStockControlDTO;
	constructor(_params: {
		product: ProductDetailsForStockControlDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class FindProductForPurchaseByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductForPurchaseByIdRequest';
	IsBlocking = false;
	ProductId: number;
	SupplierId: number;
	SupplierReference: string;
	WarehouseId: number;
	constructor(_params: {
		productId: number,
		warehouseId: number,
		supplierId: number,
		supplierReference: string
	}) {
		super({});
		this.ProductId = _params.productId;
		this.WarehouseId = _params.warehouseId;
		this.SupplierId = _params.supplierId;
		this.SupplierReference = _params.supplierReference;
	}
}

export class FindProductForPurchaseByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductForPurchaseByIdResponse';
	IsBlocking = false;
	Product: ProductDetailsForPurchaseDTO;
	constructor(_params: {
		product: ProductDetailsForPurchaseDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class FindProductsByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindProductsByTextRequest';
	IsBlocking = true;
	IncludePrices: boolean;
	MaxProducts: number;
	Text: string;
	constructor(_params: {
		text: string,
		includePrices: boolean,
		maxProducts: number
	}) {
		super({});
		this.Text = _params.text;
		this.IncludePrices = _params.includePrices;
		this.MaxProducts = _params.maxProducts;
	}
}

export class FindProductsByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindProductsByTextResponse';
	IsBlocking = false;
	Products: ProductInListDTO[];
	constructor(_params: {
		products: ProductInListDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsDetailsForPurchaseByIdsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsDetailsForPurchaseByIdsRequest';
	IsBlocking = false;
	ProductIds: number[];
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		productIds: number[],
		warehouseId: number,
		supplierId: number
	}) {
		super({});
		this.ProductIds = _params.productIds;
		this.WarehouseId = _params.warehouseId;
		this.SupplierId = _params.supplierId;
	}
}

export class FindProductsDetailsForPurchaseByIdsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsDetailsForPurchaseByIdsResponse';
	IsBlocking = false;
	Products: ProductDetailsForPurchaseDTO[];
	constructor(_params: {
		products: ProductDetailsForPurchaseDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsForDataSheetByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForDataSheetByTextRequest';
	IsBlocking = false;
	MaxProducts: number;
	Text: string;
	constructor(_params: {
		text: string,
		maxProducts: number
	}) {
		super({});
		this.Text = _params.text;
		this.MaxProducts = _params.maxProducts;
	}
}

export class FindProductsForDataSheetByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForDataSheetByTextResponse';
	IsBlocking = false;
	Products: ProductInListDTO[];
	constructor(_params: {
		products: ProductInListDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsForInventoryCountByBarcodeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForInventoryCountByBarcodeRequest';
	IsBlocking = false;
	Barcode: string;
	WarehouseId: number;
	constructor(_params: {
		barcode: string,
		warehouseId: number
	}) {
		super({});
		this.Barcode = _params.barcode;
		this.WarehouseId = _params.warehouseId;
	}
}

export class FindProductsForInventoryCountByBarcodeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForInventoryCountByBarcodeResponse';
	IsBlocking = false;
	Products: ProductForInventoryCountDTO[];
	constructor(_params: {
		products: ProductForInventoryCountDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsForInventoryCountByCategoryIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForInventoryCountByCategoryIdRequest';
	IsBlocking = false;
	CategoryId: number;
	WarehouseId: number;
	constructor(_params: {
		categoryId: number,
		warehouseId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class FindProductsForInventoryCountByCategoryIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForInventoryCountByCategoryIdResponse';
	IsBlocking = false;
	Products: ProductForInventoryCountDTO[];
	constructor(_params: {
		products: ProductForInventoryCountDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsForInventoryCountByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForInventoryCountByIdRequest';
	IsBlocking = false;
	ProductId: number;
	WarehouseId: number;
	constructor(_params: {
		productId: number,
		warehouseId: number
	}) {
		super({});
		this.ProductId = _params.productId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class FindProductsForInventoryCountByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForInventoryCountByIdResponse';
	IsBlocking = false;
	Products: ProductForInventoryCountDTO[];
	constructor(_params: {
		products: ProductForInventoryCountDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsForPurchaseByCategoryIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForPurchaseByCategoryIdRequest';
	IsBlocking = false;
	CategoryId: number;
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		categoryId: number,
		supplierId: number,
		warehouseId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
		this.SupplierId = _params.supplierId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class FindProductsForPurchaseByCategoryIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForPurchaseByCategoryIdResponse';
	IsBlocking = false;
	Products: ProductForPurchaseDTO[];
	constructor(_params: {
		products: ProductForPurchaseDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsForPurchaseBySupplierIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForPurchaseBySupplierIdRequest';
	IsBlocking = false;
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		supplierId: number,
		warehouseId: number
	}) {
		super({});
		this.SupplierId = _params.supplierId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class FindProductsForPurchaseBySupplierIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForPurchaseBySupplierIdResponse';
	IsBlocking = false;
	Products: ProductForPurchaseDTO[];
	constructor(_params: {
		products: ProductForPurchaseDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsForStockControlByIdsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForStockControlByIdsRequest';
	IsBlocking = true;
	ExcludeRecipeAuto: boolean;
	ProductIds: number[];
	WarehouseId: number;
	constructor(_params: {
		productIds: number[],
		warehouseId: number,
		excludeRecipeAuto: boolean
	}) {
		super({});
		this.ProductIds = _params.productIds;
		this.WarehouseId = _params.warehouseId;
		this.ExcludeRecipeAuto = _params.excludeRecipeAuto;
	}
}

export class FindProductsForStockControlByIdsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindProductsForStockControlByIdsResponse';
	IsBlocking = false;
	Products: ProductDetailsForStockControlDTO[];
	constructor(_params: {
		products: ProductDetailsForStockControlDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindProductsInGroupByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindProductsInGroupByTextRequest';
	IsBlocking = true;
	Text: string;
	constructor(_params: {
		text: string
	}) {
		super({});
		this.Text = _params.text;
	}
}

export class FindProductsInGroupByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindProductsInGroupByTextResponse';
	IsBlocking = false;
	Products: ProductInGroupDTO[];
	constructor(_params: {
		products: ProductInGroupDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class FindSaleFormatsByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindSaleFormatsByTextRequest';
	IsBlocking = true;
	IncludeMenus: boolean;
	IncludeSizeAndColor: boolean;
	Text: string;
	constructor(_params: {
		text: string,
		includeMenus: boolean,
		includeSizeAndColor: boolean
	}) {
		super({});
		this.Text = _params.text;
		this.IncludeMenus = _params.includeMenus;
		this.IncludeSizeAndColor = _params.includeSizeAndColor;
	}
}

export class FindSaleFormatsByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.FindSaleFormatsByTextResponse';
	IsBlocking = false;
	SaleFormats: SaleFormatInListDTO[];
	constructor(_params: {
		saleFormats: SaleFormatInListDTO[]
	}) {
		super({});
		this.SaleFormats = _params.saleFormats;
	}
}

export class FindSaleFormatsInGroupByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindSaleFormatsInGroupByTextRequest';
	IsBlocking = false;
	Text: string;
	constructor(_params: {
		text: string
	}) {
		super({});
		this.Text = _params.text;
	}
}

export class FindSaleFormatsInGroupByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.FindSaleFormatsInGroupByTextResponse';
	IsBlocking = false;
	SaleFormats: SaleFormatInGroupDTO[];
	constructor(_params: {
		saleFormats: SaleFormatInGroupDTO[]
	}) {
		super({});
		this.SaleFormats = _params.saleFormats;
	}
}

export class FingerprintLoginRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.FingerprintLoginRequest';
	IsBlocking = false;
	DefaultLanguageCode: string;
	UserId: number;
	constructor(_params: {
		userId: number,
		defaultLanguageCode: string
	}) {
		super({});
		this.UserId = _params.userId;
		this.DefaultLanguageCode = _params.defaultLanguageCode;
	}
}

export class FingerprintLoginResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.FingerprintLoginResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Session: SessionDTO;
	Success: boolean;
	constructor(_params: {
		session: SessionDTO,
		success: boolean,
		errorMessage: string
	}) {
		super({});
		this.Session = _params.session;
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class FinishCookingRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.FinishCookingRequest';
	IsBlocking = false;
	CancelledLines: TicketPreparationLineDTO[];
	DisplayId: number;
	Lines: TicketPreparationLineDTO[];
	constructor(_params: {
		lines: TicketPreparationLineDTO[],
		cancelledLines: TicketPreparationLineDTO[],
		displayId: number
	}) {
		super({});
		this.Lines = _params.lines;
		this.CancelledLines = _params.cancelledLines;
		this.DisplayId = _params.displayId;
	}
}

export class FinishCookingResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.FinishCookingResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class FinishPendingCardTransactionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.FinishPendingCardTransactionRequest';
	IsBlocking = false;
	Amount: number;
	TicketGlobalId: Nullable<string>;
	TransactionId: string;
	TransactionType: string;
	XmlDetails: string;
	constructor(_params: {
		ticketGlobalId: Nullable<string>,
		transactionId: string,
		amount: number,
		transactionType: string,
		xmlDetails: string
	}) {
		super({});
		this.TicketGlobalId = _params.ticketGlobalId;
		this.TransactionId = _params.transactionId;
		this.Amount = _params.amount;
		this.TransactionType = _params.transactionType;
		this.XmlDetails = _params.xmlDetails;
	}
}

export class FinishPendingCardTransactionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.FinishPendingCardTransactionResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ForceCloseDayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.ForceCloseDayRequest';
	IsBlocking = false;
	PosIds: number[];
	constructor(_params: {
		posIds: number[]
	}) {
		super({});
		this.PosIds = _params.posIds;
	}
}

export class ForceCloseDayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.ForceCloseDayResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ForceGStockUploadRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.ForceGStockUploadRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ForceGStockUploadResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.ForceGStockUploadResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ForceMyAgoraUpdateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ForceMyAgoraUpdateRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ForceMyAgoraUpdateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ForceMyAgoraUpdateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GenerateAutomaticLotRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GenerateAutomaticLotRequest';
	IsBlocking = false;
	ProductId: number;
	constructor(_params: {
		productId: number
	}) {
		super({});
		this.ProductId = _params.productId;
	}
}

export class GenerateAutomaticLotResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GenerateAutomaticLotResponse';
	IsBlocking = false;
	Lot: LotInListDTO;
	constructor(_params: {
		lot: LotInListDTO
	}) {
		super({});
		this.Lot = _params.lot;
	}
}

export class GenerateControlRollRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GenerateControlRollRequest';
	IsBlocking = false;
	IncludeTotals: boolean;
	InvoiceIds: number[];
	constructor(_params: {
		invoiceIds: number[],
		includeTotals: boolean
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
		this.IncludeTotals = _params.includeTotals;
	}
}

export class GenerateControlRollResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GenerateControlRollResponse';
	IsBlocking = false;
	Data: string;
	constructor(_params: {
		data: string
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class GenerateDeliveryNotePdfsZipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateDeliveryNotePdfsZipRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	TemplateId: number;
	constructor(_params: {
		deliveryNoteIds: number[],
		templateId: number
	}) {
		super({});
		this.DeliveryNoteIds = _params.deliveryNoteIds;
		this.TemplateId = _params.templateId;
	}
}

export class GenerateDeliveryNotePdfsZipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateDeliveryNotePdfsZipResponse';
	IsBlocking = false;
	File: string;
	constructor(_params: {
		file: string
	}) {
		super({});
		this.File = _params.file;
	}
}

export class GenerateInvoicePdfsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateInvoicePdfsRequest';
	IsBlocking = false;
	InvoiceIds: number[];
	TemplateId: number;
	constructor(_params: {
		invoiceIds: number[],
		templateId: number
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
		this.TemplateId = _params.templateId;
	}
}

export class GenerateInvoicePdfsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateInvoicePdfsResponse';
	IsBlocking = false;
	Files: FileContentDTO[];
	constructor(_params: {
		files: FileContentDTO[]
	}) {
		super({});
		this.Files = _params.files;
	}
}

export class GenerateInvoicePdfsZipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateInvoicePdfsZipRequest';
	IsBlocking = false;
	InvoiceIds: number[];
	TemplateId: number;
	constructor(_params: {
		invoiceIds: number[],
		templateId: number
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
		this.TemplateId = _params.templateId;
	}
}

export class GenerateInvoicePdfsZipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateInvoicePdfsZipResponse';
	IsBlocking = false;
	File: string;
	constructor(_params: {
		file: string
	}) {
		super({});
		this.File = _params.file;
	}
}

export class GenerateSalesOrderPdfsZipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateSalesOrderPdfsZipRequest';
	IsBlocking = false;
	SalesOrderIds: number[];
	TemplateId: number;
	constructor(_params: {
		salesOrderIds: number[],
		templateId: number
	}) {
		super({});
		this.SalesOrderIds = _params.salesOrderIds;
		this.TemplateId = _params.templateId;
	}
}

export class GenerateSalesOrderPdfsZipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateSalesOrderPdfsZipResponse';
	IsBlocking = false;
	File: string;
	constructor(_params: {
		file: string
	}) {
		super({});
		this.File = _params.file;
	}
}

export class GenerateScanAndPayQRZipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateScanAndPayQRZipRequest';
	IsBlocking = false;
	DigitalMenuId: number;
	DigitalMenuMode: DigitalMenuMode;
	PriceListId: Nullable<number>;
	SaleCenterId: number;
	WorkplaceId: number;
	constructor(_params: {
		digitalMenuId: number,
		saleCenterId: number,
		workplaceId: number,
		priceListId: Nullable<number>,
		digitalMenuMode: DigitalMenuMode
	}) {
		super({});
		this.DigitalMenuId = _params.digitalMenuId;
		this.SaleCenterId = _params.saleCenterId;
		this.WorkplaceId = _params.workplaceId;
		this.PriceListId = _params.priceListId;
		this.DigitalMenuMode = _params.digitalMenuMode;
	}
}

export class GenerateScanAndPayQRZipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateScanAndPayQRZipResponse';
	IsBlocking = false;
	File: string;
	constructor(_params: {
		file: string
	}) {
		super({});
		this.File = _params.file;
	}
}

export class GenerateSmartMenuDocumentPdfRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.SmartMenu.Messages.GenerateSmartMenuDocumentPdfRequest';
	IsBlocking = false;
	TicketGlobalId: string;
	constructor(_params: {
		ticketGlobalId: string
	}) {
		super({});
		this.TicketGlobalId = _params.ticketGlobalId;
	}
}

export class GenerateSmartMenuDocumentPdfResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.SmartMenu.Messages.GenerateSmartMenuDocumentPdfResponse';
	IsBlocking = false;
	Content: string;
	constructor(_params: {
		content: string
	}) {
		super({});
		this.Content = _params.content;
	}
}

export class GenerateWorkingPeriodsExcelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateWorkingPeriodsExcelRequest';
	IsBlocking = false;
	ExcludeEmptyPeriods: boolean;
	From: Date;
	To: Date;
	UserIds: number[];
	WorkplaceIds: number[];
	constructor(_params: {
		userIds: number[],
		workplaceIds: number[],
		from: Date,
		to: Date,
		excludeEmptyPeriods: boolean
	}) {
		super({});
		this.UserIds = _params.userIds;
		this.WorkplaceIds = _params.workplaceIds;
		this.From = _params.from;
		this.To = _params.to;
		this.ExcludeEmptyPeriods = _params.excludeEmptyPeriods;
	}
}

export class GenerateWorkingPeriodsExcelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GenerateWorkingPeriodsExcelResponse';
	IsBlocking = false;
	FileContent: string;
	FileName: string;
	constructor(_params: {
		fileName: string,
		fileContent: string
	}) {
		super({});
		this.FileName = _params.fileName;
		this.FileContent = _params.fileContent;
	}
}

export class GenerateWorkplaceDataRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GenerateWorkplaceDataRequest';
	IsBlocking = true;
	WorkplaceIds: number[];
	constructor(_params: {
		workplaceIds: number[]
	}) {
		super({});
		this.WorkplaceIds = _params.workplaceIds;
	}
}

export class GenerateWorkplaceDataResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GenerateWorkplaceDataResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAddinRolesBySaleFormatRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetAddinRolesBySaleFormatRequest';
	IsBlocking = false;
	SaleFormatId: number;
	constructor(_params: {
		saleFormatId: number
	}) {
		super({});
		this.SaleFormatId = _params.saleFormatId;
	}
}

export class GetAddinRolesBySaleFormatResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetAddinRolesBySaleFormatResponse';
	IsBlocking = false;
	Roles: AddinRoleDTO[];
	constructor(_params: {
		roles: AddinRoleDTO[]
	}) {
		super({});
		this.Roles = _params.roles;
	}
}

export class GetAgoraPaymentsReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPaymentsReportRequest';
	IsBlocking = true;
	AmexIsExternal: boolean;
	CutoffTime: Date;
	From: Date;
	PosGroups: PosGroupByUserDTO[];
	To: Date;
	constructor(_params: {
		posGroups: PosGroupByUserDTO[],
		from: Date,
		to: Date,
		cutoffTime: Date,
		amexIsExternal: boolean
	}) {
		super({});
		this.PosGroups = _params.posGroups;
		this.From = _params.from;
		this.To = _params.to;
		this.CutoffTime = _params.cutoffTime;
		this.AmexIsExternal = _params.amexIsExternal;
	}
}

export class GetAgoraPaymentsReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPaymentsReportResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Sales: AgoraPaymentsSalesByDayDTO[];
	Success: boolean;
	constructor(_params: {
		success: boolean,
		errorMessage: string,
		sales: AgoraPaymentsSalesByDayDTO[]
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
		this.Sales = _params.sales;
	}
}

export class GetAgoraPaymentsTransactionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPaymentsTransactionRequest';
	IsBlocking = true;
	PosGroups: PosGroupByUserDTO[];
	PSP: string;
	constructor(_params: {
		posGroups: PosGroupByUserDTO[],
		pSP: string
	}) {
		super({});
		this.PosGroups = _params.posGroups;
		this.PSP = _params.pSP;
	}
}

export class GetAgoraPaymentsTransactionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPaymentsTransactionResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Success: boolean;
	Transaction: AgoraPaymentsTransactionDetailsDTO;
	constructor(_params: {
		success: boolean,
		errorMessage: string,
		transaction: AgoraPaymentsTransactionDetailsDTO
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
		this.Transaction = _params.transaction;
	}
}

export class GetAgoraPaymentsTransactionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPaymentsTransactionsRequest';
	IsBlocking = true;
	AmexIsExternal: boolean;
	CutoffTime: Date;
	Date: Date;
	PosGroups: PosGroupByUserDTO[];
	constructor(_params: {
		posGroups: PosGroupByUserDTO[],
		date: Date,
		cutoffTime: Date,
		amexIsExternal: boolean
	}) {
		super({});
		this.PosGroups = _params.posGroups;
		this.Date = _params.date;
		this.CutoffTime = _params.cutoffTime;
		this.AmexIsExternal = _params.amexIsExternal;
	}
}

export class GetAgoraPaymentsTransactionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPaymentsTransactionsResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Success: boolean;
	Transactions: AgoraPaymentsTransactionSummaryDTO[];
	constructor(_params: {
		success: boolean,
		errorMessage: string,
		transactions: AgoraPaymentsTransactionSummaryDTO[]
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
		this.Transactions = _params.transactions;
	}
}

export class GetAgoraPayoutsReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPayoutsReportRequest';
	IsBlocking = true;
	AmexIsExternal: boolean;
	CutoffTime: Date;
	From: Date;
	PosGroups: PosGroupByUserDTO[];
	To: Date;
	constructor(_params: {
		posGroups: PosGroupByUserDTO[],
		from: Date,
		to: Date,
		cutoffTime: Date,
		amexIsExternal: boolean
	}) {
		super({});
		this.PosGroups = _params.posGroups;
		this.From = _params.from;
		this.To = _params.to;
		this.CutoffTime = _params.cutoffTime;
		this.AmexIsExternal = _params.amexIsExternal;
	}
}

export class GetAgoraPayoutsReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAgoraPayoutsReportResponse';
	IsBlocking = false;
	Report: AgoraPayoutsReportDTO;
	constructor(_params: {
		report: AgoraPayoutsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetAllActionButtonsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllActionButtonsRequest';
	IsBlocking = false;
	PosType: PosType;
	constructor(_params: {
		posType: PosType
	}) {
		super({});
		this.PosType = _params.posType;
	}
}

export class GetAllActionButtonsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllActionButtonsResponse';
	IsBlocking = false;
	ButtonsForMainView: ActionButtonDefinitionDTO[];
	ButtonsForSelectLocationView: ActionButtonDefinitionDTO[];
	constructor(_params: {
		buttonsForMainView: ActionButtonDefinitionDTO[],
		buttonsForSelectLocationView: ActionButtonDefinitionDTO[]
	}) {
		super({});
		this.ButtonsForMainView = _params.buttonsForMainView;
		this.ButtonsForSelectLocationView = _params.buttonsForSelectLocationView;
	}
}

export class GetAllAdminBookmarksRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.WebAdmin.Messages.GetAllAdminBookmarksRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllAdminBookmarksResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.WebAdmin.Messages.GetAllAdminBookmarksResponse';
	IsBlocking = false;
	Bookmarks: string[];
	constructor(_params: {
		bookmarks: string[]
	}) {
		super({});
		this.Bookmarks = _params.bookmarks;
	}
}

export class GetAllByUserResponse<_TInList> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllByUserResponse<TInList>';
	All: _TInList[];
	constructor(_params: {
		all: _TInList[]
	}) {
		super({});
		this.All = _params.all;
	}
}

export class GetAllCategoryTagsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCategoryTagsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCategoryTagsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCategoryTagsResponse';
	IsBlocking = false;
	Tags: string[];
	constructor(_params: {
		tags: string[]
	}) {
		super({});
		this.Tags = _params.tags;
	}
}

export class GetAllCustomersForEmailingRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetAllCustomersForEmailingRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCustomersForEmailingResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetAllCustomersForEmailingResponse';
	IsBlocking = false;
	Customers: CustomerForEmailingDTO[];
	constructor(_params: {
		customers: CustomerForEmailingDTO[]
	}) {
		super({});
		this.Customers = _params.customers;
	}
}

export class GetAllInternalOrdersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllInternalOrdersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllInternalOrdersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllInternalOrdersResponse';
	IsBlocking = false;
	All: InternalOrderDTO[];
	constructor(_params: {
		all: InternalOrderDTO[]
	}) {
		super({});
		this.All = _params.all;
	}
}

export class GetAllLinesInInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetAllLinesInInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetAllLinesInInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetAllLinesInInvoiceResponse';
	IsBlocking = false;
	Lines: TicketLineDTO[];
	constructor(_params: {
		lines: TicketLineDTO[]
	}) {
		super({});
		this.Lines = _params.lines;
	}
}

export class GetAllMasterPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMasterPosRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllMasterPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMasterPosResponse';
	IsBlocking = false;
	AllMasterPos: PosInListDTO[];
	constructor(_params: {
		allMasterPos: PosInListDTO[]
	}) {
		super({});
		this.AllMasterPos = _params.allMasterPos;
	}
}

export class GetAllPriceListsByTicketIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetAllPriceListsByTicketIdRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetAllPriceListsByTicketIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetAllPriceListsByTicketIdResponse';
	IsBlocking = false;
	PriceLists: PriceListDTO[];
	constructor(_params: {
		priceLists: PriceListDTO[]
	}) {
		super({});
		this.PriceLists = _params.priceLists;
	}
}

export class GetAllRequest<_TInList> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllRequest<TInList>';
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllResponse<_TInList> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllResponse<TInList>';
	All: _TInList[];
	constructor(_params: {
		all: _TInList[]
	}) {
		super({});
		this.All = _params.all;
	}
}

export class GetAllUsersForWorkingPeriodExcelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllUsersForWorkingPeriodExcelRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllUsersForWorkingPeriodExcelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllUsersForWorkingPeriodExcelResponse';
	IsBlocking = false;
	AvailableUsers: UserInListDTO[];
	constructor(_params: {
		availableUsers: UserInListDTO[]
	}) {
		super({});
		this.AvailableUsers = _params.availableUsers;
	}
}

export class GetAllVerifactuChainRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetAllVerifactuChainRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllVerifactuChainResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetAllVerifactuChainResponse';
	IsBlocking = false;
	All: VerifactuChainDTO[];
	Environment: VerifactuEnvironment;
	constructor(_params: {
		all: VerifactuChainDTO[],
		environment: VerifactuEnvironment
	}) {
		super({});
		this.All = _params.all;
		this.Environment = _params.environment;
	}
}

export class GetAllVisibleCategoriesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllVisibleCategoriesRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllVisibleCategoriesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllVisibleCategoriesResponse';
	IsBlocking = false;
	Categories: CategoryInListDTO[];
	constructor(_params: {
		categories: CategoryInListDTO[]
	}) {
		super({});
		this.Categories = _params.categories;
	}
}

export class GetAllVisibleFamiliesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllVisibleFamiliesRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllVisibleFamiliesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllVisibleFamiliesResponse';
	IsBlocking = false;
	Families: FamilyInListDTO[];
	constructor(_params: {
		families: FamilyInListDTO[]
	}) {
		super({});
		this.Families = _params.families;
	}
}

export class GetAllWorkingPeriodsBetweenRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWorkingPeriodsBetweenRequest';
	IsBlocking = true;
	From: Date;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
	}
}

export class GetAllWorkingPeriodsBetweenResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWorkingPeriodsBetweenResponse';
	IsBlocking = false;
	All: WorkingPeriodInListDTO[];
	constructor(_params: {
		all: WorkingPeriodInListDTO[]
	}) {
		super({});
		this.All = _params.all;
	}
}

export class GetAllWorkingPeriodsByUserBetweenRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWorkingPeriodsByUserBetweenRequest';
	IsBlocking = true;
	From: Date;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
	}
}

export class GetAllWorkingPeriodsByUserBetweenResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWorkingPeriodsByUserBetweenResponse';
	IsBlocking = false;
	All: WorkingPeriodInListDTO[];
	constructor(_params: {
		all: WorkingPeriodInListDTO[]
	}) {
		super({});
		this.All = _params.all;
	}
}

export class GetAmountToPayFromDeliveryNotesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetAmountToPayFromDeliveryNotesRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	constructor(_params: {
		deliveryNoteIds: number[]
	}) {
		super({});
		this.DeliveryNoteIds = _params.deliveryNoteIds;
	}
}

export class GetAmountToPayFromDeliveryNotesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetAmountToPayFromDeliveryNotesResponse';
	IsBlocking = false;
	Amount: number;
	constructor(_params: {
		amount: number
	}) {
		super({});
		this.Amount = _params.amount;
	}
}

export class GetAppoinmentsByDayReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAppoinmentsByDayReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	ShowOnlyPendings: boolean;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		showOnlyPendings: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.ShowOnlyPendings = _params.showOnlyPendings;
	}
}

export class GetAppointmentByDayReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAppointmentByDayReportResponse';
	IsBlocking = false;
	Report: AppointmentsByDayReportDTO;
	constructor(_params: {
		report: AppointmentsByDayReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetAuditEventsForPreparationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetAuditEventsForPreparationRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetAuditEventsForPreparationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetAuditEventsForPreparationResponse';
	IsBlocking = false;
	Events: AuditEventDTO[];
	constructor(_params: {
		events: AuditEventDTO[]
	}) {
		super({});
		this.Events = _params.events;
	}
}

export class GetAuditFileReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAuditFileReportRequest';
	IsBlocking = true;
	FileType: ReportFileType;
	IncludeEvents: boolean;
	Options: AuditMonitorOptionsDTO;
	QueryName: string;
	constructor(_params: {
		options: AuditMonitorOptionsDTO,
		includeEvents: boolean,
		fileType: ReportFileType,
		queryName: string
	}) {
		super({});
		this.Options = _params.options;
		this.IncludeEvents = _params.includeEvents;
		this.FileType = _params.fileType;
		this.QueryName = _params.queryName;
	}
}

export class GetAuditFileReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetAuditFileReportResponse';
	IsBlocking = false;
	Report: string;
	constructor(_params: {
		report: string
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetAuditMonitorEventsForDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsForDeliveryNoteRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class GetAuditMonitorEventsForDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsForDeliveryNoteResponse';
	IsBlocking = false;
	Events: AuditEventDTO[];
	constructor(_params: {
		events: AuditEventDTO[]
	}) {
		super({});
		this.Events = _params.events;
	}
}

export class GetAuditMonitorEventsForInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsForInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetAuditMonitorEventsForInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsForInvoiceResponse';
	IsBlocking = false;
	Events: AuditEventDTO[];
	constructor(_params: {
		events: AuditEventDTO[]
	}) {
		super({});
		this.Events = _params.events;
	}
}

export class GetAuditMonitorEventsForSalesOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsForSalesOrderRequest';
	IsBlocking = false;
	OrderId: number;
	constructor(_params: {
		orderId: number
	}) {
		super({});
		this.OrderId = _params.orderId;
	}
}

export class GetAuditMonitorEventsForSalesOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsForSalesOrderResponse';
	IsBlocking = false;
	Events: AuditEventDTO[];
	constructor(_params: {
		events: AuditEventDTO[]
	}) {
		super({});
		this.Events = _params.events;
	}
}

export class GetAuditMonitorEventsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsRequest';
	IsBlocking = false;
	Options: AuditMonitorOptionsDTO;
	constructor(_params: {
		options: AuditMonitorOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class GetAuditMonitorEventsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorEventsResponse';
	IsBlocking = false;
	Events: AuditEventDTO[];
	constructor(_params: {
		events: AuditEventDTO[]
	}) {
		super({});
		this.Events = _params.events;
	}
}

export class GetAuditMonitorOptionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorOptionsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAuditMonitorOptionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAuditMonitorOptionsResponse';
	IsBlocking = false;
	AllEvents: AuditEventTypeDTO[];
	PointOfSales: PosInListDTO[];
	Queries: AuditQueryDTO[];
	Users: UserInListDTO[];
	constructor(_params: {
		queries: AuditQueryDTO[],
		users: UserInListDTO[],
		pointOfSales: PosInListDTO[],
		allEvents: AuditEventTypeDTO[]
	}) {
		super({});
		this.Queries = _params.queries;
		this.Users = _params.users;
		this.PointOfSales = _params.pointOfSales;
		this.AllEvents = _params.allEvents;
	}
}

export class GetAutoInvoiceEmailOptionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetAutoInvoiceEmailOptionsRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetAutoInvoiceEmailOptionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetAutoInvoiceEmailOptionsResponse';
	IsBlocking = false;
	Options: AutoInvoiceEmailOptionsDTO;
	constructor(_params: {
		options: AutoInvoiceEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class GetAvailableBackupsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.GetAvailableBackupsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAvailableBackupsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.GetAvailableBackupsResponse';
	IsBlocking = false;
	BackupOperationInProgress: boolean;
	Backups: BackupInfoDTO[];
	constructor(_params: {
		backups: BackupInfoDTO[],
		backupOperationInProgress: boolean
	}) {
		super({});
		this.Backups = _params.backups;
		this.BackupOperationInProgress = _params.backupOperationInProgress;
	}
}

export class GetAvailableLanguagesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetAvailableLanguagesRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAvailableLanguagesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetAvailableLanguagesResponse';
	IsBlocking = false;
	Languages: LanguageDTO[];
	constructor(_params: {
		languages: LanguageDTO[]
	}) {
		super({});
		this.Languages = _params.languages;
	}
}

export class GetAvailableOnlineReservationsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.GetAvailableOnlineReservationsRequest';
	IsBlocking = false;
	Date: Date;
	IdTable: string;
	constructor(_params: {
		date: Date,
		idTable: string
	}) {
		super({});
		this.Date = _params.date;
		this.IdTable = _params.idTable;
	}
}

export class GetAvailableOnlineReservationsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.GetAvailableOnlineReservationsResponse';
	IsBlocking = false;
	Reservations: OnlineReservationInListDTO[];
	constructor(_params: {
		reservations: OnlineReservationInListDTO[]
	}) {
		super({});
		this.Reservations = _params.reservations;
	}
}

export class GetAvailableUsersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAvailableUsersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAvailableUsersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetAvailableUsersResponse';
	IsBlocking = false;
	Users: AvailableUserDTO[];
	constructor(_params: {
		users: AvailableUserDTO[]
	}) {
		super({});
		this.Users = _params.users;
	}
}

export class GetBackupSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.GetBackupSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetBackupSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.GetBackupSettingsResponse';
	IsBlocking = false;
	Settings: BackupSettingsDTO;
	constructor(_params: {
		settings: BackupSettingsDTO
	}) {
		super({});
		this.Settings = _params.settings;
	}
}

export class GetBuyerCustomerByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetBuyerCustomerByIdRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class GetBuyerCustomerByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetBuyerCustomerByIdResponse';
	IsBlocking = false;
	Customer: BuyerCustomerDTO;
	constructor(_params: {
		customer: BuyerCustomerDTO
	}) {
		super({});
		this.Customer = _params.customer;
	}
}

export class GetCancellationsByUserAndProductReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCancellationsByUserAndProductReportRequest';
	IsBlocking = true;
	CategoryIds: number[];
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.CategoryIds = _params.categoryIds;
	}
}

export class GetCancellationsByUserAndProductReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCancellationsByUserAndProductReportResponse';
	IsBlocking = false;
	Report: CancellationsByUserAndProductReportDTO;
	constructor(_params: {
		report: CancellationsByUserAndProductReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetCancellationsByUserAndTypeReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCancellationsByUserAndTypeReportRequest';
	IsBlocking = true;
	CategoryIds: number[];
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.CategoryIds = _params.categoryIds;
	}
}

export class GetCancellationsByUserAndTypeReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCancellationsByUserAndTypeReportResponse';
	IsBlocking = false;
	Report: CancellationsByUserAndTypeReportDTO;
	constructor(_params: {
		report: CancellationsByUserAndTypeReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetCandidateParentCustomersByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCandidateParentCustomersByTextRequest';
	IsBlocking = false;
	Text: string;
	constructor(_params: {
		text: string
	}) {
		super({});
		this.Text = _params.text;
	}
}

export class GetCandidateParentCustomersByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCandidateParentCustomersByTextResponse';
	IsBlocking = false;
	Customers: CustomerInListDTO[];
	constructor(_params: {
		customers: CustomerInListDTO[]
	}) {
		super({});
		this.Customers = _params.customers;
	}
}

export class GetCashTransactionsReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCashTransactionsReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetCashTransactionsReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCashTransactionsReportResponse';
	IsBlocking = false;
	Report: CashTransactionsReportDTO;
	constructor(_params: {
		report: CashTransactionsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetCategoriesByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCategoriesByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetCategoriesByWarehouseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCategoriesByWarehouseRequest';
	IsBlocking = false;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetCategoryProductsDisplayOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCategoryProductsDisplayOrderRequest';
	IsBlocking = false;
	CategoryId: number;
	constructor(_params: {
		categoryId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
	}
}

export class GetCategoryProductsDisplayOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCategoryProductsDisplayOrderResponse';
	IsBlocking = false;
	Products: SortableProductDTO[];
	constructor(_params: {
		products: SortableProductDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetCertificateDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetCertificateDetailsRequest';
	IsBlocking = false;
	CertFile: FileContentDTO;
	CertPassword: string;
	constructor(_params: {
		certFile: FileContentDTO,
		certPassword: string
	}) {
		super({});
		this.CertFile = _params.certFile;
		this.CertPassword = _params.certPassword;
	}
}

export class GetCertificateDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetCertificateDetailsResponse';
	IsBlocking = false;
	CertDetails: string;
	IsValid: boolean;
	constructor(_params: {
		isValid: boolean,
		certDetails: string
	}) {
		super({});
		this.IsValid = _params.isValid;
		this.CertDetails = _params.certDetails;
	}
}

export class GetClientCommsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetClientCommsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetClientCommsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetClientCommsResponse';
	IsBlocking = false;
	Comms: HubClientCommsDTO;
	constructor(_params: {
		comms: HubClientCommsDTO
	}) {
		super({});
		this.Comms = _params.comms;
	}
}

export class GetClockingUserByCardNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.GetClockingUserByCardNumberRequest';
	IsBlocking = false;
	CardNumber: string;
	constructor(_params: {
		cardNumber: string
	}) {
		super({});
		this.CardNumber = _params.cardNumber;
	}
}

export class GetClockingUserByCardNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.GetClockingUserByCardNumberResponse';
	IsBlocking = false;
	User: ClockingUserDTO;
	constructor(_params: {
		user: ClockingUserDTO
	}) {
		super({});
		this.User = _params.user;
	}
}

export class GetClockingUsersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.GetClockingUsersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetClockingUsersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.GetClockingUsersResponse';
	IsBlocking = false;
	Users: ClockingUserDTO[];
	constructor(_params: {
		users: ClockingUserDTO[]
	}) {
		super({});
		this.Users = _params.users;
	}
}

export class GetCostPricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetCostPricesRequest';
	IsBlocking = false;
	Product: ProductForEditionDTO;
	constructor(_params: {
		product: ProductForEditionDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class GetCostPricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetCostPricesResponse';
	IsBlocking = false;
	AvgCostPrice: number;
	CostPrices: CostPriceByWarehouseDTO[];
	WeightedAvgCostPrice: number;
	constructor(_params: {
		avgCostPrice: number,
		weightedAvgCostPrice: number,
		costPrices: CostPriceByWarehouseDTO[]
	}) {
		super({});
		this.AvgCostPrice = _params.avgCostPrice;
		this.WeightedAvgCostPrice = _params.weightedAvgCostPrice;
		this.CostPrices = _params.costPrices;
	}
}

export class GetCouponSamplePrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetCouponSamplePrintPreviewRequest';
	IsBlocking = false;
	Template: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		template: CouponPrintTemplateForEditionDTO
	}) {
		super({});
		this.Template = _params.template;
	}
}

export class GetCouponSamplePrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetCouponSamplePrintPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetCouponSampleWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetCouponSampleWebPrintResultRequest';
	IsBlocking = false;
	Template: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		template: CouponPrintTemplateForEditionDTO
	}) {
		super({});
		this.Template = _params.template;
	}
}

export class GetCouponSampleWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetCouponSampleWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetCoursesToPrepareRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetCoursesToPrepareRequest';
	IsBlocking = false;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[]
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
	}
}

export class GetCoursesToPrepareResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetCoursesToPrepareResponse';
	IsBlocking = false;
	Courses: CourseDTO[];
	constructor(_params: {
		courses: CourseDTO[]
	}) {
		super({});
		this.Courses = _params.courses;
	}
}

export class GetCurrentAmountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetCurrentAmountRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetCurrentAmountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetCurrentAmountResponse';
	IsBlocking = false;
	Amount: number;
	constructor(_params: {
		amount: number
	}) {
		super({});
		this.Amount = _params.amount;
	}
}

export class GetCurrentBalancesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetCurrentBalancesRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetCurrentBalancesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetCurrentBalancesResponse';
	IsBlocking = false;
	Balances: PaymentMethodBalanceDTO[];
	constructor(_params: {
		balances: PaymentMethodBalanceDTO[]
	}) {
		super({});
		this.Balances = _params.balances;
	}
}

export class GetCurrentBusinessDayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.GetCurrentBusinessDayRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetCurrentBusinessDayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.GetCurrentBusinessDayResponse';
	IsBlocking = false;
	BusinessDay: Nullable<Date>;
	constructor(_params: {
		businessDay: Nullable<Date>
	}) {
		super({});
		this.BusinessDay = _params.businessDay;
	}
}

export class GetCurrentStockByProductRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetCurrentStockByProductRequest';
	IsBlocking = false;
	ProductId: number;
	WarehouseId: Nullable<number>;
	constructor(_params: {
		productId: number,
		warehouseId: Nullable<number>
	}) {
		super({});
		this.ProductId = _params.productId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetCurrentStockByProductResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetCurrentStockByProductResponse';
	IsBlocking = false;
	CurrentStock: CurrentStockDTO[];
	constructor(_params: {
		currentStock: CurrentStockDTO[]
	}) {
		super({});
		this.CurrentStock = _params.currentStock;
	}
}

export class GetCustomActionButtonCommandRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCustomActionButtonCommandRequest';
	IsBlocking = false;
	ActionId: string;
	constructor(_params: {
		actionId: string
	}) {
		super({});
		this.ActionId = _params.actionId;
	}
}

export class GetCustomActionButtonCommandResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCustomActionButtonCommandResponse';
	IsBlocking = false;
	Command: CustomActionButtonCommandDTO;
	constructor(_params: {
		command: CustomActionButtonCommandDTO
	}) {
		super({});
		this.Command = _params.command;
	}
}

export class GetCustomActionButtonsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCustomActionButtonsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetCustomActionButtonsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCustomActionButtonsResponse';
	IsBlocking = false;
	Buttons: ActionButtonDefinitionDTO[];
	constructor(_params: {
		buttons: ActionButtonDefinitionDTO[]
	}) {
		super({});
		this.Buttons = _params.buttons;
	}
}

export class GetCustomerByPhoneRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerByPhoneRequest';
	IsBlocking = false;
	Phone: string;
	constructor(_params: {
		phone: string
	}) {
		super({});
		this.Phone = _params.phone;
	}
}

export class GetCustomerByPhoneResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerByPhoneResponse';
	IsBlocking = false;
	Customer: CustomerForEditionDTO;
	constructor(_params: {
		customer: CustomerForEditionDTO
	}) {
		super({});
		this.Customer = _params.customer;
	}
}

export class GetCustomerDetailsByCardNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerDetailsByCardNumberRequest';
	IsBlocking = false;
	CardNumber: string;
	constructor(_params: {
		cardNumber: string
	}) {
		super({});
		this.CardNumber = _params.cardNumber;
	}
}

export class GetCustomerDetailsByCardNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerDetailsByCardNumberResponse';
	IsBlocking = false;
	Customer: CustomerDetailsDTO;
	constructor(_params: {
		customer: CustomerDetailsDTO
	}) {
		super({});
		this.Customer = _params.customer;
	}
}

export class GetCustomerDetailsByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerDetailsByIdRequest';
	IsBlocking = false;
	CustomerId: number;
	constructor(_params: {
		customerId: number
	}) {
		super({});
		this.CustomerId = _params.customerId;
	}
}

export class GetCustomerDetailsByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerDetailsByIdResponse';
	IsBlocking = false;
	Customer: CustomerDetailsDTO;
	constructor(_params: {
		customer: CustomerDetailsDTO
	}) {
		super({});
		this.Customer = _params.customer;
	}
}

export class GetCustomerDisplayImageRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerDisplayImageRequest';
	IsBlocking = false;
	ImageId: string;
	constructor(_params: {
		imageId: string
	}) {
		super({});
		this.ImageId = _params.imageId;
	}
}

export class GetCustomerDisplayImageResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomerDisplayImageResponse';
	IsBlocking = false;
	Image: ImageDTO;
	constructor(_params: {
		image: ImageDTO
	}) {
		super({});
		this.Image = _params.image;
	}
}

export class GetCustomerPreparationsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetCustomerPreparationsRequest';
	IsBlocking = false;
	IncludeServedOrders: boolean;
	constructor(_params: {
		includeServedOrders: boolean
	}) {
		super({});
		this.IncludeServedOrders = _params.includeServedOrders;
	}
}

export class GetCustomerPreparationsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetCustomerPreparationsResponse';
	IsBlocking = false;
	InProgress: CustomerPreparationDTO[];
	Ready: CustomerPreparationDTO[];
	constructor(_params: {
		inProgress: CustomerPreparationDTO[],
		ready: CustomerPreparationDTO[]
	}) {
		super({});
		this.InProgress = _params.inProgress;
		this.Ready = _params.ready;
	}
}

export class GetCustomerPurchasesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomerPurchasesReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetCustomerPurchasesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomerPurchasesReportResponse';
	IsBlocking = false;
	Report: CustomerPurchasesReportDTO;
	constructor(_params: {
		report: CustomerPurchasesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetCustomerSalesByProductReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomerSalesByProductReportRequest';
	IsBlocking = true;
	CustomerFilterText: string;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		customerFilterText: string
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.CustomerFilterText = _params.customerFilterText;
	}
}

export class GetCustomerSalesByProductReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomerSalesByProductReportResponse';
	IsBlocking = false;
	Report: ProductSalesByCustomerReportDTO;
	constructor(_params: {
		report: ProductSalesByCustomerReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetCustomersByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomersByTextRequest';
	IsBlocking = false;
	Criteria: string;
	FilterByCustomerTypeId: Nullable<number>;
	MaxResults: Nullable<number>;
	PosId: Nullable<number>;
	constructor(_params: {
		criteria: string,
		maxResults: Nullable<number>,
		posId: Nullable<number>,
		filterByCustomerTypeId: Nullable<number>
	}) {
		super({});
		this.Criteria = _params.criteria;
		this.MaxResults = _params.maxResults;
		this.PosId = _params.posId;
		this.FilterByCustomerTypeId = _params.filterByCustomerTypeId;
	}
}

export class GetCustomersByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetCustomersByTextResponse';
	IsBlocking = false;
	Customers: CustomerInListDTO[];
	constructor(_params: {
		customers: CustomerInListDTO[]
	}) {
		super({});
		this.Customers = _params.customers;
	}
}

export class GetCustomQueriesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomQueriesRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetCustomQueriesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomQueriesResponse';
	IsBlocking = false;
	Queries: CustomQueryInMenuDTO[];
	constructor(_params: {
		queries: CustomQueryInMenuDTO[]
	}) {
		super({});
		this.Queries = _params.queries;
	}
}

export class GetCustomQueryParamsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomQueryParamsRequest';
	IsBlocking = false;
	QueryGuid: string;
	constructor(_params: {
		queryGuid: string
	}) {
		super({});
		this.QueryGuid = _params.queryGuid;
	}
}

export class GetCustomQueryParamsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetCustomQueryParamsResponse';
	IsBlocking = false;
	IsAuthorized: boolean;
	Params: CustomQueryParamControlDTO[];
	QueryDescription: string;
	QueryName: string;
	QueryPDFOrientation: PDFOrientation;
	constructor(_params: {
		queryName: string,
		queryDescription: string,
		queryPDFOrientation: PDFOrientation,
		params: CustomQueryParamControlDTO[],
		isAuthorized: boolean
	}) {
		super({});
		this.QueryName = _params.queryName;
		this.QueryDescription = _params.queryDescription;
		this.QueryPDFOrientation = _params.queryPDFOrientation;
		this.Params = _params.params;
		this.IsAuthorized = _params.isAuthorized;
	}
}

export class GetDailyFiscalSummaryReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDailyFiscalSummaryReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	ShowTickets: boolean;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		showTickets: boolean,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.ShowTickets = _params.showTickets;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetDailyFiscalSummaryReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDailyFiscalSummaryReportResponse';
	IsBlocking = false;
	Report: DailyFiscalSummaryReportDTO;
	constructor(_params: {
		report: DailyFiscalSummaryReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetDailyFiscalSummaryReportWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDailyFiscalSummaryReportWebPrintResultRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	PrintTickets: boolean;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		printTickets: boolean,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PrintTickets = _params.printTickets;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetDailyFiscalSummaryReportWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDailyFiscalSummaryReportWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetDataToPrintTestRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDataToPrintTestRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetDataToPrintTestResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDataToPrintTestResponse';
	IsBlocking = false;
	Data: DataToPrintTestDTO;
	constructor(_params: {
		data: DataToPrintTestDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class GetDefaultSupplierIdForPurchaseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetDefaultSupplierIdForPurchaseRequest';
	IsBlocking = false;
	FromDate: Date;
	ProductId: number;
	WarehouseId: number;
	constructor(_params: {
		productId: number,
		warehouseId: number,
		fromDate: Date
	}) {
		super({});
		this.ProductId = _params.productId;
		this.WarehouseId = _params.warehouseId;
		this.FromDate = _params.fromDate;
	}
}

export class GetDefaultSupplierIdForPurchaseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetDefaultSupplierIdForPurchaseResponse';
	IsBlocking = false;
	SupplierId: Nullable<number>;
	constructor(_params: {
		supplierId: Nullable<number>
	}) {
		super({});
		this.SupplierId = _params.supplierId;
	}
}

export class GetDeliveryNoteDetailsBySerieAndNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNoteDetailsBySerieAndNumberRequest';
	IsBlocking = false;
	Number: number;
	Serie: string;
	constructor(_params: {
		serie: string,
		number: number
	}) {
		super({});
		this.Serie = _params.serie;
		this.Number = _params.number;
	}
}

export class GetDeliveryNoteDetailsBySerieAndNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNoteDetailsBySerieAndNumberResponse';
	IsBlocking = false;
	Details: DeliveryNoteDetailsDTO;
	constructor(_params: {
		details: DeliveryNoteDetailsDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetDeliveryNoteDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNoteDetailsRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class GetDeliveryNoteDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNoteDetailsResponse';
	IsBlocking = false;
	Details: DeliveryNoteDetailsDTO;
	constructor(_params: {
		details: DeliveryNoteDetailsDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetDeliveryNoteDraftRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDeliveryNoteDraftRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetDeliveryNoteDraftResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDeliveryNoteDraftResponse';
	IsBlocking = false;
	Draft: DeliveryNoteDraftDTO;
	constructor(_params: {
		draft: DeliveryNoteDraftDTO
	}) {
		super({});
		this.Draft = _params.draft;
	}
}

export class GetDeliveryNoteEmailOptionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNoteEmailOptionsRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class GetDeliveryNoteEmailOptionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNoteEmailOptionsResponse';
	IsBlocking = false;
	Options: DocumentEmailOptionsDTO;
	constructor(_params: {
		options: DocumentEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class GetDeliveryNoteLineDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNoteLineDetailsRequest';
	IsBlocking = false;
	DeliveryNoteIds: number[];
	constructor(_params: {
		deliveryNoteIds: number[]
	}) {
		super({});
		this.DeliveryNoteIds = _params.deliveryNoteIds;
	}
}

export class GetDeliveryNoteLineDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNoteLineDetailsResponse';
	IsBlocking = false;
	LineDetails: DeliveryNoteLineDetailsDTO[];
	constructor(_params: {
		lineDetails: DeliveryNoteLineDetailsDTO[]
	}) {
		super({});
		this.LineDetails = _params.lineDetails;
	}
}

export class GetDeliveryNotePreviewFromWebRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNotePreviewFromWebRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class GetDeliveryNotePreviewFromWebResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNotePreviewFromWebResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetDeliveryNotePreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNotePreviewRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class GetDeliveryNotePreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNotePreviewResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetDeliveryNotesReportWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDeliveryNotesReportWebPrintResultRequest';
	IsBlocking = true;
	DeliveryNotes: DeliveryNoteInListDTO[];
	Summary: DeliveryNotesSummaryDTO;
	constructor(_params: {
		deliveryNotes: DeliveryNoteInListDTO[],
		summary: DeliveryNotesSummaryDTO
	}) {
		super({});
		this.DeliveryNotes = _params.deliveryNotes;
		this.Summary = _params.summary;
	}
}

export class GetDeliveryNotesReportWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDeliveryNotesReportWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetDeliveryNotesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNotesRequest';
	IsBlocking = false;
	FromBusinessDay: Date;
	PosGroupIds: number[];
	ToBusinessDay: Date;
	constructor(_params: {
		toBusinessDay: Date,
		fromBusinessDay: Date,
		posGroupIds: number[]
	}) {
		super({});
		this.ToBusinessDay = _params.toBusinessDay;
		this.FromBusinessDay = _params.fromBusinessDay;
		this.PosGroupIds = _params.posGroupIds;
	}
}

export class GetDeliveryNotesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDeliveryNotesResponse';
	IsBlocking = false;
	DeliveryNotes: DeliveryNoteInListDTO[];
	constructor(_params: {
		deliveryNotes: DeliveryNoteInListDTO[]
	}) {
		super({});
		this.DeliveryNotes = _params.deliveryNotes;
	}
}

export class GetDeliveryNoteWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNoteWebPrintResultRequest';
	IsBlocking = false;
	ContentReplacement: string;
	DeliveryNoteId: number;
	Filename: string;
	constructor(_params: {
		deliveryNoteId: number,
		filename: string,
		contentReplacement: string
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
		this.Filename = _params.filename;
		this.ContentReplacement = _params.contentReplacement;
	}
}

export class GetDeliveryNoteWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDeliveryNoteWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetDeliveryNotificationMailSampleContentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetDeliveryNotificationMailSampleContentRequest';
	IsBlocking = false;
	AccentColor: string;
	MailFooter: string;
	MailHeader: string;
	OrderType: SalesOrderType;
	constructor(_params: {
		mailHeader: string,
		mailFooter: string,
		accentColor: string,
		orderType: SalesOrderType
	}) {
		super({});
		this.MailHeader = _params.mailHeader;
		this.MailFooter = _params.mailFooter;
		this.AccentColor = _params.accentColor;
		this.OrderType = _params.orderType;
	}
}

export class GetDeliveryNotificationMailSampleContentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetDeliveryNotificationMailSampleContentResponse';
	IsBlocking = false;
	MailContent: string;
	constructor(_params: {
		mailContent: string
	}) {
		super({});
		this.MailContent = _params.mailContent;
	}
}

export class GetDeliveryPersonsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDeliveryPersonsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetDeliveryPersonsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDeliveryPersonsResponse';
	IsBlocking = false;
	Statuses: DeliveryPersonDTO[];
	constructor(_params: {
		statuses: DeliveryPersonDTO[]
	}) {
		super({});
		this.Statuses = _params.statuses;
	}
}

export class GetDeviceConfigurationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetDeviceConfigurationRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetDeviceConfigurationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetDeviceConfigurationResponse';
	IsBlocking = false;
	AdminHttpPort: number;
	AdminHttpUseSsl: boolean;
	ApplicationName: string;
	CustomerDisplayConfiguration: CustomerDisplayConfigurationDTO;
	DisplayProfile: CurrentActionDisplayProfileDTO;
	EnableAttendanceModule: boolean;
	Fingerprints: UserFingerprintDTO[];
	FiscalSystem: FiscalSystem;
	FiscalSystemCertificateExpirationdate: Nullable<Date>;
	HubUrl: string;
	InstallationType: InstallationType;
	MachineType: MachineType;
	ScalePortConfiguration: SerialPortConfigurationDTO;
	Type: PosType;
	UseCardProcessor: boolean;
	UseCashControl: boolean;
	UseFingerprintReader: boolean;
	UseScale: boolean;
	XmlCardProcessorSettings: string;
	XmlCashControlSettings: string;
	constructor(_params: {
		customerDisplayConfiguration: CustomerDisplayConfigurationDTO,
		useCashControl: boolean,
		displayProfile: CurrentActionDisplayProfileDTO,
		installationType: InstallationType,
		useCardProcessor: boolean,
		xmlCashControlSettings: string,
		xmlCardProcessorSettings: string,
		type: PosType,
		enableAttendanceModule: boolean,
		useFingerprintReader: boolean,
		machineType: MachineType,
		applicationName: string,
		useScale: boolean,
		scalePortConfiguration: SerialPortConfigurationDTO,
		fingerprints: UserFingerprintDTO[],
		adminHttpPort: number,
		adminHttpUseSsl: boolean,
		hubUrl: string,
		fiscalSystem: FiscalSystem,
		fiscalSystemCertificateExpirationdate: Nullable<Date>
	}) {
		super({});
		this.CustomerDisplayConfiguration = _params.customerDisplayConfiguration;
		this.UseCashControl = _params.useCashControl;
		this.DisplayProfile = _params.displayProfile;
		this.InstallationType = _params.installationType;
		this.UseCardProcessor = _params.useCardProcessor;
		this.XmlCashControlSettings = _params.xmlCashControlSettings;
		this.XmlCardProcessorSettings = _params.xmlCardProcessorSettings;
		this.Type = _params.type;
		this.EnableAttendanceModule = _params.enableAttendanceModule;
		this.UseFingerprintReader = _params.useFingerprintReader;
		this.MachineType = _params.machineType;
		this.ApplicationName = _params.applicationName;
		this.UseScale = _params.useScale;
		this.ScalePortConfiguration = _params.scalePortConfiguration;
		this.Fingerprints = _params.fingerprints;
		this.AdminHttpPort = _params.adminHttpPort;
		this.AdminHttpUseSsl = _params.adminHttpUseSsl;
		this.HubUrl = _params.hubUrl;
		this.FiscalSystem = _params.fiscalSystem;
		this.FiscalSystemCertificateExpirationdate = _params.fiscalSystemCertificateExpirationdate;
	}
}

export class GetDigitalMenuQRParamsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDigitalMenuQRParamsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetDigitalMenuQRParamsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDigitalMenuQRParamsResponse';
	IsBlocking = false;
	DigitalMenuModes: DigitalMenuMode[];
	DigitalMenus: DigitalMenuInListDTO[];
	SaleCenters: SaleCenterInListDTO[];
	SmartMenuCenter: string;
	Workplaces: WorkplaceForQRDTO[];
	constructor(_params: {
		digitalMenuModes: DigitalMenuMode[],
		workplaces: WorkplaceForQRDTO[],
		saleCenters: SaleCenterInListDTO[],
		digitalMenus: DigitalMenuInListDTO[],
		smartMenuCenter: string
	}) {
		super({});
		this.DigitalMenuModes = _params.digitalMenuModes;
		this.Workplaces = _params.workplaces;
		this.SaleCenters = _params.saleCenters;
		this.DigitalMenus = _params.digitalMenus;
		this.SmartMenuCenter = _params.smartMenuCenter;
	}
}

export class GetDigitalMenuResourcesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDigitalMenuResourcesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetDigitalMenuResourcesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetDigitalMenuResourcesResponse';
	IsBlocking = false;
	Data: DigitalMenuResourcesForEditionDTO;
	constructor(_params: {
		data: DigitalMenuResourcesForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class GetDiscountsByUserAndProductReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDiscountsByUserAndProductReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetDiscountsByUserAndProductReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDiscountsByUserAndProductReportResponse';
	IsBlocking = false;
	Report: DiscountsByUserAndProductReportDTO;
	constructor(_params: {
		report: DiscountsByUserAndProductReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetDiscountsByUserAndTypeReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDiscountsByUserAndTypeReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetDiscountsByUserAndTypeReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetDiscountsByUserAndTypeReportResponse';
	IsBlocking = false;
	Report: DiscountsByUserAndTypeReportDTO;
	constructor(_params: {
		report: DiscountsByUserAndTypeReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetDocumentAuditDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetDocumentAuditDetailsRequest';
	IsBlocking = false;
	TicketGlobalId: string;
	constructor(_params: {
		ticketGlobalId: string
	}) {
		super({});
		this.TicketGlobalId = _params.ticketGlobalId;
	}
}

export class GetDocumentAuditDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetDocumentAuditDetailsResponse';
	IsBlocking = false;
	Events: AuditEventDTO[];
	PrintPreview: PrintPreviewDTO;
	constructor(_params: {
		events: AuditEventDTO[],
		printPreview: PrintPreviewDTO
	}) {
		super({});
		this.Events = _params.events;
		this.PrintPreview = _params.printPreview;
	}
}

export class GetDocumentByGlobalIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDocumentByGlobalIdRequest';
	IsBlocking = false;
	Format: SerializationFormat;
	GlobalId: string;
	constructor(_params: {
		globalId: string,
		format: SerializationFormat
	}) {
		super({});
		this.GlobalId = _params.globalId;
		this.Format = _params.format;
	}
}

export class GetDocumentByGlobalIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDocumentByGlobalIdResponse';
	IsBlocking = false;
	Data: string;
	constructor(_params: {
		data: string
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class GetDocumentIdByGlobalIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDocumentIdByGlobalIdRequest';
	IsBlocking = false;
	GlobalId: string;
	Type: EntityType;
	constructor(_params: {
		globalId: string,
		type: EntityType
	}) {
		super({});
		this.GlobalId = _params.globalId;
		this.Type = _params.type;
	}
}

export class GetDocumentIdByGlobalIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetDocumentIdByGlobalIdResponse';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class GetDocumentPreviewFromWebRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDocumentPreviewFromWebRequest';
	IsBlocking = false;
	TicketGlobalId: string;
	constructor(_params: {
		ticketGlobalId: string
	}) {
		super({});
		this.TicketGlobalId = _params.ticketGlobalId;
	}
}

export class GetDocumentPreviewFromWebResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDocumentPreviewFromWebResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetDocumentPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDocumentPreviewRequest';
	IsBlocking = false;
	TicketGlobalId: string;
	constructor(_params: {
		ticketGlobalId: string
	}) {
		super({});
		this.TicketGlobalId = _params.ticketGlobalId;
	}
}

export class GetDocumentPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetDocumentPreviewResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetDocumentTotalRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetDocumentTotalRequest';
	IsBlocking = false;
	ApplySurcharge: boolean;
	CashDiscount: number;
	DiscountPercentage: number;
	Lines: DocumentLineDTO[];
	PricesIncludeVat: boolean;
	TaxDeltas: TaxDeltaDTO[];
	constructor(_params: {
		pricesIncludeVat: boolean,
		applySurcharge: boolean,
		discountPercentage: number,
		cashDiscount: number,
		lines: DocumentLineDTO[],
		taxDeltas: TaxDeltaDTO[]
	}) {
		super({});
		this.PricesIncludeVat = _params.pricesIncludeVat;
		this.ApplySurcharge = _params.applySurcharge;
		this.DiscountPercentage = _params.discountPercentage;
		this.CashDiscount = _params.cashDiscount;
		this.Lines = _params.lines;
		this.TaxDeltas = _params.taxDeltas;
	}
}

export class GetDocumentTotalResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetDocumentTotalResponse';
	IsBlocking = false;
	Total: DocumentTotalDTO;
	constructor(_params: {
		total: DocumentTotalDTO
	}) {
		super({});
		this.Total = _params.total;
	}
}

export class GetEmailAccountsByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetEmailAccountsByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetEmailAccountsByWarehousesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetEmailAccountsByWarehousesRequest';
	IsBlocking = false;
	WarehouseIds: number[];
	constructor(_params: {
		warehouseIds: number[]
	}) {
		super({});
		this.WarehouseIds = _params.warehouseIds;
	}
}

export class GetEmailAccountsByWarehousesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetEmailAccountsByWarehousesResponse';
	IsBlocking = false;
	EmailAccounts: EmailAccountInListDTO[];
	constructor(_params: {
		emailAccounts: EmailAccountInListDTO[]
	}) {
		super({});
		this.EmailAccounts = _params.emailAccounts;
	}
}

export class GetEmailingStatsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetEmailingStatsRequest';
	IsBlocking = false;
	EmailingId: number;
	constructor(_params: {
		emailingId: number
	}) {
		super({});
		this.EmailingId = _params.emailingId;
	}
}

export class GetEmailingStatsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetEmailingStatsResponse';
	IsBlocking = false;
	Stats: EmailingStatsDTO;
	constructor(_params: {
		stats: EmailingStatsDTO
	}) {
		super({});
		this.Stats = _params.stats;
	}
}

export class GetEscPosSamplePrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetEscPosSamplePrintPreviewRequest';
	IsBlocking = false;
	Template: EscPosTemplateForEditionDTO;
	constructor(_params: {
		template: EscPosTemplateForEditionDTO
	}) {
		super({});
		this.Template = _params.template;
	}
}

export class GetEscPosSamplePrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetEscPosSamplePrintPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetEscPosSampleWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetEscPosSampleWebPrintResultRequest';
	IsBlocking = false;
	Template: EscPosTemplateForEditionDTO;
	constructor(_params: {
		template: EscPosTemplateForEditionDTO
	}) {
		super({});
		this.Template = _params.template;
	}
}

export class GetEscPosSampleWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetEscPosSampleWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetEventsForTicketsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetEventsForTicketsRequest';
	IsBlocking = false;
	Ids: string[];
	constructor(_params: {
		ids: string[]
	}) {
		super({});
		this.Ids = _params.ids;
	}
}

export class GetEventsForTicketsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetEventsForTicketsResponse';
	IsBlocking = false;
	Events: AuditEventDTO[];
	constructor(_params: {
		events: AuditEventDTO[]
	}) {
		super({});
		this.Events = _params.events;
	}
}

export class GetExistingTicketsInLocationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetExistingTicketsInLocationRequest';
	IsBlocking = false;
	SaleCenterId: number;
	SaleLocationName: string;
	constructor(_params: {
		saleCenterId: number,
		saleLocationName: string
	}) {
		super({});
		this.SaleCenterId = _params.saleCenterId;
		this.SaleLocationName = _params.saleLocationName;
	}
}

export class GetExistingTicketsInLocationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetExistingTicketsInLocationResponse';
	IsBlocking = false;
	Tickets: TicketSummaryDTO[];
	constructor(_params: {
		tickets: TicketSummaryDTO[]
	}) {
		super({});
		this.Tickets = _params.tickets;
	}
}

export class GetExpectedStockInSaleUnitRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetExpectedStockInSaleUnitRequest';
	IsBlocking = false;
	Date: Date;
	ProductId: number;
	WarehouseId: number;
	constructor(_params: {
		productId: number,
		date: Date,
		warehouseId: number
	}) {
		super({});
		this.ProductId = _params.productId;
		this.Date = _params.date;
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetExpectedStockInSaleUnitResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetExpectedStockInSaleUnitResponse';
	IsBlocking = false;
	Stock: number;
	constructor(_params: {
		stock: number
	}) {
		super({});
		this.Stock = _params.stock;
	}
}

export class GetFamiliesByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetFamiliesByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetFamiliesByWarehouseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetFamiliesByWarehouseRequest';
	IsBlocking = false;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetFamilyProductsDisplayOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetFamilyProductsDisplayOrderRequest';
	IsBlocking = false;
	FamilyId: number;
	constructor(_params: {
		familyId: number
	}) {
		super({});
		this.FamilyId = _params.familyId;
	}
}

export class GetFamilyProductsDisplayOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetFamilyProductsDisplayOrderResponse';
	IsBlocking = false;
	Products: SortableProductDTO[];
	constructor(_params: {
		products: SortableProductDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetGlobalSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetGlobalSalesReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetGlobalSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetGlobalSalesReportResponse';
	IsBlocking = false;
	Report: GlobalSalesReportDTO;
	constructor(_params: {
		report: GlobalSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetGStockPendingUploadsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.GetGStockPendingUploadsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetGStockPendingUploadsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.GStock.Messages.GetGStockPendingUploadsResponse';
	IsBlocking = false;
	Uploads: GStockPendingUploadDTO[];
	constructor(_params: {
		uploads: GStockPendingUploadDTO[]
	}) {
		super({});
		this.Uploads = _params.uploads;
	}
}

export class GetHubCommsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetHubCommsRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetHubCommsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetHubCommsResponse';
	IsBlocking = false;
	Comms: HubCommsDTO[];
	constructor(_params: {
		comms: HubCommsDTO[]
	}) {
		super({});
		this.Comms = _params.comms;
	}
}

export class GetIncomingDeliveryNoteAsPdfRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNoteAsPdfRequest';
	IsBlocking = false;
	IncomingDeliveryNote: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		incomingDeliveryNote: IncomingDeliveryNoteForEditionDTO
	}) {
		super({});
		this.IncomingDeliveryNote = _params.incomingDeliveryNote;
	}
}

export class GetIncomingDeliveryNoteAsPdfResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNoteAsPdfResponse';
	IsBlocking = false;
	Pdf: string;
	constructor(_params: {
		pdf: string
	}) {
		super({});
		this.Pdf = _params.pdf;
	}
}

export class GetIncomingDeliveryNoteAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNoteAttachmentRequest';
	IsBlocking = false;
	IncomingDeliveryNoteId: number;
	constructor(_params: {
		incomingDeliveryNoteId: number
	}) {
		super({});
		this.IncomingDeliveryNoteId = _params.incomingDeliveryNoteId;
	}
}

export class GetIncomingDeliveryNoteAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNoteAttachmentResponse';
	IsBlocking = false;
	Attachments: AttachmentDTO[];
	constructor(_params: {
		attachments: AttachmentDTO[]
	}) {
		super({});
		this.Attachments = _params.attachments;
	}
}

export class GetIncomingDeliveryNotesDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNotesDetailsRequest';
	IsBlocking = true;
	NoteIds: number[];
	constructor(_params: {
		noteIds: number[]
	}) {
		super({});
		this.NoteIds = _params.noteIds;
	}
}

export class GetIncomingDeliveryNotesDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNotesDetailsResponse';
	IsBlocking = true;
	Notes: IncomingDeliveryNoteDetailsDTO[];
	constructor(_params: {
		notes: IncomingDeliveryNoteDetailsDTO[]
	}) {
		super({});
		this.Notes = _params.notes;
	}
}

export class GetIncomingDeliveryNotesToInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNotesToInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	SupplierId: number;
	constructor(_params: {
		supplierId: number,
		invoiceId: number
	}) {
		super({});
		this.SupplierId = _params.supplierId;
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetIncomingDeliveryNotesToInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIncomingDeliveryNotesToInvoiceResponse';
	IsBlocking = false;
	Notes: IncomingDeliveryNoteInListDTO[];
	constructor(_params: {
		notes: IncomingDeliveryNoteInListDTO[]
	}) {
		super({});
		this.Notes = _params.notes;
	}
}

export class GetIngredientForRecipeByBarcodeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIngredientForRecipeByBarcodeRequest';
	IsBlocking = true;
	Barcode: string;
	constructor(_params: {
		barcode: string
	}) {
		super({});
		this.Barcode = _params.barcode;
	}
}

export class GetIngredientForRecipeByBarcodeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIngredientForRecipeByBarcodeResponse';
	IsBlocking = false;
	Ingredient: IngredientForRecipeDTO;
	constructor(_params: {
		ingredient: IngredientForRecipeDTO
	}) {
		super({});
		this.Ingredient = _params.ingredient;
	}
}

export class GetIngredientForRecipeByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIngredientForRecipeByIdRequest';
	IsBlocking = true;
	ProductId: number;
	constructor(_params: {
		productId: number
	}) {
		super({});
		this.ProductId = _params.productId;
	}
}

export class GetIngredientForRecipeByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetIngredientForRecipeByIdResponse';
	IsBlocking = false;
	Ingredient: IngredientForRecipeDTO;
	constructor(_params: {
		ingredient: IngredientForRecipeDTO
	}) {
		super({});
		this.Ingredient = _params.ingredient;
	}
}

export class GetIngredientsForRecipeByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetIngredientsForRecipeByTextRequest';
	IsBlocking = true;
	Filter: string;
	constructor(_params: {
		filter: string
	}) {
		super({});
		this.Filter = _params.filter;
	}
}

export class GetIngredientsForRecipeByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetIngredientsForRecipeByTextResponse';
	IsBlocking = false;
	Ingredients: IngredientSearchResultDTO[];
	constructor(_params: {
		ingredients: IngredientSearchResultDTO[]
	}) {
		super({});
		this.Ingredients = _params.ingredients;
	}
}

export class GetInstalledPrintersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInstalledPrintersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetInstalledPrintersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInstalledPrintersResponse';
	IsBlocking = false;
	Printers: string[];
	constructor(_params: {
		printers: string[]
	}) {
		super({});
		this.Printers = _params.printers;
	}
}

export class GetInternalDiscountForInternalPurchaseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetInternalDiscountForInternalPurchaseRequest';
	IsBlocking = false;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetInternalDiscountForInternalPurchaseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetInternalDiscountForInternalPurchaseResponse';
	IsBlocking = false;
	DiscountPercentage: number;
	constructor(_params: {
		discountPercentage: number
	}) {
		super({});
		this.DiscountPercentage = _params.discountPercentage;
	}
}

export class GetInventoryAsPdfRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetInventoryAsPdfRequest';
	IsBlocking = false;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class GetInventoryAsPdfResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetInventoryAsPdfResponse';
	IsBlocking = false;
	Pdf: string;
	constructor(_params: {
		pdf: string
	}) {
		super({});
		this.Pdf = _params.pdf;
	}
}

export class GetInventoryLinesFromCountsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetInventoryLinesFromCountsRequest';
	IsBlocking = true;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class GetInventoryLinesFromCountsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetInventoryLinesFromCountsResponse';
	IsBlocking = true;
	Lines: InventoryLineForEditionDTO[];
	constructor(_params: {
		lines: InventoryLineForEditionDTO[]
	}) {
		super({});
		this.Lines = _params.lines;
	}
}

export class GetInvitationsByBusinessDayReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvitationsByBusinessDayReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetInvitationsByBusinessDayReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvitationsByBusinessDayReportResponse';
	IsBlocking = false;
	Report: InvitationsByBusinessDayReportDTO;
	constructor(_params: {
		report: InvitationsByBusinessDayReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetInvoiceByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetInvoiceByIdRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetInvoiceByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetInvoiceByIdResponse';
	IsBlocking = false;
	Invoice: InvoiceDTO;
	constructor(_params: {
		invoice: InvoiceDTO
	}) {
		super({});
		this.Invoice = _params.invoice;
	}
}

export class GetInvoiceByTicketIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetInvoiceByTicketIdRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetInvoiceByTicketIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetInvoiceByTicketIdResponse';
	IsBlocking = false;
	Invoice: InvoiceDTO;
	constructor(_params: {
		invoice: InvoiceDTO
	}) {
		super({});
		this.Invoice = _params.invoice;
	}
}

export class GetInvoiceDetailsBySerieAndNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoiceDetailsBySerieAndNumberRequest';
	IsBlocking = false;
	Number: number;
	Serie: string;
	constructor(_params: {
		serie: string,
		number: number
	}) {
		super({});
		this.Serie = _params.serie;
		this.Number = _params.number;
	}
}

export class GetInvoiceDetailsBySerieAndNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoiceDetailsBySerieAndNumberResponse';
	IsBlocking = false;
	Details: InvoiceDetailsDTO;
	constructor(_params: {
		details: InvoiceDetailsDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetInvoiceDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoiceDetailsRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetInvoiceDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoiceDetailsResponse';
	IsBlocking = false;
	Details: InvoiceDetailsDTO;
	constructor(_params: {
		details: InvoiceDetailsDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetInvoiceDocumentPaymentsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetInvoiceDocumentPaymentsRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetInvoiceDocumentPaymentsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetInvoiceDocumentPaymentsResponse';
	IsBlocking = false;
	Payments: DocumentPaymentDTO[];
	constructor(_params: {
		payments: DocumentPaymentDTO[]
	}) {
		super({});
		this.Payments = _params.payments;
	}
}

export class GetInvoiceEmailOptionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoiceEmailOptionsRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetInvoiceEmailOptionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoiceEmailOptionsResponse';
	IsBlocking = false;
	Options: DocumentEmailOptionsDTO;
	constructor(_params: {
		options: DocumentEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class GetInvoicePreviewByTicketGlobalIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoicePreviewByTicketGlobalIdRequest';
	IsBlocking = false;
	TicketGlobalId: string;
	constructor(_params: {
		ticketGlobalId: string
	}) {
		super({});
		this.TicketGlobalId = _params.ticketGlobalId;
	}
}

export class GetInvoicePreviewByTicketGlobalIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoicePreviewByTicketGlobalIdResponse';
	IsBlocking = false;
	CanBeConvertedToStandard: boolean;
	CanBeSentByEmail: boolean;
	InvoiceId: number;
	Preview: PrintPreviewDTO;
	Reason: string;
	constructor(_params: {
		preview: PrintPreviewDTO,
		invoiceId: number,
		canBeConvertedToStandard: boolean,
		reason: string,
		canBeSentByEmail: boolean
	}) {
		super({});
		this.Preview = _params.preview;
		this.InvoiceId = _params.invoiceId;
		this.CanBeConvertedToStandard = _params.canBeConvertedToStandard;
		this.Reason = _params.reason;
		this.CanBeSentByEmail = _params.canBeSentByEmail;
	}
}

export class GetInvoicePreviewFromWebRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoicePreviewFromWebRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetInvoicePreviewFromWebResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoicePreviewFromWebResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetInvoicePreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoicePreviewRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetInvoicePreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoicePreviewResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetInvoicesByBusinesssDayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetInvoicesByBusinesssDayRequest';
	IsBlocking = false;
	FromBusinessDay: Date;
	IncludeFromOtherPointOfSales: boolean;
	ToBusinessDay: Date;
	constructor(_params: {
		fromBusinessDay: Date,
		toBusinessDay: Date,
		includeFromOtherPointOfSales: boolean
	}) {
		super({});
		this.FromBusinessDay = _params.fromBusinessDay;
		this.ToBusinessDay = _params.toBusinessDay;
		this.IncludeFromOtherPointOfSales = _params.includeFromOtherPointOfSales;
	}
}

export class GetInvoicesByBusinesssDayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetInvoicesByBusinesssDayResponse';
	IsBlocking = false;
	Invoices: InvoiceInListDTO[];
	constructor(_params: {
		invoices: InvoiceInListDTO[]
	}) {
		super({});
		this.Invoices = _params.invoices;
	}
}

export class GetInvoicesByCustomerReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvoicesByCustomerReportRequest';
	IsBlocking = true;
	CustomerFilterText: string;
	From: Date;
	PosGroupsIds: number[];
	ShowSurcharge: boolean;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		customerFilterText: string,
		showSurcharge: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.CustomerFilterText = _params.customerFilterText;
		this.ShowSurcharge = _params.showSurcharge;
	}
}

export class GetInvoicesByCustomerReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvoicesByCustomerReportResponse';
	IsBlocking = false;
	Report: InvoicesByCustomerReportDTO;
	constructor(_params: {
		report: InvoicesByCustomerReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetInvoicesByVerifactuChainRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetInvoicesByVerifactuChainRequest';
	IsBlocking = false;
	FromBusinessDay: Date;
	SifSettingsId: number;
	ToBusinessDay: Date;
	WorkplaceId: number;
	constructor(_params: {
		toBusinessDay: Date,
		fromBusinessDay: Date,
		sifSettingsId: number,
		workplaceId: number
	}) {
		super({});
		this.ToBusinessDay = _params.toBusinessDay;
		this.FromBusinessDay = _params.fromBusinessDay;
		this.SifSettingsId = _params.sifSettingsId;
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetInvoicesByVerifactuChainResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetInvoicesByVerifactuChainResponse';
	IsBlocking = false;
	VerifactuInvoices: VerifactuInvoiceInListDTO[];
	constructor(_params: {
		verifactuInvoices: VerifactuInvoiceInListDTO[]
	}) {
		super({});
		this.VerifactuInvoices = _params.verifactuInvoices;
	}
}

export class GetInvoicesLineDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoicesLineDetailsRequest';
	IsBlocking = false;
	InvoiceIds: number[];
	constructor(_params: {
		invoiceIds: number[]
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
	}
}

export class GetInvoicesLineDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoicesLineDetailsResponse';
	IsBlocking = false;
	LineDetails: InvoiceLineDetailsDTO[];
	constructor(_params: {
		lineDetails: InvoiceLineDetailsDTO[]
	}) {
		super({});
		this.LineDetails = _params.lineDetails;
	}
}

export class GetInvoicesPerMonthThroughYearsFileReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvoicesPerMonthThroughYearsFileReportResponse';
	IsBlocking = false;
	Report: InvoicesPerMonthThroughYearsReportDTO;
	constructor(_params: {
		report: InvoicesPerMonthThroughYearsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetInvoicesPerMonthThroughYearsReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvoicesPerMonthThroughYearsReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetInvoicesReportWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvoicesReportWebPrintResultRequest';
	IsBlocking = true;
	Invoices: InvoiceInListDTO[];
	Summary: InvoicesSummaryDTO;
	constructor(_params: {
		invoices: InvoiceInListDTO[],
		summary: InvoicesSummaryDTO
	}) {
		super({});
		this.Invoices = _params.invoices;
		this.Summary = _params.summary;
	}
}

export class GetInvoicesReportWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetInvoicesReportWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetInvoicesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoicesRequest';
	IsBlocking = false;
	FromBusinessDay: Date;
	PosGroupIds: number[];
	ToBusinessDay: Date;
	constructor(_params: {
		toBusinessDay: Date,
		fromBusinessDay: Date,
		posGroupIds: number[]
	}) {
		super({});
		this.ToBusinessDay = _params.toBusinessDay;
		this.FromBusinessDay = _params.fromBusinessDay;
		this.PosGroupIds = _params.posGroupIds;
	}
}

export class GetInvoicesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetInvoicesResponse';
	IsBlocking = false;
	Invoices: InvoiceInListDTO[];
	constructor(_params: {
		invoices: InvoiceInListDTO[]
	}) {
		super({});
		this.Invoices = _params.invoices;
	}
}

export class GetInvoiceWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoiceWebPrintResultRequest';
	IsBlocking = false;
	ContentReplacement: string;
	Filename: string;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number,
		filename: string,
		contentReplacement: string
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Filename = _params.filename;
		this.ContentReplacement = _params.contentReplacement;
	}
}

export class GetInvoiceWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetInvoiceWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetKeepAliveDataRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.SmartMenu.Messages.GetKeepAliveDataRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetKeepAliveDataResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.SmartMenu.Messages.GetKeepAliveDataResponse';
	IsBlocking = false;
	DisabledDeliveryTimes: Date[];
	DisabledLocations: DisabledLocationsDTO[];
	DisabledTakeAwayTimes: Date[];
	ProductIds: number[];
	constructor(_params: {
		productIds: number[],
		disabledTakeAwayTimes: Date[],
		disabledDeliveryTimes: Date[],
		disabledLocations: DisabledLocationsDTO[]
	}) {
		super({});
		this.ProductIds = _params.productIds;
		this.DisabledTakeAwayTimes = _params.disabledTakeAwayTimes;
		this.DisabledDeliveryTimes = _params.disabledDeliveryTimes;
		this.DisabledLocations = _params.disabledLocations;
	}
}

export class GetKitchenDisplayConfigurationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetKitchenDisplayConfigurationRequest';
	IsBlocking = false;
	DisplayId: number;
	constructor(_params: {
		displayId: number
	}) {
		super({});
		this.DisplayId = _params.displayId;
	}
}

export class GetKitchenDisplayConfigurationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetKitchenDisplayConfigurationResponse';
	IsBlocking = false;
	Configuration: KitchenDisplayConfigurationDTO;
	constructor(_params: {
		configuration: KitchenDisplayConfigurationDTO
	}) {
		super({});
		this.Configuration = _params.configuration;
	}
}

export class GetLastCashAmountToRefundFromInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetLastCashAmountToRefundFromInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetLastCashAmountToRefundFromInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetLastCashAmountToRefundFromInvoiceResponse';
	IsBlocking = false;
	Amount: number;
	constructor(_params: {
		amount: number
	}) {
		super({});
		this.Amount = _params.amount;
	}
}

export class GetLastUpdatedPendingPreparationsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetLastUpdatedPendingPreparationsRequest';
	IsBlocking = false;
	DisplayId: number;
	IncludeSiblingItems: boolean;
	constructor(_params: {
		displayId: number,
		includeSiblingItems: boolean
	}) {
		super({});
		this.DisplayId = _params.displayId;
		this.IncludeSiblingItems = _params.includeSiblingItems;
	}
}

export class GetLastUpdatedPendingPreparationsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetLastUpdatedPendingPreparationsResponse';
	IsBlocking = false;
	Items: PreparationItemDTO[];
	constructor(_params: {
		items: PreparationItemDTO[]
	}) {
		super({});
		this.Items = _params.items;
	}
}

export class GetLicenseContainerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Licensing.Messages.GetLicenseContainerRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetLicenseContainerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Licensing.Messages.GetLicenseContainerResponse';
	IsBlocking = false;
	Container: LicenseContainerDTO;
	constructor(_params: {
		container: LicenseContainerDTO
	}) {
		super({});
		this.Container = _params.container;
	}
}

export class GetLineCancellationReasonsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetLineCancellationReasonsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetLineCancellationReasonsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetLineCancellationReasonsResponse';
	IsBlocking = false;
	Reasons: string[];
	constructor(_params: {
		reasons: string[]
	}) {
		super({});
		this.Reasons = _params.reasons;
	}
}

export class GetLogLevelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetLogLevelRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetLogLevelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetLogLevelResponse';
	IsBlocking = false;
	IntegrationServicesLevel: string;
	InterceptorLevel: string;
	RootLevel: string;
	constructor(_params: {
		rootLevel: string,
		integrationServicesLevel: string,
		interceptorLevel: string
	}) {
		super({});
		this.RootLevel = _params.rootLevel;
		this.IntegrationServicesLevel = _params.integrationServicesLevel;
		this.InterceptorLevel = _params.interceptorLevel;
	}
}

export class GetLossReasonsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetLossReasonsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetLossReasonsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetLossReasonsResponse';
	IsBlocking = false;
	Reasons: string[];
	constructor(_params: {
		reasons: string[]
	}) {
		super({});
		this.Reasons = _params.reasons;
	}
}

export class GetLotsByExpirationDateReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetLotsByExpirationDateReportRequest';
	IsBlocking = true;
	Filter: string;
	From: Date;
	OnlyInStock: boolean;
	To: Date;
	WarehouseIds: number[];
	constructor(_params: {
		from: Date,
		to: Date,
		filter: string,
		onlyInStock: boolean,
		warehouseIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.Filter = _params.filter;
		this.OnlyInStock = _params.onlyInStock;
		this.WarehouseIds = _params.warehouseIds;
	}
}

export class GetLotsByExpirationDateReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetLotsByExpirationDateReportResponse';
	IsBlocking = false;
	Report: LotsReportDTO;
	constructor(_params: {
		report: LotsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetLotsInStockReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetLotsInStockReportRequest';
	IsBlocking = true;
	Filter: string;
	From: Date;
	To: Date;
	WarehouseIds: number[];
	constructor(_params: {
		from: Date,
		to: Date,
		filter: string,
		warehouseIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.Filter = _params.filter;
		this.WarehouseIds = _params.warehouseIds;
	}
}

export class GetLotsInStockReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetLotsInStockReportResponse';
	IsBlocking = false;
	Report: LotsReportDTO;
	constructor(_params: {
		report: LotsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetMajorGroupSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetMajorGroupSalesReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetMajorGroupSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetMajorGroupSalesReportResponse';
	IsBlocking = false;
	Report: MajorGroupSalesReportDTO;
	constructor(_params: {
		report: MajorGroupSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetMapClipartsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetMapClipartsRequest';
	IsBlocking = false;
	IncludeStatusCliparts: boolean;
	constructor(_params: {
		includeStatusCliparts: boolean
	}) {
		super({});
		this.IncludeStatusCliparts = _params.includeStatusCliparts;
	}
}

export class GetMapClipartsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetMapClipartsResponse';
	IsBlocking = false;
	Cliparts: MapClipartsDTO;
	constructor(_params: {
		cliparts: MapClipartsDTO
	}) {
		super({});
		this.Cliparts = _params.cliparts;
	}
}

export class GetMaxBusinessDayInSerieRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.GetMaxBusinessDayInSerieRequest';
	IsBlocking = false;
	DocumentType: DocumentType;
	PosId: number;
	constructor(_params: {
		documentType: DocumentType,
		posId: number
	}) {
		super({});
		this.DocumentType = _params.documentType;
		this.PosId = _params.posId;
	}
}

export class GetMaxBusinessDayInSerieResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.GetMaxBusinessDayInSerieResponse';
	IsBlocking = false;
	MaxBusinessDay: Date;
	constructor(_params: {
		maxBusinessDay: Date
	}) {
		super({});
		this.MaxBusinessDay = _params.maxBusinessDay;
	}
}

export class GetMenuForSaleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetMenuForSaleRequest';
	IsBlocking = false;
	SaleFormatId: number;
	constructor(_params: {
		saleFormatId: number
	}) {
		super({});
		this.SaleFormatId = _params.saleFormatId;
	}
}

export class GetMenuForSaleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetMenuForSaleResponse';
	IsBlocking = false;
	MenuForSale: MenuForSaleDTO;
	constructor(_params: {
		menuForSale: MenuForSaleDTO
	}) {
		super({});
		this.MenuForSale = _params.menuForSale;
	}
}

export class GetMenuSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetMenuSalesReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	ShowMenuDetails: boolean;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		showMenuDetails: boolean,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.ShowMenuDetails = _params.showMenuDetails;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetMenuSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetMenuSalesReportResponse';
	IsBlocking = false;
	Report: MenuSalesReportDTO;
	constructor(_params: {
		report: MenuSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetMenusToConfigureRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetMenusToConfigureRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetMenusToConfigureResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetMenusToConfigureResponse';
	IsBlocking = false;
	Menus: MenuConfigurationDTO[];
	constructor(_params: {
		menus: MenuConfigurationDTO[]
	}) {
		super({});
		this.Menus = _params.menus;
	}
}

export class GetMonthlyAppointmentsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetMonthlyAppointmentsRequest';
	IsBlocking = false;
	CurrentDate: Date;
	From: Date;
	To: Date;
	constructor(_params: {
		currentDate: Date,
		from: Date,
		to: Date
	}) {
		super({});
		this.CurrentDate = _params.currentDate;
		this.From = _params.from;
		this.To = _params.to;
	}
}

export class GetMonthlyAppointmentsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetMonthlyAppointmentsResponse';
	IsBlocking = false;
	Calendar: MonthlyAppointmentsDTO;
	constructor(_params: {
		calendar: MonthlyAppointmentsDTO
	}) {
		super({});
		this.Calendar = _params.calendar;
	}
}

export class GetMyAgoraUsersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetMyAgoraUsersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetMyAgoraUsersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetMyAgoraUsersResponse';
	IsBlocking = false;
	Users: string[];
	constructor(_params: {
		users: string[]
	}) {
		super({});
		this.Users = _params.users;
	}
}

export class GetNamedDiscountAuthorizersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetNamedDiscountAuthorizersRequest';
	IsBlocking = false;
	DiscountId: number;
	constructor(_params: {
		discountId: number
	}) {
		super({});
		this.DiscountId = _params.discountId;
	}
}

export class GetNamedDiscountAuthorizersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetNamedDiscountAuthorizersResponse';
	IsBlocking = false;
	Users: AvailableUserDTO[];
	constructor(_params: {
		users: AvailableUserDTO[]
	}) {
		super({});
		this.Users = _params.users;
	}
}

export class GetNamedDiscountProposalRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetNamedDiscountProposalRequest';
	IsBlocking = false;
	DiscountId: number;
	LineId: Nullable<number>;
	TicketId: number;
	constructor(_params: {
		discountId: number,
		ticketId: number,
		lineId: Nullable<number>
	}) {
		super({});
		this.DiscountId = _params.discountId;
		this.TicketId = _params.ticketId;
		this.LineId = _params.lineId;
	}
}

export class GetNamedDiscountProposalResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetNamedDiscountProposalResponse';
	IsBlocking = false;
	Proposal: NamedDiscountProposalDTO;
	constructor(_params: {
		proposal: NamedDiscountProposalDTO
	}) {
		super({});
		this.Proposal = _params.proposal;
	}
}

export class GetNamedDiscountsByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetNamedDiscountsByUserRequest';
	IsBlocking = false;
	TicketId: number;
	Type: NamedDiscountType;
	constructor(_params: {
		type: NamedDiscountType,
		ticketId: number
	}) {
		super({});
		this.Type = _params.type;
		this.TicketId = _params.ticketId;
	}
}

export class GetNamedDiscountsByUserResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetNamedDiscountsByUserResponse';
	IsBlocking = false;
	Discounts: NamedDiscountDTO[];
	constructor(_params: {
		discounts: NamedDiscountDTO[]
	}) {
		super({});
		this.Discounts = _params.discounts;
	}
}

export class GetNewTakeOutOrderCountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetNewTakeOutOrderCountRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetNewTakeOutOrderCountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetNewTakeOutOrderCountResponse';
	IsBlocking = false;
	Count: number;
	constructor(_params: {
		count: number
	}) {
		super({});
		this.Count = _params.count;
	}
}

export class GetOccupancyWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetOccupancyWidgetRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetOccupancyWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetOccupancyWidgetResponse';
	IsBlocking = false;
	Occupancy: OccupancyWidgetDTO;
	constructor(_params: {
		occupancy: OccupancyWidgetDTO
	}) {
		super({});
		this.Occupancy = _params.occupancy;
	}
}

export class GetOffersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetOffersRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetOffersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetOffersResponse';
	IsBlocking = false;
	Offers: OfferInListDTO[];
	constructor(_params: {
		offers: OfferInListDTO[]
	}) {
		super({});
		this.Offers = _params.offers;
	}
}

export class GetOpenDayParamsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.GetOpenDayParamsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetOpenDayParamsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.GetOpenDayParamsResponse';
	IsBlocking = false;
	Params: OpenDayParamsDTO;
	constructor(_params: {
		params: OpenDayParamsDTO
	}) {
		super({});
		this.Params = _params.params;
	}
}

export class GetOpenedTicketsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetOpenedTicketsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetOpenedTicketsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetOpenedTicketsResponse';
	IsBlocking = false;
	Tickets: TicketSummaryDTO[];
	constructor(_params: {
		tickets: TicketSummaryDTO[]
	}) {
		super({});
		this.Tickets = _params.tickets;
	}
}

export class GetOrCreateIncomingDeliveryNoteDraftFromPurchaseOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetOrCreateIncomingDeliveryNoteDraftFromPurchaseOrderRequest';
	IsBlocking = false;
	PurchaseOrderId: number;
	constructor(_params: {
		purchaseOrderId: number
	}) {
		super({});
		this.PurchaseOrderId = _params.purchaseOrderId;
	}
}

export class GetOrCreateIncomingDeliveryNoteDraftFromPurchaseOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetOrCreateIncomingDeliveryNoteDraftFromPurchaseOrderResponse';
	IsBlocking = false;
	Note: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		note: IncomingDeliveryNoteForEditionDTO
	}) {
		super({});
		this.Note = _params.note;
	}
}

export class GetOrderedItemsStateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetOrderedItemsStateRequest';
	IsBlocking = false;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[]
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
	}
}

export class GetOrderedItemsStateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetOrderedItemsStateResponse';
	IsBlocking = false;
	OrdersState: OrderedItemsStateDTO[];
	constructor(_params: {
		ordersState: OrderedItemsStateDTO[]
	}) {
		super({});
		this.OrdersState = _params.ordersState;
	}
}

export class GetOriginalInvoicePaymentsToRefundRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetOriginalInvoicePaymentsToRefundRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetOriginalInvoicePaymentsToRefundResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetOriginalInvoicePaymentsToRefundResponse';
	IsBlocking = false;
	Payments: PaymentDTO[];
	constructor(_params: {
		payments: PaymentDTO[]
	}) {
		super({});
		this.Payments = _params.payments;
	}
}

export class GetPartialBalanceReportPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPartialBalanceReportPreviewRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPartialBalanceReportPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPartialBalanceReportPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetPaymentMethodSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPaymentMethodSalesReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetPaymentMethodSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPaymentMethodSalesReportResponse';
	IsBlocking = false;
	Report: PaymentMethodSalesReportDTO;
	constructor(_params: {
		report: PaymentMethodSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetPaymentMethodsForPhoneOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetPaymentMethodsForPhoneOrderRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPaymentMethodsForPhoneOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetPaymentMethodsForPhoneOrderResponse';
	IsBlocking = false;
	Methods: PaymentMethodDTO[];
	constructor(_params: {
		methods: PaymentMethodDTO[]
	}) {
		super({});
		this.Methods = _params.methods;
	}
}

export class GetPaymentMethodsForPurchaseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPaymentMethodsForPurchaseRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPaymentMethodsForPurchaseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPaymentMethodsForPurchaseResponse';
	IsBlocking = false;
	All: PaymentMethodInListDTO[];
	constructor(_params: {
		all: PaymentMethodInListDTO[]
	}) {
		super({});
		this.All = _params.all;
	}
}

export class GetPaymentMethodsForSaleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetPaymentMethodsForSaleRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPaymentMethodsForSaleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetPaymentMethodsForSaleResponse';
	IsBlocking = false;
	Methods: PaymentMethodDTO[];
	constructor(_params: {
		methods: PaymentMethodDTO[]
	}) {
		super({});
		this.Methods = _params.methods;
	}
}

export class GetPendingDeliveryNoteByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingDeliveryNoteByIdRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	IsTrainingMode: boolean;
	constructor(_params: {
		deliveryNoteId: number,
		isTrainingMode: boolean
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
		this.IsTrainingMode = _params.isTrainingMode;
	}
}

export class GetPendingDeliveryNoteByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingDeliveryNoteByIdResponse';
	IsBlocking = false;
	DeliveryNote: DeliveryNoteDTO;
	constructor(_params: {
		deliveryNote: DeliveryNoteDTO
	}) {
		super({});
		this.DeliveryNote = _params.deliveryNote;
	}
}

export class GetPendingDeliveryNotesByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingDeliveryNotesByTextRequest';
	IsBlocking = false;
	Text: string;
	constructor(_params: {
		text: string
	}) {
		super({});
		this.Text = _params.text;
	}
}

export class GetPendingDeliveryNotesByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingDeliveryNotesByTextResponse';
	IsBlocking = false;
	DeliveryNotes: DeliveryNoteDTO[];
	constructor(_params: {
		deliveryNotes: DeliveryNoteDTO[]
	}) {
		super({});
		this.DeliveryNotes = _params.deliveryNotes;
	}
}

export class GetPendingPreparationsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetPendingPreparationsRequest';
	IsBlocking = false;
	DisplayId: number;
	constructor(_params: {
		displayId: number
	}) {
		super({});
		this.DisplayId = _params.displayId;
	}
}

export class GetPendingPreparationsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetPendingPreparationsResponse';
	IsBlocking = false;
	Items: PreparationItemDTO[];
	constructor(_params: {
		items: PreparationItemDTO[]
	}) {
		super({});
		this.Items = _params.items;
	}
}

export class GetPendingSalesOrderByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingSalesOrderByIdRequest';
	IsBlocking = false;
	IsTrainingMode: boolean;
	OrderId: number;
	constructor(_params: {
		orderId: number,
		isTrainingMode: boolean
	}) {
		super({});
		this.OrderId = _params.orderId;
		this.IsTrainingMode = _params.isTrainingMode;
	}
}

export class GetPendingSalesOrderByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingSalesOrderByIdResponse';
	IsBlocking = false;
	Order: SalesOrderDTO;
	constructor(_params: {
		order: SalesOrderDTO
	}) {
		super({});
		this.Order = _params.order;
	}
}

export class GetPendingSalesOrdersByProductRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPendingSalesOrdersByProductRequest';
	IsBlocking = false;
	ProductIds: number[];
	constructor(_params: {
		productIds: number[]
	}) {
		super({});
		this.ProductIds = _params.productIds;
	}
}

export class GetPendingSalesOrdersByProductResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPendingSalesOrdersByProductResponse';
	IsBlocking = false;
	SalesOrders: SalesOrderInListDTO[];
	constructor(_params: {
		salesOrders: SalesOrderInListDTO[]
	}) {
		super({});
		this.SalesOrders = _params.salesOrders;
	}
}

export class GetPendingScaleTicketsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingScaleTicketsRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetPendingScaleTicketsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPendingScaleTicketsResponse';
	IsBlocking = false;
	Tickets: ScaleTicketDTO[];
	constructor(_params: {
		tickets: ScaleTicketDTO[]
	}) {
		super({});
		this.Tickets = _params.tickets;
	}
}

export class GetPendingStandardSalesOrdersByDeliveryDateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPendingStandardSalesOrdersByDeliveryDateRequest';
	IsBlocking = false;
	DeliveryDate: Date;
	constructor(_params: {
		deliveryDate: Date
	}) {
		super({});
		this.DeliveryDate = _params.deliveryDate;
	}
}

export class GetPendingStandardSalesOrdersByDeliveryDateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPendingStandardSalesOrdersByDeliveryDateResponse';
	IsBlocking = false;
	SalesOrders: SalesOrderDTO[];
	constructor(_params: {
		salesOrders: SalesOrderDTO[]
	}) {
		super({});
		this.SalesOrders = _params.salesOrders;
	}
}

export class GetPendingTipToExtractRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetPendingTipToExtractRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPendingTipToExtractResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.GetPendingTipToExtractResponse';
	IsBlocking = false;
	PendingTipToExtract: number;
	constructor(_params: {
		pendingTipToExtract: number
	}) {
		super({});
		this.PendingTipToExtract = _params.pendingTipToExtract;
	}
}

export class GetPointsOfSaleStatusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPointsOfSaleStatusRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPointsOfSaleStatusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPointsOfSaleStatusResponse';
	IsBlocking = false;
	PointsOfSale: PointOfSaleStatusDTO[];
	constructor(_params: {
		pointsOfSale: PointOfSaleStatusDTO[]
	}) {
		super({});
		this.PointsOfSale = _params.pointsOfSale;
	}
}

export class GetPosCloseOutPrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPosCloseOutPrintPreviewRequest';
	IsBlocking = false;
	PosCloseOutId: number;
	constructor(_params: {
		posCloseOutId: number
	}) {
		super({});
		this.PosCloseOutId = _params.posCloseOutId;
	}
}

export class GetPosCloseOutPrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPosCloseOutPrintPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetPosCloseOutsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPosCloseOutsRequest';
	IsBlocking = false;
	FromCloseDate: Date;
	PosGroupIds: number[];
	ToCloseDate: Date;
	constructor(_params: {
		fromCloseDate: Date,
		toCloseDate: Date,
		posGroupIds: number[]
	}) {
		super({});
		this.FromCloseDate = _params.fromCloseDate;
		this.ToCloseDate = _params.toCloseDate;
		this.PosGroupIds = _params.posGroupIds;
	}
}

export class GetPosCloseOutsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPosCloseOutsResponse';
	IsBlocking = false;
	PosCloseOuts: PosCloseOutDTO[];
	constructor(_params: {
		posCloseOuts: PosCloseOutDTO[]
	}) {
		super({});
		this.PosCloseOuts = _params.posCloseOuts;
	}
}

export class GetPosCloseOutWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPosCloseOutWebPrintResultRequest';
	IsBlocking = false;
	PosCloseOutId: number;
	constructor(_params: {
		posCloseOutId: number
	}) {
		super({});
		this.PosCloseOutId = _params.posCloseOutId;
	}
}

export class GetPosCloseOutWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPosCloseOutWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetPosGroupsByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPosGroupsByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPossibleDuplicateCustomersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPossibleDuplicateCustomersRequest';
	IsBlocking = true;
	Customer: CustomerForEditionDTO;
	constructor(_params: {
		customer: CustomerForEditionDTO
	}) {
		super({});
		this.Customer = _params.customer;
	}
}

export class GetPossibleDuplicateCustomersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPossibleDuplicateCustomersResponse';
	IsBlocking = false;
	Customers: CustomerInListDTO[];
	constructor(_params: {
		customers: CustomerInListDTO[]
	}) {
		super({});
		this.Customers = _params.customers;
	}
}

export class GetPosWarehouseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPosWarehouseRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPosWarehouseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPosWarehouseResponse';
	IsBlocking = false;
	Warehouse: WarehouseInListDTO;
	constructor(_params: {
		warehouse: WarehouseInListDTO
	}) {
		super({});
		this.Warehouse = _params.warehouse;
	}
}

export class GetPredefinedNotesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPredefinedNotesRequest';
	IsBlocking = false;
	SaleFormatId: number;
	constructor(_params: {
		saleFormatId: number
	}) {
		super({});
		this.SaleFormatId = _params.saleFormatId;
	}
}

export class GetPredefinedNotesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPredefinedNotesResponse';
	IsBlocking = false;
	Notes: PredefinedNoteDTO[];
	constructor(_params: {
		notes: PredefinedNoteDTO[]
	}) {
		super({});
		this.Notes = _params.notes;
	}
}

export class GetPreparationCounterLastNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPreparationCounterLastNumberRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPreparationCounterLastNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPreparationCounterLastNumberResponse';
	IsBlocking = false;
	LastNumber: number;
	constructor(_params: {
		lastNumber: number
	}) {
		super({});
		this.LastNumber = _params.lastNumber;
	}
}

export class GetPreparationOrdersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPreparationOrdersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPreparationOrdersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPreparationOrdersResponse';
	IsBlocking = false;
	Orders: PreparationOrderDTO[];
	constructor(_params: {
		orders: PreparationOrderDTO[]
	}) {
		super({});
		this.Orders = _params.orders;
	}
}

export class GetPreparationSummaryPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetPreparationSummaryPreviewRequest';
	IsBlocking = false;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[]
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
	}
}

export class GetPreparationSummaryPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetPreparationSummaryPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetPreparationTypesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPreparationTypesRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPreparationTypesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPreparationTypesResponse';
	IsBlocking = false;
	Types: PreparationTypeDTO[];
	constructor(_params: {
		types: PreparationTypeDTO[]
	}) {
		super({});
		this.Types = _params.types;
	}
}

export class GetPreviousPurchasesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPreviousPurchasesRequest';
	IsBlocking = false;
	Note: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		note: IncomingDeliveryNoteForEditionDTO
	}) {
		super({});
		this.Note = _params.note;
	}
}

export class GetPreviousPurchasesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPreviousPurchasesResponse';
	IsBlocking = false;
	PreviousPurchases: PreviousPurchaseDTO[];
	constructor(_params: {
		previousPurchases: PreviousPurchaseDTO[]
	}) {
		super({});
		this.PreviousPurchases = _params.previousPurchases;
	}
}

export class GetPriceListConfigurationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPriceListConfigurationRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPriceListConfigurationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetPriceListConfigurationResponse';
	IsBlocking = false;
	Configuration: PriceListConfigurationDTO;
	constructor(_params: {
		configuration: PriceListConfigurationDTO
	}) {
		super({});
		this.Configuration = _params.configuration;
	}
}

export class GetPriceListSaleReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPriceListSaleReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetPriceListSaleReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPriceListSaleReportResponse';
	IsBlocking = false;
	Report: PriceListSalesReportDTO;
	constructor(_params: {
		report: PriceListSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetPriceListScheduleTableRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPriceListScheduleTableRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPriceListScheduleTableResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPriceListScheduleTableResponse';
	IsBlocking = false;
	Schedule: PriceListScheduleTableDTO;
	constructor(_params: {
		schedule: PriceListScheduleTableDTO
	}) {
		super({});
		this.Schedule = _params.schedule;
	}
}

export class GetPriceProposalRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPriceProposalRequest';
	IsBlocking = false;
	Date: Date;
	ProductsUnit: ProductUnitDTO[];
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		supplierId: number,
		date: Date,
		productsUnit: ProductUnitDTO[]
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.SupplierId = _params.supplierId;
		this.Date = _params.date;
		this.ProductsUnit = _params.productsUnit;
	}
}

export class GetPriceProposalResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPriceProposalResponse';
	IsBlocking = false;
	Info: PriceProposalDTO[];
	constructor(_params: {
		info: PriceProposalDTO[]
	}) {
		super({});
		this.Info = _params.info;
	}
}

export class GetPrintDocumentOptionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintDocumentOptionsRequest';
	IsBlocking = false;
	DocumentType: DocumentType;
	constructor(_params: {
		documentType: DocumentType
	}) {
		super({});
		this.DocumentType = _params.documentType;
	}
}

export class GetPrintInvoiceOptionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintInvoiceOptionsResponse';
	IsBlocking = false;
	Options: PrintDocumentOptionsDTO;
	constructor(_params: {
		options: PrintDocumentOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class GetPrintLabelOptionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintLabelOptionsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetPrintLabelOptionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintLabelOptionsResponse';
	IsBlocking = false;
	Options: PrintLabelOptionsDTO;
	constructor(_params: {
		options: PrintLabelOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class GetPrintLabelWebPrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintLabelWebPrintPreviewRequest';
	IsBlocking = true;
	LabelId: number;
	Labels: ProductLabelDTO[];
	constructor(_params: {
		labels: ProductLabelDTO[],
		labelId: number
	}) {
		super({});
		this.Labels = _params.labels;
		this.LabelId = _params.labelId;
	}
}

export class GetPrintLabelWebPrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintLabelWebPrintPreviewResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetPrintMenuPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPrintMenuPreviewRequest';
	IsBlocking = false;
	Menu: MenuConfigurationDTO;
	constructor(_params: {
		menu: MenuConfigurationDTO
	}) {
		super({});
		this.Menu = _params.menu;
	}
}

export class GetPrintMenuPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPrintMenuPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetPrintPurchasedOrProducedProductLabelWebPrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintPurchasedOrProducedProductLabelWebPrintPreviewRequest';
	IsBlocking = true;
	AlternativePriceListId: Nullable<number>;
	LabelId: number;
	PriceListId: number;
	Products: PurchasedOrProducedProductLabelDTO[];
	constructor(_params: {
		products: PurchasedOrProducedProductLabelDTO[],
		labelId: number,
		priceListId: number,
		alternativePriceListId: Nullable<number>
	}) {
		super({});
		this.Products = _params.products;
		this.LabelId = _params.labelId;
		this.PriceListId = _params.priceListId;
		this.AlternativePriceListId = _params.alternativePriceListId;
	}
}

export class GetPrintPurchasedOrProducedProductLabelWebPrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintPurchasedOrProducedProductLabelWebPrintPreviewResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetPrintSampleLabelWebPrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintSampleLabelWebPrintPreviewRequest';
	IsBlocking = true;
	SampleLabel: SampleLabelDTO;
	constructor(_params: {
		sampleLabel: SampleLabelDTO
	}) {
		super({});
		this.SampleLabel = _params.sampleLabel;
	}
}

export class GetPrintSampleLabelWebPrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetPrintSampleLabelWebPrintPreviewResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetProductAvailableQuantitiesByKitchenDisplayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetProductAvailableQuantitiesByKitchenDisplayRequest';
	IsBlocking = false;
	KitchenDisplayId: number;
	constructor(_params: {
		kitchenDisplayId: number
	}) {
		super({});
		this.KitchenDisplayId = _params.kitchenDisplayId;
	}
}

export class GetProductAvailableQuantitiesByKitchenDisplayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetProductAvailableQuantitiesByKitchenDisplayResponse';
	IsBlocking = false;
	Quantities: ProductAvailabilityDTO[];
	constructor(_params: {
		quantities: ProductAvailabilityDTO[]
	}) {
		super({});
		this.Quantities = _params.quantities;
	}
}

export class GetProductAvailableQuantitiesByPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetProductAvailableQuantitiesByPosRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetProductAvailableQuantitiesByPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetProductAvailableQuantitiesByPosResponse';
	IsBlocking = false;
	Quantities: ProductAvailabilityDTO[];
	constructor(_params: {
		quantities: ProductAvailabilityDTO[]
	}) {
		super({});
		this.Quantities = _params.quantities;
	}
}

export class GetProductDetailsForLotsByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductDetailsForLotsByIdRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class GetProductDetailsForLotsByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductDetailsForLotsByIdResponse';
	IsBlocking = false;
	Product: ProductDetailsForTraceabilityDTO;
	constructor(_params: {
		product: ProductDetailsForTraceabilityDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class GetProductDetailsInPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductDetailsInPosRequest';
	IsBlocking = false;
	SaleCenterId: number;
	SaleFormatId: number;
	constructor(_params: {
		saleFormatId: number,
		saleCenterId: number
	}) {
		super({});
		this.SaleFormatId = _params.saleFormatId;
		this.SaleCenterId = _params.saleCenterId;
	}
}

export class GetProductDetailsInPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductDetailsInPosResponse';
	IsBlocking = false;
	Details: ProductDetailsDTO;
	constructor(_params: {
		details: ProductDetailsDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetProductForDataSheetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductForDataSheetRequest';
	IsBlocking = false;
	ProductId: number;
	constructor(_params: {
		productId: number
	}) {
		super({});
		this.ProductId = _params.productId;
	}
}

export class GetProductForDataSheetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductForDataSheetResponse';
	IsBlocking = false;
	DataSheet: ProductForDataSheetDTO;
	constructor(_params: {
		dataSheet: ProductForDataSheetDTO
	}) {
		super({});
		this.DataSheet = _params.dataSheet;
	}
}

export class GetProductGroupsDisplayOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductGroupsDisplayOrderRequest';
	IsBlocking = false;
	PosGroupId: number;
	constructor(_params: {
		posGroupId: number
	}) {
		super({});
		this.PosGroupId = _params.posGroupId;
	}
}

export class GetProductGroupsDisplayOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductGroupsDisplayOrderResponse';
	IsBlocking = false;
	Groups: SortableProductGroupDTO[];
	constructor(_params: {
		groups: SortableProductGroupDTO[]
	}) {
		super({});
		this.Groups = _params.groups;
	}
}

export class GetProductGroupsForMenuConfigurationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductGroupsForMenuConfigurationRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetProductGroupsForMenuConfigurationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductGroupsForMenuConfigurationResponse';
	IsBlocking = false;
	ProductGroups: ProductGroupForSaleDTO[];
	constructor(_params: {
		productGroups: ProductGroupForSaleDTO[]
	}) {
		super({});
		this.ProductGroups = _params.productGroups;
	}
}

export class GetProductGroupsForSaleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductGroupsForSaleRequest';
	IsBlocking = false;
	SaleCenterId: number;
	constructor(_params: {
		saleCenterId: number
	}) {
		super({});
		this.SaleCenterId = _params.saleCenterId;
	}
}

export class GetProductGroupsForSaleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductGroupsForSaleResponse';
	IsBlocking = false;
	ProductGroups: ProductGroupForSaleDTO[];
	constructor(_params: {
		productGroups: ProductGroupForSaleDTO[]
	}) {
		super({});
		this.ProductGroups = _params.productGroups;
	}
}

export class GetProductHistoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.DTOs.GetProductHistoryRequest';
	IsBlocking = false;
	From: Date;
	ProductId: number;
	To: Date;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		productId: number,
		from: Date,
		to: Date
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.ProductId = _params.productId;
		this.From = _params.from;
		this.To = _params.to;
	}
}

export class GetProductHistoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.DTOs.GetProductHistoryResponse';
	IsBlocking = false;
	History: ProductHistoryDTO[];
	constructor(_params: {
		history: ProductHistoryDTO[]
	}) {
		super({});
		this.History = _params.history;
	}
}

export class GetProductionAsPdfRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductionAsPdfRequest';
	IsBlocking = false;
	Production: ProductionForEditionDTO;
	constructor(_params: {
		production: ProductionForEditionDTO
	}) {
		super({});
		this.Production = _params.production;
	}
}

export class GetProductionAsPdfResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductionAsPdfResponse';
	IsBlocking = false;
	Pdf: string;
	constructor(_params: {
		pdf: string
	}) {
		super({});
		this.Pdf = _params.pdf;
	}
}

export class GetProductionRecipeLinesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductionRecipeLinesRequest';
	IsBlocking = false;
	ProductId: number;
	ProductionQuantity: number;
	ProductionUnit: UnitOfMeasurementDTO;
	WarehouseId: number;
	constructor(_params: {
		productId: number,
		productionQuantity: number,
		productionUnit: UnitOfMeasurementDTO,
		warehouseId: number
	}) {
		super({});
		this.ProductId = _params.productId;
		this.ProductionQuantity = _params.productionQuantity;
		this.ProductionUnit = _params.productionUnit;
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetProductionRecipeLinesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductionRecipeLinesResponse';
	IsBlocking = false;
	ConsumedLines: ProductionLineForEditionDTO[];
	ProducedLine: ProductionLineForEditionDTO;
	constructor(_params: {
		producedLine: ProductionLineForEditionDTO,
		consumedLines: ProductionLineForEditionDTO[]
	}) {
		super({});
		this.ProducedLine = _params.producedLine;
		this.ConsumedLines = _params.consumedLines;
	}
}

export class GetProductMarginsByCategoryReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductMarginsByCategoryReportRequest';
	IsBlocking = true;
	CategoriesIds: number[];
	From: Date;
	IncludeDeliveryNotes: boolean;
	IncludeNotSoldProducts: boolean;
	PosGroupsIds: number[];
	SortOrder: string;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		includeDeliveryNotes: boolean,
		includeNotSoldProducts: boolean,
		categoriesIds: number[],
		sortOrder: string
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
		this.IncludeNotSoldProducts = _params.includeNotSoldProducts;
		this.CategoriesIds = _params.categoriesIds;
		this.SortOrder = _params.sortOrder;
	}
}

export class GetProductMarginsByCategoryReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductMarginsByCategoryReportResponse';
	IsBlocking = false;
	Report: ProductSalesByCategoryReportDTO;
	constructor(_params: {
		report: ProductSalesByCategoryReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductMarginsByFamilyReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductMarginsByFamilyReportRequest';
	IsBlocking = true;
	FamiliesIds: number[];
	From: Date;
	IncludeDeliveryNotes: boolean;
	IncludeNotSoldProducts: boolean;
	PosGroupsIds: number[];
	SortOrder: string;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		familiesIds: number[],
		includeNotSoldProducts: boolean,
		includeDeliveryNotes: boolean,
		sortOrder: string
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.FamiliesIds = _params.familiesIds;
		this.IncludeNotSoldProducts = _params.includeNotSoldProducts;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
		this.SortOrder = _params.sortOrder;
	}
}

export class GetProductMarginsByFamilyReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductMarginsByFamilyReportResponse';
	IsBlocking = false;
	Report: ProductSalesReportDTO;
	constructor(_params: {
		report: ProductSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductMarginsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductMarginsRequest';
	IsBlocking = false;
	categoryIds: number[];
	familyIds: number[];
	PriceListId: number;
	constructor(_params: {
		priceListId: number,
		familyIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.PriceListId = _params.priceListId;
		this.familyIds = _params.familyIds;
		this.categoryIds = _params.categoryIds;
	}
}

export class GetProductMarginsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductMarginsResponse';
	IsBlocking = false;
	Margins: ProductMarginForEditionDTO[];
	constructor(_params: {
		margins: ProductMarginForEditionDTO[]
	}) {
		super({});
		this.Margins = _params.margins;
	}
}

export class GetProductPreparationTimeFileReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductPreparationTimeFileReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetProductPreparationTimeFileReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductPreparationTimeFileReportResponse';
	IsBlocking = false;
	Report: ProductPreparationTimeReportDTO;
	constructor(_params: {
		report: ProductPreparationTimeReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductPricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductPricesRequest';
	IsBlocking = false;
	CategoryIds: number[];
	FamilyIds: number[];
	constructor(_params: {
		familyIds: number[],
		categoryIds: number[]
	}) {
		super({});
		this.FamilyIds = _params.familyIds;
		this.CategoryIds = _params.categoryIds;
	}
}

export class GetProductPricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductPricesResponse';
	IsBlocking = false;
	ProductPrices: ProductPriceForEditionDTO[];
	constructor(_params: {
		productPrices: ProductPriceForEditionDTO[]
	}) {
		super({});
		this.ProductPrices = _params.productPrices;
	}
}

export class GetProductPurchaseInfoProposalRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductPurchaseInfoProposalRequest';
	IsBlocking = false;
	Date: Date;
	OnlyUnitsWithPurchaseCondition: boolean;
	ProductId: number;
	Reference: string;
	SupplierId: number;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		supplierId: number,
		productId: number,
		date: Date,
		onlyUnitsWithPurchaseCondition: boolean,
		reference: string
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.SupplierId = _params.supplierId;
		this.ProductId = _params.productId;
		this.Date = _params.date;
		this.OnlyUnitsWithPurchaseCondition = _params.onlyUnitsWithPurchaseCondition;
		this.Reference = _params.reference;
	}
}

export class GetProductPurchaseInfoProposalResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductPurchaseInfoProposalResponse';
	IsBlocking = false;
	Proposal: ProductPurchaseInfoProposalDTO;
	constructor(_params: {
		proposal: ProductPurchaseInfoProposalDTO
	}) {
		super({});
		this.Proposal = _params.proposal;
	}
}

export class GetProductPurchasesAndSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductPurchasesAndSalesReportRequest';
	IsBlocking = true;
	Categories: CategoryByUserDTO[];
	Families: FamilyByUserDTO[];
	From: Date;
	IncludeDeliveryNotes: boolean;
	IncludeProductsWithPurchasesAndSalesOnly: boolean;
	To: Date;
	UseIncomingDeliveryNotesAsPurchaseDataOrigin: boolean;
	constructor(_params: {
		from: Date,
		to: Date,
		families: FamilyByUserDTO[],
		categories: CategoryByUserDTO[],
		useIncomingDeliveryNotesAsPurchaseDataOrigin: boolean,
		includeDeliveryNotes: boolean,
		includeProductsWithPurchasesAndSalesOnly: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.Families = _params.families;
		this.Categories = _params.categories;
		this.UseIncomingDeliveryNotesAsPurchaseDataOrigin = _params.useIncomingDeliveryNotesAsPurchaseDataOrigin;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
		this.IncludeProductsWithPurchasesAndSalesOnly = _params.includeProductsWithPurchasesAndSalesOnly;
	}
}

export class GetProductPurchasesAndSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductPurchasesAndSalesReportResponse';
	IsBlocking = false;
	Report: ProductPurchasesAndSalesReportDTO;
	constructor(_params: {
		report: ProductPurchasesAndSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductPurchasesByDeliveryNotesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductPurchasesByDeliveryNotesRequest';
	IsBlocking = true;
	NoteIds: number[];
	constructor(_params: {
		noteIds: number[]
	}) {
		super({});
		this.NoteIds = _params.noteIds;
	}
}

export class GetProductPurchasesByDeliveryNotesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductPurchasesByDeliveryNotesResponse';
	IsBlocking = true;
	ProductPurchases: ProductPurchaseDetailsDTO[];
	constructor(_params: {
		productPurchases: ProductPurchaseDetailsDTO[]
	}) {
		super({});
		this.ProductPurchases = _params.productPurchases;
	}
}

export class GetProductPurchasesByInvoicesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductPurchasesByInvoicesRequest';
	IsBlocking = true;
	InvoiceIds: number[];
	constructor(_params: {
		invoiceIds: number[]
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
	}
}

export class GetProductPurchasesByInvoicesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductPurchasesByInvoicesResponse';
	IsBlocking = true;
	ProductPurchases: ProductPurchaseDetailsDTO[];
	constructor(_params: {
		productPurchases: ProductPurchaseDetailsDTO[]
	}) {
		super({});
		this.ProductPurchases = _params.productPurchases;
	}
}

export class GetProductRecipesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetProductRecipesRequest';
	IsBlocking = false;
	SaleFormatIds: number[];
	constructor(_params: {
		saleFormatIds: number[]
	}) {
		super({});
		this.SaleFormatIds = _params.saleFormatIds;
	}
}

export class GetProductRecipesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetProductRecipesResponse';
	IsBlocking = false;
	Recipes: RecipeDetailsDTO[];
	constructor(_params: {
		recipes: RecipeDetailsDTO[]
	}) {
		super({});
		this.Recipes = _params.recipes;
	}
}

export class GetProductSalesByCategoryFileReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByCategoryFileReportRequest';
	IsBlocking = true;
	CategoriesIds: number[];
	From: Date;
	IncludeDeliveryNotes: boolean;
	IncludeNotSoldProducts: boolean;
	PosGroupsIds: number[];
	SortOrder: string;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		categoriesIds: number[],
		includeNotSoldProducts: boolean,
		sortOrder: string,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.CategoriesIds = _params.categoriesIds;
		this.IncludeNotSoldProducts = _params.includeNotSoldProducts;
		this.SortOrder = _params.sortOrder;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetProductSalesByCategoryFileReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByCategoryFileReportResponse';
	IsBlocking = false;
	Report: ProductSalesByCategoryReportDTO;
	constructor(_params: {
		report: ProductSalesByCategoryReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductSalesByOfferReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByOfferReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetProductSalesByOfferReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByOfferReportResponse';
	IsBlocking = false;
	Report: ProductSalesByOfferReportDTO;
	constructor(_params: {
		report: ProductSalesByOfferReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductSalesBySaleCenterFileReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesBySaleCenterFileReportResponse';
	IsBlocking = false;
	Report: ProductSalesBySaleCenterReportDTO;
	constructor(_params: {
		report: ProductSalesBySaleCenterReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductSalesBySaleCenterReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesBySaleCenterReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	SaleCenterId: number;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		saleCenterId: number,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.SaleCenterId = _params.saleCenterId;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetProductSalesByTimeFrameReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByTimeFrameReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	TimeFrameName: string;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameName: string,
		timeFrameGroupId: number,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameName = _params.timeFrameName;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetProductSalesByTimeFrameReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByTimeFrameReportResponse';
	IsBlocking = false;
	Report: ProductSalesByTimeFrameReportDTO;
	constructor(_params: {
		report: ProductSalesByTimeFrameReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductSalesByUserReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByUserReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetProductSalesByUserReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesByUserReportResponse';
	IsBlocking = false;
	Report: ProductSalesByUserReportDTO;
	constructor(_params: {
		report: ProductSalesByUserReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesReportRequest';
	IsBlocking = true;
	FamiliesIds: number[];
	From: Date;
	IncludeDeliveryNotes: boolean;
	IncludeNotSoldProducts: boolean;
	PosGroupsIds: number[];
	SortOrder: string;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		sortOrder: string,
		familiesIds: number[],
		includeNotSoldProducts: boolean,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.SortOrder = _params.sortOrder;
		this.FamiliesIds = _params.familiesIds;
		this.IncludeNotSoldProducts = _params.includeNotSoldProducts;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetProductSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductSalesReportResponse';
	IsBlocking = false;
	Report: ProductSalesReportDTO;
	constructor(_params: {
		report: ProductSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductsByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductsByIdRequest';
	IsBlocking = false;
	IncludePrices: boolean;
	ProductIds: number[];
	constructor(_params: {
		productIds: number[],
		includePrices: boolean
	}) {
		super({});
		this.ProductIds = _params.productIds;
		this.IncludePrices = _params.includePrices;
	}
}

export class GetProductsByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetProductsByIdResponse';
	IsBlocking = false;
	Products: ProductInListDTO[];
	constructor(_params: {
		products: ProductInListDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetProductsDetailsForLotsByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductsDetailsForLotsByTextRequest';
	IsBlocking = true;
	Filter: string;
	constructor(_params: {
		filter: string
	}) {
		super({});
		this.Filter = _params.filter;
	}
}

export class GetProductsDetailsForLotsByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductsDetailsForLotsByTextResponse';
	IsBlocking = false;
	Products: ProductDetailsForTraceabilityDTO[];
	constructor(_params: {
		products: ProductDetailsForTraceabilityDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetProductsForMenuConfigurationByCategoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductsForMenuConfigurationByCategoryRequest';
	IsBlocking = false;
	CategoryId: number;
	constructor(_params: {
		categoryId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
	}
}

export class GetProductsForMenuConfigurationByCategoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductsForMenuConfigurationByCategoryResponse';
	IsBlocking = false;
	Products: ProductForMenuConfigurationDTO[];
	constructor(_params: {
		products: ProductForMenuConfigurationDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetProductsForMenuConfigurationByFamilyRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductsForMenuConfigurationByFamilyRequest';
	IsBlocking = false;
	FamilyId: number;
	constructor(_params: {
		familyId: number
	}) {
		super({});
		this.FamilyId = _params.familyId;
	}
}

export class GetProductsForMenuConfigurationByFamilyResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetProductsForMenuConfigurationByFamilyResponse';
	IsBlocking = false;
	Products: ProductForMenuConfigurationDTO[];
	constructor(_params: {
		products: ProductForMenuConfigurationDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetProductsInListStockRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductsInListStockRequest';
	IsBlocking = false;
	ProductIds: number[];
	constructor(_params: {
		productIds: number[]
	}) {
		super({});
		this.ProductIds = _params.productIds;
	}
}

export class GetProductsInListStockResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetProductsInListStockResponse';
	IsBlocking = false;
	Stocks: ProductInListStockDTO[];
	constructor(_params: {
		stocks: ProductInListStockDTO[]
	}) {
		super({});
		this.Stocks = _params.stocks;
	}
}

export class GetProductStocksReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductStocksReportRequest';
	IsBlocking = true;
	Categories: CategoryByUserDTO[];
	Families: FamilyByUserDTO[];
	From: Date;
	IncludeOnlyProductsInStock: boolean;
	IncludeOnlyProductsUnderMinStock: boolean;
	Suppliers: SupplierByUserDTO[];
	To: Date;
	Warehouses: WarehouseByUserDTO[];
	constructor(_params: {
		from: Date,
		to: Date,
		warehouses: WarehouseByUserDTO[],
		families: FamilyByUserDTO[],
		suppliers: SupplierByUserDTO[],
		includeOnlyProductsUnderMinStock: boolean,
		includeOnlyProductsInStock: boolean,
		categories: CategoryByUserDTO[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.Warehouses = _params.warehouses;
		this.Families = _params.families;
		this.Suppliers = _params.suppliers;
		this.IncludeOnlyProductsUnderMinStock = _params.includeOnlyProductsUnderMinStock;
		this.IncludeOnlyProductsInStock = _params.includeOnlyProductsInStock;
		this.Categories = _params.categories;
	}
}

export class GetProductStocksReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetProductStocksReportResponse';
	IsBlocking = false;
	Report: ProductStocksReportDTO;
	constructor(_params: {
		report: ProductStocksReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetProductsWithRecipeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetProductsWithRecipeRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetProductsWithRecipeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetProductsWithRecipeResponse';
	IsBlocking = false;
	Products: ProductWithRecipeDTO[];
	constructor(_params: {
		products: ProductWithRecipeDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetPurchaseDetailsBySupplierReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPurchaseDetailsBySupplierReportRequest';
	IsBlocking = true;
	From: Date;
	Supplier: SupplierByUserDTO;
	To: Date;
	Warehouses: WarehouseByUserDTO[];
	constructor(_params: {
		from: Date,
		to: Date,
		warehouses: WarehouseByUserDTO[],
		supplier: SupplierByUserDTO
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.Warehouses = _params.warehouses;
		this.Supplier = _params.supplier;
	}
}

export class GetPurchaseDetailsBySupplierReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPurchaseDetailsBySupplierReportResponse';
	IsBlocking = false;
	Report: PurchaseDetailsBySupplierReportDTO;
	constructor(_params: {
		report: PurchaseDetailsBySupplierReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetPurchaseInvoiceAsPdfRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceAsPdfRequest';
	IsBlocking = false;
	PurchaseInvoice: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		purchaseInvoice: PurchaseInvoiceForEditionDTO
	}) {
		super({});
		this.PurchaseInvoice = _params.purchaseInvoice;
	}
}

export class GetPurchaseInvoiceAsPdfResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceAsPdfResponse';
	IsBlocking = false;
	Pdf: string;
	constructor(_params: {
		pdf: string
	}) {
		super({});
		this.Pdf = _params.pdf;
	}
}

export class GetPurchaseInvoiceAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceAttachmentRequest';
	IsBlocking = false;
	PurchaseInvoiceId: number;
	constructor(_params: {
		purchaseInvoiceId: number
	}) {
		super({});
		this.PurchaseInvoiceId = _params.purchaseInvoiceId;
	}
}

export class GetPurchaseInvoiceAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceAttachmentResponse';
	IsBlocking = false;
	Attachments: AttachmentDTO[];
	constructor(_params: {
		attachments: AttachmentDTO[]
	}) {
		super({});
		this.Attachments = _params.attachments;
	}
}

export class GetPurchaseInvoiceDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceDetailsRequest';
	IsBlocking = true;
	InvoiceIds: number[];
	constructor(_params: {
		invoiceIds: number[]
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
	}
}

export class GetPurchaseInvoiceDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceDetailsResponse';
	IsBlocking = true;
	Invoices: PurchaseInvoiceDetailsDTO[];
	constructor(_params: {
		invoices: PurchaseInvoiceDetailsDTO[]
	}) {
		super({});
		this.Invoices = _params.invoices;
	}
}

export class GetPurchaseInvoiceTotalRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceTotalRequest';
	IsBlocking = false;
	Invoice: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		invoice: PurchaseInvoiceForEditionDTO
	}) {
		super({});
		this.Invoice = _params.invoice;
	}
}

export class GetPurchaseInvoiceTotalResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseInvoiceTotalResponse';
	IsBlocking = false;
	Total: DocumentTotalDTO;
	constructor(_params: {
		total: DocumentTotalDTO
	}) {
		super({});
		this.Total = _params.total;
	}
}

export class GetPurchaseOrderAsPdfRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseOrderAsPdfRequest';
	IsBlocking = false;
	HidePrices: boolean;
	PurchaseOrder: PurchaseOrderForEditionDTO;
	constructor(_params: {
		purchaseOrder: PurchaseOrderForEditionDTO,
		hidePrices: boolean
	}) {
		super({});
		this.PurchaseOrder = _params.purchaseOrder;
		this.HidePrices = _params.hidePrices;
	}
}

export class GetPurchaseOrderAsPdfResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseOrderAsPdfResponse';
	IsBlocking = false;
	Pdf: string;
	constructor(_params: {
		pdf: string
	}) {
		super({});
		this.Pdf = _params.pdf;
	}
}

export class GetPurchaseOrderAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseOrderAttachmentRequest';
	IsBlocking = false;
	PurchaseOrderId: number;
	constructor(_params: {
		purchaseOrderId: number
	}) {
		super({});
		this.PurchaseOrderId = _params.purchaseOrderId;
	}
}

export class GetPurchaseOrderAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchaseOrderAttachmentResponse';
	IsBlocking = false;
	Attachments: AttachmentDTO[];
	constructor(_params: {
		attachments: AttachmentDTO[]
	}) {
		super({});
		this.Attachments = _params.attachments;
	}
}

export class GetPurchasePricesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPurchasePricesReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeProductsWithoutPurchases: boolean;
	Supplier: SupplierByUserDTO;
	To: Date;
	UseDeliveryNotesAsPurchaseDataOrigin: boolean;
	Warehouses: WarehouseByUserDTO[];
	constructor(_params: {
		from: Date,
		to: Date,
		supplier: SupplierByUserDTO,
		useDeliveryNotesAsPurchaseDataOrigin: boolean,
		includeProductsWithoutPurchases: boolean,
		warehouses: WarehouseByUserDTO[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.Supplier = _params.supplier;
		this.UseDeliveryNotesAsPurchaseDataOrigin = _params.useDeliveryNotesAsPurchaseDataOrigin;
		this.IncludeProductsWithoutPurchases = _params.includeProductsWithoutPurchases;
		this.Warehouses = _params.warehouses;
	}
}

export class GetPurchasePricesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPurchasePricesReportResponse';
	IsBlocking = false;
	Report: PurchasePricesReportDTO;
	constructor(_params: {
		report: PurchasePricesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetPurchasePurchaseOrderByIncomingDeliveryNoteIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchasePurchaseOrderByIncomingDeliveryNoteIdRequest';
	IsBlocking = false;
	IncomingDeliveryNoteId: number;
	constructor(_params: {
		incomingDeliveryNoteId: number
	}) {
		super({});
		this.IncomingDeliveryNoteId = _params.incomingDeliveryNoteId;
	}
}

export class GetPurchasePurchaseOrderByIncomingDeliveryNoteIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetPurchasePurchaseOrderByIncomingDeliveryNoteIdResponse';
	IsBlocking = false;
	Order: PurchaseOrderForEditionDTO;
	constructor(_params: {
		order: PurchaseOrderForEditionDTO
	}) {
		super({});
		this.Order = _params.order;
	}
}

export class GetPurchasesAnalyticsReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPurchasesAnalyticsReportRequest';
	IsBlocking = true;
	From: Date;
	To: Date;
	WarehouseIds: number[];
	constructor(_params: {
		from: Date,
		to: Date,
		warehouseIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.WarehouseIds = _params.warehouseIds;
	}
}

export class GetPurchasesAnalyticsReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetPurchasesAnalyticsReportResponse';
	IsBlocking = false;
	Report: PurchasesAnalyticsReportDTO;
	constructor(_params: {
		report: PurchasesAnalyticsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetQuantityByProductLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetQuantityByProductLineRequest';
	IsBlocking = false;
	OrderIds: number[];
	constructor(_params: {
		orderIds: number[]
	}) {
		super({});
		this.OrderIds = _params.orderIds;
	}
}

export class GetQuantityByProductLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetQuantityByProductLineResponse';
	IsBlocking = false;
	QuantityLines: QuantityLineDTO[];
	constructor(_params: {
		quantityLines: QuantityLineDTO[]
	}) {
		super({});
		this.QuantityLines = _params.quantityLines;
	}
}

export class GetRdlSamplePrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetRdlSamplePrintPreviewRequest';
	IsBlocking = false;
	Template: RdlTemplateForEditionDTO;
	constructor(_params: {
		template: RdlTemplateForEditionDTO
	}) {
		super({});
		this.Template = _params.template;
	}
}

export class GetRdlSamplePrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetRdlSamplePrintPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetRdlSampleWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetRdlSampleWebPrintResultRequest';
	IsBlocking = false;
	Template: RdlTemplateForEditionDTO;
	constructor(_params: {
		template: RdlTemplateForEditionDTO
	}) {
		super({});
		this.Template = _params.template;
	}
}

export class GetRdlSampleWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetRdlSampleWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetRecentSalesByCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetRecentSalesByCustomerRequest';
	IsBlocking = false;
	CustomerId: number;
	constructor(_params: {
		customerId: number
	}) {
		super({});
		this.CustomerId = _params.customerId;
	}
}

export class GetRecentSalesByCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetRecentSalesByCustomerResponse';
	IsBlocking = false;
	RecentSales: RecentSaleDTO[];
	constructor(_params: {
		recentSales: RecentSaleDTO[]
	}) {
		super({});
		this.RecentSales = _params.recentSales;
	}
}

export class GetRecipeIngredientsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetRecipeIngredientsRequest';
	IsBlocking = false;
	SaleFormatId: number;
	constructor(_params: {
		saleFormatId: number
	}) {
		super({});
		this.SaleFormatId = _params.saleFormatId;
	}
}

export class GetRecipeIngredientsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetRecipeIngredientsResponse';
	IsBlocking = false;
	Ingredients: RecipeIngredientDTO[];
	constructor(_params: {
		ingredients: RecipeIngredientDTO[]
	}) {
		super({});
		this.Ingredients = _params.ingredients;
	}
}

export class GetRecipeItemCostPricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetRecipeItemCostPricesRequest';
	IsBlocking = false;
	IngredientIds: number[];
	constructor(_params: {
		ingredientIds: number[]
	}) {
		super({});
		this.IngredientIds = _params.ingredientIds;
	}
}

export class GetRecipeItemCostPricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetRecipeItemCostPricesResponse';
	IsBlocking = false;
	Items: RecipeItemCostPricesDTO[];
	constructor(_params: {
		items: RecipeItemCostPricesDTO[]
	}) {
		super({});
		this.Items = _params.items;
	}
}

export class GetRelatedProductsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetRelatedProductsRequest';
	IsBlocking = false;
	ProductId: number;
	constructor(_params: {
		productId: number
	}) {
		super({});
		this.ProductId = _params.productId;
	}
}

export class GetRelatedProductsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetRelatedProductsResponse';
	IsBlocking = false;
	Addins: RelatedAddinDTO[];
	Menus: RelatedMenuDTO[];
	RecipeItems: RelatedRecipeItemDTO[];
	constructor(_params: {
		recipeItems: RelatedRecipeItemDTO[],
		addins: RelatedAddinDTO[],
		menus: RelatedMenuDTO[]
	}) {
		super({});
		this.RecipeItems = _params.recipeItems;
		this.Addins = _params.addins;
		this.Menus = _params.menus;
	}
}

export class GetReleaseDateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetReleaseDateRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetReleaseDateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetReleaseDateResponse';
	IsBlocking = false;
	ReleaseDate: Date;
	constructor(_params: {
		releaseDate: Date
	}) {
		super({});
		this.ReleaseDate = _params.releaseDate;
	}
}

export class GetReportViewsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetReportViewsRequest';
	IsBlocking = false;
	ReportId: string;
	constructor(_params: {
		reportId: string
	}) {
		super({});
		this.ReportId = _params.reportId;
	}
}

export class GetReportViewsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetReportViewsResponse';
	IsBlocking = false;
	Views: ReportViewDTO[];
	constructor(_params: {
		views: ReportViewDTO[]
	}) {
		super({});
		this.Views = _params.views;
	}
}

export class GetResellerBannerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetResellerBannerRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetResellerBannerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetResellerBannerResponse';
	IsBlocking = false;
	Banner: ResellerBannerDTO;
	constructor(_params: {
		banner: ResellerBannerDTO
	}) {
		super({});
		this.Banner = _params.banner;
	}
}

export class GetRestaurantStatusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetRestaurantStatusRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetRestaurantStatusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetRestaurantStatusResponse';
	IsBlocking = false;
	Status: RestaurantStatusDTO;
	constructor(_params: {
		status: RestaurantStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class GetSaleableAsAddinByRoleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsAddinByRoleRequest';
	IsBlocking = false;
	AddinRoleId: number;
	IsAddinInMenu: boolean;
	TicketId: number;
	constructor(_params: {
		addinRoleId: number,
		ticketId: number,
		isAddinInMenu: boolean
	}) {
		super({});
		this.AddinRoleId = _params.addinRoleId;
		this.TicketId = _params.ticketId;
		this.IsAddinInMenu = _params.isAddinInMenu;
	}
}

export class GetSaleableAsAddinByRoleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsAddinByRoleResponse';
	IsBlocking = false;
	AllowedAddins: ProductForSaleDTO[];
	constructor(_params: {
		allowedAddins: ProductForSaleDTO[]
	}) {
		super({});
		this.AllowedAddins = _params.allowedAddins;
	}
}

export class GetSaleableAsMainByPriceLookUpCodeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByPriceLookUpCodeRequest';
	IsBlocking = false;
	PriceLookUpCode: string;
	TicketId: number;
	constructor(_params: {
		priceLookUpCode: string,
		ticketId: number
	}) {
		super({});
		this.PriceLookUpCode = _params.priceLookUpCode;
		this.TicketId = _params.ticketId;
	}
}

export class GetSaleableAsMainByPriceLookUpCodeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByPriceLookUpCodeResponse';
	IsBlocking = false;
	Product: ProductForSaleDTO;
	constructor(_params: {
		product: ProductForSaleDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class GetSaleableAsMainByProductGroupRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByProductGroupRequest';
	IsBlocking = false;
	ProductGroupId: number;
	ProductGroupType: ProductGroupType;
	TicketId: number;
	constructor(_params: {
		productGroupType: ProductGroupType,
		ticketId: number,
		productGroupId: number
	}) {
		super({});
		this.ProductGroupType = _params.productGroupType;
		this.TicketId = _params.ticketId;
		this.ProductGroupId = _params.productGroupId;
	}
}

export class GetSaleableAsMainByProductGroupResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByProductGroupResponse';
	IsBlocking = false;
	Products: ProductForSaleDTO[];
	constructor(_params: {
		products: ProductForSaleDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetSaleableAsMainByProductIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByProductIdRequest';
	IsBlocking = false;
	ProductId: number;
	TicketId: number;
	constructor(_params: {
		productId: number,
		ticketId: number
	}) {
		super({});
		this.ProductId = _params.productId;
		this.TicketId = _params.ticketId;
	}
}

export class GetSaleableAsMainByProductIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByProductIdResponse';
	IsBlocking = false;
	Product: ProductForSaleDTO;
	constructor(_params: {
		product: ProductForSaleDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class GetSaleableAsMainBySaleFormatIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainBySaleFormatIdRequest';
	IsBlocking = false;
	SaleFormatId: number;
	TicketId: number;
	constructor(_params: {
		saleFormatId: number,
		ticketId: number
	}) {
		super({});
		this.SaleFormatId = _params.saleFormatId;
		this.TicketId = _params.ticketId;
	}
}

export class GetSaleableAsMainBySaleFormatIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainBySaleFormatIdResponse';
	IsBlocking = false;
	Product: ProductForSaleDTO;
	constructor(_params: {
		product: ProductForSaleDTO
	}) {
		super({});
		this.Product = _params.product;
	}
}

export class GetSaleableAsMainByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByTextRequest';
	IsBlocking = false;
	OnlyInPosId: Nullable<number>;
	Text: string;
	TicketId: number;
	constructor(_params: {
		text: string,
		ticketId: number,
		onlyInPosId: Nullable<number>
	}) {
		super({});
		this.Text = _params.text;
		this.TicketId = _params.ticketId;
		this.OnlyInPosId = _params.onlyInPosId;
	}
}

export class GetSaleableAsMainByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainByTextResponse';
	IsBlocking = false;
	MaxResults: number;
	Products: ProductForSaleDTO[];
	constructor(_params: {
		products: ProductForSaleDTO[],
		maxResults: number
	}) {
		super({});
		this.Products = _params.products;
		this.MaxResults = _params.maxResults;
	}
}

export class GetSaleableAsMainFormatsByProductRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainFormatsByProductRequest';
	IsBlocking = false;
	ProductId: number;
	TicketId: number;
	constructor(_params: {
		productId: number,
		ticketId: number
	}) {
		super({});
		this.ProductId = _params.productId;
		this.TicketId = _params.ticketId;
	}
}

export class GetSaleableAsMainFormatsByProductResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMainFormatsByProductResponse';
	IsBlocking = false;
	Formats: ProductForSaleDTO[];
	constructor(_params: {
		formats: ProductForSaleDTO[]
	}) {
		super({});
		this.Formats = _params.formats;
	}
}

export class GetSaleableAsMenuItemByProductGroupRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMenuItemByProductGroupRequest';
	IsBlocking = false;
	ProductGroup: ProductGroupForSaleDTO;
	TicketId: number;
	constructor(_params: {
		productGroup: ProductGroupForSaleDTO,
		ticketId: number
	}) {
		super({});
		this.ProductGroup = _params.productGroup;
		this.TicketId = _params.ticketId;
	}
}

export class GetSaleableAsMenuItemByProductGroupResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMenuItemByProductGroupResponse';
	IsBlocking = false;
	Products: ProductForSaleDTO[];
	constructor(_params: {
		products: ProductForSaleDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetSaleableAsMenuItemFormatsByProductRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMenuItemFormatsByProductRequest';
	IsBlocking = false;
	ProductId: number;
	TicketId: number;
	constructor(_params: {
		productId: number,
		ticketId: number
	}) {
		super({});
		this.ProductId = _params.productId;
		this.TicketId = _params.ticketId;
	}
}

export class GetSaleableAsMenuItemFormatsByProductResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.GetSaleableAsMenuItemFormatsByProductResponse';
	IsBlocking = false;
	Formats: ProductForSaleDTO[];
	constructor(_params: {
		formats: ProductForSaleDTO[]
	}) {
		super({});
		this.Formats = _params.formats;
	}
}

export class GetSaleCenterAvailablePriceListsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleCenterAvailablePriceListsRequest';
	IsBlocking = false;
	SaleCenterId: number;
	constructor(_params: {
		saleCenterId: number
	}) {
		super({});
		this.SaleCenterId = _params.saleCenterId;
	}
}

export class GetSaleCenterAvailablePriceListsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleCenterAvailablePriceListsResponse';
	IsBlocking = false;
	AvailablePriceLists: PriceListInListDTO[];
	constructor(_params: {
		availablePriceLists: PriceListInListDTO[]
	}) {
		super({});
		this.AvailablePriceLists = _params.availablePriceLists;
	}
}

export class GetSaleCenterDefaultProductGroupRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetSaleCenterDefaultProductGroupRequest';
	IsBlocking = false;
	SaleCenterId: number;
	constructor(_params: {
		saleCenterId: number
	}) {
		super({});
		this.SaleCenterId = _params.saleCenterId;
	}
}

export class GetSaleCenterDefaultProductGroupResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetSaleCenterDefaultProductGroupResponse';
	IsBlocking = false;
	DefaultProductGroup: ProductGroupForSaleDTO;
	HasDefaultProductGroup: boolean;
	constructor(_params: {
		hasDefaultProductGroup: boolean,
		defaultProductGroup: ProductGroupForSaleDTO
	}) {
		super({});
		this.HasDefaultProductGroup = _params.hasDefaultProductGroup;
		this.DefaultProductGroup = _params.defaultProductGroup;
	}
}

export class GetSaleCenterForPosGroupRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleCenterForPosGroupRequest';
	IsBlocking = false;
	PosGroupId: number;
	constructor(_params: {
		posGroupId: number
	}) {
		super({});
		this.PosGroupId = _params.posGroupId;
	}
}

export class GetSaleCenterForPosGroupResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleCenterForPosGroupResponse';
	IsBlocking = false;
	SaleCenters: SaleCenterInListDTO[];
	constructor(_params: {
		saleCenters: SaleCenterInListDTO[]
	}) {
		super({});
		this.SaleCenters = _params.saleCenters;
	}
}

export class GetSaleCenterOccupancyWidgetsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCenterOccupancyWidgetsRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetSaleCenterOccupancyWidgetsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCenterOccupancyWidgetsResponse';
	IsBlocking = false;
	Occupancies: SaleCenterOccupancyWidgetDTO[];
	constructor(_params: {
		occupancies: SaleCenterOccupancyWidgetDTO[]
	}) {
		super({});
		this.Occupancies = _params.occupancies;
	}
}

export class GetSaleCenterSalesByTimeFrameReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCenterSalesByTimeFrameReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	TimeFrameName: string;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameName: string,
		timeFrameGroupId: number
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameName = _params.timeFrameName;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
	}
}

export class GetSaleCenterSalesByTimeFrameReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCenterSalesByTimeFrameReportResponse';
	IsBlocking = false;
	Report: SaleCenterSalesByTimeFrameReportDTO;
	constructor(_params: {
		report: SaleCenterSalesByTimeFrameReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetSaleCenterSalesFileReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCenterSalesFileReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetSaleCenterSalesFileReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCenterSalesFileReportResponse';
	IsBlocking = false;
	Report: SaleCenterSalesReportDTO;
	constructor(_params: {
		report: SaleCenterSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetSaleCentersByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleCentersByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetSaleCentersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCentersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetSaleCentersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleCentersResponse';
	IsBlocking = false;
	SaleCenters: SaleCenterInListDTO[];
	constructor(_params: {
		saleCenters: SaleCenterInListDTO[]
	}) {
		super({});
		this.SaleCenters = _params.saleCenters;
	}
}

export class GetSaleFormatKeysByCategoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleFormatKeysByCategoryRequest';
	IsBlocking = false;
	CategoryId: number;
	constructor(_params: {
		categoryId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
	}
}

export class GetSaleFormatKeysByCategoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleFormatKeysByCategoryResponse';
	IsBlocking = false;
	SaleFormats: SaleFormatForKeyDTO[];
	constructor(_params: {
		saleFormats: SaleFormatForKeyDTO[]
	}) {
		super({});
		this.SaleFormats = _params.saleFormats;
	}
}

export class GetSaleFormatsWithRecipeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetSaleFormatsWithRecipeRequest';
	IsBlocking = false;
	SaleFormatIds: number[];
	constructor(_params: {
		saleFormatIds: number[]
	}) {
		super({});
		this.SaleFormatIds = _params.saleFormatIds;
	}
}

export class GetSaleFormatsWithRecipeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.GetSaleFormatsWithRecipeResponse';
	IsBlocking = false;
	SaleFormatIds: number[];
	constructor(_params: {
		saleFormatIds: number[]
	}) {
		super({});
		this.SaleFormatIds = _params.saleFormatIds;
	}
}

export class GetSaleLocationSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleLocationSalesReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetSaleLocationSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSaleLocationSalesReportResponse';
	IsBlocking = false;
	Report: SaleLocationSalesReportDTO;
	constructor(_params: {
		report: SaleLocationSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetSalesAnalyticsReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSalesAnalyticsReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameGroupId: number,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetSalesAnalyticsReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSalesAnalyticsReportResponse';
	IsBlocking = false;
	Report: SalesAnalyticsReportDTO;
	constructor(_params: {
		report: SalesAnalyticsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetSalesOrderDeliveryAddressLocationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetSalesOrderDeliveryAddressLocationRequest';
	IsBlocking = false;
	OrderId: number;
	constructor(_params: {
		orderId: number
	}) {
		super({});
		this.OrderId = _params.orderId;
	}
}

export class GetSalesOrderDeliveryAddressLocationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetSalesOrderDeliveryAddressLocationResponse';
	IsBlocking = false;
	DeliveryAddress: AddressDTO;
	Location: AddressLocationDTO;
	constructor(_params: {
		deliveryAddress: AddressDTO,
		location: AddressLocationDTO
	}) {
		super({});
		this.DeliveryAddress = _params.deliveryAddress;
		this.Location = _params.location;
	}
}

export class GetSalesOrderDetailsBySerieAndNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrderDetailsBySerieAndNumberRequest';
	IsBlocking = false;
	Number: number;
	Serie: string;
	constructor(_params: {
		serie: string,
		number: number
	}) {
		super({});
		this.Serie = _params.serie;
		this.Number = _params.number;
	}
}

export class GetSalesOrderDetailsBySerieAndNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrderDetailsBySerieAndNumberResponse';
	IsBlocking = false;
	Details: SalesOrderDetailsDTO;
	constructor(_params: {
		details: SalesOrderDetailsDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetSalesOrderDetailsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrderDetailsRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class GetSalesOrderDetailsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrderDetailsResponse';
	IsBlocking = false;
	Details: SalesOrderDetailsDTO;
	constructor(_params: {
		details: SalesOrderDetailsDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetSalesOrderDraftRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetSalesOrderDraftRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetSalesOrderDraftResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetSalesOrderDraftResponse';
	IsBlocking = false;
	Draft: SalesOrderDraftDTO;
	constructor(_params: {
		draft: SalesOrderDraftDTO
	}) {
		super({});
		this.Draft = _params.draft;
	}
}

export class GetSalesOrderEmailOptionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderEmailOptionsRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class GetSalesOrderEmailOptionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderEmailOptionsResponse';
	IsBlocking = false;
	Options: DocumentEmailOptionsDTO;
	constructor(_params: {
		options: DocumentEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class GetSalesOrderLineDetailsByIdsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrderLineDetailsByIdsRequest';
	IsBlocking = false;
	SalesOrdersIds: number[];
	constructor(_params: {
		salesOrdersIds: number[]
	}) {
		super({});
		this.SalesOrdersIds = _params.salesOrdersIds;
	}
}

export class GetSalesOrderLineDetailsByIdsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrderLineDetailsByIdsResponse';
	IsBlocking = false;
	LineDetails: SalesOrderLineDetailsDTO[];
	constructor(_params: {
		lineDetails: SalesOrderLineDetailsDTO[]
	}) {
		super({});
		this.LineDetails = _params.lineDetails;
	}
}

export class GetSalesOrderPreviewFromWebRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderPreviewFromWebRequest';
	IsBlocking = false;
	SaleOrderId: number;
	constructor(_params: {
		saleOrderId: number
	}) {
		super({});
		this.SaleOrderId = _params.saleOrderId;
	}
}

export class GetSalesOrderPreviewFromWebResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderPreviewFromWebResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetSalesOrderPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderPreviewRequest';
	IsBlocking = false;
	OrderId: number;
	constructor(_params: {
		orderId: number
	}) {
		super({});
		this.OrderId = _params.orderId;
	}
}

export class GetSalesOrderPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderPreviewResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetSalesOrdersByBusinessDayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrdersByBusinessDayRequest';
	IsBlocking = false;
	FromBusinessDay: Date;
	PosGroupIds: number[];
	ToBusinessDay: Date;
	constructor(_params: {
		fromBusinessDay: Date,
		toBusinessDay: Date,
		posGroupIds: number[]
	}) {
		super({});
		this.FromBusinessDay = _params.fromBusinessDay;
		this.ToBusinessDay = _params.toBusinessDay;
		this.PosGroupIds = _params.posGroupIds;
	}
}

export class GetSalesOrdersByBusinessDayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSalesOrdersByBusinessDayResponse';
	IsBlocking = false;
	SalesOrders: SalesOrderInListDTO[];
	constructor(_params: {
		salesOrders: SalesOrderInListDTO[]
	}) {
		super({});
		this.SalesOrders = _params.salesOrders;
	}
}

export class GetSalesOrderWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderWebPrintResultRequest';
	IsBlocking = false;
	ContentReplacement: string;
	Filename: string;
	SaleOrderId: number;
	constructor(_params: {
		saleOrderId: number,
		filename: string,
		contentReplacement: string
	}) {
		super({});
		this.SaleOrderId = _params.saleOrderId;
		this.Filename = _params.filename;
		this.ContentReplacement = _params.contentReplacement;
	}
}

export class GetSalesOrderWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSalesOrderWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSalesWidgetRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSalesWidgetResponse';
	IsBlocking = false;
	Sales: SalesWidgetDTO;
	constructor(_params: {
		sales: SalesWidgetDTO
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetScaleCounterDataSummaryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetScaleCounterDataSummaryRequest';
	IsBlocking = true;
	ScaleCounterId: number;
	constructor(_params: {
		scaleCounterId: number
	}) {
		super({});
		this.ScaleCounterId = _params.scaleCounterId;
	}
}

export class GetScaleCounterDataSummaryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetScaleCounterDataSummaryResponse';
	IsBlocking = false;
	Summary: EntitySummaryDTO[];
	constructor(_params: {
		summary: EntitySummaryDTO[]
	}) {
		super({});
		this.Summary = _params.summary;
	}
}

export class GetSectionsBySaleFormatCategoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSectionsBySaleFormatCategoryRequest';
	IsBlocking = false;
	CategoryId: number;
	constructor(_params: {
		categoryId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
	}
}

export class GetSectionsBySaleFormatCategoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSectionsBySaleFormatCategoryResponse';
	IsBlocking = false;
	Sections: FamilyForSectionDTO[];
	constructor(_params: {
		sections: FamilyForSectionDTO[]
	}) {
		super({});
		this.Sections = _params.sections;
	}
}

export class GetServerLogsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetServerLogsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetServerLogsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetServerLogsResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Success: boolean;
	ZipContent: string;
	constructor(_params: {
		zipContent: string,
		success: boolean,
		errorMessage: string
	}) {
		super({});
		this.ZipContent = _params.zipContent;
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class GetSizesAndColorsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSizesAndColorsRequest';
	IsBlocking = false;
	ProductId: number;
	constructor(_params: {
		productId: number
	}) {
		super({});
		this.ProductId = _params.productId;
	}
}

export class GetSizesAndColorsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSizesAndColorsResponse';
	IsBlocking = false;
	SizesAndColors: SizesAndColorsDTO;
	constructor(_params: {
		sizesAndColors: SizesAndColorsDTO
	}) {
		super({});
		this.SizesAndColors = _params.sizesAndColors;
	}
}

export class GetSmartMenuDownloadTemplateFromWorkplaceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSmartMenuDownloadTemplateFromWorkplaceRequest';
	IsBlocking = true;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetSmartMenuDownloadTemplateFromWorkplaceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSmartMenuDownloadTemplateFromWorkplaceResponse';
	IsBlocking = false;
	DownloadTemplate: PrintTemplateInListDTO;
	constructor(_params: {
		downloadTemplate: PrintTemplateInListDTO
	}) {
		super({});
		this.DownloadTemplate = _params.downloadTemplate;
	}
}

export class GetSmartMenuPaymentStatusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetSmartMenuPaymentStatusRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetSmartMenuPaymentStatusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetSmartMenuPaymentStatusResponse';
	IsBlocking = false;
	Status: SmartMenuPaymentStatusDTO;
	constructor(_params: {
		status: SmartMenuPaymentStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class GetSmartMenuPublishStatusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSmartMenuPublishStatusRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetSmartMenuPublishStatusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSmartMenuPublishStatusResponse';
	IsBlocking = false;
	PublishStatus: SmartMenuPublishStatusDTO;
	constructor(_params: {
		publishStatus: SmartMenuPublishStatusDTO
	}) {
		super({});
		this.PublishStatus = _params.publishStatus;
	}
}

export class GetStockChangeAsPdfRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetStockChangeAsPdfRequest';
	IsBlocking = false;
	StockChange: StockChangeForEditionDTO;
	constructor(_params: {
		stockChange: StockChangeForEditionDTO
	}) {
		super({});
		this.StockChange = _params.stockChange;
	}
}

export class GetStockChangeAsPdfResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetStockChangeAsPdfResponse';
	IsBlocking = false;
	Pdf: string;
	constructor(_params: {
		pdf: string
	}) {
		super({});
		this.Pdf = _params.pdf;
	}
}

export class GetStockChangeAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetStockChangeAttachmentRequest';
	IsBlocking = false;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
	}
}

export class GetStockChangeAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetStockChangeAttachmentResponse';
	IsBlocking = false;
	Attachments: AttachmentDTO[];
	constructor(_params: {
		attachments: AttachmentDTO[]
	}) {
		super({});
		this.Attachments = _params.attachments;
	}
}

export class GetStockSummaryValueWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetStockSummaryValueWidgetRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetStockSummaryValueWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetStockSummaryValueWidgetResponse';
	IsBlocking = false;
	Value: StockValueSummaryWidgetDTO;
	constructor(_params: {
		value: StockValueSummaryWidgetDTO
	}) {
		super({});
		this.Value = _params.value;
	}
}

export class GetStoredSamplePrintPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetStoredSamplePrintPreviewRequest';
	IsBlocking = false;
	CustomTemplateId: number;
	constructor(_params: {
		customTemplateId: number
	}) {
		super({});
		this.CustomTemplateId = _params.customTemplateId;
	}
}

export class GetStoredSamplePrintPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetStoredSamplePrintPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetSupplierEmailRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSupplierEmailRequest';
	IsBlocking = false;
	SupplierId: number;
	WarehouseId: Nullable<number>;
	constructor(_params: {
		supplierId: number,
		warehouseId: Nullable<number>
	}) {
		super({});
		this.SupplierId = _params.supplierId;
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetSupplierEmailResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSupplierEmailResponse';
	IsBlocking = false;
	Email: string;
	constructor(_params: {
		email: string
	}) {
		super({});
		this.Email = _params.email;
	}
}

export class GetSupplierPurchasesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSupplierPurchasesReportRequest';
	IsBlocking = true;
	From: Date;
	Suppliers: SupplierByUserDTO[];
	To: Date;
	UseIncomingDeliveryNotes: boolean;
	Warehouses: WarehouseByUserDTO[];
	constructor(_params: {
		from: Date,
		to: Date,
		suppliers: SupplierByUserDTO[],
		warehouses: WarehouseByUserDTO[],
		useIncomingDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.Suppliers = _params.suppliers;
		this.Warehouses = _params.warehouses;
		this.UseIncomingDeliveryNotes = _params.useIncomingDeliveryNotes;
	}
}

export class GetSupplierPurchasesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSupplierPurchasesReportResponse';
	IsBlocking = false;
	Report: SupplierPurchasesReportDTO;
	constructor(_params: {
		report: SupplierPurchasesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetSuppliersByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSuppliersByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetSystemByUnitRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSystemByUnitRequest';
	IsBlocking = false;
	UnitId: number;
	constructor(_params: {
		unitId: number
	}) {
		super({});
		this.UnitId = _params.unitId;
	}
}

export class GetSystemByUnitResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSystemByUnitResponse';
	IsBlocking = false;
	Units: UnitOfMeasurementDTO[];
	constructor(_params: {
		units: UnitOfMeasurementDTO[]
	}) {
		super({});
		this.Units = _params.units;
	}
}

export class GetSystemCloseOutReportPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSystemCloseOutReportPreviewRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetSystemCloseOutReportPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSystemCloseOutReportPreviewResponse';
	IsBlocking = false;
	Preview: string;
	constructor(_params: {
		preview: string
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetSystemCloseOutsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSystemCloseOutsRequest';
	IsBlocking = false;
	From: Date;
	PosGroupIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupIds = _params.posGroupIds;
	}
}

export class GetSystemCloseOutsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetSystemCloseOutsResponse';
	IsBlocking = false;
	SystemCloseOuts: SystemCloseOutDTO[];
	constructor(_params: {
		systemCloseOuts: SystemCloseOutDTO[]
	}) {
		super({});
		this.SystemCloseOuts = _params.systemCloseOuts;
	}
}

export class GetSystemCloseOutWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSystemCloseOutWebPrintResultRequest';
	IsBlocking = false;
	SystemCloseOutId: number;
	constructor(_params: {
		systemCloseOutId: number
	}) {
		super({});
		this.SystemCloseOutId = _params.systemCloseOutId;
	}
}

export class GetSystemCloseOutWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetSystemCloseOutWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetTableCompanionsBySaleCenterReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTableCompanionsBySaleCenterReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetTableCompanionsBySaleCenterReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTableCompanionsBySaleCenterReportResponse';
	IsBlocking = false;
	Report: TableCompanionsBySaleCenterReportDTO;
	constructor(_params: {
		report: TableCompanionsBySaleCenterReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTableCompanionsByTimeFrameReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTableCompanionsByTimeFrameReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameGroupId: number,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetTableCompanionsByTimeFrameReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTableCompanionsByTimeFrameReportResponse';
	IsBlocking = false;
	Report: TableCompanionsByTimeFrameReportDTO;
	constructor(_params: {
		report: TableCompanionsByTimeFrameReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTableCompanionsByWorkplaceAndByTimeFrameReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTableCompanionsByWorkplaceAndByTimeFrameReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameGroupId: number,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetTableCompanionsByWorkplaceAndByTimeFrameReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTableCompanionsByWorkplaceAndByTimeFrameReportResponse';
	IsBlocking = false;
	Report: TableCompanionsByWorkplaceAndTimeFrameReportDTO;
	constructor(_params: {
		report: TableCompanionsByWorkplaceAndTimeFrameReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTakeOutOrdersByDeliveryDateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetTakeOutOrdersByDeliveryDateRequest';
	IsBlocking = false;
	DeliveryDate: Date;
	Statuses: DeliveryStatus[];
	Types: SalesOrderType[];
	constructor(_params: {
		deliveryDate: Date,
		types: SalesOrderType[],
		statuses: DeliveryStatus[]
	}) {
		super({});
		this.DeliveryDate = _params.deliveryDate;
		this.Types = _params.types;
		this.Statuses = _params.statuses;
	}
}

export class GetTakeOutOrdersByDeliveryDateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetTakeOutOrdersByDeliveryDateResponse';
	IsBlocking = false;
	SalesOrders: SalesOrderDTO[];
	constructor(_params: {
		salesOrders: SalesOrderDTO[]
	}) {
		super({});
		this.SalesOrders = _params.salesOrders;
	}
}

export class GetTaxesByCustomerReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTaxesByCustomerReportRequest';
	IsBlocking = true;
	CustomerFilterText: string;
	From: Date;
	IncludeBasicInvoices: boolean;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		customerFilterText: string,
		includeBasicInvoices: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.CustomerFilterText = _params.customerFilterText;
		this.IncludeBasicInvoices = _params.includeBasicInvoices;
	}
}

export class GetTaxesByCustomerReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTaxesByCustomerReportResponse';
	IsBlocking = false;
	Report: TaxesByCustomerReportDTO;
	constructor(_params: {
		report: TaxesByCustomerReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTelemetrySettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetTelemetrySettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetTelemetrySettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.GetTelemetrySettingsResponse';
	IsBlocking = false;
	ConnectionString: string;
	DefaultProperties: TelemetryDefaultPropertyDTO[];
	Settings: TelemetrySamplingRateDTO[];
	constructor(_params: {
		connectionString: string,
		defaultProperties: TelemetryDefaultPropertyDTO[],
		settings: TelemetrySamplingRateDTO[]
	}) {
		super({});
		this.ConnectionString = _params.connectionString;
		this.DefaultProperties = _params.defaultProperties;
		this.Settings = _params.settings;
	}
}

export class GetTicketBAIStatusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.TicketBAI.Messages.GetTicketBAIStatusRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetTicketBAIStatusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.TicketBAI.Messages.GetTicketBAIStatusResponse';
	IsBlocking = false;
	Status: TicketBAIStatusDTO;
	constructor(_params: {
		status: TicketBAIStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class GetTicketBAIXmlRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.TicketBAI.Messages.GetTicketBAIXmlRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetTicketBAIXmlResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.TicketBAI.Messages.GetTicketBAIXmlResponse';
	IsBlocking = false;
	Xml: string;
	constructor(_params: {
		xml: string
	}) {
		super({});
		this.Xml = _params.xml;
	}
}

export class GetTicketByIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketByIdRequest';
	IsBlocking = false;
	ClaimTicket: boolean;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		claimTicket: boolean
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.ClaimTicket = _params.claimTicket;
	}
}

export class GetTicketByIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketByIdResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class GetTicketGlobalIdByInvoiceIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketGlobalIdByInvoiceIdRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class GetTicketGlobalIdByInvoiceIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketGlobalIdByInvoiceIdResponse';
	IsBlocking = false;
	GlobalId: Nullable<string>;
	constructor(_params: {
		globalId: Nullable<string>
	}) {
		super({});
		this.GlobalId = _params.globalId;
	}
}

export class GetTicketPaymentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketPaymentRequest';
	IsBlocking = false;
	DocumentPaymentId: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		documentPaymentId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.DocumentPaymentId = _params.documentPaymentId;
	}
}

export class GetTicketPaymentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketPaymentResponse';
	IsBlocking = false;
	Payment: PaymentDTO;
	constructor(_params: {
		payment: PaymentDTO
	}) {
		super({});
		this.Payment = _params.payment;
	}
}

export class GetTicketPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetTicketPreviewRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetTicketPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetTicketPreviewResponse';
	IsBlocking = false;
	Previews: PrintPreviewDTO[];
	constructor(_params: {
		previews: PrintPreviewDTO[]
	}) {
		super({});
		this.Previews = _params.previews;
	}
}

export class GetTicketsBySaleCenterReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsBySaleCenterReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetTicketsBySaleCenterReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsBySaleCenterReportResponse';
	IsBlocking = false;
	Report: TableCompanionsBySaleCenterReportDTO;
	constructor(_params: {
		report: TableCompanionsBySaleCenterReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTicketsByTimeFrameReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsByTimeFrameReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameGroupId: number,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetTicketsByTimeFrameReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsByTimeFrameReportResponse';
	IsBlocking = false;
	Report: TicketsByTimeFrameReportDTO;
	constructor(_params: {
		report: TicketsByTimeFrameReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTicketsByWorkplaceAndTimeFrameReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsByWorkplaceAndTimeFrameReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeDeliveryNotes: boolean;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameGroupId: number,
		includeDeliveryNotes: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
		this.IncludeDeliveryNotes = _params.includeDeliveryNotes;
	}
}

export class GetTicketsByWorkplaceAndTimeFrameReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsByWorkplaceAndTimeFrameReportResponse';
	IsBlocking = false;
	Report: TableCompanionsByWorkplaceAndTimeFrameReportDTO;
	constructor(_params: {
		report: TableCompanionsByWorkplaceAndTimeFrameReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTicketServiceChargeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketServiceChargeRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetTicketServiceChargeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketServiceChargeResponse';
	IsBlocking = false;
	ServiceCharge: ServiceChargeDTO;
	constructor(_params: {
		serviceCharge: ServiceChargeDTO
	}) {
		super({});
		this.ServiceCharge = _params.serviceCharge;
	}
}

export class GetTicketsWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsWidgetRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetTicketsWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTicketsWidgetResponse';
	IsBlocking = false;
	Tickets: TicketsWidgetDTO;
	constructor(_params: {
		tickets: TicketsWidgetDTO
	}) {
		super({});
		this.Tickets = _params.tickets;
	}
}

export class GetTicketTipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketTipRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class GetTicketTipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.GetTicketTipResponse';
	IsBlocking = false;
	Tip: TipDTO;
	constructor(_params: {
		tip: TipDTO
	}) {
		super({});
		this.Tip = _params.tip;
	}
}

export class GetTimeFramesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTimeFramesRequest';
	IsBlocking = false;
	TimeFrameGroupId: number;
	constructor(_params: {
		timeFrameGroupId: number
	}) {
		super({});
		this.TimeFrameGroupId = _params.timeFrameGroupId;
	}
}

export class GetTimeFramesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTimeFramesResponse';
	IsBlocking = false;
	TimeFrames: TimeFrameDTO[];
	constructor(_params: {
		timeFrames: TimeFrameDTO[]
	}) {
		super({});
		this.TimeFrames = _params.timeFrames;
	}
}

export class GetTipsByUserReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTipsByUserReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetTipsByUserReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTipsByUserReportResponse';
	IsBlocking = false;
	Report: TipsByUserReportDTO;
	constructor(_params: {
		report: TipsByUserReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetTotalBalanceReportPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTotalBalanceReportPreviewRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetTotalBalanceReportPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTotalBalanceReportPreviewResponse';
	IsBlocking = false;
	Preview: PrintPreviewDTO;
	constructor(_params: {
		preview: PrintPreviewDTO
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetTrainingSessionReportPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTrainingSessionReportPreviewRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetTrainingSessionReportPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTrainingSessionReportPreviewResponse';
	IsBlocking = false;
	Preview: string;
	constructor(_params: {
		preview: string
	}) {
		super({});
		this.Preview = _params.preview;
	}
}

export class GetTrainingSessionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTrainingSessionsRequest';
	IsBlocking = false;
	FromCloseDate: Date;
	PosGroupIds: number[];
	ToCloseDate: Date;
	constructor(_params: {
		fromCloseDate: Date,
		toCloseDate: Date,
		posGroupIds: number[]
	}) {
		super({});
		this.FromCloseDate = _params.fromCloseDate;
		this.ToCloseDate = _params.toCloseDate;
		this.PosGroupIds = _params.posGroupIds;
	}
}

export class GetTrainingSessionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetTrainingSessionsResponse';
	IsBlocking = false;
	Sessions: TrainingSessionDTO[];
	constructor(_params: {
		sessions: TrainingSessionDTO[]
	}) {
		super({});
		this.Sessions = _params.sessions;
	}
}

export class GetTrainingSessionWebPrintResultRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetTrainingSessionWebPrintResultRequest';
	IsBlocking = false;
	SummaryId: number;
	constructor(_params: {
		summaryId: number
	}) {
		super({});
		this.SummaryId = _params.summaryId;
	}
}

export class GetTrainingSessionWebPrintResultResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.GetTrainingSessionWebPrintResultResponse';
	IsBlocking = false;
	Result: WebPrintResultDTO;
	constructor(_params: {
		result: WebPrintResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetTrainingSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetTrainingSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetTrainingSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetTrainingSettingsResponse';
	IsBlocking = false;
	Settings: TrainingSettingsDTO;
	constructor(_params: {
		settings: TrainingSettingsDTO
	}) {
		super({});
		this.Settings = _params.settings;
	}
}

export class GetUndeliveredPurchaseOrdersByIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetUndeliveredPurchaseOrdersByIncomingDeliveryNoteRequest';
	IsBlocking = false;
	Note: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		note: IncomingDeliveryNoteForEditionDTO
	}) {
		super({});
		this.Note = _params.note;
	}
}

export class GetUndeliveredPurchaseOrdersByIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetUndeliveredPurchaseOrdersByIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Orders: PurchaseOrderForDeliveryDTO[];
	constructor(_params: {
		orders: PurchaseOrderForDeliveryDTO[]
	}) {
		super({});
		this.Orders = _params.orders;
	}
}

export class GetUnitsForSystemRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetUnitsForSystemRequest';
	IsBlocking = false;
	SomId: number;
	constructor(_params: {
		somId: number
	}) {
		super({});
		this.SomId = _params.somId;
	}
}

export class GetUnitsForSystemResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetUnitsForSystemResponse';
	IsBlocking = false;
	Units: UnitOfMeasurementDTO[];
	constructor(_params: {
		units: UnitOfMeasurementDTO[]
	}) {
		super({});
		this.Units = _params.units;
	}
}

export class GetUnpaidScaleSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUnpaidScaleSalesReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetUnpaidScaleSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUnpaidScaleSalesReportResponse';
	IsBlocking = false;
	Report: UnpaidScaleSalesReportDTO;
	constructor(_params: {
		report: UnpaidScaleSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetUpdatedProductPricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetUpdatedProductPricesRequest';
	IsBlocking = false;
	From: Date;
	PriceListId: number;
	constructor(_params: {
		from: Date,
		priceListId: number
	}) {
		super({});
		this.From = _params.from;
		this.PriceListId = _params.priceListId;
	}
}

export class GetUpdatedProductPricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetUpdatedProductPricesResponse';
	IsBlocking = false;
	Products: UpdatedProductPriceDTO[];
	constructor(_params: {
		products: UpdatedProductPriceDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class GetUserByCardNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetUserByCardNumberRequest';
	IsBlocking = false;
	CardNumber: string;
	constructor(_params: {
		cardNumber: string
	}) {
		super({});
		this.CardNumber = _params.cardNumber;
	}
}

export class GetUserByCardNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetUserByCardNumberResponse';
	IsBlocking = false;
	User: AvailableUserDTO;
	constructor(_params: {
		user: AvailableUserDTO
	}) {
		super({});
		this.User = _params.user;
	}
}

export class GetUserLoginsReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUserLoginsReportRequest';
	IsBlocking = true;
	From: Date;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
	}
}

export class GetUserLoginsReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUserLoginsReportResponse';
	IsBlocking = false;
	Report: UserLoginsReportDTO;
	constructor(_params: {
		report: UserLoginsReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetUserSalesByTimeFrameReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUserSalesByTimeFrameReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	TimeFrameGroupId: number;
	TimeFrameName: string;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		timeFrameName: string,
		timeFrameGroupId: number
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.TimeFrameName = _params.timeFrameName;
		this.TimeFrameGroupId = _params.timeFrameGroupId;
	}
}

export class GetUserSalesByTimeFrameReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUserSalesByTimeFrameReportResponse';
	IsBlocking = false;
	Report: UserSalesByTimeFrameReportDTO;
	constructor(_params: {
		report: UserSalesByTimeFrameReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetUserSalesFileReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUserSalesFileReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class GetUserSalesFileReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetUserSalesFileReportResponse';
	IsBlocking = false;
	Report: UserSalesReportDTO;
	constructor(_params: {
		report: UserSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetUsersByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetUsersByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetUsersFingerprintsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetUsersFingerprintsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetUsersFingerprintsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetUsersFingerprintsResponse';
	IsBlocking = false;
	Users: UserFingerprintDTO[];
	constructor(_params: {
		users: UserFingerprintDTO[]
	}) {
		super({});
		this.Users = _params.users;
	}
}

export class GetUsersWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetUsersWidgetRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetUsersWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetUsersWidgetResponse';
	IsBlocking = false;
	Users: UserWidgetDTO[];
	constructor(_params: {
		users: UserWidgetDTO[]
	}) {
		super({});
		this.Users = _params.users;
	}
}

export class GetVatsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetVatsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetVatsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.GetVatsResponse';
	IsBlocking = false;
	Vats: VatDTO[];
	constructor(_params: {
		vats: VatDTO[]
	}) {
		super({});
		this.Vats = _params.vats;
	}
}

export class GetVerifactuIssuesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetVerifactuIssuesRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetVerifactuIssuesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetVerifactuIssuesResponse';
	IsBlocking = false;
	HasVerifactuInvoiceIssues: boolean;
	constructor(_params: {
		hasVerifactuInvoiceIssues: boolean
	}) {
		super({});
		this.HasVerifactuInvoiceIssues = _params.hasVerifactuInvoiceIssues;
	}
}

export class GetVerifactuXmlRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetVerifactuXmlRequest';
	IsBlocking = false;
	InvoiceIds: number[];
	constructor(_params: {
		invoiceIds: number[]
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
	}
}

export class GetVerifactuXmlResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Verifactu.Messages.GetVerifactuXmlResponse';
	IsBlocking = false;
	Xmls: string[];
	constructor(_params: {
		xmls: string[]
	}) {
		super({});
		this.Xmls = _params.xmls;
	}
}

export class GetWarehousesByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetWarehousesByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetWarehousesStockValuesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWarehousesStockValuesWidgetRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetWarehousesStockValuesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWarehousesStockValuesWidgetResponse';
	IsBlocking = false;
	Values: WarehouseStockValueWidgetDTO[];
	constructor(_params: {
		values: WarehouseStockValueWidgetDTO[]
	}) {
		super({});
		this.Values = _params.values;
	}
}

export class GetWarehouseStockValueWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWarehouseStockValueWidgetRequest';
	IsBlocking = false;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
	}
}

export class GetWarehouseStockValueWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWarehouseStockValueWidgetResponse';
	IsBlocking = false;
	Details: WarehouseStockValueDetailsWidgetDTO;
	constructor(_params: {
		details: WarehouseStockValueDetailsWidgetDTO
	}) {
		super({});
		this.Details = _params.details;
	}
}

export class GetWebAdminDefaultsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetWebAdminDefaultsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetWebAdminDefaultsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.GetWebAdminDefaultsResponse';
	IsBlocking = false;
	IncludePricesInProductList: boolean;
	InventoryCountsCategoryTags: string[];
	LanguageCode: string;
	LogoImageData: string;
	MaxProductsInProductList: number;
	MenusCategoryTags: string[];
	PredefinedNotesCategoryTags: string[];
	PurchaseOrderCategoryTags: string[];
	ReportsCategoryTags: string[];
	RestocksCategoryTags: string[];
	StockTransfersCategoryTags: string[];
	constructor(_params: {
		languageCode: string,
		logoImageData: string,
		restocksCategoryTags: string[],
		predefinedNotesCategoryTags: string[],
		menusCategoryTags: string[],
		reportsCategoryTags: string[],
		inventoryCountsCategoryTags: string[],
		purchaseOrderCategoryTags: string[],
		stockTransfersCategoryTags: string[],
		includePricesInProductList: boolean,
		maxProductsInProductList: number
	}) {
		super({});
		this.LanguageCode = _params.languageCode;
		this.LogoImageData = _params.logoImageData;
		this.RestocksCategoryTags = _params.restocksCategoryTags;
		this.PredefinedNotesCategoryTags = _params.predefinedNotesCategoryTags;
		this.MenusCategoryTags = _params.menusCategoryTags;
		this.ReportsCategoryTags = _params.reportsCategoryTags;
		this.InventoryCountsCategoryTags = _params.inventoryCountsCategoryTags;
		this.PurchaseOrderCategoryTags = _params.purchaseOrderCategoryTags;
		this.StockTransfersCategoryTags = _params.stockTransfersCategoryTags;
		this.IncludePricesInProductList = _params.includePricesInProductList;
		this.MaxProductsInProductList = _params.maxProductsInProductList;
	}
}

export class GetWorkedHoursByUserReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkedHoursByUserReportRequest';
	IsBlocking = false;
	From: Date;
	To: Date;
	UserIds: number[];
	WorkplaceIds: number[];
	constructor(_params: {
		from: Date,
		to: Date,
		workplaceIds: number[],
		userIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.WorkplaceIds = _params.workplaceIds;
		this.UserIds = _params.userIds;
	}
}

export class GetWorkedHoursByUserReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkedHoursByUserReportResponse';
	IsBlocking = false;
	Result: CustomQueryResultDTO;
	constructor(_params: {
		result: CustomQueryResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class GetWorkingPeriodStatusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.GetWorkingPeriodStatusRequest';
	IsBlocking = false;
	UserId: number;
	constructor(_params: {
		userId: number
	}) {
		super({});
		this.UserId = _params.userId;
	}
}

export class GetWorkingPeriodStatusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.GetWorkingPeriodStatusResponse';
	IsBlocking = false;
	WorkingPeriodStatus: WorkingPeriodStatusDTO;
	constructor(_params: {
		workingPeriodStatus: WorkingPeriodStatusDTO
	}) {
		super({});
		this.WorkingPeriodStatus = _params.workingPeriodStatus;
	}
}

export class GetWorkplaceAvgTableCompanionsTicketAmountHeatMapRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceAvgTableCompanionsTicketAmountHeatMapRequest';
	IsBlocking = false;
	From: Date;
	IncludeHalfHours: boolean;
	To: Date;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>,
		from: Date,
		to: Date,
		includeHalfHours: boolean
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
		this.From = _params.from;
		this.To = _params.to;
		this.IncludeHalfHours = _params.includeHalfHours;
	}
}

export class GetWorkplaceAvgTableCompanionsTicketAmountHeatMapResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceAvgTableCompanionsTicketAmountHeatMapResponse';
	IsBlocking = false;
	HeatMap: HeatMapDTO;
	constructor(_params: {
		heatMap: HeatMapDTO
	}) {
		super({});
		this.HeatMap = _params.heatMap;
	}
}

export class GetWorkplaceAvgTicketAmountHeatMapRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceAvgTicketAmountHeatMapRequest';
	IsBlocking = false;
	From: Date;
	IncludeHalfHours: boolean;
	To: Date;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>,
		from: Date,
		to: Date,
		includeHalfHours: boolean
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
		this.From = _params.from;
		this.To = _params.to;
		this.IncludeHalfHours = _params.includeHalfHours;
	}
}

export class GetWorkplaceAvgTicketAmountHeatMapResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceAvgTicketAmountHeatMapResponse';
	IsBlocking = false;
	HeatMap: HeatMapDTO;
	constructor(_params: {
		heatMap: HeatMapDTO
	}) {
		super({});
		this.HeatMap = _params.heatMap;
	}
}

export class GetWorkplaceAvgTicketDurationHeatMapRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceAvgTicketDurationHeatMapRequest';
	IsBlocking = false;
	From: Date;
	IncludeHalfHours: boolean;
	To: Date;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>,
		from: Date,
		to: Date,
		includeHalfHours: boolean
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
		this.From = _params.from;
		this.To = _params.to;
		this.IncludeHalfHours = _params.includeHalfHours;
	}
}

export class GetWorkplaceAvgTicketDurationHeatMapResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceAvgTicketDurationHeatMapResponse';
	IsBlocking = false;
	HeatMap: HeatMapDTO;
	constructor(_params: {
		heatMap: HeatMapDTO
	}) {
		super({});
		this.HeatMap = _params.heatMap;
	}
}

export class GetWorkplaceDataSummaryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetWorkplaceDataSummaryRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceDataSummaryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.GetWorkplaceDataSummaryResponse';
	IsBlocking = false;
	Summary: EntitySummaryDTO[];
	constructor(_params: {
		summary: EntitySummaryDTO[]
	}) {
		super({});
		this.Summary = _params.summary;
	}
}

export class GetWorkplaceMonthMajorGroupSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceMonthMajorGroupSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceMonthMajorGroupSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceMonthMajorGroupSalesWidgetResponse';
	IsBlocking = false;
	Sales: MajorGroupSalesWidgetDTO[];
	constructor(_params: {
		sales: MajorGroupSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceMonthPaymentSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceMonthPaymentSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceMonthPaymentSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceMonthPaymentSalesWidgetResponse';
	IsBlocking = false;
	Sales: PaymentSalesWidgetDTO[];
	constructor(_params: {
		sales: PaymentSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceMonthSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceMonthSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceMonthSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceMonthSalesWidgetResponse';
	IsBlocking = false;
	Sales: PeriodSalesWidgetDTO;
	constructor(_params: {
		sales: PeriodSalesWidgetDTO
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceOccupancyWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceOccupancyWidgetRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceOccupancyWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceOccupancyWidgetResponse';
	IsBlocking = false;
	Occupancy: WorkplaceOccupancyWidgetDTO;
	constructor(_params: {
		occupancy: WorkplaceOccupancyWidgetDTO
	}) {
		super({});
		this.Occupancy = _params.occupancy;
	}
}

export class GetWorkplaceOccupancyWidgetsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceOccupancyWidgetsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetWorkplaceOccupancyWidgetsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceOccupancyWidgetsResponse';
	IsBlocking = false;
	Occupancies: WorkplaceOccupancyWidgetDTO[];
	constructor(_params: {
		occupancies: WorkplaceOccupancyWidgetDTO[]
	}) {
		super({});
		this.Occupancies = _params.occupancies;
	}
}

export class GetWorkplaceSalesHeatMapRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesHeatMapRequest';
	IsBlocking = false;
	From: Date;
	IncludeHalfHours: boolean;
	To: Date;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>,
		from: Date,
		to: Date,
		includeHalfHours: boolean
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
		this.From = _params.from;
		this.To = _params.to;
		this.IncludeHalfHours = _params.includeHalfHours;
	}
}

export class GetWorkplaceSalesHeatMapResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesHeatMapResponse';
	IsBlocking = false;
	HeatMap: HeatMapDTO;
	constructor(_params: {
		heatMap: HeatMapDTO
	}) {
		super({});
		this.HeatMap = _params.heatMap;
	}
}

export class GetWorkplaceSalesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesReportRequest';
	IsBlocking = true;
	From: Date;
	IncludeSalesByBusinessDay: boolean;
	PosGroupsIds: number[];
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		posGroupsIds: number[],
		includeSalesByBusinessDay: boolean
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PosGroupsIds = _params.posGroupsIds;
		this.IncludeSalesByBusinessDay = _params.includeSalesByBusinessDay;
	}
}

export class GetWorkplaceSalesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesReportResponse';
	IsBlocking = false;
	Report: WorkplaceSalesReportDTO;
	constructor(_params: {
		report: WorkplaceSalesReportDTO
	}) {
		super({});
		this.Report = _params.report;
	}
}

export class GetWorkplaceSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesWidgetResponse';
	IsBlocking = false;
	Sales: WorkplaceSalesWidgetDTO;
	constructor(_params: {
		sales: WorkplaceSalesWidgetDTO
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceSalesWidgetsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesWidgetsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetWorkplaceSalesWidgetsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceSalesWidgetsResponse';
	IsBlocking = false;
	Sales: WorkplaceSalesWidgetDTO[];
	constructor(_params: {
		sales: WorkplaceSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplacesByUserRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetWorkplacesByUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetWorkplaceTableCompanionsHeatMapRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTableCompanionsHeatMapRequest';
	IsBlocking = false;
	From: Date;
	IncludeHalfHours: boolean;
	To: Date;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>,
		from: Date,
		to: Date,
		includeHalfHours: boolean
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
		this.From = _params.from;
		this.To = _params.to;
		this.IncludeHalfHours = _params.includeHalfHours;
	}
}

export class GetWorkplaceTableCompanionsHeatMapResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTableCompanionsHeatMapResponse';
	IsBlocking = false;
	HeatMap: HeatMapDTO;
	constructor(_params: {
		heatMap: HeatMapDTO
	}) {
		super({});
		this.HeatMap = _params.heatMap;
	}
}

export class GetWorkplaceTicketsHeatMapRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTicketsHeatMapRequest';
	IsBlocking = false;
	From: Date;
	IncludeHalfHours: boolean;
	To: Date;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>,
		from: Date,
		to: Date,
		includeHalfHours: boolean
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
		this.From = _params.from;
		this.To = _params.to;
		this.IncludeHalfHours = _params.includeHalfHours;
	}
}

export class GetWorkplaceTicketsHeatMapResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTicketsHeatMapResponse';
	IsBlocking = false;
	HeatMap: HeatMapDTO;
	constructor(_params: {
		heatMap: HeatMapDTO
	}) {
		super({});
		this.HeatMap = _params.heatMap;
	}
}

export class GetWorkplaceTicketsWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTicketsWidgetRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceTicketsWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTicketsWidgetResponse';
	IsBlocking = false;
	Tickets: WorkplaceTicketsWidgetDTO;
	constructor(_params: {
		tickets: WorkplaceTicketsWidgetDTO
	}) {
		super({});
		this.Tickets = _params.tickets;
	}
}

export class GetWorkplaceTicketsWidgetsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTicketsWidgetsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetWorkplaceTicketsWidgetsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTicketsWidgetsResponse';
	IsBlocking = false;
	Tickets: WorkplaceTicketsWidgetDTO[];
	constructor(_params: {
		tickets: WorkplaceTicketsWidgetDTO[]
	}) {
		super({});
		this.Tickets = _params.tickets;
	}
}

export class GetWorkplaceTodayMajorGroupSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTodayMajorGroupSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceTodayMajorGroupSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTodayMajorGroupSalesWidgetResponse';
	IsBlocking = false;
	Sales: MajorGroupSalesWidgetDTO[];
	constructor(_params: {
		sales: MajorGroupSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceTodayPaymentSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTodayPaymentSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceTodayPaymentSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTodayPaymentSalesWidgetResponse';
	IsBlocking = false;
	Sales: PaymentSalesWidgetDTO[];
	constructor(_params: {
		sales: PaymentSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceTodaySalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTodaySalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceTodaySalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceTodaySalesWidgetResponse';
	IsBlocking = false;
	Sales: PeriodSalesWidgetDTO;
	constructor(_params: {
		sales: PeriodSalesWidgetDTO
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceWeekMajorGroupSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceWeekMajorGroupSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceWeekMajorGroupSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceWeekMajorGroupSalesWidgetResponse';
	IsBlocking = false;
	Sales: MajorGroupSalesWidgetDTO[];
	constructor(_params: {
		sales: MajorGroupSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceWeekPaymentSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceWeekPaymentSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceWeekPaymentSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceWeekPaymentSalesWidgetResponse';
	IsBlocking = false;
	Sales: PaymentSalesWidgetDTO[];
	constructor(_params: {
		sales: PaymentSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceWeekSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceWeekSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceWeekSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceWeekSalesWidgetResponse';
	IsBlocking = false;
	Sales: PeriodSalesWidgetDTO;
	constructor(_params: {
		sales: PeriodSalesWidgetDTO
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceYearMajorGroupSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceYearMajorGroupSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceYearMajorGroupSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceYearMajorGroupSalesWidgetResponse';
	IsBlocking = false;
	Sales: MajorGroupSalesWidgetDTO[];
	constructor(_params: {
		sales: MajorGroupSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceYearPaymentSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceYearPaymentSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceYearPaymentSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceYearPaymentSalesWidgetResponse';
	IsBlocking = false;
	Sales: PaymentSalesWidgetDTO[];
	constructor(_params: {
		sales: PaymentSalesWidgetDTO[]
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GetWorkplaceYearSalesWidgetRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceYearSalesWidgetRequest';
	IsBlocking = false;
	WorkplaceId: Nullable<number>;
	constructor(_params: {
		workplaceId: Nullable<number>
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class GetWorkplaceYearSalesWidgetResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.GetWorkplaceYearSalesWidgetResponse';
	IsBlocking = false;
	Sales: PeriodSalesWidgetDTO;
	constructor(_params: {
		sales: PeriodSalesWidgetDTO
	}) {
		super({});
		this.Sales = _params.sales;
	}
}

export class GrantClientLicensesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Licensing.Messages.GrantClientLicensesRequest';
	IsBlocking = false;
	MachineId: string;
	constructor(_params: {
		machineId: string
	}) {
		super({});
		this.MachineId = _params.machineId;
	}
}

export class GrantClientLicensesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Licensing.Messages.GrantClientLicensesResponse';
	IsBlocking = false;
	Licenses: GrantedLicenseDTO[];
	constructor(_params: {
		licenses: GrantedLicenseDTO[]
	}) {
		super({});
		this.Licenses = _params.licenses;
	}
}

export class HasAlreadyBeenRefundedRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.HasAlreadyBeenRefundedRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class HasAlreadyBeenRefundedResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.HasAlreadyBeenRefundedResponse';
	IsBlocking = false;
	HasBeenRefunded: boolean;
	constructor(_params: {
		hasBeenRefunded: boolean
	}) {
		super({});
		this.HasBeenRefunded = _params.hasBeenRefunded;
	}
}

export class ImportDataFromExcelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Distributor.ImportDataFromExcelRequest';
	IsBlocking = true;
	ExcelContent: string;
	constructor(_params: {
		excelContent: string
	}) {
		super({});
		this.ExcelContent = _params.excelContent;
	}
}

export class ImportDataFromExcelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Distributor.ImportDataFromExcelResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Success: boolean;
	constructor(_params: {
		success: boolean,
		errorMessage: string
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class ImportDigitalMenuResourcesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ImportDigitalMenuResourcesRequest';
	IsBlocking = false;
	ExcelContent: string;
	Items: DigitalMenuResourceItemForEditionDTO[];
	Languages: LanguageDTO[];
	ReferenceLanguageCode: string;
	constructor(_params: {
		excelContent: string,
		referenceLanguageCode: string,
		languages: LanguageDTO[],
		items: DigitalMenuResourceItemForEditionDTO[]
	}) {
		super({});
		this.ExcelContent = _params.excelContent;
		this.ReferenceLanguageCode = _params.referenceLanguageCode;
		this.Languages = _params.languages;
		this.Items = _params.items;
	}
}

export class ImportDigitalMenuResourcesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ImportDigitalMenuResourcesResponse';
	IsBlocking = false;
	Data: DigitalMenuResourcesForEditionDTO;
	ErrorMessage: string;
	constructor(_params: {
		errorMessage: string,
		data: DigitalMenuResourcesForEditionDTO
	}) {
		super({});
		this.ErrorMessage = _params.errorMessage;
		this.Data = _params.data;
	}
}

export class ImportIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportIncomingDeliveryNoteRequest';
	IsBlocking = true;
	FileContent: string;
	Format: ProductExportFormat;
	SupplierId: number;
	constructor(_params: {
		format: ProductExportFormat,
		fileContent: string,
		supplierId: number
	}) {
		super({});
		this.Format = _params.format;
		this.FileContent = _params.fileContent;
		this.SupplierId = _params.supplierId;
	}
}

export class ImportIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Lines: IncomingDeliveryNoteLineForEditionDTO[];
	constructor(_params: {
		lines: IncomingDeliveryNoteLineForEditionDTO[]
	}) {
		super({});
		this.Lines = _params.lines;
	}
}

export class ImportInventoryCountFromRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportInventoryCountFromRequest';
	IsBlocking = false;
	FileContent: string;
	Format: ProductExportFormat;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		format: ProductExportFormat,
		fileContent: string
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.Format = _params.format;
		this.FileContent = _params.fileContent;
	}
}

export class ImportInventoryCountFromResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportInventoryCountFromResponse';
	IsBlocking = false;
	Lines: InventoryCountLineDTO[];
	constructor(_params: {
		lines: InventoryCountLineDTO[]
	}) {
		super({});
		this.Lines = _params.lines;
	}
}

export class ImportPricesFromExcelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ImportPricesFromExcelRequest';
	IsBlocking = false;
	Data: string;
	constructor(_params: {
		data: string
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ImportPricesFromExcelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ImportPricesFromExcelResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ImportPurchaseOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportPurchaseOrderRequest';
	IsBlocking = true;
	FileContent: string;
	Format: ProductExportFormat;
	SupplierId: number;
	constructor(_params: {
		format: ProductExportFormat,
		fileContent: string,
		supplierId: number
	}) {
		super({});
		this.Format = _params.format;
		this.FileContent = _params.fileContent;
		this.SupplierId = _params.supplierId;
	}
}

export class ImportPurchaseOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportPurchaseOrderResponse';
	IsBlocking = false;
	Lines: PurchaseOrderLineForEditionDTO[];
	constructor(_params: {
		lines: PurchaseOrderLineForEditionDTO[]
	}) {
		super({});
		this.Lines = _params.lines;
	}
}

export class ImportStockChangeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportStockChangeRequest';
	IsBlocking = true;
	FileContent: string;
	Format: ProductExportFormat;
	WarehouseId: number;
	constructor(_params: {
		format: ProductExportFormat,
		fileContent: string,
		warehouseId: number
	}) {
		super({});
		this.Format = _params.format;
		this.FileContent = _params.fileContent;
		this.WarehouseId = _params.warehouseId;
	}
}

export class ImportStockChangeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ImportStockChangeResponse';
	IsBlocking = false;
	Lines: StockChangeLineForEditionDTO[];
	constructor(_params: {
		lines: StockChangeLineForEditionDTO[]
	}) {
		super({});
		this.Lines = _params.lines;
	}
}

export class InviteTicketLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.InviteTicketLineRequest';
	IsBlocking = false;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
	}
}

export class InviteTicketLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.InviteTicketLineResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class IsThereTrainingActivityRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.IsThereTrainingActivityRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class IsThereTrainingActivityResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.IsThereTrainingActivityResponse';
	IsBlocking = false;
	IsThereTrainingActivity: boolean;
	constructor(_params: {
		isThereTrainingActivity: boolean
	}) {
		super({});
		this.IsThereTrainingActivity = _params.isThereTrainingActivity;
	}
}

export class LoginRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.LoginRequest';
	IsBlocking = false;
	DefaultLanguageCode: string;
	NotificationToken: string;
	RememberMe: boolean;
	RestorePreviousSession: boolean;
	UserName: string;
	UserPassword: string;
	constructor(_params: {
		userName: string,
		userPassword: string,
		defaultLanguageCode: string,
		restorePreviousSession: boolean,
		rememberMe: boolean,
		notificationToken: string
	}) {
		super({});
		this.UserName = _params.userName;
		this.UserPassword = _params.userPassword;
		this.DefaultLanguageCode = _params.defaultLanguageCode;
		this.RestorePreviousSession = _params.restorePreviousSession;
		this.RememberMe = _params.rememberMe;
		this.NotificationToken = _params.notificationToken;
	}
}

export class LoginResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.LoginResponse';
	IsBlocking = false;
	ErrorMessage: string;
	Session: SessionDTO;
	Success: boolean;
	constructor(_params: {
		session: SessionDTO,
		success: boolean,
		errorMessage: string
	}) {
		super({});
		this.Session = _params.session;
		this.Success = _params.success;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class LogoutRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.LogoutRequest';
	IsBlocking = false;
	NotificationToken: string;
	constructor(_params: {
		notificationToken: string
	}) {
		super({});
		this.NotificationToken = _params.notificationToken;
	}
}

export class LogoutResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.LogoutResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class MarkAsDefaultReportViewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.MarkAsDefaultReportViewRequest';
	IsBlocking = false;
	Name: string;
	ReportId: string;
	constructor(_params: {
		reportId: string,
		name: string
	}) {
		super({});
		this.ReportId = _params.reportId;
		this.Name = _params.name;
	}
}

export class MarkAsDefaultReportViewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.MarkAsDefaultReportViewResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class MarkDeliveryNoteAsPrintedRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.MarkDeliveryNoteAsPrintedRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class MarkDeliveryNoteAsPrintedResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.MarkDeliveryNoteAsPrintedResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class MarkInvoiceAsPrintedRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.MarkInvoiceAsPrintedRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class MarkInvoiceAsPrintedResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.MarkInvoiceAsPrintedResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class MarkOrderAsPreparedRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MarkOrderAsPreparedRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class MarkOrderAsPreparedResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MarkOrderAsPreparedResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class MarkSalesOrderAsDeliveredRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MarkSalesOrderAsDeliveredRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class MarkSalesOrderAsDeliveredResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MarkSalesOrderAsDeliveredResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class MarkSalesOrderAsPrintedRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.MarkSalesOrderAsPrintedRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class MarkSalesOrderAsPrintedResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.MarkSalesOrderAsPrintedResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class MergePurchaseOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MergePurchaseOrderRequest';
	IsBlocking = true;
	DeliveryDate: Nullable<Date>;
	OrderDate: Date;
	OrderIdsToMerge: number[];
	SupplierDocumentNumber: string;
	constructor(_params: {
		orderDate: Date,
		deliveryDate: Nullable<Date>,
		supplierDocumentNumber: string,
		orderIdsToMerge: number[]
	}) {
		super({});
		this.OrderDate = _params.orderDate;
		this.DeliveryDate = _params.deliveryDate;
		this.SupplierDocumentNumber = _params.supplierDocumentNumber;
		this.OrderIdsToMerge = _params.orderIdsToMerge;
	}
}

export class MergePurchaseOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MergePurchaseOrderResponse';
	IsBlocking = false;
	NewOrderId: number;
	constructor(_params: {
		newOrderId: number
	}) {
		super({});
		this.NewOrderId = _params.newOrderId;
	}
}

export class MoveOnePartToRightTicketDivisionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOnePartToRightTicketDivisionRequest';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	Line: TicketLineDTO;
	NumberOfParts: number;
	constructor(_params: {
		division: TicketDivisionDTO,
		line: TicketLineDTO,
		numberOfParts: number
	}) {
		super({});
		this.Division = _params.division;
		this.Line = _params.line;
		this.NumberOfParts = _params.numberOfParts;
	}
}

export class MoveOnePartToRightTicketDivisionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOnePartToRightTicketDivisionResponse';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class MoveOneTableCompanionToLeftTicketDivisionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneTableCompanionToLeftTicketDivisionRequest';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class MoveOneTableCompanionToLeftTicketDivisionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneTableCompanionToLeftTicketDivisionResponse';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class MoveOneTableCompanionToRightTicketDivisionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneTableCompanionToRightTicketDivisionRequest';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class MoveOneTableCompanionToRightTicketDivisionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneTableCompanionToRightTicketDivisionResponse';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class MoveOneToLeftTicketDivisionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneToLeftTicketDivisionRequest';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	Line: TicketLineDTO;
	constructor(_params: {
		division: TicketDivisionDTO,
		line: TicketLineDTO
	}) {
		super({});
		this.Division = _params.division;
		this.Line = _params.line;
	}
}

export class MoveOneToLeftTicketDivisionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneToLeftTicketDivisionResponse';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class MoveOneToRightTicketDivisionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneToRightTicketDivisionRequest';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	Line: TicketLineDTO;
	constructor(_params: {
		division: TicketDivisionDTO,
		line: TicketLineDTO
	}) {
		super({});
		this.Division = _params.division;
		this.Line = _params.line;
	}
}

export class MoveOneToRightTicketDivisionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveOneToRightTicketDivisionResponse';
	IsBlocking = false;
	Division: TicketDivisionDTO;
	constructor(_params: {
		division: TicketDivisionDTO
	}) {
		super({});
		this.Division = _params.division;
	}
}

export class MoveTicketRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveTicketRequest';
	IsBlocking = false;
	KeepPrices: boolean;
	SourceTicketId: number;
	TargetLocation: TicketLocationDTO;
	TargetTicketId: Nullable<number>;
	constructor(_params: {
		sourceTicketId: number,
		targetLocation: TicketLocationDTO,
		keepPrices: boolean,
		targetTicketId: Nullable<number>
	}) {
		super({});
		this.SourceTicketId = _params.sourceTicketId;
		this.TargetLocation = _params.targetLocation;
		this.KeepPrices = _params.keepPrices;
		this.TargetTicketId = _params.targetTicketId;
	}
}

export class MoveTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.MoveTicketResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class MustWarnDuplicatedIncomingDeliveryNoteNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MustWarnDuplicatedIncomingDeliveryNoteNumberRequest';
	IsBlocking = false;
	SupplierDocumentNumber: string;
	SupplierId: number;
	constructor(_params: {
		supplierId: number,
		supplierDocumentNumber: string
	}) {
		super({});
		this.SupplierId = _params.supplierId;
		this.SupplierDocumentNumber = _params.supplierDocumentNumber;
	}
}

export class MustWarnDuplicatedIncomingDeliveryNoteNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MustWarnDuplicatedIncomingDeliveryNoteNumberResponse';
	IsBlocking = false;
	DocumentNumberExists: boolean;
	constructor(_params: {
		documentNumberExists: boolean
	}) {
		super({});
		this.DocumentNumberExists = _params.documentNumberExists;
	}
}

export class MustWarnDuplicatedPurchaseInvoiceNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MustWarnDuplicatedPurchaseInvoiceNumberRequest';
	IsBlocking = false;
	SupplierDocumentNumber: string;
	SupplierId: number;
	constructor(_params: {
		supplierId: number,
		supplierDocumentNumber: string
	}) {
		super({});
		this.SupplierId = _params.supplierId;
		this.SupplierDocumentNumber = _params.supplierDocumentNumber;
	}
}

export class MustWarnDuplicatedPurchaseInvoiceNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MustWarnDuplicatedPurchaseInvoiceNumberResponse';
	IsBlocking = false;
	DocumentNumberExists: boolean;
	constructor(_params: {
		documentNumberExists: boolean
	}) {
		super({});
		this.DocumentNumberExists = _params.documentNumberExists;
	}
}

export class MustWarnDuplicatedPurchaseOrderNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MustWarnDuplicatedPurchaseOrderNumberRequest';
	IsBlocking = false;
	SupplierDocumentNumber: string;
	SupplierId: number;
	constructor(_params: {
		supplierId: number,
		supplierDocumentNumber: string
	}) {
		super({});
		this.SupplierId = _params.supplierId;
		this.SupplierDocumentNumber = _params.supplierDocumentNumber;
	}
}

export class MustWarnDuplicatedPurchaseOrderNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.MustWarnDuplicatedPurchaseOrderNumberResponse';
	IsBlocking = false;
	DocumentNumberExists: boolean;
	constructor(_params: {
		documentNumberExists: boolean
	}) {
		super({});
		this.DocumentNumberExists = _params.documentNumberExists;
	}
}

export class OpenBusinessDayRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.OpenBusinessDayRequest';
	IsBlocking = false;
	BusinessDay: Date;
	ExpectedSystemBusinessDay: Nullable<Date>;
	InitialAmount: number;
	constructor(_params: {
		initialAmount: number,
		businessDay: Date,
		expectedSystemBusinessDay: Nullable<Date>
	}) {
		super({});
		this.InitialAmount = _params.initialAmount;
		this.BusinessDay = _params.businessDay;
		this.ExpectedSystemBusinessDay = _params.expectedSystemBusinessDay;
	}
}

export class OpenBusinessDayResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.BusinessDay.Messages.OpenBusinessDayResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class OpenCashdrawerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.OpenCashdrawerRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class OpenCashdrawerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.OpenCashdrawerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ParseBarcodeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.ParseBarcodeRequest';
	IsBlocking = false;
	Barcode: string;
	TicketId: number;
	constructor(_params: {
		barcode: string,
		ticketId: number
	}) {
		super({});
		this.Barcode = _params.barcode;
		this.TicketId = _params.ticketId;
	}
}

export class ParseBarcodeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.ParseBarcodeResponse';
	IsBlocking = false;
	Result: ParseBarcodeResultDTO;
	constructor(_params: {
		result: ParseBarcodeResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class PayPurchaseInvoicesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.PayPurchaseInvoicesRequest';
	IsBlocking = true;
	InvoiceIds: number[];
	Method: PaymentMethodInListDTO;
	constructor(_params: {
		invoiceIds: number[],
		method: PaymentMethodInListDTO
	}) {
		super({});
		this.InvoiceIds = _params.invoiceIds;
		this.Method = _params.method;
	}
}

export class PayPurchaseInvoicesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.PayPurchaseInvoicesResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrepareTicketAgainRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketAgainRequest';
	IsBlocking = false;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[]
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
	}
}

export class PrepareTicketAgainResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketAgainResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrepareTicketLineAgainRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketLineAgainRequest';
	IsBlocking = false;
	LineId: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		lineId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.LineId = _params.lineId;
	}
}

export class PrepareTicketLineAgainResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketLineAgainResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrepareTicketLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketLineRequest';
	IsBlocking = false;
	LineId: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		lineId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.LineId = _params.lineId;
	}
}

export class PrepareTicketLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketLineResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrepareTicketRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketRequest';
	IsBlocking = false;
	IsAutoPrepare: boolean;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[],
		isAutoPrepare: boolean
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
		this.IsAutoPrepare = _params.isAutoPrepare;
	}
}

export class PrepareTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrepareTicketResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintCashControlStatusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintCashControlStatusRequest';
	IsBlocking = false;
	Status: CashControlStatusDTO;
	constructor(_params: {
		status: CashControlStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class PrintCashControlStatusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintCashControlStatusResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintCouponSampleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintCouponSampleRequest';
	IsBlocking = false;
	PrinterName: string;
	Template: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		template: CouponPrintTemplateForEditionDTO,
		printerName: string
	}) {
		super({});
		this.Template = _params.template;
		this.PrinterName = _params.printerName;
	}
}

export class PrintCouponSampleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintCouponSampleResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintCouponsForDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.PrintCouponsForDeliveryNoteRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class PrintCouponsForDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.PrintCouponsForDeliveryNoteResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintCouponsForInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.PrintCouponsForInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class PrintCouponsForInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.PrintCouponsForInvoiceResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintDailyFiscalSummaryReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintDailyFiscalSummaryReportRequest';
	IsBlocking = true;
	From: Date;
	PosGroupsIds: number[];
	PrintTickets: boolean;
	To: Date;
	constructor(_params: {
		from: Date,
		to: Date,
		printTickets: boolean,
		posGroupsIds: number[]
	}) {
		super({});
		this.From = _params.from;
		this.To = _params.to;
		this.PrintTickets = _params.printTickets;
		this.PosGroupsIds = _params.posGroupsIds;
	}
}

export class PrintDailyFiscalSummaryReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintDailyFiscalSummaryReportResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintDeliveryNoteOnPrinterRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintDeliveryNoteOnPrinterRequest';
	IsBlocking = false;
	ContentReplacement: string;
	DeliveryNoteId: number;
	Printer: string;
	TemplateId: number;
	constructor(_params: {
		deliveryNoteId: number,
		templateId: number,
		printer: string,
		contentReplacement: string
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
		this.TemplateId = _params.templateId;
		this.Printer = _params.printer;
		this.ContentReplacement = _params.contentReplacement;
	}
}

export class PrintDeliveryNoteOnPrinterResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintDeliveryNoteOnPrinterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintDeliveryNoteRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	constructor(_params: {
		deliveryNoteId: number
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
	}
}

export class PrintDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintDeliveryNoteResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintDeliveryNotesOnPrinterRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintDeliveryNotesOnPrinterRequest';
	IsBlocking = false;
	ContentReplacement: string;
	DeliveryNoteIds: number[];
	Printer: string;
	TemplateId: number;
	constructor(_params: {
		deliveryNoteIds: number[],
		templateId: number,
		printer: string,
		contentReplacement: string
	}) {
		super({});
		this.DeliveryNoteIds = _params.deliveryNoteIds;
		this.TemplateId = _params.templateId;
		this.Printer = _params.printer;
		this.ContentReplacement = _params.contentReplacement;
	}
}

export class PrintDeliveryNotesOnPrinterResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintDeliveryNotesOnPrinterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintDeliveryNotesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintDeliveryNotesReportRequest';
	IsBlocking = false;
	DeliveryNotes: DeliveryNoteInListDTO[];
	Summary: DeliveryNotesSummaryDTO;
	constructor(_params: {
		deliveryNotes: DeliveryNoteInListDTO[],
		summary: DeliveryNotesSummaryDTO
	}) {
		super({});
		this.DeliveryNotes = _params.deliveryNotes;
		this.Summary = _params.summary;
	}
}

export class PrintDeliveryNotesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintDeliveryNotesReportResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintEscPosSampleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintEscPosSampleRequest';
	IsBlocking = false;
	PrinterName: string;
	Template: EscPosTemplateForEditionDTO;
	constructor(_params: {
		printerName: string,
		template: EscPosTemplateForEditionDTO
	}) {
		super({});
		this.PrinterName = _params.printerName;
		this.Template = _params.template;
	}
}

export class PrintEscPosSampleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintEscPosSampleResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintGiftInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintGiftInvoiceRequest';
	IsBlocking = false;
	IncludeAll: boolean;
	InvoiceId: number;
	LineIdsIncluded: number[];
	constructor(_params: {
		invoiceId: number,
		includeAll: boolean,
		lineIdsIncluded: number[]
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.IncludeAll = _params.includeAll;
		this.LineIdsIncluded = _params.lineIdsIncluded;
	}
}

export class PrintGiftTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintGiftTicketResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintInvoiceOnPrinterRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintInvoiceOnPrinterRequest';
	IsBlocking = false;
	ContentReplacement: string;
	InvoiceId: number;
	Printer: string;
	TemplateId: number;
	constructor(_params: {
		invoiceId: number,
		templateId: number,
		printer: string,
		contentReplacement: string
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.TemplateId = _params.templateId;
		this.Printer = _params.printer;
		this.ContentReplacement = _params.contentReplacement;
	}
}

export class PrintInvoiceOnPrinterResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintInvoiceOnPrinterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class PrintInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintInvoiceResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintInvoicesReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintInvoicesReportRequest';
	IsBlocking = false;
	Invoices: InvoiceInListDTO[];
	Summary: InvoicesSummaryDTO;
	constructor(_params: {
		invoices: InvoiceInListDTO[],
		summary: InvoicesSummaryDTO
	}) {
		super({});
		this.Invoices = _params.invoices;
		this.Summary = _params.summary;
	}
}

export class PrintInvoicesReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintInvoicesReportResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintLabelsToCsvFormatRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintLabelsToCsvFormatRequest';
	IsBlocking = true;
	Labels: ProductLabelDTO[];
	constructor(_params: {
		labels: ProductLabelDTO[]
	}) {
		super({});
		this.Labels = _params.labels;
	}
}

export class PrintLabelsToCsvFormatResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintLabelsToCsvFormatResponse';
	IsBlocking = false;
	Format: CsvLabelsFormatDTO;
	constructor(_params: {
		format: CsvLabelsFormatDTO
	}) {
		super({});
		this.Format = _params.format;
	}
}

export class PrintMenuRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintMenuRequest';
	IsBlocking = false;
	Copies: number;
	Menu: MenuConfigurationDTO;
	PrinterName: string;
	constructor(_params: {
		menu: MenuConfigurationDTO,
		printerName: string,
		copies: number
	}) {
		super({});
		this.Menu = _params.menu;
		this.PrinterName = _params.printerName;
		this.Copies = _params.copies;
	}
}

export class PrintMenuResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintMenuResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintPartialBalanceReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintPartialBalanceReportRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintPartialBalanceReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintPartialBalanceReportResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintPosCloseOutRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintPosCloseOutRequest';
	IsBlocking = false;
	PosCloseOutId: number;
	constructor(_params: {
		posCloseOutId: number
	}) {
		super({});
		this.PosCloseOutId = _params.posCloseOutId;
	}
}

export class PrintPosCloseOutResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintPosCloseOutResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintPreparationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.PrintPreparationRequest';
	IsBlocking = false;
	DisplayId: number;
	PreparationOrderId: number;
	TicketId: number;
	constructor(_params: {
		displayId: number,
		ticketId: number,
		preparationOrderId: number
	}) {
		super({});
		this.DisplayId = _params.displayId;
		this.TicketId = _params.ticketId;
		this.PreparationOrderId = _params.preparationOrderId;
	}
}

export class PrintPreparationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.PrintPreparationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintPreparationSummaryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrintPreparationSummaryRequest';
	IsBlocking = false;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[]
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
	}
}

export class PrintPreparationSummaryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.PrintPreparationSummaryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintPurchasedOrProducedProductLabelsToCsvRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintPurchasedOrProducedProductLabelsToCsvRequest';
	IsBlocking = true;
	AlternativePriceListId: Nullable<number>;
	Labels: PurchasedOrProducedProductLabelDTO[];
	PriceListId: number;
	constructor(_params: {
		labels: PurchasedOrProducedProductLabelDTO[],
		priceListId: number,
		alternativePriceListId: Nullable<number>
	}) {
		super({});
		this.Labels = _params.labels;
		this.PriceListId = _params.priceListId;
		this.AlternativePriceListId = _params.alternativePriceListId;
	}
}

export class PrintPurchasedOrProducedProductLabelsToCsvResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintPurchasedOrProducedProductLabelsToCsvResponse';
	IsBlocking = false;
	Format: CsvLabelsFormatDTO;
	constructor(_params: {
		format: CsvLabelsFormatDTO
	}) {
		super({});
		this.Format = _params.format;
	}
}

export class PrintRdlSampleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintRdlSampleRequest';
	IsBlocking = false;
	PrinterName: string;
	Template: RdlTemplateForEditionDTO;
	constructor(_params: {
		printerName: string,
		template: RdlTemplateForEditionDTO
	}) {
		super({});
		this.PrinterName = _params.printerName;
		this.Template = _params.template;
	}
}

export class PrintRdlSampleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintRdlSampleResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintSalesOrderOnPrinterRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintSalesOrderOnPrinterRequest';
	IsBlocking = false;
	ContentReplacement: string;
	Printer: string;
	SalesOrderId: number;
	TemplateId: number;
	constructor(_params: {
		salesOrderId: number,
		templateId: number,
		printer: string,
		contentReplacement: string
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
		this.TemplateId = _params.templateId;
		this.Printer = _params.printer;
		this.ContentReplacement = _params.contentReplacement;
	}
}

export class PrintSalesOrderOnPrinterResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintSalesOrderOnPrinterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintSalesOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintSalesOrderRequest';
	IsBlocking = false;
	OrderId: number;
	constructor(_params: {
		orderId: number
	}) {
		super({});
		this.OrderId = _params.orderId;
	}
}

export class PrintSalesOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintSalesOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintSampleLabelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintSampleLabelRequest';
	IsBlocking = false;
	PrinterName: string;
	SampleLabel: SampleLabelDTO;
	constructor(_params: {
		printerName: string,
		sampleLabel: SampleLabelDTO
	}) {
		super({});
		this.PrinterName = _params.printerName;
		this.SampleLabel = _params.sampleLabel;
	}
}

export class PrintSampleLabelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintSampleLabelResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintSystemCloseOutReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintSystemCloseOutReportRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintSystemCloseOutReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintSystemCloseOutReportResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintSystemCloseOutRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintSystemCloseOutRequest';
	IsBlocking = false;
	SystemCloseOutId: number;
	constructor(_params: {
		systemCloseOutId: number
	}) {
		super({});
		this.SystemCloseOutId = _params.systemCloseOutId;
	}
}

export class PrintSystemCloseOutResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintSystemCloseOutResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintTicketRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintTicketRequest';
	IsBlocking = false;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[]
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
	}
}

export class PrintTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.PrintTicketResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintTotalBalanceReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintTotalBalanceReportRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintTotalBalanceReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintTotalBalanceReportResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintTrainingSessionReportRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintTrainingSessionReportRequest';
	IsBlocking = false;
	SummaryId: number;
	constructor(_params: {
		summaryId: number
	}) {
		super({});
		this.SummaryId = _params.summaryId;
	}
}

export class PrintTrainingSessionReportResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintTrainingSessionReportResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class PrintTrainingSessionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintTrainingSessionRequest';
	IsBlocking = false;
	SummaryId: number;
	constructor(_params: {
		summaryId: number
	}) {
		super({});
		this.SummaryId = _params.summaryId;
	}
}

export class PrintTrainingSessionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.PrintTrainingSessionResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ProcessPendingCardTransactionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ProcessPendingCardTransactionsRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class ProcessPendingCardTransactionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ProcessPendingCardTransactionsResponse';
	IsBlocking = false;
	TransactionsStatus: PendingCardTransactionsStatusDTO[];
	constructor(_params: {
		transactionsStatus: PendingCardTransactionsStatusDTO[]
	}) {
		super({});
		this.TransactionsStatus = _params.transactionsStatus;
	}
}

export class PublishDigitalMenuPreviewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.PublishDigitalMenuPreviewRequest';
	IsBlocking = true;
	Data: DigitalMenuForEditionDTO;
	constructor(_params: {
		data: DigitalMenuForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class PublishDigitalMenuPreviewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.PublishDigitalMenuPreviewResponse';
	IsBlocking = false;
	ErrorMsg: string;
	PreviewUrl: string;
	Success: boolean;
	constructor(_params: {
		success: boolean,
		errorMsg: string,
		previewUrl: string
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMsg = _params.errorMsg;
		this.PreviewUrl = _params.previewUrl;
	}
}

export class ReceiveStockChangeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ReceiveStockChangeRequest';
	IsBlocking = true;
	FixMode: StockChangeFixMode;
	Lines: StockChangeLineForEditionDTO[];
	Reason: string;
	ReceptionDate: Date;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number,
		receptionDate: Date,
		reason: string,
		fixMode: StockChangeFixMode,
		lines: StockChangeLineForEditionDTO[]
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
		this.ReceptionDate = _params.receptionDate;
		this.Reason = _params.reason;
		this.FixMode = _params.fixMode;
		this.Lines = _params.lines;
	}
}

export class ReceiveStockChangeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ReceiveStockChangeResponse';
	IsBlocking = false;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ReconnectSmartMenuPaymentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ReconnectSmartMenuPaymentRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ReconnectSmartMenuPaymentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ReconnectSmartMenuPaymentResponse';
	IsBlocking = false;
	Status: SmartMenuPaymentStatusDTO;
	constructor(_params: {
		status: SmartMenuPaymentStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class RefundInvoiceFromAdminRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RefundInvoiceFromAdminRequest';
	IsBlocking = false;
	InvoiceId: number;
	Params: InvoiceParamsFromAdminDTO;
	constructor(_params: {
		invoiceId: number,
		params: InvoiceParamsFromAdminDTO
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Params = _params.params;
	}
}

export class RefundInvoiceFromAdminResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RefundInvoiceFromAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RefundInvoiceFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RefundInvoiceFromPosRequest';
	IsBlocking = false;
	InvoiceId: number;
	Params: InvoiceParamsFromPosDTO;
	constructor(_params: {
		invoiceId: number,
		params: InvoiceParamsFromPosDTO
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Params = _params.params;
	}
}

export class RefundInvoiceFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RefundInvoiceFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class RefundTicketFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RefundTicketFromPosRequest';
	IsBlocking = false;
	IsInvoicePartialRefund: boolean;
	Params: InvoiceParamsFromPosDTO;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		isInvoicePartialRefund: boolean,
		params: InvoiceParamsFromPosDTO
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.IsInvoicePartialRefund = _params.isInvoicePartialRefund;
		this.Params = _params.params;
	}
}

export class RefundTicketFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RefundTicketFromPosResponse';
	IsBlocking = false;
	Sale: SaleDTO;
	constructor(_params: {
		sale: SaleDTO
	}) {
		super({});
		this.Sale = _params.sale;
	}
}

export class RegisterCashTransactionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.RegisterCashTransactionRequest';
	IsBlocking = false;
	Amount: number;
	Date: Nullable<Date>;
	Description: string;
	IsCashControlDiscrepancyAmount: boolean;
	PrintReceipt: boolean;
	Provider: string;
	constructor(_params: {
		provider: string,
		description: string,
		amount: number,
		printReceipt: boolean,
		isCashControlDiscrepancyAmount: boolean,
		date: Nullable<Date>
	}) {
		super({});
		this.Provider = _params.provider;
		this.Description = _params.description;
		this.Amount = _params.amount;
		this.PrintReceipt = _params.printReceipt;
		this.IsCashControlDiscrepancyAmount = _params.isCashControlDiscrepancyAmount;
		this.Date = _params.date;
	}
}

export class RegisterCashTransactionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Cashdrawer.Messages.RegisterCashTransactionResponse';
	IsBlocking = false;
	Result: RegisterCashTransactionResultDTO;
	constructor(_params: {
		result: RegisterCashTransactionResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class RegisterClockInRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.RegisterClockInRequest';
	IsBlocking = false;
	WorkingPeriodStatus: WorkingPeriodStatusDTO;
	constructor(_params: {
		workingPeriodStatus: WorkingPeriodStatusDTO
	}) {
		super({});
		this.WorkingPeriodStatus = _params.workingPeriodStatus;
	}
}

export class RegisterClockInResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.RegisterClockInResponse';
	IsBlocking = false;
	WorkingPeriodStatus: WorkingPeriodStatusDTO;
	constructor(_params: {
		workingPeriodStatus: WorkingPeriodStatusDTO
	}) {
		super({});
		this.WorkingPeriodStatus = _params.workingPeriodStatus;
	}
}

export class RegisterClockOutRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.RegisterClockOutRequest';
	IsBlocking = false;
	WorkingPeriodStatus: WorkingPeriodStatusDTO;
	constructor(_params: {
		workingPeriodStatus: WorkingPeriodStatusDTO
	}) {
		super({});
		this.WorkingPeriodStatus = _params.workingPeriodStatus;
	}
}

export class RegisterClockOutResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.RegisterClockOutResponse';
	IsBlocking = false;
	WorkingPeriodStatus: WorkingPeriodStatusDTO;
	constructor(_params: {
		workingPeriodStatus: WorkingPeriodStatusDTO
	}) {
		super({});
		this.WorkingPeriodStatus = _params.workingPeriodStatus;
	}
}

export class RegisterPendingCardTransactionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RegisterPendingCardTransactionRequest';
	IsBlocking = false;
	Amount: number;
	CardTransactionType: string;
	TicketGlobalId: Nullable<string>;
	constructor(_params: {
		ticketGlobalId: Nullable<string>,
		amount: number,
		cardTransactionType: string
	}) {
		super({});
		this.TicketGlobalId = _params.ticketGlobalId;
		this.Amount = _params.amount;
		this.CardTransactionType = _params.cardTransactionType;
	}
}

export class RegisterPendingCardTransactionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RegisterPendingCardTransactionResponse';
	IsBlocking = false;
	TransactionId: string;
	constructor(_params: {
		transactionId: string
	}) {
		super({});
		this.TransactionId = _params.transactionId;
	}
}

export class RejectSalesOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RejectSalesOrderRequest';
	IsBlocking = false;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
	}
}

export class RejectSalesOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RejectSalesOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ReleaseScaleTicketRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.ReleaseScaleTicketRequest';
	IsBlocking = false;
	Scale: string;
	ScaleTicketNumber: string;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		scale: string,
		scaleTicketNumber: string
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Scale = _params.scale;
		this.ScaleTicketNumber = _params.scaleTicketNumber;
	}
}

export class ReleaseScaleTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.ReleaseScaleTicketResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ReleaseTicketRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReleaseTicketRequest';
	IsBlocking = false;
	ReleasedByCurrentUser: boolean;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		releasedByCurrentUser: boolean
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.ReleasedByCurrentUser = _params.releasedByCurrentUser;
	}
}

export class ReleaseTicketResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReleaseTicketResponse';
	IsBlocking = false;
	HasBeenDeletedOrCancelled: boolean;
	constructor(_params: {
		hasBeenDeletedOrCancelled: boolean
	}) {
		super({});
		this.HasBeenDeletedOrCancelled = _params.hasBeenDeletedOrCancelled;
	}
}

export class RemoveAdminBookmarkRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.WebAdmin.Messages.RemoveAdminBookmarkRequest';
	IsBlocking = false;
	Bookmark: string;
	constructor(_params: {
		bookmark: string
	}) {
		super({});
		this.Bookmark = _params.bookmark;
	}
}

export class RemoveAdminBookmarkResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.WebAdmin.Messages.RemoveAdminBookmarkResponse';
	IsBlocking = false;
	Bookmarks: string[];
	constructor(_params: {
		bookmarks: string[]
	}) {
		super({});
		this.Bookmarks = _params.bookmarks;
	}
}

export class RemoveDeliveryAddressRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.RemoveDeliveryAddressRequest';
	IsBlocking = false;
	Address: AddressDTO;
	CustomerId: number;
	constructor(_params: {
		customerId: number,
		address: AddressDTO
	}) {
		super({});
		this.CustomerId = _params.customerId;
		this.Address = _params.address;
	}
}

export class RemoveDeliveryAddressResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.RemoveDeliveryAddressResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RemoveOnlineReservationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.RemoveOnlineReservationRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class RemoveOnlineReservationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.OnlineReservations.Messages.RemoveOnlineReservationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RemovePrintedTicketLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RemovePrintedTicketLineRequest';
	IsBlocking = false;
	Reason: string;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		reason: string
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Reason = _params.reason;
	}
}

export class RemovePrintedTicketLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RemovePrintedTicketLineResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RemoveProductFromCategoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.RemoveProductFromCategoryRequest';
	IsBlocking = false;
	CategoryId: number;
	ProductId: number;
	constructor(_params: {
		categoryId: number,
		productId: number
	}) {
		super({});
		this.CategoryId = _params.categoryId;
		this.ProductId = _params.productId;
	}
}

export class RemoveProductFromCategoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Catalogue.Messages.RemoveProductFromCategoryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RemoveReportViewRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.RemoveReportViewRequest';
	IsBlocking = false;
	Name: string;
	ReportId: string;
	constructor(_params: {
		reportId: string,
		name: string
	}) {
		super({});
		this.ReportId = _params.reportId;
		this.Name = _params.name;
	}
}

export class RemoveReportViewResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.RemoveReportViewResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RemoveTicketLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RemoveTicketLineRequest';
	IsBlocking = false;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
	}
}

export class RemoveTicketLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RemoveTicketLineResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RemoveTicketLoyaltyInfoRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RemoveTicketLoyaltyInfoRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class RemoveTicketLoyaltyInfoResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RemoveTicketLoyaltyInfoResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ReopenDeliveryNoteFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReopenDeliveryNoteFromPosRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	Params: ReopenDeliveryNoteParamsFromPosDTO;
	constructor(_params: {
		deliveryNoteId: number,
		params: ReopenDeliveryNoteParamsFromPosDTO
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
		this.Params = _params.params;
	}
}

export class ReopenDeliveryNoteFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReopenDeliveryNoteFromPosResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class ReopenInvoiceFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReopenInvoiceFromPosRequest';
	IsBlocking = false;
	InvoiceId: number;
	Params: ReopenInvoiceParamsFromPosDTO;
	constructor(_params: {
		invoiceId: number,
		params: ReopenInvoiceParamsFromPosDTO
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Params = _params.params;
	}
}

export class ReopenInvoiceFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReopenInvoiceFromPosResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class ReopenSalesOrderFromPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReopenSalesOrderFromPosRequest';
	IsBlocking = false;
	Params: ReopenSalesOrderParamsFromPosDTO;
	SalesOrderId: number;
	constructor(_params: {
		salesOrderId: number,
		params: ReopenSalesOrderParamsFromPosDTO
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
		this.Params = _params.params;
	}
}

export class ReopenSalesOrderFromPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ReopenSalesOrderFromPosResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class RequestOrderedItemsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RequestOrderedItemsRequest';
	IsBlocking = false;
	PreparationOrderId: number;
	TicketIds: number[];
	constructor(_params: {
		ticketIds: number[],
		preparationOrderId: number
	}) {
		super({});
		this.TicketIds = _params.ticketIds;
		this.PreparationOrderId = _params.preparationOrderId;
	}
}

export class RequestOrderedItemsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RequestOrderedItemsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class RequestOrderedLineRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RequestOrderedLineRequest';
	IsBlocking = false;
	LineId: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		lineId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.LineId = _params.lineId;
	}
}

export class RequestOrderedLineResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.RequestOrderedLineResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ResumeDeliveryCommsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ResumeDeliveryCommsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ResumeDeliveryCommsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ResumeDeliveryCommsResponse';
	IsBlocking = false;
	Status: SmartMenuPaymentStatusDTO;
	constructor(_params: {
		status: SmartMenuPaymentStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class ResumeTakeAwayCommsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ResumeTakeAwayCommsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ResumeTakeAwayCommsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.ResumeTakeAwayCommsResponse';
	IsBlocking = false;
	Status: SmartMenuPaymentStatusDTO;
	constructor(_params: {
		status: SmartMenuPaymentStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class ReviewWarehouseCloseOutRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ReviewWarehouseCloseOutRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({});
		this.Id = _params.id;
	}
}

export class ReviewWarehouseCloseOutResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ReviewWarehouseCloseOutResponse';
	IsBlocking = false;
	Data: WarehouseCloseOutForReviewDTO;
	constructor(_params: {
		data: WarehouseCloseOutForReviewDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class SaveAppointmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SaveAppointmentRequest';
	IsBlocking = false;
	Appointment: AppointmentForEditionDTO;
	constructor(_params: {
		appointment: AppointmentForEditionDTO
	}) {
		super({});
		this.Appointment = _params.appointment;
	}
}

export class SaveAppointmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SaveAppointmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveAuditQueryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.SaveAuditQueryRequest';
	IsBlocking = false;
	Query: AuditQueryDTO;
	constructor(_params: {
		query: AuditQueryDTO
	}) {
		super({});
		this.Query = _params.query;
	}
}

export class SaveAuditQueryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.SaveAuditQueryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveColorsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveColorsRequest';
	IsBlocking = false;
	Data: ColorsForEditionDTO;
	constructor(_params: {
		data: ColorsForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class SaveColorsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveColorsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveIncomingDeliveryNoteAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveIncomingDeliveryNoteAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	IncomingDeliveryNoteId: number;
	constructor(_params: {
		incomingDeliveryNoteId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.IncomingDeliveryNoteId = _params.incomingDeliveryNoteId;
		this.Attachment = _params.attachment;
	}
}

export class SaveIncomingDeliveryNoteAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveIncomingDeliveryNoteAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePriceListScheduleTableRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePriceListScheduleTableRequest';
	IsBlocking = false;
	Schedules: PriceListScheduleForEditionDTO[];
	constructor(_params: {
		schedules: PriceListScheduleForEditionDTO[]
	}) {
		super({});
		this.Schedules = _params.schedules;
	}
}

export class SavePriceListScheduleTableResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePriceListScheduleTableResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePurchaseInvoiceAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseInvoiceAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	PurchaseInvoiceId: number;
	constructor(_params: {
		purchaseInvoiceId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.PurchaseInvoiceId = _params.purchaseInvoiceId;
		this.Attachment = _params.attachment;
	}
}

export class SavePurchaseInvoiceAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseInvoiceAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePurchaseOrderAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseOrderAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	PurchaseOrderId: number;
	constructor(_params: {
		purchaseOrderId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.PurchaseOrderId = _params.purchaseOrderId;
		this.Attachment = _params.attachment;
	}
}

export class SavePurchaseOrderAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseOrderAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveRequest<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveRequest<TForEdition>';
	Data: _TForEdition;
	constructor(_params: {
		data: _TForEdition
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class SaveResponse<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveResponse<TForEdition>';
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveSizesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSizesRequest';
	IsBlocking = false;
	Data: SizesForEditionDTO;
	constructor(_params: {
		data: SizesForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class SaveSizesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSizesResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveStockChangeAttachmentRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveStockChangeAttachmentRequest';
	IsBlocking = false;
	Attachment: AttachmentDTO;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number,
		attachment: AttachmentDTO
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
		this.Attachment = _params.attachment;
	}
}

export class SaveStockChangeAttachmentResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveStockChangeAttachmentResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SearchLotsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchLotsRequest';
	IsBlocking = false;
	ExactMatch: boolean;
	NumberPattern: string;
	ProductId: Nullable<number>;
	constructor(_params: {
		numberPattern: string,
		productId: Nullable<number>,
		exactMatch: boolean
	}) {
		super({});
		this.NumberPattern = _params.numberPattern;
		this.ProductId = _params.productId;
		this.ExactMatch = _params.exactMatch;
	}
}

export class SearchLotsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchLotsResponse';
	IsBlocking = false;
	Lots: LotInListDTO[];
	constructor(_params: {
		lots: LotInListDTO[]
	}) {
		super({});
		this.Lots = _params.lots;
	}
}

export class SearchLotsWithStockInCurrentPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchLotsWithStockInCurrentPosRequest';
	IsBlocking = false;
	CurrentSaleCenterId: number;
	ExactMatch: boolean;
	NumberPattern: string;
	ProductId: Nullable<number>;
	constructor(_params: {
		numberPattern: string,
		productId: Nullable<number>,
		exactMatch: boolean,
		currentSaleCenterId: number
	}) {
		super({});
		this.NumberPattern = _params.numberPattern;
		this.ProductId = _params.productId;
		this.ExactMatch = _params.exactMatch;
		this.CurrentSaleCenterId = _params.currentSaleCenterId;
	}
}

export class SearchLotsWithStockInCurrentPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchLotsWithStockInCurrentPosResponse';
	IsBlocking = false;
	Lots: LotInListDTO[];
	constructor(_params: {
		lots: LotInListDTO[]
	}) {
		super({});
		this.Lots = _params.lots;
	}
}

export class SearchLotsWithStockInWarehouseRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchLotsWithStockInWarehouseRequest';
	IsBlocking = false;
	ExactMatch: boolean;
	NumberPattern: string;
	ProductId: Nullable<number>;
	WarehouseId: number;
	constructor(_params: {
		numberPattern: string,
		productId: Nullable<number>,
		exactMatch: boolean,
		warehouseId: number
	}) {
		super({});
		this.NumberPattern = _params.numberPattern;
		this.ProductId = _params.productId;
		this.ExactMatch = _params.exactMatch;
		this.WarehouseId = _params.warehouseId;
	}
}

export class SearchLotsWithStockInWarehouseResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchLotsWithStockInWarehouseResponse';
	IsBlocking = false;
	Lots: LotInListDTO[];
	constructor(_params: {
		lots: LotInListDTO[]
	}) {
		super({});
		this.Lots = _params.lots;
	}
}

export class SearchPendingSalesOrdersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SearchPendingSalesOrdersRequest';
	IsBlocking = false;
	SearchText: string;
	Types: SalesOrderType[];
	constructor(_params: {
		searchText: string,
		types: SalesOrderType[]
	}) {
		super({});
		this.SearchText = _params.searchText;
		this.Types = _params.types;
	}
}

export class SearchPendingSalesOrdersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SearchPendingSalesOrdersResponse';
	IsBlocking = false;
	Orders: SalesOrderDTO[];
	constructor(_params: {
		orders: SalesOrderDTO[]
	}) {
		super({});
		this.Orders = _params.orders;
	}
}

export class SearchProductDetailsForProductionByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductDetailsForProductionByTextRequest';
	IsBlocking = true;
	Text: string;
	WarehouseId: number;
	constructor(_params: {
		warehouseId: number,
		text: string
	}) {
		super({});
		this.WarehouseId = _params.warehouseId;
		this.Text = _params.text;
	}
}

export class SearchProductDetailsForProductionByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductDetailsForProductionByTextResponse';
	IsBlocking = false;
	Products: ProductDetailsForProductionDTO[];
	constructor(_params: {
		products: ProductDetailsForProductionDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class SearchProductForStockByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductForStockByTextRequest';
	IsBlocking = false;
	IgnoreRecipeAuto: boolean;
	Text: string;
	constructor(_params: {
		text: string,
		ignoreRecipeAuto: boolean
	}) {
		super({});
		this.Text = _params.text;
		this.IgnoreRecipeAuto = _params.ignoreRecipeAuto;
	}
}

export class SearchProductForStockByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductForStockByTextResponse';
	IsBlocking = false;
	Products: ProductForStockControlSearchDTO[];
	constructor(_params: {
		products: ProductForStockControlSearchDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class SearchProductsDetailsForPurchaseByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsDetailsForPurchaseByTextRequest';
	IsBlocking = false;
	SupplierId: Nullable<number>;
	Text: string;
	constructor(_params: {
		text: string,
		supplierId: Nullable<number>
	}) {
		super({});
		this.Text = _params.text;
		this.SupplierId = _params.supplierId;
	}
}

export class SearchProductsDetailsForPurchaseByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsDetailsForPurchaseByTextResponse';
	IsBlocking = false;
	Products: ProductDetailsForPurchaseSearchDTO[];
	constructor(_params: {
		products: ProductDetailsForPurchaseSearchDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class SearchProductsDetailsForStockByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsDetailsForStockByTextRequest';
	IsBlocking = false;
	IgnoreRecipeAuto: boolean;
	Text: string;
	constructor(_params: {
		text: string,
		ignoreRecipeAuto: boolean
	}) {
		super({});
		this.Text = _params.text;
		this.IgnoreRecipeAuto = _params.ignoreRecipeAuto;
	}
}

export class SearchProductsDetailsForStockByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsDetailsForStockByTextResponse';
	IsBlocking = false;
	Products: ProductDetailsForStockControlSearchDTO[];
	constructor(_params: {
		products: ProductDetailsForStockControlSearchDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class SearchProductsForPurchaseByTextRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsForPurchaseByTextRequest';
	IsBlocking = false;
	FilterBySupplier: boolean;
	SupplierId: Nullable<number>;
	Text: string;
	constructor(_params: {
		text: string,
		supplierId: Nullable<number>,
		filterBySupplier: boolean
	}) {
		super({});
		this.Text = _params.text;
		this.SupplierId = _params.supplierId;
		this.FilterBySupplier = _params.filterBySupplier;
	}
}

export class SearchProductsForPurchaseByTextResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsForPurchaseByTextResponse';
	IsBlocking = false;
	Products: ProductForPurchaseSearchDTO[];
	constructor(_params: {
		products: ProductForPurchaseSearchDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class SearchProductsForStockByCategoryIdRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsForStockByCategoryIdRequest';
	IsBlocking = false;
	CategoryId: number;
	ExcludeRecipeAuto: boolean;
	constructor(_params: {
		categoryId: number,
		excludeRecipeAuto: boolean
	}) {
		super({});
		this.CategoryId = _params.categoryId;
		this.ExcludeRecipeAuto = _params.excludeRecipeAuto;
	}
}

export class SearchProductsForStockByCategoryIdResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SearchProductsForStockByCategoryIdResponse';
	IsBlocking = false;
	Products: ProductForStockControlSearchDTO[];
	constructor(_params: {
		products: ProductForStockControlSearchDTO[]
	}) {
		super({});
		this.Products = _params.products;
	}
}

export class SearchTakeOutOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.SmartMenu.Messages.SearchTakeOutOrderRequest';
	IsBlocking = false;
	Number: number;
	Serie: string;
	constructor(_params: {
		serie: string,
		number: number
	}) {
		super({});
		this.Serie = _params.serie;
		this.Number = _params.number;
	}
}

export class SearchTakeOutOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.SmartMenu.Messages.SearchTakeOutOrderResponse';
	IsBlocking = false;
	Result: SearchTakeOutOrderResultDTO;
	constructor(_params: {
		result: SearchTakeOutOrderResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class SendAutoInvoiceEmailRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendAutoInvoiceEmailRequest';
	IsBlocking = false;
	Options: AutoInvoiceEmailOptionsDTO;
	constructor(_params: {
		options: AutoInvoiceEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class SendAutoInvoiceEmailResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendAutoInvoiceEmailResponse';
	IsBlocking = false;
	Result: SendDocumentEmailResultDTO;
	constructor(_params: {
		result: SendDocumentEmailResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class SendDeliveryNoteEmailRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendDeliveryNoteEmailRequest';
	IsBlocking = false;
	Options: DocumentEmailOptionsDTO;
	constructor(_params: {
		options: DocumentEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class SendDeliveryNoteEmailResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendDeliveryNoteEmailResponse';
	IsBlocking = false;
	Result: SendDocumentEmailResultDTO;
	constructor(_params: {
		result: SendDocumentEmailResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class SendDocumentByEmailRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.SendDocumentByEmailRequest';
	IsBlocking = true;
	Base64DocumentContent: string;
	Body: string;
	EmailAccountId: number;
	ReportFileName: string;
	Subject: string;
	To: string;
	constructor(_params: {
		to: string,
		subject: string,
		body: string,
		reportFileName: string,
		base64DocumentContent: string,
		emailAccountId: number
	}) {
		super({});
		this.To = _params.to;
		this.Subject = _params.subject;
		this.Body = _params.body;
		this.ReportFileName = _params.reportFileName;
		this.Base64DocumentContent = _params.base64DocumentContent;
		this.EmailAccountId = _params.emailAccountId;
	}
}

export class SendDocumentByEmailResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Reporting.Messages.SendDocumentByEmailResponse';
	IsBlocking = false;
	ErrorMessage: string;
	constructor(_params: {
		errorMessage: string
	}) {
		super({});
		this.ErrorMessage = _params.errorMessage;
	}
}

export class SendEmailingTestRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.SendEmailingTestRequest';
	IsBlocking = false;
	EmailAccount: EmailAccountByUserDTO;
	Emailing: EmailingForEditionDTO;
	To: string;
	constructor(_params: {
		emailing: EmailingForEditionDTO,
		to: string,
		emailAccount: EmailAccountByUserDTO
	}) {
		super({});
		this.Emailing = _params.emailing;
		this.To = _params.to;
		this.EmailAccount = _params.emailAccount;
	}
}

export class SendEmailingTestResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.SendEmailingTestResponse';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SendInvoiceEmailRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendInvoiceEmailRequest';
	IsBlocking = false;
	Options: DocumentEmailOptionsDTO;
	constructor(_params: {
		options: DocumentEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class SendInvoiceEmailResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendInvoiceEmailResponse';
	IsBlocking = false;
	Result: SendDocumentEmailResultDTO;
	constructor(_params: {
		result: SendDocumentEmailResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class SendPurchaseDocumentByEmailRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SendPurchaseDocumentByEmailRequest';
	IsBlocking = true;
	Base64DocumentContent: string;
	Body: string;
	EmailAccountId: number;
	PurchaseDocumentId: number;
	PurchaseDocumentType: DocumentType;
	ReportFileName: string;
	Subject: string;
	To: string;
	constructor(_params: {
		to: string,
		subject: string,
		body: string,
		reportFileName: string,
		base64DocumentContent: string,
		emailAccountId: number,
		purchaseDocumentId: number,
		purchaseDocumentType: DocumentType
	}) {
		super({});
		this.To = _params.to;
		this.Subject = _params.subject;
		this.Body = _params.body;
		this.ReportFileName = _params.reportFileName;
		this.Base64DocumentContent = _params.base64DocumentContent;
		this.EmailAccountId = _params.emailAccountId;
		this.PurchaseDocumentId = _params.purchaseDocumentId;
		this.PurchaseDocumentType = _params.purchaseDocumentType;
	}
}

export class SendPurchaseDocumentByEmailResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SendPurchaseDocumentByEmailResponse';
	IsBlocking = false;
	ErrorMessage: string;
	constructor(_params: {
		errorMessage: string
	}) {
		super({});
		this.ErrorMessage = _params.errorMessage;
	}
}

export class SendSalesOrderEmailRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendSalesOrderEmailRequest';
	IsBlocking = false;
	Options: DocumentEmailOptionsDTO;
	constructor(_params: {
		options: DocumentEmailOptionsDTO
	}) {
		super({});
		this.Options = _params.options;
	}
}

export class SendSalesOrderEmailResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Printing.Messages.SendSalesOrderEmailResponse';
	IsBlocking = false;
	Result: SendDocumentEmailResultDTO;
	constructor(_params: {
		result: SendDocumentEmailResultDTO
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class SendScaleSystemConfigurationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SendScaleSystemConfigurationRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SendScaleSystemConfigurationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SendScaleSystemConfigurationResponse';
	IsBlocking = false;
	Result: string;
	constructor(_params: {
		result: string
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class SendStockChangeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SendStockChangeRequest';
	IsBlocking = true;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
	}
}

export class SendStockChangeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SendStockChangeResponse';
	IsBlocking = false;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class SendWorkPlaceUpdateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.SendWorkPlaceUpdateRequest';
	IsBlocking = false;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class SendWorkPlaceUpdateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Hub.Messages.SendWorkPlaceUpdateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ServePreparationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.ServePreparationRequest';
	IsBlocking = false;
	CancelledLines: TicketPreparationLineDTO[];
	DisplayId: number;
	Lines: TicketPreparationLineDTO[];
	constructor(_params: {
		lines: TicketPreparationLineDTO[],
		cancelledLines: TicketPreparationLineDTO[],
		displayId: number
	}) {
		super({});
		this.Lines = _params.lines;
		this.CancelledLines = _params.cancelledLines;
		this.DisplayId = _params.displayId;
	}
}

export class ServePreparationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.ServePreparationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetBuyerCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetBuyerCustomerRequest';
	IsBlocking = false;
	Customer: BuyerCustomerDTO;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		customer: BuyerCustomerDTO
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Customer = _params.customer;
	}
}

export class SetBuyerCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetBuyerCustomerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetCategoryProductsDisplayOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetCategoryProductsDisplayOrderRequest';
	IsBlocking = true;
	CategoryId: number;
	Products: SortableProductDTO[];
	constructor(_params: {
		categoryId: number,
		products: SortableProductDTO[]
	}) {
		super({});
		this.CategoryId = _params.categoryId;
		this.Products = _params.products;
	}
}

export class SetCategoryProductsDisplayOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetCategoryProductsDisplayOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetDeliveryNoteTableCompanionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetDeliveryNoteTableCompanionsRequest';
	IsBlocking = false;
	DeliveryNoteId: number;
	TableCompanions: Nullable<number>;
	constructor(_params: {
		deliveryNoteId: number,
		tableCompanions: Nullable<number>
	}) {
		super({});
		this.DeliveryNoteId = _params.deliveryNoteId;
		this.TableCompanions = _params.tableCompanions;
	}
}

export class SetDeliveryNoteTableCompanionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetDeliveryNoteTableCompanionsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetDigitalMenuOwnerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetDigitalMenuOwnerRequest';
	IsBlocking = true;
	Data: DigitalMenuForEditionDTO;
	constructor(_params: {
		data: DigitalMenuForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class SetDigitalMenuOwnerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetDigitalMenuOwnerResponse';
	IsBlocking = false;
	Data: DigitalMenuForEditionDTO;
	ErrorMsg: string;
	Success: boolean;
	constructor(_params: {
		success: boolean,
		errorMsg: string,
		data: DigitalMenuForEditionDTO
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMsg = _params.errorMsg;
		this.Data = _params.data;
	}
}

export class SetFamilyProductsDisplayOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetFamilyProductsDisplayOrderRequest';
	IsBlocking = true;
	FamilyId: number;
	Products: SortableProductDTO[];
	constructor(_params: {
		familyId: number,
		products: SortableProductDTO[]
	}) {
		super({});
		this.FamilyId = _params.familyId;
		this.Products = _params.products;
	}
}

export class SetFamilyProductsDisplayOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetFamilyProductsDisplayOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetInventoryDateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SetInventoryDateRequest';
	IsBlocking = false;
	Date: Date;
	InventoryId: number;
	constructor(_params: {
		inventoryId: number,
		date: Date
	}) {
		super({});
		this.InventoryId = _params.inventoryId;
		this.Date = _params.date;
	}
}

export class SetInventoryDateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SetInventoryDateResponse';
	IsBlocking = false;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class SetInventoryReasonRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SetInventoryReasonRequest';
	IsBlocking = false;
	InventoryId: number;
	Reason: string;
	constructor(_params: {
		inventoryId: number,
		reason: string
	}) {
		super({});
		this.InventoryId = _params.inventoryId;
		this.Reason = _params.reason;
	}
}

export class SetInventoryReasonResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SetInventoryReasonResponse';
	IsBlocking = false;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class SetInvoiceBuyerCustomerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetInvoiceBuyerCustomerRequest';
	IsBlocking = false;
	Customer: BuyerCustomerDTO;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number,
		customer: BuyerCustomerDTO
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.Customer = _params.customer;
	}
}

export class SetInvoiceBuyerCustomerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetInvoiceBuyerCustomerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetInvoiceTableCompanionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetInvoiceTableCompanionsRequest';
	IsBlocking = false;
	InvoiceId: number;
	TableCompanions: Nullable<number>;
	constructor(_params: {
		invoiceId: number,
		tableCompanions: Nullable<number>
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
		this.TableCompanions = _params.tableCompanions;
	}
}

export class SetInvoiceTableCompanionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetInvoiceTableCompanionsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetLogLevelRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SetLogLevelRequest';
	IsBlocking = false;
	IntegrationServicesLevel: string;
	InterceptorLevel: string;
	RootLevel: string;
	constructor(_params: {
		rootLevel: string,
		integrationServicesLevel: string,
		interceptorLevel: string
	}) {
		super({});
		this.RootLevel = _params.rootLevel;
		this.IntegrationServicesLevel = _params.integrationServicesLevel;
		this.InterceptorLevel = _params.interceptorLevel;
	}
}

export class SetLogLevelResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SetLogLevelResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetMinTicketAmountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetMinTicketAmountRequest';
	IsBlocking = false;
	MinAmount: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		minAmount: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.MinAmount = _params.minAmount;
	}
}

export class SetMinTicketAmountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetMinTicketAmountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetPreparationCounterLastNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SetPreparationCounterLastNumberRequest';
	IsBlocking = false;
	LastNumber: number;
	constructor(_params: {
		lastNumber: number
	}) {
		super({});
		this.LastNumber = _params.lastNumber;
	}
}

export class SetPreparationCounterLastNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SetPreparationCounterLastNumberResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetPriceListConfigurationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SetPriceListConfigurationRequest';
	IsBlocking = false;
	Configuration: PriceListConfigurationDTO;
	constructor(_params: {
		configuration: PriceListConfigurationDTO
	}) {
		super({});
		this.Configuration = _params.configuration;
	}
}

export class SetPriceListConfigurationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SetPriceListConfigurationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetProductAvailableQuantitiesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SetProductAvailableQuantitiesRequest';
	IsBlocking = false;
	Quantities: ProductAvailabilityDTO[];
	constructor(_params: {
		quantities: ProductAvailabilityDTO[]
	}) {
		super({});
		this.Quantities = _params.quantities;
	}
}

export class SetProductAvailableQuantitiesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Restaurant.Messages.SetProductAvailableQuantitiesResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetProductGroupsDisplayOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetProductGroupsDisplayOrderRequest';
	IsBlocking = false;
	Groups: SortableProductGroupDTO[];
	PosGroupId: number;
	constructor(_params: {
		groups: SortableProductGroupDTO[],
		posGroupId: number
	}) {
		super({});
		this.Groups = _params.groups;
		this.PosGroupId = _params.posGroupId;
	}
}

export class SetProductGroupsDisplayOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetProductGroupsDisplayOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetProductMarginsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetProductMarginsRequest';
	IsBlocking = true;
	Margins: ProductMarginForEditionDTO[];
	PriceListId: number;
	constructor(_params: {
		margins: ProductMarginForEditionDTO[],
		priceListId: number
	}) {
		super({});
		this.Margins = _params.margins;
		this.PriceListId = _params.priceListId;
	}
}

export class SetProductMarginsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetProductMarginsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetProductPricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetProductPricesRequest';
	IsBlocking = true;
	ProductPrices: ProductPriceForEditionDTO[];
	constructor(_params: {
		productPrices: ProductPriceForEditionDTO[]
	}) {
		super({});
		this.ProductPrices = _params.productPrices;
	}
}

export class SetProductPricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetProductPricesResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetSalesOrderTableCompanionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetSalesOrderTableCompanionsRequest';
	IsBlocking = false;
	SalesOrderId: number;
	TableCompanions: Nullable<number>;
	constructor(_params: {
		salesOrderId: number,
		tableCompanions: Nullable<number>
	}) {
		super({});
		this.SalesOrderId = _params.salesOrderId;
		this.TableCompanions = _params.tableCompanions;
	}
}

export class SetSalesOrderTableCompanionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetSalesOrderTableCompanionsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetSmartMenuWorkplaceOwnerRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SetSmartMenuWorkplaceOwnerRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetSmartMenuWorkplaceOwnerResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SetSmartMenuWorkplaceOwnerResponse';
	IsBlocking = false;
	ErrorMsg: string;
	Success: boolean;
	constructor(_params: {
		success: boolean,
		errorMsg: string
	}) {
		super({});
		this.Success = _params.success;
		this.ErrorMsg = _params.errorMsg;
	}
}

export class SetTableCompanionsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTableCompanionsRequest';
	IsBlocking = false;
	TableCompanions: Nullable<number>;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		tableCompanions: Nullable<number>
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TableCompanions = _params.tableCompanions;
	}
}

export class SetTableCompanionsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTableCompanionsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketDiscountsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketDiscountsRequest';
	IsBlocking = false;
	CashDiscount: number;
	DiscountPercentage: number;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		cashDiscount: number,
		discountPercentage: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.CashDiscount = _params.cashDiscount;
		this.DiscountPercentage = _params.discountPercentage;
	}
}

export class SetTicketDiscountsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketDiscountsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketFriendlyNameRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketFriendlyNameRequest';
	IsBlocking = false;
	Name: string;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		name: string
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Name = _params.name;
	}
}

export class SetTicketFriendlyNameResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketFriendlyNameResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class SetTicketLineCashDiscountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineCashDiscountRequest';
	IsBlocking = false;
	Discount: number;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		discount: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Discount = _params.discount;
	}
}

export class SetTicketLineCashDiscountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineCashDiscountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLineCreatorRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineCreatorRequest';
	IsBlocking = false;
	CreatorId: number;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		creatorId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.CreatorId = _params.creatorId;
	}
}

export class SetTicketLineCreatorResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineCreatorResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLineDiscountPercentageRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineDiscountPercentageRequest';
	IsBlocking = false;
	Percentage: number;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		percentage: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Percentage = _params.percentage;
	}
}

export class SetTicketLineDiscountPercentageResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineDiscountPercentageResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLineDiscountsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineDiscountsRequest';
	IsBlocking = false;
	CashDiscount: number;
	DiscountPercentage: number;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		cashDiscount: number,
		discountPercentage: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.CashDiscount = _params.cashDiscount;
		this.DiscountPercentage = _params.discountPercentage;
	}
}

export class SetTicketLineDiscountsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineDiscountsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLineNamedDiscountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineNamedDiscountRequest';
	IsBlocking = false;
	AuthorizerId: Nullable<number>;
	DiscountId: number;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		discountId: number,
		ticketId: number,
		ticketLineId: number,
		authorizerId: Nullable<number>
	}) {
		super({});
		this.DiscountId = _params.discountId;
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.AuthorizerId = _params.authorizerId;
	}
}

export class SetTicketLineNamedDiscountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineNamedDiscountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLinePreparationOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLinePreparationOrderRequest';
	IsBlocking = false;
	PreparationOrderId: number;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		preparationOrderId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.PreparationOrderId = _params.preparationOrderId;
	}
}

export class SetTicketLinePreparationOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLinePreparationOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLinePriceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLinePriceRequest';
	IsBlocking = false;
	Price: number;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		price: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Price = _params.price;
	}
}

export class SetTicketLinePriceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLinePriceResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLineQuantityRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineQuantityRequest';
	IsBlocking = false;
	NotifyKitchenPrinters: boolean;
	Quantity: number;
	TicketId: number;
	TicketLineId: number;
	TicketLineStatus: TicketLineStatus;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		quantity: number,
		ticketLineStatus: TicketLineStatus,
		notifyKitchenPrinters: boolean
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.Quantity = _params.quantity;
		this.TicketLineStatus = _params.ticketLineStatus;
		this.NotifyKitchenPrinters = _params.notifyKitchenPrinters;
	}
}

export class SetTicketLineQuantityResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineQuantityResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketLineSeatNumberRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineSeatNumberRequest';
	IsBlocking = false;
	SeatNumber: Nullable<number>;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number,
		seatNumber: Nullable<number>
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
		this.SeatNumber = _params.seatNumber;
	}
}

export class SetTicketLineSeatNumberResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketLineSeatNumberResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketNamedDiscountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketNamedDiscountRequest';
	IsBlocking = false;
	AuthorizerId: Nullable<number>;
	DiscountId: number;
	TicketId: number;
	constructor(_params: {
		discountId: number,
		ticketId: number,
		authorizerId: Nullable<number>
	}) {
		super({});
		this.DiscountId = _params.discountId;
		this.TicketId = _params.ticketId;
		this.AuthorizerId = _params.authorizerId;
	}
}

export class SetTicketNamedDiscountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketNamedDiscountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketOffersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketOffersRequest';
	IsBlocking = false;
	Offers: OfferInListDTO[];
	TicketId: number;
	constructor(_params: {
		offers: OfferInListDTO[],
		ticketId: number
	}) {
		super({});
		this.Offers = _params.offers;
		this.TicketId = _params.ticketId;
	}
}

export class SetTicketOffersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketOffersResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketPriceListRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketPriceListRequest';
	IsBlocking = false;
	PriceListId: Nullable<number>;
	TicketId: number;
	constructor(_params: {
		priceListId: Nullable<number>,
		ticketId: number
	}) {
		super({});
		this.PriceListId = _params.priceListId;
		this.TicketId = _params.ticketId;
	}
}

export class SetTicketPriceListResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketPriceListResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketServiceChargeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketServiceChargeRequest';
	IsBlocking = false;
	ApplyTo: TicketType;
	ChargePercentage: number;
	ChargeTax: VatDTO;
	IgnoreTicketDiscounts: boolean;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		chargePercentage: number,
		applyTo: TicketType,
		chargeTax: VatDTO,
		ignoreTicketDiscounts: boolean
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.ChargePercentage = _params.chargePercentage;
		this.ApplyTo = _params.applyTo;
		this.ChargeTax = _params.chargeTax;
		this.IgnoreTicketDiscounts = _params.ignoreTicketDiscounts;
	}
}

export class SetTicketServiceChargeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketServiceChargeResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTicketTipRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketTipRequest';
	IsBlocking = false;
	ApplyTo: TicketType;
	IgnoreTicketDiscounts: boolean;
	TicketId: number;
	TipPercentage: number;
	TipTax: VatDTO;
	constructor(_params: {
		ticketId: number,
		tipPercentage: number,
		applyTo: TicketType,
		tipTax: VatDTO,
		ignoreTicketDiscounts: boolean
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TipPercentage = _params.tipPercentage;
		this.ApplyTo = _params.applyTo;
		this.TipTax = _params.tipTax;
		this.IgnoreTicketDiscounts = _params.ignoreTicketDiscounts;
	}
}

export class SetTicketTipResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.SetTicketTipResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SetTrainingSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetTrainingSettingsRequest';
	IsBlocking = false;
	Settings: TrainingSettingsDTO;
	constructor(_params: {
		settings: TrainingSettingsDTO
	}) {
		super({});
		this.Settings = _params.settings;
	}
}

export class SetTrainingSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SetTrainingSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ShouldAskBeforeNotifyQuantityChangedRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ShouldAskBeforeNotifyQuantityChangedRequest';
	IsBlocking = false;
	TicketId: number;
	TicketLineId: number;
	constructor(_params: {
		ticketId: number,
		ticketLineId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.TicketLineId = _params.ticketLineId;
	}
}

export class ShouldAskBeforeNotifyQuantityChangedResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ShouldAskBeforeNotifyQuantityChangedResponse';
	IsBlocking = false;
	ShouldAsk: boolean;
	constructor(_params: {
		shouldAsk: boolean
	}) {
		super({});
		this.ShouldAsk = _params.shouldAsk;
	}
}

export class ShouldTicketBeCancelledOrDeletedRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ShouldTicketBeCancelledOrDeletedRequest';
	IsBlocking = false;
	TicketId: number;
	constructor(_params: {
		ticketId: number
	}) {
		super({});
		this.TicketId = _params.ticketId;
	}
}

export class ShouldTicketBeCancelledOrDeletedResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.ShouldTicketBeCancelledOrDeletedResponse';
	IsBlocking = false;
	Should: boolean;
	constructor(_params: {
		should: boolean
	}) {
		super({});
		this.Should = _params.should;
	}
}

export class StartBackupRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.StartBackupRequest';
	IsBlocking = true;
	Name: string;
	constructor(_params: {
		name: string
	}) {
		super({});
		this.Name = _params.name;
	}
}

export class StartCookingRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.StartCookingRequest';
	IsBlocking = false;
	CancelledLines: TicketPreparationLineDTO[];
	DisplayId: number;
	Lines: TicketPreparationLineDTO[];
	constructor(_params: {
		displayId: number,
		lines: TicketPreparationLineDTO[],
		cancelledLines: TicketPreparationLineDTO[]
	}) {
		super({});
		this.DisplayId = _params.displayId;
		this.Lines = _params.lines;
		this.CancelledLines = _params.cancelledLines;
	}
}

export class StartCookingResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.StartCookingResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class StartEmailingRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.StartEmailingRequest';
	IsBlocking = true;
	CustomerIds: number[];
	EmailingId: number;
	constructor(_params: {
		emailingId: number,
		customerIds: number[]
	}) {
		super({});
		this.EmailingId = _params.emailingId;
		this.CustomerIds = _params.customerIds;
	}
}

export class StartEmailingResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.StartEmailingResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class StartPublishDigitalMenusRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.StartPublishDigitalMenusRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class StartPublishDigitalMenusResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.StartPublishDigitalMenusResponse';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class StartTakeOutOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.StartTakeOutOrderRequest';
	IsBlocking = false;
	Location: TicketLocationDTO;
	Params: StartTakeOutOrderParamsDTO;
	constructor(_params: {
		params: StartTakeOutOrderParamsDTO,
		location: TicketLocationDTO
	}) {
		super({});
		this.Params = _params.params;
		this.Location = _params.location;
	}
}

export class StartTakeOutOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.StartTakeOutOrderResponse';
	IsBlocking = false;
	Ticket: TicketDTO;
	constructor(_params: {
		ticket: TicketDTO
	}) {
		super({});
		this.Ticket = _params.ticket;
	}
}

export class SuspendDeliveryCommsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SuspendDeliveryCommsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SuspendDeliveryCommsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SuspendDeliveryCommsResponse';
	IsBlocking = false;
	Status: SmartMenuPaymentStatusDTO;
	constructor(_params: {
		status: SmartMenuPaymentStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class SuspendOrResumeTableOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SuspendOrResumeTableOrderRequest';
	IsBlocking = false;
	Statuses: TableOrderSaleCenterStatusDTO[];
	constructor(_params: {
		statuses: TableOrderSaleCenterStatusDTO[]
	}) {
		super({});
		this.Statuses = _params.statuses;
	}
}

export class SuspendOrResumeTableOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SuspendOrResumeTableOrderResponse';
	IsBlocking = false;
	Status: SmartMenuPaymentStatusDTO;
	constructor(_params: {
		status: SmartMenuPaymentStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class SuspendTakeAwayCommsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SuspendTakeAwayCommsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SuspendTakeAwayCommsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.SuspendTakeAwayCommsResponse';
	IsBlocking = false;
	Status: SmartMenuPaymentStatusDTO;
	constructor(_params: {
		status: SmartMenuPaymentStatusDTO
	}) {
		super({});
		this.Status = _params.status;
	}
}

export class TestEmailAccountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.TestEmailAccountRequest';
	IsBlocking = true;
	Data: EmailAccountForEditionDTO;
	constructor(_params: {
		data: EmailAccountForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class TestEmailAccountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.TestEmailAccountResponse';
	IsBlocking = false;
	Result: string;
	constructor(_params: {
		result: string
	}) {
		super({});
		this.Result = _params.result;
	}
}

export class TryCompleteFingerprintRegistrationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.TryCompleteFingerprintRegistrationRequest';
	IsBlocking = false;
	RegistrationId: string;
	constructor(_params: {
		registrationId: string
	}) {
		super({});
		this.RegistrationId = _params.registrationId;
	}
}

export class TryCompleteFingerprintRegistrationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.TryCompleteFingerprintRegistrationResponse';
	IsBlocking = false;
	IsCompleted: boolean;
	Result: string;
	constructor(_params: {
		isCompleted: boolean,
		result: string
	}) {
		super({});
		this.IsCompleted = _params.isCompleted;
		this.Result = _params.result;
	}
}

export class UnblockTicketByPosRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.UnblockTicketByPosRequest';
	IsBlocking = false;
	Audit: boolean;
	TicketId: number;
	constructor(_params: {
		ticketId: number,
		audit: boolean
	}) {
		super({});
		this.TicketId = _params.ticketId;
		this.Audit = _params.audit;
	}
}

export class UnblockTicketByPosResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.UnblockTicketByPosResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UnConfirmInventoryRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UnConfirmInventoryRequest';
	IsBlocking = true;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class UnConfirmInventoryResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UnConfirmInventoryResponse';
	IsBlocking = false;
	Inventory: InventoryForEditionDTO;
	constructor(_params: {
		inventory: InventoryForEditionDTO
	}) {
		super({});
		this.Inventory = _params.inventory;
	}
}

export class UndoAccountPurchaseInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoAccountPurchaseInvoiceRequest';
	IsBlocking = true;
	PurchaseInvoiceId: number;
	constructor(_params: {
		purchaseInvoiceId: number
	}) {
		super({});
		this.PurchaseInvoiceId = _params.purchaseInvoiceId;
	}
}

export class UndoAccountPurchaseInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoAccountPurchaseInvoiceResponse';
	IsBlocking = false;
	Data: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		data: PurchaseInvoiceForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class UndoConfirmIncomingDeliveryNoteRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoConfirmIncomingDeliveryNoteRequest';
	IsBlocking = true;
	IncomingDeliveryNoteId: number;
	constructor(_params: {
		incomingDeliveryNoteId: number
	}) {
		super({});
		this.IncomingDeliveryNoteId = _params.incomingDeliveryNoteId;
	}
}

export class UndoConfirmIncomingDeliveryNoteResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoConfirmIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Data: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		data: IncomingDeliveryNoteForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class UndoConfirmPurchaseOrderRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoConfirmPurchaseOrderRequest';
	IsBlocking = true;
	PurchaseOrderId: number;
	constructor(_params: {
		purchaseOrderId: number
	}) {
		super({});
		this.PurchaseOrderId = _params.purchaseOrderId;
	}
}

export class UndoConfirmPurchaseOrderResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoConfirmPurchaseOrderResponse';
	IsBlocking = false;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class UndoPreparationRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.UndoPreparationRequest';
	IsBlocking = false;
	DisplayId: number;
	Lines: TicketPreparationLineDTO[];
	constructor(_params: {
		displayId: number,
		lines: TicketPreparationLineDTO[]
	}) {
		super({});
		this.DisplayId = _params.displayId;
		this.Lines = _params.lines;
	}
}

export class UndoPreparationResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.KDS.Messages.UndoPreparationResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UndoSendStockChangeRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoSendStockChangeRequest';
	IsBlocking = true;
	StockChangeId: number;
	constructor(_params: {
		stockChangeId: number
	}) {
		super({});
		this.StockChangeId = _params.stockChangeId;
	}
}

export class UndoSendStockChangeResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UndoSendStockChangeResponse';
	IsBlocking = false;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class UnregisterNotificationTokenRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.UnregisterNotificationTokenRequest';
	IsBlocking = false;
	NotificationToken: string;
	constructor(_params: {
		notificationToken: string
	}) {
		super({});
		this.NotificationToken = _params.notificationToken;
	}
}

export class UnregisterNotificationTokenResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Security.Messages.UnregisterNotificationTokenResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UpdateBackupSettingsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.UpdateBackupSettingsRequest';
	IsBlocking = true;
	Settings: BackupSettingsDTO;
	constructor(_params: {
		settings: BackupSettingsDTO
	}) {
		super({});
		this.Settings = _params.settings;
	}
}

export class UpdateBackupSettingsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Backups.Messages.UpdateBackupSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UpdateCostPricesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UpdateCostPricesRequest';
	IsBlocking = true;
	CostPrices: CalculatedCostPriceDTO[];
	WarehouseId: number;
	constructor(_params: {
		costPrices: CalculatedCostPriceDTO[],
		warehouseId: number
	}) {
		super({});
		this.CostPrices = _params.costPrices;
		this.WarehouseId = _params.warehouseId;
	}
}

export class UpdateCostPricesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UpdateCostPricesResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UpdateCustomerDataFromInvoiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.UpdateCustomerDataFromInvoiceRequest';
	IsBlocking = false;
	InvoiceId: number;
	constructor(_params: {
		invoiceId: number
	}) {
		super({});
		this.InvoiceId = _params.invoiceId;
	}
}

export class UpdateCustomerDataFromInvoiceResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.UpdateCustomerDataFromInvoiceResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UpdateDigitalMenuResourcesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.UpdateDigitalMenuResourcesRequest';
	IsBlocking = true;
	Items: DigitalMenuResourceItemForEditionDTO[];
	Languages: LanguageDTO[];
	ReferenceLanguageCode: string;
	constructor(_params: {
		referenceLanguageCode: string,
		languages: LanguageDTO[],
		items: DigitalMenuResourceItemForEditionDTO[]
	}) {
		super({});
		this.ReferenceLanguageCode = _params.referenceLanguageCode;
		this.Languages = _params.languages;
		this.Items = _params.items;
	}
}

export class UpdateDigitalMenuResourcesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.UpdateDigitalMenuResourcesResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UpdateInventoryCountRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UpdateInventoryCountRequest';
	IsBlocking = false;
	Count: InventoryCountDTO;
	InventoryId: number;
	constructor(_params: {
		inventoryId: number,
		count: InventoryCountDTO
	}) {
		super({});
		this.InventoryId = _params.inventoryId;
		this.Count = _params.count;
	}
}

export class UpdateInventoryCountResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UpdateInventoryCountResponse';
	IsBlocking = false;
	Count: InventoryCountDTO;
	constructor(_params: {
		count: InventoryCountDTO
	}) {
		super({});
		this.Count = _params.count;
	}
}

export class UpdateRegularSuppliersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UpdateRegularSuppliersRequest';
	IsBlocking = true;
	Products: PurchasedProductDTO[];
	Supplier: SupplierDetailsDTO;
	constructor(_params: {
		supplier: SupplierDetailsDTO,
		products: PurchasedProductDTO[]
	}) {
		super({});
		this.Supplier = _params.supplier;
		this.Products = _params.products;
	}
}

export class UpdateRegularSuppliersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.UpdateRegularSuppliersResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class UpdateSalesOrderDeliveryAddressRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.UpdateSalesOrderDeliveryAddressRequest';
	IsBlocking = false;
	Location: AddressLocationDTO;
	OrderId: number;
	UpdatedDeliveryAddress: AddressDTO;
	constructor(_params: {
		orderId: number,
		updatedDeliveryAddress: AddressDTO,
		location: AddressLocationDTO
	}) {
		super({});
		this.OrderId = _params.orderId;
		this.UpdatedDeliveryAddress = _params.updatedDeliveryAddress;
		this.Location = _params.location;
	}
}

export class UpdateSalesOrderDeliveryAddressResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Sales.Tickets.Messages.UpdateSalesOrderDeliveryAddressResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ValidateAddinRoleRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAddinRoleRequest';
	IsBlocking = false;
	AddinRoleIndex: number;
	SaleFormat: SaleFormatForEditionDTO;
	constructor(_params: {
		saleFormat: SaleFormatForEditionDTO,
		addinRoleIndex: number
	}) {
		super({});
		this.SaleFormat = _params.saleFormat;
		this.AddinRoleIndex = _params.addinRoleIndex;
	}
}

export class ValidateAddinRoleResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAddinRoleResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateAddPosGroupToMultipleSaleCentersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAddPosGroupToMultipleSaleCentersRequest';
	IsBlocking = true;
	Data: AddPosGroupToMultipleSaleCentersParamsDTO;
	constructor(_params: {
		data: AddPosGroupToMultipleSaleCentersParamsDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateAddPosGroupToMultipleSaleCentersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAddPosGroupToMultipleSaleCentersResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateAddPosGroupToMultipleWarehousesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAddPosGroupToMultipleWarehousesRequest';
	IsBlocking = true;
	Data: AddPosGroupToMultipleWarehousesParamsDTO;
	constructor(_params: {
		data: AddPosGroupToMultipleWarehousesParamsDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateAddPosGroupToMultipleWarehousesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAddPosGroupToMultipleWarehousesResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateDeliveryAreaRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateDeliveryAreaRequest';
	IsBlocking = true;
	Area: DeliveryAreaDTO;
	OtherAreas: DeliveryAreaDTO[];
	constructor(_params: {
		area: DeliveryAreaDTO,
		otherAreas: DeliveryAreaDTO[]
	}) {
		super({});
		this.Area = _params.area;
		this.OtherAreas = _params.otherAreas;
	}
}

export class ValidateDeliveryAreaResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateDeliveryAreaResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateMultipleUserProfileEditionRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMultipleUserProfileEditionRequest';
	IsBlocking = true;
	Data: MultipleUserProfileEditionDTO;
	constructor(_params: {
		data: MultipleUserProfileEditionDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateMultipleUserProfileEditionResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMultipleUserProfileEditionResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidatePasswordForDistributorToolsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Distributor.ValidatePasswordForDistributorToolsRequest';
	IsBlocking = true;
	Password: string;
	constructor(_params: {
		password: string
	}) {
		super({});
		this.Password = _params.password;
	}
}

export class ValidatePasswordForDistributorToolsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Distributor.ValidatePasswordForDistributorToolsResponse';
	IsBlocking = false;
	IsValid: boolean;
	constructor(_params: {
		isValid: boolean
	}) {
		super({});
		this.IsValid = _params.isValid;
	}
}

export class ValidatePasswordRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.ValidatePasswordRequest';
	IsBlocking = false;
	Password: string;
	UserId: number;
	constructor(_params: {
		userId: number,
		password: string
	}) {
		super({});
		this.UserId = _params.userId;
		this.Password = _params.password;
	}
}

export class ValidatePasswordResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Attendance.Messages.ValidatePasswordResponse';
	IsBlocking = false;
	Valid: boolean;
	constructor(_params: {
		valid: boolean
	}) {
		super({});
		this.Valid = _params.valid;
	}
}

export class ValidateRemovePosGroupFromMultipleSaleCentersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRemovePosGroupFromMultipleSaleCentersRequest';
	IsBlocking = true;
	Data: RemovePosGroupFromMultipleSaleCentersParamsDTO;
	constructor(_params: {
		data: RemovePosGroupFromMultipleSaleCentersParamsDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateRemovePosGroupFromMultipleSaleCentersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRemovePosGroupFromMultipleSaleCentersResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateRemovePosGroupFromMultipleWarehousesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRemovePosGroupFromMultipleWarehousesRequest';
	IsBlocking = true;
	Data: RemovePosGroupFromMultipleWarehousesParamsDTO;
	constructor(_params: {
		data: RemovePosGroupFromMultipleWarehousesParamsDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateRemovePosGroupFromMultipleWarehousesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRemovePosGroupFromMultipleWarehousesResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateRequest<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRequest<TForEdition>';
	Data: _TForEdition;
	constructor(_params: {
		data: _TForEdition
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateResponse<_TForEdition> extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateResponse<TForEdition>';
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateSaleFormatRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSaleFormatRequest';
	IsBlocking = false;
	Product: ProductForEditionDTO;
	SaleFormatIndex: number;
	constructor(_params: {
		product: ProductForEditionDTO,
		saleFormatIndex: number
	}) {
		super({});
		this.Product = _params.product;
		this.SaleFormatIndex = _params.saleFormatIndex;
	}
}

export class ValidateSaleFormatResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSaleFormatResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateSetPosGroupsToMultipleSaleCentersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSetPosGroupsToMultipleSaleCentersRequest';
	IsBlocking = true;
	Data: SetPosGroupsToMultipleSaleCentersParamsDTO;
	constructor(_params: {
		data: SetPosGroupsToMultipleSaleCentersParamsDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateSetPosGroupsToMultipleSaleCentersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSetPosGroupsToMultipleSaleCentersResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateSetPosGroupsToMultipleWarehousesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSetPosGroupsToMultipleWarehousesRequest';
	IsBlocking = true;
	Data: SetPosGroupsToMultipleWarehousesParamsDTO;
	constructor(_params: {
		data: SetPosGroupsToMultipleWarehousesParamsDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateSetPosGroupsToMultipleWarehousesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSetPosGroupsToMultipleWarehousesResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateSetWarehouseToMultipleSaleCentersRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSetWarehouseToMultipleSaleCentersRequest';
	IsBlocking = true;
	Data: SetWarehouseToMultipleSaleCentersParamsDTO;
	constructor(_params: {
		data: SetWarehouseToMultipleSaleCentersParamsDTO
	}) {
		super({});
		this.Data = _params.data;
	}
}

export class ValidateSetWarehouseToMultipleSaleCentersResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSetWarehouseToMultipleSaleCentersResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateSizeAndColorBarcodesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSizeAndColorBarcodesRequest';
	IsBlocking = true;
	ProductId: number;
	RegularBarcodes: string[];
	SizeAndColorBarcodes: ProductBarcodeDTO[];
	constructor(_params: {
		productId: number,
		regularBarcodes: string[],
		sizeAndColorBarcodes: ProductBarcodeDTO[]
	}) {
		super({});
		this.ProductId = _params.productId;
		this.RegularBarcodes = _params.regularBarcodes;
		this.SizeAndColorBarcodes = _params.sizeAndColorBarcodes;
	}
}

export class ValidateSizeAndColorBarcodesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSizeAndColorBarcodesResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({});
		this.Notification = _params.notification;
	}
}

export class ValidateTakeOutServiceRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTakeOutServiceRequest';
	IsBlocking = true;
	OtherServices: TakeOutServiceDTO[];
	Service: TakeOutServiceDTO;
	constructor(_params: {
		service: TakeOutServiceDTO,
		otherServices: TakeOutServiceDTO[]
	}) {
		super({});
		this.Service = _params.service;
		this.OtherServices = _params.otherServices;
	}
}

export class ValidateTimeFramesRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTimeFramesRequest';
	IsBlocking = false;
	TimeFrames: TimeFrameDTO[];
	constructor(_params: {
		timeFrames: TimeFrameDTO[]
	}) {
		super({});
		this.TimeFrames = _params.timeFrames;
	}
}

export class ValidateTimeFramesResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTimeFramesResponse';
	IsBlocking = false;
	Errors: string[];
	Warnings: string[];
	constructor(_params: {
		errors: string[],
		warnings: string[]
	}) {
		super({});
		this.Errors = _params.errors;
		this.Warnings = _params.warnings;
	}
}

export class VerifyAdyenCredentialsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.VerifyAdyenCredentialsRequest';
	IsBlocking = true;
	ApiKey: string;
	ClientKey: string;
	GoogleMerchantId: string;
	MerchantAccount: string;
	Store: string;
	constructor(_params: {
		merchantAccount: string,
		apiKey: string,
		clientKey: string,
		googleMerchantId: string,
		store: string
	}) {
		super({});
		this.MerchantAccount = _params.merchantAccount;
		this.ApiKey = _params.apiKey;
		this.ClientKey = _params.clientKey;
		this.GoogleMerchantId = _params.googleMerchantId;
		this.Store = _params.store;
	}
}

export class VerifyAdyenCredentialsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.VerifyAdyenCredentialsResponse';
	IsBlocking = false;
	AreValid: boolean;
	ErrorMessage: string;
	constructor(_params: {
		areValid: boolean,
		errorMessage: string
	}) {
		super({});
		this.AreValid = _params.areValid;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class VerifyCertificateRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.VerifyCertificateRequest';
	IsBlocking = false;
	CertFile: FileContentDTO;
	CertPassword: string;
	constructor(_params: {
		certFile: FileContentDTO,
		certPassword: string
	}) {
		super({});
		this.CertFile = _params.certFile;
		this.CertPassword = _params.certPassword;
	}
}

export class VerifyCertificateResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.Common.Messages.VerifyCertificateResponse';
	IsBlocking = false;
	CanBeLoaded: boolean;
	ErrorMessage: string;
	Info: CertificateInfoDTO;
	VerificationPassed: boolean;
	constructor(_params: {
		canBeLoaded: boolean,
		info: CertificateInfoDTO,
		errorMessage: string,
		verificationPassed: boolean
	}) {
		super({});
		this.CanBeLoaded = _params.canBeLoaded;
		this.Info = _params.info;
		this.ErrorMessage = _params.errorMessage;
		this.VerificationPassed = _params.verificationPassed;
	}
}

export class VerifyUniversalPayCredentialsRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.VerifyUniversalPayCredentialsRequest';
	IsBlocking = true;
	Key: string;
	Merchant: string;
	constructor(_params: {
		merchant: string,
		key: string
	}) {
		super({});
		this.Merchant = _params.merchant;
		this.Key = _params.key;
	}
}

export class VerifyUniversalPayCredentialsResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.VerifyUniversalPayCredentialsResponse';
	IsBlocking = false;
	AreValid: boolean;
	ErrorMessage: string;
	constructor(_params: {
		areValid: boolean,
		errorMessage: string
	}) {
		super({});
		this.AreValid = _params.areValid;
		this.ErrorMessage = _params.errorMessage;
	}
}

export class WorkplaceHasVerifactuDataRequest extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.WorkplaceHasVerifactuDataRequest';
	IsBlocking = true;
	WorkplaceId: number;
	constructor(_params: {
		workplaceId: number
	}) {
		super({});
		this.WorkplaceId = _params.workplaceId;
	}
}

export class WorkplaceHasVerifactuDataResponse extends AbstractMessage {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.WorkplaceHasVerifactuDataResponse';
	IsBlocking = false;
	HasVerifactuData: boolean;
	constructor(_params: {
		hasVerifactuData: boolean
	}) {
		super({});
		this.HasVerifactuData = _params.hasVerifactuData;
	}
}

export class CreateAllergenRequest extends CreateRequest<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateAllergenRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateAllergenResponse extends CreateResponse<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateAllergenResponse';
	IsBlocking = false;
	Data: AllergenForEditionDTO;
	constructor(_params: {
		data: AllergenForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCardProcessorSettingsRequest extends CreateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCardProcessorSettingsRequest';
	IsBlocking = false;
	ProcessorType: string;
	constructor(_params: {
		processorType: string
	}) {
		super({processorType: _params.processorType});
		this.ProcessorType = _params.processorType;
	}
}

export class CreateCardProcessorSettingsResponse extends CreateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCardProcessorSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCashControlSettingsRequest extends CreateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCashControlSettingsRequest';
	IsBlocking = false;
	MachineType: string;
	constructor(_params: {
		machineType: string
	}) {
		super({machineType: _params.machineType});
		this.MachineType = _params.machineType;
	}
}

export class CreateCashControlSettingsResponse extends CreateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCashControlSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCategoryRequest extends CreateRequest<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCategoryRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateCategoryResponse extends CreateResponse<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCategoryResponse';
	IsBlocking = false;
	Data: CategoryForEditionDTO;
	constructor(_params: {
		data: CategoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCouponPrintTemplateRequest extends CreateRequest<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCouponPrintTemplateRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateCouponPrintTemplateResponse extends CreateResponse<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCouponPrintTemplateResponse';
	IsBlocking = false;
	Data: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		data: CouponPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCouponSettingsRequest extends CreateRequest<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCouponSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateCouponSettingsResponse extends CreateResponse<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCouponSettingsResponse';
	IsBlocking = false;
	Data: CouponSettingsForEditionDTO;
	constructor(_params: {
		data: CouponSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCustomActionButtonRequest extends CreateRequest<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCustomActionButtonRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateCustomActionButtonResponse extends CreateResponse<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCustomActionButtonResponse';
	IsBlocking = false;
	Data: CustomActionButtonForEditionDTO;
	constructor(_params: {
		data: CustomActionButtonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCustomerRequest extends CreateRequest<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCustomerRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateCustomerResponse extends CreateResponse<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCustomerResponse';
	IsBlocking = false;
	Data: CustomerForEditionDTO;
	constructor(_params: {
		data: CustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateCustomerTypeRequest extends CreateRequest<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCustomerTypeRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateCustomerTypeResponse extends CreateResponse<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateCustomerTypeResponse';
	IsBlocking = false;
	Data: CustomerTypeForEditionDTO;
	constructor(_params: {
		data: CustomerTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateDigitalMenuRequest extends CreateRequest<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateDigitalMenuRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateDigitalMenuResponse extends CreateResponse<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateDigitalMenuResponse';
	IsBlocking = false;
	Data: DigitalMenuForEditionDTO;
	constructor(_params: {
		data: DigitalMenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateEmailAccountRequest extends CreateRequest<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CreateEmailAccountRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateEmailAccountResponse extends CreateResponse<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CreateEmailAccountResponse';
	IsBlocking = false;
	Data: EmailAccountForEditionDTO;
	constructor(_params: {
		data: EmailAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateEmailingRequest extends CreateRequest<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CreateEmailingRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateEmailingResponse extends CreateResponse<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.CreateEmailingResponse';
	IsBlocking = false;
	Data: EmailingForEditionDTO;
	constructor(_params: {
		data: EmailingForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateEscPosTemplateRequest extends CreateRequest<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateEscPosTemplateRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateEscPosTemplateResponse extends CreateResponse<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateEscPosTemplateResponse';
	IsBlocking = false;
	Data: EscPosTemplateForEditionDTO;
	constructor(_params: {
		data: EscPosTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateFamilyRequest extends CreateRequest<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateFamilyRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateFamilyResponse extends CreateResponse<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateFamilyResponse';
	IsBlocking = false;
	Data: FamilyForEditionDTO;
	constructor(_params: {
		data: FamilyForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateIncomingDeliveryNoteRequest extends CreateRequest<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateIncomingDeliveryNoteRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateIncomingDeliveryNoteResponse extends CreateResponse<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Data: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		data: IncomingDeliveryNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateInternalCustomerRequest extends CreateRequest<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateInternalCustomerRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateInternalCustomerResponse extends CreateResponse<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateInternalCustomerResponse';
	IsBlocking = false;
	Data: InternalCustomerForEditionDTO;
	constructor(_params: {
		data: InternalCustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateInternalSupplierRequest extends CreateRequest<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateInternalSupplierRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateInternalSupplierResponse extends CreateResponse<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateInternalSupplierResponse';
	IsBlocking = false;
	Data: InternalSupplierForEditionDTO;
	constructor(_params: {
		data: InternalSupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateInventoryRequest extends CreateRequest<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateInventoryRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateInventoryResponse extends CreateResponse<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateInventoryResponse';
	IsBlocking = false;
	Data: InventoryForEditionDTO;
	constructor(_params: {
		data: InventoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateKitchenDisplayRequest extends CreateRequest<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateKitchenDisplayRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateKitchenDisplayResponse extends CreateResponse<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateKitchenDisplayResponse';
	IsBlocking = false;
	Data: KitchenDisplayForEditionDTO;
	constructor(_params: {
		data: KitchenDisplayForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateKitchenPrintTemplateRequest extends CreateRequest<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateKitchenPrintTemplateRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateKitchenPrintTemplateResponse extends CreateResponse<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateKitchenPrintTemplateResponse';
	IsBlocking = false;
	Data: KitchenPrintTemplateForEditionDTO;
	constructor(_params: {
		data: KitchenPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateLabelRequest extends CreateRequest<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateLabelRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateLabelResponse extends CreateResponse<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateLabelResponse';
	IsBlocking = false;
	Data: LabelForEditionDTO;
	constructor(_params: {
		data: LabelForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateLineCancellationReasonRequest extends CreateRequest<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateLineCancellationReasonRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateLineCancellationReasonResponse extends CreateResponse<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateLineCancellationReasonResponse';
	IsBlocking = false;
	Data: LineCancellationReasonForEditionDTO;
	constructor(_params: {
		data: LineCancellationReasonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateLotRequest extends CreateRequest<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateLotRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateLotResponse extends CreateResponse<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateLotResponse';
	IsBlocking = false;
	Data: LotForEditionDTO;
	constructor(_params: {
		data: LotForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateMajorGroupRequest extends CreateRequest<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMajorGroupRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateMajorGroupResponse extends CreateResponse<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMajorGroupResponse';
	IsBlocking = false;
	Data: MajorGroupForEditionDTO;
	constructor(_params: {
		data: MajorGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateMapRequest extends CreateRequest<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMapRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateMapResponse extends CreateResponse<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMapResponse';
	IsBlocking = false;
	Data: MapForEditionDTO;
	constructor(_params: {
		data: MapForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateMenuRequest extends CreateRequest<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMenuRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateMenuResponse extends CreateResponse<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMenuResponse';
	IsBlocking = false;
	Data: MenuForEditionDTO;
	constructor(_params: {
		data: MenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateMyAgoraAccountRequest extends CreateRequest<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMyAgoraAccountRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateMyAgoraAccountResponse extends CreateResponse<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateMyAgoraAccountResponse';
	IsBlocking = false;
	Data: MyAgoraAccountForEditionDTO;
	constructor(_params: {
		data: MyAgoraAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateNamedDiscountRequest extends CreateRequest<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateNamedDiscountRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateNamedDiscountResponse extends CreateResponse<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateNamedDiscountResponse';
	IsBlocking = false;
	Data: NamedDiscountForEditionDTO;
	constructor(_params: {
		data: NamedDiscountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateOfferRequest extends CreateRequest<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateOfferRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateOfferResponse extends CreateResponse<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateOfferResponse';
	IsBlocking = false;
	Data: OfferForEditionDTO;
	constructor(_params: {
		data: OfferForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePaymentMethodRequest extends CreateRequest<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePaymentMethodRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePaymentMethodResponse extends CreateResponse<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePaymentMethodResponse';
	IsBlocking = false;
	Data: PaymentMethodForEditionDTO;
	constructor(_params: {
		data: PaymentMethodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePosGroupRequest extends CreateRequest<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePosGroupRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePosGroupResponse extends CreateResponse<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePosGroupResponse';
	IsBlocking = false;
	Data: PosGroupForEditionDTO;
	constructor(_params: {
		data: PosGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePosRequest extends CreateRequest<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePosRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePosResponse extends CreateResponse<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePosResponse';
	IsBlocking = false;
	Data: PosForEditionDTO;
	constructor(_params: {
		data: PosForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePredefinedNoteRequest extends CreateRequest<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePredefinedNoteRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePredefinedNoteResponse extends CreateResponse<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePredefinedNoteResponse';
	IsBlocking = false;
	Data: PredefinedNoteForEditionDTO;
	constructor(_params: {
		data: PredefinedNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePreparationOrderRequest extends CreateRequest<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePreparationOrderRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePreparationOrderResponse extends CreateResponse<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePreparationOrderResponse';
	IsBlocking = false;
	Data: PreparationOrderForEditionDTO;
	constructor(_params: {
		data: PreparationOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePreparationTypeRequest extends CreateRequest<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePreparationTypeRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePreparationTypeResponse extends CreateResponse<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePreparationTypeResponse';
	IsBlocking = false;
	Data: PreparationTypeForEditionDTO;
	constructor(_params: {
		data: PreparationTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePriceListRequest extends CreateRequest<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePriceListRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePriceListResponse extends CreateResponse<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreatePriceListResponse';
	IsBlocking = false;
	Data: PriceListForEditionDTO;
	constructor(_params: {
		data: PriceListForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateProductionRequest extends CreateRequest<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateProductionRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateProductionResponse extends CreateResponse<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateProductionResponse';
	IsBlocking = false;
	Data: ProductionForEditionDTO;
	constructor(_params: {
		data: ProductionForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateProductRequest extends CreateRequest<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateProductRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateProductResponse extends CreateResponse<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateProductResponse';
	IsBlocking = false;
	Data: ProductForEditionDTO;
	constructor(_params: {
		data: ProductForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateProductTagRequest extends CreateRequest<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateProductTagRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateProductTagResponse extends CreateResponse<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateProductTagResponse';
	IsBlocking = false;
	Data: ProductTagForEditionDTO;
	constructor(_params: {
		data: ProductTagForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePurchaseInvoiceRequest extends CreateRequest<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreatePurchaseInvoiceRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePurchaseInvoiceResponse extends CreateResponse<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreatePurchaseInvoiceResponse';
	IsBlocking = false;
	Data: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		data: PurchaseInvoiceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreatePurchaseOrderRequest extends CreateRequest<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreatePurchaseOrderRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreatePurchaseOrderResponse extends CreateResponse<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreatePurchaseOrderResponse';
	IsBlocking = false;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateRdlTemplateRequest extends CreateRequest<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateRdlTemplateRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateRdlTemplateResponse extends CreateResponse<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateRdlTemplateResponse';
	IsBlocking = false;
	Data: RdlTemplateForEditionDTO;
	constructor(_params: {
		data: RdlTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSaleCenterRequest extends CreateRequest<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSaleCenterRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSaleCenterResponse extends CreateResponse<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSaleCenterResponse';
	IsBlocking = false;
	Data: SaleCenterForEditionDTO;
	constructor(_params: {
		data: SaleCenterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateScaleCounterRequest extends CreateRequest<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateScaleCounterRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateScaleCounterResponse extends CreateResponse<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateScaleCounterResponse';
	IsBlocking = false;
	Data: ScaleCounterForEditionDTO;
	constructor(_params: {
		data: ScaleCounterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSerieRequest extends CreateRequest<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSerieRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSerieResponse extends CreateResponse<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSerieResponse';
	IsBlocking = false;
	Data: SerieForEditionDTO;
	constructor(_params: {
		data: SerieForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSifSettingsRequest extends CreateRequest<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSifSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSifSettingsResponse extends CreateResponse<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSifSettingsResponse';
	IsBlocking = false;
	Data: SifSettingsForEditionDTO;
	constructor(_params: {
		data: SifSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSmartMenuOrderSettingsRequest extends CreateRequest<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSmartMenuOrderSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSmartMenuOrderSettingsResponse extends CreateResponse<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	Data: SmartMenuOrderSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuOrderSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSmartMenuWorkplaceGroupSettingsRequest extends CreateRequest<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSmartMenuWorkplaceGroupSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSmartMenuWorkplaceGroupSettingsResponse extends CreateResponse<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSmartMenuWorkplaceGroupSettingsResponse';
	IsBlocking = false;
	Data: SmartMenuWorkplaceGroupSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuWorkplaceGroupSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSmartphoneActionDisplayProfileRequest extends CreateRequest<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSmartphoneActionDisplayProfileRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSmartphoneActionDisplayProfileResponse extends CreateResponse<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSmartphoneActionDisplayProfileResponse';
	IsBlocking = false;
	Data: ActionDisplayProfileForEditionDTO;
	constructor(_params: {
		data: ActionDisplayProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateStockChangeRequest extends CreateRequest<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateStockChangeRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateStockChangeResponse extends CreateResponse<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateStockChangeResponse';
	IsBlocking = false;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSupplierRequest extends CreateRequest<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSupplierRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSupplierResponse extends CreateResponse<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSupplierResponse';
	IsBlocking = false;
	Data: SupplierForEditionDTO;
	constructor(_params: {
		data: SupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateSystemOfMeasurementRequest extends CreateRequest<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSystemOfMeasurementRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateSystemOfMeasurementResponse extends CreateResponse<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateSystemOfMeasurementResponse';
	IsBlocking = false;
	Data: SystemOfMeasurementForEditionDTO;
	constructor(_params: {
		data: SystemOfMeasurementForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateTablePaymentSettingsRequest extends CreateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateTablePaymentSettingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateTablePaymentSettingsResponse extends CreateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateTablePaymentSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateTabletActionDisplayProfileRequest extends CreateRequest<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateTabletActionDisplayProfileRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateTabletActionDisplayProfileResponse extends CreateResponse<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateTabletActionDisplayProfileResponse';
	IsBlocking = false;
	Data: ActionDisplayProfileForEditionDTO;
	constructor(_params: {
		data: ActionDisplayProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateTimeFrameGroupRequest extends CreateRequest<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateTimeFrameGroupRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateTimeFrameGroupResponse extends CreateResponse<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateTimeFrameGroupResponse';
	IsBlocking = false;
	Data: TimeFrameGroupForEditionDTO;
	constructor(_params: {
		data: TimeFrameGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateUserProfileRequest extends CreateRequest<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateUserProfileRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateUserProfileResponse extends CreateResponse<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateUserProfileResponse';
	IsBlocking = false;
	Data: UserProfileForEditionDTO;
	constructor(_params: {
		data: UserProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateUserRequest extends CreateRequest<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateUserRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateUserResponse extends CreateResponse<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateUserResponse';
	IsBlocking = false;
	Data: UserForEditionDTO;
	constructor(_params: {
		data: UserForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateWarehouseCloseOutRequest extends CreateRequest<WarehouseCloseOutForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateWarehouseCloseOutRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateWarehouseCloseOutResponse extends CreateResponse<WarehouseCloseOutForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.CreateWarehouseCloseOutResponse';
	IsBlocking = false;
	Data: WarehouseCloseOutForEditionDTO;
	constructor(_params: {
		data: WarehouseCloseOutForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateWarehouseRequest extends CreateRequest<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWarehouseRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateWarehouseResponse extends CreateResponse<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWarehouseResponse';
	IsBlocking = false;
	Data: WarehouseForEditionDTO;
	constructor(_params: {
		data: WarehouseForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateWebPosActionDisplayProfileRequest extends CreateRequest<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWebPosActionDisplayProfileRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateWebPosActionDisplayProfileResponse extends CreateResponse<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWebPosActionDisplayProfileResponse';
	IsBlocking = false;
	Data: ActionDisplayProfileForEditionDTO;
	constructor(_params: {
		data: ActionDisplayProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateWorkingPeriodRequest extends CreateRequest<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWorkingPeriodRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateWorkingPeriodResponse extends CreateResponse<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWorkingPeriodResponse';
	IsBlocking = false;
	Data: WorkingPeriodForEditionDTO;
	constructor(_params: {
		data: WorkingPeriodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class CreateWorkplaceRequest extends CreateRequest<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWorkplaceRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class CreateWorkplaceResponse extends CreateResponse<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.CreateWorkplaceResponse';
	IsBlocking = false;
	Data: WorkplaceForEditionDTO;
	constructor(_params: {
		data: WorkplaceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DeleteActionDisplayProfileRequest extends DeleteRequest<ActionDisplayProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteActionDisplayProfileRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteActionDisplayProfileResponse extends DeleteResponse<ActionDisplayProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteActionDisplayProfileResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteAllergenRequest extends DeleteRequest<AllergenInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteAllergenRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteAllergenResponse extends DeleteResponse<AllergenInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteAllergenResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCardProcessorSettingsRequest extends DeleteRequest<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCardProcessorSettingsRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCardProcessorSettingsResponse extends DeleteResponse<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCardProcessorSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCashControlSettingsRequest extends DeleteRequest<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCashControlSettingsRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCashControlSettingsResponse extends DeleteResponse<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCashControlSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCategoryRequest extends DeleteRequest<CategoryInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCategoryRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCategoryResponse extends DeleteResponse<CategoryInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCategoryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCouponPrintTemplateRequest extends DeleteRequest<CouponPrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCouponPrintTemplateRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCouponPrintTemplateResponse extends DeleteResponse<CouponPrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCouponPrintTemplateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCouponSettingsRequest extends DeleteRequest<CouponSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCouponSettingsRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCouponSettingsResponse extends DeleteResponse<CouponSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCouponSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCustomActionButtonRequest extends DeleteRequest<CustomActionButtonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCustomActionButtonRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCustomActionButtonResponse extends DeleteResponse<CustomActionButtonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCustomActionButtonResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCustomerRequest extends DeleteRequest<CustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCustomerRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCustomerResponse extends DeleteResponse<CustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCustomerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteCustomerTypeRequest extends DeleteRequest<CustomerTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCustomerTypeRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteCustomerTypeResponse extends DeleteResponse<CustomerTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteCustomerTypeResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteDigitalMenuRequest extends DeleteRequest<DigitalMenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteDigitalMenuRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteDigitalMenuResponse extends DeleteResponse<DigitalMenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteDigitalMenuResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteEmailAccountRequest extends DeleteRequest<EmailAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DeleteEmailAccountRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteEmailAccountResponse extends DeleteResponse<EmailAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DeleteEmailAccountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteEmailingRequest extends DeleteRequest<EmailingInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DeleteEmailingRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteEmailingResponse extends DeleteResponse<EmailingInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DeleteEmailingResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteFamilyRequest extends DeleteRequest<FamilyInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteFamilyRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteFamilyResponse extends DeleteResponse<FamilyInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteFamilyResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteIncomingDeliveryNoteRequest extends DeleteRequest<IncomingDeliveryNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteIncomingDeliveryNoteRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteIncomingDeliveryNoteResponse extends DeleteResponse<IncomingDeliveryNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteIncomingDeliveryNoteResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteInternalCustomerRequest extends DeleteRequest<InternalCustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteInternalCustomerRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteInternalCustomerResponse extends DeleteResponse<InternalCustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteInternalCustomerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteInternalSupplierRequest extends DeleteRequest<InternalSupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteInternalSupplierRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteInternalSupplierResponse extends DeleteResponse<InternalSupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteInternalSupplierResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteInventoryRequest extends DeleteRequest<InventoryInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteInventoryRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteInventoryResponse extends DeleteResponse<InventoryInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteInventoryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteKitchenDisplayRequest extends DeleteRequest<KitchenDisplayInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteKitchenDisplayRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteKitchenDisplayResponse extends DeleteResponse<KitchenDisplayInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteKitchenDisplayResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteKitchenPrintTemplateRequest extends DeleteRequest<KitchenPrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteKitchenPrintTemplateRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteKitchenPrintTemplateResponse extends DeleteResponse<KitchenPrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteKitchenPrintTemplateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteLabelRequest extends DeleteRequest<LabelInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteLabelRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteLabelResponse extends DeleteResponse<LabelInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteLabelResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteLineCancellationReasonRequest extends DeleteRequest<LineCancellationReasonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteLineCancellationReasonRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteLineCancellationReasonResponse extends DeleteResponse<LineCancellationReasonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteLineCancellationReasonResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteLotRequest extends DeleteRequest<LotInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteLotRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteLotResponse extends DeleteResponse<LotInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteLotResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteMajorGroupRequest extends DeleteRequest<MajorGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMajorGroupRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteMajorGroupResponse extends DeleteResponse<MajorGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMajorGroupResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteMapRequest extends DeleteRequest<MapInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMapRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteMapResponse extends DeleteResponse<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMapResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteMenuRequest extends DeleteRequest<MenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMenuRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteMenuResponse extends DeleteResponse<MenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMenuResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteMyAgoraAccountRequest extends DeleteRequest<MyAgoraAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMyAgoraAccountRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteMyAgoraAccountResponse extends DeleteResponse<MyAgoraAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteMyAgoraAccountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteNamedDiscountRequest extends DeleteRequest<NamedDiscountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteNamedDiscountRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteNamedDiscountResponse extends DeleteResponse<NamedDiscountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteNamedDiscountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteOfferRequest extends DeleteRequest<OfferInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteOfferRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteOfferResponse extends DeleteResponse<OfferInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteOfferResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePaymentMethodRequest extends DeleteRequest<PaymentMethodInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePaymentMethodRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePaymentMethodResponse extends DeleteResponse<PaymentMethodInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePaymentMethodResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePosGroupRequest extends DeleteRequest<PosGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePosGroupRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePosGroupResponse extends DeleteResponse<PosGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePosGroupResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePosRequest extends DeleteRequest<PosInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePosRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePosResponse extends DeleteResponse<PosInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePosResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePredefinedNoteRequest extends DeleteRequest<PredefinedNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePredefinedNoteRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePredefinedNoteResponse extends DeleteResponse<PredefinedNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePredefinedNoteResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePreparationOrderRequest extends DeleteRequest<PreparationOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePreparationOrderRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePreparationOrderResponse extends DeleteResponse<PreparationOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePreparationOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePreparationTypeRequest extends DeleteRequest<PreparationTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePreparationTypeRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePreparationTypeResponse extends DeleteResponse<PreparationTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePreparationTypeResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePriceListRequest extends DeleteRequest<PriceListInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePriceListRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePriceListResponse extends DeleteResponse<PriceListInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePriceListResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePrintTemplateRequest extends DeleteRequest<PrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePrintTemplateRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePrintTemplateResponse extends DeleteResponse<PrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeletePrintTemplateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteProductionRequest extends DeleteRequest<ProductionInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteProductionRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteProductionResponse extends DeleteResponse<ProductionInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteProductionResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteProductRequest extends DeleteRequest<ProductInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteProductRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteProductResponse extends DeleteResponse<ProductInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteProductResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteProductTagRequest extends DeleteRequest<ProductTagInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteProductTagRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteProductTagResponse extends DeleteResponse<ProductTagInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteProductTagResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePurchaseInvoiceRequest extends DeleteRequest<PurchaseInvoiceInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseInvoiceRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePurchaseInvoiceResponse extends DeleteResponse<PurchaseInvoiceInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseInvoiceResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeletePurchaseOrderRequest extends DeleteRequest<PurchaseOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseOrderRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeletePurchaseOrderResponse extends DeleteResponse<PurchaseOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeletePurchaseOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteSaleCenterRequest extends DeleteRequest<SaleCenterInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSaleCenterRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteSaleCenterResponse extends DeleteResponse<SaleCenterInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSaleCenterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteScaleCounterRequest extends DeleteRequest<ScaleCounterInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteScaleCounterRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteScaleCounterResponse extends DeleteResponse<ScaleCounterInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteScaleCounterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteSerieRequest extends DeleteRequest<SerieInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSerieRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteSerieResponse extends DeleteResponse<SerieInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSerieResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteSifSettingsRequest extends DeleteRequest<SifSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSifSettingsRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteSifSettingsResponse extends DeleteResponse<SifSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSifSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteSmartMenuOrderSettingsRequest extends DeleteRequest<SmartMenuOrderSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSmartMenuOrderSettingsRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteSmartMenuOrderSettingsResponse extends DeleteResponse<SmartMenuOrderSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteSmartMenuWorkplaceGroupSettingsRequest extends DeleteRequest<SmartMenuWorkplaceGroupSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSmartMenuWorkplaceGroupSettingsRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteSmartMenuWorkplaceGroupSettingsResponse extends DeleteResponse<SmartMenuWorkplaceGroupSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSmartMenuWorkplaceGroupSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteStockChangeRequest extends DeleteRequest<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteStockChangeRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteStockChangeResponse extends DeleteResponse<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteStockChangeResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteSupplierRequest extends DeleteRequest<SupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSupplierRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteSupplierResponse extends DeleteResponse<SupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSupplierResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteSystemOfMeasurementRequest extends DeleteRequest<SystemOfMeasurementInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSystemOfMeasurementRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteSystemOfMeasurementResponse extends DeleteResponse<SystemOfMeasurementInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteSystemOfMeasurementResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteTablePaymentSettingsRequest extends DeleteRequest<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteTablePaymentSettingsRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteTablePaymentSettingsResponse extends DeleteResponse<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteTablePaymentSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteTimeFrameGroupRequest extends DeleteRequest<TimeFrameGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteTimeFrameGroupRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteTimeFrameGroupResponse extends DeleteResponse<TimeFrameGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteTimeFrameGroupResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteUserProfileRequest extends DeleteRequest<UserProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteUserProfileRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteUserProfileResponse extends DeleteResponse<UserProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteUserProfileResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteUserRequest extends DeleteRequest<UserInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteUserRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteUserResponse extends DeleteResponse<UserInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteUserResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteWarehouseCloseOutRequest extends DeleteRequest<WarehouseCloseOutInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteWarehouseCloseOutRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteWarehouseCloseOutResponse extends DeleteResponse<WarehouseCloseOutInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DeleteWarehouseCloseOutResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteWarehouseRequest extends DeleteRequest<WarehouseInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteWarehouseRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteWarehouseResponse extends DeleteResponse<WarehouseInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteWarehouseResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteWorkingPeriodRequest extends DeleteRequest<WorkingPeriodInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteWorkingPeriodRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteWorkingPeriodResponse extends DeleteResponse<WorkingPeriodInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteWorkingPeriodResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DeleteWorkplaceRequest extends DeleteRequest<WorkplaceInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteWorkplaceRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DeleteWorkplaceResponse extends DeleteResponse<WorkplaceInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DeleteWorkplaceResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class DuplicateActionDisplayProfileRequest extends DuplicateRequest<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateActionDisplayProfileRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateActionDisplayProfileResponse extends DuplicateResponse<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateActionDisplayProfileResponse';
	IsBlocking = false;
	Data: ActionDisplayProfileForEditionDTO;
	constructor(_params: {
		data: ActionDisplayProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateAllergenRequest extends DuplicateRequest<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateAllergenRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateAllergenResponse extends DuplicateResponse<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateAllergenResponse';
	IsBlocking = false;
	Data: AllergenForEditionDTO;
	constructor(_params: {
		data: AllergenForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCardProcessorSettingsRequest extends DuplicateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCardProcessorSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCardProcessorSettingsResponse extends DuplicateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCardProcessorSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCashControlSettingsRequest extends DuplicateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCashControlSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCashControlSettingsResponse extends DuplicateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCashControlSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCategoryRequest extends DuplicateRequest<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCategoryRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCategoryResponse extends DuplicateResponse<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCategoryResponse';
	IsBlocking = false;
	Data: CategoryForEditionDTO;
	constructor(_params: {
		data: CategoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCouponPrintTemplateRequest extends DuplicateRequest<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCouponPrintTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCouponPrintTemplateResponse extends DuplicateResponse<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCouponPrintTemplateResponse';
	IsBlocking = false;
	Data: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		data: CouponPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCouponSettingsRequest extends DuplicateRequest<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCouponSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCouponSettingsResponse extends DuplicateResponse<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCouponSettingsResponse';
	IsBlocking = false;
	Data: CouponSettingsForEditionDTO;
	constructor(_params: {
		data: CouponSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCustomActionButtonRequest extends DuplicateRequest<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCustomActionButtonRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCustomActionButtonResponse extends DuplicateResponse<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCustomActionButtonResponse';
	IsBlocking = false;
	Data: CustomActionButtonForEditionDTO;
	constructor(_params: {
		data: CustomActionButtonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCustomerRequest extends DuplicateRequest<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCustomerRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCustomerResponse extends DuplicateResponse<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCustomerResponse';
	IsBlocking = false;
	Data: CustomerForEditionDTO;
	constructor(_params: {
		data: CustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateCustomerTypeRequest extends DuplicateRequest<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCustomerTypeRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateCustomerTypeResponse extends DuplicateResponse<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateCustomerTypeResponse';
	IsBlocking = false;
	Data: CustomerTypeForEditionDTO;
	constructor(_params: {
		data: CustomerTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateDigitalMenuRequest extends DuplicateRequest<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateDigitalMenuRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateDigitalMenuResponse extends DuplicateResponse<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateDigitalMenuResponse';
	IsBlocking = false;
	Data: DigitalMenuForEditionDTO;
	constructor(_params: {
		data: DigitalMenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateEmailAccountRequest extends DuplicateRequest<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DuplicateEmailAccountRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateEmailAccountResponse extends DuplicateResponse<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DuplicateEmailAccountResponse';
	IsBlocking = false;
	Data: EmailAccountForEditionDTO;
	constructor(_params: {
		data: EmailAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateEmailingRequest extends DuplicateRequest<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DuplicateEmailingRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateEmailingResponse extends DuplicateResponse<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.DuplicateEmailingResponse';
	IsBlocking = false;
	Data: EmailingForEditionDTO;
	constructor(_params: {
		data: EmailingForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateEscPosTemplateRequest extends DuplicateRequest<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateEscPosTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateEscPosTemplateResponse extends DuplicateResponse<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateEscPosTemplateResponse';
	IsBlocking = false;
	Data: EscPosTemplateForEditionDTO;
	constructor(_params: {
		data: EscPosTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateFamilyRequest extends DuplicateRequest<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateFamilyRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateFamilyResponse extends DuplicateResponse<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateFamilyResponse';
	IsBlocking = false;
	Data: FamilyForEditionDTO;
	constructor(_params: {
		data: FamilyForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateIncomingDeliveryNoteRequest extends DuplicateRequest<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateIncomingDeliveryNoteRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateIncomingDeliveryNoteResponse extends DuplicateResponse<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Data: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		data: IncomingDeliveryNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateInternalCustomerRequest extends DuplicateRequest<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateInternalCustomerRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateInternalCustomerResponse extends DuplicateResponse<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateInternalCustomerResponse';
	IsBlocking = false;
	Data: InternalCustomerForEditionDTO;
	constructor(_params: {
		data: InternalCustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateInternalSupplierRequest extends DuplicateRequest<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateInternalSupplierRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateInternalSupplierResponse extends DuplicateResponse<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateInternalSupplierResponse';
	IsBlocking = false;
	Data: InternalSupplierForEditionDTO;
	constructor(_params: {
		data: InternalSupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateInventoryRequest extends DuplicateRequest<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateInventoryRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateInventoryResponse extends DuplicateResponse<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateInventoryResponse';
	IsBlocking = false;
	Data: InventoryForEditionDTO;
	constructor(_params: {
		data: InventoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateKitchenDisplayRequest extends DuplicateRequest<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateKitchenDisplayRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateKitchenDisplayResponse extends DuplicateResponse<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateKitchenDisplayResponse';
	IsBlocking = false;
	Data: KitchenDisplayForEditionDTO;
	constructor(_params: {
		data: KitchenDisplayForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateKitchenPrintTemplateRequest extends DuplicateRequest<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateKitchenPrintTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateKitchenPrintTemplateResponse extends DuplicateResponse<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateKitchenPrintTemplateResponse';
	IsBlocking = false;
	Data: KitchenPrintTemplateForEditionDTO;
	constructor(_params: {
		data: KitchenPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateLabelRequest extends DuplicateRequest<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateLabelRequest';
	IsBlocking = true;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateLabelResponse extends DuplicateResponse<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateLabelResponse';
	IsBlocking = true;
	Data: LabelForEditionDTO;
	constructor(_params: {
		data: LabelForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateLineCancellationReasonRequest extends DuplicateRequest<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateLineCancellationReasonRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateLineCancellationReasonResponse extends DuplicateResponse<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateLineCancellationReasonResponse';
	IsBlocking = false;
	Data: LineCancellationReasonForEditionDTO;
	constructor(_params: {
		data: LineCancellationReasonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateMajorGroupRequest extends DuplicateRequest<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateMajorGroupRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateMajorGroupResponse extends DuplicateResponse<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateMajorGroupResponse';
	IsBlocking = false;
	Data: MajorGroupForEditionDTO;
	constructor(_params: {
		data: MajorGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateMapRequest extends DuplicateRequest<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateMapRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateMapResponse extends DuplicateResponse<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateMapResponse';
	IsBlocking = false;
	Data: MapForEditionDTO;
	constructor(_params: {
		data: MapForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateMenuRequest extends DuplicateRequest<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateMenuRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateMenuResponse extends DuplicateResponse<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateMenuResponse';
	IsBlocking = false;
	Data: MenuForEditionDTO;
	constructor(_params: {
		data: MenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateNamedDiscountRequest extends DuplicateRequest<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateNamedDiscountRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateNamedDiscountResponse extends DuplicateResponse<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateNamedDiscountResponse';
	IsBlocking = false;
	Data: NamedDiscountForEditionDTO;
	constructor(_params: {
		data: NamedDiscountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateOfferRequest extends DuplicateRequest<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateOfferRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateOfferResponse extends DuplicateResponse<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateOfferResponse';
	IsBlocking = false;
	Data: OfferForEditionDTO;
	constructor(_params: {
		data: OfferForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePaymentMethodRequest extends DuplicateRequest<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePaymentMethodRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePaymentMethodResponse extends DuplicateResponse<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePaymentMethodResponse';
	IsBlocking = false;
	Data: PaymentMethodForEditionDTO;
	constructor(_params: {
		data: PaymentMethodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePosGroupRequest extends DuplicateRequest<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePosGroupRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePosGroupResponse extends DuplicateResponse<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePosGroupResponse';
	IsBlocking = false;
	Data: PosGroupForEditionDTO;
	constructor(_params: {
		data: PosGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePosRequest extends DuplicateRequest<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePosRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePosResponse extends DuplicateResponse<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePosResponse';
	IsBlocking = false;
	Data: PosForEditionDTO;
	constructor(_params: {
		data: PosForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePredefinedNoteRequest extends DuplicateRequest<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePredefinedNoteRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePredefinedNoteResponse extends DuplicateResponse<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePredefinedNoteResponse';
	IsBlocking = false;
	Data: PredefinedNoteForEditionDTO;
	constructor(_params: {
		data: PredefinedNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePreparationOrderRequest extends DuplicateRequest<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePreparationOrderRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePreparationOrderResponse extends DuplicateResponse<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePreparationOrderResponse';
	IsBlocking = false;
	Data: PreparationOrderForEditionDTO;
	constructor(_params: {
		data: PreparationOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePreparationTypeRequest extends DuplicateRequest<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePreparationTypeRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePreparationTypeResponse extends DuplicateResponse<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePreparationTypeResponse';
	IsBlocking = false;
	Data: PreparationTypeForEditionDTO;
	constructor(_params: {
		data: PreparationTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePriceListRequest extends DuplicateRequest<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePriceListRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePriceListResponse extends DuplicateResponse<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicatePriceListResponse';
	IsBlocking = false;
	Data: PriceListForEditionDTO;
	constructor(_params: {
		data: PriceListForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateProductionRequest extends DuplicateRequest<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateProductionRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateProductionResponse extends DuplicateResponse<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateProductionResponse';
	IsBlocking = false;
	Data: ProductionForEditionDTO;
	constructor(_params: {
		data: ProductionForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateProductRequest extends DuplicateRequest<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateProductRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateProductResponse extends DuplicateResponse<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateProductResponse';
	IsBlocking = false;
	Data: ProductForEditionDTO;
	constructor(_params: {
		data: ProductForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateProductTagRequest extends DuplicateRequest<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateProductTagRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateProductTagResponse extends DuplicateResponse<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateProductTagResponse';
	IsBlocking = false;
	Data: ProductTagForEditionDTO;
	constructor(_params: {
		data: ProductTagForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePurchaseInvoiceRequest extends DuplicateRequest<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicatePurchaseInvoiceRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePurchaseInvoiceResponse extends DuplicateResponse<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicatePurchaseInvoiceResponse';
	IsBlocking = false;
	Data: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		data: PurchaseInvoiceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicatePurchaseOrderRequest extends DuplicateRequest<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicatePurchaseOrderRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicatePurchaseOrderResponse extends DuplicateResponse<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicatePurchaseOrderResponse';
	IsBlocking = false;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateRdlTemplateRequest extends DuplicateRequest<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateRdlTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateRdlTemplateResponse extends DuplicateResponse<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateRdlTemplateResponse';
	IsBlocking = false;
	Data: RdlTemplateForEditionDTO;
	constructor(_params: {
		data: RdlTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateSaleCenterRequest extends DuplicateRequest<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSaleCenterRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateSaleCenterResponse extends DuplicateResponse<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSaleCenterResponse';
	IsBlocking = true;
	Data: SaleCenterForEditionDTO;
	constructor(_params: {
		data: SaleCenterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateScaleCounterRequest extends DuplicateRequest<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateScaleCounterRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateScaleCounterResponse extends DuplicateResponse<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateScaleCounterResponse';
	IsBlocking = false;
	Data: ScaleCounterForEditionDTO;
	constructor(_params: {
		data: ScaleCounterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateSerieRequest extends DuplicateRequest<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSerieRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateSerieResponse extends DuplicateResponse<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSerieResponse';
	IsBlocking = false;
	Data: SerieForEditionDTO;
	constructor(_params: {
		data: SerieForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateSifSettingsRequest extends DuplicateRequest<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSifSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateSifSettingsResponse extends DuplicateResponse<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSifSettingsResponse';
	IsBlocking = false;
	Data: SifSettingsForEditionDTO;
	constructor(_params: {
		data: SifSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateSmartMenuOrderSettingsRequest extends DuplicateRequest<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSmartMenuOrderSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateSmartMenuOrderSettingsResponse extends DuplicateResponse<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	Data: SmartMenuOrderSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuOrderSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateSmartMenuWorkplaceGroupSettingsRequest extends DuplicateRequest<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSmartMenuWorkplaceGroupSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateSmartMenuWorkplaceGroupSettingsResponse extends DuplicateResponse<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSmartMenuWorkplaceGroupSettingsResponse';
	IsBlocking = false;
	Data: SmartMenuWorkplaceGroupSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuWorkplaceGroupSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateStockChangeRequest extends DuplicateRequest<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateStockChangeRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateStockChangeResponse extends DuplicateResponse<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.DuplicateStockChangeResponse';
	IsBlocking = false;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateSupplierRequest extends DuplicateRequest<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSupplierRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateSupplierResponse extends DuplicateResponse<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSupplierResponse';
	IsBlocking = false;
	Data: SupplierForEditionDTO;
	constructor(_params: {
		data: SupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateSystemOfMeasurementRequest extends DuplicateRequest<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSystemOfMeasurementRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateSystemOfMeasurementResponse extends DuplicateResponse<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateSystemOfMeasurementResponse';
	IsBlocking = false;
	Data: SystemOfMeasurementForEditionDTO;
	constructor(_params: {
		data: SystemOfMeasurementForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateTablePaymentSettingsRequest extends DuplicateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateTablePaymentSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateTablePaymentSettingsResponse extends DuplicateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateTablePaymentSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateTimeFrameGroupRequest extends DuplicateRequest<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateTimeFrameGroupRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateTimeFrameGroupResponse extends DuplicateResponse<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateTimeFrameGroupResponse';
	IsBlocking = false;
	Data: TimeFrameGroupForEditionDTO;
	constructor(_params: {
		data: TimeFrameGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateUserProfileRequest extends DuplicateRequest<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateUserProfileRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateUserProfileResponse extends DuplicateResponse<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateUserProfileResponse';
	IsBlocking = false;
	Data: UserProfileForEditionDTO;
	constructor(_params: {
		data: UserProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateUserRequest extends DuplicateRequest<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateUserRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateUserResponse extends DuplicateResponse<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateUserResponse';
	IsBlocking = false;
	Data: UserForEditionDTO;
	constructor(_params: {
		data: UserForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateWarehouseRequest extends DuplicateRequest<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateWarehouseRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateWarehouseResponse extends DuplicateResponse<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateWarehouseResponse';
	IsBlocking = false;
	Data: WarehouseForEditionDTO;
	constructor(_params: {
		data: WarehouseForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateWorkingPeriodRequest extends DuplicateRequest<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateWorkingPeriodRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateWorkingPeriodResponse extends DuplicateResponse<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateWorkingPeriodResponse';
	IsBlocking = false;
	Data: WorkingPeriodForEditionDTO;
	constructor(_params: {
		data: WorkingPeriodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class DuplicateWorkplaceRequest extends DuplicateRequest<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateWorkplaceRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class DuplicateWorkplaceResponse extends DuplicateResponse<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.DuplicateWorkplaceResponse';
	IsBlocking = false;
	Data: WorkplaceForEditionDTO;
	constructor(_params: {
		data: WorkplaceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditActionDisplayProfileRequest extends EditRequest<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditActionDisplayProfileRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditActionDisplayProfileResponse extends EditResponse<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditActionDisplayProfileResponse';
	IsBlocking = false;
	Data: ActionDisplayProfileForEditionDTO;
	constructor(_params: {
		data: ActionDisplayProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditAllergenRequest extends EditRequest<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditAllergenRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditAllergenResponse extends EditResponse<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditAllergenResponse';
	IsBlocking = false;
	Data: AllergenForEditionDTO;
	constructor(_params: {
		data: AllergenForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCardProcessorSettingsRequest extends EditRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCardProcessorSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCardProcessorSettingsResponse extends EditResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCardProcessorSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCashControlSettingsRequest extends EditRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCashControlSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCashControlSettingsResponse extends EditResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCashControlSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCategoryRequest extends EditRequest<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCategoryRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCategoryResponse extends EditResponse<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCategoryResponse';
	IsBlocking = false;
	Data: CategoryForEditionDTO;
	constructor(_params: {
		data: CategoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCompanyRequest extends EditRequest<CompanyDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCompanyRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCompanyResponse extends EditResponse<CompanyDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCompanyResponse';
	IsBlocking = false;
	Data: CompanyDTO;
	constructor(_params: {
		data: CompanyDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCouponPrintTemplateRequest extends EditRequest<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCouponPrintTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCouponPrintTemplateResponse extends EditResponse<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCouponPrintTemplateResponse';
	IsBlocking = false;
	Data: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		data: CouponPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCouponSettingsRequest extends EditRequest<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCouponSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCouponSettingsResponse extends EditResponse<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCouponSettingsResponse';
	IsBlocking = false;
	Data: CouponSettingsForEditionDTO;
	constructor(_params: {
		data: CouponSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCustomActionButtonRequest extends EditRequest<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCustomActionButtonRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCustomActionButtonResponse extends EditResponse<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCustomActionButtonResponse';
	IsBlocking = false;
	Data: CustomActionButtonForEditionDTO;
	constructor(_params: {
		data: CustomActionButtonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCustomerRequest extends EditRequest<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCustomerRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCustomerResponse extends EditResponse<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCustomerResponse';
	IsBlocking = false;
	Data: CustomerForEditionDTO;
	constructor(_params: {
		data: CustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditCustomerTypeRequest extends EditRequest<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCustomerTypeRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditCustomerTypeResponse extends EditResponse<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditCustomerTypeResponse';
	IsBlocking = false;
	Data: CustomerTypeForEditionDTO;
	constructor(_params: {
		data: CustomerTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditDigitalMenuRequest extends EditRequest<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditDigitalMenuRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditDigitalMenuResponse extends EditResponse<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditDigitalMenuResponse';
	IsBlocking = false;
	Data: DigitalMenuForEditionDTO;
	constructor(_params: {
		data: DigitalMenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditEmailAccountRequest extends EditRequest<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.EditEmailAccountRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditEmailAccountResponse extends EditResponse<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.EditEmailAccountResponse';
	IsBlocking = false;
	Data: EmailAccountForEditionDTO;
	constructor(_params: {
		data: EmailAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditEmailingRequest extends EditRequest<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.EditEmailingRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditEmailingResponse extends EditResponse<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.EditEmailingResponse';
	IsBlocking = false;
	Data: EmailingForEditionDTO;
	constructor(_params: {
		data: EmailingForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditEscPosTemplateRequest extends EditRequest<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditEscPosTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditEscPosTemplateResponse extends EditResponse<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditEscPosTemplateResponse';
	IsBlocking = false;
	Data: EscPosTemplateForEditionDTO;
	constructor(_params: {
		data: EscPosTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditFamilyRequest extends EditRequest<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditFamilyRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditFamilyResponse extends EditResponse<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditFamilyResponse';
	IsBlocking = false;
	Data: FamilyForEditionDTO;
	constructor(_params: {
		data: FamilyForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditIncomingDeliveryNoteRequest extends EditRequest<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditIncomingDeliveryNoteRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditIncomingDeliveryNoteResponse extends EditResponse<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Data: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		data: IncomingDeliveryNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditInternalCustomerRequest extends EditRequest<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditInternalCustomerRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditInternalCustomerResponse extends EditResponse<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditInternalCustomerResponse';
	IsBlocking = false;
	Data: InternalCustomerForEditionDTO;
	constructor(_params: {
		data: InternalCustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditInternalSupplierRequest extends EditRequest<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditInternalSupplierRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditInternalSupplierResponse extends EditResponse<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditInternalSupplierResponse';
	IsBlocking = false;
	Data: InternalSupplierForEditionDTO;
	constructor(_params: {
		data: InternalSupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditInventoryRequest extends EditRequest<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditInventoryRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditInventoryResponse extends EditResponse<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditInventoryResponse';
	IsBlocking = false;
	Data: InventoryForEditionDTO;
	constructor(_params: {
		data: InventoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditKitchenDisplayRequest extends EditRequest<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditKitchenDisplayRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditKitchenDisplayResponse extends EditResponse<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditKitchenDisplayResponse';
	IsBlocking = false;
	Data: KitchenDisplayForEditionDTO;
	constructor(_params: {
		data: KitchenDisplayForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditKitchenPrintTemplateRequest extends EditRequest<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditKitchenPrintTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditKitchenPrintTemplateResponse extends EditResponse<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditKitchenPrintTemplateResponse';
	IsBlocking = false;
	Data: KitchenPrintTemplateForEditionDTO;
	constructor(_params: {
		data: KitchenPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditLabelRequest extends EditRequest<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditLabelRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditLabelResponse extends EditResponse<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditLabelResponse';
	IsBlocking = false;
	Data: LabelForEditionDTO;
	constructor(_params: {
		data: LabelForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditLineCancellationReasonRequest extends EditRequest<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditLineCancellationReasonRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditLineCancellationReasonResponse extends EditResponse<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditLineCancellationReasonResponse';
	IsBlocking = false;
	Data: LineCancellationReasonForEditionDTO;
	constructor(_params: {
		data: LineCancellationReasonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditLotRequest extends EditRequest<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditLotRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditLotResponse extends EditResponse<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditLotResponse';
	IsBlocking = false;
	Data: LotForEditionDTO;
	constructor(_params: {
		data: LotForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditMajorGroupRequest extends EditRequest<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMajorGroupRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditMajorGroupResponse extends EditResponse<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMajorGroupResponse';
	IsBlocking = false;
	Data: MajorGroupForEditionDTO;
	constructor(_params: {
		data: MajorGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditMapRequest extends EditRequest<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMapRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditMapResponse extends EditResponse<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMapResponse';
	IsBlocking = false;
	Data: MapForEditionDTO;
	constructor(_params: {
		data: MapForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditMenuRequest extends EditRequest<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMenuRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditMenuResponse extends EditResponse<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMenuResponse';
	IsBlocking = false;
	Data: MenuForEditionDTO;
	constructor(_params: {
		data: MenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditMyAgoraAccountRequest extends EditRequest<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMyAgoraAccountRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditMyAgoraAccountResponse extends EditResponse<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditMyAgoraAccountResponse';
	IsBlocking = false;
	Data: MyAgoraAccountForEditionDTO;
	constructor(_params: {
		data: MyAgoraAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditNamedDiscountRequest extends EditRequest<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditNamedDiscountRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditNamedDiscountResponse extends EditResponse<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditNamedDiscountResponse';
	IsBlocking = false;
	Data: NamedDiscountForEditionDTO;
	constructor(_params: {
		data: NamedDiscountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditOfferRequest extends EditRequest<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditOfferRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditOfferResponse extends EditResponse<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditOfferResponse';
	IsBlocking = false;
	Data: OfferForEditionDTO;
	constructor(_params: {
		data: OfferForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPaymentMethodRequest extends EditRequest<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPaymentMethodRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPaymentMethodResponse extends EditResponse<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPaymentMethodResponse';
	IsBlocking = false;
	Data: PaymentMethodForEditionDTO;
	constructor(_params: {
		data: PaymentMethodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPosGroupRequest extends EditRequest<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPosGroupRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPosGroupResponse extends EditResponse<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPosGroupResponse';
	IsBlocking = false;
	Data: PosGroupForEditionDTO;
	constructor(_params: {
		data: PosGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPosRequest extends EditRequest<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPosRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPosResponse extends EditResponse<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPosResponse';
	IsBlocking = false;
	Data: PosForEditionDTO;
	constructor(_params: {
		data: PosForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPredefinedNoteRequest extends EditRequest<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPredefinedNoteRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPredefinedNoteResponse extends EditResponse<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPredefinedNoteResponse';
	IsBlocking = false;
	Data: PredefinedNoteForEditionDTO;
	constructor(_params: {
		data: PredefinedNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPreparationOrderRequest extends EditRequest<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPreparationOrderRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPreparationOrderResponse extends EditResponse<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPreparationOrderResponse';
	IsBlocking = false;
	Data: PreparationOrderForEditionDTO;
	constructor(_params: {
		data: PreparationOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPreparationTypeRequest extends EditRequest<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPreparationTypeRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPreparationTypeResponse extends EditResponse<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPreparationTypeResponse';
	IsBlocking = false;
	Data: PreparationTypeForEditionDTO;
	constructor(_params: {
		data: PreparationTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPriceListRequest extends EditRequest<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPriceListRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPriceListResponse extends EditResponse<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditPriceListResponse';
	IsBlocking = false;
	Data: PriceListForEditionDTO;
	constructor(_params: {
		data: PriceListForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditProductionRequest extends EditRequest<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditProductionRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditProductionResponse extends EditResponse<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditProductionResponse';
	IsBlocking = false;
	Data: ProductionForEditionDTO;
	constructor(_params: {
		data: ProductionForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditProductRequest extends EditRequest<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditProductRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditProductResponse extends EditResponse<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditProductResponse';
	IsBlocking = false;
	Data: ProductForEditionDTO;
	constructor(_params: {
		data: ProductForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditProductTagRequest extends EditRequest<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditProductTagRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditProductTagResponse extends EditResponse<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditProductTagResponse';
	IsBlocking = false;
	Data: ProductTagForEditionDTO;
	constructor(_params: {
		data: ProductTagForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPurchaseInvoiceRequest extends EditRequest<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditPurchaseInvoiceRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPurchaseInvoiceResponse extends EditResponse<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditPurchaseInvoiceResponse';
	IsBlocking = false;
	Data: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		data: PurchaseInvoiceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditPurchaseOrderRequest extends EditRequest<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditPurchaseOrderRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditPurchaseOrderResponse extends EditResponse<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditPurchaseOrderResponse';
	IsBlocking = false;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditRdlTemplateRequest extends EditRequest<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditRdlTemplateRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditRdlTemplateResponse extends EditResponse<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditRdlTemplateResponse';
	IsBlocking = false;
	Data: RdlTemplateForEditionDTO;
	constructor(_params: {
		data: RdlTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditSaleCenterRequest extends EditRequest<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSaleCenterRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditSaleCenterResponse extends EditResponse<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSaleCenterResponse';
	IsBlocking = false;
	Data: SaleCenterForEditionDTO;
	constructor(_params: {
		data: SaleCenterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditScaleCounterRequest extends EditRequest<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditScaleCounterRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditScaleCounterResponse extends EditResponse<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditScaleCounterResponse';
	IsBlocking = false;
	Data: ScaleCounterForEditionDTO;
	constructor(_params: {
		data: ScaleCounterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditSerieRequest extends EditRequest<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSerieRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditSerieResponse extends EditResponse<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSerieResponse';
	IsBlocking = false;
	Data: SerieForEditionDTO;
	constructor(_params: {
		data: SerieForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditSifSettingsRequest extends EditRequest<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSifSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditSifSettingsResponse extends EditResponse<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSifSettingsResponse';
	IsBlocking = false;
	Data: SifSettingsForEditionDTO;
	constructor(_params: {
		data: SifSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditSmartMenuOrderSettingsRequest extends EditRequest<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSmartMenuOrderSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditSmartMenuOrderSettingsResponse extends EditResponse<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	Data: SmartMenuOrderSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuOrderSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditSmartMenuWorkplaceGroupSettingsRequest extends EditRequest<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSmartMenuWorkplaceGroupSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditSmartMenuWorkplaceGroupSettingsResponse extends EditResponse<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSmartMenuWorkplaceGroupSettingsResponse';
	IsBlocking = false;
	Data: SmartMenuWorkplaceGroupSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuWorkplaceGroupSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditStockChangeRequest extends EditRequest<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditStockChangeRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditStockChangeResponse extends EditResponse<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.EditStockChangeResponse';
	IsBlocking = false;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditSupplierRequest extends EditRequest<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSupplierRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditSupplierResponse extends EditResponse<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSupplierResponse';
	IsBlocking = false;
	Data: SupplierForEditionDTO;
	constructor(_params: {
		data: SupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditSystemOfMeasurementRequest extends EditRequest<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSystemOfMeasurementRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditSystemOfMeasurementResponse extends EditResponse<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditSystemOfMeasurementResponse';
	IsBlocking = false;
	Data: SystemOfMeasurementForEditionDTO;
	constructor(_params: {
		data: SystemOfMeasurementForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditTablePaymentSettingsRequest extends EditRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditTablePaymentSettingsRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditTablePaymentSettingsResponse extends EditResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditTablePaymentSettingsResponse';
	IsBlocking = false;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditTimeFrameGroupRequest extends EditRequest<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditTimeFrameGroupRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditTimeFrameGroupResponse extends EditResponse<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditTimeFrameGroupResponse';
	IsBlocking = false;
	Data: TimeFrameGroupForEditionDTO;
	constructor(_params: {
		data: TimeFrameGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditUserProfileRequest extends EditRequest<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditUserProfileRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditUserProfileResponse extends EditResponse<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditUserProfileResponse';
	IsBlocking = false;
	Data: UserProfileForEditionDTO;
	constructor(_params: {
		data: UserProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditUserRequest extends EditRequest<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditUserRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditUserResponse extends EditResponse<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditUserResponse';
	IsBlocking = false;
	Data: UserForEditionDTO;
	constructor(_params: {
		data: UserForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditVatRequest extends EditRequest<VatCollectionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditVatRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditVatResponse extends EditResponse<VatCollectionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditVatResponse';
	IsBlocking = false;
	Data: VatCollectionDTO;
	constructor(_params: {
		data: VatCollectionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditWarehouseRequest extends EditRequest<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWarehouseRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditWarehouseResponse extends EditResponse<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWarehouseResponse';
	IsBlocking = false;
	Data: WarehouseForEditionDTO;
	constructor(_params: {
		data: WarehouseForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditWebAdminRequest extends EditRequest<WebAdminForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWebAdminRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditWebAdminResponse extends EditResponse<WebAdminForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWebAdminResponse';
	IsBlocking = false;
	Data: WebAdminForEditionDTO;
	constructor(_params: {
		data: WebAdminForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditWorkingPeriodRequest extends EditRequest<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWorkingPeriodRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditWorkingPeriodResponse extends EditResponse<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWorkingPeriodResponse';
	IsBlocking = false;
	Data: WorkingPeriodForEditionDTO;
	constructor(_params: {
		data: WorkingPeriodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class EditWorkplaceRequest extends EditRequest<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWorkplaceRequest';
	IsBlocking = false;
	Id: number;
	constructor(_params: {
		id: number
	}) {
		super({id: _params.id});
		this.Id = _params.id;
	}
}

export class EditWorkplaceResponse extends EditResponse<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.EditWorkplaceResponse';
	IsBlocking = false;
	Data: WorkplaceForEditionDTO;
	constructor(_params: {
		data: WorkplaceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class GetAllActionDisplayProfilesRequest extends GetAllRequest<ActionDisplayProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllActionDisplayProfilesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllActionDisplayProfilesResponse extends GetAllResponse<ActionDisplayProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllActionDisplayProfilesResponse';
	IsBlocking = false;
	All: ActionDisplayProfileInListDTO[];
	constructor(_params: {
		all: ActionDisplayProfileInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllAllergensRequest extends GetAllRequest<AllergenInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllAllergensRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllAllergensResponse extends GetAllResponse<AllergenInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllAllergensResponse';
	IsBlocking = false;
	All: AllergenInListDTO[];
	constructor(_params: {
		all: AllergenInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllCardProcessorSettingsRequest extends GetAllRequest<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCardProcessorSettingsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCardProcessorSettingsResponse extends GetAllResponse<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCardProcessorSettingsResponse';
	IsBlocking = false;
	All: SettingsFileInListDTO[];
	constructor(_params: {
		all: SettingsFileInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllCashControlSettingsRequest extends GetAllRequest<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCashControlSettingsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCashControlSettingsResponse extends GetAllResponse<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCashControlSettingsResponse';
	IsBlocking = false;
	All: SettingsFileInListDTO[];
	constructor(_params: {
		all: SettingsFileInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllCategoriesRequest extends GetAllRequest<CategoryInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCategoriesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCategoriesResponse extends GetAllResponse<CategoryInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCategoriesResponse';
	IsBlocking = false;
	All: CategoryInListDTO[];
	constructor(_params: {
		all: CategoryInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllCouponPrintTemplatesRequest extends GetAllRequest<CouponPrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCouponPrintTemplatesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCouponSettingsRequest extends GetAllRequest<CouponSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCouponSettingsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCouponSettingsResponse extends GetAllResponse<CouponSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCouponSettingsResponse';
	IsBlocking = false;
	All: CouponSettingsInListDTO[];
	constructor(_params: {
		all: CouponSettingsInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllCustomActionButtonsRequest extends GetAllRequest<CustomActionButtonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCustomActionButtonsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCustomActionButtonsResponse extends GetAllResponse<CustomActionButtonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCustomActionButtonsResponse';
	IsBlocking = false;
	All: CustomActionButtonInListDTO[];
	constructor(_params: {
		all: CustomActionButtonInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllCustomersRequest extends GetAllRequest<CustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCustomersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCustomersResponse extends GetAllResponse<CustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCustomersResponse';
	IsBlocking = false;
	All: CustomerInListDTO[];
	constructor(_params: {
		all: CustomerInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllCustomerTypesRequest extends GetAllRequest<CustomerTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCustomerTypesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllCustomerTypesResponse extends GetAllResponse<CustomerTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllCustomerTypesResponse';
	IsBlocking = false;
	All: CustomerTypeInListDTO[];
	constructor(_params: {
		all: CustomerTypeInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllDigitalMenusRequest extends GetAllRequest<DigitalMenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllDigitalMenusRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllDigitalMenusResponse extends GetAllResponse<DigitalMenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllDigitalMenusResponse';
	IsBlocking = false;
	All: DigitalMenuInListDTO[];
	constructor(_params: {
		all: DigitalMenuInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllEditableUsersRequest extends GetAllRequest<UserInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllEditableUsersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllEditableUsersResponse extends GetAllResponse<UserInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllEditableUsersResponse';
	IsBlocking = false;
	All: UserInListDTO[];
	constructor(_params: {
		all: UserInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllEmailAccountsRequest extends GetAllRequest<EmailAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetAllEmailAccountsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllEmailAccountsResponse extends GetAllResponse<EmailAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetAllEmailAccountsResponse';
	IsBlocking = false;
	All: EmailAccountInListDTO[];
	constructor(_params: {
		all: EmailAccountInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllEmailingsRequest extends GetAllRequest<EmailingInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetAllEmailingsRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllEmailingsResponse extends GetAllResponse<EmailingInListDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.GetAllEmailingsResponse';
	IsBlocking = false;
	All: EmailingInListDTO[];
	constructor(_params: {
		all: EmailingInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllFamiliesRequest extends GetAllRequest<FamilyInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllFamiliesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllFamiliesResponse extends GetAllResponse<FamilyInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllFamiliesResponse';
	IsBlocking = false;
	All: FamilyInListDTO[];
	constructor(_params: {
		all: FamilyInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllIncomingDeliveryNotesRequest extends GetAllRequest<IncomingDeliveryNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllIncomingDeliveryNotesRequest';
	IsBlocking = true;
	IncludeOnlyDrafts: boolean;
	MaxNotes: Nullable<number>;
	constructor(_params: {
		includeOnlyDrafts: boolean,
		maxNotes: Nullable<number>
	}) {
		super({includeOnlyDrafts: _params.includeOnlyDrafts,maxNotes: _params.maxNotes});
		this.IncludeOnlyDrafts = _params.includeOnlyDrafts;
		this.MaxNotes = _params.maxNotes;
	}
}

export class GetAllIncomingDeliveryNotesResponse extends GetAllResponse<IncomingDeliveryNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllIncomingDeliveryNotesResponse';
	IsBlocking = false;
	All: IncomingDeliveryNoteInListDTO[];
	constructor(_params: {
		all: IncomingDeliveryNoteInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllInternalCustomersRequest extends GetAllRequest<InternalCustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllInternalCustomersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllInternalCustomersResponse extends GetAllResponse<InternalCustomerInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllInternalCustomersResponse';
	IsBlocking = false;
	All: InternalCustomerInListDTO[];
	constructor(_params: {
		all: InternalCustomerInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllInternalSuppliersRequest extends GetAllRequest<InternalSupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllInternalSuppliersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllInternalSuppliersResponse extends GetAllResponse<InternalSupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllInternalSuppliersResponse';
	IsBlocking = false;
	All: InternalSupplierInListDTO[];
	constructor(_params: {
		all: InternalSupplierInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllInventoriesRequest extends GetAllRequest<InventoryInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllInventoriesRequest';
	IsBlocking = true;
	IncludeOnlyDraft: boolean;
	constructor(_params: {
		includeOnlyDraft: boolean
	}) {
		super({includeOnlyDraft: _params.includeOnlyDraft});
		this.IncludeOnlyDraft = _params.includeOnlyDraft;
	}
}

export class GetAllInventoriesResponse extends GetAllResponse<InventoryInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllInventoriesResponse';
	IsBlocking = false;
	All: InventoryInListDTO[];
	constructor(_params: {
		all: InventoryInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllKitchenDisplaysRequest extends GetAllRequest<KitchenDisplayInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllKitchenDisplaysRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllKitchenDisplaysResponse extends GetAllResponse<KitchenDisplayInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllKitchenDisplaysResponse';
	IsBlocking = false;
	All: KitchenDisplayInListDTO[];
	constructor(_params: {
		all: KitchenDisplayInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllKitchenPrintTemplateRequest extends GetAllRequest<KitchenPrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllKitchenPrintTemplateRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllKitchenPrintTemplateResponse extends GetAllResponse<KitchenPrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllKitchenPrintTemplateResponse';
	IsBlocking = false;
	All: KitchenPrintTemplateInListDTO[];
	constructor(_params: {
		all: KitchenPrintTemplateInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllLabelsRequest extends GetAllRequest<LabelInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllLabelsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllLabelsResponse extends GetAllResponse<LabelInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllLabelsResponse';
	IsBlocking = false;
	All: LabelInListDTO[];
	constructor(_params: {
		all: LabelInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllLineCancellationReasonsRequest extends GetAllRequest<LineCancellationReasonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllLineCancellationReasonsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllLineCancellationReasonsResponse extends GetAllResponse<LineCancellationReasonInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllLineCancellationReasonsResponse';
	IsBlocking = false;
	All: LineCancellationReasonInListDTO[];
	constructor(_params: {
		all: LineCancellationReasonInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllMajorGroupsRequest extends GetAllRequest<MajorGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMajorGroupsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllMajorGroupsResponse extends GetAllResponse<MajorGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMajorGroupsResponse';
	IsBlocking = false;
	All: MajorGroupInListDTO[];
	constructor(_params: {
		all: MajorGroupInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllMapsRequest extends GetAllRequest<MapInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMapsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllMapsResponse extends GetAllResponse<MapInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMapsResponse';
	IsBlocking = false;
	All: MapInListDTO[];
	constructor(_params: {
		all: MapInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllMenusRequest extends GetAllRequest<MenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMenusRequest';
	IsBlocking = true;
	IncludePrices: boolean;
	MaxProducts: number;
	constructor(_params: {
		maxProducts: number,
		includePrices: boolean
	}) {
		super({includePrices: _params.includePrices,maxProducts: _params.maxProducts});
		this.MaxProducts = _params.maxProducts;
		this.IncludePrices = _params.includePrices;
	}
}

export class GetAllMenusResponse extends GetAllResponse<MenuInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMenusResponse';
	IsBlocking = false;
	All: MenuInListDTO[];
	constructor(_params: {
		all: MenuInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllMyAgoraAccountsRequest extends GetAllRequest<MyAgoraAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMyAgoraAccountsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllMyAgoraAccountsResponse extends GetAllResponse<MyAgoraAccountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllMyAgoraAccountsResponse';
	IsBlocking = false;
	All: MyAgoraAccountInListDTO[];
	constructor(_params: {
		all: MyAgoraAccountInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllNamedDiscountsRequest extends GetAllRequest<NamedDiscountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllNamedDiscountsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllNamedDiscountsResponse extends GetAllResponse<NamedDiscountInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllNamedDiscountsResponse';
	IsBlocking = false;
	All: NamedDiscountInListDTO[];
	constructor(_params: {
		all: NamedDiscountInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllOffersRequest extends GetAllRequest<OfferInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllOffersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllOffersResponse extends GetAllResponse<OfferInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllOffersResponse';
	IsBlocking = false;
	All: OfferInListDTO[];
	constructor(_params: {
		all: OfferInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPaymentMethodsRequest extends GetAllRequest<PaymentMethodInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPaymentMethodsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPaymentMethodsResponse extends GetAllResponse<PaymentMethodInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPaymentMethodsResponse';
	IsBlocking = false;
	All: PaymentMethodInListDTO[];
	constructor(_params: {
		all: PaymentMethodInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPendingTransfersRequest extends GetAllRequest<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllPendingTransfersRequest';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPendingTransfersResponse extends GetAllResponse<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllPendingTransfersResponse';
	IsBlocking = false;
	All: StockChangeInListDTO[];
	constructor(_params: {
		all: StockChangeInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPosGroupsRequest extends GetAllRequest<PosGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPosGroupsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPosGroupsResponse extends GetAllResponse<PosGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPosGroupsResponse';
	IsBlocking = false;
	All: PosGroupInListDTO[];
	constructor(_params: {
		all: PosGroupInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPosRequest extends GetAllRequest<PosInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPosRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPosResponse extends GetAllResponse<PosInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPosResponse';
	IsBlocking = false;
	All: PosInListDTO[];
	constructor(_params: {
		all: PosInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPredefinedNotesRequest extends GetAllRequest<PredefinedNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPredefinedNotesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPredefinedNotesResponse extends GetAllResponse<PredefinedNoteInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPredefinedNotesResponse';
	IsBlocking = false;
	All: PredefinedNoteInListDTO[];
	constructor(_params: {
		all: PredefinedNoteInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPreparationOrdersRequest extends GetAllRequest<PreparationOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPreparationOrdersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPreparationOrdersResponse extends GetAllResponse<PreparationOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPreparationOrdersResponse';
	IsBlocking = false;
	All: PreparationOrderInListDTO[];
	constructor(_params: {
		all: PreparationOrderInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPreparationTypesRequest extends GetAllRequest<PreparationTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPreparationTypesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPreparationTypesResponse extends GetAllResponse<PreparationTypeInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPreparationTypesResponse';
	IsBlocking = false;
	All: PreparationTypeInListDTO[];
	constructor(_params: {
		all: PreparationTypeInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPriceListRequest extends GetAllRequest<PriceListInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPriceListRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPriceListResponse extends GetAllResponse<PriceListInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPriceListResponse';
	IsBlocking = false;
	All: PriceListInListDTO[];
	constructor(_params: {
		all: PriceListInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPrintTemplatesRequest extends GetAllRequest<PrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPrintTemplatesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPrintTemplatesResponse extends GetAllResponse<PrintTemplateInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllPrintTemplatesResponse';
	IsBlocking = false;
	All: PrintTemplateInListDTO[];
	constructor(_params: {
		all: PrintTemplateInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllProductionsRequest extends GetAllRequest<ProductionInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllProductionsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllproductionsResponse extends GetAllResponse<ProductionInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllproductionsResponse';
	IsBlocking = false;
	All: ProductionInListDTO[];
	constructor(_params: {
		all: ProductionInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllProductsRequest extends GetAllRequest<ProductInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllProductsRequest';
	IsBlocking = true;
	IncludePrices: boolean;
	MaxProducts: number;
	constructor(_params: {
		maxProducts: number,
		includePrices: boolean
	}) {
		super({includePrices: _params.includePrices,maxProducts: _params.maxProducts});
		this.MaxProducts = _params.maxProducts;
		this.IncludePrices = _params.includePrices;
	}
}

export class GetAllProductsResponse extends GetAllResponse<ProductInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllProductsResponse';
	IsBlocking = false;
	All: ProductInListDTO[];
	constructor(_params: {
		all: ProductInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllProductTagsRequest extends GetAllRequest<ProductTagInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllProductTagsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllProductTagsResponse extends GetAllResponse<ProductTagInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllProductTagsResponse';
	IsBlocking = false;
	All: ProductTagInListDTO[];
	constructor(_params: {
		all: ProductTagInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPurchaseInvoicesRequest extends GetAllRequest<PurchaseInvoiceInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllPurchaseInvoicesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllPurchaseInvoicesResponse extends GetAllResponse<PurchaseInvoiceInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllPurchaseInvoicesResponse';
	IsBlocking = false;
	All: PurchaseInvoiceInListDTO[];
	constructor(_params: {
		all: PurchaseInvoiceInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllPurchaseOrdersRequest extends GetAllRequest<PurchaseOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllPurchaseOrdersRequest';
	IsBlocking = true;
	IgnoreDeliveredOrders: boolean;
	MaxOrders: Nullable<number>;
	constructor(_params: {
		ignoreDeliveredOrders: boolean,
		maxOrders: Nullable<number>
	}) {
		super({ignoreDeliveredOrders: _params.ignoreDeliveredOrders,maxOrders: _params.maxOrders});
		this.IgnoreDeliveredOrders = _params.ignoreDeliveredOrders;
		this.MaxOrders = _params.maxOrders;
	}
}

export class GetAllPurchaseOrdersResponse extends GetAllResponse<PurchaseOrderInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllPurchaseOrdersResponse';
	IsBlocking = false;
	All: PurchaseOrderInListDTO[];
	constructor(_params: {
		all: PurchaseOrderInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllSaleCentersRequest extends GetAllRequest<SaleCenterInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSaleCentersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSaleCentersResponse extends GetAllResponse<SaleCenterInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSaleCentersResponse';
	IsBlocking = false;
	All: SaleCenterInListDTO[];
	constructor(_params: {
		all: SaleCenterInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllScaleCounterRequest extends GetAllRequest<ScaleCounterInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllScaleCounterRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSeriesRequest extends GetAllRequest<SerieInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSeriesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSeriesResponse extends GetAllResponse<SerieInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSeriesResponse';
	IsBlocking = false;
	All: SerieInListDTO[];
	constructor(_params: {
		all: SerieInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllSifSettingsRequest extends GetAllRequest<SifSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSifSettingsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSifSettingsResponse extends GetAllResponse<SifSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSifSettingsResponse';
	IsBlocking = false;
	All: SifSettingsInListDTO[];
	constructor(_params: {
		all: SifSettingsInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllSmartMenuOrderSettingsRequest extends GetAllRequest<SmartMenuOrderSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSmartMenuOrderSettingsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSmartMenuOrderSettingsResponse extends GetAllResponse<SmartMenuOrderSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	All: SmartMenuOrderSettingsInListDTO[];
	constructor(_params: {
		all: SmartMenuOrderSettingsInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllSmartMenuWorkplaceGroupSettingsRequest extends GetAllRequest<SmartMenuWorkplaceGroupSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSmartMenuWorkplaceGroupSettingsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSmartMenuWorkplaceGroupSettingsResponse extends GetAllResponse<SmartMenuWorkplaceGroupSettingsInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSmartMenuWorkplaceGroupSettingsResponse';
	IsBlocking = false;
	All: SmartMenuWorkplaceGroupSettingsInListDTO[];
	constructor(_params: {
		all: SmartMenuWorkplaceGroupSettingsInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllStockChangesRequest extends GetAllRequest<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllStockChangesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllStockChangesResponse extends GetAllResponse<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllStockChangesResponse';
	IsBlocking = false;
	All: StockChangeInListDTO[];
	constructor(_params: {
		all: StockChangeInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllSuppliersRequest extends GetAllRequest<SupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSuppliersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSuppliersResponse extends GetAllResponse<SupplierInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSuppliersResponse';
	IsBlocking = false;
	All: SupplierInListDTO[];
	constructor(_params: {
		all: SupplierInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllSystemOfMeasurementsRequest extends GetAllRequest<SystemOfMeasurementInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSystemOfMeasurementsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllSystemOfMeasurementsResponse extends GetAllResponse<SystemOfMeasurementInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllSystemOfMeasurementsResponse';
	IsBlocking = false;
	All: SystemOfMeasurementInListDTO[];
	constructor(_params: {
		all: SystemOfMeasurementInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllTablePaymentSettingsRequest extends GetAllRequest<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllTablePaymentSettingsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllTablePaymentSettingsResponse extends GetAllResponse<SettingsFileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllTablePaymentSettingsResponse';
	IsBlocking = false;
	All: SettingsFileInListDTO[];
	constructor(_params: {
		all: SettingsFileInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllTimeFrameGroupsRequest extends GetAllRequest<TimeFrameGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllTimeFrameGroupsRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllTimeFrameGroupsResponse extends GetAllResponse<TimeFrameGroupInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllTimeFrameGroupsResponse';
	IsBlocking = false;
	All: TimeFrameGroupInListDTO[];
	constructor(_params: {
		all: TimeFrameGroupInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllUserProfilesRequest extends GetAllRequest<UserProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllUserProfilesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllUserProfilesResponse extends GetAllResponse<UserProfileInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllUserProfilesResponse';
	IsBlocking = false;
	All: UserProfileInListDTO[];
	constructor(_params: {
		all: UserProfileInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllUsersRequest extends GetAllRequest<UserInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllUsersRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllUsersResponse extends GetAllResponse<UserInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllUsersResponse';
	IsBlocking = false;
	All: UserInListDTO[];
	constructor(_params: {
		all: UserInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllWarehouseCloseOutRequest extends GetAllRequest<WarehouseCloseOutInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllWarehouseCloseOutRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllWarehouseCloseOutResponse extends GetAllResponse<WarehouseCloseOutInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetAllWarehouseCloseOutResponse';
	IsBlocking = false;
	All: WarehouseCloseOutInListDTO[];
	constructor(_params: {
		all: WarehouseCloseOutInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllWarehousesRequest extends GetAllRequest<WarehouseInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWarehousesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllWarehousesResponse extends GetAllResponse<WarehouseInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWarehousesResponse';
	IsBlocking = false;
	All: WarehouseInListDTO[];
	constructor(_params: {
		all: WarehouseInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetAllWorkplacesRequest extends GetAllRequest<WorkplaceInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWorkplacesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetAllWorkplacesResponse extends GetAllResponse<WorkplaceInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetAllWorkplacesResponse';
	IsBlocking = false;
	All: WorkplaceInListDTO[];
	constructor(_params: {
		all: WorkplaceInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetCategoriesByUserResponse extends GetAllByUserResponse<CategoryByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCategoriesByUserResponse';
	IsBlocking = false;
	All: CategoryByUserDTO[];
	constructor(_params: {
		all: CategoryByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetCategoriesByWarehouseResponse extends GetAllByUserResponse<CategoryInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetCategoriesByWarehouseResponse';
	IsBlocking = false;
	All: CategoryInListDTO[];
	constructor(_params: {
		all: CategoryInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetEmailAccountsByUserResponse extends GetAllByUserResponse<EmailAccountByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetEmailAccountsByUserResponse';
	IsBlocking = false;
	All: EmailAccountByUserDTO[];
	constructor(_params: {
		all: EmailAccountByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetFamiliesByUserResponse extends GetAllByUserResponse<FamilyByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetFamiliesByUserResponse';
	IsBlocking = false;
	All: FamilyByUserDTO[];
	constructor(_params: {
		all: FamilyByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetFamiliesByWarehouseResponse extends GetAllByUserResponse<FamilyInListDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetFamiliesByWarehouseResponse';
	IsBlocking = false;
	All: FamilyInListDTO[];
	constructor(_params: {
		all: FamilyInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetLastLossesRequest extends GetAllRequest<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetLastLossesRequest';
	IsBlocking = true;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class GetLastLossesResponse extends GetAllResponse<StockChangeInListDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.GetLastLossesResponse';
	IsBlocking = false;
	All: StockChangeInListDTO[];
	constructor(_params: {
		all: StockChangeInListDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetPosGroupsByUserResponse extends GetAllByUserResponse<PosGroupByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetPosGroupsByUserResponse';
	IsBlocking = false;
	All: PosGroupByUserDTO[];
	constructor(_params: {
		all: PosGroupByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetSaleCentersByUserResponse extends GetAllByUserResponse<SaleCenterByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSaleCentersByUserResponse';
	IsBlocking = false;
	All: SaleCenterByUserDTO[];
	constructor(_params: {
		all: SaleCenterByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetSuppliersByUserResponse extends GetAllByUserResponse<SupplierByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetSuppliersByUserResponse';
	IsBlocking = false;
	All: SupplierByUserDTO[];
	constructor(_params: {
		all: SupplierByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetUsersByUserResponse extends GetAllByUserResponse<UserByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetUsersByUserResponse';
	IsBlocking = false;
	All: UserByUserDTO[];
	constructor(_params: {
		all: UserByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetWarehousesByUserResponse extends GetAllByUserResponse<WarehouseByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetWarehousesByUserResponse';
	IsBlocking = false;
	All: WarehouseByUserDTO[];
	constructor(_params: {
		all: WarehouseByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class GetWorkplacesByUserResponse extends GetAllByUserResponse<WorkplaceByUserDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.GetWorkplacesByUserResponse';
	IsBlocking = false;
	All: WorkplaceByUserDTO[];
	constructor(_params: {
		all: WorkplaceByUserDTO[]
	}) {
		super({all: _params.all});
		this.All = _params.all;
	}
}

export class SaveActionDisplayProfileRequest extends SaveRequest<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveActionDisplayProfileRequest';
	IsBlocking = true;
	Data: ActionDisplayProfileForEditionDTO;
	constructor(_params: {
		data: ActionDisplayProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveActionDisplayProfileResponse extends SaveResponse<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveActionDisplayProfileResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveAllergenRequest extends SaveRequest<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveAllergenRequest';
	IsBlocking = true;
	Data: AllergenForEditionDTO;
	constructor(_params: {
		data: AllergenForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveAllergenResponse extends SaveResponse<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveAllergenResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCardProcessorSettingsRequest extends SaveRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCardProcessorSettingsRequest';
	IsBlocking = true;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCardProcessorSettingsResponse extends SaveResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCardProcessorSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCashControlSettingsRequest extends SaveRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCashControlSettingsRequest';
	IsBlocking = true;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCashControlSettingsResponse extends SaveResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCashControlSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCategoryRequest extends SaveRequest<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCategoryRequest';
	IsBlocking = true;
	Data: CategoryForEditionDTO;
	constructor(_params: {
		data: CategoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCategoryResponse extends SaveResponse<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCategoryResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCompanyRequest extends SaveRequest<CompanyDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCompanyRequest';
	IsBlocking = true;
	Data: CompanyDTO;
	constructor(_params: {
		data: CompanyDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCompanyResponse extends SaveResponse<CompanyDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCompanyResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCouponPrintTemplateRequest extends SaveRequest<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCouponPrintTemplateRequest';
	IsBlocking = true;
	Data: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		data: CouponPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCouponPrintTemplateResponse extends SaveResponse<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCouponPrintTemplateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCouponSettingsRequest extends SaveRequest<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCouponSettingsRequest';
	IsBlocking = true;
	Data: CouponSettingsForEditionDTO;
	constructor(_params: {
		data: CouponSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCouponSettingsResponse extends SaveResponse<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCouponSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCustomActionButtonRequest extends SaveRequest<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCustomActionButtonRequest';
	IsBlocking = true;
	Data: CustomActionButtonForEditionDTO;
	constructor(_params: {
		data: CustomActionButtonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCustomActionButtonResponse extends SaveResponse<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCustomActionButtonResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveCustomerRequest extends SaveRequest<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCustomerRequest';
	IsBlocking = true;
	Data: CustomerForEditionDTO;
	constructor(_params: {
		data: CustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCustomerResponse extends SaveResponse<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCustomerResponse';
	IsBlocking = false;
	Data: CustomerForEditionDTO;
	constructor(_params: {
		data: CustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCustomerTypeRequest extends SaveRequest<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCustomerTypeRequest';
	IsBlocking = true;
	Data: CustomerTypeForEditionDTO;
	constructor(_params: {
		data: CustomerTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveCustomerTypeResponse extends SaveResponse<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveCustomerTypeResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveDigitalMenuRequest extends SaveRequest<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveDigitalMenuRequest';
	IsBlocking = true;
	Data: DigitalMenuForEditionDTO;
	constructor(_params: {
		data: DigitalMenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveDigitalMenuResponse extends SaveResponse<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveDigitalMenuResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveEmailAccountRequest extends SaveRequest<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.SaveEmailAccountRequest';
	IsBlocking = true;
	Data: EmailAccountForEditionDTO;
	constructor(_params: {
		data: EmailAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveEmailAccountResponse extends SaveResponse<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.SaveEmailAccountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveEmailingRequest extends SaveRequest<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.SaveEmailingRequest';
	IsBlocking = true;
	Data: EmailingForEditionDTO;
	constructor(_params: {
		data: EmailingForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveEmailingResponse extends SaveResponse<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.SaveEmailingResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveEscPosTemplateRequest extends SaveRequest<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveEscPosTemplateRequest';
	IsBlocking = true;
	Data: EscPosTemplateForEditionDTO;
	constructor(_params: {
		data: EscPosTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveEscPosTemplateResponse extends SaveResponse<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveEscPosTemplateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveFamilyRequest extends SaveRequest<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveFamilyRequest';
	IsBlocking = true;
	Data: FamilyForEditionDTO;
	constructor(_params: {
		data: FamilyForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveFamilyResponse extends SaveResponse<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveFamilyResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveIncomingDeliveryNoteRequest extends SaveRequest<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveIncomingDeliveryNoteRequest';
	IsBlocking = true;
	Data: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		data: IncomingDeliveryNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveIncomingDeliveryNoteResponse extends SaveResponse<IncomingDeliveryNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveIncomingDeliveryNoteResponse';
	IsBlocking = false;
	Data: IncomingDeliveryNoteForEditionDTO;
	constructor(_params: {
		data: IncomingDeliveryNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveInternalCustomerRequest extends SaveRequest<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveInternalCustomerRequest';
	IsBlocking = true;
	Data: InternalCustomerForEditionDTO;
	constructor(_params: {
		data: InternalCustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveInternalCustomerResponse extends SaveResponse<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveInternalCustomerResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveInternalSupplierRequest extends SaveRequest<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveInternalSupplierRequest';
	IsBlocking = true;
	Data: InternalSupplierForEditionDTO;
	constructor(_params: {
		data: InternalSupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveInternalSupplierResponse extends SaveResponse<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveInternalSupplierResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveInventoryRequest extends SaveRequest<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveInventoryRequest';
	IsBlocking = true;
	Data: InventoryForEditionDTO;
	constructor(_params: {
		data: InventoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveInventoryResponse extends SaveResponse<InventoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveInventoryResponse';
	IsBlocking = false;
	Data: InventoryForEditionDTO;
	constructor(_params: {
		data: InventoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveKitchenDisplayRequest extends SaveRequest<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveKitchenDisplayRequest';
	IsBlocking = true;
	Data: KitchenDisplayForEditionDTO;
	constructor(_params: {
		data: KitchenDisplayForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveKitchenDisplayResponse extends SaveResponse<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveKitchenDisplayResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveKitchenPrintTemplateRequest extends SaveRequest<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveKitchenPrintTemplateRequest';
	IsBlocking = true;
	Data: KitchenPrintTemplateForEditionDTO;
	constructor(_params: {
		data: KitchenPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveKitchenPrintTemplateResponse extends SaveResponse<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveKitchenPrintTemplateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveLabelRequest extends SaveRequest<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveLabelRequest';
	IsBlocking = true;
	Data: LabelForEditionDTO;
	constructor(_params: {
		data: LabelForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveLabelResponse extends SaveResponse<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveLabelResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveLineCancellationReasonRequest extends SaveRequest<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveLineCancellationReasonRequest';
	IsBlocking = true;
	Data: LineCancellationReasonForEditionDTO;
	constructor(_params: {
		data: LineCancellationReasonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveLineCancellationReasonResponse extends SaveResponse<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveLineCancellationReasonResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveLotRequest extends SaveRequest<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveLotRequest';
	IsBlocking = true;
	Data: LotForEditionDTO;
	constructor(_params: {
		data: LotForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveLotResponse extends SaveResponse<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveLotResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveMajorGroupRequest extends SaveRequest<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMajorGroupRequest';
	IsBlocking = true;
	Data: MajorGroupForEditionDTO;
	constructor(_params: {
		data: MajorGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveMajorGroupResponse extends SaveResponse<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMajorGroupResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveMapeResponse extends SaveResponse<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMapeResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveMapRequest extends SaveRequest<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMapRequest';
	IsBlocking = true;
	Data: MapForEditionDTO;
	constructor(_params: {
		data: MapForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveMenuRequest extends SaveRequest<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMenuRequest';
	IsBlocking = true;
	Data: MenuForEditionDTO;
	constructor(_params: {
		data: MenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveMenuResponse extends SaveResponse<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMenuResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveMyAgoraAccountRequest extends SaveRequest<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMyAgoraAccountRequest';
	IsBlocking = true;
	Data: MyAgoraAccountForEditionDTO;
	constructor(_params: {
		data: MyAgoraAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveMyAgoraAccountResponse extends SaveResponse<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveMyAgoraAccountResponse';
	IsBlocking = false;
	Error: string;
	HasError: boolean;
	constructor(_params: {
		hasError: boolean,
		error: string
	}) {
		super({error: _params.error,hasError: _params.hasError});
		this.HasError = _params.hasError;
		this.Error = _params.error;
	}
}

export class SaveNamedDiscountRequest extends SaveRequest<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveNamedDiscountRequest';
	IsBlocking = true;
	Data: NamedDiscountForEditionDTO;
	constructor(_params: {
		data: NamedDiscountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveNamedDiscountResponse extends SaveResponse<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveNamedDiscountResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveOfferRequest extends SaveRequest<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveOfferRequest';
	IsBlocking = true;
	Data: OfferForEditionDTO;
	constructor(_params: {
		data: OfferForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveOfferResponse extends SaveResponse<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveOfferResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePaymentMethodRequest extends SaveRequest<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePaymentMethodRequest';
	IsBlocking = true;
	Data: PaymentMethodForEditionDTO;
	constructor(_params: {
		data: PaymentMethodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePaymentMethodResponse extends SaveResponse<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePaymentMethodResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePosGroupRequest extends SaveRequest<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePosGroupRequest';
	IsBlocking = true;
	Data: PosGroupForEditionDTO;
	constructor(_params: {
		data: PosGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePosGroupResponse extends SaveResponse<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePosGroupResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePosRequest extends SaveRequest<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePosRequest';
	IsBlocking = true;
	Data: PosForEditionDTO;
	constructor(_params: {
		data: PosForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePosResponse extends SaveResponse<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePosResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePredefinedNoteRequest extends SaveRequest<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePredefinedNoteRequest';
	IsBlocking = true;
	Data: PredefinedNoteForEditionDTO;
	constructor(_params: {
		data: PredefinedNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePredefinedNoteResponse extends SaveResponse<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePredefinedNoteResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePreparationOrderRequest extends SaveRequest<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePreparationOrderRequest';
	IsBlocking = true;
	Data: PreparationOrderForEditionDTO;
	constructor(_params: {
		data: PreparationOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePreparationOrderResponse extends SaveResponse<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePreparationOrderResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePreparationTypeRequest extends SaveRequest<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePreparationTypeRequest';
	IsBlocking = true;
	Data: PreparationTypeForEditionDTO;
	constructor(_params: {
		data: PreparationTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePreparationTypeResponse extends SaveResponse<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePreparationTypeResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePriceListRequest extends SaveRequest<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePriceListRequest';
	IsBlocking = true;
	Data: PriceListForEditionDTO;
	constructor(_params: {
		data: PriceListForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePriceListResponse extends SaveResponse<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SavePriceListResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveProductionRequest extends SaveRequest<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveProductionRequest';
	IsBlocking = true;
	Data: ProductionForEditionDTO;
	constructor(_params: {
		data: ProductionForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveProductionResponse extends SaveResponse<ProductionForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveProductionResponse';
	IsBlocking = false;
	Data: LowStockWarningDTO[];
	constructor(_params: {
		data: LowStockWarningDTO[]
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveProductRequest extends SaveRequest<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveProductRequest';
	IsBlocking = true;
	Data: ProductForEditionDTO;
	constructor(_params: {
		data: ProductForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveProductResponse extends SaveResponse<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveProductResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveProductTagRequest extends SaveRequest<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveProductTagRequest';
	IsBlocking = true;
	Data: ProductTagForEditionDTO;
	constructor(_params: {
		data: ProductTagForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveProductTagResponse extends SaveResponse<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveProductTagResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SavePurchaseInvoiceRequest extends SaveRequest<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseInvoiceRequest';
	IsBlocking = true;
	Data: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		data: PurchaseInvoiceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePurchaseInvoiceResponse extends SaveResponse<PurchaseInvoiceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseInvoiceResponse';
	IsBlocking = false;
	Data: PurchaseInvoiceForEditionDTO;
	constructor(_params: {
		data: PurchaseInvoiceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePurchaseOrderRequest extends SaveRequest<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseOrderRequest';
	IsBlocking = true;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SavePurchaseOrderResponse extends SaveResponse<PurchaseOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SavePurchaseOrderResponse';
	IsBlocking = false;
	Data: PurchaseOrderForEditionDTO;
	constructor(_params: {
		data: PurchaseOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveRdlTemplateRequest extends SaveRequest<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveRdlTemplateRequest';
	IsBlocking = true;
	Data: RdlTemplateForEditionDTO;
	constructor(_params: {
		data: RdlTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveRdlTemplateResponse extends SaveResponse<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveRdlTemplateResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveSaleCenterRequest extends SaveRequest<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSaleCenterRequest';
	IsBlocking = true;
	Data: SaleCenterForEditionDTO;
	constructor(_params: {
		data: SaleCenterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSaleCenterResponse extends SaveResponse<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSaleCenterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveScaleCounterRequest extends SaveRequest<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveScaleCounterRequest';
	IsBlocking = true;
	Data: ScaleCounterForEditionDTO;
	constructor(_params: {
		data: ScaleCounterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveScaleCounterResponse extends SaveResponse<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveScaleCounterResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveSerieRequest extends SaveRequest<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSerieRequest';
	IsBlocking = true;
	Data: SerieForEditionDTO;
	constructor(_params: {
		data: SerieForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSerieResponse extends SaveResponse<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSerieResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveSifSettingsRequest extends SaveRequest<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSifSettingsRequest';
	IsBlocking = true;
	Data: SifSettingsForEditionDTO;
	constructor(_params: {
		data: SifSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSifSettingsResponse extends SaveResponse<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSifSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveSmartMenuOrderSettingsRequest extends SaveRequest<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSmartMenuOrderSettingsRequest';
	IsBlocking = true;
	Data: SmartMenuOrderSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuOrderSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSmartMenuOrderSettingsResponse extends SaveResponse<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveSmartMenuWorkplaceGroupSettingsRequest extends SaveRequest<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSmartMenuWorkplaceGroupSettingsRequest';
	IsBlocking = true;
	Data: SmartMenuWorkplaceGroupSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuWorkplaceGroupSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSmartMenuWorkplaceGroupSettingsResponse extends SaveResponse<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSmartMenuWorkplaceGroupSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveStockChangeRequest extends SaveRequest<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveStockChangeRequest';
	IsBlocking = true;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveStockChangeResponse extends SaveResponse<StockChangeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveStockChangeResponse';
	IsBlocking = false;
	Data: StockChangeForEditionDTO;
	constructor(_params: {
		data: StockChangeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSupplierRequest extends SaveRequest<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSupplierRequest';
	IsBlocking = true;
	Data: SupplierForEditionDTO;
	constructor(_params: {
		data: SupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSupplierResponse extends SaveResponse<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSupplierResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveSystemOfMeasurementRequest extends SaveRequest<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSystemOfMeasurementRequest';
	IsBlocking = true;
	Data: SystemOfMeasurementForEditionDTO;
	constructor(_params: {
		data: SystemOfMeasurementForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveSystemOfMeasurementResponse extends SaveResponse<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveSystemOfMeasurementResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveTablePaymentSettingsRequest extends SaveRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveTablePaymentSettingsRequest';
	IsBlocking = true;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveTablePaymentSettingsResponse extends SaveResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveTablePaymentSettingsResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveTimeFrameGroupRequest extends SaveRequest<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveTimeFrameGroupRequest';
	IsBlocking = true;
	Data: TimeFrameGroupForEditionDTO;
	constructor(_params: {
		data: TimeFrameGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveTimeFrameGroupResponse extends SaveResponse<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveTimeFrameGroupResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveUserProfileRequest extends SaveRequest<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveUserProfileRequest';
	IsBlocking = true;
	Data: UserProfileForEditionDTO;
	constructor(_params: {
		data: UserProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveUserProfileResponse extends SaveResponse<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveUserProfileResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveUserRequest extends SaveRequest<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveUserRequest';
	IsBlocking = true;
	Data: UserForEditionDTO;
	constructor(_params: {
		data: UserForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveUserResponse extends SaveResponse<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveUserResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveVatRequest extends SaveRequest<VatCollectionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveVatRequest';
	IsBlocking = true;
	Data: VatCollectionDTO;
	constructor(_params: {
		data: VatCollectionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveVatResponse extends SaveResponse<VatCollectionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveVatResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveWarehouseCloseOutRequest extends SaveRequest<WarehouseCloseOutForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveWarehouseCloseOutRequest';
	IsBlocking = true;
	Data: WarehouseCloseOutForEditionDTO;
	constructor(_params: {
		data: WarehouseCloseOutForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveWarehouseCloseOutResponse extends SaveResponse<WarehouseCloseOutForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.SaveWarehouseCloseOutResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveWarehouseRequest extends SaveRequest<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWarehouseRequest';
	IsBlocking = true;
	Data: WarehouseForEditionDTO;
	constructor(_params: {
		data: WarehouseForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveWarehouseResponse extends SaveResponse<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWarehouseResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveWebAdminRequest extends SaveRequest<WebAdminForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWebAdminRequest';
	IsBlocking = true;
	Data: WebAdminForEditionDTO;
	constructor(_params: {
		data: WebAdminForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveWebAdminResponse extends SaveResponse<WebAdminForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWebAdminResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveWorkingPeriodRequest extends SaveRequest<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWorkingPeriodRequest';
	IsBlocking = true;
	Data: WorkingPeriodForEditionDTO;
	constructor(_params: {
		data: WorkingPeriodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveWorkingPeriodResponse extends SaveResponse<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWorkingPeriodResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class SaveWorkplaceRequest extends SaveRequest<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWorkplaceRequest';
	IsBlocking = true;
	Data: WorkplaceForEditionDTO;
	constructor(_params: {
		data: WorkplaceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class SaveWorkplaceResponse extends SaveResponse<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.SaveWorkplaceResponse';
	IsBlocking = false;
	constructor(_params?: {

	}) {
		super({});
	}
}

export class ValidateActionDisplayProfileRequest extends ValidateRequest<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateActionDisplayProfileRequest';
	IsBlocking = true;
	Data: ActionDisplayProfileForEditionDTO;
	constructor(_params: {
		data: ActionDisplayProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateActionDisplayProfileResponse extends ValidateResponse<ActionDisplayProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateActionDisplayProfileResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateAllergenRequest extends ValidateRequest<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAllergenRequest';
	IsBlocking = true;
	Data: AllergenForEditionDTO;
	constructor(_params: {
		data: AllergenForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateAllergenResponse extends ValidateResponse<AllergenForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateAllergenResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateAuditQueryRequest extends ValidateRequest<AuditQueryDTO> {
	CLRType = 'IGT.POS.Bus.Security.Messages.ValidateAuditQueryRequest';
	IsBlocking = true;
	Data: AuditQueryDTO;
	constructor(_params: {
		data: AuditQueryDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateAuditQueryResponse extends ValidateResponse<AuditQueryDTO> {
	CLRType = 'IGT.POS.Bus.Security.Messages.ValidateAuditQueryResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCardProcessorSettingsRequest extends ValidateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCardProcessorSettingsRequest';
	IsBlocking = true;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCardProcessorSettingsResponse extends ValidateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCardProcessorSettingsResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCashControlSettingsRequest extends ValidateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCashControlSettingsRequest';
	IsBlocking = true;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCashControlSettingsResponse extends ValidateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCashControlSettingsResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCategoryRequest extends ValidateRequest<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCategoryRequest';
	IsBlocking = true;
	Data: CategoryForEditionDTO;
	constructor(_params: {
		data: CategoryForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCategoryResponse extends ValidateResponse<CategoryForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCategoryResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCategoryScheduleRequest extends ValidateRequest<CategoryScheduleDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCategoryScheduleRequest';
	IsBlocking = true;
	Data: CategoryScheduleDTO;
	constructor(_params: {
		data: CategoryScheduleDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCategoryScheduleResponse extends ValidateResponse<CategoryScheduleDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCategoryScheduleResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCompanyRequest extends ValidateRequest<CompanyDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCompanyRequest';
	IsBlocking = true;
	Data: CompanyDTO;
	constructor(_params: {
		data: CompanyDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCompanyResponse extends ValidateResponse<CompanyDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCompanyResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCouponPrintTemplateRequest extends ValidateRequest<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCouponPrintTemplateRequest';
	IsBlocking = true;
	Data: CouponPrintTemplateForEditionDTO;
	constructor(_params: {
		data: CouponPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCouponPrintTemplateResponse extends ValidateResponse<CouponPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCouponPrintTemplateResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCouponSettingsRequest extends ValidateRequest<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCouponSettingsRequest';
	IsBlocking = true;
	Data: CouponSettingsForEditionDTO;
	constructor(_params: {
		data: CouponSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCouponSettingsResponse extends ValidateResponse<CouponSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCouponSettingsResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCustomActionButtonRequest extends ValidateRequest<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCustomActionButtonRequest';
	IsBlocking = true;
	Data: CustomActionButtonForEditionDTO;
	constructor(_params: {
		data: CustomActionButtonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCustomActionButtonResponse extends ValidateResponse<CustomActionButtonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCustomActionButtonResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCustomerRequest extends ValidateRequest<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCustomerRequest';
	IsBlocking = true;
	Data: CustomerForEditionDTO;
	constructor(_params: {
		data: CustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCustomerResponse extends ValidateResponse<CustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCustomerResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateCustomerTypeRequest extends ValidateRequest<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCustomerTypeRequest';
	IsBlocking = true;
	Data: CustomerTypeForEditionDTO;
	constructor(_params: {
		data: CustomerTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateCustomerTypeResponse extends ValidateResponse<CustomerTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateCustomerTypeResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateDigitalMenuRequest extends ValidateRequest<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateDigitalMenuRequest';
	IsBlocking = true;
	Data: DigitalMenuForEditionDTO;
	constructor(_params: {
		data: DigitalMenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateDigitalMenuResponse extends ValidateResponse<DigitalMenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateDigitalMenuResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateEditSmartMenuWorkplaceGroupSettingsRequest extends ValidateRequest<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateEditSmartMenuWorkplaceGroupSettingsRequest';
	IsBlocking = true;
	Data: SmartMenuWorkplaceGroupSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuWorkplaceGroupSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateEditSmartMenuWorkplaceGroupSettingsResopnse extends ValidateResponse<SmartMenuWorkplaceGroupSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateEditSmartMenuWorkplaceGroupSettingsResopnse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateEmailAccountRequest extends ValidateRequest<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.ValidateEmailAccountRequest';
	IsBlocking = true;
	Data: EmailAccountForEditionDTO;
	constructor(_params: {
		data: EmailAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateEmailAccountResponse extends ValidateResponse<EmailAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.ValidateEmailAccountResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateEmailingRequest extends ValidateRequest<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.ValidateEmailingRequest';
	IsBlocking = true;
	Data: EmailingForEditionDTO;
	constructor(_params: {
		data: EmailingForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateEmailingResponse extends ValidateResponse<EmailingForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Mailing.Messages.ValidateEmailingResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateEscPosTemplateRequest extends ValidateRequest<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateEscPosTemplateRequest';
	IsBlocking = true;
	Data: EscPosTemplateForEditionDTO;
	constructor(_params: {
		data: EscPosTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateEscPosTemplateResponse extends ValidateResponse<EscPosTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateEscPosTemplateResponse';
	IsBlocking = true;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateFamilyRequest extends ValidateRequest<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateFamilyRequest';
	IsBlocking = true;
	Data: FamilyForEditionDTO;
	constructor(_params: {
		data: FamilyForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateFamilyResponse extends ValidateResponse<FamilyForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateFamilyResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateInternalCustomerRequest extends ValidateRequest<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateInternalCustomerRequest';
	IsBlocking = true;
	Data: InternalCustomerForEditionDTO;
	constructor(_params: {
		data: InternalCustomerForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateInternalCustomerResponse extends ValidateResponse<InternalCustomerForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateInternalCustomerResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateInternalSupplierRequest extends ValidateRequest<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateInternalSupplierRequest';
	IsBlocking = true;
	Data: InternalSupplierForEditionDTO;
	constructor(_params: {
		data: InternalSupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateInternalSupplierResponse extends ValidateResponse<InternalSupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateInternalSupplierResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateKitchenDisplayRequest extends ValidateRequest<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateKitchenDisplayRequest';
	IsBlocking = true;
	Data: KitchenDisplayForEditionDTO;
	constructor(_params: {
		data: KitchenDisplayForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateKitchenDisplayResponse extends ValidateResponse<KitchenDisplayForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateKitchenDisplayResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateKitchenPrintTemplateRequest extends ValidateRequest<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateKitchenPrintTemplateRequest';
	IsBlocking = true;
	Data: KitchenPrintTemplateForEditionDTO;
	constructor(_params: {
		data: KitchenPrintTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateKitchenPrintTemplateResponse extends ValidateResponse<KitchenPrintTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateKitchenPrintTemplateResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateLabelRequest extends ValidateRequest<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateLabelRequest';
	IsBlocking = true;
	Data: LabelForEditionDTO;
	constructor(_params: {
		data: LabelForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateLabelResponse extends ValidateResponse<LabelForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateLabelResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateLineCancellationReasonRequest extends ValidateRequest<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateLineCancellationReasonRequest';
	IsBlocking = true;
	Data: LineCancellationReasonForEditionDTO;
	constructor(_params: {
		data: LineCancellationReasonForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateLineCancellationReasonResponse extends ValidateResponse<LineCancellationReasonForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateLineCancellationReasonResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateLotRequest extends ValidateRequest<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ValidateLotRequest';
	IsBlocking = true;
	Data: LotForEditionDTO;
	constructor(_params: {
		data: LotForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateLotResponse extends ValidateResponse<LotForEditionDTO> {
	CLRType = 'IGT.POS.Bus.Warehouse.Messages.ValidateLotResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateMajorGroupRequest extends ValidateRequest<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMajorGroupRequest';
	IsBlocking = true;
	Data: MajorGroupForEditionDTO;
	constructor(_params: {
		data: MajorGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateMajorGroupResponse extends ValidateResponse<MajorGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMajorGroupResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateMapRequest extends ValidateRequest<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMapRequest';
	IsBlocking = true;
	Data: MapForEditionDTO;
	constructor(_params: {
		data: MapForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateMapResponse extends ValidateResponse<MapForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMapResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateMenuRequest extends ValidateRequest<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMenuRequest';
	IsBlocking = true;
	Data: MenuForEditionDTO;
	constructor(_params: {
		data: MenuForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateMenuResponse extends ValidateResponse<MenuForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMenuResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateMyAgoraAccountRequest extends ValidateRequest<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMyAgoraAccountRequest';
	IsBlocking = true;
	Data: MyAgoraAccountForEditionDTO;
	constructor(_params: {
		data: MyAgoraAccountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateMyAgoraAccountResponse extends ValidateResponse<MyAgoraAccountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateMyAgoraAccountResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateNamedDiscountRequest extends ValidateRequest<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateNamedDiscountRequest';
	IsBlocking = true;
	Data: NamedDiscountForEditionDTO;
	constructor(_params: {
		data: NamedDiscountForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateNamedDiscountResponse extends ValidateResponse<NamedDiscountForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateNamedDiscountResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateOfferRequest extends ValidateRequest<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateOfferRequest';
	IsBlocking = true;
	Data: OfferForEditionDTO;
	constructor(_params: {
		data: OfferForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateOfferResponse extends ValidateResponse<OfferForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateOfferResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidatePaymentMethodRequest extends ValidateRequest<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePaymentMethodRequest';
	IsBlocking = true;
	Data: PaymentMethodForEditionDTO;
	constructor(_params: {
		data: PaymentMethodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidatePaymentMethodResponse extends ValidateResponse<PaymentMethodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePaymentMethodResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidatePosGroupRequest extends ValidateRequest<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePosGroupRequest';
	IsBlocking = true;
	Data: PosGroupForEditionDTO;
	constructor(_params: {
		data: PosGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidatePosGroupResponse extends ValidateResponse<PosGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePosGroupResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidatePosRequest extends ValidateRequest<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePosRequest';
	IsBlocking = true;
	Data: PosForEditionDTO;
	constructor(_params: {
		data: PosForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidatePosResponse extends ValidateResponse<PosForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePosResponse';
	IsBlocking = true;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidatePredefinedNoteRequest extends ValidateRequest<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePredefinedNoteRequest';
	IsBlocking = true;
	Data: PredefinedNoteForEditionDTO;
	constructor(_params: {
		data: PredefinedNoteForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidatePredefinedNoteResponse extends ValidateResponse<PredefinedNoteForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePredefinedNoteResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidatePreparationOrderRequest extends ValidateRequest<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePreparationOrderRequest';
	IsBlocking = true;
	Data: PreparationOrderForEditionDTO;
	constructor(_params: {
		data: PreparationOrderForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidatePreparationOrderResponse extends ValidateResponse<PreparationOrderForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePreparationOrderResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidatePreparationTypeRequest extends ValidateRequest<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePreparationTypeRequest';
	IsBlocking = true;
	Data: PreparationTypeForEditionDTO;
	constructor(_params: {
		data: PreparationTypeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidatePreparationTypeResponse extends ValidateResponse<PreparationTypeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePreparationTypeResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidatePriceListRequest extends ValidateRequest<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePriceListRequest';
	IsBlocking = true;
	Data: PriceListForEditionDTO;
	constructor(_params: {
		data: PriceListForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidatePriceListResponse extends ValidateResponse<PriceListForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidatePriceListResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateProductRequest extends ValidateRequest<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateProductRequest';
	IsBlocking = true;
	Data: ProductForEditionDTO;
	constructor(_params: {
		data: ProductForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateProductResponse extends ValidateResponse<ProductForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateProductResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateProductTagRequest extends ValidateRequest<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateProductTagRequest';
	IsBlocking = true;
	Data: ProductTagForEditionDTO;
	constructor(_params: {
		data: ProductTagForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateProductTagResponse extends ValidateResponse<ProductTagForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateProductTagResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateRdlTemplateRequest extends ValidateRequest<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRdlTemplateRequest';
	IsBlocking = true;
	Data: RdlTemplateForEditionDTO;
	constructor(_params: {
		data: RdlTemplateForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateRdlTemplateResponse extends ValidateResponse<RdlTemplateForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRdlTemplateResponse';
	IsBlocking = true;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateRecipeRequest extends ValidateRequest<RecipeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRecipeRequest';
	IsBlocking = true;
	Data: RecipeForEditionDTO;
	constructor(_params: {
		data: RecipeForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateRecipeResponse extends ValidateResponse<RecipeForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateRecipeResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateSaleCenterRequest extends ValidateRequest<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSaleCenterRequest';
	IsBlocking = true;
	Data: SaleCenterForEditionDTO;
	constructor(_params: {
		data: SaleCenterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateSaleCenterResponse extends ValidateResponse<SaleCenterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSaleCenterResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateScaleCounterRequest extends ValidateRequest<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateScaleCounterRequest';
	IsBlocking = true;
	Data: ScaleCounterForEditionDTO;
	constructor(_params: {
		data: ScaleCounterForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateScaleCounterResponse extends ValidateResponse<ScaleCounterForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateScaleCounterResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateSerieRequest extends ValidateRequest<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSerieRequest';
	IsBlocking = true;
	Data: SerieForEditionDTO;
	constructor(_params: {
		data: SerieForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateSerieResponse extends ValidateResponse<SerieForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSerieResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateSifSettingsRequest extends ValidateRequest<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSifSettingsRequest';
	IsBlocking = true;
	Data: SifSettingsForEditionDTO;
	constructor(_params: {
		data: SifSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateSifSettingsResponse extends ValidateResponse<SifSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSifSettingsResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateSmartMenuOrderSettingsRequest extends ValidateRequest<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSmartMenuOrderSettingsRequest';
	IsBlocking = true;
	Data: SmartMenuOrderSettingsForEditionDTO;
	constructor(_params: {
		data: SmartMenuOrderSettingsForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateSmartMenuOrderSettingsResponse extends ValidateResponse<SmartMenuOrderSettingsForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSmartMenuOrderSettingsResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateSupplierRequest extends ValidateRequest<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSupplierRequest';
	IsBlocking = true;
	Data: SupplierForEditionDTO;
	constructor(_params: {
		data: SupplierForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateSupplierResponse extends ValidateResponse<SupplierForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSupplierResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateSystemOfMeasurementRequest extends ValidateRequest<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSystemOfMeasurementRequest';
	IsBlocking = true;
	Data: SystemOfMeasurementForEditionDTO;
	constructor(_params: {
		data: SystemOfMeasurementForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateSystemOfMeasurementResponse extends ValidateResponse<SystemOfMeasurementForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateSystemOfMeasurementResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateTablePaymentSettingsRequest extends ValidateRequest<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTablePaymentSettingsRequest';
	IsBlocking = true;
	Data: SettingsFileForEditionDTO;
	constructor(_params: {
		data: SettingsFileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateTablePaymentSettingsResponse extends ValidateResponse<SettingsFileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTablePaymentSettingsResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateTakeOutServiceResponse extends ValidateResponse<TakeOutServiceDTO[]> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTakeOutServiceResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateTimeFrameGroupRequest extends ValidateRequest<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTimeFrameGroupRequest';
	IsBlocking = true;
	Data: TimeFrameGroupForEditionDTO;
	constructor(_params: {
		data: TimeFrameGroupForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateTimeFrameGroupResponse extends ValidateResponse<TimeFrameGroupForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateTimeFrameGroupResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateUserProfileRequest extends ValidateRequest<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateUserProfileRequest';
	IsBlocking = true;
	Data: UserProfileForEditionDTO;
	constructor(_params: {
		data: UserProfileForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateUserProfileResponse extends ValidateResponse<UserProfileForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateUserProfileResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateUserRequest extends ValidateRequest<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateUserRequest';
	IsBlocking = true;
	Data: UserForEditionDTO;
	constructor(_params: {
		data: UserForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateUserResponse extends ValidateResponse<UserForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateUserResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateVatRequest extends ValidateRequest<VatCollectionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateVatRequest';
	IsBlocking = true;
	Data: VatCollectionDTO;
	constructor(_params: {
		data: VatCollectionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateVatResponse extends ValidateResponse<VatCollectionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateVatResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateWarehouseRequest extends ValidateRequest<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWarehouseRequest';
	IsBlocking = true;
	Data: WarehouseForEditionDTO;
	constructor(_params: {
		data: WarehouseForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateWarehouseResponse extends ValidateResponse<WarehouseForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWarehouseResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateWebAdminRequest extends ValidateRequest<WebAdminForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWebAdminRequest';
	IsBlocking = true;
	Data: WebAdminForEditionDTO;
	constructor(_params: {
		data: WebAdminForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateWebAdminResponse extends ValidateResponse<WebAdminForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWebAdminResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateWorkingPeriodRequest extends ValidateRequest<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWorkingPeriodRequest';
	IsBlocking = true;
	Data: WorkingPeriodForEditionDTO;
	constructor(_params: {
		data: WorkingPeriodForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateWorkingPeriodResponse extends ValidateResponse<WorkingPeriodForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWorkingPeriodResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}

export class ValidateWorkplaceRequest extends ValidateRequest<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWorkplaceRequest';
	IsBlocking = true;
	Data: WorkplaceForEditionDTO;
	constructor(_params: {
		data: WorkplaceForEditionDTO
	}) {
		super({data: _params.data});
		this.Data = _params.data;
	}
}

export class ValidateWorkplaceResponse extends ValidateResponse<WorkplaceForEditionDTO> {
	CLRType = 'IGT.POS.Bus.SystemManagement.Messages.ValidateWorkplaceResponse';
	IsBlocking = false;
	Notification: NotificationDTO;
	constructor(_params: {
		notification: NotificationDTO
	}) {
		super({notification: _params.notification});
		this.Notification = _params.notification;
	}
}


